(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 32884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgToyotaLexus = function SvgToyotaLexus(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333.67 75.72"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "currentColor",
    d: "M133 0h2.53v75.72H133zM58.11.28C26.02.28 0 17.11 0 37.87s26.02 37.58 58.11 37.58 58.12-16.83 58.12-37.58S90.21.28 58.11.28Zm0 59.04c-4.77 0-8.67-9.4-8.92-21.23a99.603 99.603 0 0 0 17.84 0c-.25 11.83-4.15 21.23-8.92 21.23ZM49.79 28.7c1.3-8.36 4.54-14.29 8.32-14.29s7.03 5.92 8.33 14.29c-2.66.24-5.45.37-8.33.37s-5.66-.14-8.32-.37Zm8.32-22.98c-6.24 0-11.55 9.33-13.51 22.35-11.82-1.84-20.07-6.04-20.07-10.92 0-6.59 15.04-11.91 33.58-11.91s33.58 5.33 33.58 11.91c0 4.88-8.25 9.07-20.07 10.92-1.96-13.02-7.27-22.35-13.51-22.35ZM8.33 36.46c0-6.37 2.45-12.34 6.72-17.48-.05.37-.07.73-.07 1.1 0 8.03 12.04 14.86 28.83 17.38v1.76c0 14.96 4.19 27.62 9.98 31.92-25.48-1.55-45.46-16.5-45.46-34.68Zm54.11 34.66c5.79-4.3 9.99-16.96 9.99-31.92v-1.76c16.79-2.52 28.83-9.35 28.83-17.38 0-.37-.03-.74-.08-1.1 4.28 5.14 6.72 11.1 6.72 17.48 0 18.19-19.99 33.15-45.47 34.68ZM257.66 2.31l-1.38 2.08c9.27 3.81 13.03 10.74 13.03 18.16 0 3.71-1.01 7.06-2.96 7.06h-24.32c-3.32 0-4.3-1.18-2.81-4.12 2.65-5.25 10.63-15.29 15.54-21.33.72-.89 1.31-2.27-1.27-2.96-2.64-.71-6.9-1-10.51-1-18.29 0-31.04 9.89-31.04 22.64 0 11.73 11.06 22.69 30.99 22.69 8.81 0 19.61-2.48 25.74-9.42h-5.28c-5.97 5.39-13.76 6.62-20.41 6.62-16.09 0-26.27-8.35-26.27-19.89 0-10.64 11.53-20.19 26.07-20.19 1.74 0 2.31.37.47 2.66-3.72 4.62-10.37 13.77-13.49 19.13-3.34 5.74.07 10.41 7.58 10.41h30.42c1.88 0 2.94-1.07 4.04-3.01.87-1.56 2.25-4.71 2.25-8.99 0-8.65-6.49-16.59-16.38-20.54ZM325.89 61.9h-20.63c.68-2.64 2.72-4.45 6.56-4.45h19.74v-4.43h-20.98c-11.97 0-14.81 8.51-14.81 13.31h25.55c3.51 0 3.51 4.73.12 4.73H293.2V53.01h-8.51v18.05h-14.11c-3.78 0-5.37-1.81-5.37-4.62V53.02h-13.63l-12.18 7.67-10.5-7.67h-30.21c-8.75 0-14.97 5.11-15.69 11.5h5.68c-2.29 1.48-4.04 3.9-5.02 6.58h-17.87c-3.37 0-4.94-1.75-4.94-5.05V53.01h-8.54V64.1c0 7.04 3.84 11.47 12.5 11.47h59.58l12.24-7.71 10.55 7.71h12.58l-16.37-11.96 13.3-8.37v12.67c0 3.93 5.09 7.66 9.72 7.66h59.53c10.35 0 10.28-13.67-.04-13.67Zm-103.03 9.2h-28.91c.3-2.41 1.55-4.82 5.5-4.82h17.92v-4.41h-23.86c.41-1.82 2.27-4.42 6.57-4.42h18.95V55l13.6 9.94-9.78 6.16Z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgToyotaLexus);

/***/ }),

/***/ 45635:
/***/ (function(module) {

/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;

/***/ }),

/***/ 47943:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=');
  if (validLen === -1) validLen = len;
  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
  return [validLen, placeHoldersLen];
}

// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  var curByte = 0;

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
  var i;
  for (i = 0; i < len; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = tmp >> 16 & 0xFF;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }
  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[curByte++] = tmp & 0xFF;
  }
  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }
  return arr;
}
function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}
function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
  }
  return parts.join('');
}

/***/ }),

/***/ 80365:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(47943);
var ieee754 = __webpack_require__(48405);
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
: null;
exports.lW = Buffer;
__webpack_unused_export__ = SlowBuffer;
exports.h2 = 50;
var K_MAX_LENGTH = 0x7fffffff;
__webpack_unused_export__ = K_MAX_LENGTH;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
  console.error('This browser lacks typed array (Uint8Array) support which is required by ' + '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');
}
function typedArraySupport() {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1);
    var proto = {
      foo: function () {
        return 42;
      }
    };
    Object.setPrototypeOf(proto, Uint8Array.prototype);
    Object.setPrototypeOf(arr, proto);
    return arr.foo() === 42;
  } catch (e) {
    return false;
  }
}
Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.buffer;
  }
});
Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.byteOffset;
  }
});
function createBuffer(length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"');
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length);
  Object.setPrototypeOf(buf, Buffer.prototype);
  return buf;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError('The "string" argument must be of type string. Received type number');
    }
    return allocUnsafe(arg);
  }
  return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192; // not used by this implementation

function from(value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset);
  }
  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value);
  }
  if (value == null) {
    throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + typeof value);
  }
  if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
    return fromArrayBuffer(value, encodingOrOffset, length);
  }
  if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length);
  }
  if (typeof value === 'number') {
    throw new TypeError('The "value" argument must not be of type number. Received type number');
  }
  var valueOf = value.valueOf && value.valueOf();
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length);
  }
  var b = fromObject(value);
  if (b) return b;
  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
  }
  throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + typeof value);
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length);
};

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number');
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"');
  }
}
function alloc(size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
  }
  return createBuffer(size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
  assertSize(size);
  return createBuffer(size < 0 ? 0 : checked(size) | 0);
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size);
};
function fromString(string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }
  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding);
  }
  var length = byteLength(string, encoding) | 0;
  var buf = createBuffer(length);
  var actual = buf.write(string, encoding);
  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
  }
  return buf;
}
function fromArrayLike(array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  var buf = createBuffer(length);
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255;
  }
  return buf;
}
function fromArrayView(arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView);
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
  }
  return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds');
  }
  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds');
  }
  var buf;
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array);
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset);
  } else {
    buf = new Uint8Array(array, byteOffset, length);
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype);
  return buf;
}
function fromObject(obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    var buf = createBuffer(len);
    if (buf.length === 0) {
      return buf;
    }
    obj.copy(buf, 0, 0, len);
    return buf;
  }
  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0);
    }
    return fromArrayLike(obj);
  }
  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data);
  }
}
function checked(length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes');
  }
  return length | 0;
}
function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
  return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
};

Buffer.compare = function compare(a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
  }
  if (a === b) return 0;
  var x = a.length;
  var y = b.length;
  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};
Buffer.concat = function concat(list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }
  if (list.length === 0) {
    return Buffer.alloc(0);
  }
  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }
  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos);
      } else {
        Uint8Array.prototype.set.call(buffer, buf, pos);
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    } else {
      buf.copy(buffer, pos);
    }
    pos += buf.length;
  }
  return buffer;
};
function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' + 'Received type ' + typeof string);
  }
  var len = string.length;
  var mustMatch = arguments.length > 2 && arguments[2] === true;
  if (!mustMatch && len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
        }

        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }
  if (end === undefined || end > this.length) {
    end = this.length;
  }
  if (end <= 0) {
    return '';
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;
  if (end <= start) {
    return '';
  }
  if (!encoding) encoding = 'utf8';
  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);
      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);
      case 'ascii':
        return asciiSlice(this, start, end);
      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);
      case 'base64':
        return base64Slice(this, start, end);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};
Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};
Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};
Buffer.prototype.toString = function toString() {
  var length = this.length;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.h2;
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
  if (this.length > max) str += ' ... ';
  return '<Buffer ' + str + '>';
};
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
}
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength);
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. ' + 'Received type ' + typeof target);
  }
  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }
  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }
  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }
  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;
  if (this === target) return 0;
  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);
  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);
  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }
  throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;
  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }
  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }
  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }
  return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }
  var strLen = string.length;
  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (numberIsNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}
function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0;
    if (isFinite(length)) {
      length = length >>> 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }
  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;
  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }
  if (!encoding) encoding = 'utf8';
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);
      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);
      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length);
      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};
Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}
function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];
  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;
      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }
    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }
    res.push(codePoint);
    i += bytesPerSequence;
  }
  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}
function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}
function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}
function hexSlice(buf, start, end) {
  var len = buf.length;
  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;
  var out = '';
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]];
  }
  return out;
}
function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}
Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;
  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }
  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }
  if (end < start) end = start;
  var newBuf = this.subarray(start, end);
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype);
  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }
  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }
  return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset + 3] = value >>> 24;
  this[offset + 2] = value >>> 16;
  this[offset + 1] = value >>> 8;
  this[offset] = value & 0xff;
  return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  this[offset + 2] = value >>> 16;
  this[offset + 3] = value >>> 24;
  return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }
  var len = end - start;
  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
  }
  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (encoding === 'utf8' && code < 128 || encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code;
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  } else if (typeof val === 'boolean') {
    val = Number(val);
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }
  if (end <= start) {
    return this;
  }
  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;
  if (!val) val = 0;
  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
    var len = bytes.length;
    if (len === 0) {
      throw new TypeError('The value "' + val + '" is invalid for argument "value"');
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }
  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0];
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}
function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];
  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;
        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }
    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }
  return bytes;
}
function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}
function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;
    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }
  return byteArray;
}
function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
  return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
  // For IE11 support
  return obj !== obj; // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function () {
  var alphabet = '0123456789abcdef';
  var table = new Array(256);
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16;
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j];
    }
  }
  return table;
}();

/***/ }),

/***/ 33100:
/***/ (function(module) {

(function webpackUniversalModuleDefinition(root, factory) {
  /* istanbul ignore next */
  if (true) module.exports = factory();else {}
})(this, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/
      var installedModules = {};

      /******/ // The require function
      /******/
      function __nested_webpack_require_618__(moduleId) {
        /******/ // Check if module is in cache
        /* istanbul ignore if */
        /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;

        /******/ // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
          /******/exports: {},
          /******/id: moduleId,
          /******/loaded: false
          /******/
        };

        /******/ // Execute the module function
        /******/
        modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_618__);

        /******/ // Flag the module as loaded
        /******/
        module.loaded = true;

        /******/ // Return the exports of the module
        /******/
        return module.exports;
        /******/
      }

      /******/ // expose the modules object (__webpack_modules__)
      /******/
      __nested_webpack_require_618__.m = modules;

      /******/ // expose the module cache
      /******/
      __nested_webpack_require_618__.c = installedModules;

      /******/ // __webpack_public_path__
      /******/
      __nested_webpack_require_618__.p = "";

      /******/ // Load entry module and return exports
      /******/
      return __nested_webpack_require_618__(0);
      /******/
    }
    /************************************************************************/
    /******/([/* 0 */
    /***/function (module, exports, __nested_webpack_require_2067__) {
      "use strict";

      /*
        Copyright JS Foundation and other contributors, https://js.foundation/
      	  Redistribution and use in source and binary forms, with or without
        modification, are permitted provided that the following conditions are met:
      	    * Redistributions of source code must retain the above copyright
            notice, this list of conditions and the following disclaimer.
          * Redistributions in binary form must reproduce the above copyright
            notice, this list of conditions and the following disclaimer in the
            documentation and/or other materials provided with the distribution.
      	  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
        AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
        IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
        ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
        DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
        (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
        LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
        ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
        (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
        THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      */
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var comment_handler_1 = __nested_webpack_require_2067__(1);
      var jsx_parser_1 = __nested_webpack_require_2067__(3);
      var parser_1 = __nested_webpack_require_2067__(8);
      var tokenizer_1 = __nested_webpack_require_2067__(15);
      function parse(code, options, delegate) {
        var commentHandler = null;
        var proxyDelegate = function (node, metadata) {
          if (delegate) {
            delegate(node, metadata);
          }
          if (commentHandler) {
            commentHandler.visit(node, metadata);
          }
        };
        var parserDelegate = typeof delegate === 'function' ? proxyDelegate : null;
        var collectComment = false;
        if (options) {
          collectComment = typeof options.comment === 'boolean' && options.comment;
          var attachComment = typeof options.attachComment === 'boolean' && options.attachComment;
          if (collectComment || attachComment) {
            commentHandler = new comment_handler_1.CommentHandler();
            commentHandler.attach = attachComment;
            options.comment = true;
            parserDelegate = proxyDelegate;
          }
        }
        var isModule = false;
        if (options && typeof options.sourceType === 'string') {
          isModule = options.sourceType === 'module';
        }
        var parser;
        if (options && typeof options.jsx === 'boolean' && options.jsx) {
          parser = new jsx_parser_1.JSXParser(code, options, parserDelegate);
        } else {
          parser = new parser_1.Parser(code, options, parserDelegate);
        }
        var program = isModule ? parser.parseModule() : parser.parseScript();
        var ast = program;
        if (collectComment && commentHandler) {
          ast.comments = commentHandler.comments;
        }
        if (parser.config.tokens) {
          ast.tokens = parser.tokens;
        }
        if (parser.config.tolerant) {
          ast.errors = parser.errorHandler.errors;
        }
        return ast;
      }
      exports.parse = parse;
      function parseModule(code, options, delegate) {
        var parsingOptions = options || {};
        parsingOptions.sourceType = 'module';
        return parse(code, parsingOptions, delegate);
      }
      exports.parseModule = parseModule;
      function parseScript(code, options, delegate) {
        var parsingOptions = options || {};
        parsingOptions.sourceType = 'script';
        return parse(code, parsingOptions, delegate);
      }
      exports.parseScript = parseScript;
      function tokenize(code, options, delegate) {
        var tokenizer = new tokenizer_1.Tokenizer(code, options);
        var tokens;
        tokens = [];
        try {
          while (true) {
            var token = tokenizer.getNextToken();
            if (!token) {
              break;
            }
            if (delegate) {
              token = delegate(token);
            }
            tokens.push(token);
          }
        } catch (e) {
          tokenizer.errorHandler.tolerate(e);
        }
        if (tokenizer.errorHandler.tolerant) {
          tokens.errors = tokenizer.errors();
        }
        return tokens;
      }
      exports.tokenize = tokenize;
      var syntax_1 = __nested_webpack_require_2067__(2);
      exports.Syntax = syntax_1.Syntax;
      // Sync with *.json manifests.
      exports.version = '4.0.1';

      /***/
    }, /* 1 */
    /***/function (module, exports, __nested_webpack_require_7048__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var syntax_1 = __nested_webpack_require_7048__(2);
      var CommentHandler = function () {
        function CommentHandler() {
          this.attach = false;
          this.comments = [];
          this.stack = [];
          this.leading = [];
          this.trailing = [];
        }
        CommentHandler.prototype.insertInnerComments = function (node, metadata) {
          //  innnerComments for properties empty block
          //  `function a() {/** comments **\/}`
          if (node.type === syntax_1.Syntax.BlockStatement && node.body.length === 0) {
            var innerComments = [];
            for (var i = this.leading.length - 1; i >= 0; --i) {
              var entry = this.leading[i];
              if (metadata.end.offset >= entry.start) {
                innerComments.unshift(entry.comment);
                this.leading.splice(i, 1);
                this.trailing.splice(i, 1);
              }
            }
            if (innerComments.length) {
              node.innerComments = innerComments;
            }
          }
        };
        CommentHandler.prototype.findTrailingComments = function (metadata) {
          var trailingComments = [];
          if (this.trailing.length > 0) {
            for (var i = this.trailing.length - 1; i >= 0; --i) {
              var entry_1 = this.trailing[i];
              if (entry_1.start >= metadata.end.offset) {
                trailingComments.unshift(entry_1.comment);
              }
            }
            this.trailing.length = 0;
            return trailingComments;
          }
          var entry = this.stack[this.stack.length - 1];
          if (entry && entry.node.trailingComments) {
            var firstComment = entry.node.trailingComments[0];
            if (firstComment && firstComment.range[0] >= metadata.end.offset) {
              trailingComments = entry.node.trailingComments;
              delete entry.node.trailingComments;
            }
          }
          return trailingComments;
        };
        CommentHandler.prototype.findLeadingComments = function (metadata) {
          var leadingComments = [];
          var target;
          while (this.stack.length > 0) {
            var entry = this.stack[this.stack.length - 1];
            if (entry && entry.start >= metadata.start.offset) {
              target = entry.node;
              this.stack.pop();
            } else {
              break;
            }
          }
          if (target) {
            var count = target.leadingComments ? target.leadingComments.length : 0;
            for (var i = count - 1; i >= 0; --i) {
              var comment = target.leadingComments[i];
              if (comment.range[1] <= metadata.start.offset) {
                leadingComments.unshift(comment);
                target.leadingComments.splice(i, 1);
              }
            }
            if (target.leadingComments && target.leadingComments.length === 0) {
              delete target.leadingComments;
            }
            return leadingComments;
          }
          for (var i = this.leading.length - 1; i >= 0; --i) {
            var entry = this.leading[i];
            if (entry.start <= metadata.start.offset) {
              leadingComments.unshift(entry.comment);
              this.leading.splice(i, 1);
            }
          }
          return leadingComments;
        };
        CommentHandler.prototype.visitNode = function (node, metadata) {
          if (node.type === syntax_1.Syntax.Program && node.body.length > 0) {
            return;
          }
          this.insertInnerComments(node, metadata);
          var trailingComments = this.findTrailingComments(metadata);
          var leadingComments = this.findLeadingComments(metadata);
          if (leadingComments.length > 0) {
            node.leadingComments = leadingComments;
          }
          if (trailingComments.length > 0) {
            node.trailingComments = trailingComments;
          }
          this.stack.push({
            node: node,
            start: metadata.start.offset
          });
        };
        CommentHandler.prototype.visitComment = function (node, metadata) {
          var type = node.type[0] === 'L' ? 'Line' : 'Block';
          var comment = {
            type: type,
            value: node.value
          };
          if (node.range) {
            comment.range = node.range;
          }
          if (node.loc) {
            comment.loc = node.loc;
          }
          this.comments.push(comment);
          if (this.attach) {
            var entry = {
              comment: {
                type: type,
                value: node.value,
                range: [metadata.start.offset, metadata.end.offset]
              },
              start: metadata.start.offset
            };
            if (node.loc) {
              entry.comment.loc = node.loc;
            }
            node.type = type;
            this.leading.push(entry);
            this.trailing.push(entry);
          }
        };
        CommentHandler.prototype.visit = function (node, metadata) {
          if (node.type === 'LineComment') {
            this.visitComment(node, metadata);
          } else if (node.type === 'BlockComment') {
            this.visitComment(node, metadata);
          } else if (this.attach) {
            this.visitNode(node, metadata);
          }
        };
        return CommentHandler;
      }();
      exports.CommentHandler = CommentHandler;

      /***/
    }, /* 2 */
    /***/function (module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Syntax = {
        AssignmentExpression: 'AssignmentExpression',
        AssignmentPattern: 'AssignmentPattern',
        ArrayExpression: 'ArrayExpression',
        ArrayPattern: 'ArrayPattern',
        ArrowFunctionExpression: 'ArrowFunctionExpression',
        AwaitExpression: 'AwaitExpression',
        BlockStatement: 'BlockStatement',
        BinaryExpression: 'BinaryExpression',
        BreakStatement: 'BreakStatement',
        CallExpression: 'CallExpression',
        CatchClause: 'CatchClause',
        ClassBody: 'ClassBody',
        ClassDeclaration: 'ClassDeclaration',
        ClassExpression: 'ClassExpression',
        ConditionalExpression: 'ConditionalExpression',
        ContinueStatement: 'ContinueStatement',
        DoWhileStatement: 'DoWhileStatement',
        DebuggerStatement: 'DebuggerStatement',
        EmptyStatement: 'EmptyStatement',
        ExportAllDeclaration: 'ExportAllDeclaration',
        ExportDefaultDeclaration: 'ExportDefaultDeclaration',
        ExportNamedDeclaration: 'ExportNamedDeclaration',
        ExportSpecifier: 'ExportSpecifier',
        ExpressionStatement: 'ExpressionStatement',
        ForStatement: 'ForStatement',
        ForOfStatement: 'ForOfStatement',
        ForInStatement: 'ForInStatement',
        FunctionDeclaration: 'FunctionDeclaration',
        FunctionExpression: 'FunctionExpression',
        Identifier: 'Identifier',
        IfStatement: 'IfStatement',
        ImportDeclaration: 'ImportDeclaration',
        ImportDefaultSpecifier: 'ImportDefaultSpecifier',
        ImportNamespaceSpecifier: 'ImportNamespaceSpecifier',
        ImportSpecifier: 'ImportSpecifier',
        Literal: 'Literal',
        LabeledStatement: 'LabeledStatement',
        LogicalExpression: 'LogicalExpression',
        MemberExpression: 'MemberExpression',
        MetaProperty: 'MetaProperty',
        MethodDefinition: 'MethodDefinition',
        NewExpression: 'NewExpression',
        ObjectExpression: 'ObjectExpression',
        ObjectPattern: 'ObjectPattern',
        Program: 'Program',
        Property: 'Property',
        RestElement: 'RestElement',
        ReturnStatement: 'ReturnStatement',
        SequenceExpression: 'SequenceExpression',
        SpreadElement: 'SpreadElement',
        Super: 'Super',
        SwitchCase: 'SwitchCase',
        SwitchStatement: 'SwitchStatement',
        TaggedTemplateExpression: 'TaggedTemplateExpression',
        TemplateElement: 'TemplateElement',
        TemplateLiteral: 'TemplateLiteral',
        ThisExpression: 'ThisExpression',
        ThrowStatement: 'ThrowStatement',
        TryStatement: 'TryStatement',
        UnaryExpression: 'UnaryExpression',
        UpdateExpression: 'UpdateExpression',
        VariableDeclaration: 'VariableDeclaration',
        VariableDeclarator: 'VariableDeclarator',
        WhileStatement: 'WhileStatement',
        WithStatement: 'WithStatement',
        YieldExpression: 'YieldExpression'
      };

      /***/
    }, /* 3 */
    /***/function (module, exports, __nested_webpack_require_15818__) {
      "use strict";

      /* istanbul ignore next */
      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var character_1 = __nested_webpack_require_15818__(4);
      var JSXNode = __nested_webpack_require_15818__(5);
      var jsx_syntax_1 = __nested_webpack_require_15818__(6);
      var Node = __nested_webpack_require_15818__(7);
      var parser_1 = __nested_webpack_require_15818__(8);
      var token_1 = __nested_webpack_require_15818__(13);
      var xhtml_entities_1 = __nested_webpack_require_15818__(14);
      token_1.TokenName[100 /* Identifier */] = 'JSXIdentifier';
      token_1.TokenName[101 /* Text */] = 'JSXText';
      // Fully qualified element name, e.g. <svg:path> returns "svg:path"
      function getQualifiedElementName(elementName) {
        var qualifiedName;
        switch (elementName.type) {
          case jsx_syntax_1.JSXSyntax.JSXIdentifier:
            var id = elementName;
            qualifiedName = id.name;
            break;
          case jsx_syntax_1.JSXSyntax.JSXNamespacedName:
            var ns = elementName;
            qualifiedName = getQualifiedElementName(ns.namespace) + ':' + getQualifiedElementName(ns.name);
            break;
          case jsx_syntax_1.JSXSyntax.JSXMemberExpression:
            var expr = elementName;
            qualifiedName = getQualifiedElementName(expr.object) + '.' + getQualifiedElementName(expr.property);
            break;
          /* istanbul ignore next */
          default:
            break;
        }
        return qualifiedName;
      }
      var JSXParser = function (_super) {
        __extends(JSXParser, _super);
        function JSXParser(code, options, delegate) {
          return _super.call(this, code, options, delegate) || this;
        }
        JSXParser.prototype.parsePrimaryExpression = function () {
          return this.match('<') ? this.parseJSXRoot() : _super.prototype.parsePrimaryExpression.call(this);
        };
        JSXParser.prototype.startJSX = function () {
          // Unwind the scanner before the lookahead token.
          this.scanner.index = this.startMarker.index;
          this.scanner.lineNumber = this.startMarker.line;
          this.scanner.lineStart = this.startMarker.index - this.startMarker.column;
        };
        JSXParser.prototype.finishJSX = function () {
          // Prime the next lookahead.
          this.nextToken();
        };
        JSXParser.prototype.reenterJSX = function () {
          this.startJSX();
          this.expectJSX('}');
          // Pop the closing '}' added from the lookahead.
          if (this.config.tokens) {
            this.tokens.pop();
          }
        };
        JSXParser.prototype.createJSXNode = function () {
          this.collectComments();
          return {
            index: this.scanner.index,
            line: this.scanner.lineNumber,
            column: this.scanner.index - this.scanner.lineStart
          };
        };
        JSXParser.prototype.createJSXChildNode = function () {
          return {
            index: this.scanner.index,
            line: this.scanner.lineNumber,
            column: this.scanner.index - this.scanner.lineStart
          };
        };
        JSXParser.prototype.scanXHTMLEntity = function (quote) {
          var result = '&';
          var valid = true;
          var terminated = false;
          var numeric = false;
          var hex = false;
          while (!this.scanner.eof() && valid && !terminated) {
            var ch = this.scanner.source[this.scanner.index];
            if (ch === quote) {
              break;
            }
            terminated = ch === ';';
            result += ch;
            ++this.scanner.index;
            if (!terminated) {
              switch (result.length) {
                case 2:
                  // e.g. '&#123;'
                  numeric = ch === '#';
                  break;
                case 3:
                  if (numeric) {
                    // e.g. '&#x41;'
                    hex = ch === 'x';
                    valid = hex || character_1.Character.isDecimalDigit(ch.charCodeAt(0));
                    numeric = numeric && !hex;
                  }
                  break;
                default:
                  valid = valid && !(numeric && !character_1.Character.isDecimalDigit(ch.charCodeAt(0)));
                  valid = valid && !(hex && !character_1.Character.isHexDigit(ch.charCodeAt(0)));
                  break;
              }
            }
          }
          if (valid && terminated && result.length > 2) {
            // e.g. '&#x41;' becomes just '#x41'
            var str = result.substr(1, result.length - 2);
            if (numeric && str.length > 1) {
              result = String.fromCharCode(parseInt(str.substr(1), 10));
            } else if (hex && str.length > 2) {
              result = String.fromCharCode(parseInt('0' + str.substr(1), 16));
            } else if (!numeric && !hex && xhtml_entities_1.XHTMLEntities[str]) {
              result = xhtml_entities_1.XHTMLEntities[str];
            }
          }
          return result;
        };
        // Scan the next JSX token. This replaces Scanner#lex when in JSX mode.
        JSXParser.prototype.lexJSX = function () {
          var cp = this.scanner.source.charCodeAt(this.scanner.index);
          // < > / : = { }
          if (cp === 60 || cp === 62 || cp === 47 || cp === 58 || cp === 61 || cp === 123 || cp === 125) {
            var value = this.scanner.source[this.scanner.index++];
            return {
              type: 7 /* Punctuator */,
              value: value,
              lineNumber: this.scanner.lineNumber,
              lineStart: this.scanner.lineStart,
              start: this.scanner.index - 1,
              end: this.scanner.index
            };
          }
          // " '
          if (cp === 34 || cp === 39) {
            var start = this.scanner.index;
            var quote = this.scanner.source[this.scanner.index++];
            var str = '';
            while (!this.scanner.eof()) {
              var ch = this.scanner.source[this.scanner.index++];
              if (ch === quote) {
                break;
              } else if (ch === '&') {
                str += this.scanXHTMLEntity(quote);
              } else {
                str += ch;
              }
            }
            return {
              type: 8 /* StringLiteral */,
              value: str,
              lineNumber: this.scanner.lineNumber,
              lineStart: this.scanner.lineStart,
              start: start,
              end: this.scanner.index
            };
          }
          // ... or .
          if (cp === 46) {
            var n1 = this.scanner.source.charCodeAt(this.scanner.index + 1);
            var n2 = this.scanner.source.charCodeAt(this.scanner.index + 2);
            var value = n1 === 46 && n2 === 46 ? '...' : '.';
            var start = this.scanner.index;
            this.scanner.index += value.length;
            return {
              type: 7 /* Punctuator */,
              value: value,
              lineNumber: this.scanner.lineNumber,
              lineStart: this.scanner.lineStart,
              start: start,
              end: this.scanner.index
            };
          }
          // `
          if (cp === 96) {
            // Only placeholder, since it will be rescanned as a real assignment expression.
            return {
              type: 10 /* Template */,
              value: '',
              lineNumber: this.scanner.lineNumber,
              lineStart: this.scanner.lineStart,
              start: this.scanner.index,
              end: this.scanner.index
            };
          }
          // Identifer can not contain backslash (char code 92).
          if (character_1.Character.isIdentifierStart(cp) && cp !== 92) {
            var start = this.scanner.index;
            ++this.scanner.index;
            while (!this.scanner.eof()) {
              var ch = this.scanner.source.charCodeAt(this.scanner.index);
              if (character_1.Character.isIdentifierPart(ch) && ch !== 92) {
                ++this.scanner.index;
              } else if (ch === 45) {
                // Hyphen (char code 45) can be part of an identifier.
                ++this.scanner.index;
              } else {
                break;
              }
            }
            var id = this.scanner.source.slice(start, this.scanner.index);
            return {
              type: 100 /* Identifier */,
              value: id,
              lineNumber: this.scanner.lineNumber,
              lineStart: this.scanner.lineStart,
              start: start,
              end: this.scanner.index
            };
          }
          return this.scanner.lex();
        };
        JSXParser.prototype.nextJSXToken = function () {
          this.collectComments();
          this.startMarker.index = this.scanner.index;
          this.startMarker.line = this.scanner.lineNumber;
          this.startMarker.column = this.scanner.index - this.scanner.lineStart;
          var token = this.lexJSX();
          this.lastMarker.index = this.scanner.index;
          this.lastMarker.line = this.scanner.lineNumber;
          this.lastMarker.column = this.scanner.index - this.scanner.lineStart;
          if (this.config.tokens) {
            this.tokens.push(this.convertToken(token));
          }
          return token;
        };
        JSXParser.prototype.nextJSXText = function () {
          this.startMarker.index = this.scanner.index;
          this.startMarker.line = this.scanner.lineNumber;
          this.startMarker.column = this.scanner.index - this.scanner.lineStart;
          var start = this.scanner.index;
          var text = '';
          while (!this.scanner.eof()) {
            var ch = this.scanner.source[this.scanner.index];
            if (ch === '{' || ch === '<') {
              break;
            }
            ++this.scanner.index;
            text += ch;
            if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
              ++this.scanner.lineNumber;
              if (ch === '\r' && this.scanner.source[this.scanner.index] === '\n') {
                ++this.scanner.index;
              }
              this.scanner.lineStart = this.scanner.index;
            }
          }
          this.lastMarker.index = this.scanner.index;
          this.lastMarker.line = this.scanner.lineNumber;
          this.lastMarker.column = this.scanner.index - this.scanner.lineStart;
          var token = {
            type: 101 /* Text */,
            value: text,
            lineNumber: this.scanner.lineNumber,
            lineStart: this.scanner.lineStart,
            start: start,
            end: this.scanner.index
          };
          if (text.length > 0 && this.config.tokens) {
            this.tokens.push(this.convertToken(token));
          }
          return token;
        };
        JSXParser.prototype.peekJSXToken = function () {
          var state = this.scanner.saveState();
          this.scanner.scanComments();
          var next = this.lexJSX();
          this.scanner.restoreState(state);
          return next;
        };
        // Expect the next JSX token to match the specified punctuator.
        // If not, an exception will be thrown.
        JSXParser.prototype.expectJSX = function (value) {
          var token = this.nextJSXToken();
          if (token.type !== 7 /* Punctuator */ || token.value !== value) {
            this.throwUnexpectedToken(token);
          }
        };
        // Return true if the next JSX token matches the specified punctuator.
        JSXParser.prototype.matchJSX = function (value) {
          var next = this.peekJSXToken();
          return next.type === 7 /* Punctuator */ && next.value === value;
        };
        JSXParser.prototype.parseJSXIdentifier = function () {
          var node = this.createJSXNode();
          var token = this.nextJSXToken();
          if (token.type !== 100 /* Identifier */) {
            this.throwUnexpectedToken(token);
          }
          return this.finalize(node, new JSXNode.JSXIdentifier(token.value));
        };
        JSXParser.prototype.parseJSXElementName = function () {
          var node = this.createJSXNode();
          var elementName = this.parseJSXIdentifier();
          if (this.matchJSX(':')) {
            var namespace = elementName;
            this.expectJSX(':');
            var name_1 = this.parseJSXIdentifier();
            elementName = this.finalize(node, new JSXNode.JSXNamespacedName(namespace, name_1));
          } else if (this.matchJSX('.')) {
            while (this.matchJSX('.')) {
              var object = elementName;
              this.expectJSX('.');
              var property = this.parseJSXIdentifier();
              elementName = this.finalize(node, new JSXNode.JSXMemberExpression(object, property));
            }
          }
          return elementName;
        };
        JSXParser.prototype.parseJSXAttributeName = function () {
          var node = this.createJSXNode();
          var attributeName;
          var identifier = this.parseJSXIdentifier();
          if (this.matchJSX(':')) {
            var namespace = identifier;
            this.expectJSX(':');
            var name_2 = this.parseJSXIdentifier();
            attributeName = this.finalize(node, new JSXNode.JSXNamespacedName(namespace, name_2));
          } else {
            attributeName = identifier;
          }
          return attributeName;
        };
        JSXParser.prototype.parseJSXStringLiteralAttribute = function () {
          var node = this.createJSXNode();
          var token = this.nextJSXToken();
          if (token.type !== 8 /* StringLiteral */) {
            this.throwUnexpectedToken(token);
          }
          var raw = this.getTokenRaw(token);
          return this.finalize(node, new Node.Literal(token.value, raw));
        };
        JSXParser.prototype.parseJSXExpressionAttribute = function () {
          var node = this.createJSXNode();
          this.expectJSX('{');
          this.finishJSX();
          if (this.match('}')) {
            this.tolerateError('JSX attributes must only be assigned a non-empty expression');
          }
          var expression = this.parseAssignmentExpression();
          this.reenterJSX();
          return this.finalize(node, new JSXNode.JSXExpressionContainer(expression));
        };
        JSXParser.prototype.parseJSXAttributeValue = function () {
          return this.matchJSX('{') ? this.parseJSXExpressionAttribute() : this.matchJSX('<') ? this.parseJSXElement() : this.parseJSXStringLiteralAttribute();
        };
        JSXParser.prototype.parseJSXNameValueAttribute = function () {
          var node = this.createJSXNode();
          var name = this.parseJSXAttributeName();
          var value = null;
          if (this.matchJSX('=')) {
            this.expectJSX('=');
            value = this.parseJSXAttributeValue();
          }
          return this.finalize(node, new JSXNode.JSXAttribute(name, value));
        };
        JSXParser.prototype.parseJSXSpreadAttribute = function () {
          var node = this.createJSXNode();
          this.expectJSX('{');
          this.expectJSX('...');
          this.finishJSX();
          var argument = this.parseAssignmentExpression();
          this.reenterJSX();
          return this.finalize(node, new JSXNode.JSXSpreadAttribute(argument));
        };
        JSXParser.prototype.parseJSXAttributes = function () {
          var attributes = [];
          while (!this.matchJSX('/') && !this.matchJSX('>')) {
            var attribute = this.matchJSX('{') ? this.parseJSXSpreadAttribute() : this.parseJSXNameValueAttribute();
            attributes.push(attribute);
          }
          return attributes;
        };
        JSXParser.prototype.parseJSXOpeningElement = function () {
          var node = this.createJSXNode();
          this.expectJSX('<');
          var name = this.parseJSXElementName();
          var attributes = this.parseJSXAttributes();
          var selfClosing = this.matchJSX('/');
          if (selfClosing) {
            this.expectJSX('/');
          }
          this.expectJSX('>');
          return this.finalize(node, new JSXNode.JSXOpeningElement(name, selfClosing, attributes));
        };
        JSXParser.prototype.parseJSXBoundaryElement = function () {
          var node = this.createJSXNode();
          this.expectJSX('<');
          if (this.matchJSX('/')) {
            this.expectJSX('/');
            var name_3 = this.parseJSXElementName();
            this.expectJSX('>');
            return this.finalize(node, new JSXNode.JSXClosingElement(name_3));
          }
          var name = this.parseJSXElementName();
          var attributes = this.parseJSXAttributes();
          var selfClosing = this.matchJSX('/');
          if (selfClosing) {
            this.expectJSX('/');
          }
          this.expectJSX('>');
          return this.finalize(node, new JSXNode.JSXOpeningElement(name, selfClosing, attributes));
        };
        JSXParser.prototype.parseJSXEmptyExpression = function () {
          var node = this.createJSXChildNode();
          this.collectComments();
          this.lastMarker.index = this.scanner.index;
          this.lastMarker.line = this.scanner.lineNumber;
          this.lastMarker.column = this.scanner.index - this.scanner.lineStart;
          return this.finalize(node, new JSXNode.JSXEmptyExpression());
        };
        JSXParser.prototype.parseJSXExpressionContainer = function () {
          var node = this.createJSXNode();
          this.expectJSX('{');
          var expression;
          if (this.matchJSX('}')) {
            expression = this.parseJSXEmptyExpression();
            this.expectJSX('}');
          } else {
            this.finishJSX();
            expression = this.parseAssignmentExpression();
            this.reenterJSX();
          }
          return this.finalize(node, new JSXNode.JSXExpressionContainer(expression));
        };
        JSXParser.prototype.parseJSXChildren = function () {
          var children = [];
          while (!this.scanner.eof()) {
            var node = this.createJSXChildNode();
            var token = this.nextJSXText();
            if (token.start < token.end) {
              var raw = this.getTokenRaw(token);
              var child = this.finalize(node, new JSXNode.JSXText(token.value, raw));
              children.push(child);
            }
            if (this.scanner.source[this.scanner.index] === '{') {
              var container = this.parseJSXExpressionContainer();
              children.push(container);
            } else {
              break;
            }
          }
          return children;
        };
        JSXParser.prototype.parseComplexJSXElement = function (el) {
          var stack = [];
          while (!this.scanner.eof()) {
            el.children = el.children.concat(this.parseJSXChildren());
            var node = this.createJSXChildNode();
            var element = this.parseJSXBoundaryElement();
            if (element.type === jsx_syntax_1.JSXSyntax.JSXOpeningElement) {
              var opening = element;
              if (opening.selfClosing) {
                var child = this.finalize(node, new JSXNode.JSXElement(opening, [], null));
                el.children.push(child);
              } else {
                stack.push(el);
                el = {
                  node: node,
                  opening: opening,
                  closing: null,
                  children: []
                };
              }
            }
            if (element.type === jsx_syntax_1.JSXSyntax.JSXClosingElement) {
              el.closing = element;
              var open_1 = getQualifiedElementName(el.opening.name);
              var close_1 = getQualifiedElementName(el.closing.name);
              if (open_1 !== close_1) {
                this.tolerateError('Expected corresponding JSX closing tag for %0', open_1);
              }
              if (stack.length > 0) {
                var child = this.finalize(el.node, new JSXNode.JSXElement(el.opening, el.children, el.closing));
                el = stack[stack.length - 1];
                el.children.push(child);
                stack.pop();
              } else {
                break;
              }
            }
          }
          return el;
        };
        JSXParser.prototype.parseJSXElement = function () {
          var node = this.createJSXNode();
          var opening = this.parseJSXOpeningElement();
          var children = [];
          var closing = null;
          if (!opening.selfClosing) {
            var el = this.parseComplexJSXElement({
              node: node,
              opening: opening,
              closing: closing,
              children: children
            });
            children = el.children;
            closing = el.closing;
          }
          return this.finalize(node, new JSXNode.JSXElement(opening, children, closing));
        };
        JSXParser.prototype.parseJSXRoot = function () {
          // Pop the opening '<' added from the lookahead.
          if (this.config.tokens) {
            this.tokens.pop();
          }
          this.startJSX();
          var element = this.parseJSXElement();
          this.finishJSX();
          return element;
        };
        JSXParser.prototype.isStartOfExpression = function () {
          return _super.prototype.isStartOfExpression.call(this) || this.match('<');
        };
        return JSXParser;
      }(parser_1.Parser);
      exports.JSXParser = JSXParser;

      /***/
    }, /* 4 */
    /***/function (module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      // See also tools/generate-unicode-regex.js.
      var Regex = {
        // Unicode v8.0.0 NonAsciiIdentifierStart:
        NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
        // Unicode v8.0.0 NonAsciiIdentifierPart:
        NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
      };
      exports.Character = {
        /* tslint:disable:no-bitwise */
        fromCodePoint: function (cp) {
          return cp < 0x10000 ? String.fromCharCode(cp) : String.fromCharCode(0xD800 + (cp - 0x10000 >> 10)) + String.fromCharCode(0xDC00 + (cp - 0x10000 & 1023));
        },
        // https://tc39.github.io/ecma262/#sec-white-space
        isWhiteSpace: function (cp) {
          return cp === 0x20 || cp === 0x09 || cp === 0x0B || cp === 0x0C || cp === 0xA0 || cp >= 0x1680 && [0x1680, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A, 0x202F, 0x205F, 0x3000, 0xFEFF].indexOf(cp) >= 0;
        },
        // https://tc39.github.io/ecma262/#sec-line-terminators
        isLineTerminator: function (cp) {
          return cp === 0x0A || cp === 0x0D || cp === 0x2028 || cp === 0x2029;
        },
        // https://tc39.github.io/ecma262/#sec-names-and-keywords
        isIdentifierStart: function (cp) {
          return cp === 0x24 || cp === 0x5F || cp >= 0x41 && cp <= 0x5A || cp >= 0x61 && cp <= 0x7A || cp === 0x5C || cp >= 0x80 && Regex.NonAsciiIdentifierStart.test(exports.Character.fromCodePoint(cp));
        },
        isIdentifierPart: function (cp) {
          return cp === 0x24 || cp === 0x5F || cp >= 0x41 && cp <= 0x5A || cp >= 0x61 && cp <= 0x7A || cp >= 0x30 && cp <= 0x39 || cp === 0x5C || cp >= 0x80 && Regex.NonAsciiIdentifierPart.test(exports.Character.fromCodePoint(cp));
        },
        // https://tc39.github.io/ecma262/#sec-literals-numeric-literals
        isDecimalDigit: function (cp) {
          return cp >= 0x30 && cp <= 0x39; // 0..9
        },

        isHexDigit: function (cp) {
          return cp >= 0x30 && cp <= 0x39 || cp >= 0x41 && cp <= 0x46 || cp >= 0x61 && cp <= 0x66; // a..f
        },

        isOctalDigit: function (cp) {
          return cp >= 0x30 && cp <= 0x37; // 0..7
        }
      };

      /***/
    }, /* 5 */
    /***/function (module, exports, __nested_webpack_require_55018__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var jsx_syntax_1 = __nested_webpack_require_55018__(6);
      /* tslint:disable:max-classes-per-file */
      var JSXClosingElement = function () {
        function JSXClosingElement(name) {
          this.type = jsx_syntax_1.JSXSyntax.JSXClosingElement;
          this.name = name;
        }
        return JSXClosingElement;
      }();
      exports.JSXClosingElement = JSXClosingElement;
      var JSXElement = function () {
        function JSXElement(openingElement, children, closingElement) {
          this.type = jsx_syntax_1.JSXSyntax.JSXElement;
          this.openingElement = openingElement;
          this.children = children;
          this.closingElement = closingElement;
        }
        return JSXElement;
      }();
      exports.JSXElement = JSXElement;
      var JSXEmptyExpression = function () {
        function JSXEmptyExpression() {
          this.type = jsx_syntax_1.JSXSyntax.JSXEmptyExpression;
        }
        return JSXEmptyExpression;
      }();
      exports.JSXEmptyExpression = JSXEmptyExpression;
      var JSXExpressionContainer = function () {
        function JSXExpressionContainer(expression) {
          this.type = jsx_syntax_1.JSXSyntax.JSXExpressionContainer;
          this.expression = expression;
        }
        return JSXExpressionContainer;
      }();
      exports.JSXExpressionContainer = JSXExpressionContainer;
      var JSXIdentifier = function () {
        function JSXIdentifier(name) {
          this.type = jsx_syntax_1.JSXSyntax.JSXIdentifier;
          this.name = name;
        }
        return JSXIdentifier;
      }();
      exports.JSXIdentifier = JSXIdentifier;
      var JSXMemberExpression = function () {
        function JSXMemberExpression(object, property) {
          this.type = jsx_syntax_1.JSXSyntax.JSXMemberExpression;
          this.object = object;
          this.property = property;
        }
        return JSXMemberExpression;
      }();
      exports.JSXMemberExpression = JSXMemberExpression;
      var JSXAttribute = function () {
        function JSXAttribute(name, value) {
          this.type = jsx_syntax_1.JSXSyntax.JSXAttribute;
          this.name = name;
          this.value = value;
        }
        return JSXAttribute;
      }();
      exports.JSXAttribute = JSXAttribute;
      var JSXNamespacedName = function () {
        function JSXNamespacedName(namespace, name) {
          this.type = jsx_syntax_1.JSXSyntax.JSXNamespacedName;
          this.namespace = namespace;
          this.name = name;
        }
        return JSXNamespacedName;
      }();
      exports.JSXNamespacedName = JSXNamespacedName;
      var JSXOpeningElement = function () {
        function JSXOpeningElement(name, selfClosing, attributes) {
          this.type = jsx_syntax_1.JSXSyntax.JSXOpeningElement;
          this.name = name;
          this.selfClosing = selfClosing;
          this.attributes = attributes;
        }
        return JSXOpeningElement;
      }();
      exports.JSXOpeningElement = JSXOpeningElement;
      var JSXSpreadAttribute = function () {
        function JSXSpreadAttribute(argument) {
          this.type = jsx_syntax_1.JSXSyntax.JSXSpreadAttribute;
          this.argument = argument;
        }
        return JSXSpreadAttribute;
      }();
      exports.JSXSpreadAttribute = JSXSpreadAttribute;
      var JSXText = function () {
        function JSXText(value, raw) {
          this.type = jsx_syntax_1.JSXSyntax.JSXText;
          this.value = value;
          this.raw = raw;
        }
        return JSXText;
      }();
      exports.JSXText = JSXText;

      /***/
    }, /* 6 */
    /***/function (module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.JSXSyntax = {
        JSXAttribute: 'JSXAttribute',
        JSXClosingElement: 'JSXClosingElement',
        JSXElement: 'JSXElement',
        JSXEmptyExpression: 'JSXEmptyExpression',
        JSXExpressionContainer: 'JSXExpressionContainer',
        JSXIdentifier: 'JSXIdentifier',
        JSXMemberExpression: 'JSXMemberExpression',
        JSXNamespacedName: 'JSXNamespacedName',
        JSXOpeningElement: 'JSXOpeningElement',
        JSXSpreadAttribute: 'JSXSpreadAttribute',
        JSXText: 'JSXText'
      };

      /***/
    }, /* 7 */
    /***/function (module, exports, __nested_webpack_require_59478__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var syntax_1 = __nested_webpack_require_59478__(2);
      /* tslint:disable:max-classes-per-file */
      var ArrayExpression = function () {
        function ArrayExpression(elements) {
          this.type = syntax_1.Syntax.ArrayExpression;
          this.elements = elements;
        }
        return ArrayExpression;
      }();
      exports.ArrayExpression = ArrayExpression;
      var ArrayPattern = function () {
        function ArrayPattern(elements) {
          this.type = syntax_1.Syntax.ArrayPattern;
          this.elements = elements;
        }
        return ArrayPattern;
      }();
      exports.ArrayPattern = ArrayPattern;
      var ArrowFunctionExpression = function () {
        function ArrowFunctionExpression(params, body, expression) {
          this.type = syntax_1.Syntax.ArrowFunctionExpression;
          this.id = null;
          this.params = params;
          this.body = body;
          this.generator = false;
          this.expression = expression;
          this.async = false;
        }
        return ArrowFunctionExpression;
      }();
      exports.ArrowFunctionExpression = ArrowFunctionExpression;
      var AssignmentExpression = function () {
        function AssignmentExpression(operator, left, right) {
          this.type = syntax_1.Syntax.AssignmentExpression;
          this.operator = operator;
          this.left = left;
          this.right = right;
        }
        return AssignmentExpression;
      }();
      exports.AssignmentExpression = AssignmentExpression;
      var AssignmentPattern = function () {
        function AssignmentPattern(left, right) {
          this.type = syntax_1.Syntax.AssignmentPattern;
          this.left = left;
          this.right = right;
        }
        return AssignmentPattern;
      }();
      exports.AssignmentPattern = AssignmentPattern;
      var AsyncArrowFunctionExpression = function () {
        function AsyncArrowFunctionExpression(params, body, expression) {
          this.type = syntax_1.Syntax.ArrowFunctionExpression;
          this.id = null;
          this.params = params;
          this.body = body;
          this.generator = false;
          this.expression = expression;
          this.async = true;
        }
        return AsyncArrowFunctionExpression;
      }();
      exports.AsyncArrowFunctionExpression = AsyncArrowFunctionExpression;
      var AsyncFunctionDeclaration = function () {
        function AsyncFunctionDeclaration(id, params, body) {
          this.type = syntax_1.Syntax.FunctionDeclaration;
          this.id = id;
          this.params = params;
          this.body = body;
          this.generator = false;
          this.expression = false;
          this.async = true;
        }
        return AsyncFunctionDeclaration;
      }();
      exports.AsyncFunctionDeclaration = AsyncFunctionDeclaration;
      var AsyncFunctionExpression = function () {
        function AsyncFunctionExpression(id, params, body) {
          this.type = syntax_1.Syntax.FunctionExpression;
          this.id = id;
          this.params = params;
          this.body = body;
          this.generator = false;
          this.expression = false;
          this.async = true;
        }
        return AsyncFunctionExpression;
      }();
      exports.AsyncFunctionExpression = AsyncFunctionExpression;
      var AwaitExpression = function () {
        function AwaitExpression(argument) {
          this.type = syntax_1.Syntax.AwaitExpression;
          this.argument = argument;
        }
        return AwaitExpression;
      }();
      exports.AwaitExpression = AwaitExpression;
      var BinaryExpression = function () {
        function BinaryExpression(operator, left, right) {
          var logical = operator === '||' || operator === '&&';
          this.type = logical ? syntax_1.Syntax.LogicalExpression : syntax_1.Syntax.BinaryExpression;
          this.operator = operator;
          this.left = left;
          this.right = right;
        }
        return BinaryExpression;
      }();
      exports.BinaryExpression = BinaryExpression;
      var BlockStatement = function () {
        function BlockStatement(body) {
          this.type = syntax_1.Syntax.BlockStatement;
          this.body = body;
        }
        return BlockStatement;
      }();
      exports.BlockStatement = BlockStatement;
      var BreakStatement = function () {
        function BreakStatement(label) {
          this.type = syntax_1.Syntax.BreakStatement;
          this.label = label;
        }
        return BreakStatement;
      }();
      exports.BreakStatement = BreakStatement;
      var CallExpression = function () {
        function CallExpression(callee, args) {
          this.type = syntax_1.Syntax.CallExpression;
          this.callee = callee;
          this.arguments = args;
        }
        return CallExpression;
      }();
      exports.CallExpression = CallExpression;
      var CatchClause = function () {
        function CatchClause(param, body) {
          this.type = syntax_1.Syntax.CatchClause;
          this.param = param;
          this.body = body;
        }
        return CatchClause;
      }();
      exports.CatchClause = CatchClause;
      var ClassBody = function () {
        function ClassBody(body) {
          this.type = syntax_1.Syntax.ClassBody;
          this.body = body;
        }
        return ClassBody;
      }();
      exports.ClassBody = ClassBody;
      var ClassDeclaration = function () {
        function ClassDeclaration(id, superClass, body) {
          this.type = syntax_1.Syntax.ClassDeclaration;
          this.id = id;
          this.superClass = superClass;
          this.body = body;
        }
        return ClassDeclaration;
      }();
      exports.ClassDeclaration = ClassDeclaration;
      var ClassExpression = function () {
        function ClassExpression(id, superClass, body) {
          this.type = syntax_1.Syntax.ClassExpression;
          this.id = id;
          this.superClass = superClass;
          this.body = body;
        }
        return ClassExpression;
      }();
      exports.ClassExpression = ClassExpression;
      var ComputedMemberExpression = function () {
        function ComputedMemberExpression(object, property) {
          this.type = syntax_1.Syntax.MemberExpression;
          this.computed = true;
          this.object = object;
          this.property = property;
        }
        return ComputedMemberExpression;
      }();
      exports.ComputedMemberExpression = ComputedMemberExpression;
      var ConditionalExpression = function () {
        function ConditionalExpression(test, consequent, alternate) {
          this.type = syntax_1.Syntax.ConditionalExpression;
          this.test = test;
          this.consequent = consequent;
          this.alternate = alternate;
        }
        return ConditionalExpression;
      }();
      exports.ConditionalExpression = ConditionalExpression;
      var ContinueStatement = function () {
        function ContinueStatement(label) {
          this.type = syntax_1.Syntax.ContinueStatement;
          this.label = label;
        }
        return ContinueStatement;
      }();
      exports.ContinueStatement = ContinueStatement;
      var DebuggerStatement = function () {
        function DebuggerStatement() {
          this.type = syntax_1.Syntax.DebuggerStatement;
        }
        return DebuggerStatement;
      }();
      exports.DebuggerStatement = DebuggerStatement;
      var Directive = function () {
        function Directive(expression, directive) {
          this.type = syntax_1.Syntax.ExpressionStatement;
          this.expression = expression;
          this.directive = directive;
        }
        return Directive;
      }();
      exports.Directive = Directive;
      var DoWhileStatement = function () {
        function DoWhileStatement(body, test) {
          this.type = syntax_1.Syntax.DoWhileStatement;
          this.body = body;
          this.test = test;
        }
        return DoWhileStatement;
      }();
      exports.DoWhileStatement = DoWhileStatement;
      var EmptyStatement = function () {
        function EmptyStatement() {
          this.type = syntax_1.Syntax.EmptyStatement;
        }
        return EmptyStatement;
      }();
      exports.EmptyStatement = EmptyStatement;
      var ExportAllDeclaration = function () {
        function ExportAllDeclaration(source) {
          this.type = syntax_1.Syntax.ExportAllDeclaration;
          this.source = source;
        }
        return ExportAllDeclaration;
      }();
      exports.ExportAllDeclaration = ExportAllDeclaration;
      var ExportDefaultDeclaration = function () {
        function ExportDefaultDeclaration(declaration) {
          this.type = syntax_1.Syntax.ExportDefaultDeclaration;
          this.declaration = declaration;
        }
        return ExportDefaultDeclaration;
      }();
      exports.ExportDefaultDeclaration = ExportDefaultDeclaration;
      var ExportNamedDeclaration = function () {
        function ExportNamedDeclaration(declaration, specifiers, source) {
          this.type = syntax_1.Syntax.ExportNamedDeclaration;
          this.declaration = declaration;
          this.specifiers = specifiers;
          this.source = source;
        }
        return ExportNamedDeclaration;
      }();
      exports.ExportNamedDeclaration = ExportNamedDeclaration;
      var ExportSpecifier = function () {
        function ExportSpecifier(local, exported) {
          this.type = syntax_1.Syntax.ExportSpecifier;
          this.exported = exported;
          this.local = local;
        }
        return ExportSpecifier;
      }();
      exports.ExportSpecifier = ExportSpecifier;
      var ExpressionStatement = function () {
        function ExpressionStatement(expression) {
          this.type = syntax_1.Syntax.ExpressionStatement;
          this.expression = expression;
        }
        return ExpressionStatement;
      }();
      exports.ExpressionStatement = ExpressionStatement;
      var ForInStatement = function () {
        function ForInStatement(left, right, body) {
          this.type = syntax_1.Syntax.ForInStatement;
          this.left = left;
          this.right = right;
          this.body = body;
          this.each = false;
        }
        return ForInStatement;
      }();
      exports.ForInStatement = ForInStatement;
      var ForOfStatement = function () {
        function ForOfStatement(left, right, body) {
          this.type = syntax_1.Syntax.ForOfStatement;
          this.left = left;
          this.right = right;
          this.body = body;
        }
        return ForOfStatement;
      }();
      exports.ForOfStatement = ForOfStatement;
      var ForStatement = function () {
        function ForStatement(init, test, update, body) {
          this.type = syntax_1.Syntax.ForStatement;
          this.init = init;
          this.test = test;
          this.update = update;
          this.body = body;
        }
        return ForStatement;
      }();
      exports.ForStatement = ForStatement;
      var FunctionDeclaration = function () {
        function FunctionDeclaration(id, params, body, generator) {
          this.type = syntax_1.Syntax.FunctionDeclaration;
          this.id = id;
          this.params = params;
          this.body = body;
          this.generator = generator;
          this.expression = false;
          this.async = false;
        }
        return FunctionDeclaration;
      }();
      exports.FunctionDeclaration = FunctionDeclaration;
      var FunctionExpression = function () {
        function FunctionExpression(id, params, body, generator) {
          this.type = syntax_1.Syntax.FunctionExpression;
          this.id = id;
          this.params = params;
          this.body = body;
          this.generator = generator;
          this.expression = false;
          this.async = false;
        }
        return FunctionExpression;
      }();
      exports.FunctionExpression = FunctionExpression;
      var Identifier = function () {
        function Identifier(name) {
          this.type = syntax_1.Syntax.Identifier;
          this.name = name;
        }
        return Identifier;
      }();
      exports.Identifier = Identifier;
      var IfStatement = function () {
        function IfStatement(test, consequent, alternate) {
          this.type = syntax_1.Syntax.IfStatement;
          this.test = test;
          this.consequent = consequent;
          this.alternate = alternate;
        }
        return IfStatement;
      }();
      exports.IfStatement = IfStatement;
      var ImportDeclaration = function () {
        function ImportDeclaration(specifiers, source) {
          this.type = syntax_1.Syntax.ImportDeclaration;
          this.specifiers = specifiers;
          this.source = source;
        }
        return ImportDeclaration;
      }();
      exports.ImportDeclaration = ImportDeclaration;
      var ImportDefaultSpecifier = function () {
        function ImportDefaultSpecifier(local) {
          this.type = syntax_1.Syntax.ImportDefaultSpecifier;
          this.local = local;
        }
        return ImportDefaultSpecifier;
      }();
      exports.ImportDefaultSpecifier = ImportDefaultSpecifier;
      var ImportNamespaceSpecifier = function () {
        function ImportNamespaceSpecifier(local) {
          this.type = syntax_1.Syntax.ImportNamespaceSpecifier;
          this.local = local;
        }
        return ImportNamespaceSpecifier;
      }();
      exports.ImportNamespaceSpecifier = ImportNamespaceSpecifier;
      var ImportSpecifier = function () {
        function ImportSpecifier(local, imported) {
          this.type = syntax_1.Syntax.ImportSpecifier;
          this.local = local;
          this.imported = imported;
        }
        return ImportSpecifier;
      }();
      exports.ImportSpecifier = ImportSpecifier;
      var LabeledStatement = function () {
        function LabeledStatement(label, body) {
          this.type = syntax_1.Syntax.LabeledStatement;
          this.label = label;
          this.body = body;
        }
        return LabeledStatement;
      }();
      exports.LabeledStatement = LabeledStatement;
      var Literal = function () {
        function Literal(value, raw) {
          this.type = syntax_1.Syntax.Literal;
          this.value = value;
          this.raw = raw;
        }
        return Literal;
      }();
      exports.Literal = Literal;
      var MetaProperty = function () {
        function MetaProperty(meta, property) {
          this.type = syntax_1.Syntax.MetaProperty;
          this.meta = meta;
          this.property = property;
        }
        return MetaProperty;
      }();
      exports.MetaProperty = MetaProperty;
      var MethodDefinition = function () {
        function MethodDefinition(key, computed, value, kind, isStatic) {
          this.type = syntax_1.Syntax.MethodDefinition;
          this.key = key;
          this.computed = computed;
          this.value = value;
          this.kind = kind;
          this.static = isStatic;
        }
        return MethodDefinition;
      }();
      exports.MethodDefinition = MethodDefinition;
      var Module = function () {
        function Module(body) {
          this.type = syntax_1.Syntax.Program;
          this.body = body;
          this.sourceType = 'module';
        }
        return Module;
      }();
      exports.Module = Module;
      var NewExpression = function () {
        function NewExpression(callee, args) {
          this.type = syntax_1.Syntax.NewExpression;
          this.callee = callee;
          this.arguments = args;
        }
        return NewExpression;
      }();
      exports.NewExpression = NewExpression;
      var ObjectExpression = function () {
        function ObjectExpression(properties) {
          this.type = syntax_1.Syntax.ObjectExpression;
          this.properties = properties;
        }
        return ObjectExpression;
      }();
      exports.ObjectExpression = ObjectExpression;
      var ObjectPattern = function () {
        function ObjectPattern(properties) {
          this.type = syntax_1.Syntax.ObjectPattern;
          this.properties = properties;
        }
        return ObjectPattern;
      }();
      exports.ObjectPattern = ObjectPattern;
      var Property = function () {
        function Property(kind, key, computed, value, method, shorthand) {
          this.type = syntax_1.Syntax.Property;
          this.key = key;
          this.computed = computed;
          this.value = value;
          this.kind = kind;
          this.method = method;
          this.shorthand = shorthand;
        }
        return Property;
      }();
      exports.Property = Property;
      var RegexLiteral = function () {
        function RegexLiteral(value, raw, pattern, flags) {
          this.type = syntax_1.Syntax.Literal;
          this.value = value;
          this.raw = raw;
          this.regex = {
            pattern: pattern,
            flags: flags
          };
        }
        return RegexLiteral;
      }();
      exports.RegexLiteral = RegexLiteral;
      var RestElement = function () {
        function RestElement(argument) {
          this.type = syntax_1.Syntax.RestElement;
          this.argument = argument;
        }
        return RestElement;
      }();
      exports.RestElement = RestElement;
      var ReturnStatement = function () {
        function ReturnStatement(argument) {
          this.type = syntax_1.Syntax.ReturnStatement;
          this.argument = argument;
        }
        return ReturnStatement;
      }();
      exports.ReturnStatement = ReturnStatement;
      var Script = function () {
        function Script(body) {
          this.type = syntax_1.Syntax.Program;
          this.body = body;
          this.sourceType = 'script';
        }
        return Script;
      }();
      exports.Script = Script;
      var SequenceExpression = function () {
        function SequenceExpression(expressions) {
          this.type = syntax_1.Syntax.SequenceExpression;
          this.expressions = expressions;
        }
        return SequenceExpression;
      }();
      exports.SequenceExpression = SequenceExpression;
      var SpreadElement = function () {
        function SpreadElement(argument) {
          this.type = syntax_1.Syntax.SpreadElement;
          this.argument = argument;
        }
        return SpreadElement;
      }();
      exports.SpreadElement = SpreadElement;
      var StaticMemberExpression = function () {
        function StaticMemberExpression(object, property) {
          this.type = syntax_1.Syntax.MemberExpression;
          this.computed = false;
          this.object = object;
          this.property = property;
        }
        return StaticMemberExpression;
      }();
      exports.StaticMemberExpression = StaticMemberExpression;
      var Super = function () {
        function Super() {
          this.type = syntax_1.Syntax.Super;
        }
        return Super;
      }();
      exports.Super = Super;
      var SwitchCase = function () {
        function SwitchCase(test, consequent) {
          this.type = syntax_1.Syntax.SwitchCase;
          this.test = test;
          this.consequent = consequent;
        }
        return SwitchCase;
      }();
      exports.SwitchCase = SwitchCase;
      var SwitchStatement = function () {
        function SwitchStatement(discriminant, cases) {
          this.type = syntax_1.Syntax.SwitchStatement;
          this.discriminant = discriminant;
          this.cases = cases;
        }
        return SwitchStatement;
      }();
      exports.SwitchStatement = SwitchStatement;
      var TaggedTemplateExpression = function () {
        function TaggedTemplateExpression(tag, quasi) {
          this.type = syntax_1.Syntax.TaggedTemplateExpression;
          this.tag = tag;
          this.quasi = quasi;
        }
        return TaggedTemplateExpression;
      }();
      exports.TaggedTemplateExpression = TaggedTemplateExpression;
      var TemplateElement = function () {
        function TemplateElement(value, tail) {
          this.type = syntax_1.Syntax.TemplateElement;
          this.value = value;
          this.tail = tail;
        }
        return TemplateElement;
      }();
      exports.TemplateElement = TemplateElement;
      var TemplateLiteral = function () {
        function TemplateLiteral(quasis, expressions) {
          this.type = syntax_1.Syntax.TemplateLiteral;
          this.quasis = quasis;
          this.expressions = expressions;
        }
        return TemplateLiteral;
      }();
      exports.TemplateLiteral = TemplateLiteral;
      var ThisExpression = function () {
        function ThisExpression() {
          this.type = syntax_1.Syntax.ThisExpression;
        }
        return ThisExpression;
      }();
      exports.ThisExpression = ThisExpression;
      var ThrowStatement = function () {
        function ThrowStatement(argument) {
          this.type = syntax_1.Syntax.ThrowStatement;
          this.argument = argument;
        }
        return ThrowStatement;
      }();
      exports.ThrowStatement = ThrowStatement;
      var TryStatement = function () {
        function TryStatement(block, handler, finalizer) {
          this.type = syntax_1.Syntax.TryStatement;
          this.block = block;
          this.handler = handler;
          this.finalizer = finalizer;
        }
        return TryStatement;
      }();
      exports.TryStatement = TryStatement;
      var UnaryExpression = function () {
        function UnaryExpression(operator, argument) {
          this.type = syntax_1.Syntax.UnaryExpression;
          this.operator = operator;
          this.argument = argument;
          this.prefix = true;
        }
        return UnaryExpression;
      }();
      exports.UnaryExpression = UnaryExpression;
      var UpdateExpression = function () {
        function UpdateExpression(operator, argument, prefix) {
          this.type = syntax_1.Syntax.UpdateExpression;
          this.operator = operator;
          this.argument = argument;
          this.prefix = prefix;
        }
        return UpdateExpression;
      }();
      exports.UpdateExpression = UpdateExpression;
      var VariableDeclaration = function () {
        function VariableDeclaration(declarations, kind) {
          this.type = syntax_1.Syntax.VariableDeclaration;
          this.declarations = declarations;
          this.kind = kind;
        }
        return VariableDeclaration;
      }();
      exports.VariableDeclaration = VariableDeclaration;
      var VariableDeclarator = function () {
        function VariableDeclarator(id, init) {
          this.type = syntax_1.Syntax.VariableDeclarator;
          this.id = id;
          this.init = init;
        }
        return VariableDeclarator;
      }();
      exports.VariableDeclarator = VariableDeclarator;
      var WhileStatement = function () {
        function WhileStatement(test, body) {
          this.type = syntax_1.Syntax.WhileStatement;
          this.test = test;
          this.body = body;
        }
        return WhileStatement;
      }();
      exports.WhileStatement = WhileStatement;
      var WithStatement = function () {
        function WithStatement(object, body) {
          this.type = syntax_1.Syntax.WithStatement;
          this.object = object;
          this.body = body;
        }
        return WithStatement;
      }();
      exports.WithStatement = WithStatement;
      var YieldExpression = function () {
        function YieldExpression(argument, delegate) {
          this.type = syntax_1.Syntax.YieldExpression;
          this.argument = argument;
          this.delegate = delegate;
        }
        return YieldExpression;
      }();
      exports.YieldExpression = YieldExpression;

      /***/
    }, /* 8 */
    /***/function (module, exports, __nested_webpack_require_83454__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var assert_1 = __nested_webpack_require_83454__(9);
      var error_handler_1 = __nested_webpack_require_83454__(10);
      var messages_1 = __nested_webpack_require_83454__(11);
      var Node = __nested_webpack_require_83454__(7);
      var scanner_1 = __nested_webpack_require_83454__(12);
      var syntax_1 = __nested_webpack_require_83454__(2);
      var token_1 = __nested_webpack_require_83454__(13);
      var ArrowParameterPlaceHolder = 'ArrowParameterPlaceHolder';
      var Parser = function () {
        function Parser(code, options, delegate) {
          if (options === void 0) {
            options = {};
          }
          this.config = {
            range: typeof options.range === 'boolean' && options.range,
            loc: typeof options.loc === 'boolean' && options.loc,
            source: null,
            tokens: typeof options.tokens === 'boolean' && options.tokens,
            comment: typeof options.comment === 'boolean' && options.comment,
            tolerant: typeof options.tolerant === 'boolean' && options.tolerant
          };
          if (this.config.loc && options.source && options.source !== null) {
            this.config.source = String(options.source);
          }
          this.delegate = delegate;
          this.errorHandler = new error_handler_1.ErrorHandler();
          this.errorHandler.tolerant = this.config.tolerant;
          this.scanner = new scanner_1.Scanner(code, this.errorHandler);
          this.scanner.trackComment = this.config.comment;
          this.operatorPrecedence = {
            ')': 0,
            ';': 0,
            ',': 0,
            '=': 0,
            ']': 0,
            '||': 1,
            '&&': 2,
            '|': 3,
            '^': 4,
            '&': 5,
            '==': 6,
            '!=': 6,
            '===': 6,
            '!==': 6,
            '<': 7,
            '>': 7,
            '<=': 7,
            '>=': 7,
            '<<': 8,
            '>>': 8,
            '>>>': 8,
            '+': 9,
            '-': 9,
            '*': 11,
            '/': 11,
            '%': 11
          };
          this.lookahead = {
            type: 2 /* EOF */,
            value: '',
            lineNumber: this.scanner.lineNumber,
            lineStart: 0,
            start: 0,
            end: 0
          };
          this.hasLineTerminator = false;
          this.context = {
            isModule: false,
            await: false,
            allowIn: true,
            allowStrictDirective: true,
            allowYield: true,
            firstCoverInitializedNameError: null,
            isAssignmentTarget: false,
            isBindingElement: false,
            inFunctionBody: false,
            inIteration: false,
            inSwitch: false,
            labelSet: {},
            strict: false
          };
          this.tokens = [];
          this.startMarker = {
            index: 0,
            line: this.scanner.lineNumber,
            column: 0
          };
          this.lastMarker = {
            index: 0,
            line: this.scanner.lineNumber,
            column: 0
          };
          this.nextToken();
          this.lastMarker = {
            index: this.scanner.index,
            line: this.scanner.lineNumber,
            column: this.scanner.index - this.scanner.lineStart
          };
        }
        Parser.prototype.throwError = function (messageFormat) {
          var values = [];
          for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
          }
          var args = Array.prototype.slice.call(arguments, 1);
          var msg = messageFormat.replace(/%(\d)/g, function (whole, idx) {
            assert_1.assert(idx < args.length, 'Message reference must be in range');
            return args[idx];
          });
          var index = this.lastMarker.index;
          var line = this.lastMarker.line;
          var column = this.lastMarker.column + 1;
          throw this.errorHandler.createError(index, line, column, msg);
        };
        Parser.prototype.tolerateError = function (messageFormat) {
          var values = [];
          for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
          }
          var args = Array.prototype.slice.call(arguments, 1);
          var msg = messageFormat.replace(/%(\d)/g, function (whole, idx) {
            assert_1.assert(idx < args.length, 'Message reference must be in range');
            return args[idx];
          });
          var index = this.lastMarker.index;
          var line = this.scanner.lineNumber;
          var column = this.lastMarker.column + 1;
          this.errorHandler.tolerateError(index, line, column, msg);
        };
        // Throw an exception because of the token.
        Parser.prototype.unexpectedTokenError = function (token, message) {
          var msg = message || messages_1.Messages.UnexpectedToken;
          var value;
          if (token) {
            if (!message) {
              msg = token.type === 2 /* EOF */ ? messages_1.Messages.UnexpectedEOS : token.type === 3 /* Identifier */ ? messages_1.Messages.UnexpectedIdentifier : token.type === 6 /* NumericLiteral */ ? messages_1.Messages.UnexpectedNumber : token.type === 8 /* StringLiteral */ ? messages_1.Messages.UnexpectedString : token.type === 10 /* Template */ ? messages_1.Messages.UnexpectedTemplate : messages_1.Messages.UnexpectedToken;
              if (token.type === 4 /* Keyword */) {
                if (this.scanner.isFutureReservedWord(token.value)) {
                  msg = messages_1.Messages.UnexpectedReserved;
                } else if (this.context.strict && this.scanner.isStrictModeReservedWord(token.value)) {
                  msg = messages_1.Messages.StrictReservedWord;
                }
              }
            }
            value = token.value;
          } else {
            value = 'ILLEGAL';
          }
          msg = msg.replace('%0', value);
          if (token && typeof token.lineNumber === 'number') {
            var index = token.start;
            var line = token.lineNumber;
            var lastMarkerLineStart = this.lastMarker.index - this.lastMarker.column;
            var column = token.start - lastMarkerLineStart + 1;
            return this.errorHandler.createError(index, line, column, msg);
          } else {
            var index = this.lastMarker.index;
            var line = this.lastMarker.line;
            var column = this.lastMarker.column + 1;
            return this.errorHandler.createError(index, line, column, msg);
          }
        };
        Parser.prototype.throwUnexpectedToken = function (token, message) {
          throw this.unexpectedTokenError(token, message);
        };
        Parser.prototype.tolerateUnexpectedToken = function (token, message) {
          this.errorHandler.tolerate(this.unexpectedTokenError(token, message));
        };
        Parser.prototype.collectComments = function () {
          if (!this.config.comment) {
            this.scanner.scanComments();
          } else {
            var comments = this.scanner.scanComments();
            if (comments.length > 0 && this.delegate) {
              for (var i = 0; i < comments.length; ++i) {
                var e = comments[i];
                var node = void 0;
                node = {
                  type: e.multiLine ? 'BlockComment' : 'LineComment',
                  value: this.scanner.source.slice(e.slice[0], e.slice[1])
                };
                if (this.config.range) {
                  node.range = e.range;
                }
                if (this.config.loc) {
                  node.loc = e.loc;
                }
                var metadata = {
                  start: {
                    line: e.loc.start.line,
                    column: e.loc.start.column,
                    offset: e.range[0]
                  },
                  end: {
                    line: e.loc.end.line,
                    column: e.loc.end.column,
                    offset: e.range[1]
                  }
                };
                this.delegate(node, metadata);
              }
            }
          }
        };
        // From internal representation to an external structure
        Parser.prototype.getTokenRaw = function (token) {
          return this.scanner.source.slice(token.start, token.end);
        };
        Parser.prototype.convertToken = function (token) {
          var t = {
            type: token_1.TokenName[token.type],
            value: this.getTokenRaw(token)
          };
          if (this.config.range) {
            t.range = [token.start, token.end];
          }
          if (this.config.loc) {
            t.loc = {
              start: {
                line: this.startMarker.line,
                column: this.startMarker.column
              },
              end: {
                line: this.scanner.lineNumber,
                column: this.scanner.index - this.scanner.lineStart
              }
            };
          }
          if (token.type === 9 /* RegularExpression */) {
            var pattern = token.pattern;
            var flags = token.flags;
            t.regex = {
              pattern: pattern,
              flags: flags
            };
          }
          return t;
        };
        Parser.prototype.nextToken = function () {
          var token = this.lookahead;
          this.lastMarker.index = this.scanner.index;
          this.lastMarker.line = this.scanner.lineNumber;
          this.lastMarker.column = this.scanner.index - this.scanner.lineStart;
          this.collectComments();
          if (this.scanner.index !== this.startMarker.index) {
            this.startMarker.index = this.scanner.index;
            this.startMarker.line = this.scanner.lineNumber;
            this.startMarker.column = this.scanner.index - this.scanner.lineStart;
          }
          var next = this.scanner.lex();
          this.hasLineTerminator = token.lineNumber !== next.lineNumber;
          if (next && this.context.strict && next.type === 3 /* Identifier */) {
            if (this.scanner.isStrictModeReservedWord(next.value)) {
              next.type = 4 /* Keyword */;
            }
          }

          this.lookahead = next;
          if (this.config.tokens && next.type !== 2 /* EOF */) {
            this.tokens.push(this.convertToken(next));
          }
          return token;
        };
        Parser.prototype.nextRegexToken = function () {
          this.collectComments();
          var token = this.scanner.scanRegExp();
          if (this.config.tokens) {
            // Pop the previous token, '/' or '/='
            // This is added from the lookahead token.
            this.tokens.pop();
            this.tokens.push(this.convertToken(token));
          }
          // Prime the next lookahead.
          this.lookahead = token;
          this.nextToken();
          return token;
        };
        Parser.prototype.createNode = function () {
          return {
            index: this.startMarker.index,
            line: this.startMarker.line,
            column: this.startMarker.column
          };
        };
        Parser.prototype.startNode = function (token, lastLineStart) {
          if (lastLineStart === void 0) {
            lastLineStart = 0;
          }
          var column = token.start - token.lineStart;
          var line = token.lineNumber;
          if (column < 0) {
            column += lastLineStart;
            line--;
          }
          return {
            index: token.start,
            line: line,
            column: column
          };
        };
        Parser.prototype.finalize = function (marker, node) {
          if (this.config.range) {
            node.range = [marker.index, this.lastMarker.index];
          }
          if (this.config.loc) {
            node.loc = {
              start: {
                line: marker.line,
                column: marker.column
              },
              end: {
                line: this.lastMarker.line,
                column: this.lastMarker.column
              }
            };
            if (this.config.source) {
              node.loc.source = this.config.source;
            }
          }
          if (this.delegate) {
            var metadata = {
              start: {
                line: marker.line,
                column: marker.column,
                offset: marker.index
              },
              end: {
                line: this.lastMarker.line,
                column: this.lastMarker.column,
                offset: this.lastMarker.index
              }
            };
            this.delegate(node, metadata);
          }
          return node;
        };
        // Expect the next token to match the specified punctuator.
        // If not, an exception will be thrown.
        Parser.prototype.expect = function (value) {
          var token = this.nextToken();
          if (token.type !== 7 /* Punctuator */ || token.value !== value) {
            this.throwUnexpectedToken(token);
          }
        };
        // Quietly expect a comma when in tolerant mode, otherwise delegates to expect().
        Parser.prototype.expectCommaSeparator = function () {
          if (this.config.tolerant) {
            var token = this.lookahead;
            if (token.type === 7 /* Punctuator */ && token.value === ',') {
              this.nextToken();
            } else if (token.type === 7 /* Punctuator */ && token.value === ';') {
              this.nextToken();
              this.tolerateUnexpectedToken(token);
            } else {
              this.tolerateUnexpectedToken(token, messages_1.Messages.UnexpectedToken);
            }
          } else {
            this.expect(',');
          }
        };
        // Expect the next token to match the specified keyword.
        // If not, an exception will be thrown.
        Parser.prototype.expectKeyword = function (keyword) {
          var token = this.nextToken();
          if (token.type !== 4 /* Keyword */ || token.value !== keyword) {
            this.throwUnexpectedToken(token);
          }
        };
        // Return true if the next token matches the specified punctuator.
        Parser.prototype.match = function (value) {
          return this.lookahead.type === 7 /* Punctuator */ && this.lookahead.value === value;
        };
        // Return true if the next token matches the specified keyword
        Parser.prototype.matchKeyword = function (keyword) {
          return this.lookahead.type === 4 /* Keyword */ && this.lookahead.value === keyword;
        };
        // Return true if the next token matches the specified contextual keyword
        // (where an identifier is sometimes a keyword depending on the context)
        Parser.prototype.matchContextualKeyword = function (keyword) {
          return this.lookahead.type === 3 /* Identifier */ && this.lookahead.value === keyword;
        };
        // Return true if the next token is an assignment operator
        Parser.prototype.matchAssign = function () {
          if (this.lookahead.type !== 7 /* Punctuator */) {
            return false;
          }
          var op = this.lookahead.value;
          return op === '=' || op === '*=' || op === '**=' || op === '/=' || op === '%=' || op === '+=' || op === '-=' || op === '<<=' || op === '>>=' || op === '>>>=' || op === '&=' || op === '^=' || op === '|=';
        };
        // Cover grammar support.
        //
        // When an assignment expression position starts with an left parenthesis, the determination of the type
        // of the syntax is to be deferred arbitrarily long until the end of the parentheses pair (plus a lookahead)
        // or the first comma. This situation also defers the determination of all the expressions nested in the pair.
        //
        // There are three productions that can be parsed in a parentheses pair that needs to be determined
        // after the outermost pair is closed. They are:
        //
        //   1. AssignmentExpression
        //   2. BindingElements
        //   3. AssignmentTargets
        //
        // In order to avoid exponential backtracking, we use two flags to denote if the production can be
        // binding element or assignment target.
        //
        // The three productions have the relationship:
        //
        //   BindingElements ⊆ AssignmentTargets ⊆ AssignmentExpression
        //
        // with a single exception that CoverInitializedName when used directly in an Expression, generates
        // an early error. Therefore, we need the third state, firstCoverInitializedNameError, to track the
        // first usage of CoverInitializedName and report it when we reached the end of the parentheses pair.
        //
        // isolateCoverGrammar function runs the given parser function with a new cover grammar context, and it does not
        // effect the current flags. This means the production the parser parses is only used as an expression. Therefore
        // the CoverInitializedName check is conducted.
        //
        // inheritCoverGrammar function runs the given parse function with a new cover grammar context, and it propagates
        // the flags outside of the parser. This means the production the parser parses is used as a part of a potential
        // pattern. The CoverInitializedName check is deferred.
        Parser.prototype.isolateCoverGrammar = function (parseFunction) {
          var previousIsBindingElement = this.context.isBindingElement;
          var previousIsAssignmentTarget = this.context.isAssignmentTarget;
          var previousFirstCoverInitializedNameError = this.context.firstCoverInitializedNameError;
          this.context.isBindingElement = true;
          this.context.isAssignmentTarget = true;
          this.context.firstCoverInitializedNameError = null;
          var result = parseFunction.call(this);
          if (this.context.firstCoverInitializedNameError !== null) {
            this.throwUnexpectedToken(this.context.firstCoverInitializedNameError);
          }
          this.context.isBindingElement = previousIsBindingElement;
          this.context.isAssignmentTarget = previousIsAssignmentTarget;
          this.context.firstCoverInitializedNameError = previousFirstCoverInitializedNameError;
          return result;
        };
        Parser.prototype.inheritCoverGrammar = function (parseFunction) {
          var previousIsBindingElement = this.context.isBindingElement;
          var previousIsAssignmentTarget = this.context.isAssignmentTarget;
          var previousFirstCoverInitializedNameError = this.context.firstCoverInitializedNameError;
          this.context.isBindingElement = true;
          this.context.isAssignmentTarget = true;
          this.context.firstCoverInitializedNameError = null;
          var result = parseFunction.call(this);
          this.context.isBindingElement = this.context.isBindingElement && previousIsBindingElement;
          this.context.isAssignmentTarget = this.context.isAssignmentTarget && previousIsAssignmentTarget;
          this.context.firstCoverInitializedNameError = previousFirstCoverInitializedNameError || this.context.firstCoverInitializedNameError;
          return result;
        };
        Parser.prototype.consumeSemicolon = function () {
          if (this.match(';')) {
            this.nextToken();
          } else if (!this.hasLineTerminator) {
            if (this.lookahead.type !== 2 /* EOF */ && !this.match('}')) {
              this.throwUnexpectedToken(this.lookahead);
            }
            this.lastMarker.index = this.startMarker.index;
            this.lastMarker.line = this.startMarker.line;
            this.lastMarker.column = this.startMarker.column;
          }
        };
        // https://tc39.github.io/ecma262/#sec-primary-expression
        Parser.prototype.parsePrimaryExpression = function () {
          var node = this.createNode();
          var expr;
          var token, raw;
          switch (this.lookahead.type) {
            case 3 /* Identifier */:
              if ((this.context.isModule || this.context.await) && this.lookahead.value === 'await') {
                this.tolerateUnexpectedToken(this.lookahead);
              }
              expr = this.matchAsyncFunction() ? this.parseFunctionExpression() : this.finalize(node, new Node.Identifier(this.nextToken().value));
              break;
            case 6 /* NumericLiteral */:
            case 8 /* StringLiteral */:
              if (this.context.strict && this.lookahead.octal) {
                this.tolerateUnexpectedToken(this.lookahead, messages_1.Messages.StrictOctalLiteral);
              }
              this.context.isAssignmentTarget = false;
              this.context.isBindingElement = false;
              token = this.nextToken();
              raw = this.getTokenRaw(token);
              expr = this.finalize(node, new Node.Literal(token.value, raw));
              break;
            case 1 /* BooleanLiteral */:
              this.context.isAssignmentTarget = false;
              this.context.isBindingElement = false;
              token = this.nextToken();
              raw = this.getTokenRaw(token);
              expr = this.finalize(node, new Node.Literal(token.value === 'true', raw));
              break;
            case 5 /* NullLiteral */:
              this.context.isAssignmentTarget = false;
              this.context.isBindingElement = false;
              token = this.nextToken();
              raw = this.getTokenRaw(token);
              expr = this.finalize(node, new Node.Literal(null, raw));
              break;
            case 10 /* Template */:
              expr = this.parseTemplateLiteral();
              break;
            case 7 /* Punctuator */:
              switch (this.lookahead.value) {
                case '(':
                  this.context.isBindingElement = false;
                  expr = this.inheritCoverGrammar(this.parseGroupExpression);
                  break;
                case '[':
                  expr = this.inheritCoverGrammar(this.parseArrayInitializer);
                  break;
                case '{':
                  expr = this.inheritCoverGrammar(this.parseObjectInitializer);
                  break;
                case '/':
                case '/=':
                  this.context.isAssignmentTarget = false;
                  this.context.isBindingElement = false;
                  this.scanner.index = this.startMarker.index;
                  token = this.nextRegexToken();
                  raw = this.getTokenRaw(token);
                  expr = this.finalize(node, new Node.RegexLiteral(token.regex, raw, token.pattern, token.flags));
                  break;
                default:
                  expr = this.throwUnexpectedToken(this.nextToken());
              }
              break;
            case 4 /* Keyword */:
              if (!this.context.strict && this.context.allowYield && this.matchKeyword('yield')) {
                expr = this.parseIdentifierName();
              } else if (!this.context.strict && this.matchKeyword('let')) {
                expr = this.finalize(node, new Node.Identifier(this.nextToken().value));
              } else {
                this.context.isAssignmentTarget = false;
                this.context.isBindingElement = false;
                if (this.matchKeyword('function')) {
                  expr = this.parseFunctionExpression();
                } else if (this.matchKeyword('this')) {
                  this.nextToken();
                  expr = this.finalize(node, new Node.ThisExpression());
                } else if (this.matchKeyword('class')) {
                  expr = this.parseClassExpression();
                } else {
                  expr = this.throwUnexpectedToken(this.nextToken());
                }
              }
              break;
            default:
              expr = this.throwUnexpectedToken(this.nextToken());
          }
          return expr;
        };
        // https://tc39.github.io/ecma262/#sec-array-initializer
        Parser.prototype.parseSpreadElement = function () {
          var node = this.createNode();
          this.expect('...');
          var arg = this.inheritCoverGrammar(this.parseAssignmentExpression);
          return this.finalize(node, new Node.SpreadElement(arg));
        };
        Parser.prototype.parseArrayInitializer = function () {
          var node = this.createNode();
          var elements = [];
          this.expect('[');
          while (!this.match(']')) {
            if (this.match(',')) {
              this.nextToken();
              elements.push(null);
            } else if (this.match('...')) {
              var element = this.parseSpreadElement();
              if (!this.match(']')) {
                this.context.isAssignmentTarget = false;
                this.context.isBindingElement = false;
                this.expect(',');
              }
              elements.push(element);
            } else {
              elements.push(this.inheritCoverGrammar(this.parseAssignmentExpression));
              if (!this.match(']')) {
                this.expect(',');
              }
            }
          }
          this.expect(']');
          return this.finalize(node, new Node.ArrayExpression(elements));
        };
        // https://tc39.github.io/ecma262/#sec-object-initializer
        Parser.prototype.parsePropertyMethod = function (params) {
          this.context.isAssignmentTarget = false;
          this.context.isBindingElement = false;
          var previousStrict = this.context.strict;
          var previousAllowStrictDirective = this.context.allowStrictDirective;
          this.context.allowStrictDirective = params.simple;
          var body = this.isolateCoverGrammar(this.parseFunctionSourceElements);
          if (this.context.strict && params.firstRestricted) {
            this.tolerateUnexpectedToken(params.firstRestricted, params.message);
          }
          if (this.context.strict && params.stricted) {
            this.tolerateUnexpectedToken(params.stricted, params.message);
          }
          this.context.strict = previousStrict;
          this.context.allowStrictDirective = previousAllowStrictDirective;
          return body;
        };
        Parser.prototype.parsePropertyMethodFunction = function () {
          var isGenerator = false;
          var node = this.createNode();
          var previousAllowYield = this.context.allowYield;
          this.context.allowYield = true;
          var params = this.parseFormalParameters();
          var method = this.parsePropertyMethod(params);
          this.context.allowYield = previousAllowYield;
          return this.finalize(node, new Node.FunctionExpression(null, params.params, method, isGenerator));
        };
        Parser.prototype.parsePropertyMethodAsyncFunction = function () {
          var node = this.createNode();
          var previousAllowYield = this.context.allowYield;
          var previousAwait = this.context.await;
          this.context.allowYield = false;
          this.context.await = true;
          var params = this.parseFormalParameters();
          var method = this.parsePropertyMethod(params);
          this.context.allowYield = previousAllowYield;
          this.context.await = previousAwait;
          return this.finalize(node, new Node.AsyncFunctionExpression(null, params.params, method));
        };
        Parser.prototype.parseObjectPropertyKey = function () {
          var node = this.createNode();
          var token = this.nextToken();
          var key;
          switch (token.type) {
            case 8 /* StringLiteral */:
            case 6 /* NumericLiteral */:
              if (this.context.strict && token.octal) {
                this.tolerateUnexpectedToken(token, messages_1.Messages.StrictOctalLiteral);
              }
              var raw = this.getTokenRaw(token);
              key = this.finalize(node, new Node.Literal(token.value, raw));
              break;
            case 3 /* Identifier */:
            case 1 /* BooleanLiteral */:
            case 5 /* NullLiteral */:
            case 4 /* Keyword */:
              key = this.finalize(node, new Node.Identifier(token.value));
              break;
            case 7 /* Punctuator */:
              if (token.value === '[') {
                key = this.isolateCoverGrammar(this.parseAssignmentExpression);
                this.expect(']');
              } else {
                key = this.throwUnexpectedToken(token);
              }
              break;
            default:
              key = this.throwUnexpectedToken(token);
          }
          return key;
        };
        Parser.prototype.isPropertyKey = function (key, value) {
          return key.type === syntax_1.Syntax.Identifier && key.name === value || key.type === syntax_1.Syntax.Literal && key.value === value;
        };
        Parser.prototype.parseObjectProperty = function (hasProto) {
          var node = this.createNode();
          var token = this.lookahead;
          var kind;
          var key = null;
          var value = null;
          var computed = false;
          var method = false;
          var shorthand = false;
          var isAsync = false;
          if (token.type === 3 /* Identifier */) {
            var id = token.value;
            this.nextToken();
            computed = this.match('[');
            isAsync = !this.hasLineTerminator && id === 'async' && !this.match(':') && !this.match('(') && !this.match('*') && !this.match(',');
            key = isAsync ? this.parseObjectPropertyKey() : this.finalize(node, new Node.Identifier(id));
          } else if (this.match('*')) {
            this.nextToken();
          } else {
            computed = this.match('[');
            key = this.parseObjectPropertyKey();
          }
          var lookaheadPropertyKey = this.qualifiedPropertyName(this.lookahead);
          if (token.type === 3 /* Identifier */ && !isAsync && token.value === 'get' && lookaheadPropertyKey) {
            kind = 'get';
            computed = this.match('[');
            key = this.parseObjectPropertyKey();
            this.context.allowYield = false;
            value = this.parseGetterMethod();
          } else if (token.type === 3 /* Identifier */ && !isAsync && token.value === 'set' && lookaheadPropertyKey) {
            kind = 'set';
            computed = this.match('[');
            key = this.parseObjectPropertyKey();
            value = this.parseSetterMethod();
          } else if (token.type === 7 /* Punctuator */ && token.value === '*' && lookaheadPropertyKey) {
            kind = 'init';
            computed = this.match('[');
            key = this.parseObjectPropertyKey();
            value = this.parseGeneratorMethod();
            method = true;
          } else {
            if (!key) {
              this.throwUnexpectedToken(this.lookahead);
            }
            kind = 'init';
            if (this.match(':') && !isAsync) {
              if (!computed && this.isPropertyKey(key, '__proto__')) {
                if (hasProto.value) {
                  this.tolerateError(messages_1.Messages.DuplicateProtoProperty);
                }
                hasProto.value = true;
              }
              this.nextToken();
              value = this.inheritCoverGrammar(this.parseAssignmentExpression);
            } else if (this.match('(')) {
              value = isAsync ? this.parsePropertyMethodAsyncFunction() : this.parsePropertyMethodFunction();
              method = true;
            } else if (token.type === 3 /* Identifier */) {
              var id = this.finalize(node, new Node.Identifier(token.value));
              if (this.match('=')) {
                this.context.firstCoverInitializedNameError = this.lookahead;
                this.nextToken();
                shorthand = true;
                var init = this.isolateCoverGrammar(this.parseAssignmentExpression);
                value = this.finalize(node, new Node.AssignmentPattern(id, init));
              } else {
                shorthand = true;
                value = id;
              }
            } else {
              this.throwUnexpectedToken(this.nextToken());
            }
          }
          return this.finalize(node, new Node.Property(kind, key, computed, value, method, shorthand));
        };
        Parser.prototype.parseObjectInitializer = function () {
          var node = this.createNode();
          this.expect('{');
          var properties = [];
          var hasProto = {
            value: false
          };
          while (!this.match('}')) {
            properties.push(this.parseObjectProperty(hasProto));
            if (!this.match('}')) {
              this.expectCommaSeparator();
            }
          }
          this.expect('}');
          return this.finalize(node, new Node.ObjectExpression(properties));
        };
        // https://tc39.github.io/ecma262/#sec-template-literals
        Parser.prototype.parseTemplateHead = function () {
          assert_1.assert(this.lookahead.head, 'Template literal must start with a template head');
          var node = this.createNode();
          var token = this.nextToken();
          var raw = token.value;
          var cooked = token.cooked;
          return this.finalize(node, new Node.TemplateElement({
            raw: raw,
            cooked: cooked
          }, token.tail));
        };
        Parser.prototype.parseTemplateElement = function () {
          if (this.lookahead.type !== 10 /* Template */) {
            this.throwUnexpectedToken();
          }
          var node = this.createNode();
          var token = this.nextToken();
          var raw = token.value;
          var cooked = token.cooked;
          return this.finalize(node, new Node.TemplateElement({
            raw: raw,
            cooked: cooked
          }, token.tail));
        };
        Parser.prototype.parseTemplateLiteral = function () {
          var node = this.createNode();
          var expressions = [];
          var quasis = [];
          var quasi = this.parseTemplateHead();
          quasis.push(quasi);
          while (!quasi.tail) {
            expressions.push(this.parseExpression());
            quasi = this.parseTemplateElement();
            quasis.push(quasi);
          }
          return this.finalize(node, new Node.TemplateLiteral(quasis, expressions));
        };
        // https://tc39.github.io/ecma262/#sec-grouping-operator
        Parser.prototype.reinterpretExpressionAsPattern = function (expr) {
          switch (expr.type) {
            case syntax_1.Syntax.Identifier:
            case syntax_1.Syntax.MemberExpression:
            case syntax_1.Syntax.RestElement:
            case syntax_1.Syntax.AssignmentPattern:
              break;
            case syntax_1.Syntax.SpreadElement:
              expr.type = syntax_1.Syntax.RestElement;
              this.reinterpretExpressionAsPattern(expr.argument);
              break;
            case syntax_1.Syntax.ArrayExpression:
              expr.type = syntax_1.Syntax.ArrayPattern;
              for (var i = 0; i < expr.elements.length; i++) {
                if (expr.elements[i] !== null) {
                  this.reinterpretExpressionAsPattern(expr.elements[i]);
                }
              }
              break;
            case syntax_1.Syntax.ObjectExpression:
              expr.type = syntax_1.Syntax.ObjectPattern;
              for (var i = 0; i < expr.properties.length; i++) {
                this.reinterpretExpressionAsPattern(expr.properties[i].value);
              }
              break;
            case syntax_1.Syntax.AssignmentExpression:
              expr.type = syntax_1.Syntax.AssignmentPattern;
              delete expr.operator;
              this.reinterpretExpressionAsPattern(expr.left);
              break;
            default:
              // Allow other node type for tolerant parsing.
              break;
          }
        };
        Parser.prototype.parseGroupExpression = function () {
          var expr;
          this.expect('(');
          if (this.match(')')) {
            this.nextToken();
            if (!this.match('=>')) {
              this.expect('=>');
            }
            expr = {
              type: ArrowParameterPlaceHolder,
              params: [],
              async: false
            };
          } else {
            var startToken = this.lookahead;
            var params = [];
            if (this.match('...')) {
              expr = this.parseRestElement(params);
              this.expect(')');
              if (!this.match('=>')) {
                this.expect('=>');
              }
              expr = {
                type: ArrowParameterPlaceHolder,
                params: [expr],
                async: false
              };
            } else {
              var arrow = false;
              this.context.isBindingElement = true;
              expr = this.inheritCoverGrammar(this.parseAssignmentExpression);
              if (this.match(',')) {
                var expressions = [];
                this.context.isAssignmentTarget = false;
                expressions.push(expr);
                while (this.lookahead.type !== 2 /* EOF */) {
                  if (!this.match(',')) {
                    break;
                  }
                  this.nextToken();
                  if (this.match(')')) {
                    this.nextToken();
                    for (var i = 0; i < expressions.length; i++) {
                      this.reinterpretExpressionAsPattern(expressions[i]);
                    }
                    arrow = true;
                    expr = {
                      type: ArrowParameterPlaceHolder,
                      params: expressions,
                      async: false
                    };
                  } else if (this.match('...')) {
                    if (!this.context.isBindingElement) {
                      this.throwUnexpectedToken(this.lookahead);
                    }
                    expressions.push(this.parseRestElement(params));
                    this.expect(')');
                    if (!this.match('=>')) {
                      this.expect('=>');
                    }
                    this.context.isBindingElement = false;
                    for (var i = 0; i < expressions.length; i++) {
                      this.reinterpretExpressionAsPattern(expressions[i]);
                    }
                    arrow = true;
                    expr = {
                      type: ArrowParameterPlaceHolder,
                      params: expressions,
                      async: false
                    };
                  } else {
                    expressions.push(this.inheritCoverGrammar(this.parseAssignmentExpression));
                  }
                  if (arrow) {
                    break;
                  }
                }
                if (!arrow) {
                  expr = this.finalize(this.startNode(startToken), new Node.SequenceExpression(expressions));
                }
              }
              if (!arrow) {
                this.expect(')');
                if (this.match('=>')) {
                  if (expr.type === syntax_1.Syntax.Identifier && expr.name === 'yield') {
                    arrow = true;
                    expr = {
                      type: ArrowParameterPlaceHolder,
                      params: [expr],
                      async: false
                    };
                  }
                  if (!arrow) {
                    if (!this.context.isBindingElement) {
                      this.throwUnexpectedToken(this.lookahead);
                    }
                    if (expr.type === syntax_1.Syntax.SequenceExpression) {
                      for (var i = 0; i < expr.expressions.length; i++) {
                        this.reinterpretExpressionAsPattern(expr.expressions[i]);
                      }
                    } else {
                      this.reinterpretExpressionAsPattern(expr);
                    }
                    var parameters = expr.type === syntax_1.Syntax.SequenceExpression ? expr.expressions : [expr];
                    expr = {
                      type: ArrowParameterPlaceHolder,
                      params: parameters,
                      async: false
                    };
                  }
                }
                this.context.isBindingElement = false;
              }
            }
          }
          return expr;
        };
        // https://tc39.github.io/ecma262/#sec-left-hand-side-expressions
        Parser.prototype.parseArguments = function () {
          this.expect('(');
          var args = [];
          if (!this.match(')')) {
            while (true) {
              var expr = this.match('...') ? this.parseSpreadElement() : this.isolateCoverGrammar(this.parseAssignmentExpression);
              args.push(expr);
              if (this.match(')')) {
                break;
              }
              this.expectCommaSeparator();
              if (this.match(')')) {
                break;
              }
            }
          }
          this.expect(')');
          return args;
        };
        Parser.prototype.isIdentifierName = function (token) {
          return token.type === 3 /* Identifier */ || token.type === 4 /* Keyword */ || token.type === 1 /* BooleanLiteral */ || token.type === 5 /* NullLiteral */;
        };

        Parser.prototype.parseIdentifierName = function () {
          var node = this.createNode();
          var token = this.nextToken();
          if (!this.isIdentifierName(token)) {
            this.throwUnexpectedToken(token);
          }
          return this.finalize(node, new Node.Identifier(token.value));
        };
        Parser.prototype.parseNewExpression = function () {
          var node = this.createNode();
          var id = this.parseIdentifierName();
          assert_1.assert(id.name === 'new', 'New expression must start with `new`');
          var expr;
          if (this.match('.')) {
            this.nextToken();
            if (this.lookahead.type === 3 /* Identifier */ && this.context.inFunctionBody && this.lookahead.value === 'target') {
              var property = this.parseIdentifierName();
              expr = new Node.MetaProperty(id, property);
            } else {
              this.throwUnexpectedToken(this.lookahead);
            }
          } else {
            var callee = this.isolateCoverGrammar(this.parseLeftHandSideExpression);
            var args = this.match('(') ? this.parseArguments() : [];
            expr = new Node.NewExpression(callee, args);
            this.context.isAssignmentTarget = false;
            this.context.isBindingElement = false;
          }
          return this.finalize(node, expr);
        };
        Parser.prototype.parseAsyncArgument = function () {
          var arg = this.parseAssignmentExpression();
          this.context.firstCoverInitializedNameError = null;
          return arg;
        };
        Parser.prototype.parseAsyncArguments = function () {
          this.expect('(');
          var args = [];
          if (!this.match(')')) {
            while (true) {
              var expr = this.match('...') ? this.parseSpreadElement() : this.isolateCoverGrammar(this.parseAsyncArgument);
              args.push(expr);
              if (this.match(')')) {
                break;
              }
              this.expectCommaSeparator();
              if (this.match(')')) {
                break;
              }
            }
          }
          this.expect(')');
          return args;
        };
        Parser.prototype.parseLeftHandSideExpressionAllowCall = function () {
          var startToken = this.lookahead;
          var maybeAsync = this.matchContextualKeyword('async');
          var previousAllowIn = this.context.allowIn;
          this.context.allowIn = true;
          var expr;
          if (this.matchKeyword('super') && this.context.inFunctionBody) {
            expr = this.createNode();
            this.nextToken();
            expr = this.finalize(expr, new Node.Super());
            if (!this.match('(') && !this.match('.') && !this.match('[')) {
              this.throwUnexpectedToken(this.lookahead);
            }
          } else {
            expr = this.inheritCoverGrammar(this.matchKeyword('new') ? this.parseNewExpression : this.parsePrimaryExpression);
          }
          while (true) {
            if (this.match('.')) {
              this.context.isBindingElement = false;
              this.context.isAssignmentTarget = true;
              this.expect('.');
              var property = this.parseIdentifierName();
              expr = this.finalize(this.startNode(startToken), new Node.StaticMemberExpression(expr, property));
            } else if (this.match('(')) {
              var asyncArrow = maybeAsync && startToken.lineNumber === this.lookahead.lineNumber;
              this.context.isBindingElement = false;
              this.context.isAssignmentTarget = false;
              var args = asyncArrow ? this.parseAsyncArguments() : this.parseArguments();
              expr = this.finalize(this.startNode(startToken), new Node.CallExpression(expr, args));
              if (asyncArrow && this.match('=>')) {
                for (var i = 0; i < args.length; ++i) {
                  this.reinterpretExpressionAsPattern(args[i]);
                }
                expr = {
                  type: ArrowParameterPlaceHolder,
                  params: args,
                  async: true
                };
              }
            } else if (this.match('[')) {
              this.context.isBindingElement = false;
              this.context.isAssignmentTarget = true;
              this.expect('[');
              var property = this.isolateCoverGrammar(this.parseExpression);
              this.expect(']');
              expr = this.finalize(this.startNode(startToken), new Node.ComputedMemberExpression(expr, property));
            } else if (this.lookahead.type === 10 /* Template */ && this.lookahead.head) {
              var quasi = this.parseTemplateLiteral();
              expr = this.finalize(this.startNode(startToken), new Node.TaggedTemplateExpression(expr, quasi));
            } else {
              break;
            }
          }
          this.context.allowIn = previousAllowIn;
          return expr;
        };
        Parser.prototype.parseSuper = function () {
          var node = this.createNode();
          this.expectKeyword('super');
          if (!this.match('[') && !this.match('.')) {
            this.throwUnexpectedToken(this.lookahead);
          }
          return this.finalize(node, new Node.Super());
        };
        Parser.prototype.parseLeftHandSideExpression = function () {
          assert_1.assert(this.context.allowIn, 'callee of new expression always allow in keyword.');
          var node = this.startNode(this.lookahead);
          var expr = this.matchKeyword('super') && this.context.inFunctionBody ? this.parseSuper() : this.inheritCoverGrammar(this.matchKeyword('new') ? this.parseNewExpression : this.parsePrimaryExpression);
          while (true) {
            if (this.match('[')) {
              this.context.isBindingElement = false;
              this.context.isAssignmentTarget = true;
              this.expect('[');
              var property = this.isolateCoverGrammar(this.parseExpression);
              this.expect(']');
              expr = this.finalize(node, new Node.ComputedMemberExpression(expr, property));
            } else if (this.match('.')) {
              this.context.isBindingElement = false;
              this.context.isAssignmentTarget = true;
              this.expect('.');
              var property = this.parseIdentifierName();
              expr = this.finalize(node, new Node.StaticMemberExpression(expr, property));
            } else if (this.lookahead.type === 10 /* Template */ && this.lookahead.head) {
              var quasi = this.parseTemplateLiteral();
              expr = this.finalize(node, new Node.TaggedTemplateExpression(expr, quasi));
            } else {
              break;
            }
          }
          return expr;
        };
        // https://tc39.github.io/ecma262/#sec-update-expressions
        Parser.prototype.parseUpdateExpression = function () {
          var expr;
          var startToken = this.lookahead;
          if (this.match('++') || this.match('--')) {
            var node = this.startNode(startToken);
            var token = this.nextToken();
            expr = this.inheritCoverGrammar(this.parseUnaryExpression);
            if (this.context.strict && expr.type === syntax_1.Syntax.Identifier && this.scanner.isRestrictedWord(expr.name)) {
              this.tolerateError(messages_1.Messages.StrictLHSPrefix);
            }
            if (!this.context.isAssignmentTarget) {
              this.tolerateError(messages_1.Messages.InvalidLHSInAssignment);
            }
            var prefix = true;
            expr = this.finalize(node, new Node.UpdateExpression(token.value, expr, prefix));
            this.context.isAssignmentTarget = false;
            this.context.isBindingElement = false;
          } else {
            expr = this.inheritCoverGrammar(this.parseLeftHandSideExpressionAllowCall);
            if (!this.hasLineTerminator && this.lookahead.type === 7 /* Punctuator */) {
              if (this.match('++') || this.match('--')) {
                if (this.context.strict && expr.type === syntax_1.Syntax.Identifier && this.scanner.isRestrictedWord(expr.name)) {
                  this.tolerateError(messages_1.Messages.StrictLHSPostfix);
                }
                if (!this.context.isAssignmentTarget) {
                  this.tolerateError(messages_1.Messages.InvalidLHSInAssignment);
                }
                this.context.isAssignmentTarget = false;
                this.context.isBindingElement = false;
                var operator = this.nextToken().value;
                var prefix = false;
                expr = this.finalize(this.startNode(startToken), new Node.UpdateExpression(operator, expr, prefix));
              }
            }
          }
          return expr;
        };
        // https://tc39.github.io/ecma262/#sec-unary-operators
        Parser.prototype.parseAwaitExpression = function () {
          var node = this.createNode();
          this.nextToken();
          var argument = this.parseUnaryExpression();
          return this.finalize(node, new Node.AwaitExpression(argument));
        };
        Parser.prototype.parseUnaryExpression = function () {
          var expr;
          if (this.match('+') || this.match('-') || this.match('~') || this.match('!') || this.matchKeyword('delete') || this.matchKeyword('void') || this.matchKeyword('typeof')) {
            var node = this.startNode(this.lookahead);
            var token = this.nextToken();
            expr = this.inheritCoverGrammar(this.parseUnaryExpression);
            expr = this.finalize(node, new Node.UnaryExpression(token.value, expr));
            if (this.context.strict && expr.operator === 'delete' && expr.argument.type === syntax_1.Syntax.Identifier) {
              this.tolerateError(messages_1.Messages.StrictDelete);
            }
            this.context.isAssignmentTarget = false;
            this.context.isBindingElement = false;
          } else if (this.context.await && this.matchContextualKeyword('await')) {
            expr = this.parseAwaitExpression();
          } else {
            expr = this.parseUpdateExpression();
          }
          return expr;
        };
        Parser.prototype.parseExponentiationExpression = function () {
          var startToken = this.lookahead;
          var expr = this.inheritCoverGrammar(this.parseUnaryExpression);
          if (expr.type !== syntax_1.Syntax.UnaryExpression && this.match('**')) {
            this.nextToken();
            this.context.isAssignmentTarget = false;
            this.context.isBindingElement = false;
            var left = expr;
            var right = this.isolateCoverGrammar(this.parseExponentiationExpression);
            expr = this.finalize(this.startNode(startToken), new Node.BinaryExpression('**', left, right));
          }
          return expr;
        };
        // https://tc39.github.io/ecma262/#sec-exp-operator
        // https://tc39.github.io/ecma262/#sec-multiplicative-operators
        // https://tc39.github.io/ecma262/#sec-additive-operators
        // https://tc39.github.io/ecma262/#sec-bitwise-shift-operators
        // https://tc39.github.io/ecma262/#sec-relational-operators
        // https://tc39.github.io/ecma262/#sec-equality-operators
        // https://tc39.github.io/ecma262/#sec-binary-bitwise-operators
        // https://tc39.github.io/ecma262/#sec-binary-logical-operators
        Parser.prototype.binaryPrecedence = function (token) {
          var op = token.value;
          var precedence;
          if (token.type === 7 /* Punctuator */) {
            precedence = this.operatorPrecedence[op] || 0;
          } else if (token.type === 4 /* Keyword */) {
            precedence = op === 'instanceof' || this.context.allowIn && op === 'in' ? 7 : 0;
          } else {
            precedence = 0;
          }
          return precedence;
        };
        Parser.prototype.parseBinaryExpression = function () {
          var startToken = this.lookahead;
          var expr = this.inheritCoverGrammar(this.parseExponentiationExpression);
          var token = this.lookahead;
          var prec = this.binaryPrecedence(token);
          if (prec > 0) {
            this.nextToken();
            this.context.isAssignmentTarget = false;
            this.context.isBindingElement = false;
            var markers = [startToken, this.lookahead];
            var left = expr;
            var right = this.isolateCoverGrammar(this.parseExponentiationExpression);
            var stack = [left, token.value, right];
            var precedences = [prec];
            while (true) {
              prec = this.binaryPrecedence(this.lookahead);
              if (prec <= 0) {
                break;
              }
              // Reduce: make a binary expression from the three topmost entries.
              while (stack.length > 2 && prec <= precedences[precedences.length - 1]) {
                right = stack.pop();
                var operator = stack.pop();
                precedences.pop();
                left = stack.pop();
                markers.pop();
                var node = this.startNode(markers[markers.length - 1]);
                stack.push(this.finalize(node, new Node.BinaryExpression(operator, left, right)));
              }
              // Shift.
              stack.push(this.nextToken().value);
              precedences.push(prec);
              markers.push(this.lookahead);
              stack.push(this.isolateCoverGrammar(this.parseExponentiationExpression));
            }
            // Final reduce to clean-up the stack.
            var i = stack.length - 1;
            expr = stack[i];
            var lastMarker = markers.pop();
            while (i > 1) {
              var marker = markers.pop();
              var lastLineStart = lastMarker && lastMarker.lineStart;
              var node = this.startNode(marker, lastLineStart);
              var operator = stack[i - 1];
              expr = this.finalize(node, new Node.BinaryExpression(operator, stack[i - 2], expr));
              i -= 2;
              lastMarker = marker;
            }
          }
          return expr;
        };
        // https://tc39.github.io/ecma262/#sec-conditional-operator
        Parser.prototype.parseConditionalExpression = function () {
          var startToken = this.lookahead;
          var expr = this.inheritCoverGrammar(this.parseBinaryExpression);
          if (this.match('?')) {
            this.nextToken();
            var previousAllowIn = this.context.allowIn;
            this.context.allowIn = true;
            var consequent = this.isolateCoverGrammar(this.parseAssignmentExpression);
            this.context.allowIn = previousAllowIn;
            this.expect(':');
            var alternate = this.isolateCoverGrammar(this.parseAssignmentExpression);
            expr = this.finalize(this.startNode(startToken), new Node.ConditionalExpression(expr, consequent, alternate));
            this.context.isAssignmentTarget = false;
            this.context.isBindingElement = false;
          }
          return expr;
        };
        // https://tc39.github.io/ecma262/#sec-assignment-operators
        Parser.prototype.checkPatternParam = function (options, param) {
          switch (param.type) {
            case syntax_1.Syntax.Identifier:
              this.validateParam(options, param, param.name);
              break;
            case syntax_1.Syntax.RestElement:
              this.checkPatternParam(options, param.argument);
              break;
            case syntax_1.Syntax.AssignmentPattern:
              this.checkPatternParam(options, param.left);
              break;
            case syntax_1.Syntax.ArrayPattern:
              for (var i = 0; i < param.elements.length; i++) {
                if (param.elements[i] !== null) {
                  this.checkPatternParam(options, param.elements[i]);
                }
              }
              break;
            case syntax_1.Syntax.ObjectPattern:
              for (var i = 0; i < param.properties.length; i++) {
                this.checkPatternParam(options, param.properties[i].value);
              }
              break;
            default:
              break;
          }
          options.simple = options.simple && param instanceof Node.Identifier;
        };
        Parser.prototype.reinterpretAsCoverFormalsList = function (expr) {
          var params = [expr];
          var options;
          var asyncArrow = false;
          switch (expr.type) {
            case syntax_1.Syntax.Identifier:
              break;
            case ArrowParameterPlaceHolder:
              params = expr.params;
              asyncArrow = expr.async;
              break;
            default:
              return null;
          }
          options = {
            simple: true,
            paramSet: {}
          };
          for (var i = 0; i < params.length; ++i) {
            var param = params[i];
            if (param.type === syntax_1.Syntax.AssignmentPattern) {
              if (param.right.type === syntax_1.Syntax.YieldExpression) {
                if (param.right.argument) {
                  this.throwUnexpectedToken(this.lookahead);
                }
                param.right.type = syntax_1.Syntax.Identifier;
                param.right.name = 'yield';
                delete param.right.argument;
                delete param.right.delegate;
              }
            } else if (asyncArrow && param.type === syntax_1.Syntax.Identifier && param.name === 'await') {
              this.throwUnexpectedToken(this.lookahead);
            }
            this.checkPatternParam(options, param);
            params[i] = param;
          }
          if (this.context.strict || !this.context.allowYield) {
            for (var i = 0; i < params.length; ++i) {
              var param = params[i];
              if (param.type === syntax_1.Syntax.YieldExpression) {
                this.throwUnexpectedToken(this.lookahead);
              }
            }
          }
          if (options.message === messages_1.Messages.StrictParamDupe) {
            var token = this.context.strict ? options.stricted : options.firstRestricted;
            this.throwUnexpectedToken(token, options.message);
          }
          return {
            simple: options.simple,
            params: params,
            stricted: options.stricted,
            firstRestricted: options.firstRestricted,
            message: options.message
          };
        };
        Parser.prototype.parseAssignmentExpression = function () {
          var expr;
          if (!this.context.allowYield && this.matchKeyword('yield')) {
            expr = this.parseYieldExpression();
          } else {
            var startToken = this.lookahead;
            var token = startToken;
            expr = this.parseConditionalExpression();
            if (token.type === 3 /* Identifier */ && token.lineNumber === this.lookahead.lineNumber && token.value === 'async') {
              if (this.lookahead.type === 3 /* Identifier */ || this.matchKeyword('yield')) {
                var arg = this.parsePrimaryExpression();
                this.reinterpretExpressionAsPattern(arg);
                expr = {
                  type: ArrowParameterPlaceHolder,
                  params: [arg],
                  async: true
                };
              }
            }
            if (expr.type === ArrowParameterPlaceHolder || this.match('=>')) {
              // https://tc39.github.io/ecma262/#sec-arrow-function-definitions
              this.context.isAssignmentTarget = false;
              this.context.isBindingElement = false;
              var isAsync = expr.async;
              var list = this.reinterpretAsCoverFormalsList(expr);
              if (list) {
                if (this.hasLineTerminator) {
                  this.tolerateUnexpectedToken(this.lookahead);
                }
                this.context.firstCoverInitializedNameError = null;
                var previousStrict = this.context.strict;
                var previousAllowStrictDirective = this.context.allowStrictDirective;
                this.context.allowStrictDirective = list.simple;
                var previousAllowYield = this.context.allowYield;
                var previousAwait = this.context.await;
                this.context.allowYield = true;
                this.context.await = isAsync;
                var node = this.startNode(startToken);
                this.expect('=>');
                var body = void 0;
                if (this.match('{')) {
                  var previousAllowIn = this.context.allowIn;
                  this.context.allowIn = true;
                  body = this.parseFunctionSourceElements();
                  this.context.allowIn = previousAllowIn;
                } else {
                  body = this.isolateCoverGrammar(this.parseAssignmentExpression);
                }
                var expression = body.type !== syntax_1.Syntax.BlockStatement;
                if (this.context.strict && list.firstRestricted) {
                  this.throwUnexpectedToken(list.firstRestricted, list.message);
                }
                if (this.context.strict && list.stricted) {
                  this.tolerateUnexpectedToken(list.stricted, list.message);
                }
                expr = isAsync ? this.finalize(node, new Node.AsyncArrowFunctionExpression(list.params, body, expression)) : this.finalize(node, new Node.ArrowFunctionExpression(list.params, body, expression));
                this.context.strict = previousStrict;
                this.context.allowStrictDirective = previousAllowStrictDirective;
                this.context.allowYield = previousAllowYield;
                this.context.await = previousAwait;
              }
            } else {
              if (this.matchAssign()) {
                if (!this.context.isAssignmentTarget) {
                  this.tolerateError(messages_1.Messages.InvalidLHSInAssignment);
                }
                if (this.context.strict && expr.type === syntax_1.Syntax.Identifier) {
                  var id = expr;
                  if (this.scanner.isRestrictedWord(id.name)) {
                    this.tolerateUnexpectedToken(token, messages_1.Messages.StrictLHSAssignment);
                  }
                  if (this.scanner.isStrictModeReservedWord(id.name)) {
                    this.tolerateUnexpectedToken(token, messages_1.Messages.StrictReservedWord);
                  }
                }
                if (!this.match('=')) {
                  this.context.isAssignmentTarget = false;
                  this.context.isBindingElement = false;
                } else {
                  this.reinterpretExpressionAsPattern(expr);
                }
                token = this.nextToken();
                var operator = token.value;
                var right = this.isolateCoverGrammar(this.parseAssignmentExpression);
                expr = this.finalize(this.startNode(startToken), new Node.AssignmentExpression(operator, expr, right));
                this.context.firstCoverInitializedNameError = null;
              }
            }
          }
          return expr;
        };
        // https://tc39.github.io/ecma262/#sec-comma-operator
        Parser.prototype.parseExpression = function () {
          var startToken = this.lookahead;
          var expr = this.isolateCoverGrammar(this.parseAssignmentExpression);
          if (this.match(',')) {
            var expressions = [];
            expressions.push(expr);
            while (this.lookahead.type !== 2 /* EOF */) {
              if (!this.match(',')) {
                break;
              }
              this.nextToken();
              expressions.push(this.isolateCoverGrammar(this.parseAssignmentExpression));
            }
            expr = this.finalize(this.startNode(startToken), new Node.SequenceExpression(expressions));
          }
          return expr;
        };
        // https://tc39.github.io/ecma262/#sec-block
        Parser.prototype.parseStatementListItem = function () {
          var statement;
          this.context.isAssignmentTarget = true;
          this.context.isBindingElement = true;
          if (this.lookahead.type === 4 /* Keyword */) {
            switch (this.lookahead.value) {
              case 'export':
                if (!this.context.isModule) {
                  this.tolerateUnexpectedToken(this.lookahead, messages_1.Messages.IllegalExportDeclaration);
                }
                statement = this.parseExportDeclaration();
                break;
              case 'import':
                if (!this.context.isModule) {
                  this.tolerateUnexpectedToken(this.lookahead, messages_1.Messages.IllegalImportDeclaration);
                }
                statement = this.parseImportDeclaration();
                break;
              case 'const':
                statement = this.parseLexicalDeclaration({
                  inFor: false
                });
                break;
              case 'function':
                statement = this.parseFunctionDeclaration();
                break;
              case 'class':
                statement = this.parseClassDeclaration();
                break;
              case 'let':
                statement = this.isLexicalDeclaration() ? this.parseLexicalDeclaration({
                  inFor: false
                }) : this.parseStatement();
                break;
              default:
                statement = this.parseStatement();
                break;
            }
          } else {
            statement = this.parseStatement();
          }
          return statement;
        };
        Parser.prototype.parseBlock = function () {
          var node = this.createNode();
          this.expect('{');
          var block = [];
          while (true) {
            if (this.match('}')) {
              break;
            }
            block.push(this.parseStatementListItem());
          }
          this.expect('}');
          return this.finalize(node, new Node.BlockStatement(block));
        };
        // https://tc39.github.io/ecma262/#sec-let-and-const-declarations
        Parser.prototype.parseLexicalBinding = function (kind, options) {
          var node = this.createNode();
          var params = [];
          var id = this.parsePattern(params, kind);
          if (this.context.strict && id.type === syntax_1.Syntax.Identifier) {
            if (this.scanner.isRestrictedWord(id.name)) {
              this.tolerateError(messages_1.Messages.StrictVarName);
            }
          }
          var init = null;
          if (kind === 'const') {
            if (!this.matchKeyword('in') && !this.matchContextualKeyword('of')) {
              if (this.match('=')) {
                this.nextToken();
                init = this.isolateCoverGrammar(this.parseAssignmentExpression);
              } else {
                this.throwError(messages_1.Messages.DeclarationMissingInitializer, 'const');
              }
            }
          } else if (!options.inFor && id.type !== syntax_1.Syntax.Identifier || this.match('=')) {
            this.expect('=');
            init = this.isolateCoverGrammar(this.parseAssignmentExpression);
          }
          return this.finalize(node, new Node.VariableDeclarator(id, init));
        };
        Parser.prototype.parseBindingList = function (kind, options) {
          var list = [this.parseLexicalBinding(kind, options)];
          while (this.match(',')) {
            this.nextToken();
            list.push(this.parseLexicalBinding(kind, options));
          }
          return list;
        };
        Parser.prototype.isLexicalDeclaration = function () {
          var state = this.scanner.saveState();
          this.scanner.scanComments();
          var next = this.scanner.lex();
          this.scanner.restoreState(state);
          return next.type === 3 /* Identifier */ || next.type === 7 /* Punctuator */ && next.value === '[' || next.type === 7 /* Punctuator */ && next.value === '{' || next.type === 4 /* Keyword */ && next.value === 'let' || next.type === 4 /* Keyword */ && next.value === 'yield';
        };
        Parser.prototype.parseLexicalDeclaration = function (options) {
          var node = this.createNode();
          var kind = this.nextToken().value;
          assert_1.assert(kind === 'let' || kind === 'const', 'Lexical declaration must be either let or const');
          var declarations = this.parseBindingList(kind, options);
          this.consumeSemicolon();
          return this.finalize(node, new Node.VariableDeclaration(declarations, kind));
        };
        // https://tc39.github.io/ecma262/#sec-destructuring-binding-patterns
        Parser.prototype.parseBindingRestElement = function (params, kind) {
          var node = this.createNode();
          this.expect('...');
          var arg = this.parsePattern(params, kind);
          return this.finalize(node, new Node.RestElement(arg));
        };
        Parser.prototype.parseArrayPattern = function (params, kind) {
          var node = this.createNode();
          this.expect('[');
          var elements = [];
          while (!this.match(']')) {
            if (this.match(',')) {
              this.nextToken();
              elements.push(null);
            } else {
              if (this.match('...')) {
                elements.push(this.parseBindingRestElement(params, kind));
                break;
              } else {
                elements.push(this.parsePatternWithDefault(params, kind));
              }
              if (!this.match(']')) {
                this.expect(',');
              }
            }
          }
          this.expect(']');
          return this.finalize(node, new Node.ArrayPattern(elements));
        };
        Parser.prototype.parsePropertyPattern = function (params, kind) {
          var node = this.createNode();
          var computed = false;
          var shorthand = false;
          var method = false;
          var key;
          var value;
          if (this.lookahead.type === 3 /* Identifier */) {
            var keyToken = this.lookahead;
            key = this.parseVariableIdentifier();
            var init = this.finalize(node, new Node.Identifier(keyToken.value));
            if (this.match('=')) {
              params.push(keyToken);
              shorthand = true;
              this.nextToken();
              var expr = this.parseAssignmentExpression();
              value = this.finalize(this.startNode(keyToken), new Node.AssignmentPattern(init, expr));
            } else if (!this.match(':')) {
              params.push(keyToken);
              shorthand = true;
              value = init;
            } else {
              this.expect(':');
              value = this.parsePatternWithDefault(params, kind);
            }
          } else {
            computed = this.match('[');
            key = this.parseObjectPropertyKey();
            this.expect(':');
            value = this.parsePatternWithDefault(params, kind);
          }
          return this.finalize(node, new Node.Property('init', key, computed, value, method, shorthand));
        };
        Parser.prototype.parseObjectPattern = function (params, kind) {
          var node = this.createNode();
          var properties = [];
          this.expect('{');
          while (!this.match('}')) {
            properties.push(this.parsePropertyPattern(params, kind));
            if (!this.match('}')) {
              this.expect(',');
            }
          }
          this.expect('}');
          return this.finalize(node, new Node.ObjectPattern(properties));
        };
        Parser.prototype.parsePattern = function (params, kind) {
          var pattern;
          if (this.match('[')) {
            pattern = this.parseArrayPattern(params, kind);
          } else if (this.match('{')) {
            pattern = this.parseObjectPattern(params, kind);
          } else {
            if (this.matchKeyword('let') && (kind === 'const' || kind === 'let')) {
              this.tolerateUnexpectedToken(this.lookahead, messages_1.Messages.LetInLexicalBinding);
            }
            params.push(this.lookahead);
            pattern = this.parseVariableIdentifier(kind);
          }
          return pattern;
        };
        Parser.prototype.parsePatternWithDefault = function (params, kind) {
          var startToken = this.lookahead;
          var pattern = this.parsePattern(params, kind);
          if (this.match('=')) {
            this.nextToken();
            var previousAllowYield = this.context.allowYield;
            this.context.allowYield = true;
            var right = this.isolateCoverGrammar(this.parseAssignmentExpression);
            this.context.allowYield = previousAllowYield;
            pattern = this.finalize(this.startNode(startToken), new Node.AssignmentPattern(pattern, right));
          }
          return pattern;
        };
        // https://tc39.github.io/ecma262/#sec-variable-statement
        Parser.prototype.parseVariableIdentifier = function (kind) {
          var node = this.createNode();
          var token = this.nextToken();
          if (token.type === 4 /* Keyword */ && token.value === 'yield') {
            if (this.context.strict) {
              this.tolerateUnexpectedToken(token, messages_1.Messages.StrictReservedWord);
            } else if (!this.context.allowYield) {
              this.throwUnexpectedToken(token);
            }
          } else if (token.type !== 3 /* Identifier */) {
            if (this.context.strict && token.type === 4 /* Keyword */ && this.scanner.isStrictModeReservedWord(token.value)) {
              this.tolerateUnexpectedToken(token, messages_1.Messages.StrictReservedWord);
            } else {
              if (this.context.strict || token.value !== 'let' || kind !== 'var') {
                this.throwUnexpectedToken(token);
              }
            }
          } else if ((this.context.isModule || this.context.await) && token.type === 3 /* Identifier */ && token.value === 'await') {
            this.tolerateUnexpectedToken(token);
          }
          return this.finalize(node, new Node.Identifier(token.value));
        };
        Parser.prototype.parseVariableDeclaration = function (options) {
          var node = this.createNode();
          var params = [];
          var id = this.parsePattern(params, 'var');
          if (this.context.strict && id.type === syntax_1.Syntax.Identifier) {
            if (this.scanner.isRestrictedWord(id.name)) {
              this.tolerateError(messages_1.Messages.StrictVarName);
            }
          }
          var init = null;
          if (this.match('=')) {
            this.nextToken();
            init = this.isolateCoverGrammar(this.parseAssignmentExpression);
          } else if (id.type !== syntax_1.Syntax.Identifier && !options.inFor) {
            this.expect('=');
          }
          return this.finalize(node, new Node.VariableDeclarator(id, init));
        };
        Parser.prototype.parseVariableDeclarationList = function (options) {
          var opt = {
            inFor: options.inFor
          };
          var list = [];
          list.push(this.parseVariableDeclaration(opt));
          while (this.match(',')) {
            this.nextToken();
            list.push(this.parseVariableDeclaration(opt));
          }
          return list;
        };
        Parser.prototype.parseVariableStatement = function () {
          var node = this.createNode();
          this.expectKeyword('var');
          var declarations = this.parseVariableDeclarationList({
            inFor: false
          });
          this.consumeSemicolon();
          return this.finalize(node, new Node.VariableDeclaration(declarations, 'var'));
        };
        // https://tc39.github.io/ecma262/#sec-empty-statement
        Parser.prototype.parseEmptyStatement = function () {
          var node = this.createNode();
          this.expect(';');
          return this.finalize(node, new Node.EmptyStatement());
        };
        // https://tc39.github.io/ecma262/#sec-expression-statement
        Parser.prototype.parseExpressionStatement = function () {
          var node = this.createNode();
          var expr = this.parseExpression();
          this.consumeSemicolon();
          return this.finalize(node, new Node.ExpressionStatement(expr));
        };
        // https://tc39.github.io/ecma262/#sec-if-statement
        Parser.prototype.parseIfClause = function () {
          if (this.context.strict && this.matchKeyword('function')) {
            this.tolerateError(messages_1.Messages.StrictFunction);
          }
          return this.parseStatement();
        };
        Parser.prototype.parseIfStatement = function () {
          var node = this.createNode();
          var consequent;
          var alternate = null;
          this.expectKeyword('if');
          this.expect('(');
          var test = this.parseExpression();
          if (!this.match(')') && this.config.tolerant) {
            this.tolerateUnexpectedToken(this.nextToken());
            consequent = this.finalize(this.createNode(), new Node.EmptyStatement());
          } else {
            this.expect(')');
            consequent = this.parseIfClause();
            if (this.matchKeyword('else')) {
              this.nextToken();
              alternate = this.parseIfClause();
            }
          }
          return this.finalize(node, new Node.IfStatement(test, consequent, alternate));
        };
        // https://tc39.github.io/ecma262/#sec-do-while-statement
        Parser.prototype.parseDoWhileStatement = function () {
          var node = this.createNode();
          this.expectKeyword('do');
          var previousInIteration = this.context.inIteration;
          this.context.inIteration = true;
          var body = this.parseStatement();
          this.context.inIteration = previousInIteration;
          this.expectKeyword('while');
          this.expect('(');
          var test = this.parseExpression();
          if (!this.match(')') && this.config.tolerant) {
            this.tolerateUnexpectedToken(this.nextToken());
          } else {
            this.expect(')');
            if (this.match(';')) {
              this.nextToken();
            }
          }
          return this.finalize(node, new Node.DoWhileStatement(body, test));
        };
        // https://tc39.github.io/ecma262/#sec-while-statement
        Parser.prototype.parseWhileStatement = function () {
          var node = this.createNode();
          var body;
          this.expectKeyword('while');
          this.expect('(');
          var test = this.parseExpression();
          if (!this.match(')') && this.config.tolerant) {
            this.tolerateUnexpectedToken(this.nextToken());
            body = this.finalize(this.createNode(), new Node.EmptyStatement());
          } else {
            this.expect(')');
            var previousInIteration = this.context.inIteration;
            this.context.inIteration = true;
            body = this.parseStatement();
            this.context.inIteration = previousInIteration;
          }
          return this.finalize(node, new Node.WhileStatement(test, body));
        };
        // https://tc39.github.io/ecma262/#sec-for-statement
        // https://tc39.github.io/ecma262/#sec-for-in-and-for-of-statements
        Parser.prototype.parseForStatement = function () {
          var init = null;
          var test = null;
          var update = null;
          var forIn = true;
          var left, right;
          var node = this.createNode();
          this.expectKeyword('for');
          this.expect('(');
          if (this.match(';')) {
            this.nextToken();
          } else {
            if (this.matchKeyword('var')) {
              init = this.createNode();
              this.nextToken();
              var previousAllowIn = this.context.allowIn;
              this.context.allowIn = false;
              var declarations = this.parseVariableDeclarationList({
                inFor: true
              });
              this.context.allowIn = previousAllowIn;
              if (declarations.length === 1 && this.matchKeyword('in')) {
                var decl = declarations[0];
                if (decl.init && (decl.id.type === syntax_1.Syntax.ArrayPattern || decl.id.type === syntax_1.Syntax.ObjectPattern || this.context.strict)) {
                  this.tolerateError(messages_1.Messages.ForInOfLoopInitializer, 'for-in');
                }
                init = this.finalize(init, new Node.VariableDeclaration(declarations, 'var'));
                this.nextToken();
                left = init;
                right = this.parseExpression();
                init = null;
              } else if (declarations.length === 1 && declarations[0].init === null && this.matchContextualKeyword('of')) {
                init = this.finalize(init, new Node.VariableDeclaration(declarations, 'var'));
                this.nextToken();
                left = init;
                right = this.parseAssignmentExpression();
                init = null;
                forIn = false;
              } else {
                init = this.finalize(init, new Node.VariableDeclaration(declarations, 'var'));
                this.expect(';');
              }
            } else if (this.matchKeyword('const') || this.matchKeyword('let')) {
              init = this.createNode();
              var kind = this.nextToken().value;
              if (!this.context.strict && this.lookahead.value === 'in') {
                init = this.finalize(init, new Node.Identifier(kind));
                this.nextToken();
                left = init;
                right = this.parseExpression();
                init = null;
              } else {
                var previousAllowIn = this.context.allowIn;
                this.context.allowIn = false;
                var declarations = this.parseBindingList(kind, {
                  inFor: true
                });
                this.context.allowIn = previousAllowIn;
                if (declarations.length === 1 && declarations[0].init === null && this.matchKeyword('in')) {
                  init = this.finalize(init, new Node.VariableDeclaration(declarations, kind));
                  this.nextToken();
                  left = init;
                  right = this.parseExpression();
                  init = null;
                } else if (declarations.length === 1 && declarations[0].init === null && this.matchContextualKeyword('of')) {
                  init = this.finalize(init, new Node.VariableDeclaration(declarations, kind));
                  this.nextToken();
                  left = init;
                  right = this.parseAssignmentExpression();
                  init = null;
                  forIn = false;
                } else {
                  this.consumeSemicolon();
                  init = this.finalize(init, new Node.VariableDeclaration(declarations, kind));
                }
              }
            } else {
              var initStartToken = this.lookahead;
              var previousAllowIn = this.context.allowIn;
              this.context.allowIn = false;
              init = this.inheritCoverGrammar(this.parseAssignmentExpression);
              this.context.allowIn = previousAllowIn;
              if (this.matchKeyword('in')) {
                if (!this.context.isAssignmentTarget || init.type === syntax_1.Syntax.AssignmentExpression) {
                  this.tolerateError(messages_1.Messages.InvalidLHSInForIn);
                }
                this.nextToken();
                this.reinterpretExpressionAsPattern(init);
                left = init;
                right = this.parseExpression();
                init = null;
              } else if (this.matchContextualKeyword('of')) {
                if (!this.context.isAssignmentTarget || init.type === syntax_1.Syntax.AssignmentExpression) {
                  this.tolerateError(messages_1.Messages.InvalidLHSInForLoop);
                }
                this.nextToken();
                this.reinterpretExpressionAsPattern(init);
                left = init;
                right = this.parseAssignmentExpression();
                init = null;
                forIn = false;
              } else {
                if (this.match(',')) {
                  var initSeq = [init];
                  while (this.match(',')) {
                    this.nextToken();
                    initSeq.push(this.isolateCoverGrammar(this.parseAssignmentExpression));
                  }
                  init = this.finalize(this.startNode(initStartToken), new Node.SequenceExpression(initSeq));
                }
                this.expect(';');
              }
            }
          }
          if (typeof left === 'undefined') {
            if (!this.match(';')) {
              test = this.parseExpression();
            }
            this.expect(';');
            if (!this.match(')')) {
              update = this.parseExpression();
            }
          }
          var body;
          if (!this.match(')') && this.config.tolerant) {
            this.tolerateUnexpectedToken(this.nextToken());
            body = this.finalize(this.createNode(), new Node.EmptyStatement());
          } else {
            this.expect(')');
            var previousInIteration = this.context.inIteration;
            this.context.inIteration = true;
            body = this.isolateCoverGrammar(this.parseStatement);
            this.context.inIteration = previousInIteration;
          }
          return typeof left === 'undefined' ? this.finalize(node, new Node.ForStatement(init, test, update, body)) : forIn ? this.finalize(node, new Node.ForInStatement(left, right, body)) : this.finalize(node, new Node.ForOfStatement(left, right, body));
        };
        // https://tc39.github.io/ecma262/#sec-continue-statement
        Parser.prototype.parseContinueStatement = function () {
          var node = this.createNode();
          this.expectKeyword('continue');
          var label = null;
          if (this.lookahead.type === 3 /* Identifier */ && !this.hasLineTerminator) {
            var id = this.parseVariableIdentifier();
            label = id;
            var key = '$' + id.name;
            if (!Object.prototype.hasOwnProperty.call(this.context.labelSet, key)) {
              this.throwError(messages_1.Messages.UnknownLabel, id.name);
            }
          }
          this.consumeSemicolon();
          if (label === null && !this.context.inIteration) {
            this.throwError(messages_1.Messages.IllegalContinue);
          }
          return this.finalize(node, new Node.ContinueStatement(label));
        };
        // https://tc39.github.io/ecma262/#sec-break-statement
        Parser.prototype.parseBreakStatement = function () {
          var node = this.createNode();
          this.expectKeyword('break');
          var label = null;
          if (this.lookahead.type === 3 /* Identifier */ && !this.hasLineTerminator) {
            var id = this.parseVariableIdentifier();
            var key = '$' + id.name;
            if (!Object.prototype.hasOwnProperty.call(this.context.labelSet, key)) {
              this.throwError(messages_1.Messages.UnknownLabel, id.name);
            }
            label = id;
          }
          this.consumeSemicolon();
          if (label === null && !this.context.inIteration && !this.context.inSwitch) {
            this.throwError(messages_1.Messages.IllegalBreak);
          }
          return this.finalize(node, new Node.BreakStatement(label));
        };
        // https://tc39.github.io/ecma262/#sec-return-statement
        Parser.prototype.parseReturnStatement = function () {
          if (!this.context.inFunctionBody) {
            this.tolerateError(messages_1.Messages.IllegalReturn);
          }
          var node = this.createNode();
          this.expectKeyword('return');
          var hasArgument = !this.match(';') && !this.match('}') && !this.hasLineTerminator && this.lookahead.type !== 2 /* EOF */ || this.lookahead.type === 8 /* StringLiteral */ || this.lookahead.type === 10 /* Template */;
          var argument = hasArgument ? this.parseExpression() : null;
          this.consumeSemicolon();
          return this.finalize(node, new Node.ReturnStatement(argument));
        };
        // https://tc39.github.io/ecma262/#sec-with-statement
        Parser.prototype.parseWithStatement = function () {
          if (this.context.strict) {
            this.tolerateError(messages_1.Messages.StrictModeWith);
          }
          var node = this.createNode();
          var body;
          this.expectKeyword('with');
          this.expect('(');
          var object = this.parseExpression();
          if (!this.match(')') && this.config.tolerant) {
            this.tolerateUnexpectedToken(this.nextToken());
            body = this.finalize(this.createNode(), new Node.EmptyStatement());
          } else {
            this.expect(')');
            body = this.parseStatement();
          }
          return this.finalize(node, new Node.WithStatement(object, body));
        };
        // https://tc39.github.io/ecma262/#sec-switch-statement
        Parser.prototype.parseSwitchCase = function () {
          var node = this.createNode();
          var test;
          if (this.matchKeyword('default')) {
            this.nextToken();
            test = null;
          } else {
            this.expectKeyword('case');
            test = this.parseExpression();
          }
          this.expect(':');
          var consequent = [];
          while (true) {
            if (this.match('}') || this.matchKeyword('default') || this.matchKeyword('case')) {
              break;
            }
            consequent.push(this.parseStatementListItem());
          }
          return this.finalize(node, new Node.SwitchCase(test, consequent));
        };
        Parser.prototype.parseSwitchStatement = function () {
          var node = this.createNode();
          this.expectKeyword('switch');
          this.expect('(');
          var discriminant = this.parseExpression();
          this.expect(')');
          var previousInSwitch = this.context.inSwitch;
          this.context.inSwitch = true;
          var cases = [];
          var defaultFound = false;
          this.expect('{');
          while (true) {
            if (this.match('}')) {
              break;
            }
            var clause = this.parseSwitchCase();
            if (clause.test === null) {
              if (defaultFound) {
                this.throwError(messages_1.Messages.MultipleDefaultsInSwitch);
              }
              defaultFound = true;
            }
            cases.push(clause);
          }
          this.expect('}');
          this.context.inSwitch = previousInSwitch;
          return this.finalize(node, new Node.SwitchStatement(discriminant, cases));
        };
        // https://tc39.github.io/ecma262/#sec-labelled-statements
        Parser.prototype.parseLabelledStatement = function () {
          var node = this.createNode();
          var expr = this.parseExpression();
          var statement;
          if (expr.type === syntax_1.Syntax.Identifier && this.match(':')) {
            this.nextToken();
            var id = expr;
            var key = '$' + id.name;
            if (Object.prototype.hasOwnProperty.call(this.context.labelSet, key)) {
              this.throwError(messages_1.Messages.Redeclaration, 'Label', id.name);
            }
            this.context.labelSet[key] = true;
            var body = void 0;
            if (this.matchKeyword('class')) {
              this.tolerateUnexpectedToken(this.lookahead);
              body = this.parseClassDeclaration();
            } else if (this.matchKeyword('function')) {
              var token = this.lookahead;
              var declaration = this.parseFunctionDeclaration();
              if (this.context.strict) {
                this.tolerateUnexpectedToken(token, messages_1.Messages.StrictFunction);
              } else if (declaration.generator) {
                this.tolerateUnexpectedToken(token, messages_1.Messages.GeneratorInLegacyContext);
              }
              body = declaration;
            } else {
              body = this.parseStatement();
            }
            delete this.context.labelSet[key];
            statement = new Node.LabeledStatement(id, body);
          } else {
            this.consumeSemicolon();
            statement = new Node.ExpressionStatement(expr);
          }
          return this.finalize(node, statement);
        };
        // https://tc39.github.io/ecma262/#sec-throw-statement
        Parser.prototype.parseThrowStatement = function () {
          var node = this.createNode();
          this.expectKeyword('throw');
          if (this.hasLineTerminator) {
            this.throwError(messages_1.Messages.NewlineAfterThrow);
          }
          var argument = this.parseExpression();
          this.consumeSemicolon();
          return this.finalize(node, new Node.ThrowStatement(argument));
        };
        // https://tc39.github.io/ecma262/#sec-try-statement
        Parser.prototype.parseCatchClause = function () {
          var node = this.createNode();
          this.expectKeyword('catch');
          this.expect('(');
          if (this.match(')')) {
            this.throwUnexpectedToken(this.lookahead);
          }
          var params = [];
          var param = this.parsePattern(params);
          var paramMap = {};
          for (var i = 0; i < params.length; i++) {
            var key = '$' + params[i].value;
            if (Object.prototype.hasOwnProperty.call(paramMap, key)) {
              this.tolerateError(messages_1.Messages.DuplicateBinding, params[i].value);
            }
            paramMap[key] = true;
          }
          if (this.context.strict && param.type === syntax_1.Syntax.Identifier) {
            if (this.scanner.isRestrictedWord(param.name)) {
              this.tolerateError(messages_1.Messages.StrictCatchVariable);
            }
          }
          this.expect(')');
          var body = this.parseBlock();
          return this.finalize(node, new Node.CatchClause(param, body));
        };
        Parser.prototype.parseFinallyClause = function () {
          this.expectKeyword('finally');
          return this.parseBlock();
        };
        Parser.prototype.parseTryStatement = function () {
          var node = this.createNode();
          this.expectKeyword('try');
          var block = this.parseBlock();
          var handler = this.matchKeyword('catch') ? this.parseCatchClause() : null;
          var finalizer = this.matchKeyword('finally') ? this.parseFinallyClause() : null;
          if (!handler && !finalizer) {
            this.throwError(messages_1.Messages.NoCatchOrFinally);
          }
          return this.finalize(node, new Node.TryStatement(block, handler, finalizer));
        };
        // https://tc39.github.io/ecma262/#sec-debugger-statement
        Parser.prototype.parseDebuggerStatement = function () {
          var node = this.createNode();
          this.expectKeyword('debugger');
          this.consumeSemicolon();
          return this.finalize(node, new Node.DebuggerStatement());
        };
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-statements-and-declarations
        Parser.prototype.parseStatement = function () {
          var statement;
          switch (this.lookahead.type) {
            case 1 /* BooleanLiteral */:
            case 5 /* NullLiteral */:
            case 6 /* NumericLiteral */:
            case 8 /* StringLiteral */:
            case 10 /* Template */:
            case 9 /* RegularExpression */:
              statement = this.parseExpressionStatement();
              break;
            case 7 /* Punctuator */:
              var value = this.lookahead.value;
              if (value === '{') {
                statement = this.parseBlock();
              } else if (value === '(') {
                statement = this.parseExpressionStatement();
              } else if (value === ';') {
                statement = this.parseEmptyStatement();
              } else {
                statement = this.parseExpressionStatement();
              }
              break;
            case 3 /* Identifier */:
              statement = this.matchAsyncFunction() ? this.parseFunctionDeclaration() : this.parseLabelledStatement();
              break;
            case 4 /* Keyword */:
              switch (this.lookahead.value) {
                case 'break':
                  statement = this.parseBreakStatement();
                  break;
                case 'continue':
                  statement = this.parseContinueStatement();
                  break;
                case 'debugger':
                  statement = this.parseDebuggerStatement();
                  break;
                case 'do':
                  statement = this.parseDoWhileStatement();
                  break;
                case 'for':
                  statement = this.parseForStatement();
                  break;
                case 'function':
                  statement = this.parseFunctionDeclaration();
                  break;
                case 'if':
                  statement = this.parseIfStatement();
                  break;
                case 'return':
                  statement = this.parseReturnStatement();
                  break;
                case 'switch':
                  statement = this.parseSwitchStatement();
                  break;
                case 'throw':
                  statement = this.parseThrowStatement();
                  break;
                case 'try':
                  statement = this.parseTryStatement();
                  break;
                case 'var':
                  statement = this.parseVariableStatement();
                  break;
                case 'while':
                  statement = this.parseWhileStatement();
                  break;
                case 'with':
                  statement = this.parseWithStatement();
                  break;
                default:
                  statement = this.parseExpressionStatement();
                  break;
              }
              break;
            default:
              statement = this.throwUnexpectedToken(this.lookahead);
          }
          return statement;
        };
        // https://tc39.github.io/ecma262/#sec-function-definitions
        Parser.prototype.parseFunctionSourceElements = function () {
          var node = this.createNode();
          this.expect('{');
          var body = this.parseDirectivePrologues();
          var previousLabelSet = this.context.labelSet;
          var previousInIteration = this.context.inIteration;
          var previousInSwitch = this.context.inSwitch;
          var previousInFunctionBody = this.context.inFunctionBody;
          this.context.labelSet = {};
          this.context.inIteration = false;
          this.context.inSwitch = false;
          this.context.inFunctionBody = true;
          while (this.lookahead.type !== 2 /* EOF */) {
            if (this.match('}')) {
              break;
            }
            body.push(this.parseStatementListItem());
          }
          this.expect('}');
          this.context.labelSet = previousLabelSet;
          this.context.inIteration = previousInIteration;
          this.context.inSwitch = previousInSwitch;
          this.context.inFunctionBody = previousInFunctionBody;
          return this.finalize(node, new Node.BlockStatement(body));
        };
        Parser.prototype.validateParam = function (options, param, name) {
          var key = '$' + name;
          if (this.context.strict) {
            if (this.scanner.isRestrictedWord(name)) {
              options.stricted = param;
              options.message = messages_1.Messages.StrictParamName;
            }
            if (Object.prototype.hasOwnProperty.call(options.paramSet, key)) {
              options.stricted = param;
              options.message = messages_1.Messages.StrictParamDupe;
            }
          } else if (!options.firstRestricted) {
            if (this.scanner.isRestrictedWord(name)) {
              options.firstRestricted = param;
              options.message = messages_1.Messages.StrictParamName;
            } else if (this.scanner.isStrictModeReservedWord(name)) {
              options.firstRestricted = param;
              options.message = messages_1.Messages.StrictReservedWord;
            } else if (Object.prototype.hasOwnProperty.call(options.paramSet, key)) {
              options.stricted = param;
              options.message = messages_1.Messages.StrictParamDupe;
            }
          }
          /* istanbul ignore next */
          if (typeof Object.defineProperty === 'function') {
            Object.defineProperty(options.paramSet, key, {
              value: true,
              enumerable: true,
              writable: true,
              configurable: true
            });
          } else {
            options.paramSet[key] = true;
          }
        };
        Parser.prototype.parseRestElement = function (params) {
          var node = this.createNode();
          this.expect('...');
          var arg = this.parsePattern(params);
          if (this.match('=')) {
            this.throwError(messages_1.Messages.DefaultRestParameter);
          }
          if (!this.match(')')) {
            this.throwError(messages_1.Messages.ParameterAfterRestParameter);
          }
          return this.finalize(node, new Node.RestElement(arg));
        };
        Parser.prototype.parseFormalParameter = function (options) {
          var params = [];
          var param = this.match('...') ? this.parseRestElement(params) : this.parsePatternWithDefault(params);
          for (var i = 0; i < params.length; i++) {
            this.validateParam(options, params[i], params[i].value);
          }
          options.simple = options.simple && param instanceof Node.Identifier;
          options.params.push(param);
        };
        Parser.prototype.parseFormalParameters = function (firstRestricted) {
          var options;
          options = {
            simple: true,
            params: [],
            firstRestricted: firstRestricted
          };
          this.expect('(');
          if (!this.match(')')) {
            options.paramSet = {};
            while (this.lookahead.type !== 2 /* EOF */) {
              this.parseFormalParameter(options);
              if (this.match(')')) {
                break;
              }
              this.expect(',');
              if (this.match(')')) {
                break;
              }
            }
          }
          this.expect(')');
          return {
            simple: options.simple,
            params: options.params,
            stricted: options.stricted,
            firstRestricted: options.firstRestricted,
            message: options.message
          };
        };
        Parser.prototype.matchAsyncFunction = function () {
          var match = this.matchContextualKeyword('async');
          if (match) {
            var state = this.scanner.saveState();
            this.scanner.scanComments();
            var next = this.scanner.lex();
            this.scanner.restoreState(state);
            match = state.lineNumber === next.lineNumber && next.type === 4 /* Keyword */ && next.value === 'function';
          }
          return match;
        };
        Parser.prototype.parseFunctionDeclaration = function (identifierIsOptional) {
          var node = this.createNode();
          var isAsync = this.matchContextualKeyword('async');
          if (isAsync) {
            this.nextToken();
          }
          this.expectKeyword('function');
          var isGenerator = isAsync ? false : this.match('*');
          if (isGenerator) {
            this.nextToken();
          }
          var message;
          var id = null;
          var firstRestricted = null;
          if (!identifierIsOptional || !this.match('(')) {
            var token = this.lookahead;
            id = this.parseVariableIdentifier();
            if (this.context.strict) {
              if (this.scanner.isRestrictedWord(token.value)) {
                this.tolerateUnexpectedToken(token, messages_1.Messages.StrictFunctionName);
              }
            } else {
              if (this.scanner.isRestrictedWord(token.value)) {
                firstRestricted = token;
                message = messages_1.Messages.StrictFunctionName;
              } else if (this.scanner.isStrictModeReservedWord(token.value)) {
                firstRestricted = token;
                message = messages_1.Messages.StrictReservedWord;
              }
            }
          }
          var previousAllowAwait = this.context.await;
          var previousAllowYield = this.context.allowYield;
          this.context.await = isAsync;
          this.context.allowYield = !isGenerator;
          var formalParameters = this.parseFormalParameters(firstRestricted);
          var params = formalParameters.params;
          var stricted = formalParameters.stricted;
          firstRestricted = formalParameters.firstRestricted;
          if (formalParameters.message) {
            message = formalParameters.message;
          }
          var previousStrict = this.context.strict;
          var previousAllowStrictDirective = this.context.allowStrictDirective;
          this.context.allowStrictDirective = formalParameters.simple;
          var body = this.parseFunctionSourceElements();
          if (this.context.strict && firstRestricted) {
            this.throwUnexpectedToken(firstRestricted, message);
          }
          if (this.context.strict && stricted) {
            this.tolerateUnexpectedToken(stricted, message);
          }
          this.context.strict = previousStrict;
          this.context.allowStrictDirective = previousAllowStrictDirective;
          this.context.await = previousAllowAwait;
          this.context.allowYield = previousAllowYield;
          return isAsync ? this.finalize(node, new Node.AsyncFunctionDeclaration(id, params, body)) : this.finalize(node, new Node.FunctionDeclaration(id, params, body, isGenerator));
        };
        Parser.prototype.parseFunctionExpression = function () {
          var node = this.createNode();
          var isAsync = this.matchContextualKeyword('async');
          if (isAsync) {
            this.nextToken();
          }
          this.expectKeyword('function');
          var isGenerator = isAsync ? false : this.match('*');
          if (isGenerator) {
            this.nextToken();
          }
          var message;
          var id = null;
          var firstRestricted;
          var previousAllowAwait = this.context.await;
          var previousAllowYield = this.context.allowYield;
          this.context.await = isAsync;
          this.context.allowYield = !isGenerator;
          if (!this.match('(')) {
            var token = this.lookahead;
            id = !this.context.strict && !isGenerator && this.matchKeyword('yield') ? this.parseIdentifierName() : this.parseVariableIdentifier();
            if (this.context.strict) {
              if (this.scanner.isRestrictedWord(token.value)) {
                this.tolerateUnexpectedToken(token, messages_1.Messages.StrictFunctionName);
              }
            } else {
              if (this.scanner.isRestrictedWord(token.value)) {
                firstRestricted = token;
                message = messages_1.Messages.StrictFunctionName;
              } else if (this.scanner.isStrictModeReservedWord(token.value)) {
                firstRestricted = token;
                message = messages_1.Messages.StrictReservedWord;
              }
            }
          }
          var formalParameters = this.parseFormalParameters(firstRestricted);
          var params = formalParameters.params;
          var stricted = formalParameters.stricted;
          firstRestricted = formalParameters.firstRestricted;
          if (formalParameters.message) {
            message = formalParameters.message;
          }
          var previousStrict = this.context.strict;
          var previousAllowStrictDirective = this.context.allowStrictDirective;
          this.context.allowStrictDirective = formalParameters.simple;
          var body = this.parseFunctionSourceElements();
          if (this.context.strict && firstRestricted) {
            this.throwUnexpectedToken(firstRestricted, message);
          }
          if (this.context.strict && stricted) {
            this.tolerateUnexpectedToken(stricted, message);
          }
          this.context.strict = previousStrict;
          this.context.allowStrictDirective = previousAllowStrictDirective;
          this.context.await = previousAllowAwait;
          this.context.allowYield = previousAllowYield;
          return isAsync ? this.finalize(node, new Node.AsyncFunctionExpression(id, params, body)) : this.finalize(node, new Node.FunctionExpression(id, params, body, isGenerator));
        };
        // https://tc39.github.io/ecma262/#sec-directive-prologues-and-the-use-strict-directive
        Parser.prototype.parseDirective = function () {
          var token = this.lookahead;
          var node = this.createNode();
          var expr = this.parseExpression();
          var directive = expr.type === syntax_1.Syntax.Literal ? this.getTokenRaw(token).slice(1, -1) : null;
          this.consumeSemicolon();
          return this.finalize(node, directive ? new Node.Directive(expr, directive) : new Node.ExpressionStatement(expr));
        };
        Parser.prototype.parseDirectivePrologues = function () {
          var firstRestricted = null;
          var body = [];
          while (true) {
            var token = this.lookahead;
            if (token.type !== 8 /* StringLiteral */) {
              break;
            }
            var statement = this.parseDirective();
            body.push(statement);
            var directive = statement.directive;
            if (typeof directive !== 'string') {
              break;
            }
            if (directive === 'use strict') {
              this.context.strict = true;
              if (firstRestricted) {
                this.tolerateUnexpectedToken(firstRestricted, messages_1.Messages.StrictOctalLiteral);
              }
              if (!this.context.allowStrictDirective) {
                this.tolerateUnexpectedToken(token, messages_1.Messages.IllegalLanguageModeDirective);
              }
            } else {
              if (!firstRestricted && token.octal) {
                firstRestricted = token;
              }
            }
          }
          return body;
        };
        // https://tc39.github.io/ecma262/#sec-method-definitions
        Parser.prototype.qualifiedPropertyName = function (token) {
          switch (token.type) {
            case 3 /* Identifier */:
            case 8 /* StringLiteral */:
            case 1 /* BooleanLiteral */:
            case 5 /* NullLiteral */:
            case 6 /* NumericLiteral */:
            case 4 /* Keyword */:
              return true;
            case 7 /* Punctuator */:
              return token.value === '[';
            default:
              break;
          }
          return false;
        };
        Parser.prototype.parseGetterMethod = function () {
          var node = this.createNode();
          var isGenerator = false;
          var previousAllowYield = this.context.allowYield;
          this.context.allowYield = !isGenerator;
          var formalParameters = this.parseFormalParameters();
          if (formalParameters.params.length > 0) {
            this.tolerateError(messages_1.Messages.BadGetterArity);
          }
          var method = this.parsePropertyMethod(formalParameters);
          this.context.allowYield = previousAllowYield;
          return this.finalize(node, new Node.FunctionExpression(null, formalParameters.params, method, isGenerator));
        };
        Parser.prototype.parseSetterMethod = function () {
          var node = this.createNode();
          var isGenerator = false;
          var previousAllowYield = this.context.allowYield;
          this.context.allowYield = !isGenerator;
          var formalParameters = this.parseFormalParameters();
          if (formalParameters.params.length !== 1) {
            this.tolerateError(messages_1.Messages.BadSetterArity);
          } else if (formalParameters.params[0] instanceof Node.RestElement) {
            this.tolerateError(messages_1.Messages.BadSetterRestParameter);
          }
          var method = this.parsePropertyMethod(formalParameters);
          this.context.allowYield = previousAllowYield;
          return this.finalize(node, new Node.FunctionExpression(null, formalParameters.params, method, isGenerator));
        };
        Parser.prototype.parseGeneratorMethod = function () {
          var node = this.createNode();
          var isGenerator = true;
          var previousAllowYield = this.context.allowYield;
          this.context.allowYield = true;
          var params = this.parseFormalParameters();
          this.context.allowYield = false;
          var method = this.parsePropertyMethod(params);
          this.context.allowYield = previousAllowYield;
          return this.finalize(node, new Node.FunctionExpression(null, params.params, method, isGenerator));
        };
        // https://tc39.github.io/ecma262/#sec-generator-function-definitions
        Parser.prototype.isStartOfExpression = function () {
          var start = true;
          var value = this.lookahead.value;
          switch (this.lookahead.type) {
            case 7 /* Punctuator */:
              start = value === '[' || value === '(' || value === '{' || value === '+' || value === '-' || value === '!' || value === '~' || value === '++' || value === '--' || value === '/' || value === '/='; // regular expression literal
              break;
            case 4 /* Keyword */:
              start = value === 'class' || value === 'delete' || value === 'function' || value === 'let' || value === 'new' || value === 'super' || value === 'this' || value === 'typeof' || value === 'void' || value === 'yield';
              break;
            default:
              break;
          }
          return start;
        };
        Parser.prototype.parseYieldExpression = function () {
          var node = this.createNode();
          this.expectKeyword('yield');
          var argument = null;
          var delegate = false;
          if (!this.hasLineTerminator) {
            var previousAllowYield = this.context.allowYield;
            this.context.allowYield = false;
            delegate = this.match('*');
            if (delegate) {
              this.nextToken();
              argument = this.parseAssignmentExpression();
            } else if (this.isStartOfExpression()) {
              argument = this.parseAssignmentExpression();
            }
            this.context.allowYield = previousAllowYield;
          }
          return this.finalize(node, new Node.YieldExpression(argument, delegate));
        };
        // https://tc39.github.io/ecma262/#sec-class-definitions
        Parser.prototype.parseClassElement = function (hasConstructor) {
          var token = this.lookahead;
          var node = this.createNode();
          var kind = '';
          var key = null;
          var value = null;
          var computed = false;
          var method = false;
          var isStatic = false;
          var isAsync = false;
          if (this.match('*')) {
            this.nextToken();
          } else {
            computed = this.match('[');
            key = this.parseObjectPropertyKey();
            var id = key;
            if (id.name === 'static' && (this.qualifiedPropertyName(this.lookahead) || this.match('*'))) {
              token = this.lookahead;
              isStatic = true;
              computed = this.match('[');
              if (this.match('*')) {
                this.nextToken();
              } else {
                key = this.parseObjectPropertyKey();
              }
            }
            if (token.type === 3 /* Identifier */ && !this.hasLineTerminator && token.value === 'async') {
              var punctuator = this.lookahead.value;
              if (punctuator !== ':' && punctuator !== '(' && punctuator !== '*') {
                isAsync = true;
                token = this.lookahead;
                key = this.parseObjectPropertyKey();
                if (token.type === 3 /* Identifier */ && token.value === 'constructor') {
                  this.tolerateUnexpectedToken(token, messages_1.Messages.ConstructorIsAsync);
                }
              }
            }
          }
          var lookaheadPropertyKey = this.qualifiedPropertyName(this.lookahead);
          if (token.type === 3 /* Identifier */) {
            if (token.value === 'get' && lookaheadPropertyKey) {
              kind = 'get';
              computed = this.match('[');
              key = this.parseObjectPropertyKey();
              this.context.allowYield = false;
              value = this.parseGetterMethod();
            } else if (token.value === 'set' && lookaheadPropertyKey) {
              kind = 'set';
              computed = this.match('[');
              key = this.parseObjectPropertyKey();
              value = this.parseSetterMethod();
            }
          } else if (token.type === 7 /* Punctuator */ && token.value === '*' && lookaheadPropertyKey) {
            kind = 'init';
            computed = this.match('[');
            key = this.parseObjectPropertyKey();
            value = this.parseGeneratorMethod();
            method = true;
          }
          if (!kind && key && this.match('(')) {
            kind = 'init';
            value = isAsync ? this.parsePropertyMethodAsyncFunction() : this.parsePropertyMethodFunction();
            method = true;
          }
          if (!kind) {
            this.throwUnexpectedToken(this.lookahead);
          }
          if (kind === 'init') {
            kind = 'method';
          }
          if (!computed) {
            if (isStatic && this.isPropertyKey(key, 'prototype')) {
              this.throwUnexpectedToken(token, messages_1.Messages.StaticPrototype);
            }
            if (!isStatic && this.isPropertyKey(key, 'constructor')) {
              if (kind !== 'method' || !method || value && value.generator) {
                this.throwUnexpectedToken(token, messages_1.Messages.ConstructorSpecialMethod);
              }
              if (hasConstructor.value) {
                this.throwUnexpectedToken(token, messages_1.Messages.DuplicateConstructor);
              } else {
                hasConstructor.value = true;
              }
              kind = 'constructor';
            }
          }
          return this.finalize(node, new Node.MethodDefinition(key, computed, value, kind, isStatic));
        };
        Parser.prototype.parseClassElementList = function () {
          var body = [];
          var hasConstructor = {
            value: false
          };
          this.expect('{');
          while (!this.match('}')) {
            if (this.match(';')) {
              this.nextToken();
            } else {
              body.push(this.parseClassElement(hasConstructor));
            }
          }
          this.expect('}');
          return body;
        };
        Parser.prototype.parseClassBody = function () {
          var node = this.createNode();
          var elementList = this.parseClassElementList();
          return this.finalize(node, new Node.ClassBody(elementList));
        };
        Parser.prototype.parseClassDeclaration = function (identifierIsOptional) {
          var node = this.createNode();
          var previousStrict = this.context.strict;
          this.context.strict = true;
          this.expectKeyword('class');
          var id = identifierIsOptional && this.lookahead.type !== 3 /* Identifier */ ? null : this.parseVariableIdentifier();
          var superClass = null;
          if (this.matchKeyword('extends')) {
            this.nextToken();
            superClass = this.isolateCoverGrammar(this.parseLeftHandSideExpressionAllowCall);
          }
          var classBody = this.parseClassBody();
          this.context.strict = previousStrict;
          return this.finalize(node, new Node.ClassDeclaration(id, superClass, classBody));
        };
        Parser.prototype.parseClassExpression = function () {
          var node = this.createNode();
          var previousStrict = this.context.strict;
          this.context.strict = true;
          this.expectKeyword('class');
          var id = this.lookahead.type === 3 /* Identifier */ ? this.parseVariableIdentifier() : null;
          var superClass = null;
          if (this.matchKeyword('extends')) {
            this.nextToken();
            superClass = this.isolateCoverGrammar(this.parseLeftHandSideExpressionAllowCall);
          }
          var classBody = this.parseClassBody();
          this.context.strict = previousStrict;
          return this.finalize(node, new Node.ClassExpression(id, superClass, classBody));
        };
        // https://tc39.github.io/ecma262/#sec-scripts
        // https://tc39.github.io/ecma262/#sec-modules
        Parser.prototype.parseModule = function () {
          this.context.strict = true;
          this.context.isModule = true;
          this.scanner.isModule = true;
          var node = this.createNode();
          var body = this.parseDirectivePrologues();
          while (this.lookahead.type !== 2 /* EOF */) {
            body.push(this.parseStatementListItem());
          }
          return this.finalize(node, new Node.Module(body));
        };
        Parser.prototype.parseScript = function () {
          var node = this.createNode();
          var body = this.parseDirectivePrologues();
          while (this.lookahead.type !== 2 /* EOF */) {
            body.push(this.parseStatementListItem());
          }
          return this.finalize(node, new Node.Script(body));
        };
        // https://tc39.github.io/ecma262/#sec-imports
        Parser.prototype.parseModuleSpecifier = function () {
          var node = this.createNode();
          if (this.lookahead.type !== 8 /* StringLiteral */) {
            this.throwError(messages_1.Messages.InvalidModuleSpecifier);
          }
          var token = this.nextToken();
          var raw = this.getTokenRaw(token);
          return this.finalize(node, new Node.Literal(token.value, raw));
        };
        // import {<foo as bar>} ...;
        Parser.prototype.parseImportSpecifier = function () {
          var node = this.createNode();
          var imported;
          var local;
          if (this.lookahead.type === 3 /* Identifier */) {
            imported = this.parseVariableIdentifier();
            local = imported;
            if (this.matchContextualKeyword('as')) {
              this.nextToken();
              local = this.parseVariableIdentifier();
            }
          } else {
            imported = this.parseIdentifierName();
            local = imported;
            if (this.matchContextualKeyword('as')) {
              this.nextToken();
              local = this.parseVariableIdentifier();
            } else {
              this.throwUnexpectedToken(this.nextToken());
            }
          }
          return this.finalize(node, new Node.ImportSpecifier(local, imported));
        };
        // {foo, bar as bas}
        Parser.prototype.parseNamedImports = function () {
          this.expect('{');
          var specifiers = [];
          while (!this.match('}')) {
            specifiers.push(this.parseImportSpecifier());
            if (!this.match('}')) {
              this.expect(',');
            }
          }
          this.expect('}');
          return specifiers;
        };
        // import <foo> ...;
        Parser.prototype.parseImportDefaultSpecifier = function () {
          var node = this.createNode();
          var local = this.parseIdentifierName();
          return this.finalize(node, new Node.ImportDefaultSpecifier(local));
        };
        // import <* as foo> ...;
        Parser.prototype.parseImportNamespaceSpecifier = function () {
          var node = this.createNode();
          this.expect('*');
          if (!this.matchContextualKeyword('as')) {
            this.throwError(messages_1.Messages.NoAsAfterImportNamespace);
          }
          this.nextToken();
          var local = this.parseIdentifierName();
          return this.finalize(node, new Node.ImportNamespaceSpecifier(local));
        };
        Parser.prototype.parseImportDeclaration = function () {
          if (this.context.inFunctionBody) {
            this.throwError(messages_1.Messages.IllegalImportDeclaration);
          }
          var node = this.createNode();
          this.expectKeyword('import');
          var src;
          var specifiers = [];
          if (this.lookahead.type === 8 /* StringLiteral */) {
            // import 'foo';
            src = this.parseModuleSpecifier();
          } else {
            if (this.match('{')) {
              // import {bar}
              specifiers = specifiers.concat(this.parseNamedImports());
            } else if (this.match('*')) {
              // import * as foo
              specifiers.push(this.parseImportNamespaceSpecifier());
            } else if (this.isIdentifierName(this.lookahead) && !this.matchKeyword('default')) {
              // import foo
              specifiers.push(this.parseImportDefaultSpecifier());
              if (this.match(',')) {
                this.nextToken();
                if (this.match('*')) {
                  // import foo, * as foo
                  specifiers.push(this.parseImportNamespaceSpecifier());
                } else if (this.match('{')) {
                  // import foo, {bar}
                  specifiers = specifiers.concat(this.parseNamedImports());
                } else {
                  this.throwUnexpectedToken(this.lookahead);
                }
              }
            } else {
              this.throwUnexpectedToken(this.nextToken());
            }
            if (!this.matchContextualKeyword('from')) {
              var message = this.lookahead.value ? messages_1.Messages.UnexpectedToken : messages_1.Messages.MissingFromClause;
              this.throwError(message, this.lookahead.value);
            }
            this.nextToken();
            src = this.parseModuleSpecifier();
          }
          this.consumeSemicolon();
          return this.finalize(node, new Node.ImportDeclaration(specifiers, src));
        };
        // https://tc39.github.io/ecma262/#sec-exports
        Parser.prototype.parseExportSpecifier = function () {
          var node = this.createNode();
          var local = this.parseIdentifierName();
          var exported = local;
          if (this.matchContextualKeyword('as')) {
            this.nextToken();
            exported = this.parseIdentifierName();
          }
          return this.finalize(node, new Node.ExportSpecifier(local, exported));
        };
        Parser.prototype.parseExportDeclaration = function () {
          if (this.context.inFunctionBody) {
            this.throwError(messages_1.Messages.IllegalExportDeclaration);
          }
          var node = this.createNode();
          this.expectKeyword('export');
          var exportDeclaration;
          if (this.matchKeyword('default')) {
            // export default ...
            this.nextToken();
            if (this.matchKeyword('function')) {
              // export default function foo () {}
              // export default function () {}
              var declaration = this.parseFunctionDeclaration(true);
              exportDeclaration = this.finalize(node, new Node.ExportDefaultDeclaration(declaration));
            } else if (this.matchKeyword('class')) {
              // export default class foo {}
              var declaration = this.parseClassDeclaration(true);
              exportDeclaration = this.finalize(node, new Node.ExportDefaultDeclaration(declaration));
            } else if (this.matchContextualKeyword('async')) {
              // export default async function f () {}
              // export default async function () {}
              // export default async x => x
              var declaration = this.matchAsyncFunction() ? this.parseFunctionDeclaration(true) : this.parseAssignmentExpression();
              exportDeclaration = this.finalize(node, new Node.ExportDefaultDeclaration(declaration));
            } else {
              if (this.matchContextualKeyword('from')) {
                this.throwError(messages_1.Messages.UnexpectedToken, this.lookahead.value);
              }
              // export default {};
              // export default [];
              // export default (1 + 2);
              var declaration = this.match('{') ? this.parseObjectInitializer() : this.match('[') ? this.parseArrayInitializer() : this.parseAssignmentExpression();
              this.consumeSemicolon();
              exportDeclaration = this.finalize(node, new Node.ExportDefaultDeclaration(declaration));
            }
          } else if (this.match('*')) {
            // export * from 'foo';
            this.nextToken();
            if (!this.matchContextualKeyword('from')) {
              var message = this.lookahead.value ? messages_1.Messages.UnexpectedToken : messages_1.Messages.MissingFromClause;
              this.throwError(message, this.lookahead.value);
            }
            this.nextToken();
            var src = this.parseModuleSpecifier();
            this.consumeSemicolon();
            exportDeclaration = this.finalize(node, new Node.ExportAllDeclaration(src));
          } else if (this.lookahead.type === 4 /* Keyword */) {
            // export var f = 1;
            var declaration = void 0;
            switch (this.lookahead.value) {
              case 'let':
              case 'const':
                declaration = this.parseLexicalDeclaration({
                  inFor: false
                });
                break;
              case 'var':
              case 'class':
              case 'function':
                declaration = this.parseStatementListItem();
                break;
              default:
                this.throwUnexpectedToken(this.lookahead);
            }
            exportDeclaration = this.finalize(node, new Node.ExportNamedDeclaration(declaration, [], null));
          } else if (this.matchAsyncFunction()) {
            var declaration = this.parseFunctionDeclaration();
            exportDeclaration = this.finalize(node, new Node.ExportNamedDeclaration(declaration, [], null));
          } else {
            var specifiers = [];
            var source = null;
            var isExportFromIdentifier = false;
            this.expect('{');
            while (!this.match('}')) {
              isExportFromIdentifier = isExportFromIdentifier || this.matchKeyword('default');
              specifiers.push(this.parseExportSpecifier());
              if (!this.match('}')) {
                this.expect(',');
              }
            }
            this.expect('}');
            if (this.matchContextualKeyword('from')) {
              // export {default} from 'foo';
              // export {foo} from 'foo';
              this.nextToken();
              source = this.parseModuleSpecifier();
              this.consumeSemicolon();
            } else if (isExportFromIdentifier) {
              // export {default}; // missing fromClause
              var message = this.lookahead.value ? messages_1.Messages.UnexpectedToken : messages_1.Messages.MissingFromClause;
              this.throwError(message, this.lookahead.value);
            } else {
              // export {foo};
              this.consumeSemicolon();
            }
            exportDeclaration = this.finalize(node, new Node.ExportNamedDeclaration(null, specifiers, source));
          }
          return exportDeclaration;
        };
        return Parser;
      }();
      exports.Parser = Parser;

      /***/
    }, /* 9 */
    /***/function (module, exports) {
      "use strict";

      // Ensure the condition is true, otherwise throw an error.
      // This is only to have a better contract semantic, i.e. another safety net
      // to catch a logic error. The condition shall be fulfilled in normal case.
      // Do NOT use this to enforce a certain condition on any user input.
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      function assert(condition, message) {
        /* istanbul ignore if */
        if (!condition) {
          throw new Error('ASSERT: ' + message);
        }
      }
      exports.assert = assert;

      /***/
    }, /* 10 */
    /***/function (module, exports) {
      "use strict";

      /* tslint:disable:max-classes-per-file */
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var ErrorHandler = function () {
        function ErrorHandler() {
          this.errors = [];
          this.tolerant = false;
        }
        ErrorHandler.prototype.recordError = function (error) {
          this.errors.push(error);
        };
        ErrorHandler.prototype.tolerate = function (error) {
          if (this.tolerant) {
            this.recordError(error);
          } else {
            throw error;
          }
        };
        ErrorHandler.prototype.constructError = function (msg, column) {
          var error = new Error(msg);
          try {
            throw error;
          } catch (base) {
            /* istanbul ignore else */
            if (Object.create && Object.defineProperty) {
              error = Object.create(base);
              Object.defineProperty(error, 'column', {
                value: column
              });
            }
          }
          /* istanbul ignore next */
          return error;
        };
        ErrorHandler.prototype.createError = function (index, line, col, description) {
          var msg = 'Line ' + line + ': ' + description;
          var error = this.constructError(msg, col);
          error.index = index;
          error.lineNumber = line;
          error.description = description;
          return error;
        };
        ErrorHandler.prototype.throwError = function (index, line, col, description) {
          throw this.createError(index, line, col, description);
        };
        ErrorHandler.prototype.tolerateError = function (index, line, col, description) {
          var error = this.createError(index, line, col, description);
          if (this.tolerant) {
            this.recordError(error);
          } else {
            throw error;
          }
        };
        return ErrorHandler;
      }();
      exports.ErrorHandler = ErrorHandler;

      /***/
    }, /* 11 */
    /***/function (module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      // Error messages should be identical to V8.
      exports.Messages = {
        BadGetterArity: 'Getter must not have any formal parameters',
        BadSetterArity: 'Setter must have exactly one formal parameter',
        BadSetterRestParameter: 'Setter function argument must not be a rest parameter',
        ConstructorIsAsync: 'Class constructor may not be an async method',
        ConstructorSpecialMethod: 'Class constructor may not be an accessor',
        DeclarationMissingInitializer: 'Missing initializer in %0 declaration',
        DefaultRestParameter: 'Unexpected token =',
        DuplicateBinding: 'Duplicate binding %0',
        DuplicateConstructor: 'A class may only have one constructor',
        DuplicateProtoProperty: 'Duplicate __proto__ fields are not allowed in object literals',
        ForInOfLoopInitializer: '%0 loop variable declaration may not have an initializer',
        GeneratorInLegacyContext: 'Generator declarations are not allowed in legacy contexts',
        IllegalBreak: 'Illegal break statement',
        IllegalContinue: 'Illegal continue statement',
        IllegalExportDeclaration: 'Unexpected token',
        IllegalImportDeclaration: 'Unexpected token',
        IllegalLanguageModeDirective: 'Illegal \'use strict\' directive in function with non-simple parameter list',
        IllegalReturn: 'Illegal return statement',
        InvalidEscapedReservedWord: 'Keyword must not contain escaped characters',
        InvalidHexEscapeSequence: 'Invalid hexadecimal escape sequence',
        InvalidLHSInAssignment: 'Invalid left-hand side in assignment',
        InvalidLHSInForIn: 'Invalid left-hand side in for-in',
        InvalidLHSInForLoop: 'Invalid left-hand side in for-loop',
        InvalidModuleSpecifier: 'Unexpected token',
        InvalidRegExp: 'Invalid regular expression',
        LetInLexicalBinding: 'let is disallowed as a lexically bound name',
        MissingFromClause: 'Unexpected token',
        MultipleDefaultsInSwitch: 'More than one default clause in switch statement',
        NewlineAfterThrow: 'Illegal newline after throw',
        NoAsAfterImportNamespace: 'Unexpected token',
        NoCatchOrFinally: 'Missing catch or finally after try',
        ParameterAfterRestParameter: 'Rest parameter must be last formal parameter',
        Redeclaration: '%0 \'%1\' has already been declared',
        StaticPrototype: 'Classes may not have static property named prototype',
        StrictCatchVariable: 'Catch variable may not be eval or arguments in strict mode',
        StrictDelete: 'Delete of an unqualified identifier in strict mode.',
        StrictFunction: 'In strict mode code, functions can only be declared at top level or inside a block',
        StrictFunctionName: 'Function name may not be eval or arguments in strict mode',
        StrictLHSAssignment: 'Assignment to eval or arguments is not allowed in strict mode',
        StrictLHSPostfix: 'Postfix increment/decrement may not have eval or arguments operand in strict mode',
        StrictLHSPrefix: 'Prefix increment/decrement may not have eval or arguments operand in strict mode',
        StrictModeWith: 'Strict mode code may not include a with statement',
        StrictOctalLiteral: 'Octal literals are not allowed in strict mode.',
        StrictParamDupe: 'Strict mode function may not have duplicate parameter names',
        StrictParamName: 'Parameter name eval or arguments is not allowed in strict mode',
        StrictReservedWord: 'Use of future reserved word in strict mode',
        StrictVarName: 'Variable name may not be eval or arguments in strict mode',
        TemplateOctalLiteral: 'Octal literals are not allowed in template strings.',
        UnexpectedEOS: 'Unexpected end of input',
        UnexpectedIdentifier: 'Unexpected identifier',
        UnexpectedNumber: 'Unexpected number',
        UnexpectedReserved: 'Unexpected reserved word',
        UnexpectedString: 'Unexpected string',
        UnexpectedTemplate: 'Unexpected quasi %0',
        UnexpectedToken: 'Unexpected token %0',
        UnexpectedTokenIllegal: 'Unexpected token ILLEGAL',
        UnknownLabel: 'Undefined label \'%0\'',
        UnterminatedRegExp: 'Invalid regular expression: missing /'
      };

      /***/
    }, /* 12 */
    /***/function (module, exports, __nested_webpack_require_224939__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var assert_1 = __nested_webpack_require_224939__(9);
      var character_1 = __nested_webpack_require_224939__(4);
      var messages_1 = __nested_webpack_require_224939__(11);
      function hexValue(ch) {
        return '0123456789abcdef'.indexOf(ch.toLowerCase());
      }
      function octalValue(ch) {
        return '01234567'.indexOf(ch);
      }
      var Scanner = function () {
        function Scanner(code, handler) {
          this.source = code;
          this.errorHandler = handler;
          this.trackComment = false;
          this.isModule = false;
          this.length = code.length;
          this.index = 0;
          this.lineNumber = code.length > 0 ? 1 : 0;
          this.lineStart = 0;
          this.curlyStack = [];
        }
        Scanner.prototype.saveState = function () {
          return {
            index: this.index,
            lineNumber: this.lineNumber,
            lineStart: this.lineStart
          };
        };
        Scanner.prototype.restoreState = function (state) {
          this.index = state.index;
          this.lineNumber = state.lineNumber;
          this.lineStart = state.lineStart;
        };
        Scanner.prototype.eof = function () {
          return this.index >= this.length;
        };
        Scanner.prototype.throwUnexpectedToken = function (message) {
          if (message === void 0) {
            message = messages_1.Messages.UnexpectedTokenIllegal;
          }
          return this.errorHandler.throwError(this.index, this.lineNumber, this.index - this.lineStart + 1, message);
        };
        Scanner.prototype.tolerateUnexpectedToken = function (message) {
          if (message === void 0) {
            message = messages_1.Messages.UnexpectedTokenIllegal;
          }
          this.errorHandler.tolerateError(this.index, this.lineNumber, this.index - this.lineStart + 1, message);
        };
        // https://tc39.github.io/ecma262/#sec-comments
        Scanner.prototype.skipSingleLineComment = function (offset) {
          var comments = [];
          var start, loc;
          if (this.trackComment) {
            comments = [];
            start = this.index - offset;
            loc = {
              start: {
                line: this.lineNumber,
                column: this.index - this.lineStart - offset
              },
              end: {}
            };
          }
          while (!this.eof()) {
            var ch = this.source.charCodeAt(this.index);
            ++this.index;
            if (character_1.Character.isLineTerminator(ch)) {
              if (this.trackComment) {
                loc.end = {
                  line: this.lineNumber,
                  column: this.index - this.lineStart - 1
                };
                var entry = {
                  multiLine: false,
                  slice: [start + offset, this.index - 1],
                  range: [start, this.index - 1],
                  loc: loc
                };
                comments.push(entry);
              }
              if (ch === 13 && this.source.charCodeAt(this.index) === 10) {
                ++this.index;
              }
              ++this.lineNumber;
              this.lineStart = this.index;
              return comments;
            }
          }
          if (this.trackComment) {
            loc.end = {
              line: this.lineNumber,
              column: this.index - this.lineStart
            };
            var entry = {
              multiLine: false,
              slice: [start + offset, this.index],
              range: [start, this.index],
              loc: loc
            };
            comments.push(entry);
          }
          return comments;
        };
        Scanner.prototype.skipMultiLineComment = function () {
          var comments = [];
          var start, loc;
          if (this.trackComment) {
            comments = [];
            start = this.index - 2;
            loc = {
              start: {
                line: this.lineNumber,
                column: this.index - this.lineStart - 2
              },
              end: {}
            };
          }
          while (!this.eof()) {
            var ch = this.source.charCodeAt(this.index);
            if (character_1.Character.isLineTerminator(ch)) {
              if (ch === 0x0D && this.source.charCodeAt(this.index + 1) === 0x0A) {
                ++this.index;
              }
              ++this.lineNumber;
              ++this.index;
              this.lineStart = this.index;
            } else if (ch === 0x2A) {
              // Block comment ends with '*/'.
              if (this.source.charCodeAt(this.index + 1) === 0x2F) {
                this.index += 2;
                if (this.trackComment) {
                  loc.end = {
                    line: this.lineNumber,
                    column: this.index - this.lineStart
                  };
                  var entry = {
                    multiLine: true,
                    slice: [start + 2, this.index - 2],
                    range: [start, this.index],
                    loc: loc
                  };
                  comments.push(entry);
                }
                return comments;
              }
              ++this.index;
            } else {
              ++this.index;
            }
          }
          // Ran off the end of the file - the whole thing is a comment
          if (this.trackComment) {
            loc.end = {
              line: this.lineNumber,
              column: this.index - this.lineStart
            };
            var entry = {
              multiLine: true,
              slice: [start + 2, this.index],
              range: [start, this.index],
              loc: loc
            };
            comments.push(entry);
          }
          this.tolerateUnexpectedToken();
          return comments;
        };
        Scanner.prototype.scanComments = function () {
          var comments;
          if (this.trackComment) {
            comments = [];
          }
          var start = this.index === 0;
          while (!this.eof()) {
            var ch = this.source.charCodeAt(this.index);
            if (character_1.Character.isWhiteSpace(ch)) {
              ++this.index;
            } else if (character_1.Character.isLineTerminator(ch)) {
              ++this.index;
              if (ch === 0x0D && this.source.charCodeAt(this.index) === 0x0A) {
                ++this.index;
              }
              ++this.lineNumber;
              this.lineStart = this.index;
              start = true;
            } else if (ch === 0x2F) {
              ch = this.source.charCodeAt(this.index + 1);
              if (ch === 0x2F) {
                this.index += 2;
                var comment = this.skipSingleLineComment(2);
                if (this.trackComment) {
                  comments = comments.concat(comment);
                }
                start = true;
              } else if (ch === 0x2A) {
                this.index += 2;
                var comment = this.skipMultiLineComment();
                if (this.trackComment) {
                  comments = comments.concat(comment);
                }
              } else {
                break;
              }
            } else if (start && ch === 0x2D) {
              // U+003E is '>'
              if (this.source.charCodeAt(this.index + 1) === 0x2D && this.source.charCodeAt(this.index + 2) === 0x3E) {
                // '-->' is a single-line comment
                this.index += 3;
                var comment = this.skipSingleLineComment(3);
                if (this.trackComment) {
                  comments = comments.concat(comment);
                }
              } else {
                break;
              }
            } else if (ch === 0x3C && !this.isModule) {
              if (this.source.slice(this.index + 1, this.index + 4) === '!--') {
                this.index += 4; // `<!--`
                var comment = this.skipSingleLineComment(4);
                if (this.trackComment) {
                  comments = comments.concat(comment);
                }
              } else {
                break;
              }
            } else {
              break;
            }
          }
          return comments;
        };
        // https://tc39.github.io/ecma262/#sec-future-reserved-words
        Scanner.prototype.isFutureReservedWord = function (id) {
          switch (id) {
            case 'enum':
            case 'export':
            case 'import':
            case 'super':
              return true;
            default:
              return false;
          }
        };
        Scanner.prototype.isStrictModeReservedWord = function (id) {
          switch (id) {
            case 'implements':
            case 'interface':
            case 'package':
            case 'private':
            case 'protected':
            case 'public':
            case 'static':
            case 'yield':
            case 'let':
              return true;
            default:
              return false;
          }
        };
        Scanner.prototype.isRestrictedWord = function (id) {
          return id === 'eval' || id === 'arguments';
        };
        // https://tc39.github.io/ecma262/#sec-keywords
        Scanner.prototype.isKeyword = function (id) {
          switch (id.length) {
            case 2:
              return id === 'if' || id === 'in' || id === 'do';
            case 3:
              return id === 'var' || id === 'for' || id === 'new' || id === 'try' || id === 'let';
            case 4:
              return id === 'this' || id === 'else' || id === 'case' || id === 'void' || id === 'with' || id === 'enum';
            case 5:
              return id === 'while' || id === 'break' || id === 'catch' || id === 'throw' || id === 'const' || id === 'yield' || id === 'class' || id === 'super';
            case 6:
              return id === 'return' || id === 'typeof' || id === 'delete' || id === 'switch' || id === 'export' || id === 'import';
            case 7:
              return id === 'default' || id === 'finally' || id === 'extends';
            case 8:
              return id === 'function' || id === 'continue' || id === 'debugger';
            case 10:
              return id === 'instanceof';
            default:
              return false;
          }
        };
        Scanner.prototype.codePointAt = function (i) {
          var cp = this.source.charCodeAt(i);
          if (cp >= 0xD800 && cp <= 0xDBFF) {
            var second = this.source.charCodeAt(i + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
              var first = cp;
              cp = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            }
          }
          return cp;
        };
        Scanner.prototype.scanHexEscape = function (prefix) {
          var len = prefix === 'u' ? 4 : 2;
          var code = 0;
          for (var i = 0; i < len; ++i) {
            if (!this.eof() && character_1.Character.isHexDigit(this.source.charCodeAt(this.index))) {
              code = code * 16 + hexValue(this.source[this.index++]);
            } else {
              return null;
            }
          }
          return String.fromCharCode(code);
        };
        Scanner.prototype.scanUnicodeCodePointEscape = function () {
          var ch = this.source[this.index];
          var code = 0;
          // At least, one hex digit is required.
          if (ch === '}') {
            this.throwUnexpectedToken();
          }
          while (!this.eof()) {
            ch = this.source[this.index++];
            if (!character_1.Character.isHexDigit(ch.charCodeAt(0))) {
              break;
            }
            code = code * 16 + hexValue(ch);
          }
          if (code > 0x10FFFF || ch !== '}') {
            this.throwUnexpectedToken();
          }
          return character_1.Character.fromCodePoint(code);
        };
        Scanner.prototype.getIdentifier = function () {
          var start = this.index++;
          while (!this.eof()) {
            var ch = this.source.charCodeAt(this.index);
            if (ch === 0x5C) {
              // Blackslash (U+005C) marks Unicode escape sequence.
              this.index = start;
              return this.getComplexIdentifier();
            } else if (ch >= 0xD800 && ch < 0xDFFF) {
              // Need to handle surrogate pairs.
              this.index = start;
              return this.getComplexIdentifier();
            }
            if (character_1.Character.isIdentifierPart(ch)) {
              ++this.index;
            } else {
              break;
            }
          }
          return this.source.slice(start, this.index);
        };
        Scanner.prototype.getComplexIdentifier = function () {
          var cp = this.codePointAt(this.index);
          var id = character_1.Character.fromCodePoint(cp);
          this.index += id.length;
          // '\u' (U+005C, U+0075) denotes an escaped character.
          var ch;
          if (cp === 0x5C) {
            if (this.source.charCodeAt(this.index) !== 0x75) {
              this.throwUnexpectedToken();
            }
            ++this.index;
            if (this.source[this.index] === '{') {
              ++this.index;
              ch = this.scanUnicodeCodePointEscape();
            } else {
              ch = this.scanHexEscape('u');
              if (ch === null || ch === '\\' || !character_1.Character.isIdentifierStart(ch.charCodeAt(0))) {
                this.throwUnexpectedToken();
              }
            }
            id = ch;
          }
          while (!this.eof()) {
            cp = this.codePointAt(this.index);
            if (!character_1.Character.isIdentifierPart(cp)) {
              break;
            }
            ch = character_1.Character.fromCodePoint(cp);
            id += ch;
            this.index += ch.length;
            // '\u' (U+005C, U+0075) denotes an escaped character.
            if (cp === 0x5C) {
              id = id.substr(0, id.length - 1);
              if (this.source.charCodeAt(this.index) !== 0x75) {
                this.throwUnexpectedToken();
              }
              ++this.index;
              if (this.source[this.index] === '{') {
                ++this.index;
                ch = this.scanUnicodeCodePointEscape();
              } else {
                ch = this.scanHexEscape('u');
                if (ch === null || ch === '\\' || !character_1.Character.isIdentifierPart(ch.charCodeAt(0))) {
                  this.throwUnexpectedToken();
                }
              }
              id += ch;
            }
          }
          return id;
        };
        Scanner.prototype.octalToDecimal = function (ch) {
          // \0 is not octal escape sequence
          var octal = ch !== '0';
          var code = octalValue(ch);
          if (!this.eof() && character_1.Character.isOctalDigit(this.source.charCodeAt(this.index))) {
            octal = true;
            code = code * 8 + octalValue(this.source[this.index++]);
            // 3 digits are only allowed when string starts
            // with 0, 1, 2, 3
            if ('0123'.indexOf(ch) >= 0 && !this.eof() && character_1.Character.isOctalDigit(this.source.charCodeAt(this.index))) {
              code = code * 8 + octalValue(this.source[this.index++]);
            }
          }
          return {
            code: code,
            octal: octal
          };
        };
        // https://tc39.github.io/ecma262/#sec-names-and-keywords
        Scanner.prototype.scanIdentifier = function () {
          var type;
          var start = this.index;
          // Backslash (U+005C) starts an escaped character.
          var id = this.source.charCodeAt(start) === 0x5C ? this.getComplexIdentifier() : this.getIdentifier();
          // There is no keyword or literal with only one character.
          // Thus, it must be an identifier.
          if (id.length === 1) {
            type = 3 /* Identifier */;
          } else if (this.isKeyword(id)) {
            type = 4 /* Keyword */;
          } else if (id === 'null') {
            type = 5 /* NullLiteral */;
          } else if (id === 'true' || id === 'false') {
            type = 1 /* BooleanLiteral */;
          } else {
            type = 3 /* Identifier */;
          }

          if (type !== 3 /* Identifier */ && start + id.length !== this.index) {
            var restore = this.index;
            this.index = start;
            this.tolerateUnexpectedToken(messages_1.Messages.InvalidEscapedReservedWord);
            this.index = restore;
          }
          return {
            type: type,
            value: id,
            lineNumber: this.lineNumber,
            lineStart: this.lineStart,
            start: start,
            end: this.index
          };
        };
        // https://tc39.github.io/ecma262/#sec-punctuators
        Scanner.prototype.scanPunctuator = function () {
          var start = this.index;
          // Check for most common single-character punctuators.
          var str = this.source[this.index];
          switch (str) {
            case '(':
            case '{':
              if (str === '{') {
                this.curlyStack.push('{');
              }
              ++this.index;
              break;
            case '.':
              ++this.index;
              if (this.source[this.index] === '.' && this.source[this.index + 1] === '.') {
                // Spread operator: ...
                this.index += 2;
                str = '...';
              }
              break;
            case '}':
              ++this.index;
              this.curlyStack.pop();
              break;
            case ')':
            case ';':
            case ',':
            case '[':
            case ']':
            case ':':
            case '?':
            case '~':
              ++this.index;
              break;
            default:
              // 4-character punctuator.
              str = this.source.substr(this.index, 4);
              if (str === '>>>=') {
                this.index += 4;
              } else {
                // 3-character punctuators.
                str = str.substr(0, 3);
                if (str === '===' || str === '!==' || str === '>>>' || str === '<<=' || str === '>>=' || str === '**=') {
                  this.index += 3;
                } else {
                  // 2-character punctuators.
                  str = str.substr(0, 2);
                  if (str === '&&' || str === '||' || str === '==' || str === '!=' || str === '+=' || str === '-=' || str === '*=' || str === '/=' || str === '++' || str === '--' || str === '<<' || str === '>>' || str === '&=' || str === '|=' || str === '^=' || str === '%=' || str === '<=' || str === '>=' || str === '=>' || str === '**') {
                    this.index += 2;
                  } else {
                    // 1-character punctuators.
                    str = this.source[this.index];
                    if ('<>=!+-*%&|^/'.indexOf(str) >= 0) {
                      ++this.index;
                    }
                  }
                }
              }
          }
          if (this.index === start) {
            this.throwUnexpectedToken();
          }
          return {
            type: 7 /* Punctuator */,
            value: str,
            lineNumber: this.lineNumber,
            lineStart: this.lineStart,
            start: start,
            end: this.index
          };
        };
        // https://tc39.github.io/ecma262/#sec-literals-numeric-literals
        Scanner.prototype.scanHexLiteral = function (start) {
          var num = '';
          while (!this.eof()) {
            if (!character_1.Character.isHexDigit(this.source.charCodeAt(this.index))) {
              break;
            }
            num += this.source[this.index++];
          }
          if (num.length === 0) {
            this.throwUnexpectedToken();
          }
          if (character_1.Character.isIdentifierStart(this.source.charCodeAt(this.index))) {
            this.throwUnexpectedToken();
          }
          return {
            type: 6 /* NumericLiteral */,
            value: parseInt('0x' + num, 16),
            lineNumber: this.lineNumber,
            lineStart: this.lineStart,
            start: start,
            end: this.index
          };
        };
        Scanner.prototype.scanBinaryLiteral = function (start) {
          var num = '';
          var ch;
          while (!this.eof()) {
            ch = this.source[this.index];
            if (ch !== '0' && ch !== '1') {
              break;
            }
            num += this.source[this.index++];
          }
          if (num.length === 0) {
            // only 0b or 0B
            this.throwUnexpectedToken();
          }
          if (!this.eof()) {
            ch = this.source.charCodeAt(this.index);
            /* istanbul ignore else */
            if (character_1.Character.isIdentifierStart(ch) || character_1.Character.isDecimalDigit(ch)) {
              this.throwUnexpectedToken();
            }
          }
          return {
            type: 6 /* NumericLiteral */,
            value: parseInt(num, 2),
            lineNumber: this.lineNumber,
            lineStart: this.lineStart,
            start: start,
            end: this.index
          };
        };
        Scanner.prototype.scanOctalLiteral = function (prefix, start) {
          var num = '';
          var octal = false;
          if (character_1.Character.isOctalDigit(prefix.charCodeAt(0))) {
            octal = true;
            num = '0' + this.source[this.index++];
          } else {
            ++this.index;
          }
          while (!this.eof()) {
            if (!character_1.Character.isOctalDigit(this.source.charCodeAt(this.index))) {
              break;
            }
            num += this.source[this.index++];
          }
          if (!octal && num.length === 0) {
            // only 0o or 0O
            this.throwUnexpectedToken();
          }
          if (character_1.Character.isIdentifierStart(this.source.charCodeAt(this.index)) || character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
            this.throwUnexpectedToken();
          }
          return {
            type: 6 /* NumericLiteral */,
            value: parseInt(num, 8),
            octal: octal,
            lineNumber: this.lineNumber,
            lineStart: this.lineStart,
            start: start,
            end: this.index
          };
        };
        Scanner.prototype.isImplicitOctalLiteral = function () {
          // Implicit octal, unless there is a non-octal digit.
          // (Annex B.1.1 on Numeric Literals)
          for (var i = this.index + 1; i < this.length; ++i) {
            var ch = this.source[i];
            if (ch === '8' || ch === '9') {
              return false;
            }
            if (!character_1.Character.isOctalDigit(ch.charCodeAt(0))) {
              return true;
            }
          }
          return true;
        };
        Scanner.prototype.scanNumericLiteral = function () {
          var start = this.index;
          var ch = this.source[start];
          assert_1.assert(character_1.Character.isDecimalDigit(ch.charCodeAt(0)) || ch === '.', 'Numeric literal must start with a decimal digit or a decimal point');
          var num = '';
          if (ch !== '.') {
            num = this.source[this.index++];
            ch = this.source[this.index];
            // Hex number starts with '0x'.
            // Octal number starts with '0'.
            // Octal number in ES6 starts with '0o'.
            // Binary number in ES6 starts with '0b'.
            if (num === '0') {
              if (ch === 'x' || ch === 'X') {
                ++this.index;
                return this.scanHexLiteral(start);
              }
              if (ch === 'b' || ch === 'B') {
                ++this.index;
                return this.scanBinaryLiteral(start);
              }
              if (ch === 'o' || ch === 'O') {
                return this.scanOctalLiteral(ch, start);
              }
              if (ch && character_1.Character.isOctalDigit(ch.charCodeAt(0))) {
                if (this.isImplicitOctalLiteral()) {
                  return this.scanOctalLiteral(ch, start);
                }
              }
            }
            while (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
              num += this.source[this.index++];
            }
            ch = this.source[this.index];
          }
          if (ch === '.') {
            num += this.source[this.index++];
            while (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
              num += this.source[this.index++];
            }
            ch = this.source[this.index];
          }
          if (ch === 'e' || ch === 'E') {
            num += this.source[this.index++];
            ch = this.source[this.index];
            if (ch === '+' || ch === '-') {
              num += this.source[this.index++];
            }
            if (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
              while (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
                num += this.source[this.index++];
              }
            } else {
              this.throwUnexpectedToken();
            }
          }
          if (character_1.Character.isIdentifierStart(this.source.charCodeAt(this.index))) {
            this.throwUnexpectedToken();
          }
          return {
            type: 6 /* NumericLiteral */,
            value: parseFloat(num),
            lineNumber: this.lineNumber,
            lineStart: this.lineStart,
            start: start,
            end: this.index
          };
        };
        // https://tc39.github.io/ecma262/#sec-literals-string-literals
        Scanner.prototype.scanStringLiteral = function () {
          var start = this.index;
          var quote = this.source[start];
          assert_1.assert(quote === '\'' || quote === '"', 'String literal must starts with a quote');
          ++this.index;
          var octal = false;
          var str = '';
          while (!this.eof()) {
            var ch = this.source[this.index++];
            if (ch === quote) {
              quote = '';
              break;
            } else if (ch === '\\') {
              ch = this.source[this.index++];
              if (!ch || !character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
                switch (ch) {
                  case 'u':
                    if (this.source[this.index] === '{') {
                      ++this.index;
                      str += this.scanUnicodeCodePointEscape();
                    } else {
                      var unescaped_1 = this.scanHexEscape(ch);
                      if (unescaped_1 === null) {
                        this.throwUnexpectedToken();
                      }
                      str += unescaped_1;
                    }
                    break;
                  case 'x':
                    var unescaped = this.scanHexEscape(ch);
                    if (unescaped === null) {
                      this.throwUnexpectedToken(messages_1.Messages.InvalidHexEscapeSequence);
                    }
                    str += unescaped;
                    break;
                  case 'n':
                    str += '\n';
                    break;
                  case 'r':
                    str += '\r';
                    break;
                  case 't':
                    str += '\t';
                    break;
                  case 'b':
                    str += '\b';
                    break;
                  case 'f':
                    str += '\f';
                    break;
                  case 'v':
                    str += '\x0B';
                    break;
                  case '8':
                  case '9':
                    str += ch;
                    this.tolerateUnexpectedToken();
                    break;
                  default:
                    if (ch && character_1.Character.isOctalDigit(ch.charCodeAt(0))) {
                      var octToDec = this.octalToDecimal(ch);
                      octal = octToDec.octal || octal;
                      str += String.fromCharCode(octToDec.code);
                    } else {
                      str += ch;
                    }
                    break;
                }
              } else {
                ++this.lineNumber;
                if (ch === '\r' && this.source[this.index] === '\n') {
                  ++this.index;
                }
                this.lineStart = this.index;
              }
            } else if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
              break;
            } else {
              str += ch;
            }
          }
          if (quote !== '') {
            this.index = start;
            this.throwUnexpectedToken();
          }
          return {
            type: 8 /* StringLiteral */,
            value: str,
            octal: octal,
            lineNumber: this.lineNumber,
            lineStart: this.lineStart,
            start: start,
            end: this.index
          };
        };
        // https://tc39.github.io/ecma262/#sec-template-literal-lexical-components
        Scanner.prototype.scanTemplate = function () {
          var cooked = '';
          var terminated = false;
          var start = this.index;
          var head = this.source[start] === '`';
          var tail = false;
          var rawOffset = 2;
          ++this.index;
          while (!this.eof()) {
            var ch = this.source[this.index++];
            if (ch === '`') {
              rawOffset = 1;
              tail = true;
              terminated = true;
              break;
            } else if (ch === '$') {
              if (this.source[this.index] === '{') {
                this.curlyStack.push('${');
                ++this.index;
                terminated = true;
                break;
              }
              cooked += ch;
            } else if (ch === '\\') {
              ch = this.source[this.index++];
              if (!character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
                switch (ch) {
                  case 'n':
                    cooked += '\n';
                    break;
                  case 'r':
                    cooked += '\r';
                    break;
                  case 't':
                    cooked += '\t';
                    break;
                  case 'u':
                    if (this.source[this.index] === '{') {
                      ++this.index;
                      cooked += this.scanUnicodeCodePointEscape();
                    } else {
                      var restore = this.index;
                      var unescaped_2 = this.scanHexEscape(ch);
                      if (unescaped_2 !== null) {
                        cooked += unescaped_2;
                      } else {
                        this.index = restore;
                        cooked += ch;
                      }
                    }
                    break;
                  case 'x':
                    var unescaped = this.scanHexEscape(ch);
                    if (unescaped === null) {
                      this.throwUnexpectedToken(messages_1.Messages.InvalidHexEscapeSequence);
                    }
                    cooked += unescaped;
                    break;
                  case 'b':
                    cooked += '\b';
                    break;
                  case 'f':
                    cooked += '\f';
                    break;
                  case 'v':
                    cooked += '\v';
                    break;
                  default:
                    if (ch === '0') {
                      if (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
                        // Illegal: \01 \02 and so on
                        this.throwUnexpectedToken(messages_1.Messages.TemplateOctalLiteral);
                      }
                      cooked += '\0';
                    } else if (character_1.Character.isOctalDigit(ch.charCodeAt(0))) {
                      // Illegal: \1 \2
                      this.throwUnexpectedToken(messages_1.Messages.TemplateOctalLiteral);
                    } else {
                      cooked += ch;
                    }
                    break;
                }
              } else {
                ++this.lineNumber;
                if (ch === '\r' && this.source[this.index] === '\n') {
                  ++this.index;
                }
                this.lineStart = this.index;
              }
            } else if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
              ++this.lineNumber;
              if (ch === '\r' && this.source[this.index] === '\n') {
                ++this.index;
              }
              this.lineStart = this.index;
              cooked += '\n';
            } else {
              cooked += ch;
            }
          }
          if (!terminated) {
            this.throwUnexpectedToken();
          }
          if (!head) {
            this.curlyStack.pop();
          }
          return {
            type: 10 /* Template */,
            value: this.source.slice(start + 1, this.index - rawOffset),
            cooked: cooked,
            head: head,
            tail: tail,
            lineNumber: this.lineNumber,
            lineStart: this.lineStart,
            start: start,
            end: this.index
          };
        };
        // https://tc39.github.io/ecma262/#sec-literals-regular-expression-literals
        Scanner.prototype.testRegExp = function (pattern, flags) {
          // The BMP character to use as a replacement for astral symbols when
          // translating an ES6 "u"-flagged pattern to an ES5-compatible
          // approximation.
          // Note: replacing with '\uFFFF' enables false positives in unlikely
          // scenarios. For example, `[\u{1044f}-\u{10440}]` is an invalid
          // pattern that would not be detected by this substitution.
          var astralSubstitute = '\uFFFF';
          var tmp = pattern;
          var self = this;
          if (flags.indexOf('u') >= 0) {
            tmp = tmp.replace(/\\u\{([0-9a-fA-F]+)\}|\\u([a-fA-F0-9]{4})/g, function ($0, $1, $2) {
              var codePoint = parseInt($1 || $2, 16);
              if (codePoint > 0x10FFFF) {
                self.throwUnexpectedToken(messages_1.Messages.InvalidRegExp);
              }
              if (codePoint <= 0xFFFF) {
                return String.fromCharCode(codePoint);
              }
              return astralSubstitute;
            }).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, astralSubstitute);
          }
          // First, detect invalid regular expressions.
          try {
            RegExp(tmp);
          } catch (e) {
            this.throwUnexpectedToken(messages_1.Messages.InvalidRegExp);
          }
          // Return a regular expression object for this pattern-flag pair, or
          // `null` in case the current environment doesn't support the flags it
          // uses.
          try {
            return new RegExp(pattern, flags);
          } catch (exception) {
            /* istanbul ignore next */
            return null;
          }
        };
        Scanner.prototype.scanRegExpBody = function () {
          var ch = this.source[this.index];
          assert_1.assert(ch === '/', 'Regular expression literal must start with a slash');
          var str = this.source[this.index++];
          var classMarker = false;
          var terminated = false;
          while (!this.eof()) {
            ch = this.source[this.index++];
            str += ch;
            if (ch === '\\') {
              ch = this.source[this.index++];
              // https://tc39.github.io/ecma262/#sec-literals-regular-expression-literals
              if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
                this.throwUnexpectedToken(messages_1.Messages.UnterminatedRegExp);
              }
              str += ch;
            } else if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
              this.throwUnexpectedToken(messages_1.Messages.UnterminatedRegExp);
            } else if (classMarker) {
              if (ch === ']') {
                classMarker = false;
              }
            } else {
              if (ch === '/') {
                terminated = true;
                break;
              } else if (ch === '[') {
                classMarker = true;
              }
            }
          }
          if (!terminated) {
            this.throwUnexpectedToken(messages_1.Messages.UnterminatedRegExp);
          }
          // Exclude leading and trailing slash.
          return str.substr(1, str.length - 2);
        };
        Scanner.prototype.scanRegExpFlags = function () {
          var str = '';
          var flags = '';
          while (!this.eof()) {
            var ch = this.source[this.index];
            if (!character_1.Character.isIdentifierPart(ch.charCodeAt(0))) {
              break;
            }
            ++this.index;
            if (ch === '\\' && !this.eof()) {
              ch = this.source[this.index];
              if (ch === 'u') {
                ++this.index;
                var restore = this.index;
                var char = this.scanHexEscape('u');
                if (char !== null) {
                  flags += char;
                  for (str += '\\u'; restore < this.index; ++restore) {
                    str += this.source[restore];
                  }
                } else {
                  this.index = restore;
                  flags += 'u';
                  str += '\\u';
                }
                this.tolerateUnexpectedToken();
              } else {
                str += '\\';
                this.tolerateUnexpectedToken();
              }
            } else {
              flags += ch;
              str += ch;
            }
          }
          return flags;
        };
        Scanner.prototype.scanRegExp = function () {
          var start = this.index;
          var pattern = this.scanRegExpBody();
          var flags = this.scanRegExpFlags();
          var value = this.testRegExp(pattern, flags);
          return {
            type: 9 /* RegularExpression */,
            value: '',
            pattern: pattern,
            flags: flags,
            regex: value,
            lineNumber: this.lineNumber,
            lineStart: this.lineStart,
            start: start,
            end: this.index
          };
        };
        Scanner.prototype.lex = function () {
          if (this.eof()) {
            return {
              type: 2 /* EOF */,
              value: '',
              lineNumber: this.lineNumber,
              lineStart: this.lineStart,
              start: this.index,
              end: this.index
            };
          }
          var cp = this.source.charCodeAt(this.index);
          if (character_1.Character.isIdentifierStart(cp)) {
            return this.scanIdentifier();
          }
          // Very common: ( and ) and ;
          if (cp === 0x28 || cp === 0x29 || cp === 0x3B) {
            return this.scanPunctuator();
          }
          // String literal starts with single quote (U+0027) or double quote (U+0022).
          if (cp === 0x27 || cp === 0x22) {
            return this.scanStringLiteral();
          }
          // Dot (.) U+002E can also start a floating-point number, hence the need
          // to check the next character.
          if (cp === 0x2E) {
            if (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index + 1))) {
              return this.scanNumericLiteral();
            }
            return this.scanPunctuator();
          }
          if (character_1.Character.isDecimalDigit(cp)) {
            return this.scanNumericLiteral();
          }
          // Template literals start with ` (U+0060) for template head
          // or } (U+007D) for template middle or template tail.
          if (cp === 0x60 || cp === 0x7D && this.curlyStack[this.curlyStack.length - 1] === '${') {
            return this.scanTemplate();
          }
          // Possible identifier start in a surrogate pair.
          if (cp >= 0xD800 && cp < 0xDFFF) {
            if (character_1.Character.isIdentifierStart(this.codePointAt(this.index))) {
              return this.scanIdentifier();
            }
          }
          return this.scanPunctuator();
        };
        return Scanner;
      }();
      exports.Scanner = Scanner;

      /***/
    }, /* 13 */
    /***/function (module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.TokenName = {};
      exports.TokenName[1 /* BooleanLiteral */] = 'Boolean';
      exports.TokenName[2 /* EOF */] = '<end>';
      exports.TokenName[3 /* Identifier */] = 'Identifier';
      exports.TokenName[4 /* Keyword */] = 'Keyword';
      exports.TokenName[5 /* NullLiteral */] = 'Null';
      exports.TokenName[6 /* NumericLiteral */] = 'Numeric';
      exports.TokenName[7 /* Punctuator */] = 'Punctuator';
      exports.TokenName[8 /* StringLiteral */] = 'String';
      exports.TokenName[9 /* RegularExpression */] = 'RegularExpression';
      exports.TokenName[10 /* Template */] = 'Template';

      /***/
    }, /* 14 */
    /***/function (module, exports) {
      "use strict";

      // Generated by generate-xhtml-entities.js. DO NOT MODIFY!
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.XHTMLEntities = {
        quot: '\u0022',
        amp: '\u0026',
        apos: '\u0027',
        gt: '\u003E',
        nbsp: '\u00A0',
        iexcl: '\u00A1',
        cent: '\u00A2',
        pound: '\u00A3',
        curren: '\u00A4',
        yen: '\u00A5',
        brvbar: '\u00A6',
        sect: '\u00A7',
        uml: '\u00A8',
        copy: '\u00A9',
        ordf: '\u00AA',
        laquo: '\u00AB',
        not: '\u00AC',
        shy: '\u00AD',
        reg: '\u00AE',
        macr: '\u00AF',
        deg: '\u00B0',
        plusmn: '\u00B1',
        sup2: '\u00B2',
        sup3: '\u00B3',
        acute: '\u00B4',
        micro: '\u00B5',
        para: '\u00B6',
        middot: '\u00B7',
        cedil: '\u00B8',
        sup1: '\u00B9',
        ordm: '\u00BA',
        raquo: '\u00BB',
        frac14: '\u00BC',
        frac12: '\u00BD',
        frac34: '\u00BE',
        iquest: '\u00BF',
        Agrave: '\u00C0',
        Aacute: '\u00C1',
        Acirc: '\u00C2',
        Atilde: '\u00C3',
        Auml: '\u00C4',
        Aring: '\u00C5',
        AElig: '\u00C6',
        Ccedil: '\u00C7',
        Egrave: '\u00C8',
        Eacute: '\u00C9',
        Ecirc: '\u00CA',
        Euml: '\u00CB',
        Igrave: '\u00CC',
        Iacute: '\u00CD',
        Icirc: '\u00CE',
        Iuml: '\u00CF',
        ETH: '\u00D0',
        Ntilde: '\u00D1',
        Ograve: '\u00D2',
        Oacute: '\u00D3',
        Ocirc: '\u00D4',
        Otilde: '\u00D5',
        Ouml: '\u00D6',
        times: '\u00D7',
        Oslash: '\u00D8',
        Ugrave: '\u00D9',
        Uacute: '\u00DA',
        Ucirc: '\u00DB',
        Uuml: '\u00DC',
        Yacute: '\u00DD',
        THORN: '\u00DE',
        szlig: '\u00DF',
        agrave: '\u00E0',
        aacute: '\u00E1',
        acirc: '\u00E2',
        atilde: '\u00E3',
        auml: '\u00E4',
        aring: '\u00E5',
        aelig: '\u00E6',
        ccedil: '\u00E7',
        egrave: '\u00E8',
        eacute: '\u00E9',
        ecirc: '\u00EA',
        euml: '\u00EB',
        igrave: '\u00EC',
        iacute: '\u00ED',
        icirc: '\u00EE',
        iuml: '\u00EF',
        eth: '\u00F0',
        ntilde: '\u00F1',
        ograve: '\u00F2',
        oacute: '\u00F3',
        ocirc: '\u00F4',
        otilde: '\u00F5',
        ouml: '\u00F6',
        divide: '\u00F7',
        oslash: '\u00F8',
        ugrave: '\u00F9',
        uacute: '\u00FA',
        ucirc: '\u00FB',
        uuml: '\u00FC',
        yacute: '\u00FD',
        thorn: '\u00FE',
        yuml: '\u00FF',
        OElig: '\u0152',
        oelig: '\u0153',
        Scaron: '\u0160',
        scaron: '\u0161',
        Yuml: '\u0178',
        fnof: '\u0192',
        circ: '\u02C6',
        tilde: '\u02DC',
        Alpha: '\u0391',
        Beta: '\u0392',
        Gamma: '\u0393',
        Delta: '\u0394',
        Epsilon: '\u0395',
        Zeta: '\u0396',
        Eta: '\u0397',
        Theta: '\u0398',
        Iota: '\u0399',
        Kappa: '\u039A',
        Lambda: '\u039B',
        Mu: '\u039C',
        Nu: '\u039D',
        Xi: '\u039E',
        Omicron: '\u039F',
        Pi: '\u03A0',
        Rho: '\u03A1',
        Sigma: '\u03A3',
        Tau: '\u03A4',
        Upsilon: '\u03A5',
        Phi: '\u03A6',
        Chi: '\u03A7',
        Psi: '\u03A8',
        Omega: '\u03A9',
        alpha: '\u03B1',
        beta: '\u03B2',
        gamma: '\u03B3',
        delta: '\u03B4',
        epsilon: '\u03B5',
        zeta: '\u03B6',
        eta: '\u03B7',
        theta: '\u03B8',
        iota: '\u03B9',
        kappa: '\u03BA',
        lambda: '\u03BB',
        mu: '\u03BC',
        nu: '\u03BD',
        xi: '\u03BE',
        omicron: '\u03BF',
        pi: '\u03C0',
        rho: '\u03C1',
        sigmaf: '\u03C2',
        sigma: '\u03C3',
        tau: '\u03C4',
        upsilon: '\u03C5',
        phi: '\u03C6',
        chi: '\u03C7',
        psi: '\u03C8',
        omega: '\u03C9',
        thetasym: '\u03D1',
        upsih: '\u03D2',
        piv: '\u03D6',
        ensp: '\u2002',
        emsp: '\u2003',
        thinsp: '\u2009',
        zwnj: '\u200C',
        zwj: '\u200D',
        lrm: '\u200E',
        rlm: '\u200F',
        ndash: '\u2013',
        mdash: '\u2014',
        lsquo: '\u2018',
        rsquo: '\u2019',
        sbquo: '\u201A',
        ldquo: '\u201C',
        rdquo: '\u201D',
        bdquo: '\u201E',
        dagger: '\u2020',
        Dagger: '\u2021',
        bull: '\u2022',
        hellip: '\u2026',
        permil: '\u2030',
        prime: '\u2032',
        Prime: '\u2033',
        lsaquo: '\u2039',
        rsaquo: '\u203A',
        oline: '\u203E',
        frasl: '\u2044',
        euro: '\u20AC',
        image: '\u2111',
        weierp: '\u2118',
        real: '\u211C',
        trade: '\u2122',
        alefsym: '\u2135',
        larr: '\u2190',
        uarr: '\u2191',
        rarr: '\u2192',
        darr: '\u2193',
        harr: '\u2194',
        crarr: '\u21B5',
        lArr: '\u21D0',
        uArr: '\u21D1',
        rArr: '\u21D2',
        dArr: '\u21D3',
        hArr: '\u21D4',
        forall: '\u2200',
        part: '\u2202',
        exist: '\u2203',
        empty: '\u2205',
        nabla: '\u2207',
        isin: '\u2208',
        notin: '\u2209',
        ni: '\u220B',
        prod: '\u220F',
        sum: '\u2211',
        minus: '\u2212',
        lowast: '\u2217',
        radic: '\u221A',
        prop: '\u221D',
        infin: '\u221E',
        ang: '\u2220',
        and: '\u2227',
        or: '\u2228',
        cap: '\u2229',
        cup: '\u222A',
        int: '\u222B',
        there4: '\u2234',
        sim: '\u223C',
        cong: '\u2245',
        asymp: '\u2248',
        ne: '\u2260',
        equiv: '\u2261',
        le: '\u2264',
        ge: '\u2265',
        sub: '\u2282',
        sup: '\u2283',
        nsub: '\u2284',
        sube: '\u2286',
        supe: '\u2287',
        oplus: '\u2295',
        otimes: '\u2297',
        perp: '\u22A5',
        sdot: '\u22C5',
        lceil: '\u2308',
        rceil: '\u2309',
        lfloor: '\u230A',
        rfloor: '\u230B',
        loz: '\u25CA',
        spades: '\u2660',
        clubs: '\u2663',
        hearts: '\u2665',
        diams: '\u2666',
        lang: '\u27E8',
        rang: '\u27E9'
      };

      /***/
    }, /* 15 */
    /***/function (module, exports, __nested_webpack_require_273181__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var error_handler_1 = __nested_webpack_require_273181__(10);
      var scanner_1 = __nested_webpack_require_273181__(12);
      var token_1 = __nested_webpack_require_273181__(13);
      var Reader = function () {
        function Reader() {
          this.values = [];
          this.curly = this.paren = -1;
        }
        // A function following one of those tokens is an expression.
        Reader.prototype.beforeFunctionExpression = function (t) {
          return ['(', '{', '[', 'in', 'typeof', 'instanceof', 'new', 'return', 'case', 'delete', 'throw', 'void',
          // assignment operators
          '=', '+=', '-=', '*=', '**=', '/=', '%=', '<<=', '>>=', '>>>=', '&=', '|=', '^=', ',',
          // binary/unary operators
          '+', '-', '*', '**', '/', '%', '++', '--', '<<', '>>', '>>>', '&', '|', '^', '!', '~', '&&', '||', '?', ':', '===', '==', '>=', '<=', '<', '>', '!=', '!=='].indexOf(t) >= 0;
        };
        // Determine if forward slash (/) is an operator or part of a regular expression
        // https://github.com/mozilla/sweet.js/wiki/design
        Reader.prototype.isRegexStart = function () {
          var previous = this.values[this.values.length - 1];
          var regex = previous !== null;
          switch (previous) {
            case 'this':
            case ']':
              regex = false;
              break;
            case ')':
              var keyword = this.values[this.paren - 1];
              regex = keyword === 'if' || keyword === 'while' || keyword === 'for' || keyword === 'with';
              break;
            case '}':
              // Dividing a function by anything makes little sense,
              // but we have to check for that.
              regex = false;
              if (this.values[this.curly - 3] === 'function') {
                // Anonymous function, e.g. function(){} /42
                var check = this.values[this.curly - 4];
                regex = check ? !this.beforeFunctionExpression(check) : false;
              } else if (this.values[this.curly - 4] === 'function') {
                // Named function, e.g. function f(){} /42/
                var check = this.values[this.curly - 5];
                regex = check ? !this.beforeFunctionExpression(check) : true;
              }
              break;
            default:
              break;
          }
          return regex;
        };
        Reader.prototype.push = function (token) {
          if (token.type === 7 /* Punctuator */ || token.type === 4 /* Keyword */) {
            if (token.value === '{') {
              this.curly = this.values.length;
            } else if (token.value === '(') {
              this.paren = this.values.length;
            }
            this.values.push(token.value);
          } else {
            this.values.push(null);
          }
        };
        return Reader;
      }();
      var Tokenizer = function () {
        function Tokenizer(code, config) {
          this.errorHandler = new error_handler_1.ErrorHandler();
          this.errorHandler.tolerant = config ? typeof config.tolerant === 'boolean' && config.tolerant : false;
          this.scanner = new scanner_1.Scanner(code, this.errorHandler);
          this.scanner.trackComment = config ? typeof config.comment === 'boolean' && config.comment : false;
          this.trackRange = config ? typeof config.range === 'boolean' && config.range : false;
          this.trackLoc = config ? typeof config.loc === 'boolean' && config.loc : false;
          this.buffer = [];
          this.reader = new Reader();
        }
        Tokenizer.prototype.errors = function () {
          return this.errorHandler.errors;
        };
        Tokenizer.prototype.getNextToken = function () {
          if (this.buffer.length === 0) {
            var comments = this.scanner.scanComments();
            if (this.scanner.trackComment) {
              for (var i = 0; i < comments.length; ++i) {
                var e = comments[i];
                var value = this.scanner.source.slice(e.slice[0], e.slice[1]);
                var comment = {
                  type: e.multiLine ? 'BlockComment' : 'LineComment',
                  value: value
                };
                if (this.trackRange) {
                  comment.range = e.range;
                }
                if (this.trackLoc) {
                  comment.loc = e.loc;
                }
                this.buffer.push(comment);
              }
            }
            if (!this.scanner.eof()) {
              var loc = void 0;
              if (this.trackLoc) {
                loc = {
                  start: {
                    line: this.scanner.lineNumber,
                    column: this.scanner.index - this.scanner.lineStart
                  },
                  end: {}
                };
              }
              var startRegex = this.scanner.source[this.scanner.index] === '/' && this.reader.isRegexStart();
              var token = startRegex ? this.scanner.scanRegExp() : this.scanner.lex();
              this.reader.push(token);
              var entry = {
                type: token_1.TokenName[token.type],
                value: this.scanner.source.slice(token.start, token.end)
              };
              if (this.trackRange) {
                entry.range = [token.start, token.end];
              }
              if (this.trackLoc) {
                loc.end = {
                  line: this.scanner.lineNumber,
                  column: this.scanner.index - this.scanner.lineStart
                };
                entry.loc = loc;
              }
              if (token.type === 9 /* RegularExpression */) {
                var pattern = token.pattern;
                var flags = token.flags;
                entry.regex = {
                  pattern: pattern,
                  flags: flags
                };
              }
              this.buffer.push(entry);
            }
          }
          return this.buffer.shift();
        };
        return Tokenizer;
      }();
      exports.Tokenizer = Tokenizer;

      /***/
    }
    /******/])
  );
});

;

/***/ }),

/***/ 15868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const fs = __webpack_require__(33596);
const sections = __webpack_require__(570);
const defaults = __webpack_require__(18960);
const stringify = __webpack_require__(50809);
const excerpt = __webpack_require__(44225);
const engines = __webpack_require__(86790);
const toFile = __webpack_require__(69927);
const parse = __webpack_require__(62826);
const utils = __webpack_require__(57545);

/**
 * Takes a string or object with `content` property, extracts
 * and parses front-matter from the string, then returns an object
 * with `data`, `content` and other [useful properties](#returned-object).
 *
 * ```js
 * const matter = require('gray-matter');
 * console.log(matter('---\ntitle: Home\n---\nOther stuff'));
 * //=> { data: { title: 'Home'}, content: 'Other stuff' }
 * ```
 * @param {Object|String} `input` String, or object with `content` string
 * @param {Object} `options`
 * @return {Object}
 * @api public
 */

function matter(input, options) {
  if (input === '') {
    return {
      data: {},
      content: input,
      excerpt: '',
      orig: input
    };
  }
  let file = toFile(input);
  const cached = matter.cache[file.content];
  if (!options) {
    if (cached) {
      file = Object.assign({}, cached);
      file.orig = cached.orig;
      return file;
    }

    // only cache if there are no options passed. if we cache when options
    // are passed, we would need to also cache options values, which would
    // negate any performance benefits of caching
    matter.cache[file.content] = file;
  }
  return parseMatter(file, options);
}

/**
 * Parse front matter
 */

function parseMatter(file, options) {
  const opts = defaults(options);
  const open = opts.delimiters[0];
  const close = '\n' + opts.delimiters[1];
  let str = file.content;
  if (opts.language) {
    file.language = opts.language;
  }

  // get the length of the opening delimiter
  const openLen = open.length;
  if (!utils.startsWith(str, open, openLen)) {
    excerpt(file, opts);
    return file;
  }

  // if the next character after the opening delimiter is
  // a character from the delimiter, then it's not a front-
  // matter delimiter
  if (str.charAt(openLen) === open.slice(-1)) {
    return file;
  }

  // strip the opening delimiter
  str = str.slice(openLen);
  const len = str.length;

  // use the language defined after first delimiter, if it exists
  const language = matter.language(str, opts);
  if (language.name) {
    file.language = language.name;
    str = str.slice(language.raw.length);
  }

  // get the index of the closing delimiter
  let closeIndex = str.indexOf(close);
  if (closeIndex === -1) {
    closeIndex = len;
  }

  // get the raw front-matter block
  file.matter = str.slice(0, closeIndex);
  const block = file.matter.replace(/^\s*#[^\n]+/gm, '').trim();
  if (block === '') {
    file.isEmpty = true;
    file.empty = file.content;
    file.data = {};
  } else {
    // create file.data by parsing the raw file.matter block
    file.data = parse(file.language, file.matter, opts);
  }

  // update file.content
  if (closeIndex === len) {
    file.content = '';
  } else {
    file.content = str.slice(closeIndex + close.length);
    if (file.content[0] === '\r') {
      file.content = file.content.slice(1);
    }
    if (file.content[0] === '\n') {
      file.content = file.content.slice(1);
    }
  }
  excerpt(file, opts);
  if (opts.sections === true || typeof opts.section === 'function') {
    sections(file, opts.section);
  }
  return file;
}

/**
 * Expose engines
 */

matter.engines = engines;

/**
 * Stringify an object to YAML or the specified language, and
 * append it to the given string. By default, only YAML and JSON
 * can be stringified. See the [engines](#engines) section to learn
 * how to stringify other languages.
 *
 * ```js
 * console.log(matter.stringify('foo bar baz', {title: 'Home'}));
 * // results in:
 * // ---
 * // title: Home
 * // ---
 * // foo bar baz
 * ```
 * @param {String|Object} `file` The content string to append to stringified front-matter, or a file object with `file.content` string.
 * @param {Object} `data` Front matter to stringify.
 * @param {Object} `options` [Options](#options) to pass to gray-matter and [js-yaml].
 * @return {String} Returns a string created by wrapping stringified yaml with delimiters, and appending that to the given string.
 * @api public
 */

matter.stringify = function (file, data, options) {
  if (typeof file === 'string') file = matter(file, options);
  return stringify(file, data, options);
};

/**
 * Synchronously read a file from the file system and parse
 * front matter. Returns the same object as the [main function](#matter).
 *
 * ```js
 * const file = matter.read('./content/blog-post.md');
 * ```
 * @param {String} `filepath` file path of the file to read.
 * @param {Object} `options` [Options](#options) to pass to gray-matter.
 * @return {Object} Returns [an object](#returned-object) with `data` and `content`
 * @api public
 */

matter.read = function (filepath, options) {
  const str = fs.readFileSync(filepath, 'utf8');
  const file = matter(str, options);
  file.path = filepath;
  return file;
};

/**
 * Returns true if the given `string` has front matter.
 * @param  {String} `string`
 * @param  {Object} `options`
 * @return {Boolean} True if front matter exists.
 * @api public
 */

matter.test = function (str, options) {
  return utils.startsWith(str, defaults(options).delimiters[0]);
};

/**
 * Detect the language to use, if one is defined after the
 * first front-matter delimiter.
 * @param  {String} `string`
 * @param  {Object} `options`
 * @return {Object} Object with `raw` (actual language string), and `name`, the language with whitespace trimmed
 */

matter.language = function (str, options) {
  const opts = defaults(options);
  const open = opts.delimiters[0];
  if (matter.test(str)) {
    str = str.slice(open.length);
  }
  const language = str.slice(0, str.search(/\r?\n/));
  return {
    raw: language,
    name: language ? language.trim() : ''
  };
};

/**
 * Expose `matter`
 */

matter.cache = {};
matter.clearCache = function () {
  matter.cache = {};
};
module.exports = matter;

/***/ }),

/***/ 18960:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const engines = __webpack_require__(86790);
const utils = __webpack_require__(57545);
module.exports = function (options) {
  const opts = Object.assign({}, options);

  // ensure that delimiters are an array
  opts.delimiters = utils.arrayify(opts.delims || opts.delimiters || '---');
  if (opts.delimiters.length === 1) {
    opts.delimiters.push(opts.delimiters[0]);
  }
  opts.language = (opts.language || opts.lang || 'yaml').toLowerCase();
  opts.engines = Object.assign({}, engines, opts.parsers, opts.engines);
  return opts;
};

/***/ }),

/***/ 35699:
/***/ (function(module) {

"use strict";


module.exports = function (name, options) {
  let engine = options.engines[name] || options.engines[aliase(name)];
  if (typeof engine === 'undefined') {
    throw new Error('gray-matter engine "' + name + '" is not registered');
  }
  if (typeof engine === 'function') {
    engine = {
      parse: engine
    };
  }
  return engine;
};
function aliase(name) {
  switch (name.toLowerCase()) {
    case 'js':
    case 'javascript':
      return 'javascript';
    case 'coffee':
    case 'coffeescript':
    case 'cson':
      return 'coffee';
    case 'yaml':
    case 'yml':
      return 'yaml';
    default:
      {
        return name;
      }
  }
}

/***/ }),

/***/ 86790:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const yaml = __webpack_require__(63548);

/**
 * Default engines
 */

const engines = exports = module.exports;

/**
 * YAML
 */

engines.yaml = {
  parse: yaml.safeLoad.bind(yaml),
  stringify: yaml.safeDump.bind(yaml)
};

/**
 * JSON
 */

engines.json = {
  parse: JSON.parse.bind(JSON),
  stringify: function (obj, options) {
    const opts = Object.assign({
      replacer: null,
      space: 2
    }, options);
    return JSON.stringify(obj, opts.replacer, opts.space);
  }
};

/**
 * JavaScript
 */

engines.javascript = {
  parse: function parse(str, options, wrap) {
    /* eslint no-eval: 0 */
    try {
      if (wrap !== false) {
        str = '(function() {\nreturn ' + str.trim() + ';\n}());';
      }
      return eval(str) || {};
    } catch (err) {
      if (wrap !== false && /(unexpected|identifier)/i.test(err.message)) {
        return parse(str, options, false);
      }
      throw new SyntaxError(err);
    }
  },
  stringify: function () {
    throw new Error('stringifying JavaScript is not supported');
  }
};

/***/ }),

/***/ 44225:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const defaults = __webpack_require__(18960);
module.exports = function (file, options) {
  const opts = defaults(options);
  if (file.data == null) {
    file.data = {};
  }
  if (typeof opts.excerpt === 'function') {
    return opts.excerpt(file, opts);
  }
  const sep = file.data.excerpt_separator || opts.excerpt_separator;
  if (sep == null && (opts.excerpt === false || opts.excerpt == null)) {
    return file;
  }
  const delimiter = typeof opts.excerpt === 'string' ? opts.excerpt : sep || opts.delimiters[0];

  // if enabled, get the excerpt defined after front-matter
  const idx = file.content.indexOf(delimiter);
  if (idx !== -1) {
    file.excerpt = file.content.slice(0, idx);
  }
  return file;
};

/***/ }),

/***/ 62826:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const getEngine = __webpack_require__(35699);
const defaults = __webpack_require__(18960);
module.exports = function (language, str, options) {
  const opts = defaults(options);
  const engine = getEngine(language, opts);
  if (typeof engine.parse !== 'function') {
    throw new TypeError('expected "' + language + '.parse" to be a function');
  }
  return engine.parse(str, opts);
};

/***/ }),

/***/ 50809:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const typeOf = __webpack_require__(66158);
const getEngine = __webpack_require__(35699);
const defaults = __webpack_require__(18960);
module.exports = function (file, data, options) {
  if (data == null && options == null) {
    switch (typeOf(file)) {
      case 'object':
        data = file.data;
        options = {};
        break;
      case 'string':
        return file;
      default:
        {
          throw new TypeError('expected file to be a string or object');
        }
    }
  }
  const str = file.content;
  const opts = defaults(options);
  if (data == null) {
    if (!opts.data) return file;
    data = opts.data;
  }
  const language = file.language || opts.language;
  const engine = getEngine(language, opts);
  if (typeof engine.stringify !== 'function') {
    throw new TypeError('expected "' + language + '.stringify" to be a function');
  }
  data = Object.assign({}, file.data, data);
  const open = opts.delimiters[0];
  const close = opts.delimiters[1];
  const matter = engine.stringify(data, options).trim();
  let buf = '';
  if (matter !== '{}') {
    buf = newline(open) + newline(matter) + newline(close);
  }
  if (typeof file.excerpt === 'string' && file.excerpt !== '') {
    if (str.indexOf(file.excerpt.trim()) === -1) {
      buf += newline(file.excerpt) + newline(close);
    }
  }
  return buf + newline(str);
};
function newline(str) {
  return str.slice(-1) !== '\n' ? str + '\n' : str;
}

/***/ }),

/***/ 69927:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const typeOf = __webpack_require__(66158);
const stringify = __webpack_require__(50809);
const utils = __webpack_require__(57545);

/**
 * Normalize the given value to ensure an object is returned
 * with the expected properties.
 */

module.exports = function (file) {
  if (typeOf(file) !== 'object') {
    file = {
      content: file
    };
  }
  if (typeOf(file.data) !== 'object') {
    file.data = {};
  }

  // if file was passed as an object, ensure that
  // "file.content" is set
  if (file.contents && file.content == null) {
    file.content = file.contents;
  }

  // set non-enumerable properties on the file object
  utils.define(file, 'orig', utils.toBuffer(file.content));
  utils.define(file, 'language', file.language || '');
  utils.define(file, 'matter', file.matter || '');
  utils.define(file, 'stringify', function (data, options) {
    if (options && options.language) {
      file.language = options.language;
    }
    return stringify(file, data, options);
  });

  // strip BOM and ensure that "file.content" is a string
  file.content = utils.toString(file.content);
  file.isEmpty = false;
  file.excerpt = '';
  return file;
};

/***/ }),

/***/ 57545:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(80365)["lW"];


const stripBom = __webpack_require__(32518);
const typeOf = __webpack_require__(66158);
exports.define = function (obj, key, val) {
  Reflect.defineProperty(obj, key, {
    enumerable: false,
    configurable: true,
    writable: true,
    value: val
  });
};

/**
 * Returns true if `val` is a buffer
 */

exports.isBuffer = function (val) {
  return typeOf(val) === 'buffer';
};

/**
 * Returns true if `val` is an object
 */

exports.isObject = function (val) {
  return typeOf(val) === 'object';
};

/**
 * Cast `input` to a buffer
 */

exports.toBuffer = function (input) {
  return typeof input === 'string' ? Buffer.from(input) : input;
};

/**
 * Cast `val` to a string.
 */

exports.toString = function (input) {
  if (exports.isBuffer(input)) return stripBom(String(input));
  if (typeof input !== 'string') {
    throw new TypeError('expected input to be a string or buffer');
  }
  return stripBom(input);
};

/**
 * Cast `val` to an array.
 */

exports.arrayify = function (val) {
  return val ? Array.isArray(val) ? val : [val] : [];
};

/**
 * Returns true if `str` starts with `substr`.
 */

exports.startsWith = function (str, substr, len) {
  if (typeof len !== 'number') len = substr.length;
  return str.slice(0, len) === substr;
};

/***/ }),

/***/ 48405:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];
  i += d;
  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
  buffer[offset + i - d] |= s * 128;
};

/***/ }),

/***/ 63548:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var yaml = __webpack_require__(24914);
module.exports = yaml;

/***/ }),

/***/ 24914:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var loader = __webpack_require__(53744);
var dumper = __webpack_require__(24005);
function deprecated(name) {
  return function () {
    throw new Error('Function ' + name + ' is deprecated and cannot be used.');
  };
}
module.exports.Type = __webpack_require__(28606);
module.exports.Schema = __webpack_require__(29130);
module.exports.FAILSAFE_SCHEMA = __webpack_require__(32961);
module.exports.JSON_SCHEMA = __webpack_require__(4431);
module.exports.CORE_SCHEMA = __webpack_require__(25644);
module.exports.DEFAULT_SAFE_SCHEMA = __webpack_require__(57378);
module.exports.DEFAULT_FULL_SCHEMA = __webpack_require__(88424);
module.exports.load = loader.load;
module.exports.loadAll = loader.loadAll;
module.exports.safeLoad = loader.safeLoad;
module.exports.safeLoadAll = loader.safeLoadAll;
module.exports.dump = dumper.dump;
module.exports.safeDump = dumper.safeDump;
module.exports.YAMLException = __webpack_require__(21087);

// Deprecated schema names from JS-YAML 2.0.x
module.exports.MINIMAL_SCHEMA = __webpack_require__(32961);
module.exports.SAFE_SCHEMA = __webpack_require__(57378);
module.exports.DEFAULT_SCHEMA = __webpack_require__(88424);

// Deprecated functions from JS-YAML 1.x.x
module.exports.scan = deprecated('scan');
module.exports.parse = deprecated('parse');
module.exports.compose = deprecated('compose');
module.exports.addConstructor = deprecated('addConstructor');

/***/ }),

/***/ 16555:
/***/ (function(module) {

"use strict";


function isNothing(subject) {
  return typeof subject === 'undefined' || subject === null;
}
function isObject(subject) {
  return typeof subject === 'object' && subject !== null;
}
function toArray(sequence) {
  if (Array.isArray(sequence)) return sequence;else if (isNothing(sequence)) return [];
  return [sequence];
}
function extend(target, source) {
  var index, length, key, sourceKeys;
  if (source) {
    sourceKeys = Object.keys(source);
    for (index = 0, length = sourceKeys.length; index < length; index += 1) {
      key = sourceKeys[index];
      target[key] = source[key];
    }
  }
  return target;
}
function repeat(string, count) {
  var result = '',
    cycle;
  for (cycle = 0; cycle < count; cycle += 1) {
    result += string;
  }
  return result;
}
function isNegativeZero(number) {
  return number === 0 && Number.NEGATIVE_INFINITY === 1 / number;
}
module.exports.isNothing = isNothing;
module.exports.isObject = isObject;
module.exports.toArray = toArray;
module.exports.repeat = repeat;
module.exports.isNegativeZero = isNegativeZero;
module.exports.extend = extend;

/***/ }),

/***/ 24005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/*eslint-disable no-use-before-define*/
var common = __webpack_require__(16555);
var YAMLException = __webpack_require__(21087);
var DEFAULT_FULL_SCHEMA = __webpack_require__(88424);
var DEFAULT_SAFE_SCHEMA = __webpack_require__(57378);
var _toString = Object.prototype.toString;
var _hasOwnProperty = Object.prototype.hasOwnProperty;
var CHAR_TAB = 0x09; /* Tab */
var CHAR_LINE_FEED = 0x0A; /* LF */
var CHAR_CARRIAGE_RETURN = 0x0D; /* CR */
var CHAR_SPACE = 0x20; /* Space */
var CHAR_EXCLAMATION = 0x21; /* ! */
var CHAR_DOUBLE_QUOTE = 0x22; /* " */
var CHAR_SHARP = 0x23; /* # */
var CHAR_PERCENT = 0x25; /* % */
var CHAR_AMPERSAND = 0x26; /* & */
var CHAR_SINGLE_QUOTE = 0x27; /* ' */
var CHAR_ASTERISK = 0x2A; /* * */
var CHAR_COMMA = 0x2C; /* , */
var CHAR_MINUS = 0x2D; /* - */
var CHAR_COLON = 0x3A; /* : */
var CHAR_EQUALS = 0x3D; /* = */
var CHAR_GREATER_THAN = 0x3E; /* > */
var CHAR_QUESTION = 0x3F; /* ? */
var CHAR_COMMERCIAL_AT = 0x40; /* @ */
var CHAR_LEFT_SQUARE_BRACKET = 0x5B; /* [ */
var CHAR_RIGHT_SQUARE_BRACKET = 0x5D; /* ] */
var CHAR_GRAVE_ACCENT = 0x60; /* ` */
var CHAR_LEFT_CURLY_BRACKET = 0x7B; /* { */
var CHAR_VERTICAL_LINE = 0x7C; /* | */
var CHAR_RIGHT_CURLY_BRACKET = 0x7D; /* } */

var ESCAPE_SEQUENCES = {};
ESCAPE_SEQUENCES[0x00] = '\\0';
ESCAPE_SEQUENCES[0x07] = '\\a';
ESCAPE_SEQUENCES[0x08] = '\\b';
ESCAPE_SEQUENCES[0x09] = '\\t';
ESCAPE_SEQUENCES[0x0A] = '\\n';
ESCAPE_SEQUENCES[0x0B] = '\\v';
ESCAPE_SEQUENCES[0x0C] = '\\f';
ESCAPE_SEQUENCES[0x0D] = '\\r';
ESCAPE_SEQUENCES[0x1B] = '\\e';
ESCAPE_SEQUENCES[0x22] = '\\"';
ESCAPE_SEQUENCES[0x5C] = '\\\\';
ESCAPE_SEQUENCES[0x85] = '\\N';
ESCAPE_SEQUENCES[0xA0] = '\\_';
ESCAPE_SEQUENCES[0x2028] = '\\L';
ESCAPE_SEQUENCES[0x2029] = '\\P';
var DEPRECATED_BOOLEANS_SYNTAX = ['y', 'Y', 'yes', 'Yes', 'YES', 'on', 'On', 'ON', 'n', 'N', 'no', 'No', 'NO', 'off', 'Off', 'OFF'];
function compileStyleMap(schema, map) {
  var result, keys, index, length, tag, style, type;
  if (map === null) return {};
  result = {};
  keys = Object.keys(map);
  for (index = 0, length = keys.length; index < length; index += 1) {
    tag = keys[index];
    style = String(map[tag]);
    if (tag.slice(0, 2) === '!!') {
      tag = 'tag:yaml.org,2002:' + tag.slice(2);
    }
    type = schema.compiledTypeMap['fallback'][tag];
    if (type && _hasOwnProperty.call(type.styleAliases, style)) {
      style = type.styleAliases[style];
    }
    result[tag] = style;
  }
  return result;
}
function encodeHex(character) {
  var string, handle, length;
  string = character.toString(16).toUpperCase();
  if (character <= 0xFF) {
    handle = 'x';
    length = 2;
  } else if (character <= 0xFFFF) {
    handle = 'u';
    length = 4;
  } else if (character <= 0xFFFFFFFF) {
    handle = 'U';
    length = 8;
  } else {
    throw new YAMLException('code point within a string may not be greater than 0xFFFFFFFF');
  }
  return '\\' + handle + common.repeat('0', length - string.length) + string;
}
function State(options) {
  this.schema = options['schema'] || DEFAULT_FULL_SCHEMA;
  this.indent = Math.max(1, options['indent'] || 2);
  this.noArrayIndent = options['noArrayIndent'] || false;
  this.skipInvalid = options['skipInvalid'] || false;
  this.flowLevel = common.isNothing(options['flowLevel']) ? -1 : options['flowLevel'];
  this.styleMap = compileStyleMap(this.schema, options['styles'] || null);
  this.sortKeys = options['sortKeys'] || false;
  this.lineWidth = options['lineWidth'] || 80;
  this.noRefs = options['noRefs'] || false;
  this.noCompatMode = options['noCompatMode'] || false;
  this.condenseFlow = options['condenseFlow'] || false;
  this.implicitTypes = this.schema.compiledImplicit;
  this.explicitTypes = this.schema.compiledExplicit;
  this.tag = null;
  this.result = '';
  this.duplicates = [];
  this.usedDuplicates = null;
}

// Indents every line in a string. Empty lines (\n only) are not indented.
function indentString(string, spaces) {
  var ind = common.repeat(' ', spaces),
    position = 0,
    next = -1,
    result = '',
    line,
    length = string.length;
  while (position < length) {
    next = string.indexOf('\n', position);
    if (next === -1) {
      line = string.slice(position);
      position = length;
    } else {
      line = string.slice(position, next + 1);
      position = next + 1;
    }
    if (line.length && line !== '\n') result += ind;
    result += line;
  }
  return result;
}
function generateNextLine(state, level) {
  return '\n' + common.repeat(' ', state.indent * level);
}
function testImplicitResolving(state, str) {
  var index, length, type;
  for (index = 0, length = state.implicitTypes.length; index < length; index += 1) {
    type = state.implicitTypes[index];
    if (type.resolve(str)) {
      return true;
    }
  }
  return false;
}

// [33] s-white ::= s-space | s-tab
function isWhitespace(c) {
  return c === CHAR_SPACE || c === CHAR_TAB;
}

// Returns true if the character can be printed without escaping.
// From YAML 1.2: "any allowed characters known to be non-printable
// should also be escaped. [However,] This isn’t mandatory"
// Derived from nb-char - \t - #x85 - #xA0 - #x2028 - #x2029.
function isPrintable(c) {
  return 0x00020 <= c && c <= 0x00007E || 0x000A1 <= c && c <= 0x00D7FF && c !== 0x2028 && c !== 0x2029 || 0x0E000 <= c && c <= 0x00FFFD && c !== 0xFEFF /* BOM */ || 0x10000 <= c && c <= 0x10FFFF;
}

// [34] ns-char ::= nb-char - s-white
// [27] nb-char ::= c-printable - b-char - c-byte-order-mark
// [26] b-char  ::= b-line-feed | b-carriage-return
// [24] b-line-feed       ::=     #xA    /* LF */
// [25] b-carriage-return ::=     #xD    /* CR */
// [3]  c-byte-order-mark ::=     #xFEFF
function isNsChar(c) {
  return isPrintable(c) && !isWhitespace(c)
  // byte-order-mark
  && c !== 0xFEFF
  // b-char
  && c !== CHAR_CARRIAGE_RETURN && c !== CHAR_LINE_FEED;
}

// Simplified test for values allowed after the first character in plain style.
function isPlainSafe(c, prev) {
  // Uses a subset of nb-char - c-flow-indicator - ":" - "#"
  // where nb-char ::= c-printable - b-char - c-byte-order-mark.
  return isPrintable(c) && c !== 0xFEFF
  // - c-flow-indicator
  && c !== CHAR_COMMA && c !== CHAR_LEFT_SQUARE_BRACKET && c !== CHAR_RIGHT_SQUARE_BRACKET && c !== CHAR_LEFT_CURLY_BRACKET && c !== CHAR_RIGHT_CURLY_BRACKET
  // - ":" - "#"
  // /* An ns-char preceding */ "#"
  && c !== CHAR_COLON && (c !== CHAR_SHARP || prev && isNsChar(prev));
}

// Simplified test for values allowed as the first character in plain style.
function isPlainSafeFirst(c) {
  // Uses a subset of ns-char - c-indicator
  // where ns-char = nb-char - s-white.
  return isPrintable(c) && c !== 0xFEFF && !isWhitespace(c) // - s-white
  // - (c-indicator ::=
  // “-” | “?” | “:” | “,” | “[” | “]” | “{” | “}”
  && c !== CHAR_MINUS && c !== CHAR_QUESTION && c !== CHAR_COLON && c !== CHAR_COMMA && c !== CHAR_LEFT_SQUARE_BRACKET && c !== CHAR_RIGHT_SQUARE_BRACKET && c !== CHAR_LEFT_CURLY_BRACKET && c !== CHAR_RIGHT_CURLY_BRACKET
  // | “#” | “&” | “*” | “!” | “|” | “=” | “>” | “'” | “"”
  && c !== CHAR_SHARP && c !== CHAR_AMPERSAND && c !== CHAR_ASTERISK && c !== CHAR_EXCLAMATION && c !== CHAR_VERTICAL_LINE && c !== CHAR_EQUALS && c !== CHAR_GREATER_THAN && c !== CHAR_SINGLE_QUOTE && c !== CHAR_DOUBLE_QUOTE
  // | “%” | “@” | “`”)
  && c !== CHAR_PERCENT && c !== CHAR_COMMERCIAL_AT && c !== CHAR_GRAVE_ACCENT;
}

// Determines whether block indentation indicator is required.
function needIndentIndicator(string) {
  var leadingSpaceRe = /^\n* /;
  return leadingSpaceRe.test(string);
}
var STYLE_PLAIN = 1,
  STYLE_SINGLE = 2,
  STYLE_LITERAL = 3,
  STYLE_FOLDED = 4,
  STYLE_DOUBLE = 5;

// Determines which scalar styles are possible and returns the preferred style.
// lineWidth = -1 => no limit.
// Pre-conditions: str.length > 0.
// Post-conditions:
//    STYLE_PLAIN or STYLE_SINGLE => no \n are in the string.
//    STYLE_LITERAL => no lines are suitable for folding (or lineWidth is -1).
//    STYLE_FOLDED => a line > lineWidth and can be folded (and lineWidth != -1).
function chooseScalarStyle(string, singleLineOnly, indentPerLevel, lineWidth, testAmbiguousType) {
  var i;
  var char, prev_char;
  var hasLineBreak = false;
  var hasFoldableLine = false; // only checked if shouldTrackWidth
  var shouldTrackWidth = lineWidth !== -1;
  var previousLineBreak = -1; // count the first line correctly
  var plain = isPlainSafeFirst(string.charCodeAt(0)) && !isWhitespace(string.charCodeAt(string.length - 1));
  if (singleLineOnly) {
    // Case: no block styles.
    // Check for disallowed characters to rule out plain and single.
    for (i = 0; i < string.length; i++) {
      char = string.charCodeAt(i);
      if (!isPrintable(char)) {
        return STYLE_DOUBLE;
      }
      prev_char = i > 0 ? string.charCodeAt(i - 1) : null;
      plain = plain && isPlainSafe(char, prev_char);
    }
  } else {
    // Case: block styles permitted.
    for (i = 0; i < string.length; i++) {
      char = string.charCodeAt(i);
      if (char === CHAR_LINE_FEED) {
        hasLineBreak = true;
        // Check if any line can be folded.
        if (shouldTrackWidth) {
          hasFoldableLine = hasFoldableLine ||
          // Foldable line = too long, and not more-indented.
          i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
          previousLineBreak = i;
        }
      } else if (!isPrintable(char)) {
        return STYLE_DOUBLE;
      }
      prev_char = i > 0 ? string.charCodeAt(i - 1) : null;
      plain = plain && isPlainSafe(char, prev_char);
    }
    // in case the end is missing a \n
    hasFoldableLine = hasFoldableLine || shouldTrackWidth && i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
  }
  // Although every style can represent \n without escaping, prefer block styles
  // for multiline, since they're more readable and they don't add empty lines.
  // Also prefer folding a super-long line.
  if (!hasLineBreak && !hasFoldableLine) {
    // Strings interpretable as another type have to be quoted;
    // e.g. the string 'true' vs. the boolean true.
    return plain && !testAmbiguousType(string) ? STYLE_PLAIN : STYLE_SINGLE;
  }
  // Edge case: block indentation indicator can only have one digit.
  if (indentPerLevel > 9 && needIndentIndicator(string)) {
    return STYLE_DOUBLE;
  }
  // At this point we know block styles are valid.
  // Prefer literal style unless we want to fold.
  return hasFoldableLine ? STYLE_FOLDED : STYLE_LITERAL;
}

// Note: line breaking/folding is implemented for only the folded style.
// NB. We drop the last trailing newline (if any) of a returned block scalar
//  since the dumper adds its own newline. This always works:
//    • No ending newline => unaffected; already using strip "-" chomping.
//    • Ending newline    => removed then restored.
//  Importantly, this keeps the "+" chomp indicator from gaining an extra line.
function writeScalar(state, string, level, iskey) {
  state.dump = function () {
    if (string.length === 0) {
      return "''";
    }
    if (!state.noCompatMode && DEPRECATED_BOOLEANS_SYNTAX.indexOf(string) !== -1) {
      return "'" + string + "'";
    }
    var indent = state.indent * Math.max(1, level); // no 0-indent scalars
    // As indentation gets deeper, let the width decrease monotonically
    // to the lower bound min(state.lineWidth, 40).
    // Note that this implies
    //  state.lineWidth ≤ 40 + state.indent: width is fixed at the lower bound.
    //  state.lineWidth > 40 + state.indent: width decreases until the lower bound.
    // This behaves better than a constant minimum width which disallows narrower options,
    // or an indent threshold which causes the width to suddenly increase.
    var lineWidth = state.lineWidth === -1 ? -1 : Math.max(Math.min(state.lineWidth, 40), state.lineWidth - indent);

    // Without knowing if keys are implicit/explicit, assume implicit for safety.
    var singleLineOnly = iskey
    // No block styles in flow mode.
    || state.flowLevel > -1 && level >= state.flowLevel;
    function testAmbiguity(string) {
      return testImplicitResolving(state, string);
    }
    switch (chooseScalarStyle(string, singleLineOnly, state.indent, lineWidth, testAmbiguity)) {
      case STYLE_PLAIN:
        return string;
      case STYLE_SINGLE:
        return "'" + string.replace(/'/g, "''") + "'";
      case STYLE_LITERAL:
        return '|' + blockHeader(string, state.indent) + dropEndingNewline(indentString(string, indent));
      case STYLE_FOLDED:
        return '>' + blockHeader(string, state.indent) + dropEndingNewline(indentString(foldString(string, lineWidth), indent));
      case STYLE_DOUBLE:
        return '"' + escapeString(string, lineWidth) + '"';
      default:
        throw new YAMLException('impossible error: invalid scalar style');
    }
  }();
}

// Pre-conditions: string is valid for a block scalar, 1 <= indentPerLevel <= 9.
function blockHeader(string, indentPerLevel) {
  var indentIndicator = needIndentIndicator(string) ? String(indentPerLevel) : '';

  // note the special case: the string '\n' counts as a "trailing" empty line.
  var clip = string[string.length - 1] === '\n';
  var keep = clip && (string[string.length - 2] === '\n' || string === '\n');
  var chomp = keep ? '+' : clip ? '' : '-';
  return indentIndicator + chomp + '\n';
}

// (See the note for writeScalar.)
function dropEndingNewline(string) {
  return string[string.length - 1] === '\n' ? string.slice(0, -1) : string;
}

// Note: a long line without a suitable break point will exceed the width limit.
// Pre-conditions: every char in str isPrintable, str.length > 0, width > 0.
function foldString(string, width) {
  // In folded style, $k$ consecutive newlines output as $k+1$ newlines—
  // unless they're before or after a more-indented line, or at the very
  // beginning or end, in which case $k$ maps to $k$.
  // Therefore, parse each chunk as newline(s) followed by a content line.
  var lineRe = /(\n+)([^\n]*)/g;

  // first line (possibly an empty line)
  var result = function () {
    var nextLF = string.indexOf('\n');
    nextLF = nextLF !== -1 ? nextLF : string.length;
    lineRe.lastIndex = nextLF;
    return foldLine(string.slice(0, nextLF), width);
  }();
  // If we haven't reached the first content line yet, don't add an extra \n.
  var prevMoreIndented = string[0] === '\n' || string[0] === ' ';
  var moreIndented;

  // rest of the lines
  var match;
  while (match = lineRe.exec(string)) {
    var prefix = match[1],
      line = match[2];
    moreIndented = line[0] === ' ';
    result += prefix + (!prevMoreIndented && !moreIndented && line !== '' ? '\n' : '') + foldLine(line, width);
    prevMoreIndented = moreIndented;
  }
  return result;
}

// Greedy line breaking.
// Picks the longest line under the limit each time,
// otherwise settles for the shortest line over the limit.
// NB. More-indented lines *cannot* be folded, as that would add an extra \n.
function foldLine(line, width) {
  if (line === '' || line[0] === ' ') return line;

  // Since a more-indented line adds a \n, breaks can't be followed by a space.
  var breakRe = / [^ ]/g; // note: the match index will always be <= length-2.
  var match;
  // start is an inclusive index. end, curr, and next are exclusive.
  var start = 0,
    end,
    curr = 0,
    next = 0;
  var result = '';

  // Invariants: 0 <= start <= length-1.
  //   0 <= curr <= next <= max(0, length-2). curr - start <= width.
  // Inside the loop:
  //   A match implies length >= 2, so curr and next are <= length-2.
  while (match = breakRe.exec(line)) {
    next = match.index;
    // maintain invariant: curr - start <= width
    if (next - start > width) {
      end = curr > start ? curr : next; // derive end <= length-2
      result += '\n' + line.slice(start, end);
      // skip the space that was output as \n
      start = end + 1; // derive start <= length-1
    }

    curr = next;
  }

  // By the invariants, start <= length-1, so there is something left over.
  // It is either the whole string or a part starting from non-whitespace.
  result += '\n';
  // Insert a break if the remainder is too long and there is a break available.
  if (line.length - start > width && curr > start) {
    result += line.slice(start, curr) + '\n' + line.slice(curr + 1);
  } else {
    result += line.slice(start);
  }
  return result.slice(1); // drop extra \n joiner
}

// Escapes a double-quoted string.
function escapeString(string) {
  var result = '';
  var char, nextChar;
  var escapeSeq;
  for (var i = 0; i < string.length; i++) {
    char = string.charCodeAt(i);
    // Check for surrogate pairs (reference Unicode 3.0 section "3.7 Surrogates").
    if (char >= 0xD800 && char <= 0xDBFF /* high surrogate */) {
      nextChar = string.charCodeAt(i + 1);
      if (nextChar >= 0xDC00 && nextChar <= 0xDFFF /* low surrogate */) {
        // Combine the surrogate pair and store it escaped.
        result += encodeHex((char - 0xD800) * 0x400 + nextChar - 0xDC00 + 0x10000);
        // Advance index one extra since we already used that char here.
        i++;
        continue;
      }
    }
    escapeSeq = ESCAPE_SEQUENCES[char];
    result += !escapeSeq && isPrintable(char) ? string[i] : escapeSeq || encodeHex(char);
  }
  return result;
}
function writeFlowSequence(state, level, object) {
  var _result = '',
    _tag = state.tag,
    index,
    length;
  for (index = 0, length = object.length; index < length; index += 1) {
    // Write only valid elements.
    if (writeNode(state, level, object[index], false, false)) {
      if (index !== 0) _result += ',' + (!state.condenseFlow ? ' ' : '');
      _result += state.dump;
    }
  }
  state.tag = _tag;
  state.dump = '[' + _result + ']';
}
function writeBlockSequence(state, level, object, compact) {
  var _result = '',
    _tag = state.tag,
    index,
    length;
  for (index = 0, length = object.length; index < length; index += 1) {
    // Write only valid elements.
    if (writeNode(state, level + 1, object[index], true, true)) {
      if (!compact || index !== 0) {
        _result += generateNextLine(state, level);
      }
      if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
        _result += '-';
      } else {
        _result += '- ';
      }
      _result += state.dump;
    }
  }
  state.tag = _tag;
  state.dump = _result || '[]'; // Empty sequence if no valid values.
}

function writeFlowMapping(state, level, object) {
  var _result = '',
    _tag = state.tag,
    objectKeyList = Object.keys(object),
    index,
    length,
    objectKey,
    objectValue,
    pairBuffer;
  for (index = 0, length = objectKeyList.length; index < length; index += 1) {
    pairBuffer = '';
    if (index !== 0) pairBuffer += ', ';
    if (state.condenseFlow) pairBuffer += '"';
    objectKey = objectKeyList[index];
    objectValue = object[objectKey];
    if (!writeNode(state, level, objectKey, false, false)) {
      continue; // Skip this pair because of invalid key;
    }

    if (state.dump.length > 1024) pairBuffer += '? ';
    pairBuffer += state.dump + (state.condenseFlow ? '"' : '') + ':' + (state.condenseFlow ? '' : ' ');
    if (!writeNode(state, level, objectValue, false, false)) {
      continue; // Skip this pair because of invalid value.
    }

    pairBuffer += state.dump;

    // Both key and value are valid.
    _result += pairBuffer;
  }
  state.tag = _tag;
  state.dump = '{' + _result + '}';
}
function writeBlockMapping(state, level, object, compact) {
  var _result = '',
    _tag = state.tag,
    objectKeyList = Object.keys(object),
    index,
    length,
    objectKey,
    objectValue,
    explicitPair,
    pairBuffer;

  // Allow sorting keys so that the output file is deterministic
  if (state.sortKeys === true) {
    // Default sorting
    objectKeyList.sort();
  } else if (typeof state.sortKeys === 'function') {
    // Custom sort function
    objectKeyList.sort(state.sortKeys);
  } else if (state.sortKeys) {
    // Something is wrong
    throw new YAMLException('sortKeys must be a boolean or a function');
  }
  for (index = 0, length = objectKeyList.length; index < length; index += 1) {
    pairBuffer = '';
    if (!compact || index !== 0) {
      pairBuffer += generateNextLine(state, level);
    }
    objectKey = objectKeyList[index];
    objectValue = object[objectKey];
    if (!writeNode(state, level + 1, objectKey, true, true, true)) {
      continue; // Skip this pair because of invalid key.
    }

    explicitPair = state.tag !== null && state.tag !== '?' || state.dump && state.dump.length > 1024;
    if (explicitPair) {
      if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
        pairBuffer += '?';
      } else {
        pairBuffer += '? ';
      }
    }
    pairBuffer += state.dump;
    if (explicitPair) {
      pairBuffer += generateNextLine(state, level);
    }
    if (!writeNode(state, level + 1, objectValue, true, explicitPair)) {
      continue; // Skip this pair because of invalid value.
    }

    if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
      pairBuffer += ':';
    } else {
      pairBuffer += ': ';
    }
    pairBuffer += state.dump;

    // Both key and value are valid.
    _result += pairBuffer;
  }
  state.tag = _tag;
  state.dump = _result || '{}'; // Empty mapping if no valid pairs.
}

function detectType(state, object, explicit) {
  var _result, typeList, index, length, type, style;
  typeList = explicit ? state.explicitTypes : state.implicitTypes;
  for (index = 0, length = typeList.length; index < length; index += 1) {
    type = typeList[index];
    if ((type.instanceOf || type.predicate) && (!type.instanceOf || typeof object === 'object' && object instanceof type.instanceOf) && (!type.predicate || type.predicate(object))) {
      state.tag = explicit ? type.tag : '?';
      if (type.represent) {
        style = state.styleMap[type.tag] || type.defaultStyle;
        if (_toString.call(type.represent) === '[object Function]') {
          _result = type.represent(object, style);
        } else if (_hasOwnProperty.call(type.represent, style)) {
          _result = type.represent[style](object, style);
        } else {
          throw new YAMLException('!<' + type.tag + '> tag resolver accepts not "' + style + '" style');
        }
        state.dump = _result;
      }
      return true;
    }
  }
  return false;
}

// Serializes `object` and writes it to global `result`.
// Returns true on success, or false on invalid object.
//
function writeNode(state, level, object, block, compact, iskey) {
  state.tag = null;
  state.dump = object;
  if (!detectType(state, object, false)) {
    detectType(state, object, true);
  }
  var type = _toString.call(state.dump);
  if (block) {
    block = state.flowLevel < 0 || state.flowLevel > level;
  }
  var objectOrArray = type === '[object Object]' || type === '[object Array]',
    duplicateIndex,
    duplicate;
  if (objectOrArray) {
    duplicateIndex = state.duplicates.indexOf(object);
    duplicate = duplicateIndex !== -1;
  }
  if (state.tag !== null && state.tag !== '?' || duplicate || state.indent !== 2 && level > 0) {
    compact = false;
  }
  if (duplicate && state.usedDuplicates[duplicateIndex]) {
    state.dump = '*ref_' + duplicateIndex;
  } else {
    if (objectOrArray && duplicate && !state.usedDuplicates[duplicateIndex]) {
      state.usedDuplicates[duplicateIndex] = true;
    }
    if (type === '[object Object]') {
      if (block && Object.keys(state.dump).length !== 0) {
        writeBlockMapping(state, level, state.dump, compact);
        if (duplicate) {
          state.dump = '&ref_' + duplicateIndex + state.dump;
        }
      } else {
        writeFlowMapping(state, level, state.dump);
        if (duplicate) {
          state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
        }
      }
    } else if (type === '[object Array]') {
      var arrayLevel = state.noArrayIndent && level > 0 ? level - 1 : level;
      if (block && state.dump.length !== 0) {
        writeBlockSequence(state, arrayLevel, state.dump, compact);
        if (duplicate) {
          state.dump = '&ref_' + duplicateIndex + state.dump;
        }
      } else {
        writeFlowSequence(state, arrayLevel, state.dump);
        if (duplicate) {
          state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
        }
      }
    } else if (type === '[object String]') {
      if (state.tag !== '?') {
        writeScalar(state, state.dump, level, iskey);
      }
    } else {
      if (state.skipInvalid) return false;
      throw new YAMLException('unacceptable kind of an object to dump ' + type);
    }
    if (state.tag !== null && state.tag !== '?') {
      state.dump = '!<' + state.tag + '> ' + state.dump;
    }
  }
  return true;
}
function getDuplicateReferences(object, state) {
  var objects = [],
    duplicatesIndexes = [],
    index,
    length;
  inspectNode(object, objects, duplicatesIndexes);
  for (index = 0, length = duplicatesIndexes.length; index < length; index += 1) {
    state.duplicates.push(objects[duplicatesIndexes[index]]);
  }
  state.usedDuplicates = new Array(length);
}
function inspectNode(object, objects, duplicatesIndexes) {
  var objectKeyList, index, length;
  if (object !== null && typeof object === 'object') {
    index = objects.indexOf(object);
    if (index !== -1) {
      if (duplicatesIndexes.indexOf(index) === -1) {
        duplicatesIndexes.push(index);
      }
    } else {
      objects.push(object);
      if (Array.isArray(object)) {
        for (index = 0, length = object.length; index < length; index += 1) {
          inspectNode(object[index], objects, duplicatesIndexes);
        }
      } else {
        objectKeyList = Object.keys(object);
        for (index = 0, length = objectKeyList.length; index < length; index += 1) {
          inspectNode(object[objectKeyList[index]], objects, duplicatesIndexes);
        }
      }
    }
  }
}
function dump(input, options) {
  options = options || {};
  var state = new State(options);
  if (!state.noRefs) getDuplicateReferences(input, state);
  if (writeNode(state, 0, input, true, true)) return state.dump + '\n';
  return '';
}
function safeDump(input, options) {
  return dump(input, common.extend({
    schema: DEFAULT_SAFE_SCHEMA
  }, options));
}
module.exports.dump = dump;
module.exports.safeDump = safeDump;

/***/ }),

/***/ 21087:
/***/ (function(module) {

"use strict";
// YAML error class. http://stackoverflow.com/questions/8458984
//


function YAMLException(reason, mark) {
  // Super constructor
  Error.call(this);
  this.name = 'YAMLException';
  this.reason = reason;
  this.mark = mark;
  this.message = (this.reason || '(unknown reason)') + (this.mark ? ' ' + this.mark.toString() : '');

  // Include stack trace in error object
  if (Error.captureStackTrace) {
    // Chrome and NodeJS
    Error.captureStackTrace(this, this.constructor);
  } else {
    // FF, IE 10+ and Safari 6+. Fallback for others
    this.stack = new Error().stack || '';
  }
}

// Inherit from Error
YAMLException.prototype = Object.create(Error.prototype);
YAMLException.prototype.constructor = YAMLException;
YAMLException.prototype.toString = function toString(compact) {
  var result = this.name + ': ';
  result += this.reason || '(unknown reason)';
  if (!compact && this.mark) {
    result += ' ' + this.mark.toString();
  }
  return result;
};
module.exports = YAMLException;

/***/ }),

/***/ 53744:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/*eslint-disable max-len,no-use-before-define*/
var common = __webpack_require__(16555);
var YAMLException = __webpack_require__(21087);
var Mark = __webpack_require__(64279);
var DEFAULT_SAFE_SCHEMA = __webpack_require__(57378);
var DEFAULT_FULL_SCHEMA = __webpack_require__(88424);
var _hasOwnProperty = Object.prototype.hasOwnProperty;
var CONTEXT_FLOW_IN = 1;
var CONTEXT_FLOW_OUT = 2;
var CONTEXT_BLOCK_IN = 3;
var CONTEXT_BLOCK_OUT = 4;
var CHOMPING_CLIP = 1;
var CHOMPING_STRIP = 2;
var CHOMPING_KEEP = 3;
var PATTERN_NON_PRINTABLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
var PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
var PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/;
var PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i;
var PATTERN_TAG_URI = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
function _class(obj) {
  return Object.prototype.toString.call(obj);
}
function is_EOL(c) {
  return c === 0x0A /* LF */ || c === 0x0D /* CR */;
}

function is_WHITE_SPACE(c) {
  return c === 0x09 /* Tab */ || c === 0x20 /* Space */;
}

function is_WS_OR_EOL(c) {
  return c === 0x09 /* Tab */ || c === 0x20 /* Space */ || c === 0x0A /* LF */ || c === 0x0D /* CR */;
}

function is_FLOW_INDICATOR(c) {
  return c === 0x2C /* , */ || c === 0x5B /* [ */ || c === 0x5D /* ] */ || c === 0x7B /* { */ || c === 0x7D /* } */;
}

function fromHexCode(c) {
  var lc;
  if (0x30 /* 0 */ <= c && c <= 0x39 /* 9 */) {
    return c - 0x30;
  }

  /*eslint-disable no-bitwise*/
  lc = c | 0x20;
  if (0x61 /* a */ <= lc && lc <= 0x66 /* f */) {
    return lc - 0x61 + 10;
  }
  return -1;
}
function escapedHexLen(c) {
  if (c === 0x78 /* x */) {
    return 2;
  }
  if (c === 0x75 /* u */) {
    return 4;
  }
  if (c === 0x55 /* U */) {
    return 8;
  }
  return 0;
}
function fromDecimalCode(c) {
  if (0x30 /* 0 */ <= c && c <= 0x39 /* 9 */) {
    return c - 0x30;
  }
  return -1;
}
function simpleEscapeSequence(c) {
  /* eslint-disable indent */
  return c === 0x30 /* 0 */ ? '\x00' : c === 0x61 /* a */ ? '\x07' : c === 0x62 /* b */ ? '\x08' : c === 0x74 /* t */ ? '\x09' : c === 0x09 /* Tab */ ? '\x09' : c === 0x6E /* n */ ? '\x0A' : c === 0x76 /* v */ ? '\x0B' : c === 0x66 /* f */ ? '\x0C' : c === 0x72 /* r */ ? '\x0D' : c === 0x65 /* e */ ? '\x1B' : c === 0x20 /* Space */ ? ' ' : c === 0x22 /* " */ ? '\x22' : c === 0x2F /* / */ ? '/' : c === 0x5C /* \ */ ? '\x5C' : c === 0x4E /* N */ ? '\x85' : c === 0x5F /* _ */ ? '\xA0' : c === 0x4C /* L */ ? '\u2028' : c === 0x50 /* P */ ? '\u2029' : '';
}
function charFromCodepoint(c) {
  if (c <= 0xFFFF) {
    return String.fromCharCode(c);
  }
  // Encode UTF-16 surrogate pair
  // https://en.wikipedia.org/wiki/UTF-16#Code_points_U.2B010000_to_U.2B10FFFF
  return String.fromCharCode((c - 0x010000 >> 10) + 0xD800, (c - 0x010000 & 0x03FF) + 0xDC00);
}
var simpleEscapeCheck = new Array(256); // integer, for fast access
var simpleEscapeMap = new Array(256);
for (var i = 0; i < 256; i++) {
  simpleEscapeCheck[i] = simpleEscapeSequence(i) ? 1 : 0;
  simpleEscapeMap[i] = simpleEscapeSequence(i);
}
function State(input, options) {
  this.input = input;
  this.filename = options['filename'] || null;
  this.schema = options['schema'] || DEFAULT_FULL_SCHEMA;
  this.onWarning = options['onWarning'] || null;
  this.legacy = options['legacy'] || false;
  this.json = options['json'] || false;
  this.listener = options['listener'] || null;
  this.implicitTypes = this.schema.compiledImplicit;
  this.typeMap = this.schema.compiledTypeMap;
  this.length = input.length;
  this.position = 0;
  this.line = 0;
  this.lineStart = 0;
  this.lineIndent = 0;
  this.documents = [];

  /*
  this.version;
  this.checkLineBreaks;
  this.tagMap;
  this.anchorMap;
  this.tag;
  this.anchor;
  this.kind;
  this.result;*/
}

function generateError(state, message) {
  return new YAMLException(message, new Mark(state.filename, state.input, state.position, state.line, state.position - state.lineStart));
}
function throwError(state, message) {
  throw generateError(state, message);
}
function throwWarning(state, message) {
  if (state.onWarning) {
    state.onWarning.call(null, generateError(state, message));
  }
}
var directiveHandlers = {
  YAML: function handleYamlDirective(state, name, args) {
    var match, major, minor;
    if (state.version !== null) {
      throwError(state, 'duplication of %YAML directive');
    }
    if (args.length !== 1) {
      throwError(state, 'YAML directive accepts exactly one argument');
    }
    match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);
    if (match === null) {
      throwError(state, 'ill-formed argument of the YAML directive');
    }
    major = parseInt(match[1], 10);
    minor = parseInt(match[2], 10);
    if (major !== 1) {
      throwError(state, 'unacceptable YAML version of the document');
    }
    state.version = args[0];
    state.checkLineBreaks = minor < 2;
    if (minor !== 1 && minor !== 2) {
      throwWarning(state, 'unsupported YAML version of the document');
    }
  },
  TAG: function handleTagDirective(state, name, args) {
    var handle, prefix;
    if (args.length !== 2) {
      throwError(state, 'TAG directive accepts exactly two arguments');
    }
    handle = args[0];
    prefix = args[1];
    if (!PATTERN_TAG_HANDLE.test(handle)) {
      throwError(state, 'ill-formed tag handle (first argument) of the TAG directive');
    }
    if (_hasOwnProperty.call(state.tagMap, handle)) {
      throwError(state, 'there is a previously declared suffix for "' + handle + '" tag handle');
    }
    if (!PATTERN_TAG_URI.test(prefix)) {
      throwError(state, 'ill-formed tag prefix (second argument) of the TAG directive');
    }
    state.tagMap[handle] = prefix;
  }
};
function captureSegment(state, start, end, checkJson) {
  var _position, _length, _character, _result;
  if (start < end) {
    _result = state.input.slice(start, end);
    if (checkJson) {
      for (_position = 0, _length = _result.length; _position < _length; _position += 1) {
        _character = _result.charCodeAt(_position);
        if (!(_character === 0x09 || 0x20 <= _character && _character <= 0x10FFFF)) {
          throwError(state, 'expected valid JSON character');
        }
      }
    } else if (PATTERN_NON_PRINTABLE.test(_result)) {
      throwError(state, 'the stream contains non-printable characters');
    }
    state.result += _result;
  }
}
function mergeMappings(state, destination, source, overridableKeys) {
  var sourceKeys, key, index, quantity;
  if (!common.isObject(source)) {
    throwError(state, 'cannot merge mappings; the provided source object is unacceptable');
  }
  sourceKeys = Object.keys(source);
  for (index = 0, quantity = sourceKeys.length; index < quantity; index += 1) {
    key = sourceKeys[index];
    if (!_hasOwnProperty.call(destination, key)) {
      destination[key] = source[key];
      overridableKeys[key] = true;
    }
  }
}
function storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, startLine, startPos) {
  var index, quantity;

  // The output is a plain object here, so keys can only be strings.
  // We need to convert keyNode to a string, but doing so can hang the process
  // (deeply nested arrays that explode exponentially using aliases).
  if (Array.isArray(keyNode)) {
    keyNode = Array.prototype.slice.call(keyNode);
    for (index = 0, quantity = keyNode.length; index < quantity; index += 1) {
      if (Array.isArray(keyNode[index])) {
        throwError(state, 'nested arrays are not supported inside keys');
      }
      if (typeof keyNode === 'object' && _class(keyNode[index]) === '[object Object]') {
        keyNode[index] = '[object Object]';
      }
    }
  }

  // Avoid code execution in load() via toString property
  // (still use its own toString for arrays, timestamps,
  // and whatever user schema extensions happen to have @@toStringTag)
  if (typeof keyNode === 'object' && _class(keyNode) === '[object Object]') {
    keyNode = '[object Object]';
  }
  keyNode = String(keyNode);
  if (_result === null) {
    _result = {};
  }
  if (keyTag === 'tag:yaml.org,2002:merge') {
    if (Array.isArray(valueNode)) {
      for (index = 0, quantity = valueNode.length; index < quantity; index += 1) {
        mergeMappings(state, _result, valueNode[index], overridableKeys);
      }
    } else {
      mergeMappings(state, _result, valueNode, overridableKeys);
    }
  } else {
    if (!state.json && !_hasOwnProperty.call(overridableKeys, keyNode) && _hasOwnProperty.call(_result, keyNode)) {
      state.line = startLine || state.line;
      state.position = startPos || state.position;
      throwError(state, 'duplicated mapping key');
    }
    _result[keyNode] = valueNode;
    delete overridableKeys[keyNode];
  }
  return _result;
}
function readLineBreak(state) {
  var ch;
  ch = state.input.charCodeAt(state.position);
  if (ch === 0x0A /* LF */) {
    state.position++;
  } else if (ch === 0x0D /* CR */) {
    state.position++;
    if (state.input.charCodeAt(state.position) === 0x0A /* LF */) {
      state.position++;
    }
  } else {
    throwError(state, 'a line break is expected');
  }
  state.line += 1;
  state.lineStart = state.position;
}
function skipSeparationSpace(state, allowComments, checkIndent) {
  var lineBreaks = 0,
    ch = state.input.charCodeAt(state.position);
  while (ch !== 0) {
    while (is_WHITE_SPACE(ch)) {
      ch = state.input.charCodeAt(++state.position);
    }
    if (allowComments && ch === 0x23 /* # */) {
      do {
        ch = state.input.charCodeAt(++state.position);
      } while (ch !== 0x0A /* LF */ && ch !== 0x0D /* CR */ && ch !== 0);
    }
    if (is_EOL(ch)) {
      readLineBreak(state);
      ch = state.input.charCodeAt(state.position);
      lineBreaks++;
      state.lineIndent = 0;
      while (ch === 0x20 /* Space */) {
        state.lineIndent++;
        ch = state.input.charCodeAt(++state.position);
      }
    } else {
      break;
    }
  }
  if (checkIndent !== -1 && lineBreaks !== 0 && state.lineIndent < checkIndent) {
    throwWarning(state, 'deficient indentation');
  }
  return lineBreaks;
}
function testDocumentSeparator(state) {
  var _position = state.position,
    ch;
  ch = state.input.charCodeAt(_position);

  // Condition state.position === state.lineStart is tested
  // in parent on each call, for efficiency. No needs to test here again.
  if ((ch === 0x2D /* - */ || ch === 0x2E /* . */) && ch === state.input.charCodeAt(_position + 1) && ch === state.input.charCodeAt(_position + 2)) {
    _position += 3;
    ch = state.input.charCodeAt(_position);
    if (ch === 0 || is_WS_OR_EOL(ch)) {
      return true;
    }
  }
  return false;
}
function writeFoldedLines(state, count) {
  if (count === 1) {
    state.result += ' ';
  } else if (count > 1) {
    state.result += common.repeat('\n', count - 1);
  }
}
function readPlainScalar(state, nodeIndent, withinFlowCollection) {
  var preceding,
    following,
    captureStart,
    captureEnd,
    hasPendingContent,
    _line,
    _lineStart,
    _lineIndent,
    _kind = state.kind,
    _result = state.result,
    ch;
  ch = state.input.charCodeAt(state.position);
  if (is_WS_OR_EOL(ch) || is_FLOW_INDICATOR(ch) || ch === 0x23 /* # */ || ch === 0x26 /* & */ || ch === 0x2A /* * */ || ch === 0x21 /* ! */ || ch === 0x7C /* | */ || ch === 0x3E /* > */ || ch === 0x27 /* ' */ || ch === 0x22 /* " */ || ch === 0x25 /* % */ || ch === 0x40 /* @ */ || ch === 0x60 /* ` */) {
    return false;
  }
  if (ch === 0x3F /* ? */ || ch === 0x2D /* - */) {
    following = state.input.charCodeAt(state.position + 1);
    if (is_WS_OR_EOL(following) || withinFlowCollection && is_FLOW_INDICATOR(following)) {
      return false;
    }
  }
  state.kind = 'scalar';
  state.result = '';
  captureStart = captureEnd = state.position;
  hasPendingContent = false;
  while (ch !== 0) {
    if (ch === 0x3A /* : */) {
      following = state.input.charCodeAt(state.position + 1);
      if (is_WS_OR_EOL(following) || withinFlowCollection && is_FLOW_INDICATOR(following)) {
        break;
      }
    } else if (ch === 0x23 /* # */) {
      preceding = state.input.charCodeAt(state.position - 1);
      if (is_WS_OR_EOL(preceding)) {
        break;
      }
    } else if (state.position === state.lineStart && testDocumentSeparator(state) || withinFlowCollection && is_FLOW_INDICATOR(ch)) {
      break;
    } else if (is_EOL(ch)) {
      _line = state.line;
      _lineStart = state.lineStart;
      _lineIndent = state.lineIndent;
      skipSeparationSpace(state, false, -1);
      if (state.lineIndent >= nodeIndent) {
        hasPendingContent = true;
        ch = state.input.charCodeAt(state.position);
        continue;
      } else {
        state.position = captureEnd;
        state.line = _line;
        state.lineStart = _lineStart;
        state.lineIndent = _lineIndent;
        break;
      }
    }
    if (hasPendingContent) {
      captureSegment(state, captureStart, captureEnd, false);
      writeFoldedLines(state, state.line - _line);
      captureStart = captureEnd = state.position;
      hasPendingContent = false;
    }
    if (!is_WHITE_SPACE(ch)) {
      captureEnd = state.position + 1;
    }
    ch = state.input.charCodeAt(++state.position);
  }
  captureSegment(state, captureStart, captureEnd, false);
  if (state.result) {
    return true;
  }
  state.kind = _kind;
  state.result = _result;
  return false;
}
function readSingleQuotedScalar(state, nodeIndent) {
  var ch, captureStart, captureEnd;
  ch = state.input.charCodeAt(state.position);
  if (ch !== 0x27 /* ' */) {
    return false;
  }
  state.kind = 'scalar';
  state.result = '';
  state.position++;
  captureStart = captureEnd = state.position;
  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
    if (ch === 0x27 /* ' */) {
      captureSegment(state, captureStart, state.position, true);
      ch = state.input.charCodeAt(++state.position);
      if (ch === 0x27 /* ' */) {
        captureStart = state.position;
        state.position++;
        captureEnd = state.position;
      } else {
        return true;
      }
    } else if (is_EOL(ch)) {
      captureSegment(state, captureStart, captureEnd, true);
      writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
      captureStart = captureEnd = state.position;
    } else if (state.position === state.lineStart && testDocumentSeparator(state)) {
      throwError(state, 'unexpected end of the document within a single quoted scalar');
    } else {
      state.position++;
      captureEnd = state.position;
    }
  }
  throwError(state, 'unexpected end of the stream within a single quoted scalar');
}
function readDoubleQuotedScalar(state, nodeIndent) {
  var captureStart, captureEnd, hexLength, hexResult, tmp, ch;
  ch = state.input.charCodeAt(state.position);
  if (ch !== 0x22 /* " */) {
    return false;
  }
  state.kind = 'scalar';
  state.result = '';
  state.position++;
  captureStart = captureEnd = state.position;
  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
    if (ch === 0x22 /* " */) {
      captureSegment(state, captureStart, state.position, true);
      state.position++;
      return true;
    } else if (ch === 0x5C /* \ */) {
      captureSegment(state, captureStart, state.position, true);
      ch = state.input.charCodeAt(++state.position);
      if (is_EOL(ch)) {
        skipSeparationSpace(state, false, nodeIndent);

        // TODO: rework to inline fn with no type cast?
      } else if (ch < 256 && simpleEscapeCheck[ch]) {
        state.result += simpleEscapeMap[ch];
        state.position++;
      } else if ((tmp = escapedHexLen(ch)) > 0) {
        hexLength = tmp;
        hexResult = 0;
        for (; hexLength > 0; hexLength--) {
          ch = state.input.charCodeAt(++state.position);
          if ((tmp = fromHexCode(ch)) >= 0) {
            hexResult = (hexResult << 4) + tmp;
          } else {
            throwError(state, 'expected hexadecimal character');
          }
        }
        state.result += charFromCodepoint(hexResult);
        state.position++;
      } else {
        throwError(state, 'unknown escape sequence');
      }
      captureStart = captureEnd = state.position;
    } else if (is_EOL(ch)) {
      captureSegment(state, captureStart, captureEnd, true);
      writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
      captureStart = captureEnd = state.position;
    } else if (state.position === state.lineStart && testDocumentSeparator(state)) {
      throwError(state, 'unexpected end of the document within a double quoted scalar');
    } else {
      state.position++;
      captureEnd = state.position;
    }
  }
  throwError(state, 'unexpected end of the stream within a double quoted scalar');
}
function readFlowCollection(state, nodeIndent) {
  var readNext = true,
    _line,
    _tag = state.tag,
    _result,
    _anchor = state.anchor,
    following,
    terminator,
    isPair,
    isExplicitPair,
    isMapping,
    overridableKeys = {},
    keyNode,
    keyTag,
    valueNode,
    ch;
  ch = state.input.charCodeAt(state.position);
  if (ch === 0x5B /* [ */) {
    terminator = 0x5D; /* ] */
    isMapping = false;
    _result = [];
  } else if (ch === 0x7B /* { */) {
    terminator = 0x7D; /* } */
    isMapping = true;
    _result = {};
  } else {
    return false;
  }
  if (state.anchor !== null) {
    state.anchorMap[state.anchor] = _result;
  }
  ch = state.input.charCodeAt(++state.position);
  while (ch !== 0) {
    skipSeparationSpace(state, true, nodeIndent);
    ch = state.input.charCodeAt(state.position);
    if (ch === terminator) {
      state.position++;
      state.tag = _tag;
      state.anchor = _anchor;
      state.kind = isMapping ? 'mapping' : 'sequence';
      state.result = _result;
      return true;
    } else if (!readNext) {
      throwError(state, 'missed comma between flow collection entries');
    }
    keyTag = keyNode = valueNode = null;
    isPair = isExplicitPair = false;
    if (ch === 0x3F /* ? */) {
      following = state.input.charCodeAt(state.position + 1);
      if (is_WS_OR_EOL(following)) {
        isPair = isExplicitPair = true;
        state.position++;
        skipSeparationSpace(state, true, nodeIndent);
      }
    }
    _line = state.line;
    composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
    keyTag = state.tag;
    keyNode = state.result;
    skipSeparationSpace(state, true, nodeIndent);
    ch = state.input.charCodeAt(state.position);
    if ((isExplicitPair || state.line === _line) && ch === 0x3A /* : */) {
      isPair = true;
      ch = state.input.charCodeAt(++state.position);
      skipSeparationSpace(state, true, nodeIndent);
      composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
      valueNode = state.result;
    }
    if (isMapping) {
      storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode);
    } else if (isPair) {
      _result.push(storeMappingPair(state, null, overridableKeys, keyTag, keyNode, valueNode));
    } else {
      _result.push(keyNode);
    }
    skipSeparationSpace(state, true, nodeIndent);
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x2C /* , */) {
      readNext = true;
      ch = state.input.charCodeAt(++state.position);
    } else {
      readNext = false;
    }
  }
  throwError(state, 'unexpected end of the stream within a flow collection');
}
function readBlockScalar(state, nodeIndent) {
  var captureStart,
    folding,
    chomping = CHOMPING_CLIP,
    didReadContent = false,
    detectedIndent = false,
    textIndent = nodeIndent,
    emptyLines = 0,
    atMoreIndented = false,
    tmp,
    ch;
  ch = state.input.charCodeAt(state.position);
  if (ch === 0x7C /* | */) {
    folding = false;
  } else if (ch === 0x3E /* > */) {
    folding = true;
  } else {
    return false;
  }
  state.kind = 'scalar';
  state.result = '';
  while (ch !== 0) {
    ch = state.input.charCodeAt(++state.position);
    if (ch === 0x2B /* + */ || ch === 0x2D /* - */) {
      if (CHOMPING_CLIP === chomping) {
        chomping = ch === 0x2B /* + */ ? CHOMPING_KEEP : CHOMPING_STRIP;
      } else {
        throwError(state, 'repeat of a chomping mode identifier');
      }
    } else if ((tmp = fromDecimalCode(ch)) >= 0) {
      if (tmp === 0) {
        throwError(state, 'bad explicit indentation width of a block scalar; it cannot be less than one');
      } else if (!detectedIndent) {
        textIndent = nodeIndent + tmp - 1;
        detectedIndent = true;
      } else {
        throwError(state, 'repeat of an indentation width identifier');
      }
    } else {
      break;
    }
  }
  if (is_WHITE_SPACE(ch)) {
    do {
      ch = state.input.charCodeAt(++state.position);
    } while (is_WHITE_SPACE(ch));
    if (ch === 0x23 /* # */) {
      do {
        ch = state.input.charCodeAt(++state.position);
      } while (!is_EOL(ch) && ch !== 0);
    }
  }
  while (ch !== 0) {
    readLineBreak(state);
    state.lineIndent = 0;
    ch = state.input.charCodeAt(state.position);
    while ((!detectedIndent || state.lineIndent < textIndent) && ch === 0x20 /* Space */) {
      state.lineIndent++;
      ch = state.input.charCodeAt(++state.position);
    }
    if (!detectedIndent && state.lineIndent > textIndent) {
      textIndent = state.lineIndent;
    }
    if (is_EOL(ch)) {
      emptyLines++;
      continue;
    }

    // End of the scalar.
    if (state.lineIndent < textIndent) {
      // Perform the chomping.
      if (chomping === CHOMPING_KEEP) {
        state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
      } else if (chomping === CHOMPING_CLIP) {
        if (didReadContent) {
          // i.e. only if the scalar is not empty.
          state.result += '\n';
        }
      }

      // Break this `while` cycle and go to the funciton's epilogue.
      break;
    }

    // Folded style: use fancy rules to handle line breaks.
    if (folding) {
      // Lines starting with white space characters (more-indented lines) are not folded.
      if (is_WHITE_SPACE(ch)) {
        atMoreIndented = true;
        // except for the first content line (cf. Example 8.1)
        state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);

        // End of more-indented block.
      } else if (atMoreIndented) {
        atMoreIndented = false;
        state.result += common.repeat('\n', emptyLines + 1);

        // Just one line break - perceive as the same line.
      } else if (emptyLines === 0) {
        if (didReadContent) {
          // i.e. only if we have already read some scalar content.
          state.result += ' ';
        }

        // Several line breaks - perceive as different lines.
      } else {
        state.result += common.repeat('\n', emptyLines);
      }

      // Literal style: just add exact number of line breaks between content lines.
    } else {
      // Keep all line breaks except the header line break.
      state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
    }
    didReadContent = true;
    detectedIndent = true;
    emptyLines = 0;
    captureStart = state.position;
    while (!is_EOL(ch) && ch !== 0) {
      ch = state.input.charCodeAt(++state.position);
    }
    captureSegment(state, captureStart, state.position, false);
  }
  return true;
}
function readBlockSequence(state, nodeIndent) {
  var _line,
    _tag = state.tag,
    _anchor = state.anchor,
    _result = [],
    following,
    detected = false,
    ch;
  if (state.anchor !== null) {
    state.anchorMap[state.anchor] = _result;
  }
  ch = state.input.charCodeAt(state.position);
  while (ch !== 0) {
    if (ch !== 0x2D /* - */) {
      break;
    }
    following = state.input.charCodeAt(state.position + 1);
    if (!is_WS_OR_EOL(following)) {
      break;
    }
    detected = true;
    state.position++;
    if (skipSeparationSpace(state, true, -1)) {
      if (state.lineIndent <= nodeIndent) {
        _result.push(null);
        ch = state.input.charCodeAt(state.position);
        continue;
      }
    }
    _line = state.line;
    composeNode(state, nodeIndent, CONTEXT_BLOCK_IN, false, true);
    _result.push(state.result);
    skipSeparationSpace(state, true, -1);
    ch = state.input.charCodeAt(state.position);
    if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) {
      throwError(state, 'bad indentation of a sequence entry');
    } else if (state.lineIndent < nodeIndent) {
      break;
    }
  }
  if (detected) {
    state.tag = _tag;
    state.anchor = _anchor;
    state.kind = 'sequence';
    state.result = _result;
    return true;
  }
  return false;
}
function readBlockMapping(state, nodeIndent, flowIndent) {
  var following,
    allowCompact,
    _line,
    _pos,
    _tag = state.tag,
    _anchor = state.anchor,
    _result = {},
    overridableKeys = {},
    keyTag = null,
    keyNode = null,
    valueNode = null,
    atExplicitKey = false,
    detected = false,
    ch;
  if (state.anchor !== null) {
    state.anchorMap[state.anchor] = _result;
  }
  ch = state.input.charCodeAt(state.position);
  while (ch !== 0) {
    following = state.input.charCodeAt(state.position + 1);
    _line = state.line; // Save the current line.
    _pos = state.position;

    //
    // Explicit notation case. There are two separate blocks:
    // first for the key (denoted by "?") and second for the value (denoted by ":")
    //
    if ((ch === 0x3F /* ? */ || ch === 0x3A /* : */) && is_WS_OR_EOL(following)) {
      if (ch === 0x3F /* ? */) {
        if (atExplicitKey) {
          storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
          keyTag = keyNode = valueNode = null;
        }
        detected = true;
        atExplicitKey = true;
        allowCompact = true;
      } else if (atExplicitKey) {
        // i.e. 0x3A/* : */ === character after the explicit key.
        atExplicitKey = false;
        allowCompact = true;
      } else {
        throwError(state, 'incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line');
      }
      state.position += 1;
      ch = following;

      //
      // Implicit notation case. Flow-style node as the key first, then ":", and the value.
      //
    } else if (composeNode(state, flowIndent, CONTEXT_FLOW_OUT, false, true)) {
      if (state.line === _line) {
        ch = state.input.charCodeAt(state.position);
        while (is_WHITE_SPACE(ch)) {
          ch = state.input.charCodeAt(++state.position);
        }
        if (ch === 0x3A /* : */) {
          ch = state.input.charCodeAt(++state.position);
          if (!is_WS_OR_EOL(ch)) {
            throwError(state, 'a whitespace character is expected after the key-value separator within a block mapping');
          }
          if (atExplicitKey) {
            storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
            keyTag = keyNode = valueNode = null;
          }
          detected = true;
          atExplicitKey = false;
          allowCompact = false;
          keyTag = state.tag;
          keyNode = state.result;
        } else if (detected) {
          throwError(state, 'can not read an implicit mapping pair; a colon is missed');
        } else {
          state.tag = _tag;
          state.anchor = _anchor;
          return true; // Keep the result of `composeNode`.
        }
      } else if (detected) {
        throwError(state, 'can not read a block mapping entry; a multiline key may not be an implicit key');
      } else {
        state.tag = _tag;
        state.anchor = _anchor;
        return true; // Keep the result of `composeNode`.
      }
    } else {
      break; // Reading is done. Go to the epilogue.
    }

    //
    // Common reading code for both explicit and implicit notations.
    //
    if (state.line === _line || state.lineIndent > nodeIndent) {
      if (composeNode(state, nodeIndent, CONTEXT_BLOCK_OUT, true, allowCompact)) {
        if (atExplicitKey) {
          keyNode = state.result;
        } else {
          valueNode = state.result;
        }
      }
      if (!atExplicitKey) {
        storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _pos);
        keyTag = keyNode = valueNode = null;
      }
      skipSeparationSpace(state, true, -1);
      ch = state.input.charCodeAt(state.position);
    }
    if (state.lineIndent > nodeIndent && ch !== 0) {
      throwError(state, 'bad indentation of a mapping entry');
    } else if (state.lineIndent < nodeIndent) {
      break;
    }
  }

  //
  // Epilogue.
  //

  // Special case: last mapping's node contains only the key in explicit notation.
  if (atExplicitKey) {
    storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
  }

  // Expose the resulting mapping.
  if (detected) {
    state.tag = _tag;
    state.anchor = _anchor;
    state.kind = 'mapping';
    state.result = _result;
  }
  return detected;
}
function readTagProperty(state) {
  var _position,
    isVerbatim = false,
    isNamed = false,
    tagHandle,
    tagName,
    ch;
  ch = state.input.charCodeAt(state.position);
  if (ch !== 0x21 /* ! */) return false;
  if (state.tag !== null) {
    throwError(state, 'duplication of a tag property');
  }
  ch = state.input.charCodeAt(++state.position);
  if (ch === 0x3C /* < */) {
    isVerbatim = true;
    ch = state.input.charCodeAt(++state.position);
  } else if (ch === 0x21 /* ! */) {
    isNamed = true;
    tagHandle = '!!';
    ch = state.input.charCodeAt(++state.position);
  } else {
    tagHandle = '!';
  }
  _position = state.position;
  if (isVerbatim) {
    do {
      ch = state.input.charCodeAt(++state.position);
    } while (ch !== 0 && ch !== 0x3E /* > */);

    if (state.position < state.length) {
      tagName = state.input.slice(_position, state.position);
      ch = state.input.charCodeAt(++state.position);
    } else {
      throwError(state, 'unexpected end of the stream within a verbatim tag');
    }
  } else {
    while (ch !== 0 && !is_WS_OR_EOL(ch)) {
      if (ch === 0x21 /* ! */) {
        if (!isNamed) {
          tagHandle = state.input.slice(_position - 1, state.position + 1);
          if (!PATTERN_TAG_HANDLE.test(tagHandle)) {
            throwError(state, 'named tag handle cannot contain such characters');
          }
          isNamed = true;
          _position = state.position + 1;
        } else {
          throwError(state, 'tag suffix cannot contain exclamation marks');
        }
      }
      ch = state.input.charCodeAt(++state.position);
    }
    tagName = state.input.slice(_position, state.position);
    if (PATTERN_FLOW_INDICATORS.test(tagName)) {
      throwError(state, 'tag suffix cannot contain flow indicator characters');
    }
  }
  if (tagName && !PATTERN_TAG_URI.test(tagName)) {
    throwError(state, 'tag name cannot contain such characters: ' + tagName);
  }
  if (isVerbatim) {
    state.tag = tagName;
  } else if (_hasOwnProperty.call(state.tagMap, tagHandle)) {
    state.tag = state.tagMap[tagHandle] + tagName;
  } else if (tagHandle === '!') {
    state.tag = '!' + tagName;
  } else if (tagHandle === '!!') {
    state.tag = 'tag:yaml.org,2002:' + tagName;
  } else {
    throwError(state, 'undeclared tag handle "' + tagHandle + '"');
  }
  return true;
}
function readAnchorProperty(state) {
  var _position, ch;
  ch = state.input.charCodeAt(state.position);
  if (ch !== 0x26 /* & */) return false;
  if (state.anchor !== null) {
    throwError(state, 'duplication of an anchor property');
  }
  ch = state.input.charCodeAt(++state.position);
  _position = state.position;
  while (ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch)) {
    ch = state.input.charCodeAt(++state.position);
  }
  if (state.position === _position) {
    throwError(state, 'name of an anchor node must contain at least one character');
  }
  state.anchor = state.input.slice(_position, state.position);
  return true;
}
function readAlias(state) {
  var _position, alias, ch;
  ch = state.input.charCodeAt(state.position);
  if (ch !== 0x2A /* * */) return false;
  ch = state.input.charCodeAt(++state.position);
  _position = state.position;
  while (ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch)) {
    ch = state.input.charCodeAt(++state.position);
  }
  if (state.position === _position) {
    throwError(state, 'name of an alias node must contain at least one character');
  }
  alias = state.input.slice(_position, state.position);
  if (!_hasOwnProperty.call(state.anchorMap, alias)) {
    throwError(state, 'unidentified alias "' + alias + '"');
  }
  state.result = state.anchorMap[alias];
  skipSeparationSpace(state, true, -1);
  return true;
}
function composeNode(state, parentIndent, nodeContext, allowToSeek, allowCompact) {
  var allowBlockStyles,
    allowBlockScalars,
    allowBlockCollections,
    indentStatus = 1,
    // 1: this>parent, 0: this=parent, -1: this<parent
    atNewLine = false,
    hasContent = false,
    typeIndex,
    typeQuantity,
    type,
    flowIndent,
    blockIndent;
  if (state.listener !== null) {
    state.listener('open', state);
  }
  state.tag = null;
  state.anchor = null;
  state.kind = null;
  state.result = null;
  allowBlockStyles = allowBlockScalars = allowBlockCollections = CONTEXT_BLOCK_OUT === nodeContext || CONTEXT_BLOCK_IN === nodeContext;
  if (allowToSeek) {
    if (skipSeparationSpace(state, true, -1)) {
      atNewLine = true;
      if (state.lineIndent > parentIndent) {
        indentStatus = 1;
      } else if (state.lineIndent === parentIndent) {
        indentStatus = 0;
      } else if (state.lineIndent < parentIndent) {
        indentStatus = -1;
      }
    }
  }
  if (indentStatus === 1) {
    while (readTagProperty(state) || readAnchorProperty(state)) {
      if (skipSeparationSpace(state, true, -1)) {
        atNewLine = true;
        allowBlockCollections = allowBlockStyles;
        if (state.lineIndent > parentIndent) {
          indentStatus = 1;
        } else if (state.lineIndent === parentIndent) {
          indentStatus = 0;
        } else if (state.lineIndent < parentIndent) {
          indentStatus = -1;
        }
      } else {
        allowBlockCollections = false;
      }
    }
  }
  if (allowBlockCollections) {
    allowBlockCollections = atNewLine || allowCompact;
  }
  if (indentStatus === 1 || CONTEXT_BLOCK_OUT === nodeContext) {
    if (CONTEXT_FLOW_IN === nodeContext || CONTEXT_FLOW_OUT === nodeContext) {
      flowIndent = parentIndent;
    } else {
      flowIndent = parentIndent + 1;
    }
    blockIndent = state.position - state.lineStart;
    if (indentStatus === 1) {
      if (allowBlockCollections && (readBlockSequence(state, blockIndent) || readBlockMapping(state, blockIndent, flowIndent)) || readFlowCollection(state, flowIndent)) {
        hasContent = true;
      } else {
        if (allowBlockScalars && readBlockScalar(state, flowIndent) || readSingleQuotedScalar(state, flowIndent) || readDoubleQuotedScalar(state, flowIndent)) {
          hasContent = true;
        } else if (readAlias(state)) {
          hasContent = true;
          if (state.tag !== null || state.anchor !== null) {
            throwError(state, 'alias node should not have any properties');
          }
        } else if (readPlainScalar(state, flowIndent, CONTEXT_FLOW_IN === nodeContext)) {
          hasContent = true;
          if (state.tag === null) {
            state.tag = '?';
          }
        }
        if (state.anchor !== null) {
          state.anchorMap[state.anchor] = state.result;
        }
      }
    } else if (indentStatus === 0) {
      // Special case: block sequences are allowed to have same indentation level as the parent.
      // http://www.yaml.org/spec/1.2/spec.html#id2799784
      hasContent = allowBlockCollections && readBlockSequence(state, blockIndent);
    }
  }
  if (state.tag !== null && state.tag !== '!') {
    if (state.tag === '?') {
      // Implicit resolving is not allowed for non-scalar types, and '?'
      // non-specific tag is only automatically assigned to plain scalars.
      //
      // We only need to check kind conformity in case user explicitly assigns '?'
      // tag, for example like this: "!<?> [0]"
      //
      if (state.result !== null && state.kind !== 'scalar') {
        throwError(state, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + state.kind + '"');
      }
      for (typeIndex = 0, typeQuantity = state.implicitTypes.length; typeIndex < typeQuantity; typeIndex += 1) {
        type = state.implicitTypes[typeIndex];
        if (type.resolve(state.result)) {
          // `state.result` updated in resolver if matched
          state.result = type.construct(state.result);
          state.tag = type.tag;
          if (state.anchor !== null) {
            state.anchorMap[state.anchor] = state.result;
          }
          break;
        }
      }
    } else if (_hasOwnProperty.call(state.typeMap[state.kind || 'fallback'], state.tag)) {
      type = state.typeMap[state.kind || 'fallback'][state.tag];
      if (state.result !== null && type.kind !== state.kind) {
        throwError(state, 'unacceptable node kind for !<' + state.tag + '> tag; it should be "' + type.kind + '", not "' + state.kind + '"');
      }
      if (!type.resolve(state.result)) {
        // `state.result` updated in resolver if matched
        throwError(state, 'cannot resolve a node with !<' + state.tag + '> explicit tag');
      } else {
        state.result = type.construct(state.result);
        if (state.anchor !== null) {
          state.anchorMap[state.anchor] = state.result;
        }
      }
    } else {
      throwError(state, 'unknown tag !<' + state.tag + '>');
    }
  }
  if (state.listener !== null) {
    state.listener('close', state);
  }
  return state.tag !== null || state.anchor !== null || hasContent;
}
function readDocument(state) {
  var documentStart = state.position,
    _position,
    directiveName,
    directiveArgs,
    hasDirectives = false,
    ch;
  state.version = null;
  state.checkLineBreaks = state.legacy;
  state.tagMap = {};
  state.anchorMap = {};
  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
    skipSeparationSpace(state, true, -1);
    ch = state.input.charCodeAt(state.position);
    if (state.lineIndent > 0 || ch !== 0x25 /* % */) {
      break;
    }
    hasDirectives = true;
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while (ch !== 0 && !is_WS_OR_EOL(ch)) {
      ch = state.input.charCodeAt(++state.position);
    }
    directiveName = state.input.slice(_position, state.position);
    directiveArgs = [];
    if (directiveName.length < 1) {
      throwError(state, 'directive name must not be less than one character in length');
    }
    while (ch !== 0) {
      while (is_WHITE_SPACE(ch)) {
        ch = state.input.charCodeAt(++state.position);
      }
      if (ch === 0x23 /* # */) {
        do {
          ch = state.input.charCodeAt(++state.position);
        } while (ch !== 0 && !is_EOL(ch));
        break;
      }
      if (is_EOL(ch)) break;
      _position = state.position;
      while (ch !== 0 && !is_WS_OR_EOL(ch)) {
        ch = state.input.charCodeAt(++state.position);
      }
      directiveArgs.push(state.input.slice(_position, state.position));
    }
    if (ch !== 0) readLineBreak(state);
    if (_hasOwnProperty.call(directiveHandlers, directiveName)) {
      directiveHandlers[directiveName](state, directiveName, directiveArgs);
    } else {
      throwWarning(state, 'unknown document directive "' + directiveName + '"');
    }
  }
  skipSeparationSpace(state, true, -1);
  if (state.lineIndent === 0 && state.input.charCodeAt(state.position) === 0x2D /* - */ && state.input.charCodeAt(state.position + 1) === 0x2D /* - */ && state.input.charCodeAt(state.position + 2) === 0x2D /* - */) {
    state.position += 3;
    skipSeparationSpace(state, true, -1);
  } else if (hasDirectives) {
    throwError(state, 'directives end mark is expected');
  }
  composeNode(state, state.lineIndent - 1, CONTEXT_BLOCK_OUT, false, true);
  skipSeparationSpace(state, true, -1);
  if (state.checkLineBreaks && PATTERN_NON_ASCII_LINE_BREAKS.test(state.input.slice(documentStart, state.position))) {
    throwWarning(state, 'non-ASCII line breaks are interpreted as content');
  }
  state.documents.push(state.result);
  if (state.position === state.lineStart && testDocumentSeparator(state)) {
    if (state.input.charCodeAt(state.position) === 0x2E /* . */) {
      state.position += 3;
      skipSeparationSpace(state, true, -1);
    }
    return;
  }
  if (state.position < state.length - 1) {
    throwError(state, 'end of the stream or a document separator is expected');
  } else {
    return;
  }
}
function loadDocuments(input, options) {
  input = String(input);
  options = options || {};
  if (input.length !== 0) {
    // Add tailing `\n` if not exists
    if (input.charCodeAt(input.length - 1) !== 0x0A /* LF */ && input.charCodeAt(input.length - 1) !== 0x0D /* CR */) {
      input += '\n';
    }

    // Strip BOM
    if (input.charCodeAt(0) === 0xFEFF) {
      input = input.slice(1);
    }
  }
  var state = new State(input, options);
  var nullpos = input.indexOf('\0');
  if (nullpos !== -1) {
    state.position = nullpos;
    throwError(state, 'null byte is not allowed in input');
  }

  // Use 0 as string terminator. That significantly simplifies bounds check.
  state.input += '\0';
  while (state.input.charCodeAt(state.position) === 0x20 /* Space */) {
    state.lineIndent += 1;
    state.position += 1;
  }
  while (state.position < state.length - 1) {
    readDocument(state);
  }
  return state.documents;
}
function loadAll(input, iterator, options) {
  if (iterator !== null && typeof iterator === 'object' && typeof options === 'undefined') {
    options = iterator;
    iterator = null;
  }
  var documents = loadDocuments(input, options);
  if (typeof iterator !== 'function') {
    return documents;
  }
  for (var index = 0, length = documents.length; index < length; index += 1) {
    iterator(documents[index]);
  }
}
function load(input, options) {
  var documents = loadDocuments(input, options);
  if (documents.length === 0) {
    /*eslint-disable no-undefined*/
    return undefined;
  } else if (documents.length === 1) {
    return documents[0];
  }
  throw new YAMLException('expected a single document in the stream, but found more');
}
function safeLoadAll(input, iterator, options) {
  if (typeof iterator === 'object' && iterator !== null && typeof options === 'undefined') {
    options = iterator;
    iterator = null;
  }
  return loadAll(input, iterator, common.extend({
    schema: DEFAULT_SAFE_SCHEMA
  }, options));
}
function safeLoad(input, options) {
  return load(input, common.extend({
    schema: DEFAULT_SAFE_SCHEMA
  }, options));
}
module.exports.loadAll = loadAll;
module.exports.load = load;
module.exports.safeLoadAll = safeLoadAll;
module.exports.safeLoad = safeLoad;

/***/ }),

/***/ 64279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var common = __webpack_require__(16555);
function Mark(name, buffer, position, line, column) {
  this.name = name;
  this.buffer = buffer;
  this.position = position;
  this.line = line;
  this.column = column;
}
Mark.prototype.getSnippet = function getSnippet(indent, maxLength) {
  var head, start, tail, end, snippet;
  if (!this.buffer) return null;
  indent = indent || 4;
  maxLength = maxLength || 75;
  head = '';
  start = this.position;
  while (start > 0 && '\x00\r\n\x85\u2028\u2029'.indexOf(this.buffer.charAt(start - 1)) === -1) {
    start -= 1;
    if (this.position - start > maxLength / 2 - 1) {
      head = ' ... ';
      start += 5;
      break;
    }
  }
  tail = '';
  end = this.position;
  while (end < this.buffer.length && '\x00\r\n\x85\u2028\u2029'.indexOf(this.buffer.charAt(end)) === -1) {
    end += 1;
    if (end - this.position > maxLength / 2 - 1) {
      tail = ' ... ';
      end -= 5;
      break;
    }
  }
  snippet = this.buffer.slice(start, end);
  return common.repeat(' ', indent) + head + snippet + tail + '\n' + common.repeat(' ', indent + this.position - start + head.length) + '^';
};
Mark.prototype.toString = function toString(compact) {
  var snippet,
    where = '';
  if (this.name) {
    where += 'in "' + this.name + '" ';
  }
  where += 'at line ' + (this.line + 1) + ', column ' + (this.column + 1);
  if (!compact) {
    snippet = this.getSnippet();
    if (snippet) {
      where += ':\n' + snippet;
    }
  }
  return where;
};
module.exports = Mark;

/***/ }),

/***/ 29130:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/*eslint-disable max-len*/
var common = __webpack_require__(16555);
var YAMLException = __webpack_require__(21087);
var Type = __webpack_require__(28606);
function compileList(schema, name, result) {
  var exclude = [];
  schema.include.forEach(function (includedSchema) {
    result = compileList(includedSchema, name, result);
  });
  schema[name].forEach(function (currentType) {
    result.forEach(function (previousType, previousIndex) {
      if (previousType.tag === currentType.tag && previousType.kind === currentType.kind) {
        exclude.push(previousIndex);
      }
    });
    result.push(currentType);
  });
  return result.filter(function (type, index) {
    return exclude.indexOf(index) === -1;
  });
}
function compileMap( /* lists... */
) {
  var result = {
      scalar: {},
      sequence: {},
      mapping: {},
      fallback: {}
    },
    index,
    length;
  function collectType(type) {
    result[type.kind][type.tag] = result['fallback'][type.tag] = type;
  }
  for (index = 0, length = arguments.length; index < length; index += 1) {
    arguments[index].forEach(collectType);
  }
  return result;
}
function Schema(definition) {
  this.include = definition.include || [];
  this.implicit = definition.implicit || [];
  this.explicit = definition.explicit || [];
  this.implicit.forEach(function (type) {
    if (type.loadKind && type.loadKind !== 'scalar') {
      throw new YAMLException('There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.');
    }
  });
  this.compiledImplicit = compileList(this, 'implicit', []);
  this.compiledExplicit = compileList(this, 'explicit', []);
  this.compiledTypeMap = compileMap(this.compiledImplicit, this.compiledExplicit);
}
Schema.DEFAULT = null;
Schema.create = function createSchema() {
  var schemas, types;
  switch (arguments.length) {
    case 1:
      schemas = Schema.DEFAULT;
      types = arguments[0];
      break;
    case 2:
      schemas = arguments[0];
      types = arguments[1];
      break;
    default:
      throw new YAMLException('Wrong number of arguments for Schema.create function');
  }
  schemas = common.toArray(schemas);
  types = common.toArray(types);
  if (!schemas.every(function (schema) {
    return schema instanceof Schema;
  })) {
    throw new YAMLException('Specified list of super schemas (or a single Schema object) contains a non-Schema object.');
  }
  if (!types.every(function (type) {
    return type instanceof Type;
  })) {
    throw new YAMLException('Specified list of YAML types (or a single Type object) contains a non-Type object.');
  }
  return new Schema({
    include: schemas,
    explicit: types
  });
};
module.exports = Schema;

/***/ }),

/***/ 25644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Standard YAML's Core schema.
// http://www.yaml.org/spec/1.2/spec.html#id2804923
//
// NOTE: JS-YAML does not support schema-specific tag resolution restrictions.
// So, Core schema has no distinctions from JSON schema is JS-YAML.



var Schema = __webpack_require__(29130);
module.exports = new Schema({
  include: [__webpack_require__(4431)]
});

/***/ }),

/***/ 88424:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// JS-YAML's default schema for `load` function.
// It is not described in the YAML specification.
//
// This schema is based on JS-YAML's default safe schema and includes
// JavaScript-specific types: !!js/undefined, !!js/regexp and !!js/function.
//
// Also this schema is used as default base schema at `Schema.create` function.



var Schema = __webpack_require__(29130);
module.exports = Schema.DEFAULT = new Schema({
  include: [__webpack_require__(57378)],
  explicit: [__webpack_require__(52868), __webpack_require__(42673), __webpack_require__(31930)]
});

/***/ }),

/***/ 57378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// JS-YAML's default schema for `safeLoad` function.
// It is not described in the YAML specification.
//
// This schema is based on standard YAML's Core schema and includes most of
// extra types described at YAML tag repository. (http://yaml.org/type/)



var Schema = __webpack_require__(29130);
module.exports = new Schema({
  include: [__webpack_require__(25644)],
  implicit: [__webpack_require__(56167), __webpack_require__(7802)],
  explicit: [__webpack_require__(8251), __webpack_require__(18613), __webpack_require__(92868), __webpack_require__(83265)]
});

/***/ }),

/***/ 32961:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Standard YAML's Failsafe schema.
// http://www.yaml.org/spec/1.2/spec.html#id2802346



var Schema = __webpack_require__(29130);
module.exports = new Schema({
  explicit: [__webpack_require__(75602), __webpack_require__(26578), __webpack_require__(31978)]
});

/***/ }),

/***/ 4431:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Standard YAML's JSON schema.
// http://www.yaml.org/spec/1.2/spec.html#id2803231
//
// NOTE: JS-YAML does not support schema-specific tag resolution restrictions.
// So, this schema is not such strict as defined in the YAML specification.
// It allows numbers in binary notaion, use `Null` and `NULL` as `null`, etc.



var Schema = __webpack_require__(29130);
module.exports = new Schema({
  include: [__webpack_require__(32961)],
  implicit: [__webpack_require__(12283), __webpack_require__(95472), __webpack_require__(9219), __webpack_require__(67890)]
});

/***/ }),

/***/ 28606:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var YAMLException = __webpack_require__(21087);
var TYPE_CONSTRUCTOR_OPTIONS = ['kind', 'resolve', 'construct', 'instanceOf', 'predicate', 'represent', 'defaultStyle', 'styleAliases'];
var YAML_NODE_KINDS = ['scalar', 'sequence', 'mapping'];
function compileStyleAliases(map) {
  var result = {};
  if (map !== null) {
    Object.keys(map).forEach(function (style) {
      map[style].forEach(function (alias) {
        result[String(alias)] = style;
      });
    });
  }
  return result;
}
function Type(tag, options) {
  options = options || {};
  Object.keys(options).forEach(function (name) {
    if (TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) {
      throw new YAMLException('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
    }
  });

  // TODO: Add tag format check.
  this.tag = tag;
  this.kind = options['kind'] || null;
  this.resolve = options['resolve'] || function () {
    return true;
  };
  this.construct = options['construct'] || function (data) {
    return data;
  };
  this.instanceOf = options['instanceOf'] || null;
  this.predicate = options['predicate'] || null;
  this.represent = options['represent'] || null;
  this.defaultStyle = options['defaultStyle'] || null;
  this.styleAliases = compileStyleAliases(options['styleAliases'] || null);
  if (YAML_NODE_KINDS.indexOf(this.kind) === -1) {
    throw new YAMLException('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
  }
}
module.exports = Type;

/***/ }),

/***/ 8251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/*eslint-disable no-bitwise*/
var NodeBuffer;
try {
  // A trick for browserified version, to not include `Buffer` shim
  var _require = undefined;
  NodeBuffer = (__webpack_require__(80365)/* .Buffer */ .lW);
} catch (__) {}
var Type = __webpack_require__(28606);

// [ 64, 65, 66 ] -> [ padding, CR, LF ]
var BASE64_MAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r';
function resolveYamlBinary(data) {
  if (data === null) return false;
  var code,
    idx,
    bitlen = 0,
    max = data.length,
    map = BASE64_MAP;

  // Convert one by one.
  for (idx = 0; idx < max; idx++) {
    code = map.indexOf(data.charAt(idx));

    // Skip CR/LF
    if (code > 64) continue;

    // Fail on illegal characters
    if (code < 0) return false;
    bitlen += 6;
  }

  // If there are any bits left, source was corrupted
  return bitlen % 8 === 0;
}
function constructYamlBinary(data) {
  var idx,
    tailbits,
    input = data.replace(/[\r\n=]/g, ''),
    // remove CR/LF & padding to simplify scan
    max = input.length,
    map = BASE64_MAP,
    bits = 0,
    result = [];

  // Collect by 6*4 bits (3 bytes)

  for (idx = 0; idx < max; idx++) {
    if (idx % 4 === 0 && idx) {
      result.push(bits >> 16 & 0xFF);
      result.push(bits >> 8 & 0xFF);
      result.push(bits & 0xFF);
    }
    bits = bits << 6 | map.indexOf(input.charAt(idx));
  }

  // Dump tail

  tailbits = max % 4 * 6;
  if (tailbits === 0) {
    result.push(bits >> 16 & 0xFF);
    result.push(bits >> 8 & 0xFF);
    result.push(bits & 0xFF);
  } else if (tailbits === 18) {
    result.push(bits >> 10 & 0xFF);
    result.push(bits >> 2 & 0xFF);
  } else if (tailbits === 12) {
    result.push(bits >> 4 & 0xFF);
  }

  // Wrap into Buffer for NodeJS and leave Array for browser
  if (NodeBuffer) {
    // Support node 6.+ Buffer API when available
    return NodeBuffer.from ? NodeBuffer.from(result) : new NodeBuffer(result);
  }
  return result;
}
function representYamlBinary(object /*, style*/) {
  var result = '',
    bits = 0,
    idx,
    tail,
    max = object.length,
    map = BASE64_MAP;

  // Convert every three bytes to 4 ASCII characters.

  for (idx = 0; idx < max; idx++) {
    if (idx % 3 === 0 && idx) {
      result += map[bits >> 18 & 0x3F];
      result += map[bits >> 12 & 0x3F];
      result += map[bits >> 6 & 0x3F];
      result += map[bits & 0x3F];
    }
    bits = (bits << 8) + object[idx];
  }

  // Dump tail

  tail = max % 3;
  if (tail === 0) {
    result += map[bits >> 18 & 0x3F];
    result += map[bits >> 12 & 0x3F];
    result += map[bits >> 6 & 0x3F];
    result += map[bits & 0x3F];
  } else if (tail === 2) {
    result += map[bits >> 10 & 0x3F];
    result += map[bits >> 4 & 0x3F];
    result += map[bits << 2 & 0x3F];
    result += map[64];
  } else if (tail === 1) {
    result += map[bits >> 2 & 0x3F];
    result += map[bits << 4 & 0x3F];
    result += map[64];
    result += map[64];
  }
  return result;
}
function isBinary(object) {
  return NodeBuffer && NodeBuffer.isBuffer(object);
}
module.exports = new Type('tag:yaml.org,2002:binary', {
  kind: 'scalar',
  resolve: resolveYamlBinary,
  construct: constructYamlBinary,
  predicate: isBinary,
  represent: representYamlBinary
});

/***/ }),

/***/ 95472:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(28606);
function resolveYamlBoolean(data) {
  if (data === null) return false;
  var max = data.length;
  return max === 4 && (data === 'true' || data === 'True' || data === 'TRUE') || max === 5 && (data === 'false' || data === 'False' || data === 'FALSE');
}
function constructYamlBoolean(data) {
  return data === 'true' || data === 'True' || data === 'TRUE';
}
function isBoolean(object) {
  return Object.prototype.toString.call(object) === '[object Boolean]';
}
module.exports = new Type('tag:yaml.org,2002:bool', {
  kind: 'scalar',
  resolve: resolveYamlBoolean,
  construct: constructYamlBoolean,
  predicate: isBoolean,
  represent: {
    lowercase: function (object) {
      return object ? 'true' : 'false';
    },
    uppercase: function (object) {
      return object ? 'TRUE' : 'FALSE';
    },
    camelcase: function (object) {
      return object ? 'True' : 'False';
    }
  },
  defaultStyle: 'lowercase'
});

/***/ }),

/***/ 67890:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var common = __webpack_require__(16555);
var Type = __webpack_require__(28606);
var YAML_FLOAT_PATTERN = new RegExp(
// 2.5e4, 2.5 and integers
'^(?:[-+]?(?:0|[1-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?' +
// .2e4, .2
// special case, seems not from spec
'|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?' +
// 20:59
'|[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\\.[0-9_]*' +
// .inf
'|[-+]?\\.(?:inf|Inf|INF)' +
// .nan
'|\\.(?:nan|NaN|NAN))$');
function resolveYamlFloat(data) {
  if (data === null) return false;
  if (!YAML_FLOAT_PATTERN.test(data) ||
  // Quick hack to not allow integers end with `_`
  // Probably should update regexp & check speed
  data[data.length - 1] === '_') {
    return false;
  }
  return true;
}
function constructYamlFloat(data) {
  var value, sign, base, digits;
  value = data.replace(/_/g, '').toLowerCase();
  sign = value[0] === '-' ? -1 : 1;
  digits = [];
  if ('+-'.indexOf(value[0]) >= 0) {
    value = value.slice(1);
  }
  if (value === '.inf') {
    return sign === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
  } else if (value === '.nan') {
    return NaN;
  } else if (value.indexOf(':') >= 0) {
    value.split(':').forEach(function (v) {
      digits.unshift(parseFloat(v, 10));
    });
    value = 0.0;
    base = 1;
    digits.forEach(function (d) {
      value += d * base;
      base *= 60;
    });
    return sign * value;
  }
  return sign * parseFloat(value, 10);
}
var SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;
function representYamlFloat(object, style) {
  var res;
  if (isNaN(object)) {
    switch (style) {
      case 'lowercase':
        return '.nan';
      case 'uppercase':
        return '.NAN';
      case 'camelcase':
        return '.NaN';
    }
  } else if (Number.POSITIVE_INFINITY === object) {
    switch (style) {
      case 'lowercase':
        return '.inf';
      case 'uppercase':
        return '.INF';
      case 'camelcase':
        return '.Inf';
    }
  } else if (Number.NEGATIVE_INFINITY === object) {
    switch (style) {
      case 'lowercase':
        return '-.inf';
      case 'uppercase':
        return '-.INF';
      case 'camelcase':
        return '-.Inf';
    }
  } else if (common.isNegativeZero(object)) {
    return '-0.0';
  }
  res = object.toString(10);

  // JS stringifier can build scientific format without dots: 5e-100,
  // while YAML requres dot: 5.e-100. Fix it with simple hack

  return SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace('e', '.e') : res;
}
function isFloat(object) {
  return Object.prototype.toString.call(object) === '[object Number]' && (object % 1 !== 0 || common.isNegativeZero(object));
}
module.exports = new Type('tag:yaml.org,2002:float', {
  kind: 'scalar',
  resolve: resolveYamlFloat,
  construct: constructYamlFloat,
  predicate: isFloat,
  represent: representYamlFloat,
  defaultStyle: 'lowercase'
});

/***/ }),

/***/ 9219:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var common = __webpack_require__(16555);
var Type = __webpack_require__(28606);
function isHexCode(c) {
  return 0x30 /* 0 */ <= c && c <= 0x39 /* 9 */ || 0x41 /* A */ <= c && c <= 0x46 /* F */ || 0x61 /* a */ <= c && c <= 0x66 /* f */;
}

function isOctCode(c) {
  return 0x30 /* 0 */ <= c && c <= 0x37 /* 7 */;
}

function isDecCode(c) {
  return 0x30 /* 0 */ <= c && c <= 0x39 /* 9 */;
}

function resolveYamlInteger(data) {
  if (data === null) return false;
  var max = data.length,
    index = 0,
    hasDigits = false,
    ch;
  if (!max) return false;
  ch = data[index];

  // sign
  if (ch === '-' || ch === '+') {
    ch = data[++index];
  }
  if (ch === '0') {
    // 0
    if (index + 1 === max) return true;
    ch = data[++index];

    // base 2, base 8, base 16

    if (ch === 'b') {
      // base 2
      index++;
      for (; index < max; index++) {
        ch = data[index];
        if (ch === '_') continue;
        if (ch !== '0' && ch !== '1') return false;
        hasDigits = true;
      }
      return hasDigits && ch !== '_';
    }
    if (ch === 'x') {
      // base 16
      index++;
      for (; index < max; index++) {
        ch = data[index];
        if (ch === '_') continue;
        if (!isHexCode(data.charCodeAt(index))) return false;
        hasDigits = true;
      }
      return hasDigits && ch !== '_';
    }

    // base 8
    for (; index < max; index++) {
      ch = data[index];
      if (ch === '_') continue;
      if (!isOctCode(data.charCodeAt(index))) return false;
      hasDigits = true;
    }
    return hasDigits && ch !== '_';
  }

  // base 10 (except 0) or base 60

  // value should not start with `_`;
  if (ch === '_') return false;
  for (; index < max; index++) {
    ch = data[index];
    if (ch === '_') continue;
    if (ch === ':') break;
    if (!isDecCode(data.charCodeAt(index))) {
      return false;
    }
    hasDigits = true;
  }

  // Should have digits and should not end with `_`
  if (!hasDigits || ch === '_') return false;

  // if !base60 - done;
  if (ch !== ':') return true;

  // base60 almost not used, no needs to optimize
  return /^(:[0-5]?[0-9])+$/.test(data.slice(index));
}
function constructYamlInteger(data) {
  var value = data,
    sign = 1,
    ch,
    base,
    digits = [];
  if (value.indexOf('_') !== -1) {
    value = value.replace(/_/g, '');
  }
  ch = value[0];
  if (ch === '-' || ch === '+') {
    if (ch === '-') sign = -1;
    value = value.slice(1);
    ch = value[0];
  }
  if (value === '0') return 0;
  if (ch === '0') {
    if (value[1] === 'b') return sign * parseInt(value.slice(2), 2);
    if (value[1] === 'x') return sign * parseInt(value, 16);
    return sign * parseInt(value, 8);
  }
  if (value.indexOf(':') !== -1) {
    value.split(':').forEach(function (v) {
      digits.unshift(parseInt(v, 10));
    });
    value = 0;
    base = 1;
    digits.forEach(function (d) {
      value += d * base;
      base *= 60;
    });
    return sign * value;
  }
  return sign * parseInt(value, 10);
}
function isInteger(object) {
  return Object.prototype.toString.call(object) === '[object Number]' && object % 1 === 0 && !common.isNegativeZero(object);
}
module.exports = new Type('tag:yaml.org,2002:int', {
  kind: 'scalar',
  resolve: resolveYamlInteger,
  construct: constructYamlInteger,
  predicate: isInteger,
  represent: {
    binary: function (obj) {
      return obj >= 0 ? '0b' + obj.toString(2) : '-0b' + obj.toString(2).slice(1);
    },
    octal: function (obj) {
      return obj >= 0 ? '0' + obj.toString(8) : '-0' + obj.toString(8).slice(1);
    },
    decimal: function (obj) {
      return obj.toString(10);
    },
    /* eslint-disable max-len */
    hexadecimal: function (obj) {
      return obj >= 0 ? '0x' + obj.toString(16).toUpperCase() : '-0x' + obj.toString(16).toUpperCase().slice(1);
    }
  },
  defaultStyle: 'decimal',
  styleAliases: {
    binary: [2, 'bin'],
    octal: [8, 'oct'],
    decimal: [10, 'dec'],
    hexadecimal: [16, 'hex']
  }
});

/***/ }),

/***/ 31930:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var esprima;

// Browserified version does not have esprima
//
// 1. For node.js just require module as deps
// 2. For browser try to require mudule via external AMD system.
//    If not found - try to fallback to window.esprima. If not
//    found too - then fail to parse.
//
try {
  // workaround to exclude package from browserify list.
  var _require = undefined;
  esprima = __webpack_require__(33100);
} catch (_) {
  /* eslint-disable no-redeclare */
  /* global window */
  if (typeof window !== 'undefined') esprima = window.esprima;
}
var Type = __webpack_require__(28606);
function resolveJavascriptFunction(data) {
  if (data === null) return false;
  try {
    var source = '(' + data + ')',
      ast = esprima.parse(source, {
        range: true
      });
    if (ast.type !== 'Program' || ast.body.length !== 1 || ast.body[0].type !== 'ExpressionStatement' || ast.body[0].expression.type !== 'ArrowFunctionExpression' && ast.body[0].expression.type !== 'FunctionExpression') {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
function constructJavascriptFunction(data) {
  /*jslint evil:true*/

  var source = '(' + data + ')',
    ast = esprima.parse(source, {
      range: true
    }),
    params = [],
    body;
  if (ast.type !== 'Program' || ast.body.length !== 1 || ast.body[0].type !== 'ExpressionStatement' || ast.body[0].expression.type !== 'ArrowFunctionExpression' && ast.body[0].expression.type !== 'FunctionExpression') {
    throw new Error('Failed to resolve function');
  }
  ast.body[0].expression.params.forEach(function (param) {
    params.push(param.name);
  });
  body = ast.body[0].expression.body.range;

  // Esprima's ranges include the first '{' and the last '}' characters on
  // function expressions. So cut them out.
  if (ast.body[0].expression.body.type === 'BlockStatement') {
    /*eslint-disable no-new-func*/
    return new Function(params, source.slice(body[0] + 1, body[1] - 1));
  }
  // ES6 arrow functions can omit the BlockStatement. In that case, just return
  // the body.
  /*eslint-disable no-new-func*/
  return new Function(params, 'return ' + source.slice(body[0], body[1]));
}
function representJavascriptFunction(object /*, style*/) {
  return object.toString();
}
function isFunction(object) {
  return Object.prototype.toString.call(object) === '[object Function]';
}
module.exports = new Type('tag:yaml.org,2002:js/function', {
  kind: 'scalar',
  resolve: resolveJavascriptFunction,
  construct: constructJavascriptFunction,
  predicate: isFunction,
  represent: representJavascriptFunction
});

/***/ }),

/***/ 42673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(28606);
function resolveJavascriptRegExp(data) {
  if (data === null) return false;
  if (data.length === 0) return false;
  var regexp = data,
    tail = /\/([gim]*)$/.exec(data),
    modifiers = '';

  // if regexp starts with '/' it can have modifiers and must be properly closed
  // `/foo/gim` - modifiers tail can be maximum 3 chars
  if (regexp[0] === '/') {
    if (tail) modifiers = tail[1];
    if (modifiers.length > 3) return false;
    // if expression starts with /, is should be properly terminated
    if (regexp[regexp.length - modifiers.length - 1] !== '/') return false;
  }
  return true;
}
function constructJavascriptRegExp(data) {
  var regexp = data,
    tail = /\/([gim]*)$/.exec(data),
    modifiers = '';

  // `/foo/gim` - tail can be maximum 4 chars
  if (regexp[0] === '/') {
    if (tail) modifiers = tail[1];
    regexp = regexp.slice(1, regexp.length - modifiers.length - 1);
  }
  return new RegExp(regexp, modifiers);
}
function representJavascriptRegExp(object /*, style*/) {
  var result = '/' + object.source + '/';
  if (object.global) result += 'g';
  if (object.multiline) result += 'm';
  if (object.ignoreCase) result += 'i';
  return result;
}
function isRegExp(object) {
  return Object.prototype.toString.call(object) === '[object RegExp]';
}
module.exports = new Type('tag:yaml.org,2002:js/regexp', {
  kind: 'scalar',
  resolve: resolveJavascriptRegExp,
  construct: constructJavascriptRegExp,
  predicate: isRegExp,
  represent: representJavascriptRegExp
});

/***/ }),

/***/ 52868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(28606);
function resolveJavascriptUndefined() {
  return true;
}
function constructJavascriptUndefined() {
  /*eslint-disable no-undefined*/
  return undefined;
}
function representJavascriptUndefined() {
  return '';
}
function isUndefined(object) {
  return typeof object === 'undefined';
}
module.exports = new Type('tag:yaml.org,2002:js/undefined', {
  kind: 'scalar',
  resolve: resolveJavascriptUndefined,
  construct: constructJavascriptUndefined,
  predicate: isUndefined,
  represent: representJavascriptUndefined
});

/***/ }),

/***/ 31978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(28606);
module.exports = new Type('tag:yaml.org,2002:map', {
  kind: 'mapping',
  construct: function (data) {
    return data !== null ? data : {};
  }
});

/***/ }),

/***/ 7802:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(28606);
function resolveYamlMerge(data) {
  return data === '<<' || data === null;
}
module.exports = new Type('tag:yaml.org,2002:merge', {
  kind: 'scalar',
  resolve: resolveYamlMerge
});

/***/ }),

/***/ 12283:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(28606);
function resolveYamlNull(data) {
  if (data === null) return true;
  var max = data.length;
  return max === 1 && data === '~' || max === 4 && (data === 'null' || data === 'Null' || data === 'NULL');
}
function constructYamlNull() {
  return null;
}
function isNull(object) {
  return object === null;
}
module.exports = new Type('tag:yaml.org,2002:null', {
  kind: 'scalar',
  resolve: resolveYamlNull,
  construct: constructYamlNull,
  predicate: isNull,
  represent: {
    canonical: function () {
      return '~';
    },
    lowercase: function () {
      return 'null';
    },
    uppercase: function () {
      return 'NULL';
    },
    camelcase: function () {
      return 'Null';
    }
  },
  defaultStyle: 'lowercase'
});

/***/ }),

/***/ 18613:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(28606);
var _hasOwnProperty = Object.prototype.hasOwnProperty;
var _toString = Object.prototype.toString;
function resolveYamlOmap(data) {
  if (data === null) return true;
  var objectKeys = [],
    index,
    length,
    pair,
    pairKey,
    pairHasKey,
    object = data;
  for (index = 0, length = object.length; index < length; index += 1) {
    pair = object[index];
    pairHasKey = false;
    if (_toString.call(pair) !== '[object Object]') return false;
    for (pairKey in pair) {
      if (_hasOwnProperty.call(pair, pairKey)) {
        if (!pairHasKey) pairHasKey = true;else return false;
      }
    }
    if (!pairHasKey) return false;
    if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey);else return false;
  }
  return true;
}
function constructYamlOmap(data) {
  return data !== null ? data : [];
}
module.exports = new Type('tag:yaml.org,2002:omap', {
  kind: 'sequence',
  resolve: resolveYamlOmap,
  construct: constructYamlOmap
});

/***/ }),

/***/ 92868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(28606);
var _toString = Object.prototype.toString;
function resolveYamlPairs(data) {
  if (data === null) return true;
  var index,
    length,
    pair,
    keys,
    result,
    object = data;
  result = new Array(object.length);
  for (index = 0, length = object.length; index < length; index += 1) {
    pair = object[index];
    if (_toString.call(pair) !== '[object Object]') return false;
    keys = Object.keys(pair);
    if (keys.length !== 1) return false;
    result[index] = [keys[0], pair[keys[0]]];
  }
  return true;
}
function constructYamlPairs(data) {
  if (data === null) return [];
  var index,
    length,
    pair,
    keys,
    result,
    object = data;
  result = new Array(object.length);
  for (index = 0, length = object.length; index < length; index += 1) {
    pair = object[index];
    keys = Object.keys(pair);
    result[index] = [keys[0], pair[keys[0]]];
  }
  return result;
}
module.exports = new Type('tag:yaml.org,2002:pairs', {
  kind: 'sequence',
  resolve: resolveYamlPairs,
  construct: constructYamlPairs
});

/***/ }),

/***/ 26578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(28606);
module.exports = new Type('tag:yaml.org,2002:seq', {
  kind: 'sequence',
  construct: function (data) {
    return data !== null ? data : [];
  }
});

/***/ }),

/***/ 83265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(28606);
var _hasOwnProperty = Object.prototype.hasOwnProperty;
function resolveYamlSet(data) {
  if (data === null) return true;
  var key,
    object = data;
  for (key in object) {
    if (_hasOwnProperty.call(object, key)) {
      if (object[key] !== null) return false;
    }
  }
  return true;
}
function constructYamlSet(data) {
  return data !== null ? data : {};
}
module.exports = new Type('tag:yaml.org,2002:set', {
  kind: 'mapping',
  resolve: resolveYamlSet,
  construct: constructYamlSet
});

/***/ }),

/***/ 75602:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(28606);
module.exports = new Type('tag:yaml.org,2002:str', {
  kind: 'scalar',
  construct: function (data) {
    return data !== null ? data : '';
  }
});

/***/ }),

/***/ 56167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(28606);
var YAML_DATE_REGEXP = new RegExp('^([0-9][0-9][0-9][0-9])' +
// [1] year
'-([0-9][0-9])' +
// [2] month
'-([0-9][0-9])$'); // [3] day

var YAML_TIMESTAMP_REGEXP = new RegExp('^([0-9][0-9][0-9][0-9])' +
// [1] year
'-([0-9][0-9]?)' +
// [2] month
'-([0-9][0-9]?)' +
// [3] day
'(?:[Tt]|[ \\t]+)' +
// ...
'([0-9][0-9]?)' +
// [4] hour
':([0-9][0-9])' +
// [5] minute
':([0-9][0-9])' +
// [6] second
'(?:\\.([0-9]*))?' +
// [7] fraction
'(?:[ \\t]*(Z|([-+])([0-9][0-9]?)' +
// [8] tz [9] tz_sign [10] tz_hour
'(?::([0-9][0-9]))?))?$'); // [11] tz_minute

function resolveYamlTimestamp(data) {
  if (data === null) return false;
  if (YAML_DATE_REGEXP.exec(data) !== null) return true;
  if (YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true;
  return false;
}
function constructYamlTimestamp(data) {
  var match,
    year,
    month,
    day,
    hour,
    minute,
    second,
    fraction = 0,
    delta = null,
    tz_hour,
    tz_minute,
    date;
  match = YAML_DATE_REGEXP.exec(data);
  if (match === null) match = YAML_TIMESTAMP_REGEXP.exec(data);
  if (match === null) throw new Error('Date resolve error');

  // match: [1] year [2] month [3] day

  year = +match[1];
  month = +match[2] - 1; // JS month starts with 0
  day = +match[3];
  if (!match[4]) {
    // no hour
    return new Date(Date.UTC(year, month, day));
  }

  // match: [4] hour [5] minute [6] second [7] fraction

  hour = +match[4];
  minute = +match[5];
  second = +match[6];
  if (match[7]) {
    fraction = match[7].slice(0, 3);
    while (fraction.length < 3) {
      // milli-seconds
      fraction += '0';
    }
    fraction = +fraction;
  }

  // match: [8] tz [9] tz_sign [10] tz_hour [11] tz_minute

  if (match[9]) {
    tz_hour = +match[10];
    tz_minute = +(match[11] || 0);
    delta = (tz_hour * 60 + tz_minute) * 60000; // delta in mili-seconds
    if (match[9] === '-') delta = -delta;
  }
  date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));
  if (delta) date.setTime(date.getTime() - delta);
  return date;
}
function representYamlTimestamp(object /*, style*/) {
  return object.toISOString();
}
module.exports = new Type('tag:yaml.org,2002:timestamp', {
  kind: 'scalar',
  resolve: resolveYamlTimestamp,
  construct: constructYamlTimestamp,
  instanceOf: Date,
  represent: representYamlTimestamp
});

/***/ }),

/***/ 66158:
/***/ (function(module) {

var toString = Object.prototype.toString;
module.exports = function kindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;
  if (type === 'boolean') return 'boolean';
  if (type === 'string') return 'string';
  if (type === 'number') return 'number';
  if (type === 'symbol') return 'symbol';
  if (type === 'function') {
    return isGeneratorFn(val) ? 'generatorfunction' : 'function';
  }
  if (isArray(val)) return 'array';
  if (isBuffer(val)) return 'buffer';
  if (isArguments(val)) return 'arguments';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  if (isRegexp(val)) return 'regexp';
  switch (ctorName(val)) {
    case 'Symbol':
      return 'symbol';
    case 'Promise':
      return 'promise';

    // Set, Map, WeakSet, WeakMap
    case 'WeakMap':
      return 'weakmap';
    case 'WeakSet':
      return 'weakset';
    case 'Map':
      return 'map';
    case 'Set':
      return 'set';

    // 8-bit typed arrays
    case 'Int8Array':
      return 'int8array';
    case 'Uint8Array':
      return 'uint8array';
    case 'Uint8ClampedArray':
      return 'uint8clampedarray';

    // 16-bit typed arrays
    case 'Int16Array':
      return 'int16array';
    case 'Uint16Array':
      return 'uint16array';

    // 32-bit typed arrays
    case 'Int32Array':
      return 'int32array';
    case 'Uint32Array':
      return 'uint32array';
    case 'Float32Array':
      return 'float32array';
    case 'Float64Array':
      return 'float64array';
  }
  if (isGeneratorObj(val)) {
    return 'generator';
  }

  // Non-plain objects
  type = toString.call(val);
  switch (type) {
    case '[object Object]':
      return 'object';
    // iterators
    case '[object Map Iterator]':
      return 'mapiterator';
    case '[object Set Iterator]':
      return 'setiterator';
    case '[object String Iterator]':
      return 'stringiterator';
    case '[object Array Iterator]':
      return 'arrayiterator';
  }

  // other
  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
};
function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function isArray(val) {
  if (Array.isArray) return Array.isArray(val);
  return val instanceof Array;
}
function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function isRegexp(val) {
  if (val instanceof RegExp) return true;
  return typeof val.flags === 'string' && typeof val.ignoreCase === 'boolean' && typeof val.multiline === 'boolean' && typeof val.global === 'boolean';
}
function isGeneratorFn(name, val) {
  return ctorName(name) === 'GeneratorFunction';
}
function isGeneratorObj(val) {
  return typeof val.throw === 'function' && typeof val.return === 'function' && typeof val.next === 'function';
}
function isArguments(val) {
  try {
    if (typeof val.length === 'number' && typeof val.callee === 'function') {
      return true;
    }
  } catch (err) {
    if (err.message.indexOf('callee') !== -1) {
      return true;
    }
  }
  return false;
}

/**
 * If you need to support Safari 5-7 (8-10 yr-old browser),
 * take a look at https://github.com/feross/is-buffer
 */

function isBuffer(val) {
  if (val.constructor && typeof val.constructor.isBuffer === 'function') {
    return val.constructor.isBuffer(val);
  }
  return false;
}

/***/ }),

/***/ 17717:
/***/ (function(module) {

var __dirname = "/";
(function () {
  "use strict";

  var e = {
    114: function (e) {
      function assertPath(e) {
        if (typeof e !== "string") {
          throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
        }
      }
      function normalizeStringPosix(e, r) {
        var t = "";
        var i = 0;
        var n = -1;
        var a = 0;
        var f;
        for (var l = 0; l <= e.length; ++l) {
          if (l < e.length) f = e.charCodeAt(l);else if (f === 47) break;else f = 47;
          if (f === 47) {
            if (n === l - 1 || a === 1) {} else if (n !== l - 1 && a === 2) {
              if (t.length < 2 || i !== 2 || t.charCodeAt(t.length - 1) !== 46 || t.charCodeAt(t.length - 2) !== 46) {
                if (t.length > 2) {
                  var s = t.lastIndexOf("/");
                  if (s !== t.length - 1) {
                    if (s === -1) {
                      t = "";
                      i = 0;
                    } else {
                      t = t.slice(0, s);
                      i = t.length - 1 - t.lastIndexOf("/");
                    }
                    n = l;
                    a = 0;
                    continue;
                  }
                } else if (t.length === 2 || t.length === 1) {
                  t = "";
                  i = 0;
                  n = l;
                  a = 0;
                  continue;
                }
              }
              if (r) {
                if (t.length > 0) t += "/..";else t = "..";
                i = 2;
              }
            } else {
              if (t.length > 0) t += "/" + e.slice(n + 1, l);else t = e.slice(n + 1, l);
              i = l - n - 1;
            }
            n = l;
            a = 0;
          } else if (f === 46 && a !== -1) {
            ++a;
          } else {
            a = -1;
          }
        }
        return t;
      }
      function _format(e, r) {
        var t = r.dir || r.root;
        var i = r.base || (r.name || "") + (r.ext || "");
        if (!t) {
          return i;
        }
        if (t === r.root) {
          return t + i;
        }
        return t + e + i;
      }
      var r = {
        resolve: function resolve() {
          var e = "";
          var r = false;
          var t;
          for (var i = arguments.length - 1; i >= -1 && !r; i--) {
            var n;
            if (i >= 0) n = arguments[i];else {
              if (t === undefined) t = "";
              n = t;
            }
            assertPath(n);
            if (n.length === 0) {
              continue;
            }
            e = n + "/" + e;
            r = n.charCodeAt(0) === 47;
          }
          e = normalizeStringPosix(e, !r);
          if (r) {
            if (e.length > 0) return "/" + e;else return "/";
          } else if (e.length > 0) {
            return e;
          } else {
            return ".";
          }
        },
        normalize: function normalize(e) {
          assertPath(e);
          if (e.length === 0) return ".";
          var r = e.charCodeAt(0) === 47;
          var t = e.charCodeAt(e.length - 1) === 47;
          e = normalizeStringPosix(e, !r);
          if (e.length === 0 && !r) e = ".";
          if (e.length > 0 && t) e += "/";
          if (r) return "/" + e;
          return e;
        },
        isAbsolute: function isAbsolute(e) {
          assertPath(e);
          return e.length > 0 && e.charCodeAt(0) === 47;
        },
        join: function join() {
          if (arguments.length === 0) return ".";
          var e;
          for (var t = 0; t < arguments.length; ++t) {
            var i = arguments[t];
            assertPath(i);
            if (i.length > 0) {
              if (e === undefined) e = i;else e += "/" + i;
            }
          }
          if (e === undefined) return ".";
          return r.normalize(e);
        },
        relative: function relative(e, t) {
          assertPath(e);
          assertPath(t);
          if (e === t) return "";
          e = r.resolve(e);
          t = r.resolve(t);
          if (e === t) return "";
          var i = 1;
          for (; i < e.length; ++i) {
            if (e.charCodeAt(i) !== 47) break;
          }
          var n = e.length;
          var a = n - i;
          var f = 1;
          for (; f < t.length; ++f) {
            if (t.charCodeAt(f) !== 47) break;
          }
          var l = t.length;
          var s = l - f;
          var o = a < s ? a : s;
          var u = -1;
          var h = 0;
          for (; h <= o; ++h) {
            if (h === o) {
              if (s > o) {
                if (t.charCodeAt(f + h) === 47) {
                  return t.slice(f + h + 1);
                } else if (h === 0) {
                  return t.slice(f + h);
                }
              } else if (a > o) {
                if (e.charCodeAt(i + h) === 47) {
                  u = h;
                } else if (h === 0) {
                  u = 0;
                }
              }
              break;
            }
            var c = e.charCodeAt(i + h);
            var v = t.charCodeAt(f + h);
            if (c !== v) break;else if (c === 47) u = h;
          }
          var g = "";
          for (h = i + u + 1; h <= n; ++h) {
            if (h === n || e.charCodeAt(h) === 47) {
              if (g.length === 0) g += "..";else g += "/..";
            }
          }
          if (g.length > 0) return g + t.slice(f + u);else {
            f += u;
            if (t.charCodeAt(f) === 47) ++f;
            return t.slice(f);
          }
        },
        _makeLong: function _makeLong(e) {
          return e;
        },
        dirname: function dirname(e) {
          assertPath(e);
          if (e.length === 0) return ".";
          var r = e.charCodeAt(0);
          var t = r === 47;
          var i = -1;
          var n = true;
          for (var a = e.length - 1; a >= 1; --a) {
            r = e.charCodeAt(a);
            if (r === 47) {
              if (!n) {
                i = a;
                break;
              }
            } else {
              n = false;
            }
          }
          if (i === -1) return t ? "/" : ".";
          if (t && i === 1) return "//";
          return e.slice(0, i);
        },
        basename: function basename(e, r) {
          if (r !== undefined && typeof r !== "string") throw new TypeError('"ext" argument must be a string');
          assertPath(e);
          var t = 0;
          var i = -1;
          var n = true;
          var a;
          if (r !== undefined && r.length > 0 && r.length <= e.length) {
            if (r.length === e.length && r === e) return "";
            var f = r.length - 1;
            var l = -1;
            for (a = e.length - 1; a >= 0; --a) {
              var s = e.charCodeAt(a);
              if (s === 47) {
                if (!n) {
                  t = a + 1;
                  break;
                }
              } else {
                if (l === -1) {
                  n = false;
                  l = a + 1;
                }
                if (f >= 0) {
                  if (s === r.charCodeAt(f)) {
                    if (--f === -1) {
                      i = a;
                    }
                  } else {
                    f = -1;
                    i = l;
                  }
                }
              }
            }
            if (t === i) i = l;else if (i === -1) i = e.length;
            return e.slice(t, i);
          } else {
            for (a = e.length - 1; a >= 0; --a) {
              if (e.charCodeAt(a) === 47) {
                if (!n) {
                  t = a + 1;
                  break;
                }
              } else if (i === -1) {
                n = false;
                i = a + 1;
              }
            }
            if (i === -1) return "";
            return e.slice(t, i);
          }
        },
        extname: function extname(e) {
          assertPath(e);
          var r = -1;
          var t = 0;
          var i = -1;
          var n = true;
          var a = 0;
          for (var f = e.length - 1; f >= 0; --f) {
            var l = e.charCodeAt(f);
            if (l === 47) {
              if (!n) {
                t = f + 1;
                break;
              }
              continue;
            }
            if (i === -1) {
              n = false;
              i = f + 1;
            }
            if (l === 46) {
              if (r === -1) r = f;else if (a !== 1) a = 1;
            } else if (r !== -1) {
              a = -1;
            }
          }
          if (r === -1 || i === -1 || a === 0 || a === 1 && r === i - 1 && r === t + 1) {
            return "";
          }
          return e.slice(r, i);
        },
        format: function format(e) {
          if (e === null || typeof e !== "object") {
            throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof e);
          }
          return _format("/", e);
        },
        parse: function parse(e) {
          assertPath(e);
          var r = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
          };
          if (e.length === 0) return r;
          var t = e.charCodeAt(0);
          var i = t === 47;
          var n;
          if (i) {
            r.root = "/";
            n = 1;
          } else {
            n = 0;
          }
          var a = -1;
          var f = 0;
          var l = -1;
          var s = true;
          var o = e.length - 1;
          var u = 0;
          for (; o >= n; --o) {
            t = e.charCodeAt(o);
            if (t === 47) {
              if (!s) {
                f = o + 1;
                break;
              }
              continue;
            }
            if (l === -1) {
              s = false;
              l = o + 1;
            }
            if (t === 46) {
              if (a === -1) a = o;else if (u !== 1) u = 1;
            } else if (a !== -1) {
              u = -1;
            }
          }
          if (a === -1 || l === -1 || u === 0 || u === 1 && a === l - 1 && a === f + 1) {
            if (l !== -1) {
              if (f === 0 && i) r.base = r.name = e.slice(1, l);else r.base = r.name = e.slice(f, l);
            }
          } else {
            if (f === 0 && i) {
              r.name = e.slice(1, a);
              r.base = e.slice(1, l);
            } else {
              r.name = e.slice(f, a);
              r.base = e.slice(f, l);
            }
            r.ext = e.slice(a, l);
          }
          if (f > 0) r.dir = e.slice(0, f - 1);else if (i) r.dir = "/";
          return r;
        },
        sep: "/",
        delimiter: ":",
        win32: null,
        posix: null
      };
      r.posix = r;
      e.exports = r;
    }
  };
  var r = {};
  function __nccwpck_require__(t) {
    var i = r[t];
    if (i !== undefined) {
      return i.exports;
    }
    var n = r[t] = {
      exports: {}
    };
    var a = true;
    try {
      e[t](n, n.exports, __nccwpck_require__);
      a = false;
    } finally {
      if (a) delete r[t];
    }
    return n.exports;
  }
  if (typeof __nccwpck_require__ !== "undefined") __nccwpck_require__.ab = __dirname + "/";
  var t = __nccwpck_require__(114);
  module.exports = t;
})();

/***/ }),

/***/ 1887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(79755);

/***/ }),

/***/ 34376:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(71378);

/***/ }),

/***/ 554:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
  throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
  throw new Error('clearTimeout has not been defined');
}
(function () {
  try {
    if (typeof setTimeout === 'function') {
      cachedSetTimeout = setTimeout;
    } else {
      cachedSetTimeout = defaultSetTimout;
    }
  } catch (e) {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    if (typeof clearTimeout === 'function') {
      cachedClearTimeout = clearTimeout;
    } else {
      cachedClearTimeout = defaultClearTimeout;
    }
  } catch (e) {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    //normal enviroments in sane situations
    return setTimeout(fun, 0);
  }
  // if setTimeout wasn't available but was latter defined
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }
  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}
function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    //normal enviroments in sane situations
    return clearTimeout(marker);
  }
  // if clearTimeout wasn't available but was latter defined
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }
  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
      return cachedClearTimeout.call(null, marker);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
      // Some versions of I.E. have different rules for clearTimeout vs setTimeout
      return cachedClearTimeout.call(this, marker);
    }
  }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }
  draining = false;
  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }
  if (queue.length) {
    drainQueue();
  }
}
function drainQueue() {
  if (draining) {
    return;
  }
  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;
  while (len) {
    currentQueue = queue;
    queue = [];
    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }
    queueIndex = -1;
    len = queue.length;
  }
  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}
process.nextTick = function (fun) {
  var args = new Array(arguments.length - 1);
  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }
  queue.push(new Item(fun, args));
  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
};

// v8 likes predictible objects
function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}
Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function (name) {
  return [];
};
process.binding = function (name) {
  throw new Error('process.binding is not supported');
};
process.cwd = function () {
  return '/';
};
process.chdir = function (dir) {
  throw new Error('process.chdir is not supported');
};
process.umask = function () {
  return 0;
};

/***/ }),

/***/ 570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var typeOf = __webpack_require__(66158);
var extend = __webpack_require__(45389);

/**
 * Parse sections in `input` with the given `options`.
 *
 * ```js
 * var sections = require('{%= name %}');
 * var result = sections(input, options);
 * // { content: 'Content before sections', sections: [] }
 * ```
 * @param {String|Buffer|Object} `input` If input is an object, it's `content` property must be a string or buffer.
 * @param {Object} options
 * @return {Object} Returns an object with a `content` string and an array of `sections` objects.
 * @api public
 */

module.exports = function (input, options) {
  if (typeof options === 'function') {
    options = {
      parse: options
    };
  }
  var file = toObject(input);
  var defaults = {
    section_delimiter: '---',
    parse: identity
  };
  var opts = extend({}, defaults, options);
  var delim = opts.section_delimiter;
  var lines = file.content.split(/\r?\n/);
  var sections = null;
  var section = createSection();
  var content = [];
  var stack = [];
  function initSections(val) {
    file.content = val;
    sections = [];
    content = [];
  }
  function closeSection(val) {
    if (stack.length) {
      section.key = getKey(stack[0], delim);
      section.content = val;
      opts.parse(section, sections);
      sections.push(section);
      section = createSection();
      content = [];
      stack = [];
    }
  }
  for (var i = 0; i < lines.length; i++) {
    var line = lines[i];
    var len = stack.length;
    var ln = line.trim();
    if (isDelimiter(ln, delim)) {
      if (ln.length === 3 && i !== 0) {
        if (len === 0 || len === 2) {
          content.push(line);
          continue;
        }
        stack.push(ln);
        section.data = content.join('\n');
        content = [];
        continue;
      }
      if (sections === null) {
        initSections(content.join('\n'));
      }
      if (len === 2) {
        closeSection(content.join('\n'));
      }
      stack.push(ln);
      continue;
    }
    content.push(line);
  }
  if (sections === null) {
    initSections(content.join('\n'));
  } else {
    closeSection(content.join('\n'));
  }
  file.sections = sections;
  return file;
};
function isDelimiter(line, delim) {
  if (line.slice(0, delim.length) !== delim) {
    return false;
  }
  if (line.charAt(delim.length + 1) === delim.slice(-1)) {
    return false;
  }
  return true;
}
function toObject(input) {
  if (typeOf(input) !== 'object') {
    input = {
      content: input
    };
  }
  if (typeof input.content !== 'string' && !isBuffer(input.content)) {
    throw new TypeError('expected a buffer or string');
  }
  input.content = input.content.toString();
  input.sections = [];
  return input;
}
function getKey(val, delim) {
  return val ? val.slice(delim.length).trim() : '';
}
function createSection() {
  return {
    key: '',
    data: '',
    content: ''
  };
}
function identity(val) {
  return val;
}
function isBuffer(val) {
  if (val && val.constructor && typeof val.constructor.isBuffer === 'function') {
    return val.constructor.isBuffer(val);
  }
  return false;
}

/***/ }),

/***/ 45389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(17027);
module.exports = function extend(o /*, objects*/) {
  if (!isObject(o)) {
    o = {};
  }
  var len = arguments.length;
  for (var i = 1; i < len; i++) {
    var obj = arguments[i];
    if (isObject(obj)) {
      assign(o, obj);
    }
  }
  return o;
};
function assign(a, b) {
  for (var key in b) {
    if (hasOwn(b, key)) {
      a[key] = b[key];
    }
  }
}

/**
 * Returns true if the given `key` is an own property of `obj`.
 */

function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

/***/ }),

/***/ 17027:
/***/ (function(module) {

"use strict";
/*!
 * is-extendable <https://github.com/jonschlinkert/is-extendable>
 *
 * Copyright (c) 2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */



module.exports = function isExtendable(val) {
  return typeof val !== 'undefined' && val !== null && (typeof val === 'object' || typeof val === 'function');
};

/***/ }),

/***/ 32518:
/***/ (function(module) {

"use strict";
/*!
 * strip-bom-string <https://github.com/jonschlinkert/strip-bom-string>
 *
 * Copyright (c) 2015, 2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function (str) {
  if (typeof str === 'string' && str.charAt(0) === '\ufeff') {
    return str.slice(1);
  }
  return str;
};

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(31412);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ logo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./src/assets/logos/kinto.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgKinto = function SvgKinto(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 944.61 240.94",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M342.23 54.39h39.55c12.59 0 20.42 5.9 29.25 17.52l65.14 104.72h.52V54.39h19.42a17.67 17.67 0 0 1 18.09 18.09v164.13h-14.71c-17.64 0-25.73-3.7-36.62-18.13l-64.54-103.86h-.5v122h-19.42c-9.63 0-18.1-7.06-18.1-18.1v-146a18 18 0 0 0-18.08-18.09M554.09 54.39h149.18a18 18 0 0 1 18.09 18.09v18.38h-54.62v145.75h-22c-10 0-18.09-7.19-18.09-18.1V90.86h-36.49c-10.43 0-18.1-7.93-18.1-18.38a17.85 17.85 0 0 0-18-18.09M237.16 218.51V97h22a17.76 17.76 0 0 1 18.09 18.09v121.52h-22a18 18 0 0 1-18.1-18.1M18.09 72.48v146a17.77 17.77 0 0 0 18.1 18.1h22V169.5l50.25 51.14c14.88 14.52 24 16 36.5 16h29.21L82.34 145.5l91.79-91.11h-50l-65.96 67.12-.16-49a18.21 18.21 0 0 0-18.1-18.12H0c9.88 0 18.09 9 18.09 18.09M849.18 50.05a95.45 95.45 0 1 0 95.43 95.45 95.45 95.45 0 0 0-95.43-95.45m0 154.31A58.86 58.86 0 1 1 908 145.5a58.87 58.87 0 0 1-58.82 58.86zM258.7 36.33c-5.28-4.07-13.7-5-21 0-10.09 6.88-11.17 19.5-5.72 29.27s15.59 13 27.24 12a42 42 0 0 0 29.89-16.81c5.54-7.56 11.49-25.81-.29-43.23C279.78 4.25 268.08 0 255.54 0c-13.82 0-23.34 10.38-29.94 18.19-10.25 12.13-14.92 14.81-23.74 15.55s-17-3-21.05-7.2a73.58 73.58 0 0 1-6.32-7.29s4.91 9.16 11.51 14.64c7.09 5.89 18.05 8.78 29.75 4.55 13.91-5 21.54-13.6 26.19-16.26 9.47-5.42 22.38-1 25.12 8.73a22 22 0 0 1-2.93 18.91s2.1-7.67-5.43-13.49",
    fill: "#006d88"
  })));
};
/* harmony default export */ var kinto = (SvgKinto);
;// CONCATENATED MODULE: ./src/assets/logos/lexus.svg
var lexus_path;
function lexus_extends() { lexus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lexus_extends.apply(this, arguments); }

var SvgLexus = function SvgLexus(props) {
  return /*#__PURE__*/react.createElement("svg", lexus_extends({
    fill: "none",
    viewBox: "0 0 58 45",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), lexus_path || (lexus_path = /*#__PURE__*/react.createElement("path", {
    d: "M29.352 2.454c.903.027.807.704.658.937-2.665 4.423-8.962 12.21-13.546 20.754-.76 1.385-1.325 2.403-1.325 3.922 0 2.06 1.205 4.495 3.627 5.54 1.593.68 2.595.702 4.314.728 12.762.421 17.88.053 29.3-.36.659-.002 1.272-.476 1.492-.762 2.208-2.456 3.481-6.872 3.481-10.767 0-8.677-5.857-16.492-14.995-20.251L40.892 4.2c8.008 3.532 12.146 10.585 12.146 18.14 0 1.699-.27 3.345-.759 4.917-.362 1.096-.809 1.726-2.106 1.747-9.307.212-14.576.368-23.907.106-1.204-.027-1.593-.495-1.789-1.512-.15-.603-.025-1.104.365-1.86 4.949-9.354 13.57-20.045 15.264-22.581.322-.469.17-1.413-.934-1.726C35.942.414 32.318 0 28.643 0 12.005.072.27 10.056 0 22.446.667 37.32 12.79 45 28.643 45c9.702 0 18.588-3.658 23.788-9.46l-4.803.207c-4.435 4.208-11.541 6.458-18.89 6.458-13.395 0-24.302-7.107-24.302-19.865 0-10.974 10.904-19.912 24.302-19.912l.615.026z",
    clipRule: "evenodd",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
/* harmony default export */ var lexus = (SvgLexus);
;// CONCATENATED MODULE: ./src/assets/logos/lexus-kinto.svg
var lexus_kinto_path, _path2, _path3, _g, _defs;
function lexus_kinto_extends() { lexus_kinto_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lexus_kinto_extends.apply(this, arguments); }

var SvgLexusKinto = function SvgLexusKinto(props) {
  return /*#__PURE__*/react.createElement("svg", lexus_kinto_extends({
    width: 143,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), lexus_kinto_path || (lexus_kinto_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.518 5.745c.693.02.62.5.505.666-2.044 3.145-6.875 8.683-10.393 14.759-.582.984-1.016 1.709-1.016 2.789 0 1.465.925 3.196 2.783 3.94 1.222.484 1.99.498 3.31.517 9.79.3 13.716.038 22.477-.256.506-.001.977-.338 1.146-.542 1.694-1.747 2.67-4.886 2.67-7.656 0-6.17-4.494-11.729-11.504-14.402l-1.125 1.427c6.144 2.512 9.319 7.527 9.319 12.899 0 1.209-.207 2.379-.582 3.497-.278.78-.62 1.227-1.616 1.242-7.14.151-11.183.262-18.341.076-.924-.02-1.222-.352-1.372-1.075-.115-.429-.02-.785.28-1.323 3.796-6.652 10.41-14.254 11.71-16.058.246-.333.13-1.004-.717-1.227C27.574 4.294 24.793 4 21.974 4 9.21 4.051.207 11.15 0 19.962.511 30.538 9.811 36 21.974 36c7.443 0 14.26-2.602 18.25-6.727l-3.686.147c-3.402 2.992-8.853 4.592-14.492 4.592-10.276 0-18.643-5.053-18.643-14.126 0-7.803 8.365-14.16 18.643-14.16l.472.02Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    stroke: "#282830",
    strokeWidth: 1.755,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M51.123 39.123V.877"
  })), /*#__PURE__*/react.createElement("mask", {
    id: "lexus-kinto_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 9,
    width: 78,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "url(#lexus-kinto_svg__a)",
    d: "M60 9.5h78v19.95H60z"
  }))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#lexus-kinto_svg__b)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#282830",
    d: "M60 9.5h78v19.95H60z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("pattern", {
    id: "lexus-kinto_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#lexus-kinto_svg__c",
    transform: "matrix(.00106 0 0 .00415 0 0)"
  })), /*#__PURE__*/react.createElement("image", {
    id: "lexus-kinto_svg__c",
    width: 943,
    height: 241,
    xlinkHref: "data:image/png;base64,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"
  }))));
};
/* harmony default export */ var lexus_kinto = (SvgLexusKinto);
;// CONCATENATED MODULE: ./src/assets/logos/toyota.svg
var toyota_path;
function toyota_extends() { toyota_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return toyota_extends.apply(this, arguments); }

var SvgToyota = function SvgToyota(props) {
  return /*#__PURE__*/react.createElement("svg", toyota_extends({
    fill: "none",
    viewBox: "0 0 69 45",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), toyota_path || (toyota_path = /*#__PURE__*/react.createElement("path", {
    d: "M34.488 0C15.44 0 0 10.074 0 22.501S15.44 45 34.488 45s34.49-10.074 34.49-22.499S53.536 0 34.488 0zm0 35.341c-2.833 0-5.144-5.626-5.292-12.708 1.707.156 3.487.238 5.292.238 1.805 0 3.585-.082 5.294-.238-.15 7.082-2.463 12.708-5.294 12.708zm-4.939-18.326c.772-5.006 2.692-8.553 4.939-8.553s4.17 3.547 4.941 8.553c-1.58.143-3.234.22-4.941.22a58.33 58.33 0 0 1-4.939-.22zm4.939-13.757c-3.705 0-6.853 5.585-8.017 13.377-7.014-1.1-11.912-3.615-11.912-6.535 0-3.944 8.924-7.132 19.928-7.132 11.005 0 19.928 3.188 19.928 7.133 0 2.92-4.895 5.428-11.909 6.534-1.163-7.792-4.315-13.377-8.018-13.377zM4.946 21.656c0-3.815 1.454-7.388 3.989-10.461-.03.219-.044.439-.044.66 0 4.806 7.145 8.895 17.11 10.402v1.055c0 8.953 2.49 16.534 5.924 19.106-15.122-.928-26.979-9.879-26.979-20.762zm32.108 20.753c3.437-2.572 5.926-10.153 5.926-19.106v-1.055c9.965-1.506 17.11-5.596 17.11-10.402 0-.221-.015-.441-.045-.66 2.537 3.078 3.99 6.647 3.99 10.461-.002 10.892-11.86 19.843-26.98 20.762z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var toyota = (SvgToyota);
;// CONCATENATED MODULE: ./src/assets/logos/toyota-kinto.svg
var toyota_kinto_path, toyota_kinto_path2, toyota_kinto_path3, toyota_kinto_g, toyota_kinto_defs;
function toyota_kinto_extends() { toyota_kinto_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return toyota_kinto_extends.apply(this, arguments); }

var SvgToyotaKinto = function SvgToyotaKinto(props) {
  return /*#__PURE__*/react.createElement("svg", toyota_kinto_extends({
    width: 158,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), toyota_kinto_path || (toyota_kinto_path = /*#__PURE__*/react.createElement("path", {
    d: "M30.999 0C13.879 0 0 8.955 0 20.001 0 31.047 13.878 40 30.999 40 48.119 40 62 31.045 62 20.001 62 8.957 48.12 0 30.999 0Zm0 31.415c-2.547 0-4.623-5.002-4.757-11.297 1.534.139 3.135.211 4.757.211 1.622 0 3.223-.072 4.759-.21-.136 6.294-2.214 11.296-4.759 11.296Zm-4.44-16.29c.694-4.45 2.42-7.603 4.44-7.603 2.02 0 3.748 3.153 4.441 7.603-1.42.127-2.907.195-4.441.195-1.534 0-3.019-.076-4.44-.195ZM31 2.896c-3.33 0-6.16 4.964-7.206 11.89-6.304-.976-10.706-3.212-10.706-5.808 0-3.506 8.02-6.34 17.912-6.34s17.912 2.834 17.912 6.34c0 2.596-4.4 4.826-10.704 5.809-1.047-6.927-3.88-11.89-7.208-11.89ZM4.445 19.25c0-3.39 1.307-6.566 3.585-9.298a4.39 4.39 0 0 0-.039.586c0 4.272 6.422 7.907 15.38 9.246v.938c0 7.958 2.237 14.697 5.324 16.984-13.592-.825-24.25-8.781-24.25-18.456Zm28.86 18.448c3.09-2.287 5.327-9.026 5.327-16.984v-.938c8.957-1.338 15.379-4.974 15.379-9.246 0-.196-.014-.392-.041-.586 2.28 2.736 3.587 5.908 3.587 9.299-.002 9.682-10.662 17.638-24.252 18.455Z",
    fill: "#282830"
  })), toyota_kinto_path2 || (toyota_kinto_path2 = /*#__PURE__*/react.createElement("path", {
    stroke: "#282830",
    strokeWidth: 1.755,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M69.123 39.123V.877"
  })), /*#__PURE__*/react.createElement("mask", {
    id: "toyota-kinto_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 9,
    width: 78,
    height: 21
  }, toyota_kinto_path3 || (toyota_kinto_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "url(#toyota-kinto_svg__a)",
    d: "M78 9.5h78v19.95H78z"
  }))), toyota_kinto_g || (toyota_kinto_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#toyota-kinto_svg__b)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#282830",
    d: "M78 9.5h78v19.95H78z"
  }))), toyota_kinto_defs || (toyota_kinto_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("pattern", {
    id: "toyota-kinto_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#toyota-kinto_svg__c",
    transform: "matrix(.00106 0 0 .00415 0 0)"
  })), /*#__PURE__*/react.createElement("image", {
    id: "toyota-kinto_svg__c",
    width: 943,
    height: 241,
    xlinkHref: "data:image/png;base64,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"
  }))));
};
/* harmony default export */ var toyota_kinto = (SvgToyotaKinto);
// EXTERNAL MODULE: ./src/assets/logos/toyota-lexus.svg
var toyota_lexus = __webpack_require__(32884);
// EXTERNAL MODULE: ./src/contexts/useBrand.tsx
var useBrand = __webpack_require__(25765);
;// CONCATENATED MODULE: ./src/components/ui/logo/index.tsx








const Logo = (param)=>{
    let { logoType , ...rest } = param;
    const brand = (0,useBrand/* useBrand */.D)();
    const type = logoType || brand;
    switch(type){
        case "kinto":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(kinto, {
                ...rest
            });
        case "lexus":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(lexus, {
                ...rest
            });
        case "lexus-kinto":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(lexus_kinto, {
                ...rest
            });
        case "toyota-kinto":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(toyota_kinto, {
                ...rest
            });
        case "toyota-lexus":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(toyota_lexus/* default */.Z, {
                ...rest
            });
        case "toyota":
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(toyota, {
                ...rest
            });
    }
};
/* harmony default export */ var logo = (Logo);


/***/ }),

/***/ 28798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HQ": function() { return /* binding */ ContextProvider; },
  "aC": function() { return /* reexport */ useAuth; },
  "DY": function() { return /* reexport */ useBrand/* useBrand */.D; },
  "yQ": function() { return /* reexport */ useCampaign/* useCampaign */.y; },
  "qY": function() { return /* reexport */ useDealer; },
  "L0": function() { return /* reexport */ useFilter; },
  "tT": function() { return /* reexport */ useModel; },
  "aM": function() { return /* reexport */ useQuery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-shims/dist-esm/Constants.js
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var Constants_strShimFunction = "function";
var strShimObject = "object";
var Constants_strShimUndefined = "undefined";
var Constants_strShimPrototype = "prototype";
var strShimHasOwnProperty = "hasOwnProperty";
var Constants_strDefault = "default";
var Constants_ObjClass = Object;
var Constants_ObjProto = Constants_ObjClass[Constants_strShimPrototype];
var ObjAssign = Constants_ObjClass["assign"];
var Constants_ObjCreate = Constants_ObjClass["create"];
var Constants_ObjDefineProperty = Constants_ObjClass["defineProperty"];
var Constants_ObjHasOwnProperty = Constants_ObjProto[strShimHasOwnProperty];
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-shims/dist-esm/Helpers.js
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

var _cachedGlobal = null;
/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions.
 */
function getGlobal(useCached) {
  if (useCached === void 0) {
    useCached = true;
  }
  var result = useCached === false ? null : _cachedGlobal;
  if (!result) {
    if (typeof globalThis !== Constants_strShimUndefined) {
      result = globalThis;
    }
    if (!result && typeof self !== Constants_strShimUndefined) {
      result = self;
    }
    if (!result && typeof window !== Constants_strShimUndefined) {
      result = window;
    }
    if (!result && typeof __webpack_require__.g !== Constants_strShimUndefined) {
      result = __webpack_require__.g;
    }
    _cachedGlobal = result;
  }
  return result;
}
function Helpers_throwTypeError(message) {
  throw new TypeError(message);
}
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object to use as a prototype. May be null
 */
function objCreateFn(obj) {
  var func = Constants_ObjCreate;
  // Use build in Object.create
  if (func) {
    // Use Object create method if it exists
    return func(obj);
  }
  if (obj == null) {
    return {};
  }
  var type = typeof obj;
  if (type !== strShimObject && type !== Constants_strShimFunction) {
    Helpers_throwTypeError("Object prototype may only be an Object:" + obj);
  }
  function tmpFunc() {}
  tmpFunc[Constants_strShimPrototype] = obj;
  return new tmpFunc();
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-shims/dist-esm/TsLibShims.js
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


// Most of these functions have been directly shamelessly "lifted" from the https://github.com/@microsoft/tslib and
// modified to be ES3 compatible and applying several minification and tree-shaking techniques so that Application Insights
// can successfully use TypeScript "importHelpers" which imports tslib during compilation but it will use these at runtime
// Which is also why all of the functions have not been included as Application Insights currently doesn't use or require
// them.
var SymbolObj = (getGlobal() || {})["Symbol"];
var ReflectObj = (getGlobal() || {})["Reflect"];
var __hasSymbol = !!SymbolObj;
var __hasReflect = !!ReflectObj;
var strDecorate = "decorate";
var strMetadata = "metadata";
var strGetOwnPropertySymbols = "getOwnPropertySymbols";
var strIterator = "iterator";
var __objAssignFnImpl = function (t) {
  // tslint:disable-next-line: ban-comma-operator
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) {
      if (Constants_ObjProto[strShimHasOwnProperty].call(s, p)) {
        t[p] = s[p];
      }
    }
  }
  return t;
};
var __assignFn = ObjAssign || __objAssignFnImpl;
// tslint:disable-next-line: only-arrow-functions
var extendStaticsFn = function (d, b) {
  extendStaticsFn = Constants_ObjClass.setPrototypeOf ||
  // tslint:disable-next-line: only-arrow-functions
  {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } ||
  // tslint:disable-next-line: only-arrow-functions
  function (d, b) {
    for (var p in b) {
      if (b[strShimHasOwnProperty](p)) {
        d[p] = b[p];
      }
    }
  };
  return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
  if (typeof b !== Constants_strShimFunction && b !== null) {
    Helpers_throwTypeError("Class extends value " + String(b) + " is not a constructor or null");
  }
  extendStaticsFn(d, b);
  function __() {
    this.constructor = d;
  }
  // tslint:disable-next-line: ban-comma-operator
  d[Constants_strShimPrototype] = b === null ? objCreateFn(b) : (__[Constants_strShimPrototype] = b[Constants_strShimPrototype], new __());
}
function __restFn(s, e) {
  var t = {};
  for (var k in s) {
    if (ObjHasOwnProperty.call(s, k) && e.indexOf(k) < 0) {
      t[k] = s[k];
    }
  }
  if (s != null && typeof ObjClass[strGetOwnPropertySymbols] === strShimFunction) {
    for (var i = 0, p = ObjClass[strGetOwnPropertySymbols](s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && ObjProto["propertyIsEnumerable"].call(s, p[i])) {
        t[p[i]] = s[p[i]];
      }
    }
  }
  return t;
}
function __decorateFn(decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = ObjClass["getOwnPropertyDescriptor"](target, key) : desc,
    d;
  if (__hasReflect && typeof ReflectObj[strDecorate] === strShimFunction) {
    r = ReflectObj[strDecorate](decorators, target, key, desc);
  } else {
    for (var i = decorators.length - 1; i >= 0; i--) {
      // eslint-disable-next-line no-cond-assign
      if (d = decorators[i]) {
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
    }
  }
  // tslint:disable-next-line:ban-comma-operator
  return c > 3 && r && ObjDefineProperty(target, key, r), r;
}
function __paramFn(paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
}
function __metadataFn(metadataKey, metadataValue) {
  if (__hasReflect && ReflectObj[strMetadata] === strShimFunction) {
    return ReflectObj[strMetadata](metadataKey, metadataValue);
  }
}
function __exportStarFn(m, o) {
  for (var p in m) {
    if (p !== strDefault && !ObjHasOwnProperty.call(o, p)) {
      __createBindingFn(o, m, p);
    }
  }
}
function __createBindingFn(o, m, k, k2) {
  if (k2 === undefined) {
    k2 = k;
  }
  if (!!ObjCreate) {
    ObjDefineProperty(o, k2, {
      enumerable: true,
      get: function () {
        return m[k];
      }
    });
  } else {
    o[k2] = m[k];
  }
}
function __valuesFn(o) {
  var s = typeof SymbolObj === strShimFunction && SymbolObj[strIterator],
    m = s && o[s],
    i = 0;
  if (m) {
    return m.call(o);
  }
  if (o && typeof o.length === "number") {
    return {
      next: function () {
        if (o && i >= o.length) {
          o = void 0;
        }
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
  }
  throwTypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __readFn(o, n) {
  var m = typeof SymbolObj === strShimFunction && o[SymbolObj[strIterator]];
  if (!m) {
    return o;
  }
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      // tslint:disable-next-line:no-conditional-assignment
      if (r && !r.done && (m = i["return"])) {
        m.call(i);
      }
    } finally {
      if (e) {
        // eslint-disable-next-line no-unsafe-finally
        throw e.error;
      }
    }
  }
  return ar;
}
/** @deprecated */
function __spreadArraysFn() {
  var theArgs = arguments;
  // Calculate new total size
  for (var s = 0, i = 0, il = theArgs.length; i < il; i++) {
    s += theArgs[i].length;
  }
  // Create new full array
  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }
  return r;
}
function __spreadArrayFn(to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
}
function __makeTemplateObjectFn(cooked, raw) {
  if (ObjDefineProperty) {
    ObjDefineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}
function __importStarFn(mod) {
  if (mod && mod.__esModule) {
    return mod;
  }
  var result = {};
  if (mod != null) {
    for (var k in mod) {
      if (k !== strDefault && Object.prototype.hasOwnProperty.call(mod, k)) {
        __createBindingFn(result, mod, k);
      }
    }
  }
  // Set default module
  if (!!ObjCreate) {
    ObjDefineProperty(result, strDefault, {
      enumerable: true,
      value: mod
    });
  } else {
    result[strDefault] = mod;
  }
  return result;
}
function __importDefaultFn(mod) {
  return mod && mod.__esModule ? mod : {
    strDefault: mod
  };
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_INITIALIZE = "initialize"; // Count: 8
var _DynamicConstants_DYN_NAME = "name"; // Count: 11
var _DYN_GET_NOTIFY_MGR = "getNotifyMgr"; // Count: 3
var _DYN_IDENTIFIER = "identifier"; // Count: 8
var _DynamicConstants_DYN_PUSH = "push"; // Count: 30
var _DYN_IS_INITIALIZED = "isInitialized"; // Count: 10
var _DYN_CONFIG = "config"; // Count: 7
var _DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 3
var _DYN_LOGGER = "logger"; // Count: 9
var _DynamicConstants_DYN_LENGTH = "length"; // Count: 43
var _DYN_TIME = "time"; // Count: 5
var _DYN_PROCESS_NEXT = "processNext"; // Count: 21
var _DYN_GET_PROCESS_TEL_CONT0 = "getProcessTelContext"; // Count: 2
var _DYN_ADD_NOTIFICATION_LIS1 = "addNotificationListener"; // Count: 5
var _DYN_REMOVE_NOTIFICATION_2 = "removeNotificationListener"; // Count: 5
var _DYN_STOP_POLLING_INTERNA3 = "stopPollingInternalLogs"; // Count: 2
var _DYN_ON_COMPLETE = "onComplete"; // Count: 4
var _DYN_GET_PLUGIN = "getPlugin"; // Count: 5
var _DYN_FLUSH = "flush"; // Count: 5
var _DYN__EXTENSIONS = "_extensions"; // Count: 4
var _DYN_SPLICE = "splice"; // Count: 6
var _DYN_TEARDOWN = "teardown"; // Count: 10
var _DYN_MESSAGE_ID = "messageId"; // Count: 4
var _DYN_MESSAGE = "message"; // Count: 7
var _DYN_IS_ASYNC = "isAsync"; // Count: 7
var _DynamicConstants_DYN_DO_TEARDOWN = "_doTeardown"; // Count: 4
var _DYN_UPDATE = "update"; // Count: 7
var _DYN_GET_NEXT = "getNext"; // Count: 12
var _DYN_DIAG_LOG = "diagLog"; // Count: 8
var _DYN_SET_NEXT_PLUGIN = "setNextPlugin"; // Count: 5
var _DYN_CREATE_NEW = "createNew"; // Count: 6
var _DYN_COOKIE_CFG = "cookieCfg"; // Count: 3
var _DynamicConstants_DYN_INDEX_OF = "indexOf"; // Count: 6
var _DynamicConstants_DYN_SUBSTRING = "substring"; // Count: 10
var _DynamicConstants_DYN_USER_AGENT = "userAgent"; // Count: 5
var _DYN_SPLIT = "split"; // Count: 5
var _DYN_SET_ENABLED = "setEnabled"; // Count: 5
var _DYN_SUBSTR = "substr"; // Count: 6
var _DYN_NODE_TYPE = "nodeType"; // Count: 3
var _DYN_APPLY = "apply"; // Count: 6
var _DYN_REPLACE = "replace"; // Count: 10
var _DYN_ENABLE_DEBUG_EXCEPTI4 = "enableDebugExceptions"; // Count: 2
var _DYN_LOG_INTERNAL_MESSAGE = "logInternalMessage"; // Count: 2
var _DynamicConstants_DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 5
var _DynamicConstants_DYN_CALL = "call"; // Count: 18
var _DynamicConstants_DYN_TYPE = "type"; // Count: 14
var _DynamicConstants_DYN_HANDLER = "handler"; // Count: 5
var _DYN_LISTENERS = "listeners"; // Count: 6
var _DYN_IS_CHILD_EVT = "isChildEvt"; // Count: 3
var _DYN_GET_CTX = "getCtx"; // Count: 6
var _DYN_SET_CTX = "setCtx"; // Count: 10
var _DYN_COMPLETE = "complete"; // Count: 3
var _DynamicConstants_DYN_TRACE_ID = "traceId"; // Count: 5
var _DynamicConstants_DYN_SPAN_ID = "spanId"; // Count: 5
var _DynamicConstants_DYN_TRACE_FLAGS = "traceFlags"; // Count: 6
var _DynamicConstants_DYN_VERSION = "version"; // Count: 4
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/InternalConstants.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var InternalConstants_STR_EMPTY = "";
var STR_CHANNELS = "channels";
var STR_CORE = "core";
var STR_CREATE_PERF_MGR = "createPerfMgr";
var STR_DISABLED = "disabled";
var STR_EXTENSION_CONFIG = "extensionConfig";
var STR_EXTENSIONS = "extensions";
var STR_PROCESS_TELEMETRY = "processTelemetry";
var STR_PRIORITY = "priority";
var STR_EVENTS_SENT = "eventsSent";
var STR_EVENTS_DISCARDED = "eventsDiscarded";
var STR_EVENTS_SEND_REQUEST = "eventsSendRequest";
var STR_PERF_EVENT = "perfEvent";
var STR_ERROR_TO_CONSOLE = "errorToConsole";
var STR_WARN_TO_CONSOLE = "warnToConsole";
var STR_GET_PERF_MGR = "getPerfMgr";
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/HelperFuncs.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minfication
var strToISOString = "toISOString";
var cStrEndsWith = "endsWith";
var cStrStartsWith = "startsWith";
var strIndexOf = "indexOf";
var strMap = "map";
var strReduce = "reduce";
var cStrTrim = "trim";
var strToString = "toString";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
  * Constant string defined to support minimization
  * @ignore
  */
var strConstructor = "constructor";
var _objDefineProperty = Constants_ObjDefineProperty;
var _objFreeze = Constants_ObjClass.freeze;
var _objSeal = Constants_ObjClass.seal;
var _objKeys = Constants_ObjClass.keys;
var StringProto = String[Constants_strShimPrototype];
var _strTrim = StringProto[cStrTrim];
var _strEndsWith = StringProto[cStrEndsWith];
var _strStartsWith = StringProto[cStrStartsWith];
var DateProto = Date[Constants_strShimPrototype];
var _dataToISOString = DateProto[strToISOString];
var _isArray = Array.isArray;
var _objToString = Constants_ObjProto[strToString];
var _fnToString = Constants_ObjHasOwnProperty[strToString];
// Cache what this browser reports as the object function constructor (as a string)
var _objFunctionString = _fnToString[_DynamicConstants_DYN_CALL /* @min:%2ecall */](Constants_ObjClass);
var rCamelCase = /-([a-z])/g;
var rNormalizeInvalid = /([^\w\d_$])/g;
var rLeadingNumeric = /^(\d+[\w\d_$])/;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Object["getPrototypeOf"];
/**
  * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
  * @ignore
  */
function _getObjProto(target) {
  if (target) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if (_objGetPrototypeOf) {
      return _objGetPrototypeOf(target);
    }
    // target[Constructor] May break if the constructor has been changed or removed
    var newProto = target[str__Proto] || target[Constants_strShimPrototype] || target[strConstructor];
    if (newProto) {
      return newProto;
    }
  }
  return null;
}
function objToString(obj) {
  return _objToString[_DYN_CALL /* @min:%2ecall */](obj);
}
function isTypeof(value, theType) {
  return typeof value === theType;
}
function isUndefined(value) {
  return value === undefined || typeof value === Constants_strShimUndefined;
}
function isNotUndefined(value) {
  return !isUndefined(value);
}
function isNullOrUndefined(value) {
  return value === null || isUndefined(value);
}
function isNotNullOrUndefined(value) {
  return !isNullOrUndefined(value);
}
function HelperFuncs_hasOwnProperty(obj, prop) {
  return !!(obj && Constants_ObjHasOwnProperty[_DynamicConstants_DYN_CALL /* @min:%2ecall */](obj, prop));
}
function isObject(value) {
  // Changing to inline for performance
  return !!(value && typeof value === strShimObject);
}
function HelperFuncs_isFunction(value) {
  // Changing to inline for performance
  return !!(value && typeof value === Constants_strShimFunction);
}
function isPromiseLike(value) {
  return value && HelperFuncs_isFunction(value.then);
}
/**
 * Validates that the string name conforms to the JS IdentifierName specification and if not
 * normalizes the name so that it would. This method does not identify or change any keywords
 * meaning that if you pass in a known keyword the same value will be returned.
 * This is a simplified version
 * @param name The name to validate
 */
function normalizeJsName(name) {
  var value = name;
  if (value && HelperFuncs_isString(value)) {
    // CamelCase everything after the "-" and remove the dash
    value = value[_DYN_REPLACE /* @min:%2ereplace */](rCamelCase, function (_all, letter) {
      return letter.toUpperCase();
    });
    value = value[_DYN_REPLACE /* @min:%2ereplace */](rNormalizeInvalid, "_");
    value = value[_DYN_REPLACE /* @min:%2ereplace */](rLeadingNumeric, function (_all, match) {
      return "_" + match;
    });
  }
  return value;
}
/**
 * This is a helper function for the equivalent of arForEach(objKeys(target), callbackFn), this is a
 * performance optimization to avoid the creation of a new array for large objects
 * @param target The target object to find and process the keys
 * @param callbackfn The function to call with the details
 */
function HelperFuncs_objForEachKey(target, callbackfn) {
  if (target) {
    for (var prop in target) {
      if (Constants_ObjHasOwnProperty[_DynamicConstants_DYN_CALL /* @min:%2ecall */](target, prop)) {
        callbackfn[_DynamicConstants_DYN_CALL /* @min:%2ecall */](target, prop, target[prop]);
      }
    }
  }
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
  var result = false;
  if (value && search && !(result = value === search)) {
    // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    result = _strEndsWith ? value[cStrEndsWith](search) : _strEndsWithPoly(value, search);
  }
  return result;
}
/**
 * The _strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function _strEndsWithPoly(value, search) {
  var result = false;
  var searchLen = search ? search[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] : 0;
  var valLen = value ? value[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] : 0;
  if (searchLen && valLen && valLen >= searchLen && !(result = value === search)) {
    var pos = valLen - 1;
    for (var lp = searchLen - 1; lp >= 0; lp--) {
      if (value[pos] != search[lp]) {
        return false;
      }
      pos--;
    }
    result = true;
  }
  return result;
}
/**
 * The strStartsWith() method determines whether a string starts with the characters of the specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param checkValue - The characters to be searched for at the start of the value.
 * @returns true if the given search value is found at the start of the string, otherwise false.
 */
function strStartsWith(value, checkValue) {
  var result = false;
  if (value && checkValue && !(result = value === checkValue)) {
    // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    result = _strStartsWith ? value[cStrStartsWith](checkValue) : _strStartsWithPoly(value, checkValue);
  }
  return result;
}
/**
 * The strStartsWith() method determines whether a string starts with the characters of the specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param checkValue - The characters to be searched for at the start of the value.
 * @returns true if the given search value is found at the start of the string, otherwise false.
 */
function _strStartsWithPoly(value, checkValue) {
  // Using helper for performance and because string startsWith() is not available on IE
  var result = false;
  var chkLen = checkValue ? checkValue[_DYN_LENGTH /* @min:%2elength */] : 0;
  if (value && chkLen && value[_DYN_LENGTH /* @min:%2elength */] >= chkLen && !(result = value === checkValue)) {
    for (var lp = 0; lp < chkLen; lp++) {
      if (value[lp] !== checkValue[lp]) {
        return false;
      }
    }
    result = true;
  }
  return result;
}
/**
 * A simple wrapper (for minification support) to check if the value contains the search string.
 * @param value - The string value to check for the existence of the search value
 * @param search - The value search within the value
 */
function strContains(value, search) {
  if (value && search) {
    return value[_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */](search) !== -1;
  }
  return false;
}
/**
 * Check if an object is of type Date
 */
function isDate(obj) {
  return !!(obj && _objToString[_DynamicConstants_DYN_CALL /* @min:%2ecall */](obj) === "[object Date]");
}
/**
 * Check if an object is of type Array with optional generic T, the generic type is not validated
 * and exists to help with TypeScript validation only.
 */
var HelperFuncs_isArray = _isArray || _isArrayPoly;
function _isArrayPoly(obj) {
  return !!(obj && _objToString[_DynamicConstants_DYN_CALL /* @min:%2ecall */](obj) === "[object Array]");
}
/**
 * Check if an object is of type Error
 */
function isError(obj) {
  return !!(obj && _objToString[_DynamicConstants_DYN_CALL /* @min:%2ecall */](obj) === "[object Error]");
}
/**
 * Checks if the type of value is a string.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a string, false otherwise.
 */
function HelperFuncs_isString(value) {
  // Changing to inline for performance
  return typeof value === "string";
}
/**
 * Checks if the type of value is a number.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a number, false otherwise.
 */
function isNumber(value) {
  // Changing to inline for performance
  return typeof value === "number";
}
/**
 * Checks if the type of value is a boolean.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a boolean, false otherwise.
 */
function isBoolean(value) {
  // Changing to inline for performance
  return typeof value === "boolean";
}
/**
 * Checks if the type of value is a Symbol.
 * This only returns a boolean as returning value is Symbol will cause issues for older TypeScript consumers
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a Symbol, false otherwise.
 */
function isSymbol(value) {
  return typeof value === "symbol";
}
/**
 * Checks if the type of the value is a normal plain object (not a null or data)
 * @param value
 */
function isPlainObject(value) {
  var result = false;
  if (value && typeof value === "object") {
    // Inlining _objGetPrototypeOf for performance to avoid an additional function call
    var proto = _objGetPrototypeOf ? _objGetPrototypeOf(value) : _getObjProto(value);
    if (!proto) {
      // No prototype found so this is a plain Object eg. 'Object.create(null)'
      result = true;
    } else {
      // Objects that have a prototype are plain only if they were created using the Object global (native) function
      if (proto[strConstructor] && Constants_ObjHasOwnProperty[_DynamicConstants_DYN_CALL /* @min:%2ecall */](proto, strConstructor)) {
        proto = proto[strConstructor];
      }
      result = typeof proto === Constants_strShimFunction && _fnToString[_DynamicConstants_DYN_CALL /* @min:%2ecall */](proto) === _objFunctionString;
    }
  }
  return result;
}
/**
 * Convert a date to I.S.O. format in IE8
 */
function toISOString(date) {
  if (date) {
    // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    return _dataToISOString ? date[strToISOString]() : _toISOStringPoly(date);
  }
}
/**
 * Convert a date to I.S.O. format in IE8
 */
function _toISOStringPoly(date) {
  if (date && date.getUTCFullYear) {
    var pad = function (num) {
      var r = String(num);
      if (r[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 1) {
        r = "0" + r;
      }
      return r;
    };
    return date.getUTCFullYear() + "-" + pad(date.getUTCMonth() + 1) + "-" + pad(date.getUTCDate()) + "T" + pad(date.getUTCHours()) + ":" + pad(date.getUTCMinutes()) + ":" + pad(date.getUTCSeconds()) + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5) + "Z";
  }
}
/**
 * Performs the specified action for each element in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array. It can return -1 to break out of the loop
 * @param thisArg  [Optional] An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function HelperFuncs_arrForEach(arr, callbackfn, thisArg) {
  var len = arr[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
  try {
    for (var idx = 0; idx < len; idx++) {
      if (idx in arr) {
        if (callbackfn[_DynamicConstants_DYN_CALL /* @min:%2ecall */](thisArg || arr, arr[idx], idx, arr) === -1) {
          break;
        }
      }
    }
  } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
  }
}
/**
 * Returns the index of the first occurrence of a value in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param searchElement The value to locate in the array.
 * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
 */
function arrIndexOf(arr, searchElement, fromIndex) {
  if (arr) {
    // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    if (arr[strIndexOf]) {
      return arr[strIndexOf](searchElement, fromIndex);
    }
    var len = arr[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    var from = fromIndex || 0;
    try {
      for (var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++) {
        if (lp in arr && arr[lp] === searchElement) {
          return lp;
        }
      }
    } catch (e) {
      // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
  }
  return -1;
}
/**
 * Calls a defined callback function on each element of an array, and returns an array that contains the results. This helper exists
 * to avoid adding a polyfil for older browsers that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page
 * checks for presence/absence of the prototype implementation. Note: For consistency this will not use the Array.prototype.xxxx
 * implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
 * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrMap(arr, callbackfn, thisArg) {
  var results;
  if (arr) {
    // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    if (arr[strMap]) {
      return arr[strMap](callbackfn, thisArg);
    }
    var len = arr[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    var _this = thisArg || arr;
    results = new Array(len);
    try {
      for (var lp = 0; lp < len; lp++) {
        if (lp in arr) {
          results[lp] = callbackfn[_DynamicConstants_DYN_CALL /* @min:%2ecall */](_this, arr[lp], arr);
        }
      }
    } catch (e) {
      // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
  }
  return results;
}
/**
 * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is
 * provided as an argument in the next call to the callback function. This helper exists to avoid adding a polyfil for older browsers that do not define
 * Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype implementation. Note: For consistency
 * this will not use the Array.prototype.xxxx implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
 * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
 */
function arrReduce(arr, callbackfn, initialValue) {
  var value;
  if (arr) {
    // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    if (arr[strReduce]) {
      return arr[strReduce](callbackfn, initialValue);
    }
    var len = arr[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    var lp = 0;
    // Specifically checking the number of passed arguments as the value could be anything
    if (arguments[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] >= 3) {
      value = arguments[2];
    } else {
      while (lp < len && !(lp in arr)) {
        lp++;
      }
      value = arr[lp++];
    }
    while (lp < len) {
      if (lp in arr) {
        value = callbackfn(value, arr[lp], lp, arr);
      }
      lp++;
    }
  }
  return value;
}
/**
 * helper method to trim strings (IE8 does not implement String.prototype.trim)
 */
function HelperFuncs_strTrim(str) {
  if (str) {
    // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    str = _strTrim && str[cStrTrim] ? str[cStrTrim]() : str[_DYN_REPLACE /* @min:%2ereplace */] ? str[_DYN_REPLACE /* @min:%2ereplace */](/^\s+|(?=\s)\s+$/g, InternalConstants_STR_EMPTY) : str;
  }
  return str;
}
var _objKeysHasDontEnumBug = !{
  toString: null
}.propertyIsEnumerable("toString");
var _objKeysDontEnums = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"];
/**
 * Returns the names of the enumerable string properties and methods of an object. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Object.keys eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.keys implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object that contains the properties and methods. This can be an object that you created or an existing Document Object Model (DOM) object.
 */
function objKeys(obj) {
  var objType = typeof obj;
  if (objType !== Constants_strShimFunction && (objType !== strShimObject || obj === null)) {
    Helpers_throwTypeError("objKeys called on non-object");
  }
  // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
  if (!_objKeysHasDontEnumBug && _objKeys) {
    return _objKeys(obj);
  }
  var result = [];
  for (var prop in obj) {
    if (obj && Constants_ObjHasOwnProperty[_DynamicConstants_DYN_CALL /* @min:%2ecall */](obj, prop)) {
      result[_DynamicConstants_DYN_PUSH /* @min:%2epush */](prop);
    }
  }
  if (_objKeysHasDontEnumBug) {
    var dontEnumsLength = _objKeysDontEnums[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    for (var lp = 0; lp < dontEnumsLength; lp++) {
      if (obj && Constants_ObjHasOwnProperty[_DynamicConstants_DYN_CALL /* @min:%2ecall */](obj, _objKeysDontEnums[lp])) {
        result[_DynamicConstants_DYN_PUSH /* @min:%2epush */](_objKeysDontEnums[lp]);
      }
    }
  }
  return result;
}
/**
 * Try to define get/set object property accessors for the target object/prototype, this will provide compatibility with
 * existing API definition when run within an ES5+ container that supports accessors but still enable the code to be loaded
 * and executed in an ES3 container, providing basic IE8 compatibility.
 * @param target The object on which to define the property.
 * @param prop The name of the property to be defined or modified.
 * @param getProp The getter function to wire against the getter.
 * @param setProp The setter function to wire against the setter.
 * @returns True if it was able to create the accessors otherwise false
 */
function objDefineAccessors(target, prop, getProp, setProp) {
  if (_objDefineProperty) {
    try {
      var descriptor = {
        enumerable: true,
        configurable: true
      };
      if (getProp) {
        descriptor.get = getProp;
      }
      if (setProp) {
        descriptor.set = setProp;
      }
      _objDefineProperty(target, prop, descriptor);
      return true;
    } catch (e) {
      // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
      // We will just ignore this here.
    }
  }
  return false;
}
function _doNothing(value) {
  return value;
}
function HelperFuncs_deepFreeze(obj) {
  if (_objFreeze) {
    HelperFuncs_objForEachKey(obj, function (name, value) {
      if (HelperFuncs_isArray(value) || isObject(value)) {
        _objFreeze(value);
      }
    });
  }
  return objFreeze(obj);
}
var objFreeze = _objFreeze || _doNothing;
var objSeal = _objSeal || _doNothing;
/**
 * Return the current time via the Date now() function (if available) and falls back to (new Date()).getTime() if now() is unavailable (IE8 or less)
 * https://caniuse.com/#search=Date.now
 */
function dateNow() {
  var dt = Date;
  return dt.now ? dt.now() : new dt().getTime();
}
/**
 * Returns the name of object if it's an Error. Otherwise, returns empty string.
 */
function getExceptionName(object) {
  if (isError(object)) {
    return object[_DynamicConstants_DYN_NAME /* @min:%2ename */];
  }

  return InternalConstants_STR_EMPTY;
}
/**
 * Sets the provided value on the target instance using the field name when the provided chk function returns true, the chk
 * function will only be called if the new value is no equal to the original value.
 * @param target - The target object
 * @param field - The key of the target
 * @param value - The value to set
 * @param valChk - [Optional] Callback to check the value that if supplied will be called check if the new value can be set
 * @param srcChk - [Optional] Callback to check to original value that if supplied will be called if the new value should be set (if allowed)
 * @returns The existing or new value, depending what was set
 */
function setValue(target, field, value, valChk, srcChk) {
  var theValue = value;
  if (target) {
    theValue = target[field];
    if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
      theValue = value;
      target[field] = theValue;
    }
  }
  return theValue;
}
/**
 * Returns the current value from the target object if not null or undefined otherwise sets the new value and returns it
 * @param target - The target object to return or set the default value
 * @param field - The key for the field to set on the target
 * @param defValue - [Optional] The value to set if not already present, when not provided a empty object will be added
 */
function getSetValue(target, field, defValue) {
  var theValue;
  if (target) {
    theValue = target[field];
    if (!theValue && isNullOrUndefined(theValue)) {
      // Supports having the default as null
      theValue = !isUndefined(defValue) ? defValue : {};
      target[field] = theValue;
    }
  } else {
    // Expanded for performance so we only check defValue if required
    theValue = !isUndefined(defValue) ? defValue : {};
  }
  return theValue;
}
/**
 * Get the mapped config value, if null or undefined any supplied defaultValue will be returned.
 * @param field - The name of the field as the named enum value (number) or the string name.
 * @param defaultValue - The default value to return if the config field is not present, null or undefined.
 */
function getCfgValue(theValue, defaultValue) {
  return !isNullOrUndefined(theValue) ? theValue : defaultValue;
}
function isNotTruthy(value) {
  return !value;
}
function isTruthy(value) {
  return !!value;
}
function throwError(message) {
  throw new Error(message);
}
function _createProxyFunction(source, funcName) {
  var srcFunc = null;
  var src = null;
  if (HelperFuncs_isFunction(source)) {
    srcFunc = source;
  } else {
    src = source;
  }
  return function () {
    // Capture the original arguments passed to the method
    var originalArguments = arguments;
    if (srcFunc) {
      src = srcFunc();
    }
    if (src) {
      return src[funcName][_DYN_APPLY /* @min:%2eapply */](src, originalArguments);
    }
  };
}
/**
 * Effectively assigns all enumerable properties (not just own properties) and functions (including inherited prototype) from
 * the source object to the target, it attempts to use proxy getters / setters (if possible) and proxy functions to avoid potential
 * implementation issues by assigning prototype functions as instance ones
 *
 * This method is the primary method used to "update" the snippet proxy with the ultimate implementations.
 *
 * Special ES3 Notes:
 * Updates (setting) of direct property values on the target or indirectly on the source object WILL NOT WORK PROPERLY, updates to the
 * properties of "referenced" object will work (target.context.newValue = 10 => will be reflected in the source.context as it's the
 * same object). ES3 Failures: assigning target.myProp = 3 -> Won't change source.myProp = 3, likewise the reverse would also fail.
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param chkSet - An optional callback to determine whether a specific property/function should be proxied
 */
function proxyAssign(target, source, chkSet) {
  if (target && source && isObject(target) && isObject(source)) {
    var _loop_1 = function (field) {
      if (HelperFuncs_isString(field)) {
        var value = source[field];
        if (HelperFuncs_isFunction(value)) {
          if (!chkSet || chkSet(field, true, source, target)) {
            // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
            target[field] = _createProxyFunction(source, field);
          }
        } else if (!chkSet || chkSet(field, false, source, target)) {
          if (HelperFuncs_hasOwnProperty(target, field)) {
            // Remove any previous instance property
            delete target[field];
          }
          if (!objDefineAccessors(target, field, function () {
            return source[field];
          }, function (theValue) {
            source[field] = theValue;
          })) {
            // Unable to create an accessor, so just assign the values as a fallback
            // -- this will (mostly) work for objects
            // -- but will fail for accessing primitives (if the source changes it) and all types of "setters" as the source won't be modified
            target[field] = value;
          }
        }
      }
    };
    // effectively apply/proxy full source to the target instance
    for (var field in source) {
      _loop_1(field);
    }
  }
  return target;
}
/**
 * Creates a proxy function on the target which internally will call the source version with all arguments passed to the target method.
 *
 * @param target - The target object to be assigned with the source properties and functions
 * @param name - The function name that will be added on the target
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param theFunc - The function name on the source that will be proxied on the target
 * @param overwriteTarget - If `false` this will not replace any pre-existing name otherwise (the default) it will overwrite any existing name
 */
function proxyFunctionAs(target, name, source, theFunc, overwriteTarget) {
  if (target && name && source) {
    if (overwriteTarget !== false || isUndefined(target[name])) {
      target[name] = _createProxyFunction(source, theFunc);
    }
  }
}
/**
 * Creates proxy functions on the target which internally will call the source version with all arguments passed to the target method.
 *
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param functionsToProxy - An array of function names that will be proxied on the target
 * @param overwriteTarget - If false this will not replace any pre-existing name otherwise (the default) it will overwrite any existing name
 */
function proxyFunctions(target, source, functionsToProxy, overwriteTarget) {
  if (target && source && isObject(target) && HelperFuncs_isArray(functionsToProxy)) {
    HelperFuncs_arrForEach(functionsToProxy, function (theFuncName) {
      if (HelperFuncs_isString(theFuncName)) {
        proxyFunctionAs(target, theFuncName, source, theFuncName, overwriteTarget);
      }
    });
  }
  return target;
}
/**
 * Simpler helper to create a dynamic class that implements the interface and populates the values with the defaults.
 * Only instance properties (hasOwnProperty) values are copied from the defaults to the new instance
 * @param defaults Simple helper
 */
function createClassFromInterface(defaults) {
  return (/** @class */function () {
      function class_1() {
        var _this_1 = this;
        if (defaults) {
          HelperFuncs_objForEachKey(defaults, function (field, value) {
            _this_1[field] = value;
          });
        }
      }
      return class_1;
    }()
  );
}
/**
 * A helper function to assist with JIT performance for objects that have properties added / removed dynamically
 * this is primarily for chromium based browsers and has limited effects on Firefox and none of IE. Only call this
 * function after you have finished "updating" the object, calling this within loops reduces or defeats the benefits.
 * This helps when iterating using for..in, objKeys() and objForEach()
 * @param theObject - The object to be optimized if possible
 */
function optimizeObject(theObject) {
  // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
  // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
  if (theObject && ObjAssign) {
    theObject = Constants_ObjClass(ObjAssign({}, theObject));
  }
  return theObject;
}
function objExtend(obj1, obj2, obj3, obj4, obj5, obj6) {
  // Variables
  var theArgs = arguments;
  var extended = theArgs[0] || {};
  var argLen = theArgs[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
  var deep = false;
  var idx = 1;
  // Check for "Deep" flag
  if (argLen > 0 && isBoolean(extended)) {
    deep = extended;
    extended = theArgs[idx] || {};
    idx++;
  }
  // Handle case when target is a string or something (possible in deep copy)
  if (!isObject(extended)) {
    extended = {};
  }
  // Loop through each remaining object and conduct a merge
  for (; idx < argLen; idx++) {
    var arg = theArgs[idx];
    var isArgArray = HelperFuncs_isArray(arg);
    var isArgObj = isObject(arg);
    for (var prop in arg) {
      var propOk = isArgArray && prop in arg || isArgObj && Constants_ObjHasOwnProperty[_DynamicConstants_DYN_CALL /* @min:%2ecall */](arg, prop);
      if (!propOk) {
        continue;
      }
      var newValue = arg[prop];
      var isNewArray = void 0;
      // If deep merge and property is an object, merge properties
      if (deep && newValue && ((isNewArray = HelperFuncs_isArray(newValue)) || isPlainObject(newValue))) {
        // Grab the current value of the extended object
        var clone = extended[prop];
        if (isNewArray) {
          if (!HelperFuncs_isArray(clone)) {
            // We can't "merge" an array with a non-array so overwrite the original
            clone = [];
          }
        } else if (!isPlainObject(clone)) {
          // We can't "merge" an object with a non-object
          clone = {};
        }
        // Never move the original objects always clone them
        newValue = objExtend(deep, clone, newValue);
      }
      // Assign the new (or previous) value (unless undefined)
      if (newValue !== undefined) {
        extended[prop] = newValue;
      }
    }
  }
  return extended;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK.Enums/EnumHelperFuncs.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Create an enum style object which has both the key => value and value => key mappings
 * @param values - The values to populate on the new object
 * @returns
 */
function createEnumStyle(values) {
  var enumClass = {};
  HelperFuncs_objForEachKey(values, function (field, value) {
    enumClass[field] = value;
    enumClass[value] = field;
  });
  return HelperFuncs_deepFreeze(enumClass);
}
/**
 * Create a 2 index map that maps an enum's key as both the key and value, X["key"] => "key" and X[0] => "keyof 0".
 * @param values - The values to populate on the new object
 * @returns
 */
function createEnumMap(values) {
  var mapClass = {};
  objForEachKey(values, function (field, value) {
    mapClass[field] = field;
    mapClass[value] = field;
  });
  return deepFreeze(mapClass);
}
/**
 * Create a 2 index map that maps an enum's key and value to the defined map value, X["key"] => mapValue and X[0] => mapValue.
 * Generic values
 * - E = the const enum type (typeof eRequestHeaders);
 * - V = Identifies the valid values for the keys, this should include both the enum numeric and string key of the type. The
 * resulting "Value" of each entry identifies the valid values withing the assignments.
 * @param values - The values to populate on the new object
 * @returns
 */
function createValueMap(values) {
  var mapClass = {};
  HelperFuncs_objForEachKey(values, function (field, value) {
    mapClass[field] = value[1];
    mapClass[value[0]] = value[1];
  });
  return HelperFuncs_deepFreeze(mapClass);
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Interfaces/Contracts/SeverityLevel.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Defines the level of severity for the event.
 */
var SeverityLevel = createEnumStyle({
  Verbose: 0 /* eSeverityLevel.Verbose */,
  Information: 1 /* eSeverityLevel.Information */,
  Warning: 2 /* eSeverityLevel.Warning */,
  Error: 3 /* eSeverityLevel.Error */,
  Critical: 4 /* eSeverityLevel.Critical */
});
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-react-js/dist-esm/AppInsightsErrorBoundary.js
/*
 * Application Insights JavaScript SDK - React Plugin, 3.4.0
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var AppInsightsErrorBoundary = /** @class */function (_super) {
  __extendsFn(AppInsightsErrorBoundary, _super);
  function AppInsightsErrorBoundary() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  AppInsightsErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
    this.setState({
      hasError: true
    });
    this.props.appInsights.trackException({
      error: error,
      exception: error,
      severityLevel: SeverityLevel.Error,
      properties: errorInfo
    });
  };
  AppInsightsErrorBoundary.prototype.render = function () {
    if (this.state.hasError) {
      var onError = this.props.onError;
      return react.createElement(onError);
    }
    return this.props.children;
  };
  return AppInsightsErrorBoundary;
}(react.Component);
/* harmony default export */ var dist_esm_AppInsightsErrorBoundary = (AppInsightsErrorBoundary);
// EXTERNAL MODULE: ./src/components/ui/logo/index.tsx + 5 modules
var logo = __webpack_require__(38364);
;// CONCATENATED MODULE: ./node_modules/@microsoft/dynamicproto-js/lib/dist/esm/dynamicproto-js.js
/*!
 * Microsoft Dynamic Proto Utility, 1.1.7
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _a;
var UNDEFINED = "undefined";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Constructor = 'constructor';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Prototype = 'prototype';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strFunction = 'function';
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */
var DynInstFuncTable = '_dynInstFuncs';
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */
var DynProxyTag = '_isDynProxy';
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */
var DynClassName = '_dynClass';
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */
var DynClassNamePrefix = '_dynCls$';
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */
var DynInstChkTag = '_dynInstChk';
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */
var DynAllowInstChkTag = DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */
var DynProtoDefaultOptions = '_dfOpts';
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */
var UnknownValue = '_unknown_';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var dynamicproto_js_str_Proto = "__proto__";
/**
 * The polyfill version of __proto__ so that it doesn't cause issues for anyone not expecting it to exist
 */
var DynProtoBaseProto = "_dyn" + dynamicproto_js_str_Proto;
/**
 * Runtime Global holder for dynamicProto settings
 */
var DynProtoGlobalSettings = "__dynProto$Gbl";
/**
 * Track the current prototype for IE8 as you can't look back to get the prototype
 */
var DynProtoCurrent = "_dynInstProto";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strUseBaseInst = 'useBaseInst';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strSetInstFuncs = 'setInstFuncs';
var Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var dynamicproto_js_objGetPrototypeOf = Obj["getPrototypeOf"];
/**
 * Pre-lookup to check for the existence of this function
 */
var _objGetOwnProps = Obj["getOwnPropertyNames"];
/**
 * Gets the runtime global reference
 * @returns
 */
function _getGlobal() {
  var result;
  if (typeof globalThis !== UNDEFINED) {
    result = globalThis;
  }
  if (!result && typeof self !== UNDEFINED) {
    result = self;
  }
  if (!result && typeof window !== UNDEFINED) {
    result = window;
  }
  if (!result && typeof __webpack_require__.g !== UNDEFINED) {
    result = __webpack_require__.g;
  }
  return result || {};
}
// Since 1.1.7 moving these to the runtime global to work around mixed version and module issues
// See Issue https://github.com/microsoft/DynamicProto-JS/issues/57 for details
var _gbl = _getGlobal();
var _gblInst = _gbl[DynProtoGlobalSettings] || (_gbl[DynProtoGlobalSettings] = {
  o: (_a = {}, _a[strSetInstFuncs] = true, _a[strUseBaseInst] = true, _a),
  n: 1000 // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
/**
 * Helper to check if the object contains a property of the name
 * @ignore
 */
function _hasOwnProperty(obj, prop) {
  return obj && Obj[Prototype].hasOwnProperty.call(obj, prop);
}
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */
function _isObjectOrArrayPrototype(target) {
  return target && (target === Obj[Prototype] || target === Array[Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */
function _isObjectArrayOrFunctionPrototype(target) {
  return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function dynamicproto_js_getObjProto(target) {
  var newProto;
  if (target) {
    // This method doesn't exist in older browsers (e.g. IE8)
    if (dynamicproto_js_objGetPrototypeOf) {
      return dynamicproto_js_objGetPrototypeOf(target);
    }
    var curProto = target[dynamicproto_js_str_Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
    // Using the pre-calculated value as IE8 doesn't support looking up the prototype of a prototype and thus fails for more than 1 base class
    newProto = target[DynProtoBaseProto] || curProto;
    if (!_hasOwnProperty(target, DynProtoBaseProto)) {
      // As this prototype doesn't have this property then this is from an inherited class so newProto is the base to return so save it
      // so we can look it up value (which for a multiple hierarchy dynamicProto will be the base class)
      delete target[DynProtoCurrent]; // Delete any current value allocated to this instance so we pick up the value from prototype hierarchy
      newProto = target[DynProtoBaseProto] = target[DynProtoCurrent] || target[DynProtoBaseProto];
      target[DynProtoCurrent] = curProto;
    }
  }
  return newProto;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */
function _forEachProp(target, func) {
  var props = [];
  if (_objGetOwnProps) {
    props = _objGetOwnProps(target);
  } else {
    for (var name_1 in target) {
      if (typeof name_1 === "string" && _hasOwnProperty(target, name_1)) {
        props.push(name_1);
      }
    }
  }
  if (props && props.length > 0) {
    for (var lp = 0; lp < props.length; lp++) {
      func(props[lp]);
    }
  }
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */
function _isDynamicCandidate(target, funcName, skipOwn) {
  return funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || _hasOwnProperty(target, funcName));
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */
function _throwTypeError(message) {
  throw new TypeError("DynamicProto: " + message);
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */
function _getInstanceFuncs(thisTarget) {
  // Get the base proto
  var instFuncs = {};
  // Save any existing instance functions
  _forEachProp(thisTarget, function (name) {
    // Don't include any dynamic prototype instances - as we only want the real functions
    if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
      // Create an instance callback for passing the base function to the caller
      instFuncs[name] = thisTarget[name];
    }
  });
  return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */
function _hasVisited(values, value) {
  for (var lp = values.length - 1; lp >= 0; lp--) {
    if (values[lp] === value) {
      return true;
    }
  }
  return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */
function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
  function _instFuncProxy(target, funcHost, funcName) {
    var theFunc = funcHost[funcName];
    if (theFunc[DynProxyTag] && useBaseInst) {
      // grab and reuse the hosted looking function (if available) otherwise the original passed function
      var instFuncTable = target[DynInstFuncTable] || {};
      if (instFuncTable[DynAllowInstChkTag] !== false) {
        theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
      }
    }
    return function () {
      // eslint-disable-next-line prefer-rest-params
      return theFunc.apply(target, arguments);
    };
  }
  // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
  var baseFuncs = {};
  _forEachProp(instFuncs, function (name) {
    // Create an instance callback for passing the base function to the caller
    baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
  });
  // Get the base prototype functions
  var baseProto = dynamicproto_js_getObjProto(classProto);
  var visited = [];
  // Don't include base object functions for Object, Array or Function
  while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
    // look for prototype functions
    _forEachProp(baseProto, function (name) {
      // Don't include any dynamic prototype instances - as we only want the real functions
      // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
      // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
      // the Object prototype methods while bypassing the check
      if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !dynamicproto_js_objGetPrototypeOf)) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
      }
    });
    // We need to find all possible functions that might be overloaded by walking the entire prototype chain
    // This avoids the caller from needing to check whether it's direct base class implements the function or not
    // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
    visited.push(baseProto);
    baseProto = dynamicproto_js_getObjProto(baseProto);
  }
  return baseFuncs;
}
function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
  var instFunc = null;
  // We need to check whether the class name is defined directly on this prototype otherwise
  // it will walk the proto chain and return any parent proto classname.
  if (target && _hasOwnProperty(proto, DynClassName)) {
    var instFuncTable = target[DynInstFuncTable] || {};
    instFunc = (instFuncTable[proto[DynClassName]] || {})[funcName];
    if (!instFunc) {
      // Avoid stack overflow from recursive calling the same function
      _throwTypeError("Missing [" + funcName + "] " + strFunction);
    }
    // We have the instance function, lets check it we can speed up further calls
    // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
    if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
      // If the instance already has an instance function we can't replace it
      var canAddInst = !_hasOwnProperty(target, funcName);
      // Get current prototype
      var objProto = dynamicproto_js_getObjProto(target);
      var visited = [];
      // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
      // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
      while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
        var protoFunc = objProto[funcName];
        if (protoFunc) {
          canAddInst = protoFunc === currentDynProtoProxy;
          break;
        }
        // We need to find all possible initial functions to ensure that we don't bypass a valid override function
        visited.push(objProto);
        objProto = dynamicproto_js_getObjProto(objProto);
      }
      try {
        if (canAddInst) {
          // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
          // so it's safe to directly assign for any subsequent calls (for better performance)
          target[funcName] = instFunc;
        }
        // Block further attempts to set the instance function for any
        instFunc[DynInstChkTag] = 1;
      } catch (e) {
        // Don't crash if the object is readonly or the runtime doesn't allow changing this
        // And set a flag so we don't try again for any function
        instFuncTable[DynAllowInstChkTag] = false;
      }
    }
  }
  return instFunc;
}
function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
  var protoFunc = proto[funcName];
  // Check that the prototype function is not a self reference -- try to avoid stack overflow!
  if (protoFunc === currentDynProtoProxy) {
    // It is so lookup the base prototype
    protoFunc = dynamicproto_js_getObjProto(proto)[funcName];
  }
  if (typeof protoFunc !== strFunction) {
    _throwTypeError("[" + funcName + "] is not a " + strFunction);
  }
  return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */
function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
  function _createDynamicPrototype(proto, funcName) {
    var dynProtoProxy = function () {
      // Use the instance or prototype function
      var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
      // eslint-disable-next-line prefer-rest-params
      return instFunc.apply(this, arguments);
    };
    // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
    // via which can dynamically replace the prototype function reference)
    dynProtoProxy[DynProxyTag] = 1;
    return dynProtoProxy;
  }
  if (!_isObjectOrArrayPrototype(proto)) {
    var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || {};
    var instFuncs_1 = instFuncTable[className] = instFuncTable[className] || {}; // fetch and assign if as it may not exist yet
    // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
    if (instFuncTable[DynAllowInstChkTag] !== false) {
      instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
    }
    _forEachProp(target, function (name) {
      // Only add overridden functions
      if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
        // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
        instFuncs_1[name] = target[name];
        delete target[name];
        // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
        if (!_hasOwnProperty(proto, name) || proto[name] && !proto[name][DynProxyTag]) {
          proto[name] = _createDynamicPrototype(proto, name);
        }
      }
    });
  }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */
function _checkPrototype(classProto, thisTarget) {
  // This method doesn't existing in older browsers (e.g. IE8)
  if (dynamicproto_js_objGetPrototypeOf) {
    // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
    var visited = [];
    var thisProto = dynamicproto_js_getObjProto(thisTarget);
    while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
      if (thisProto === classProto) {
        return true;
      }
      // This avoids the caller from needing to check whether it's direct base class implements the function or not
      // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
      visited.push(thisProto);
      thisProto = dynamicproto_js_getObjProto(thisProto);
    }
    return false;
  }
  // If objGetPrototypeOf doesn't exist then just assume everything is ok.
  return true;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */
function _getObjName(target, unknownValue) {
  if (_hasOwnProperty(target, Prototype)) {
    // Look like a prototype
    return target.name || unknownValue || UnknownValue;
  }
  return ((target || {})[Constructor] || {}).name || unknownValue || UnknownValue;
}
/**
 * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
 * - Saves references to all defined base class functions
 * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
 * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
 * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
 * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
 * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
 * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
 * defined in the constructor or some other function (rather than declared as complete typescript functions).
 * ### Usage
 * ```typescript
 * import dynamicProto from "@microsoft/dynamicproto-js";
 * class ExampleClass extends BaseClass {
 *     constructor() {
 *         dynamicProto(ExampleClass, this, (_self, base) => {
 *             // This will define a function that will be converted to a prototype function
 *             _self.newFunc = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     ...
 *                 }
 *             }
 *             // This will define a function that will be converted to a prototype function
 *             _self.myFunction = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     // Call the base version of the function that we are overriding
 *                     base.myFunction();
 *                 }
 *                 ...
 *             }
 *             _self.initialize = () => {
 *                 ...
 *             }
 *             // Warnings: While the following will work as _self is simply a reference to
 *             // this, if anyone overrides myFunction() the overridden will be called first
 *             // as the normal JavaScript method resolution will occur and the defined
 *             // _self.initialize() function is actually gets removed from the instance and
 *             // a proxy prototype version is created to reference the created method.
 *             _self.initialize();
 *         });
 *     }
 * }
 * ```
 * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
 * @typeparam DPCls The type that contains the prototype of the current class
 * @param theClass - This is the current class instance which contains the prototype for the current class
 * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
 * @param delegateFunc - The callback function (closure) that will create the dynamic function
 * @param options - Additional options to configure how the dynamic prototype operates
 */
function dynamicProto(theClass, target, delegateFunc, options) {
  // Make sure that the passed theClass argument looks correct
  if (!_hasOwnProperty(theClass, Prototype)) {
    _throwTypeError("theClass is an invalid class definition.");
  }
  // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
  var classProto = theClass[Prototype];
  if (!_checkPrototype(classProto, target)) {
    _throwTypeError("[" + _getObjName(theClass) + "] not in hierarchy of [" + _getObjName(target) + "]");
  }
  var className = null;
  if (_hasOwnProperty(classProto, DynClassName)) {
    // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
    className = classProto[DynClassName];
  } else {
    // As not all browser support name on the prototype creating a unique dynamic one if we have not already
    // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
    // function table lookup.
    className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _gblInst.n;
    _gblInst.n++;
    classProto[DynClassName] = className;
  }
  var perfOptions = dynamicProto[DynProtoDefaultOptions];
  var useBaseInst = !!perfOptions[strUseBaseInst];
  if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
    useBaseInst = !!options[strUseBaseInst];
  }
  // Get the current instance functions
  var instFuncs = _getInstanceFuncs(target);
  // Get all of the functions for any base instance (before they are potentially overridden)
  var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
  // Execute the delegate passing in both the current target "this" and "base" function references
  // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
  delegateFunc(target, baseFuncs);
  // Don't allow setting instance functions for older IE instances
  var setInstanceFunc = !!dynamicproto_js_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
  if (setInstanceFunc && options) {
    setInstanceFunc = !!options[strSetInstFuncs];
  }
  // Populate the Prototype for any overridden instance functions
  _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */
dynamicProto[DynProtoDefaultOptions] = _gblInst.o;

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/EnvUtils.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only use defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */
var strWindow = "window";
var strDocument = "document";
var strDocumentMode = "documentMode";
var strNavigator = "navigator";
var strHistory = "history";
var strLocation = "location";
var strConsole = "console";
var strPerformance = "performance";
var strJSON = "JSON";
var strCrypto = "crypto";
var strMsCrypto = "msCrypto";
var strReactNative = "ReactNative";
var strMsie = "msie";
var strTrident = "trident/";
var strXMLHttpRequest = "XMLHttpRequest";
var _isTrident = null;
var _navUserAgentCheck = null;
var _enableMocks = false;
var _useXDomainRequest = null;
var _beaconsSupported = null;
function _hasProperty(theClass, property) {
  var supported = false;
  if (theClass) {
    try {
      supported = property in theClass;
      if (!supported) {
        var proto = theClass[Constants_strShimPrototype];
        if (proto) {
          supported = property in proto;
        }
      }
    } catch (e) {
      // Do Nothing
    }
    if (!supported) {
      try {
        var tmp = new theClass();
        supported = !isUndefined(tmp[property]);
      } catch (e) {
        // Do Nothing
      }
    }
  }
  return supported;
}
/**
 * Enable the lookup of test mock objects if requested
 * @param enabled
 */
function setEnableEnvMocks(enabled) {
  _enableMocks = enabled;
}
/**
 * Return the named global object if available, will return null if the object is not available.
 * @param name The globally named object
 */
function getGlobalInst(name) {
  var gbl = getGlobal();
  if (gbl && gbl[name]) {
    return gbl[name];
  }
  // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
  if (name === strWindow && hasWindow()) {
    // tslint:disable-next-line: no-angle-bracket-type-assertion
    return window;
  }
  return null;
}
/**
 * Checks if window object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a window
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: window is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasWindow() {
  return Boolean(typeof window === strShimObject && window);
}
/**
 * Returns the global window object if it is present otherwise null.
 * This helper is used to access the window object without causing an exception
 * "Uncaught ReferenceError: window is not defined"
 */
function getWindow() {
  if (hasWindow()) {
    return window;
  }
  // Return the global instance or null
  return getGlobalInst(strWindow);
}
/**
 * Checks if document object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a document
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: document is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasDocument() {
  return Boolean(typeof document === strShimObject && document);
}
/**
 * Returns the global document object if it is present otherwise null.
 * This helper is used to access the document object without causing an exception
 * "Uncaught ReferenceError: document is not defined"
 */
function EnvUtils_getDocument() {
  if (hasDocument()) {
    return document;
  }
  return getGlobalInst(strDocument);
}
/**
 * Checks if navigator object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a navigator
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: navigator is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasNavigator() {
  return Boolean(typeof navigator === strShimObject && navigator);
}
/**
 * Returns the global navigator object if it is present otherwise null.
 * This helper is used to access the navigator object without causing an exception
 * "Uncaught ReferenceError: navigator is not defined"
 */
function getNavigator() {
  if (hasNavigator()) {
    return navigator;
  }
  return getGlobalInst(strNavigator);
}
/**
 * Checks if history object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: history is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasHistory() {
  return Boolean(typeof history === strShimObject && history);
}
/**
 * Returns the global history object if it is present otherwise null.
 * This helper is used to access the history object without causing an exception
 * "Uncaught ReferenceError: history is not defined"
 */
function getHistory() {
  if (hasHistory()) {
    return history;
  }
  return getGlobalInst(strHistory);
}
/**
 * Returns the global location object if it is present otherwise null.
 * This helper is used to access the location object without causing an exception
 * "Uncaught ReferenceError: location is not defined"
 */
function getLocation(checkForMock) {
  if (checkForMock && _enableMocks) {
    var mockLocation = getGlobalInst("__mockLocation");
    if (mockLocation) {
      return mockLocation;
    }
  }
  if (typeof location === strShimObject && location) {
    return location;
  }
  return getGlobalInst(strLocation);
}
/**
 * Returns the global console object
 */
function getConsole() {
  if (typeof console !== Constants_strShimUndefined) {
    return console;
  }
  return getGlobalInst(strConsole);
}
/**
 * Returns the performance object if it is present otherwise null.
 * This helper is used to access the performance object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getPerformance() {
  return getGlobalInst(strPerformance);
}
/**
 * Checks if JSON object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: JSON is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasJSON() {
  return Boolean(typeof JSON === strShimObject && JSON || getGlobalInst(strJSON) !== null);
}
/**
 * Returns the global JSON object if it is present otherwise null.
 * This helper is used to access the JSON object without causing an exception
 * "Uncaught ReferenceError: JSON is not defined"
 */
function getJSON() {
  if (hasJSON()) {
    return JSON || getGlobalInst(strJSON);
  }
  return null;
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getCrypto() {
  return getGlobalInst(strCrypto);
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getMsCrypto() {
  return getGlobalInst(strMsCrypto);
}
/**
 * Returns whether the environment is reporting that we are running in a React Native Environment
 */
function isReactNative() {
  // If running in React Native, navigator.product will be populated
  var nav = getNavigator();
  if (nav && nav.product) {
    return nav.product === strReactNative;
  }
  return false;
}
/**
 * Identifies whether the current environment appears to be IE
 */
function isIE() {
  var nav = getNavigator();
  if (nav && (nav[_DynamicConstants_DYN_USER_AGENT /* @min:%2euserAgent */] !== _navUserAgentCheck || _isTrident === null)) {
    // Added to support test mocking of the user agent
    _navUserAgentCheck = nav[_DynamicConstants_DYN_USER_AGENT /* @min:%2euserAgent */];
    var userAgent = (_navUserAgentCheck || InternalConstants_STR_EMPTY)[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
    _isTrident = strContains(userAgent, strMsie) || strContains(userAgent, strTrident);
  }
  return _isTrident;
}
/**
 * Gets IE version returning the document emulation mode if we are running on IE, or null otherwise
 */
function getIEVersion(userAgentStr) {
  if (userAgentStr === void 0) {
    userAgentStr = null;
  }
  if (!userAgentStr) {
    var navigator_1 = getNavigator() || {};
    userAgentStr = navigator_1 ? (navigator_1[_DynamicConstants_DYN_USER_AGENT /* @min:%2euserAgent */] || InternalConstants_STR_EMPTY)[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]() : InternalConstants_STR_EMPTY;
  }
  var ua = (userAgentStr || InternalConstants_STR_EMPTY)[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
  // Also check for documentMode in case X-UA-Compatible meta tag was included in HTML.
  if (strContains(ua, strMsie)) {
    var doc = EnvUtils_getDocument() || {};
    return Math.max(parseInt(ua[_DYN_SPLIT /* @min:%2esplit */](strMsie)[1]), doc[strDocumentMode] || 0);
  } else if (strContains(ua, strTrident)) {
    var tridentVer = parseInt(ua[_DYN_SPLIT /* @min:%2esplit */](strTrident)[1]);
    if (tridentVer) {
      return tridentVer + 4;
    }
  }
  return null;
}
/**
 * Returns string representation of an object suitable for diagnostics logging.
 */
function dumpObj(object) {
  var objectTypeDump = Object[Constants_strShimPrototype].toString[_DynamicConstants_DYN_CALL /* @min:%2ecall */](object);
  var propertyValueDump = InternalConstants_STR_EMPTY;
  if (objectTypeDump === "[object Error]") {
    propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object[_DynamicConstants_DYN_NAME /* @min:%2ename */] + "'";
  } else if (hasJSON()) {
    propertyValueDump = getJSON().stringify(object);
  }
  return objectTypeDump + propertyValueDump;
}
function isSafari(userAgentStr) {
  if (!userAgentStr || !isString(userAgentStr)) {
    var navigator_2 = getNavigator() || {};
    userAgentStr = navigator_2 ? (navigator_2[_DYN_USER_AGENT /* @min:%2euserAgent */] || STR_EMPTY)[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]() : STR_EMPTY;
  }
  var ua = (userAgentStr || STR_EMPTY)[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
  return ua[_DYN_INDEX_OF /* @min:%2eindexOf */]("safari") >= 0;
}
/**
 * Checks if HTML5 Beacons are supported in the current environment.
 * @returns True if supported, false otherwise.
 */
function isBeaconsSupported() {
  if (_beaconsSupported === null) {
    _beaconsSupported = hasNavigator() && Boolean(getNavigator().sendBeacon);
  }
  return _beaconsSupported;
}
/**
 * Checks if the Fetch API is supported in the current environment.
 * @param withKeepAlive - [Optional] If True, check if fetch is available and it supports the keepalive feature, otherwise only check if fetch is supported
 * @returns True if supported, otherwise false
 */
function isFetchSupported(withKeepAlive) {
  var isSupported = false;
  try {
    isSupported = !!getGlobalInst("fetch");
    var request = getGlobalInst("Request");
    if (isSupported && withKeepAlive && request) {
      isSupported = _hasProperty(request, "keepalive");
    }
  } catch (e) {
    // Just Swallow any failure during availability checks
  }
  return isSupported;
}
function useXDomainRequest() {
  if (_useXDomainRequest === null) {
    _useXDomainRequest = typeof XDomainRequest !== Constants_strShimUndefined;
    if (_useXDomainRequest && isXhrSupported()) {
      _useXDomainRequest = _useXDomainRequest && !_hasProperty(getGlobalInst(strXMLHttpRequest), "withCredentials");
    }
  }
  return _useXDomainRequest;
}
/**
 * Checks if XMLHttpRequest is supported
 * @returns True if supported, otherwise false
 */
function isXhrSupported() {
  var isSupported = false;
  try {
    var xmlHttpRequest = getGlobalInst(strXMLHttpRequest);
    isSupported = !!xmlHttpRequest;
  } catch (e) {
    // Just Swallow any failure during availability checks
  }
  return isSupported;
}
function _getNamedValue(values, name) {
  if (values) {
    for (var i = 0; i < values[_DYN_LENGTH /* @min:%2elength */]; i++) {
      var value = values[i];
      if (value[_DYN_NAME /* @min:%2ename */]) {
        if (value[_DYN_NAME /* @min:%2ename */] === name) {
          return value;
        }
      }
    }
  }
  return {};
}
/**
 * Helper function to fetch the named meta-tag from the page.
 * @param name
 */
function EnvUtils_findMetaTag(name) {
  var doc = EnvUtils_getDocument();
  if (doc && name) {
    // Look for a meta-tag
    return _getNamedValue(doc.querySelectorAll("meta"), name).content;
  }
  return null;
}
/**
 * Helper function to fetch the named server timing value from the page response (first navigation event).
 * @param name
 */
function EnvUtils_findNamedServerTiming(name) {
  var value;
  var perf = getPerformance();
  if (perf) {
    // Try looking for a server-timing header
    var navPerf = perf.getEntriesByType("navigation") || [];
    value = _getNamedValue((navPerf[_DYN_LENGTH /* @min:%2elength */] > 0 ? navPerf[0] : {}).serverTiming, name).description;
  }
  return value;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/DbgExtensionUtils.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var listenerFuncs = ["eventsSent", "eventsDiscarded", "eventsSendRequest", "perfEvent"];
var _aiNamespace = null;
var _debugListener;
function _listenerProxyFunc(name, config) {
  return function () {
    var args = arguments;
    var dbgExt = getDebugExt(config);
    if (dbgExt) {
      var listener = dbgExt.listener;
      if (listener && listener[name]) {
        listener[name][_DYN_APPLY /* @min:%2eapply */](listener, args);
      }
    }
  };
}
function _getExtensionNamespace() {
  // Cache the lookup of the global namespace object
  var target = getGlobalInst("Microsoft");
  if (target) {
    _aiNamespace = target["ApplicationInsights"];
  }
  return _aiNamespace;
}
function getDebugExt(config) {
  var ns = _aiNamespace;
  if (!ns && config.disableDbgExt !== true) {
    ns = _aiNamespace || _getExtensionNamespace();
  }
  return ns ? ns["ChromeDbgExt"] : null;
}
function getDebugListener(config) {
  if (!_debugListener) {
    _debugListener = {};
    for (var lp = 0; lp < listenerFuncs[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
      _debugListener[listenerFuncs[lp]] = _listenerProxyFunc(listenerFuncs[lp], config);
    }
  }
  return _debugListener;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/DiagnosticLogger.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









/**
 * For user non actionable traces use AI Internal prefix.
 */
var AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */
var AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */
var AIInternalMessagePrefix = "AITR_";
function _sanitizeDiagnosticText(text) {
  if (text) {
    return "\"" + text[_DYN_REPLACE /* @min:%2ereplace */](/\"/g, InternalConstants_STR_EMPTY) + "\"";
  }
  return InternalConstants_STR_EMPTY;
}
function _logToConsole(func, message) {
  var theConsole = getConsole();
  if (!!theConsole) {
    var logFunc = "log";
    if (theConsole[func]) {
      logFunc = func;
    }
    if (HelperFuncs_isFunction(theConsole[logFunc])) {
      theConsole[logFunc](message);
    }
  }
}
var _InternalLogMessage = /** @class */function () {
  function _InternalLogMessage(msgId, msg, isUserAct, properties) {
    if (isUserAct === void 0) {
      isUserAct = false;
    }
    var _self = this;
    _self[_DYN_MESSAGE_ID /* @min:%2emessageId */] = msgId;
    _self[_DYN_MESSAGE /* @min:%2emessage */] = (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) + msgId;
    var strProps = InternalConstants_STR_EMPTY;
    if (hasJSON()) {
      strProps = getJSON().stringify(properties);
    }
    var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : InternalConstants_STR_EMPTY) + (properties ? " props:" + _sanitizeDiagnosticText(strProps) : InternalConstants_STR_EMPTY);
    _self[_DYN_MESSAGE /* @min:%2emessage */] += diagnosticText;
  }
  _InternalLogMessage.dataType = "MessageData";
  return _InternalLogMessage;
}();

function safeGetLogger(core, config) {
  return (core || {})[_DYN_LOGGER /* @min:%2elogger */] || new DiagnosticLogger(config);
}
var DiagnosticLogger = /** @class */function () {
  function DiagnosticLogger(config) {
    this.identifier = "DiagnosticLogger";
    /**
     * The internal logging queue
     */
    this.queue = [];
    /**
     * Count of internal messages sent
     */
    var _messageCount = 0;
    /**
     * Holds information about what message types were already logged to console or sent to server.
     */
    var _messageLogged = {};
    var _loggingLevelConsole;
    var _loggingLevelTelemetry;
    var _maxInternalMessageLimit;
    var _enableDebugExceptions;
    dynamicProto(DiagnosticLogger, this, function (_self) {
      _setDefaultsFromConfig(config || {});
      _self.consoleLoggingLevel = function () {
        return _loggingLevelConsole;
      };
      _self.telemetryLoggingLevel = function () {
        return _loggingLevelTelemetry;
      };
      _self.maxInternalMessageLimit = function () {
        return _maxInternalMessageLimit;
      };
      _self[_DYN_ENABLE_DEBUG_EXCEPTI4 /* @min:%2eenableDebugExceptions */] = function () {
        return _enableDebugExceptions;
      };
      /**
       * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
       * @param severity {LoggingSeverity} - The severity of the log message
       * @param message {_InternalLogMessage} - The log message.
       */
      _self.throwInternal = function (severity, msgId, msg, properties, isUserAct) {
        if (isUserAct === void 0) {
          isUserAct = false;
        }
        var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
        if (_enableDebugExceptions) {
          throw dumpObj(message);
        } else {
          // Get the logging function and fallback to warnToConsole of for some reason errorToConsole doesn't exist
          var logFunc = severity === 1 /* eLoggingSeverity.CRITICAL */ ? STR_ERROR_TO_CONSOLE : STR_WARN_TO_CONSOLE;
          if (!isUndefined(message[_DYN_MESSAGE /* @min:%2emessage */])) {
            if (isUserAct) {
              // check if this message type was already logged to console for this page view and if so, don't log it again
              var messageKey = +message[_DYN_MESSAGE_ID /* @min:%2emessageId */];
              if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                _self[logFunc](message[_DYN_MESSAGE /* @min:%2emessage */]);
                _messageLogged[messageKey] = true;
              }
            } else {
              // Only log traces if the console Logging Level is >= the throwInternal severity level
              if (_loggingLevelConsole >= severity) {
                _self[logFunc](message[_DYN_MESSAGE /* @min:%2emessage */]);
              }
            }

            _logInternalMessage(severity, message);
          } else {
            _debugExtMsg("throw" + (severity === 1 /* eLoggingSeverity.CRITICAL */ ? "Critical" : "Warning"), message);
          }
        }
      };
      /**
       * This will write a warning to the console if possible
       * @param message {string} - The warning message
       */
      _self[STR_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */] = function (message) {
        _logToConsole("warn", message);
        _debugExtMsg("warning", message);
      };
      /**
       * This will write an error to the console if possible
       * @param message {string} - The error message
       */
      _self[STR_ERROR_TO_CONSOLE /* @min:%2eerrorToConsole */] = function (message) {
        _logToConsole("error", message);
        _debugExtMsg("error", message);
      };
      /**
       * Resets the internal message count
       */
      _self.resetInternalMessageCount = function () {
        _messageCount = 0;
        _messageLogged = {};
      };
      /**
       * Logs a message to the internal queue.
       * @param severity {LoggingSeverity} - The severity of the log message
       * @param message {_InternalLogMessage} - The message to log.
       */
      _self[_DYN_LOG_INTERNAL_MESSAGE /* @min:%2elogInternalMessage */] = _logInternalMessage;
      function _logInternalMessage(severity, message) {
        if (_areInternalMessagesThrottled()) {
          return;
        }
        // check if this message type was already logged for this session and if so, don't log it again
        var logMessage = true;
        var messageKey = AIInternalMessagePrefix + message[_DYN_MESSAGE_ID /* @min:%2emessageId */];
        // if the session storage is not available, limit to only one message type per page view
        if (_messageLogged[messageKey]) {
          logMessage = false;
        } else {
          _messageLogged[messageKey] = true;
        }
        if (logMessage) {
          // Push the event in the internal queue
          if (severity <= _loggingLevelTelemetry) {
            _self.queue[_DynamicConstants_DYN_PUSH /* @min:%2epush */](message);
            _messageCount++;
            _debugExtMsg(severity === 1 /* eLoggingSeverity.CRITICAL */ ? "error" : "warn", message);
          }
          // When throttle limit reached, send a special event
          if (_messageCount === _maxInternalMessageLimit) {
            var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
            var throttleMessage = new _InternalLogMessage(23 /* _eInternalMessageId.MessageLimitPerPVExceeded */, throttleLimitMessage, false);
            _self.queue[_DynamicConstants_DYN_PUSH /* @min:%2epush */](throttleMessage);
            if (severity === 1 /* eLoggingSeverity.CRITICAL */) {
              _self[STR_ERROR_TO_CONSOLE /* @min:%2eerrorToConsole */](throttleLimitMessage);
            } else {
              _self[STR_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](throttleLimitMessage);
            }
          }
        }
      }
      function _setDefaultsFromConfig(config) {
        _loggingLevelConsole = getCfgValue(config.loggingLevelConsole, 0);
        _loggingLevelTelemetry = getCfgValue(config.loggingLevelTelemetry, 1);
        _maxInternalMessageLimit = getCfgValue(config.maxMessageLimit, 25);
        _enableDebugExceptions = getCfgValue(config[_DYN_ENABLE_DEBUG_EXCEPTI4 /* @min:%2eenableDebugExceptions */], false);
      }
      function _areInternalMessagesThrottled() {
        return _messageCount >= _maxInternalMessageLimit;
      }
      function _debugExtMsg(name, data) {
        var dbgExt = getDebugExt(config || {});
        if (dbgExt && dbgExt[_DYN_DIAG_LOG /* @min:%2ediagLog */]) {
          dbgExt[_DYN_DIAG_LOG /* @min:%2ediagLog */](name, data);
        }
      }
    });
  }
  // Removed Stub for DiagnosticLogger.prototype.enableDebugExceptions.
  // Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
  // Removed Stub for DiagnosticLogger.prototype.telemetryLoggingLevel.
  // Removed Stub for DiagnosticLogger.prototype.maxInternalMessageLimit.
  // Removed Stub for DiagnosticLogger.prototype.throwInternal.
  // Removed Stub for DiagnosticLogger.prototype.warnToConsole.
  // Removed Stub for DiagnosticLogger.prototype.errorToConsole.
  // Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
  // Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  DiagnosticLogger.__ieDyn = 1;
  return DiagnosticLogger;
}();

function _getLogger(logger) {
  return logger || new DiagnosticLogger();
}
/**
 * This is a helper method which will call throwInternal on the passed logger, will throw exceptions in
 * debug mode or attempt to log the error as a console warning. This helper is provided mostly to better
 * support minification as logger.throwInternal() will not compress the publish "throwInternal" used throughout
 * the code.
 * @param logger - The Diagnostic Logger instance to use.
 * @param severity {LoggingSeverity} - The severity of the log message
 * @param message {_InternalLogMessage} - The log message.
 */
function _throwInternal(logger, severity, msgId, msg, properties, isUserAct) {
  if (isUserAct === void 0) {
    isUserAct = false;
  }
  _getLogger(logger).throwInternal(severity, msgId, msg, properties, isUserAct);
}
/**
 * This is a helper method which will call warnToConsole on the passed logger with the provided message.
 * @param logger - The Diagnostic Logger instance to use.
 * @param message {_InternalLogMessage} - The log message.
 */
function _warnToConsole(logger, message) {
  _getLogger(logger)[STR_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](message);
}
/**
 * Logs a message to the internal queue.
 * @param logger - The Diagnostic Logger instance to use.
 * @param severity {LoggingSeverity} - The severity of the log message
 * @param message {_InternalLogMessage} - The message to log.
 */
function _logInternalMessage(logger, severity, message) {
  _getLogger(logger)[_DYN_LOG_INTERNAL_MESSAGE /* @min:%2elogInternalMessage */](severity, message);
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/CookieMgr.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var strToGMTString = "toGMTString";
var strToUTCString = "toUTCString";
var strCookie = "cookie";
var strExpires = "expires";
var strEnabled = "enabled";
var strIsCookieUseDisabled = "isCookieUseDisabled";
var strDisableCookiesUsage = "disableCookiesUsage";
var strConfigCookieMgr = "_ckMgr";
var _supportsCookies = null;
var _allowUaSameSite = null;
var _parsedCookieValue = null;
var _doc = EnvUtils_getDocument();
var _cookieCache = {};
var _globalCookieConfig = {};
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */
function _gblCookieMgr(config, logger) {
  // Stash the global instance against the BaseCookieMgr class
  var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
  if (!inst) {
    // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
    // that ultimately is never used
    inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
    _globalCookieConfig[strConfigCookieMgr] = inst;
  }
  return inst;
}
function _isMgrEnabled(cookieMgr) {
  if (cookieMgr) {
    return cookieMgr.isEnabled();
  }
  return true;
}
function _createCookieMgrConfig(rootConfig) {
  var cookieMgrCfg = rootConfig[_DYN_COOKIE_CFG /* @min:%2ecookieCfg */] = rootConfig[_DYN_COOKIE_CFG /* @min:%2ecookieCfg */] || {};
  // Sets the values from the root config if not already present on the cookieMgrCfg
  setValue(cookieMgrCfg, "domain", rootConfig.cookieDomain, isNotNullOrUndefined, isNullOrUndefined);
  setValue(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, isNullOrUndefined);
  if (isNullOrUndefined(cookieMgrCfg[strEnabled])) {
    // Set the enabled from the provided setting or the legacy root values
    var cookieEnabled = void 0;
    if (!isUndefined(rootConfig[strIsCookieUseDisabled])) {
      cookieEnabled = !rootConfig[strIsCookieUseDisabled];
    }
    if (!isUndefined(rootConfig[strDisableCookiesUsage])) {
      cookieEnabled = !rootConfig[strDisableCookiesUsage];
    }
    cookieMgrCfg[strEnabled] = cookieEnabled;
  }
  return cookieMgrCfg;
}
function _isIgnoredCookie(cookieMgrCfg, name) {
  if (name && cookieMgrCfg && HelperFuncs_isArray(cookieMgrCfg.ignoreCookies)) {
    return cookieMgrCfg.ignoreCookies[_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */](name) !== -1;
  }
  return false;
}
function _isBlockedCookie(cookieMgrCfg, name) {
  if (name && cookieMgrCfg && HelperFuncs_isArray(cookieMgrCfg.blockedCookies)) {
    if (cookieMgrCfg.blockedCookies[_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */](name) !== -1) {
      return true;
    }
  }
  return _isIgnoredCookie(cookieMgrCfg, name);
}
/**
 * Helper to return the ICookieMgr from the core (if not null/undefined) or a default implementation
 * associated with the configuration or a legacy default.
 * @param core
 * @param config
 * @returns
 */
function safeGetCookieMgr(core, config) {
  var cookieMgr;
  if (core) {
    // Always returns an instance
    cookieMgr = core.getCookieMgr();
  } else if (config) {
    var cookieCfg = config[_DYN_COOKIE_CFG /* @min:%2ecookieCfg */];
    if (cookieCfg[strConfigCookieMgr]) {
      cookieMgr = cookieCfg[strConfigCookieMgr];
    } else {
      cookieMgr = createCookieMgr(config);
    }
  }
  if (!cookieMgr) {
    // Get or initialize the default global (legacy) cookie manager if we couldn't find one
    cookieMgr = _gblCookieMgr(config, (core || {})[_DYN_LOGGER /* @min:%2elogger */]);
  }

  return cookieMgr;
}
function createCookieMgr(rootConfig, logger) {
  var _a;
  var cookieMgrConfig = _createCookieMgrConfig(rootConfig || _globalCookieConfig);
  var _path = cookieMgrConfig.path || "/";
  var _domain = cookieMgrConfig.domain;
  // Explicitly checking against false, so that setting to undefined will === true
  var _enabled = cookieMgrConfig[strEnabled] !== false;
  var cookieMgr = (_a = {
    isEnabled: function () {
      var enabled = _enabled && areCookiesSupported(logger);
      // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
      // that don't use the "applicationinsights-core" version of the default cookie function
      var gblManager = _globalCookieConfig[strConfigCookieMgr];
      if (enabled && gblManager && cookieMgr !== gblManager) {
        // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
        // As the global (deprecated) functions may have been called (for backward compatibility)
        enabled = _isMgrEnabled(gblManager);
      }
      return enabled;
    }
  }, _a[_DYN_SET_ENABLED /* @min:setEnabled */] = function (value) {
    // Explicitly checking against false, so that setting to undefined will === true
    _enabled = value !== false;
  }, _a.set = function (name, value, maxAgeSec, domain, path) {
    var result = false;
    if (_isMgrEnabled(cookieMgr) && !_isBlockedCookie(cookieMgrConfig, name)) {
      var values = {};
      var theValue = HelperFuncs_strTrim(value || InternalConstants_STR_EMPTY);
      var idx = theValue[_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */](";");
      if (idx !== -1) {
        theValue = HelperFuncs_strTrim(value[_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](0, idx));
        values = _extractParts(value[_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](idx + 1));
      }
      // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
      setValue(values, "domain", domain || _domain, isTruthy, isUndefined);
      if (!isNullOrUndefined(maxAgeSec)) {
        var _isIE = isIE();
        if (isUndefined(values[strExpires])) {
          var nowMs = dateNow();
          // Only add expires if not already present
          var expireMs = nowMs + maxAgeSec * 1000;
          // Sanity check, if zero or -ve then ignore
          if (expireMs > 0) {
            var expiry = new Date();
            expiry.setTime(expireMs);
            setValue(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || InternalConstants_STR_EMPTY, isTruthy);
          }
        }
        if (!_isIE) {
          // Only replace if not already present
          setValue(values, "max-age", InternalConstants_STR_EMPTY + maxAgeSec, null, isUndefined);
        }
      }
      var location_1 = getLocation();
      if (location_1 && location_1.protocol === "https:") {
        setValue(values, "secure", null, null, isUndefined);
        // Only set same site if not also secure
        if (_allowUaSameSite === null) {
          _allowUaSameSite = !uaDisallowsSameSiteNone((getNavigator() || {})[_DynamicConstants_DYN_USER_AGENT /* @min:%2euserAgent */]);
        }

        if (_allowUaSameSite) {
          setValue(values, "SameSite", "None", null, isUndefined);
        }
      }
      setValue(values, "path", path || _path, null, isUndefined);
      var setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
      setCookieFn(name, _formatCookieValue(theValue, values));
      result = true;
    }
    return result;
  }, _a.get = function (name) {
    var value = InternalConstants_STR_EMPTY;
    if (_isMgrEnabled(cookieMgr) && !_isIgnoredCookie(cookieMgrConfig, name)) {
      value = (cookieMgrConfig.getCookie || _getCookieValue)(name);
    }
    return value;
  }, _a.del = function (name, path) {
    var result = false;
    if (_isMgrEnabled(cookieMgr)) {
      // Only remove the cookie if the manager and cookie support has not been disabled
      result = cookieMgr.purge(name, path);
    }
    return result;
  }, _a.purge = function (name, path) {
    var _a;
    var result = false;
    if (areCookiesSupported(logger)) {
      // Setting the expiration date in the past immediately removes the cookie
      var values = (_a = {}, _a["path"] = path ? path : "/", _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT", _a);
      if (!isIE()) {
        // Set max age to expire now
        values["max-age"] = "0";
      }
      var delCookie = cookieMgrConfig.delCookie || _setCookieValue;
      delCookie(name, _formatCookieValue(InternalConstants_STR_EMPTY, values));
      result = true;
    }
    return result;
  }, _a);
  // Associated this cookie manager with the config
  cookieMgr[strConfigCookieMgr] = cookieMgr;
  return cookieMgr;
}
/*
* Helper method to tell if document.cookie object is supported by the runtime
*/
function areCookiesSupported(logger) {
  if (_supportsCookies === null) {
    _supportsCookies = false;
    try {
      var doc = _doc || {};
      _supportsCookies = doc[strCookie] !== undefined;
    } catch (e) {
      _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 68 /* _eInternalMessageId.CannotAccessCookie */, "Cannot access document.cookie - " + getExceptionName(e), {
        exception: dumpObj(e)
      });
    }
  }
  return _supportsCookies;
}
function _extractParts(theValue) {
  var values = {};
  if (theValue && theValue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
    var parts = HelperFuncs_strTrim(theValue)[_DYN_SPLIT /* @min:%2esplit */](";");
    HelperFuncs_arrForEach(parts, function (thePart) {
      thePart = HelperFuncs_strTrim(thePart || InternalConstants_STR_EMPTY);
      if (thePart) {
        var idx = thePart[_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */]("=");
        if (idx === -1) {
          values[thePart] = null;
        } else {
          values[HelperFuncs_strTrim(thePart[_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](0, idx))] = HelperFuncs_strTrim(thePart[_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](idx + 1));
        }
      }
    });
  }
  return values;
}
function _formatDate(theDate, func) {
  if (HelperFuncs_isFunction(theDate[func])) {
    return theDate[func]();
  }
  return null;
}
function _formatCookieValue(value, values) {
  var cookieValue = value || InternalConstants_STR_EMPTY;
  HelperFuncs_objForEachKey(values, function (name, theValue) {
    cookieValue += "; " + name + (!isNullOrUndefined(theValue) ? "=" + theValue : InternalConstants_STR_EMPTY);
  });
  return cookieValue;
}
function _getCookieValue(name) {
  var cookieValue = InternalConstants_STR_EMPTY;
  if (_doc) {
    var theCookie = _doc[strCookie] || InternalConstants_STR_EMPTY;
    if (_parsedCookieValue !== theCookie) {
      _cookieCache = _extractParts(theCookie);
      _parsedCookieValue = theCookie;
    }
    cookieValue = HelperFuncs_strTrim(_cookieCache[name] || InternalConstants_STR_EMPTY);
  }
  return cookieValue;
}
function _setCookieValue(name, cookieValue) {
  if (_doc) {
    _doc[strCookie] = name + "=" + cookieValue;
  }
}
function uaDisallowsSameSiteNone(userAgent) {
  if (!HelperFuncs_isString(userAgent)) {
    return false;
  }
  // Cover all iOS based browsers here. This includes:
  // - Safari on iOS 12 for iPhone, iPod Touch, iPad
  // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
  // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
  // All of which are broken by SameSite=None, because they use the iOS networking stack
  if (strContains(userAgent, "CPU iPhone OS 12") || strContains(userAgent, "iPad; CPU OS 12")) {
    return true;
  }
  // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
  // - Safari on Mac OS X
  // This does not include:
  // - Internal browser on Mac OS X
  // - Chrome on Mac OS X
  // - Chromium on Mac OS X
  // Because they do not use the Mac OS networking stack.
  if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strContains(userAgent, "Version/") && strContains(userAgent, "Safari")) {
    return true;
  }
  // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
  // - Internal browser on Mac OS X
  // This does not include:
  // - Safari on Mac OS X
  // - Chrome on Mac OS X
  // - Chromium on Mac OS X
  // Because they do not use the Mac OS networking stack.
  if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strEndsWith(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
    return true;
  }
  // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
  // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
  // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
  if (strContains(userAgent, "Chrome/5") || strContains(userAgent, "Chrome/6")) {
    return true;
  }
  // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
  // that don't specify their Chrome version as lacking support for SameSite=None.
  if (strContains(userAgent, "UnrealEngine") && !strContains(userAgent, "Chrome")) {
    return true;
  }
  // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
  // NB: this rule isn't complete - you need regex to make a complete rule.
  // See: https://www.chromium.org/updates/same-site/incompatible-clients
  if (strContains(userAgent, "UCBrowser/12") || strContains(userAgent, "UCBrowser/11")) {
    return true;
  }
  return false;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/PerfManager.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var strExecutionContextKey = "ctx";
var strParentContextKey = "ParentContextKey";
var strChildrenContextKey = "ChildrenContextKey";
var _defaultPerfManager = null;
var PerfEvent = /** @class */function () {
  function PerfEvent(name, payloadDetails, isAsync) {
    var _self = this;
    var accessorDefined = false;
    _self.start = dateNow();
    _self[_DynamicConstants_DYN_NAME /* @min:%2ename */] = name;
    _self[_DYN_IS_ASYNC /* @min:%2eisAsync */] = isAsync;
    _self[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */] = function () {
      return false;
    };
    if (HelperFuncs_isFunction(payloadDetails)) {
      // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
      var theDetails_1;
      accessorDefined = objDefineAccessors(_self, "payload", function () {
        // Delay the execution of the payloadDetails until needed
        if (!theDetails_1 && HelperFuncs_isFunction(payloadDetails)) {
          theDetails_1 = payloadDetails();
          // clear it out now so the referenced objects can be garbage collected
          payloadDetails = null;
        }
        return theDetails_1;
      });
    }
    _self[_DYN_GET_CTX /* @min:%2egetCtx */] = function (key) {
      if (key) {
        // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
        if (key === PerfEvent[strParentContextKey] || key === PerfEvent[strChildrenContextKey]) {
          return _self[key];
        }
        return (_self[strExecutionContextKey] || {})[key];
      }
      return null;
    };
    _self[_DYN_SET_CTX /* @min:%2esetCtx */] = function (key, value) {
      if (key) {
        // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
        if (key === PerfEvent[strParentContextKey]) {
          // Simple assumption, if we are setting a parent then we must be a child
          if (!_self[key]) {
            _self[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */] = function () {
              return true;
            };
          }
          _self[key] = value;
        } else if (key === PerfEvent[strChildrenContextKey]) {
          _self[key] = value;
        } else {
          var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
          ctx[key] = value;
        }
      }
    };
    _self[_DYN_COMPLETE /* @min:%2ecomplete */] = function () {
      var childTime = 0;
      var childEvts = _self[_DYN_GET_CTX /* @min:%2egetCtx */](PerfEvent[strChildrenContextKey]);
      if (HelperFuncs_isArray(childEvts)) {
        for (var lp = 0; lp < childEvts[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
          var childEvt = childEvts[lp];
          if (childEvt) {
            childTime += childEvt[_DYN_TIME /* @min:%2etime */];
          }
        }
      }

      _self[_DYN_TIME /* @min:%2etime */] = dateNow() - _self.start;
      _self.exTime = _self[_DYN_TIME /* @min:%2etime */] - childTime;
      _self[_DYN_COMPLETE /* @min:%2ecomplete */] = function () {};
      if (!accessorDefined && HelperFuncs_isFunction(payloadDetails)) {
        // If we couldn't define the property set during complete -- to minimize the perf impact until after the time
        _self.payload = payloadDetails();
      }
    };
  }
  PerfEvent.ParentContextKey = "parent";
  PerfEvent.ChildrenContextKey = "childEvts";
  return PerfEvent;
}();

var PerfManager = /** @class */function () {
  function PerfManager(manager) {
    /**
     * General bucket used for execution context set and retrieved via setCtx() and getCtx.
     * Defined as private so it can be visualized via the DebugPlugin
     */
    this.ctx = {};
    dynamicProto(PerfManager, this, function (_self) {
      _self.create = function (src, payloadDetails, isAsync) {
        // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
        // for now this is just a simple do everything.
        return new PerfEvent(src, payloadDetails, isAsync);
      };
      _self.fire = function (perfEvent) {
        if (perfEvent) {
          perfEvent[_DYN_COMPLETE /* @min:%2ecomplete */]();
          if (manager && HelperFuncs_isFunction(manager[STR_PERF_EVENT /* @min:%2eperfEvent */])) {
            manager[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent);
          }
        }
      };
      _self[_DYN_SET_CTX /* @min:%2esetCtx */] = function (key, value) {
        if (key) {
          var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
          ctx[key] = value;
        }
      };
      _self[_DYN_GET_CTX /* @min:%2egetCtx */] = function (key) {
        return (_self[strExecutionContextKey] || {})[key];
      };
    });
  }
  // Removed Stub for PerfManager.prototype.create.
  // Removed Stub for PerfManager.prototype.fire.
  // Removed Stub for PerfManager.prototype.setCtx.
  // Removed Stub for PerfManager.prototype.getCtx.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  PerfManager.__ieDyn = 1;
  return PerfManager;
}();

var doPerfActiveKey = "CoreUtils.doPerf";
/**
 * Helper function to wrap a function with a perf event
 * @param mgrSource - The Performance Manager or a Performance provider source (may be null)
 * @param getSource - The callback to create the source name for the event (if perf monitoring is enabled)
 * @param func - The function to call and measure
 * @param details - A function to return the payload details
 * @param isAsync - Is the event / function being call asynchronously or synchronously
 */
function doPerf(mgrSource, getSource, func, details, isAsync) {
  if (mgrSource) {
    var perfMgr = mgrSource;
    if (perfMgr[STR_GET_PERF_MGR]) {
      // Looks like a perf manager provider object
      perfMgr = perfMgr[STR_GET_PERF_MGR]();
    }
    if (perfMgr) {
      var perfEvt = void 0;
      var currentActive = perfMgr[_DYN_GET_CTX /* @min:%2egetCtx */](doPerfActiveKey);
      try {
        perfEvt = perfMgr.create(getSource(), details, isAsync);
        if (perfEvt) {
          if (currentActive && perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */]) {
            perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */](PerfEvent[strParentContextKey], currentActive);
            if (currentActive[_DYN_GET_CTX /* @min:%2egetCtx */] && currentActive[_DYN_SET_CTX /* @min:%2esetCtx */]) {
              var children = currentActive[_DYN_GET_CTX /* @min:%2egetCtx */](PerfEvent[strChildrenContextKey]);
              if (!children) {
                children = [];
                currentActive[_DYN_SET_CTX /* @min:%2esetCtx */](PerfEvent[strChildrenContextKey], children);
              }
              children[_DynamicConstants_DYN_PUSH /* @min:%2epush */](perfEvt);
            }
          }
          // Set this event as the active event now
          perfMgr[_DYN_SET_CTX /* @min:%2esetCtx */](doPerfActiveKey, perfEvt);
          return func(perfEvt);
        }
      } catch (ex) {
        if (perfEvt && perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */]) {
          perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */]("exception", ex);
        }
      } finally {
        // fire the perf event
        if (perfEvt) {
          perfMgr.fire(perfEvt);
        }
        // Reset the active event to the previous value
        perfMgr[_DYN_SET_CTX /* @min:%2esetCtx */](doPerfActiveKey, currentActive);
      }
    }
  }
  return func();
}
/**
 * Set the global performance manager to use when there is no core instance or it has not been initialized yet.
 * @param perfManager - The IPerfManager instance to use when no performance manager is supplied.
 */
function setGblPerfMgr(perfManager) {
  _defaultPerfManager = perfManager;
}
/**
 * Get the current global performance manager that will be used with no performance manager is supplied.
 * @returns - The current default manager
 */
function getGblPerfMgr() {
  return _defaultPerfManager;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/RandomHelper.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var UInt32Mask = 0x100000000;
var MaxUInt32 = 0xffffffff;
// MWC based Random generator (for IE)
var _mwcSeeded = false;
var _mwcW = 123456789;
var _mwcZ = 987654321;
// Takes any integer
function _mwcSeed(seedValue) {
  if (seedValue < 0) {
    // Make sure we end up with a positive number and not -ve one.
    seedValue >>>= 0;
  }
  _mwcW = 123456789 + seedValue & MaxUInt32;
  _mwcZ = 987654321 - seedValue & MaxUInt32;
  _mwcSeeded = true;
}
function _autoSeedMwc() {
  // Simple initialization using default Math.random() - So we inherit any entropy from the browser
  // and bitwise XOR with the current milliseconds
  try {
    var now = dateNow() & 0x7fffffff;
    _mwcSeed((Math.random() * UInt32Mask ^ now) + now);
  } catch (e) {
    // Don't crash if something goes wrong
  }
}
/**
 * Generate a random value between 0 and maxValue, max value should be limited to a 32-bit maximum.
 * So maxValue(16) will produce a number from 0..16 (range of 17)
 * @param maxValue
 */
function randomValue(maxValue) {
  if (maxValue > 0) {
    return Math.floor(random32() / MaxUInt32 * (maxValue + 1)) >>> 0;
  }
  return 0;
}
/**
 * generate a random 32-bit number (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), defaults un-unsigned.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function random32(signed) {
  var value = 0;
  var c = getCrypto() || getMsCrypto();
  if (c && c.getRandomValues) {
    // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
  }
  if (value === 0 && isIE()) {
    // For IE 6, 7, 8 (especially on XP) Math.random is not very random
    if (!_mwcSeeded) {
      // Set the seed for the Mwc algorithm
      _autoSeedMwc();
    }
    // Don't use Math.random for IE
    // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = mwcRandom32() & MaxUInt32;
  }
  if (value === 0) {
    // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = Math.floor(UInt32Mask * Math.random() | 0);
  }
  if (!signed) {
    // Make sure we end up with a positive number and not -ve one.
    value >>>= 0;
  }
  return value;
}
/**
 * Seed the MWC random number generator with the specified seed or a random value
 * @param value - optional the number to used as the seed, if undefined, null or zero a random value will be chosen
 */
function mwcRandomSeed(value) {
  if (!value) {
    _autoSeedMwc();
  } else {
    _mwcSeed(value);
  }
}
/**
 * Generate a random 32-bit number between (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), using MWC (Multiply with carry)
 * instead of Math.random() defaults to un-signed.
 * Used as a replacement random generator for IE to avoid issues with older IE instances.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function mwcRandom32(signed) {
  _mwcZ = 36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16) & MaxUInt32;
  _mwcW = 18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16) & MaxUInt32;
  var value = (_mwcZ << 16) + (_mwcW & 0xFFFF) >>> 0 & MaxUInt32 | 0;
  if (!signed) {
    // Make sure we end up with a positive number and not -ve one.
    value >>>= 0;
  }
  return value;
}
/**
 * Generate random base64 id string.
 * The default length is 22 which is 132-bits so almost the same as a GUID but as base64 (the previous default was 5)
 * @param maxLength - Optional value to specify the length of the id to be generated, defaults to 22
 */
function newId(maxLength) {
  if (maxLength === void 0) {
    maxLength = 22;
  }
  var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  // Start with an initial random number, consuming the value in reverse byte order
  var number = random32() >>> 0; // Make sure it's a +ve number
  var chars = 0;
  var result = InternalConstants_STR_EMPTY;
  while (result[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] < maxLength) {
    chars++;
    result += base64chars.charAt(number & 0x3F);
    number >>>= 6; // Zero fill with right shift
    if (chars === 5) {
      // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
      // So add on another 30 bits and make sure it's +ve
      number = (random32() << 2 & 0xFFFFFFFF | number & 0x03) >>> 0;
      chars = 0; // We need to reset the number every 5 chars (30 bits)
    }
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/DataCacheHelper.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var DataCacheHelper_objDefineProperty = Constants_ObjDefineProperty;
var version = '2.8.9';
var instanceName = "." + newId(6);
var _dataUid = 0;
function _createAccessor(target, prop, value) {
  if (DataCacheHelper_objDefineProperty) {
    try {
      DataCacheHelper_objDefineProperty(target, prop, {
        value: value,
        enumerable: false,
        configurable: true
      });
      return true;
    } catch (e) {
      // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
      // We will just ignore this here.
    }
  }
  return false;
}
// Accepts only:
//  - Node
//    - Node.ELEMENT_NODE
//    - Node.DOCUMENT_NODE
//  - Object
//    - Any
function _canAcceptData(target) {
  return target[_DYN_NODE_TYPE /* @min:%2enodeType */] === 1 || target[_DYN_NODE_TYPE /* @min:%2enodeType */] === 9 || !+target[_DYN_NODE_TYPE /* @min:%2enodeType */];
}

function _getCache(data, target) {
  var theCache = target[data.id];
  if (!theCache) {
    theCache = {};
    try {
      if (_canAcceptData(target)) {
        if (!_createAccessor(target, data.id, theCache)) {
          // Environment doesn't support accessor, so just use direct assignment
          target[data.id] = theCache;
        }
      }
    } catch (e) {
      // Not all environments allow extending all objects, so just ignore the cache in those cases
    }
  }
  return theCache;
}
function createUniqueNamespace(name, includeVersion) {
  if (includeVersion === void 0) {
    includeVersion = false;
  }
  return normalizeJsName(name + _dataUid++ + (includeVersion ? "." + version : InternalConstants_STR_EMPTY) + instanceName);
}
function createElmNodeData(name) {
  var data = {
    id: createUniqueNamespace("_aiData-" + (name || InternalConstants_STR_EMPTY) + "." + version),
    accept: function (target) {
      return _canAcceptData(target);
    },
    get: function (target, name, defValue, addDefault) {
      var theCache = target[data.id];
      if (!theCache) {
        if (addDefault) {
          // Side effect is adds the cache
          theCache = _getCache(data, target);
          theCache[normalizeJsName(name)] = defValue;
        }
        return defValue;
      }
      return theCache[normalizeJsName(name)];
    },
    kill: function (target, name) {
      if (target && target[name]) {
        try {
          delete target[name];
        } catch (e) {
          // Just cleaning up, so if this fails -- ignore
        }
      }
    }
  };
  return data;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/EventHelpers.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






// Added to help with minfication
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
var strEvents = "events";
var strVisibilityChangeEvt = "visibilitychange";
var strPageHide = "pagehide";
var strPageShow = "pageshow";
var strUnload = "unload";
var strBeforeUnload = "beforeunload";
var strPageHideNamespace = createUniqueNamespace("aiEvtPageHide");
var strPageShowNamespace = createUniqueNamespace("aiEvtPageShow");
var rRemoveEmptyNs = /\.[\.]+/g;
var rRemoveTrailingEmptyNs = /[\.]+$/;
var _guid = 1;
var elmNodeData = createElmNodeData("events");
var eventNamespace = /^([^.]*)(?:\.(.+)|)/;
function _normalizeNamespace(name) {
  if (name && name[_DYN_REPLACE /* @min:%2ereplace */]) {
    return name[_DYN_REPLACE /* @min:%2ereplace */](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, InternalConstants_STR_EMPTY);
  }
  return name;
}
function _getEvtNamespace(eventName, evtNamespace) {
  var _a;
  if (evtNamespace) {
    var theNamespace_1 = InternalConstants_STR_EMPTY;
    if (HelperFuncs_isArray(evtNamespace)) {
      theNamespace_1 = InternalConstants_STR_EMPTY;
      HelperFuncs_arrForEach(evtNamespace, function (name) {
        name = _normalizeNamespace(name);
        if (name) {
          if (name[0] !== ".") {
            name = "." + name;
          }
          theNamespace_1 += name;
        }
      });
    } else {
      theNamespace_1 = _normalizeNamespace(evtNamespace);
    }
    if (theNamespace_1) {
      if (theNamespace_1[0] !== ".") {
        theNamespace_1 = "." + theNamespace_1;
      }
      // We may only have the namespace and not an eventName
      eventName = (eventName || InternalConstants_STR_EMPTY) + theNamespace_1;
    }
  }
  var parsedEvent = eventNamespace.exec(eventName || InternalConstants_STR_EMPTY) || [];
  return _a = {}, _a[_DynamicConstants_DYN_TYPE /* @min:type */] = parsedEvent[1], _a.ns = (parsedEvent[2] || InternalConstants_STR_EMPTY).replace(rRemoveEmptyNs, ".").replace(rRemoveTrailingEmptyNs, InternalConstants_STR_EMPTY)[_DYN_SPLIT /* @min:%2esplit */](".").sort().join("."), _a;
}
/**
 * Get all of the registered events on the target object, this is primarily used for testing cleanup but may also be used by
 * applications to remove their own events
 * @param target - The EventTarget that has registered events
 * @param eventName - [Optional] The name of the event to return the registered handlers and full name (with namespaces)
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 */
function __getRegisteredEvents(target, eventName, evtNamespace) {
  var theEvents = [];
  var eventCache = elmNodeData.get(target, strEvents, {}, false);
  var evtName = _getEvtNamespace(eventName, evtNamespace);
  objForEachKey(eventCache, function (evtType, registeredEvents) {
    arrForEach(registeredEvents, function (value) {
      var _a;
      if (!evtName[_DYN_TYPE /* @min:%2etype */] || evtName[_DYN_TYPE /* @min:%2etype */] === value.evtName[_DYN_TYPE /* @min:%2etype */]) {
        if (!evtName.ns || evtName.ns === evtName.ns) {
          theEvents[_DYN_PUSH /* @min:%2epush */]((_a = {}, _a[_DYN_NAME /* @min:name */] = value.evtName[_DYN_TYPE /* @min:%2etype */] + (value.evtName.ns ? "." + value.evtName.ns : STR_EMPTY), _a.handler = value[_DYN_HANDLER /* @min:%2ehandler */], _a));
        }
      }
    });
  });
  return theEvents;
}
// Exported for internal unit testing only
function _getRegisteredEvents(target, evtName, addDefault) {
  if (addDefault === void 0) {
    addDefault = true;
  }
  var aiEvts = elmNodeData.get(target, strEvents, {}, addDefault);
  var registeredEvents = aiEvts[evtName];
  if (!registeredEvents) {
    registeredEvents = aiEvts[evtName] = [];
  }
  return registeredEvents;
}
function _doDetach(obj, evtName, handlerRef, useCapture) {
  if (obj && evtName && evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */]) {
    if (obj[strRemoveEventListener]) {
      obj[strRemoveEventListener](evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */], handlerRef, useCapture);
    } else if (obj[strDetachEvent]) {
      obj[strDetachEvent](strOnPrefix + evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */], handlerRef);
    }
  }
}
function _doAttach(obj, evtName, handlerRef, useCapture) {
  var result = false;
  if (obj && evtName && evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */] && handlerRef) {
    if (obj[strAddEventHelper]) {
      // all browsers except IE before version 9
      obj[strAddEventHelper](evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */], handlerRef, useCapture);
      result = true;
    } else if (obj[strAttachEvent]) {
      // IE before version 9
      obj[strAttachEvent](strOnPrefix + evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */], handlerRef);
      result = true;
    }
  }
  return result;
}
function _doUnregister(target, events, evtName, unRegFn) {
  var idx = events[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
  while (idx--) {
    var theEvent = events[idx];
    if (theEvent) {
      if (!evtName.ns || evtName.ns === theEvent.evtName.ns) {
        if (!unRegFn || unRegFn(theEvent)) {
          _doDetach(target, theEvent.evtName, theEvent[_DynamicConstants_DYN_HANDLER /* @min:%2ehandler */], theEvent.capture);
          // Remove the registered event
          events[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
        }
      }
    }
  }
}
function _unregisterEvents(target, evtName, unRegFn) {
  if (evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */]) {
    _doUnregister(target, _getRegisteredEvents(target, evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */]), evtName, unRegFn);
  } else {
    var eventCache = elmNodeData.get(target, strEvents, {});
    HelperFuncs_objForEachKey(eventCache, function (evtType, events) {
      _doUnregister(target, events, evtName, unRegFn);
    });
    // Cleanup
    if (objKeys(eventCache)[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0) {
      elmNodeData.kill(target, strEvents);
    }
  }
}
function mergeEvtNamespace(theNamespace, namespaces) {
  var newNamespaces;
  if (namespaces) {
    if (HelperFuncs_isArray(namespaces)) {
      newNamespaces = [theNamespace].concat(namespaces);
    } else {
      newNamespaces = [theNamespace, namespaces];
    }
    // resort the namespaces so they are always in order
    newNamespaces = _getEvtNamespace("xx", newNamespaces).ns[_DYN_SPLIT /* @min:%2esplit */](".");
  } else {
    newNamespaces = theNamespace;
  }
  return newNamespaces;
}
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj Object to add the event too.
 * @param eventName String that specifies any of the standard DHTML Events without "on" prefix, if may also include an optional (dot "." prefixed)
 * namespaces "click" "click.mynamespace" in addition to specific namespaces.
 * @param handlerRef Pointer that specifies the function to call when event fires
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 * @param useCapture [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function eventOn(target, eventName, handlerRef, evtNamespace, useCapture) {
  var _a;
  if (useCapture === void 0) {
    useCapture = false;
  }
  var result = false;
  if (target) {
    try {
      var evtName = _getEvtNamespace(eventName, evtNamespace);
      result = _doAttach(target, evtName, handlerRef, useCapture);
      if (result && elmNodeData.accept(target)) {
        var registeredEvent = (_a = {
          guid: _guid++,
          evtName: evtName
        }, _a[_DynamicConstants_DYN_HANDLER /* @min:handler */] = handlerRef, _a.capture = useCapture, _a);
        _getRegisteredEvents(target, evtName.type)[_DynamicConstants_DYN_PUSH /* @min:%2epush */](registeredEvent);
      }
    } catch (e) {
      // Just Ignore any error so that we don't break any execution path
    }
  }
  return result;
}
/**
 * Removes an event handler for the specified event
 * @param Object to remove the event from
 * @param eventName {string} - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param handlerRef {any} - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 * @param useCapture [Optional] Defaults to false
 */
function eventOff(target, eventName, handlerRef, evtNamespace, useCapture) {
  if (useCapture === void 0) {
    useCapture = false;
  }
  if (target) {
    try {
      var evtName_1 = _getEvtNamespace(eventName, evtNamespace);
      var found_1 = false;
      _unregisterEvents(target, evtName_1, function (regEvent) {
        if (evtName_1.ns && !handlerRef || regEvent[_DynamicConstants_DYN_HANDLER /* @min:%2ehandler */] === handlerRef) {
          found_1 = true;
          return true;
        }
        return false;
      });
      if (!found_1) {
        // fallback to try and remove as requested
        _doDetach(target, evtName_1, handlerRef, useCapture);
      }
    } catch (e) {
      // Just Ignore any error so that we don't break any execution path
    }
  }
}
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj Object to add the event too.
 * @param eventNameWithoutOn String that specifies any of the standard DHTML Events without "on" prefix and optional (dot "." prefixed) namespaces "click" "click.mynamespace".
 * @param handlerRef Pointer that specifies the function to call when event fires
 * @param useCapture [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
  if (useCapture === void 0) {
    useCapture = false;
  }
  return eventOn(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
/**
 * Removes an event handler for the specified event
 * @param Object to remove the event from
 * @param eventNameWithoutOn {string} - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param handlerRef {any} - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param useCapture [Optional] Defaults to false
 */
function detachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
  if (useCapture === void 0) {
    useCapture = false;
  }
  eventOff(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
/**
 * Trys to add an event handler for the specified event to the window, body and document
 * @param eventName {string} - The name of the event
 * @param callback {any} - The callback function that needs to be executed for the given event
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @return {boolean} - true if the handler was successfully added
 */
function addEventHandler(eventName, callback, evtNamespace) {
  var result = false;
  var w = getWindow();
  if (w) {
    result = eventOn(w, eventName, callback, evtNamespace);
    result = eventOn(w["body"], eventName, callback, evtNamespace) || result;
  }
  var doc = EnvUtils_getDocument();
  if (doc) {
    result = eventOn(doc, eventName, callback, evtNamespace) || result;
  }
  return result;
}
/**
 * Trys to remove event handler(s) for the specified event/namespace to the window, body and document
 * @param eventName {string} - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param callback {any} - - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 */
function removeEventHandler(eventName, callback, evtNamespace) {
  var w = getWindow();
  if (w) {
    eventOff(w, eventName, callback, evtNamespace);
    eventOff(w["body"], eventName, callback, evtNamespace);
  }
  var doc = EnvUtils_getDocument();
  if (doc) {
    eventOff(doc, eventName, callback, evtNamespace);
  }
}
/**
 * Bind the listener to the array of events
 * @param events An string array of event names to bind the listener to
 * @param listener The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function _addEventListeners(events, listener, excludeEvents, evtNamespace) {
  var added = false;
  if (listener && events && events[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
    HelperFuncs_arrForEach(events, function (name) {
      if (name) {
        if (!excludeEvents || arrIndexOf(excludeEvents, name) === -1) {
          added = addEventHandler(name, listener, evtNamespace) || added;
        }
      }
    });
  }
  return added;
}
/**
 * Bind the listener to the array of events
 * @param events An string array of event names to bind the listener to
 * @param listener The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addEventListeners(events, listener, excludeEvents, evtNamespace) {
  var added = false;
  if (listener && events && HelperFuncs_isArray(events)) {
    added = _addEventListeners(events, listener, excludeEvents, evtNamespace);
    if (!added && excludeEvents && excludeEvents[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
      // Failed to add any listeners and we excluded some, so just attempt to add the excluded events
      added = _addEventListeners(events, listener, null, evtNamespace);
    }
  }
  return added;
}
/**
 * Remove the listener from the array of events
 * @param events An string array of event names to bind the listener to
 * @param listener The event callback to call when the event is triggered
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 */
function removeEventListeners(events, listener, evtNamespace) {
  if (events && HelperFuncs_isArray(events)) {
    HelperFuncs_arrForEach(events, function (name) {
      if (name) {
        removeEventHandler(name, listener, evtNamespace);
      }
    });
  }
}
/**
 * Listen to the 'beforeunload', 'unload' and 'pagehide' events which indicates a page unload is occurring,
 * this does NOT listen to the 'visibilitychange' event as while it does indicate that the page is being hidden
 * it does not *necessarily* mean that the page is being completely unloaded, it can mean that the user is
 * just navigating to a different Tab and may come back (without unloading the page). As such you may also
 * need to listen to the 'addPageHideEventListener' and 'addPageShowEventListener' events.
 * @param listener - The event callback to call when a page unload event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked, unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageUnloadEventListener(listener, excludeEvents, evtNamespace) {
  // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
  // As just hooking the window does not always fire (on chrome) for page navigation's.
  return addEventListeners([strBeforeUnload, strUnload, strPageHide], listener, excludeEvents, evtNamespace);
}
/**
 * Remove any matching 'beforeunload', 'unload' and 'pagehide' events that may have been added via addEventListener,
 * addEventListeners, addPageUnloadEventListener or addPageHideEventListener.
 * @param listener - The specific event callback to to be removed
 * @param evtNamespace - [Optional] Namespace(s) uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function removePageUnloadEventListener(listener, evtNamespace) {
  removeEventListeners([strBeforeUnload, strUnload, strPageHide], listener, evtNamespace);
}
/**
 * Listen to the pagehide and visibility changing to 'hidden' events, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when if you plan to call
 * removePageShowEventListener as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The event callback to call when a page hide event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] A Namespace to append to the event listeners so they can be uniquely identified and removed
 * based on this namespace. This call also adds an additional unique "pageshow" namespace to the events
 * so that only the matching "removePageHideEventListener" can remove these events.
 * Suggestion: pass as true if you are also calling addPageUnloadEventListener as that also hooks pagehide
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageHideEventListener(listener, excludeEvents, evtNamespace) {
  function _handlePageVisibility(evt) {
    var doc = EnvUtils_getDocument();
    if (listener && doc && doc.visibilityState === "hidden") {
      listener(evt);
    }
  }
  // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pagehide"
  var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
  var pageUnloadAdded = _addEventListeners([strPageHide], listener, excludeEvents, newNamespaces);
  if (!excludeEvents || arrIndexOf(excludeEvents, strVisibilityChangeEvt) === -1) {
    pageUnloadAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
  }
  if (!pageUnloadAdded && excludeEvents) {
    // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
    pageUnloadAdded = addPageHideEventListener(listener, null, evtNamespace);
  }
  return pageUnloadAdded;
}
/**
 * Removes the pageHide event listeners added by addPageHideEventListener, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when calling addPageHideEventListener
 * as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The specific listener to remove for the 'pageshow' event only (ignored for 'visibilitychange')
 * @param evtNamespace - The unique namespace used when calling addPageShowEventListener
 */
function removePageHideEventListener(listener, evtNamespace) {
  // add the unique page show namespace to any provided namespace so we only remove the ones added by "pagehide"
  var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
  removeEventListeners([strPageHide], listener, newNamespaces);
  removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
}
/**
 * Listen to the pageshow and visibility changing to 'visible' events, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when if you plan to call
 * removePageShowEventListener as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The event callback to call when a page is show event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional/Recommended] A Namespace to append to the event listeners so they can be uniquely
 * identified and removed based on this namespace. This call also adds an additional unique "pageshow" namespace to the events
 * so that only the matching "removePageShowEventListener" can remove these events.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageShowEventListener(listener, excludeEvents, evtNamespace) {
  function _handlePageVisibility(evt) {
    var doc = getDocument();
    if (listener && doc && doc.visibilityState === "visible") {
      listener(evt);
    }
  }
  // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pageshow"
  var newNamespaces = mergeEvtNamespace(strPageShowNamespace, evtNamespace);
  var pageShowAdded = _addEventListeners([strPageShow], listener, excludeEvents, newNamespaces);
  pageShowAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageShowAdded;
  if (!pageShowAdded && excludeEvents) {
    // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
    pageShowAdded = addPageShowEventListener(listener, null, evtNamespace);
  }
  return pageShowAdded;
}
/**
 * Removes the pageShow event listeners added by addPageShowEventListener, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when calling addPageShowEventListener
 * as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The specific listener to remove for the 'pageshow' event only (ignored for 'visibilitychange')
 * @param evtNamespace - The unique namespace used when calling addPageShowEventListener
 */
function removePageShowEventListener(listener, evtNamespace) {
  // add the unique page show namespace to any provided namespace so we only remove the ones added by "pageshow"
  var newNamespaces = mergeEvtNamespace(strPageShowNamespace, evtNamespace);
  removeEventListeners([strPageShow], listener, newNamespaces);
  removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/CoreUtils.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */











var _cookieMgrs = null;
var _canUseCookies; // legacy supported config
// Added to help with minfication
var Undefined = (/* unused pure expression or super */ null && (strShimUndefined));
function newGuid() {
  var uuid = generateW3CId();
  return uuid[_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](0, 8) + "-" + uuid[_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](8, 12) + "-" + uuid[_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](12, 16) + "-" + uuid[_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](16, 20) + "-" + uuid[_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](20);
}
/**
 * Return the current value of the Performance Api now() function (if available) and fallback to dateNow() if it is unavailable (IE9 or less)
 * https://caniuse.com/#search=performance.now
 */
function perfNow() {
  var perf = getPerformance();
  if (perf && perf.now) {
    return perf.now();
  }
  return dateNow();
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function CoreUtils_strEndsWith(value, search) {
  if (value && search) {
    var len = value[_DYN_LENGTH /* @min:%2elength */];
    var start = len - search[_DYN_LENGTH /* @min:%2elength */];
    return value[_DYN_SUBSTRING /* @min:%2esubstring */](start >= 0 ? start : 0, len) === search;
  }
  return false;
}
/**
 * generate W3C trace id
 */
function generateW3CId() {
  var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
  // rfc4122 version 4 UUID without dashes and with lowercase letters
  var oct = InternalConstants_STR_EMPTY,
    tmp;
  for (var a = 0; a < 4; a++) {
    tmp = random32();
    oct += hexValues[tmp & 0xF] + hexValues[tmp >> 4 & 0xF] + hexValues[tmp >> 8 & 0xF] + hexValues[tmp >> 12 & 0xF] + hexValues[tmp >> 16 & 0xF] + hexValues[tmp >> 20 & 0xF] + hexValues[tmp >> 24 & 0xF] + hexValues[tmp >> 28 & 0xF];
  }
  // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
  var clockSequenceHi = hexValues[8 + (random32() & 0x03) | 0];
  return oct[_DYN_SUBSTR /* @min:%2esubstr */](0, 8) + oct[_DYN_SUBSTR /* @min:%2esubstr */](9, 4) + "4" + oct[_DYN_SUBSTR /* @min:%2esubstr */](13, 3) + clockSequenceHi + oct[_DYN_SUBSTR /* @min:%2esubstr */](16, 3) + oct[_DYN_SUBSTR /* @min:%2esubstr */](19, 12);
}
/**
 * Provides a collection of utility functions, included for backward compatibility with previous releases.
 * @deprecated Marking this instance as deprecated in favor of direct usage of the helper functions
 * as direct usage provides better tree-shaking and minification by avoiding the inclusion of the unused items
 * in your resulting code.
 */
var CoreUtils = {
  _canUseCookies: undefined,
  isTypeof: isTypeof,
  isUndefined: isUndefined,
  isNullOrUndefined: isNullOrUndefined,
  hasOwnProperty: HelperFuncs_hasOwnProperty,
  isFunction: HelperFuncs_isFunction,
  isObject: isObject,
  isDate: isDate,
  isArray: HelperFuncs_isArray,
  isError: isError,
  isString: HelperFuncs_isString,
  isNumber: isNumber,
  isBoolean: isBoolean,
  toISOString: toISOString,
  arrForEach: HelperFuncs_arrForEach,
  arrIndexOf: arrIndexOf,
  arrMap: arrMap,
  arrReduce: arrReduce,
  strTrim: HelperFuncs_strTrim,
  objCreate: objCreateFn,
  objKeys: objKeys,
  objDefineAccessors: objDefineAccessors,
  addEventHandler: addEventHandler,
  dateNow: dateNow,
  isIE: isIE,
  disableCookies: disableCookies,
  newGuid: newGuid,
  perfNow: perfNow,
  newId: newId,
  randomValue: randomValue,
  random32: random32,
  mwcRandomSeed: mwcRandomSeed,
  mwcRandom32: mwcRandom32,
  generateW3CId: generateW3CId
};
var GuidRegex = /[xy]/g;
var EventHelper = {
  Attach: attachEvent,
  AttachEvent: attachEvent,
  Detach: detachEvent,
  DetachEvent: detachEvent
};
/**
 * Helper to support backward compatibility for users that use the legacy cookie handling functions and the use the internal
 * CoreUtils._canUseCookies global flag to enable/disable cookies usage.
 * Note: This has the following deliberate side-effects
 * - Creates the global (legacy) cookie manager if it does not already exist
 * - Attempts to add "listeners" to the CoreUtils._canUseCookies property to support the legacy usage
 * @param config
 * @param logger
 * @returns
 */
function _legacyCookieMgr(config, logger) {
  var cookieMgr = _gblCookieMgr(config, logger);
  var legacyCanUseCookies = CoreUtils._canUseCookies;
  if (_cookieMgrs === null) {
    _cookieMgrs = [];
    _canUseCookies = legacyCanUseCookies;
    // Dynamically create get/set property accessors for backward compatibility for enabling / disabling cookies
    // this WILL NOT work for ES3 browsers (< IE8)
    objDefineAccessors(CoreUtils, "_canUseCookies", function () {
      return _canUseCookies;
    }, function (value) {
      _canUseCookies = value;
      HelperFuncs_arrForEach(_cookieMgrs, function (mgr) {
        mgr[_DYN_SET_ENABLED /* @min:%2esetEnabled */](value);
      });
    });
  }
  if (arrIndexOf(_cookieMgrs, cookieMgr) === -1) {
    _cookieMgrs[_DynamicConstants_DYN_PUSH /* @min:%2epush */](cookieMgr);
  }
  if (isBoolean(legacyCanUseCookies)) {
    cookieMgr[_DYN_SET_ENABLED /* @min:%2esetEnabled */](legacyCanUseCookies);
  }
  if (isBoolean(_canUseCookies)) {
    cookieMgr[_DYN_SET_ENABLED /* @min:%2esetEnabled */](_canUseCookies);
  }
  return cookieMgr;
}
/**
 * @deprecated - Use the core.getCookieMgr().disable()
 * Force the SDK not to store and read any data from cookies.
 */
function disableCookies() {
  _legacyCookieMgr()[_DYN_SET_ENABLED /* @min:%2esetEnabled */](false);
}
/**
 * @deprecated - Use the core.getCookieMgr().isEnabled()
 * Helper method to tell if document.cookie object is available and whether it can be used.
 */
function canUseCookies(logger) {
  return _legacyCookieMgr(null, logger).isEnabled();
}
/**
 * @deprecated - Use the core.getCookieMgr().get()
 * helper method to access userId and sessionId cookie
 */
function getCookie(logger, name) {
  return _legacyCookieMgr(null, logger).get(name);
}
/**
 * @deprecated - Use the core.getCookieMgr().set()
 * helper method to set userId and sessionId cookie
 */
function setCookie(logger, name, value, domain) {
  _legacyCookieMgr(null, logger).set(name, value, null, domain);
}
/**
 * @deprecated - Use the core.getCookieMgr().del()
 * Deletes a cookie by setting it's expiration time in the past.
 * @param name - The name of the cookie to delete.
 */
function deleteCookie(logger, name) {
  return _legacyCookieMgr(null, logger).del(name);
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/W3cTraceParent.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




// using {0,16} for leading and trailing whitespace just to constrain the possible runtime of a random string
var TRACE_PARENT_REGEX = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})(-[^\s]*)?$/;
var DEFAULT_VERSION = "00";
var INVALID_VERSION = "ff";
var INVALID_TRACE_ID = "00000000000000000000000000000000";
var INVALID_SPAN_ID = "0000000000000000";
var SAMPLED_FLAG = 0x01;
function _isValid(value, len, invalidValue) {
  if (value && value[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === len && value !== invalidValue) {
    return !!value.match(/^[\da-f]*$/);
  }
  return false;
}
function _formatValue(value, len, defValue) {
  if (_isValid(value, len)) {
    return value;
  }
  return defValue;
}
function _formatFlags(value) {
  if (isNaN(value) || value < 0 || value > 255) {
    value = 0x01;
  }
  var result = value.toString(16);
  while (result[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] < 2) {
    result = "0" + result;
  }
  return result;
}
/**
 * Create a new ITraceParent instance using the provided values.
 * @param traceId - The traceId to use, when invalid a new random W3C id will be generated.
 * @param spanId - The parent/span id to use, a new random value will be generated if it is invalid.
 * @param flags - The traceFlags to use, defaults to zero (0) if not supplied or invalid
 * @param version - The version to used, defaults to version "01" if not supplied or invalid.
 * @returns
 */
function createTraceParent(traceId, spanId, flags, version) {
  var _a;
  return _a = {}, _a[_DynamicConstants_DYN_VERSION /* @min:version */] = _isValid(version, 2, INVALID_VERSION) ? version : DEFAULT_VERSION, _a[_DynamicConstants_DYN_TRACE_ID /* @min:traceId */] = isValidTraceId(traceId) ? traceId : generateW3CId(), _a.spanId = isValidSpanId(spanId) ? spanId : generateW3CId()[_DYN_SUBSTR /* @min:%2esubstr */](0, 16), _a.traceFlags = flags >= 0 && flags <= 0xFF ? flags : 1, _a;
}
/**
 * Attempt to parse the provided string as a W3C TraceParent header value (https://www.w3.org/TR/trace-context/#traceparent-header)
 *
 * @param value
 * @returns
 */
function parseTraceParent(value) {
  var _a;
  if (!value) {
    // Don't pass a null/undefined or empty string
    return null;
  }
  if (isArray(value)) {
    // The value may have been encoded on the page into an array so handle this automatically
    value = value[0] || "";
  }
  if (!value || !isString(value) || value[_DYN_LENGTH /* @min:%2elength */] > 8192) {
    // limit potential processing based on total length
    return null;
  }
  // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
  var match = TRACE_PARENT_REGEX.exec(strTrim(value));
  if (!match ||
  // No match
  match[1] === INVALID_VERSION ||
  // version ff is forbidden
  match[2] === INVALID_TRACE_ID ||
  // All zeros is considered to be invalid
  match[3] === INVALID_SPAN_ID) {
    // All zeros is considered to be invalid
    return null;
  }
  return _a = {}, _a[_DYN_VERSION /* @min:version */] = match[1], _a[_DYN_TRACE_ID /* @min:traceId */] = match[2], _a[_DYN_SPAN_ID /* @min:spanId */] = match[3], _a[_DYN_TRACE_FLAGS /* @min:traceFlags */] = parseInt(match[4], 16), _a;
}
/**
 * Is the provided W3c Trace Id a valid string representation, it must be a 32-character string
 * of lowercase hexadecimal characters for example, 4bf92f3577b34da6a3ce929d0e0e4736.
 * If all characters as zero (00000000000000000000000000000000) it will be considered an invalid value.
 * @param value - The W3c trace Id to be validated
 * @returns true if valid otherwise false
 */
function isValidTraceId(value) {
  return _isValid(value, 32, INVALID_TRACE_ID);
}
/**
 * Is the provided W3c span id (aka. parent id) a valid string representation, it must be a 16-character
 * string of lowercase hexadecimal characters, for example, 00f067aa0ba902b7.
 * If all characters are zero (0000000000000000) this is considered an invalid value.
 * @param value - The W3c span id to be validated
 * @returns true if valid otherwise false
 */
function isValidSpanId(value) {
  return _isValid(value, 16, INVALID_SPAN_ID);
}
/**
 * Validates that the provided ITraceParent instance conforms to the currently supported specifications
 * @param value
 * @returns
 */
function isValidTraceParent(value) {
  if (!value || !_isValid(value[_DYN_VERSION /* @min:%2eversion */], 2, INVALID_VERSION) || !_isValid(value[_DYN_TRACE_ID /* @min:%2etraceId */], 32, INVALID_TRACE_ID) || !_isValid(value[_DYN_SPAN_ID /* @min:%2espanId */], 16, INVALID_SPAN_ID) || !_isValid(_formatFlags(value[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */]), 2)) {
    // Each known field must contain a valid value
    return false;
  }
  return true;
}
/**
 * Is the parsed traceParent indicating that the trace is currently sampled.
 * @param value - The parsed traceParent value
 * @returns
 */
function isSampledFlag(value) {
  if (isValidTraceParent(value)) {
    return (value[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] & SAMPLED_FLAG) === SAMPLED_FLAG;
  }
  return false;
}
/**
 * Format the ITraceParent value as a string using the supported and know version formats.
 * So even if the passed traceParent is a later version the string value returned from this
 * function will convert it to only the known version formats.
 * This currently only supports version "00" and invalid "ff"
 * @param value - The parsed traceParent value
 * @returns
 */
function formatTraceParent(value) {
  if (value) {
    // Special Note: This only supports formatting as version 00, future versions should encode any known supported version
    // So parsing a future version will populate the correct version value but reformatting will reduce it to version 00.
    var flags = _formatFlags(value[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */]);
    if (!_isValid(flags, 2)) {
      flags = "01";
    }
    var version = value[_DynamicConstants_DYN_VERSION /* @min:%2eversion */] || DEFAULT_VERSION;
    if (version !== "00" && version !== "ff") {
      // Reduce version to "00"
      version = DEFAULT_VERSION;
    }
    // Format as version 00
    return "".concat(version, "-").concat(_formatValue(value.traceId, 32, INVALID_TRACE_ID), "-").concat(_formatValue(value.spanId, 16, INVALID_SPAN_ID), "-").concat(flags);
  }
  return "";
}
/**
 * Helper function to fetch the passed traceparent from the page, looking for it as a meta-tag or a Server-Timing header.
 * @returns
 */
function findW3cTraceParent() {
  var name = "traceparent";
  var traceParent = parseTraceParent(findMetaTag(name));
  if (!traceParent) {
    traceParent = parseTraceParent(findNamedServerTiming(name));
  }
  return traceParent;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/TelemetryHelpers.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








var pluginStateData = createElmNodeData("plugin");
function _getPluginState(plugin) {
  return pluginStateData.get(plugin, "state", {}, true);
}
/**
 * Initialize the queue of plugins
 * @param plugins - The array of plugins to initialize and setting of the next plugin
 * @param config The current config for the instance
 * @param core THe current core instance
 * @param extensions The extensions
 */
function initializePlugins(processContext, extensions) {
  // Set the next plugin and identified the uninitialized plugins
  var initPlugins = [];
  var lastPlugin = null;
  var proxy = processContext[_DYN_GET_NEXT /* @min:%2egetNext */]();
  var pluginState;
  while (proxy) {
    var thePlugin = proxy[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]();
    if (thePlugin) {
      if (lastPlugin && HelperFuncs_isFunction(lastPlugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */]) && HelperFuncs_isFunction(thePlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */])) {
        // Set this plugin as the next for the previous one
        lastPlugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */](thePlugin);
      }
      var isInitialized = false;
      if (HelperFuncs_isFunction(thePlugin[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */])) {
        isInitialized = thePlugin[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]();
      } else {
        pluginState = _getPluginState(thePlugin);
        isInitialized = pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */];
      }

      if (!isInitialized) {
        initPlugins[_DynamicConstants_DYN_PUSH /* @min:%2epush */](thePlugin);
      }
      lastPlugin = thePlugin;
      proxy = proxy[_DYN_GET_NEXT /* @min:%2egetNext */]();
    }
  }
  // Now initialize the plugins
  HelperFuncs_arrForEach(initPlugins, function (thePlugin) {
    var core = processContext[STR_CORE]();
    thePlugin[_DYN_INITIALIZE /* @min:%2einitialize */](processContext.getCfg(), core, extensions, processContext[_DYN_GET_NEXT /* @min:%2egetNext */]());
    pluginState = _getPluginState(thePlugin);
    // Only add the core to the state if the plugin didn't set it (doesn't extent from BaseTelemetryPlugin)
    if (!thePlugin[STR_CORE] && !pluginState[STR_CORE]) {
      pluginState[STR_CORE] = core;
    }
    pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = true;
    delete pluginState[_DYN_TEARDOWN /* @min:%2eteardown */];
  });
}

function sortPlugins(plugins) {
  // Sort by priority
  return plugins.sort(function (extA, extB) {
    var result = 0;
    if (extB) {
      var bHasProcess = HelperFuncs_isFunction(extB[STR_PROCESS_TELEMETRY]);
      if (HelperFuncs_isFunction(extA[STR_PROCESS_TELEMETRY])) {
        result = bHasProcess ? extA[STR_PRIORITY] - extB[STR_PRIORITY] : 1;
      } else if (bHasProcess) {
        result = -1;
      }
    } else {
      result = extA ? 1 : -1;
    }
    return result;
  });
  // sort complete
}
/**
 * Teardown / Unload helper to perform teardown/unloading operations for the provided components synchronously or asynchronously, this will call any
 * _doTeardown() or _doUnload() functions on the provided components to allow them to finish removal.
 * @param components - The components you want to unload
 * @param unloadCtx - This is the context that should be used during unloading.
 * @param unloadState - The details / state of the unload process, it holds details like whether it should be unloaded synchronously or asynchronously and the reason for the unload.
 * @param asyncCallback - An optional callback that the plugin must call if it returns true to inform the caller that it has completed any async unload/teardown operations.
 * @returns boolean - true if the plugin has or will call asyncCallback, this allows the plugin to perform any asynchronous operations.
 */
function unloadComponents(components, unloadCtx, unloadState, asyncCallback) {
  var idx = 0;
  function _doUnload() {
    while (idx < components[_DYN_LENGTH /* @min:%2elength */]) {
      var component = components[idx++];
      if (component) {
        var func = component._doUnload || component[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */];
        if (isFunction(func)) {
          if (func[_DYN_CALL /* @min:%2ecall */](component, unloadCtx, unloadState, _doUnload) === true) {
            return true;
          }
        }
      }
    }
  }
  return _doUnload();
}
/**
 * Creates a IDistributedTraceContext which optionally also "sets" the value on a parent
 * @param parentCtx - An optional parent distributed trace instance
 * @returns A new IDistributedTraceContext instance that uses an internal temporary object
 */
function createDistributedTraceContext(parentCtx) {
  var trace = {};
  return {
    getName: function () {
      return trace[_DynamicConstants_DYN_NAME /* @min:%2ename */];
    },

    setName: function (newValue) {
      parentCtx && parentCtx.setName(newValue);
      trace[_DynamicConstants_DYN_NAME /* @min:%2ename */] = newValue;
    },
    getTraceId: function () {
      return trace[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */];
    },

    setTraceId: function (newValue) {
      parentCtx && parentCtx.setTraceId(newValue);
      if (isValidTraceId(newValue)) {
        trace[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] = newValue;
      }
    },
    getSpanId: function () {
      return trace[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */];
    },

    setSpanId: function (newValue) {
      parentCtx && parentCtx.setSpanId(newValue);
      if (isValidSpanId(newValue)) {
        trace[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] = newValue;
      }
    },
    getTraceFlags: function () {
      return trace[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
    },

    setTraceFlags: function (newTraceFlags) {
      parentCtx && parentCtx.setTraceFlags(newTraceFlags);
      trace[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = newTraceFlags;
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/ProcessTelemetryContext.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */










var strTelemetryPluginChain = "TelemetryPluginChain";
var strHasRunFlags = "_hasRun";
var strGetTelCtx = "_getTelCtx";
var _chainId = 0;
function _getNextProxyStart(proxy, core, startAt) {
  while (proxy) {
    if (proxy[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]() === startAt) {
      return proxy;
    }
    proxy = proxy[_DYN_GET_NEXT /* @min:%2egetNext */]();
  }
  // This wasn't found in the existing chain so create an isolated one with just this plugin
  return createTelemetryProxyChain([startAt], core[_DYN_CONFIG /* @min:%2econfig */] || {}, core);
}
/**
 * @ignore
 * @param telemetryChain
 * @param config
 * @param core
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 * @returns
 */
function _createInternalContext(telemetryChain, config, core, startAt) {
  // We have a special case where we want to start execution from this specific plugin
  // or we simply reuse the existing telemetry plugin chain (normal execution case)
  var _nextProxy = null; // By Default set as no next plugin
  var _onComplete = [];
  if (startAt !== null) {
    // There is no next element (null) vs not defined (undefined) so use the full chain
    _nextProxy = startAt ? _getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
  }
  var context = {
    _next: _moveNext,
    ctx: {
      core: function () {
        return core;
      },
      diagLog: function () {
        return safeGetLogger(core, config);
      },
      getCfg: function () {
        return config;
      },
      getExtCfg: _getExtCfg,
      getConfig: _getConfig,
      hasNext: function () {
        return !!_nextProxy;
      },
      getNext: function () {
        return _nextProxy;
      },
      setNext: function (nextPlugin) {
        _nextProxy = nextPlugin;
      },
      iterate: _iterateChain,
      onComplete: _addOnComplete
    }
  };
  function _addOnComplete(onComplete, that) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    if (onComplete) {
      _onComplete[_DynamicConstants_DYN_PUSH /* @min:%2epush */]({
        func: onComplete,
        self: !isUndefined(that) ? that : context.ctx,
        args: args
      });
    }
  }
  function _moveNext() {
    var nextProxy = _nextProxy;
    // Automatically move to the next plugin
    _nextProxy = nextProxy ? nextProxy[_DYN_GET_NEXT /* @min:%2egetNext */]() : null;
    if (!nextProxy) {
      var onComplete = _onComplete;
      if (onComplete && onComplete[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
        HelperFuncs_arrForEach(onComplete, function (completeDetails) {
          try {
            completeDetails.func[_DynamicConstants_DYN_CALL /* @min:%2ecall */](completeDetails.self, completeDetails.args);
          } catch (e) {
            _throwInternal(core[_DYN_LOGGER /* @min:%2elogger */], 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unexpected Exception during onComplete - " + dumpObj(e));
          }
        });
        _onComplete = [];
      }
    }
    return nextProxy;
  }
  function _getExtCfg(identifier, defaultValue, mergeDefault) {
    if (defaultValue === void 0) {
      defaultValue = {};
    }
    if (mergeDefault === void 0) {
      mergeDefault = 0 /* GetExtCfgMergeType.None */;
    }
    var theConfig;
    if (config) {
      var extConfig = config[STR_EXTENSION_CONFIG /* @min:%2eextensionConfig */];
      if (extConfig && identifier) {
        theConfig = extConfig[identifier];
      }
    }
    if (!theConfig) {
      // Just use the defaults
      theConfig = defaultValue;
    } else if (isObject(defaultValue)) {
      if (mergeDefault !== 0 /* GetExtCfgMergeType.None */) {
        // Merge the defaults and configured values
        var newConfig_1 = objExtend(true, defaultValue, theConfig);
        if (config && mergeDefault === 2 /* GetExtCfgMergeType.MergeDefaultFromRootOrDefault */) {
          // Enumerate over the defaultValues and if not already populated attempt to
          // find a value from the root config
          HelperFuncs_objForEachKey(defaultValue, function (field) {
            // for each unspecified field, set the default value
            if (isNullOrUndefined(newConfig_1[field])) {
              var cfgValue = config[field];
              if (!isNullOrUndefined(cfgValue)) {
                newConfig_1[field] = cfgValue;
              }
            }
          });
        }
        theConfig = newConfig_1;
      }
    }
    return theConfig;
  }
  function _getConfig(identifier, field, defaultValue) {
    if (defaultValue === void 0) {
      defaultValue = false;
    }
    var theValue;
    var extConfig = _getExtCfg(identifier, null);
    if (extConfig && !isNullOrUndefined(extConfig[field])) {
      theValue = extConfig[field];
    } else if (config && !isNullOrUndefined(config[field])) {
      theValue = config[field];
    }
    return !isNullOrUndefined(theValue) ? theValue : defaultValue;
  }
  function _iterateChain(cb) {
    // Keep processing until we reach the end of the chain
    var nextPlugin;
    while (!!(nextPlugin = context._next())) {
      var plugin = nextPlugin[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]();
      if (plugin) {
        // callback with the current on
        cb(plugin);
      }
    }
  }
  return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryContext(telemetryChain, config, core, startAt) {
  var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
  var context = internalContext.ctx;
  function _processNext(env) {
    var nextPlugin = internalContext._next();
    // Run the next plugin which will call "processNext()"
    nextPlugin && nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, context);
    return !nextPlugin;
  }
  function _createNew(plugins, startAt) {
    if (plugins === void 0) {
      plugins = null;
    }
    if (HelperFuncs_isArray(plugins)) {
      plugins = createTelemetryProxyChain(plugins, config, core, startAt);
    }
    return createProcessTelemetryContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), config, core, startAt);
  }
  context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
  context[_DYN_CREATE_NEW /* @min:%2ecreateNew */] = _createNew;
  return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain for handling the unloading of the chain
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryUnloadContext(telemetryChain, core, startAt) {
  var config = core[_DYN_CONFIG /* @min:%2econfig */] || {};
  var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
  var context = internalContext.ctx;
  function _processNext(unloadState) {
    var nextPlugin = internalContext._next();
    nextPlugin && nextPlugin.unload(context, unloadState);
    return !nextPlugin;
  }
  function _createNew(plugins, startAt) {
    if (plugins === void 0) {
      plugins = null;
    }
    if (HelperFuncs_isArray(plugins)) {
      plugins = createTelemetryProxyChain(plugins, config, core, startAt);
    }
    return createProcessTelemetryUnloadContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), core, startAt);
  }
  context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
  context[_DYN_CREATE_NEW /* @min:%2ecreateNew */] = _createNew;
  return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain for updating the configuration
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryUpdateContext(telemetryChain, core, startAt) {
  var config = core[_DYN_CONFIG /* @min:%2econfig */] || {};
  var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
  var context = internalContext.ctx;
  function _processNext(updateState) {
    return context.iterate(function (plugin) {
      if (HelperFuncs_isFunction(plugin[_DYN_UPDATE /* @min:%2eupdate */])) {
        plugin[_DYN_UPDATE /* @min:%2eupdate */](context, updateState);
      }
    });
  }
  function _createNew(plugins, startAt) {
    if (plugins === void 0) {
      plugins = null;
    }
    if (HelperFuncs_isArray(plugins)) {
      plugins = createTelemetryProxyChain(plugins, config, core, startAt);
    }
    return createProcessTelemetryUpdateContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), core, startAt);
  }
  context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
  context[_DYN_CREATE_NEW /* @min:%2ecreateNew */] = _createNew;
  return context;
}
/**
 * Creates an execution chain from the array of plugins
 * @param plugins - The array of plugins that will be executed in this order
 * @param defItemCtx - The default execution context to use when no telemetry context is passed to processTelemetry(), this
 * should be for legacy plugins only. Currently, only used for passing the current core instance and to provide better error
 * reporting (hasRun) when errors occur.
 */
function createTelemetryProxyChain(plugins, config, core, startAt) {
  var firstProxy = null;
  var add = startAt ? false : true;
  if (HelperFuncs_isArray(plugins) && plugins[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
    // Create the proxies and wire up the next plugin chain
    var lastProxy_1 = null;
    HelperFuncs_arrForEach(plugins, function (thePlugin) {
      if (!add && startAt === thePlugin) {
        add = true;
      }
      if (add && thePlugin && HelperFuncs_isFunction(thePlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */])) {
        // Only add plugins that are processors
        var newProxy = createTelemetryPluginProxy(thePlugin, config, core);
        if (!firstProxy) {
          firstProxy = newProxy;
        }
        if (lastProxy_1) {
          // Set this new proxy as the next for the previous one
          lastProxy_1._setNext(newProxy);
        }
        lastProxy_1 = newProxy;
      }
    });
  }
  if (startAt && !firstProxy) {
    // Special case where the "startAt" was not in the original list of plugins
    return createTelemetryProxyChain([startAt], config, core);
  }
  return firstProxy;
}
/**
 * Create the processing telemetry proxy instance, the proxy is used to abstract the current plugin to allow monitoring and
 * execution plugins while passing around the dynamic execution state (IProcessTelemetryContext), the proxy instance no longer
 * contains any execution state and can be reused between requests (this was not the case for 2.7.2 and earlier with the
 * TelemetryPluginChain class).
 * @param plugin - The plugin instance to proxy
 * @param config - The default execution context to use when no telemetry context is passed to processTelemetry(), this
 * should be for legacy plugins only. Currently, only used for passing the current core instance and to provide better error
 * reporting (hasRun) when errors occur.
 * @returns
 */
function createTelemetryPluginProxy(plugin, config, core) {
  var nextProxy = null;
  var hasProcessTelemetry = HelperFuncs_isFunction(plugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */]);
  var hasSetNext = HelperFuncs_isFunction(plugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */]);
  var chainId;
  if (plugin) {
    chainId = plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] + "-" + plugin[STR_PRIORITY /* @min:%2epriority */] + "-" + _chainId++;
  } else {
    chainId = "Unknown-0-" + _chainId++;
  }
  var proxyChain = {
    getPlugin: function () {
      return plugin;
    },
    getNext: function () {
      return nextProxy;
    },
    processTelemetry: _processTelemetry,
    unload: _unloadPlugin,
    update: _updatePlugin,
    _id: chainId,
    _setNext: function (nextPlugin) {
      nextProxy = nextPlugin;
    }
  };
  function _getTelCtx() {
    var itemCtx;
    // Looks like a plugin didn't pass the (optional) context, so create a new one
    if (plugin && HelperFuncs_isFunction(plugin[strGetTelCtx])) {
      // This plugin extends from the BaseTelemetryPlugin so lets use it
      itemCtx = plugin[strGetTelCtx]();
    }
    if (!itemCtx) {
      // Create a temporary one
      itemCtx = createProcessTelemetryContext(proxyChain, config, core);
    }
    return itemCtx;
  }
  function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
    var hasRun = false;
    var identifier = plugin ? plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] : strTelemetryPluginChain;
    var hasRunContext = itemCtx[strHasRunFlags];
    if (!hasRunContext) {
      // Assign and populate
      hasRunContext = itemCtx[strHasRunFlags] = {};
    }
    // Ensure that we keep the context in sync
    itemCtx.setNext(nextProxy);
    if (plugin) {
      doPerf(itemCtx[STR_CORE /* @min:%2ecore */](), function () {
        return identifier + ":" + name;
      }, function () {
        // Mark this component as having run
        hasRunContext[chainId] = true;
        try {
          // Set a flag on the next plugin so we know if it was attempted to be executed
          var nextId = nextProxy ? nextProxy._id : InternalConstants_STR_EMPTY;
          if (nextId) {
            hasRunContext[nextId] = false;
          }
          hasRun = processPluginFn(itemCtx);
        } catch (error) {
          var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
          if (hasNextRun) {
            // The next plugin after us has already run so set this one as complete
            hasRun = true;
          }
          if (!nextProxy || !hasNextRun) {
            // Either we have no next plugin or the current one did not attempt to call the next plugin
            // Which means the current one is the root of the failure so log/report this failure
            _throwInternal(itemCtx[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 73 /* _eInternalMessageId.PluginException */, "Plugin [" + identifier + "] failed during " + name + " - " + dumpObj(error) + ", run flags: " + dumpObj(hasRunContext));
          }
        }
      }, details, isAsync);
    }
    return hasRun;
  }
  function _processTelemetry(env, itemCtx) {
    itemCtx = itemCtx || _getTelCtx();
    function _callProcessTelemetry(itemCtx) {
      if (!plugin || !hasProcessTelemetry) {
        return false;
      }
      var pluginState = _getPluginState(plugin);
      if (pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] || pluginState[STR_DISABLED]) {
        return false;
      }
      // Ensure that we keep the context in sync (for processNext()), just in case a plugin
      // doesn't calls processTelemetry() instead of itemContext.processNext() or some
      // other form of error occurred
      if (hasSetNext) {
        // Backward compatibility setting the next plugin on the instance
        plugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */](nextProxy);
      }
      plugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, itemCtx);
      // Process Telemetry is expected to call itemCtx.processNext() or nextPlugin.processTelemetry()
      return true;
    }
    if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function () {
      return {
        item: env
      };
    }, !env.sync)) {
      // The underlying plugin is either not defined, not enabled or does not have a processTelemetry implementation
      // so we still want the next plugin to be executed.
      itemCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](env);
    }
  }
  function _unloadPlugin(unloadCtx, unloadState) {
    function _callTeardown() {
      // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
      var hasRun = false;
      if (plugin) {
        var pluginState = _getPluginState(plugin);
        var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE /* @min:%2ecore */];
        // Only teardown the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
        if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */]) {
          // Handle plugins that don't extend from the BaseTelemetryPlugin
          pluginState[STR_CORE /* @min:%2ecore */] = null;
          pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] = true;
          pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = false;
          if (plugin[_DYN_TEARDOWN /* @min:%2eteardown */] && plugin[_DYN_TEARDOWN /* @min:%2eteardown */](unloadCtx, unloadState) === true) {
            // plugin told us that it was going to (or has) call unloadCtx.processNext()
            hasRun = true;
          }
        }
      }
      return hasRun;
    }
    if (!_processChain(unloadCtx, _callTeardown, "unload", function () {}, unloadState[_DYN_IS_ASYNC /* @min:%2eisAsync */])) {
      // Only called if we hasRun was not true
      unloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
    }
  }
  function _updatePlugin(updateCtx, updateState) {
    function _callUpdate() {
      // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
      var hasRun = false;
      if (plugin) {
        var pluginState = _getPluginState(plugin);
        var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE /* @min:%2ecore */];
        // Only update the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
        if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */]) {
          if (plugin[_DYN_UPDATE /* @min:%2eupdate */] && plugin[_DYN_UPDATE /* @min:%2eupdate */](updateCtx, updateState) === true) {
            // plugin told us that it was going to (or has) call unloadCtx.processNext()
            hasRun = true;
          }
        }
      }
      return hasRun;
    }
    if (!_processChain(updateCtx, _callUpdate, "update", function () {}, false)) {
      // Only called if we hasRun was not true
      updateCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](updateState);
    }
  }
  return objFreeze(proxyChain);
}
/**
 * This class will be removed!
 * @deprecated use createProcessTelemetryContext() instead
 */
var ProcessTelemetryContext = /** @class */function () {
  /**
   * Creates a new Telemetry Item context with the current config, core and plugin execution chain
   * @param plugins - The plugin instances that will be executed
   * @param config - The current config
   * @param core - The current core instance
   */
  function ProcessTelemetryContext(pluginChain, config, core, startAt) {
    var _self = this;
    var context = createProcessTelemetryContext(pluginChain, config, core, startAt);
    // Proxy all functions of the context to this object
    proxyFunctions(_self, context, objKeys(context));
  }
  return ProcessTelemetryContext;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/UnloadHandlerContainer.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





function createUnloadHandlerContainer() {
  var handlers = [];
  function _addHandler(handler) {
    if (handler) {
      handlers[_DynamicConstants_DYN_PUSH /* @min:%2epush */](handler);
    }
  }
  function _runHandlers(unloadCtx, unloadState) {
    HelperFuncs_arrForEach(handlers, function (handler) {
      try {
        handler(unloadCtx, unloadState);
      } catch (e) {
        _throwInternal(unloadCtx[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unexpected error calling unload handler - " + dumpObj(e));
      }
    });
    handlers = [];
  }
  return {
    add: _addHandler,
    run: _runHandlers
  };
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/BaseTelemetryPlugin.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var strGetPlugin = "getPlugin";
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */
var BaseTelemetryPlugin = /** @class */function () {
  function BaseTelemetryPlugin() {
    var _self = this; // Setting _self here as it's used outside of the dynamicProto as well
    // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
    var _isinitialized;
    var _rootCtx; // Used as the root context, holding the current config and initialized core
    var _nextPlugin; // Used for backward compatibility where plugins don't call the main pipeline
    var _unloadHandlerContainer;
    var _hooks;
    _initDefaults();
    dynamicProto(BaseTelemetryPlugin, _self, function (_self) {
      _self[_DYN_INITIALIZE /* @min:%2einitialize */] = function (config, core, extensions, pluginChain) {
        _setDefaults(config, core, pluginChain);
        _isinitialized = true;
      };
      _self[_DYN_TEARDOWN /* @min:%2eteardown */] = function (unloadCtx, unloadState) {
        var _a;
        // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
        // or the core being used for unload was not the same core used for initialization.
        var core = _self[STR_CORE /* @min:%2ecore */];
        if (!core || unloadCtx && core !== unloadCtx[STR_CORE /* @min:%2ecore */]()) {
          // Do Nothing as either the plugin is not initialized or was not initialized by the current core
          return;
        }
        var result;
        var unloadDone = false;
        var theUnloadCtx = unloadCtx || createProcessTelemetryUnloadContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
        var theUnloadState = unloadState || (_a = {
          reason: 0 /* TelemetryUnloadReason.ManualTeardown */
        }, _a[_DYN_IS_ASYNC /* @min:isAsync */] = false, _a);
        function _unloadCallback() {
          if (!unloadDone) {
            unloadDone = true;
            _unloadHandlerContainer.run(theUnloadCtx, unloadState);
            var oldHooks = _hooks;
            _hooks = [];
            // Remove all instrumentation hooks
            HelperFuncs_arrForEach(oldHooks, function (fn) {
              fn.rm();
            });
            if (result === true) {
              theUnloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](theUnloadState);
            }
            _initDefaults();
          }
        }
        if (!_self[_DynamicConstants_DYN_DO_TEARDOWN /* @min:%2e_doTeardown */] || _self[_DynamicConstants_DYN_DO_TEARDOWN /* @min:%2e_doTeardown */](theUnloadCtx, theUnloadState, _unloadCallback) !== true) {
          _unloadCallback();
        } else {
          // Tell the caller that we will be calling processNext()
          result = true;
        }
        return result;
      };
      _self[_DYN_UPDATE /* @min:%2eupdate */] = function (updateCtx, updateState) {
        // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
        // or the core being used for unload was not the same core used for initialization.
        var core = _self[STR_CORE /* @min:%2ecore */];
        if (!core || updateCtx && core !== updateCtx[STR_CORE /* @min:%2ecore */]()) {
          // Do Nothing
          return;
        }
        var result;
        var updateDone = false;
        var theUpdateCtx = updateCtx || createProcessTelemetryUpdateContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
        var theUpdateState = updateState || {
          reason: 0 /* TelemetryUpdateReason.Unknown */
        };

        function _updateCallback() {
          if (!updateDone) {
            updateDone = true;
            _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[_DYN_GET_NEXT /* @min:%2egetNext */]());
          }
        }

        if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) {
          _updateCallback();
        } else {
          result = true;
        }
        return result;
      };
      _self._addHook = function (hooks) {
        if (hooks) {
          if (HelperFuncs_isArray(hooks)) {
            _hooks = _hooks.concat(hooks);
          } else {
            _hooks[_DynamicConstants_DYN_PUSH /* @min:%2epush */](hooks);
          }
        }
      };
      proxyFunctionAs(_self, "_addUnloadCb", function () {
        return _unloadHandlerContainer;
      }, "add");
    });
    // These are added after the dynamicProto so that are not moved to the prototype
    _self[_DYN_DIAG_LOG /* @min:%2ediagLog */] = function (itemCtx) {
      return _getTelCtx(itemCtx)[_DYN_DIAG_LOG /* @min:%2ediagLog */]();
    };

    _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = function () {
      return _isinitialized;
    };
    _self.setInitialized = function (isInitialized) {
      _isinitialized = isInitialized;
    };
    // _self.getNextPlugin = () => DO NOT IMPLEMENT
    // Sub-classes of this base class *should* not be relying on this value and instead
    // should use processNext() function. If you require access to the plugin use the
    // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
    _self[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */] = function (next) {
      _nextPlugin = next;
    };
    _self[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = function (env, itemCtx) {
      if (itemCtx) {
        // Normal core execution sequence
        itemCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](env);
      } else if (_nextPlugin && HelperFuncs_isFunction(_nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */])) {
        // Looks like backward compatibility or out of band processing. And as it looks
        // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
        _nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, null);
      }
    };
    _self._getTelCtx = _getTelCtx;
    function _getTelCtx(currentCtx) {
      if (currentCtx === void 0) {
        currentCtx = null;
      }
      var itemCtx = currentCtx;
      if (!itemCtx) {
        var rootCtx = _rootCtx || createProcessTelemetryContext(null, {}, _self[STR_CORE /* @min:%2ecore */]);
        // tslint:disable-next-line: prefer-conditional-expression
        if (_nextPlugin && _nextPlugin[strGetPlugin]) {
          // Looks like a chain object
          itemCtx = rootCtx[_DYN_CREATE_NEW /* @min:%2ecreateNew */](null, _nextPlugin[strGetPlugin]);
        } else {
          itemCtx = rootCtx[_DYN_CREATE_NEW /* @min:%2ecreateNew */](null, _nextPlugin);
        }
      }
      return itemCtx;
    }
    function _setDefaults(config, core, pluginChain) {
      if (config) {
        // Make sure the extensionConfig exists
        setValue(config, STR_EXTENSION_CONFIG, [], null, isNullOrUndefined);
      }
      if (!pluginChain && core) {
        // Get the first plugin from the core
        pluginChain = core[_DYN_GET_PROCESS_TEL_CONT0 /* @min:%2egetProcessTelContext */]()[_DYN_GET_NEXT /* @min:%2egetNext */]();
      }

      var nextPlugin = _nextPlugin;
      if (_nextPlugin && _nextPlugin[strGetPlugin]) {
        // If it looks like a proxy/chain then get the plugin
        nextPlugin = _nextPlugin[strGetPlugin]();
      }
      // Support legacy plugins where core was defined as a property
      _self[STR_CORE /* @min:%2ecore */] = core;
      _rootCtx = createProcessTelemetryContext(pluginChain, config, core, nextPlugin);
    }
    function _initDefaults() {
      _isinitialized = false;
      _self[STR_CORE /* @min:%2ecore */] = null;
      _rootCtx = null;
      _nextPlugin = null;
      _hooks = [];
      _unloadHandlerContainer = createUnloadHandlerContainer();
    }
  }
  // Removed Stub for BaseTelemetryPlugin.prototype.initialize.
  // Removed Stub for BaseTelemetryPlugin.prototype.teardown.
  // Removed Stub for BaseTelemetryPlugin.prototype.update.
  // Removed Stub for BaseTelemetryPlugin.prototype._addUnloadCb.
  // Removed Stub for BaseTelemetryPlugin.prototype._addHook.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  BaseTelemetryPlugin.__ieDyn = 1;
  return BaseTelemetryPlugin;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-react-js/dist-esm/ReactPlugin.js
/*
 * Application Insights JavaScript SDK - React Plugin, 3.4.0
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* ReactPlugin.ts
* @copyright Microsoft 2019
*/



var ReactPlugin = /** @class */function (_super) {
  __extendsFn(ReactPlugin, _super);
  function ReactPlugin() {
    var _this = _super.call(this) || this;
    _this.priority = 185;
    _this.identifier = 'ReactPlugin';
    var _analyticsPlugin;
    var _extensionConfig;
    var _unlisten;
    var _pageViewTimer;
    dynamicProto(ReactPlugin, _this, function (_self, _base) {
      _initDefaults();
      _self.initialize = function (config, core, extensions, pluginChain) {
        _super.prototype.initialize.call(_this, config, core, extensions, pluginChain);
        _extensionConfig = config.extensionConfig && config.extensionConfig[_self.identifier] ? config.extensionConfig[_self.identifier] : {
          history: null
        };
        HelperFuncs_arrForEach(extensions, function (ext) {
          var identifier = ext.identifier;
          if (identifier === 'ApplicationInsightsAnalytics') {
            _analyticsPlugin = ext;
          }
        });
        if (_extensionConfig.history) {
          _addHistoryListener(_extensionConfig.history);
          var pageViewTelemetry = {
            uri: _extensionConfig.history.location.pathname
          };
          _self.trackPageView(pageViewTelemetry);
        }
      };
      _self.getCookieMgr = function () {
        return safeGetCookieMgr(_self.core);
      };
      _self.getAppInsights = _getAnalytics;
      _self.processTelemetry = function (event, itemCtx) {
        _self.processNext(event, itemCtx);
      };
      _self._doTeardown = function (unloadCtx, unloadState, asyncCallback) {
        if (HelperFuncs_isFunction(_unlisten)) {
          _unlisten();
        }
        if (_pageViewTimer) {
          clearTimeout(_pageViewTimer);
        }
        _initDefaults();
      };
      // Proxy the analytics functions
      proxyFunctions(_self, _getAnalytics, ["trackMetric", "trackPageView", "trackEvent", "trackException", "trackTrace"]);
      function _initDefaults() {
        _analyticsPlugin = null;
        _extensionConfig = null;
        _unlisten = null;
        _pageViewTimer = null;
      }
      function _getAnalytics() {
        if (!_analyticsPlugin) {
          _throwInternal(_self.diagLog(), 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
        }
        return _analyticsPlugin;
      }
      function _addHistoryListener(history) {
        var locationListener = function (arg) {
          // v4 of the history API passes "location" as the first argument, while v5 passes an object that contains location and action 
          var locn = null;
          if ("location" in arg) {
            // Looks like v5
            locn = arg["location"];
          } else {
            locn = arg;
          }
          // Timeout to ensure any changes to the DOM made by route changes get included in pageView telemetry
          _pageViewTimer = setTimeout(function () {
            _pageViewTimer = null;
            var pageViewTelemetry = {
              uri: locn.pathname
            };
            _self.trackPageView(pageViewTelemetry);
          }, 500);
        };
        _unlisten = history.listen(locationListener);
      }
      objDefineAccessors(_self, "_extensionConfig", function () {
        return _extensionConfig;
      });
    });
    return _this;
  }
  // Removed Stub for ReactPlugin.prototype.initialize.
  // Removed Stub for ReactPlugin.prototype.getCookieMgr.
  // Removed Stub for ReactPlugin.prototype.getAppInsights.
  // Removed Stub for ReactPlugin.prototype.processTelemetry.
  // Removed Stub for ReactPlugin.prototype.trackMetric.
  // Removed Stub for ReactPlugin.prototype.trackPageView.
  // Removed Stub for ReactPlugin.prototype.trackEvent.
  // Removed Stub for ReactPlugin.prototype.trackException.
  // Removed Stub for ReactPlugin.prototype.trackTrace.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  ReactPlugin.__ieDyn = 1;
  return ReactPlugin;
}(BaseTelemetryPlugin);
/* harmony default export */ var dist_esm_ReactPlugin = (ReactPlugin);
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DynamicConstants_DYN_SPLIT = "split"; // Count: 6
var dist_esm_DynamicConstants_DYN_LENGTH = "length"; // Count: 41
var dist_esm_DynamicConstants_DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 6
var _DYN_INGESTIONENDPOINT = "ingestionendpoint"; // Count: 4
var _DYN_TO_STRING = "toString"; // Count: 12
var _DYN_REMOVE_ITEM = "removeItem"; // Count: 3
var dist_esm_DynamicConstants_DYN_NAME = "name"; // Count: 11
var _DynamicConstants_DYN_MESSAGE = "message"; // Count: 10
var _DYN_COUNT = "count"; // Count: 8
var _DYN_PRE_TRIGGER_DATE = "preTriggerDate"; // Count: 4
var _DYN_DISABLED = "disabled"; // Count: 3
var _DYN_DATE = "date"; // Count: 5
var _DYN_GET_UTCDATE = "getUTCDate"; // Count: 3
var _DYN_MAX_TIMES_PER_MONTH = "maxTimesPerMonth"; // Count: 2
var _DYN_STRINGIFY = "stringify"; // Count: 4
var _DYN_PATHNAME = "pathname"; // Count: 4
var _DYN_CORRELATION_HEADER_E0 = "correlationHeaderExcludePatterns"; // Count: 2
var dist_esm_DynamicConstants_DYN_INDEX_OF = "indexOf"; // Count: 4
var _DYN_EXTENSION_CONFIG = "extensionConfig"; // Count: 4
var _DYN_EXCEPTIONS = "exceptions"; // Count: 6
var _DYN_PARSED_STACK = "parsedStack"; // Count: 11
var _DYN_PROPERTIES = "properties"; // Count: 9
var _DYN_MEASUREMENTS = "measurements"; // Count: 9
var _DYN_SIZE_IN_BYTES = "sizeInBytes"; // Count: 11
var _DYN_TYPE_NAME = "typeName"; // Count: 11
var _DYN_SEVERITY_LEVEL = "severityLevel"; // Count: 5
var _DYN_PROBLEM_GROUP = "problemGroup"; // Count: 3
var _DYN_IS_MANUAL = "isManual"; // Count: 3
var _DYN__CREATE_FROM_INTERFA1 = "CreateFromInterface"; // Count: 2
var _DYN_HAS_FULL_STACK = "hasFullStack"; // Count: 6
var _DYN_LEVEL = "level"; // Count: 5
var _DYN_METHOD = "method"; // Count: 7
var _DYN_ASSEMBLY = "assembly"; // Count: 5
var _DYN_FILE_NAME = "fileName"; // Count: 6
var _DYN_LINE = "line"; // Count: 6
var _DYN_DURATION = "duration"; // Count: 4
var _DYN_RECEIVED_RESPONSE = "receivedResponse"; // Count: 2
var dist_esm_DynamicConstants_DYN_SUBSTRING = "substring"; // Count: 6
var _DYN_SANITIZE_KEY_AND_ADD2 = "sanitizeKeyAndAddUniqueness"; // Count: 2
var _DYN_SANITIZE_EXCEPTION = "sanitizeException"; // Count: 2
var _DYN_SANITIZE_PROPERTIES = "sanitizeProperties"; // Count: 2
var _DYN_SANITIZE_MEASUREMENT3 = "sanitizeMeasurements"; // Count: 2
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/HelperFuncs.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var strEmpty = "";
function stringToBoolOrDefault(str, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }
  if (str === undefined || str === null) {
    return defaultValue;
  }
  return str.toString()[dist_esm_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]() === "true";
}
/**
 * Convert ms to c# time span format
 */
function msToTimeSpan(totalms) {
  if (isNaN(totalms) || totalms < 0) {
    totalms = 0;
  }
  totalms = Math.round(totalms);
  var ms = strEmpty + totalms % 1000;
  var sec = strEmpty + Math.floor(totalms / 1000) % 60;
  var min = strEmpty + Math.floor(totalms / (1000 * 60)) % 60;
  var hour = strEmpty + Math.floor(totalms / (1000 * 60 * 60)) % 24;
  var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
  ms = ms[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 1 ? "00" + ms : ms[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 2 ? "0" + ms : ms;
  sec = sec[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] < 2 ? "0" + sec : sec;
  min = min[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] < 2 ? "0" + min : min;
  hour = hour[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] < 2 ? "0" + hour : hour;
  return (days > 0 ? days + "." : strEmpty) + hour + ":" + min + ":" + sec + "." + ms;
}
function getExtensionByName(extensions, identifier) {
  var extension = null;
  HelperFuncs_arrForEach(extensions, function (value) {
    if (value.identifier === identifier) {
      extension = value;
      return -1;
    }
  });
  return extension;
}
function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
  return !error && HelperFuncs_isString(message) && (message === "Script error." || message === "Script error");
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Enums.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var StorageType = createEnumStyle({
  LocalStorage: 0 /* eStorageType.LocalStorage */,
  SessionStorage: 1 /* eStorageType.SessionStorage */
});

var DistributedTracingModes = createEnumStyle({
  AI: 0 /* eDistributedTracingModes.AI */,
  AI_AND_W3C: 1 /* eDistributedTracingModes.AI_AND_W3C */,
  W3C: 2 /* eDistributedTracingModes.W3C */
});
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/StorageHelperFuncs.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _canUseLocalStorage = undefined;
var _canUseSessionStorage = undefined;
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getLocalStorageObject() {
  if (utlCanUseLocalStorage()) {
    return _getVerifiedStorageObject(StorageType.LocalStorage);
  }
  return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */
function _getVerifiedStorageObject(storageType) {
  try {
    if (isNullOrUndefined(getGlobal())) {
      return null;
    }
    var uid = new Date()[_DYN_TO_STRING /* @min:%2etoString */]();
    var storage = getGlobalInst(storageType === StorageType.LocalStorage ? "localStorage" : "sessionStorage");
    storage.setItem(uid, uid);
    var fail = storage.getItem(uid) !== uid;
    storage[_DYN_REMOVE_ITEM /* @min:%2eremoveItem */](uid);
    if (!fail) {
      return storage;
    }
  } catch (exception) {
    // eslint-disable-next-line no-empty
  }
  return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getSessionStorageObject() {
  if (utlCanUseSessionStorage()) {
    return _getVerifiedStorageObject(StorageType.SessionStorage);
  }
  return null;
}
/**
 * Disables the global SDK usage of local or session storage if available
 */
function utlDisableStorage() {
  _canUseLocalStorage = false;
  _canUseSessionStorage = false;
}
/**
 * Re-enables the global SDK usage of local or session storage if available
 */
function utlEnableStorage() {
  _canUseLocalStorage = utlCanUseLocalStorage(true);
  _canUseSessionStorage = utlCanUseSessionStorage(true);
}
/**
 * Returns whether LocalStorage can be used, if the reset parameter is passed a true this will override
 * any previous disable calls.
 * @param reset - Should the usage be reset and determined only based on whether LocalStorage is available
 */
function utlCanUseLocalStorage(reset) {
  if (reset || _canUseLocalStorage === undefined) {
    _canUseLocalStorage = !!_getVerifiedStorageObject(StorageType.LocalStorage);
  }
  return _canUseLocalStorage;
}
function utlGetLocalStorage(logger, name) {
  var storage = _getLocalStorageObject();
  if (storage !== null) {
    try {
      return storage.getItem(name);
    } catch (e) {
      _canUseLocalStorage = false;
      _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 1 /* _eInternalMessageId.BrowserCannotReadLocalStorage */, "Browser failed read of local storage. " + getExceptionName(e), {
        exception: dumpObj(e)
      });
    }
  }
  return null;
}
function utlSetLocalStorage(logger, name, data) {
  var storage = _getLocalStorageObject();
  if (storage !== null) {
    try {
      storage.setItem(name, data);
      return true;
    } catch (e) {
      _canUseLocalStorage = false;
      _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 3 /* _eInternalMessageId.BrowserCannotWriteLocalStorage */, "Browser failed write to local storage. " + getExceptionName(e), {
        exception: dumpObj(e)
      });
    }
  }
  return false;
}
function utlRemoveStorage(logger, name) {
  var storage = _getLocalStorageObject();
  if (storage !== null) {
    try {
      storage[_DYN_REMOVE_ITEM /* @min:%2eremoveItem */](name);
      return true;
    } catch (e) {
      _canUseLocalStorage = false;
      _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 5 /* _eInternalMessageId.BrowserFailedRemovalFromLocalStorage */, "Browser failed removal of local storage item. " + getExceptionName(e), {
        exception: dumpObj(e)
      });
    }
  }
  return false;
}
function utlCanUseSessionStorage(reset) {
  if (reset || _canUseSessionStorage === undefined) {
    _canUseSessionStorage = !!_getVerifiedStorageObject(StorageType.SessionStorage);
  }
  return _canUseSessionStorage;
}
function utlGetSessionStorageKeys() {
  var keys = [];
  if (utlCanUseSessionStorage()) {
    HelperFuncs_objForEachKey(getGlobalInst("sessionStorage"), function (key) {
      keys.push(key);
    });
  }
  return keys;
}
function utlGetSessionStorage(logger, name) {
  var storage = _getSessionStorageObject();
  if (storage !== null) {
    try {
      return storage.getItem(name);
    } catch (e) {
      _canUseSessionStorage = false;
      _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 2 /* _eInternalMessageId.BrowserCannotReadSessionStorage */, "Browser failed read of session storage. " + getExceptionName(e), {
        exception: dumpObj(e)
      });
    }
  }
  return null;
}
function utlSetSessionStorage(logger, name, data) {
  var storage = _getSessionStorageObject();
  if (storage !== null) {
    try {
      storage.setItem(name, data);
      return true;
    } catch (e) {
      _canUseSessionStorage = false;
      _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 4 /* _eInternalMessageId.BrowserCannotWriteSessionStorage */, "Browser failed write to session storage. " + getExceptionName(e), {
        exception: dumpObj(e)
      });
    }
  }
  return false;
}
function utlRemoveSessionStorage(logger, name) {
  var storage = _getSessionStorageObject();
  if (storage !== null) {
    try {
      storage[_DYN_REMOVE_ITEM /* @min:%2eremoveItem */](name);
      return true;
    } catch (e) {
      _canUseSessionStorage = false;
      _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 6 /* _eInternalMessageId.BrowserFailedRemovalFromSessionStorage */, "Browser failed removal of session storage item. " + getExceptionName(e), {
        exception: dumpObj(e)
      });
    }
  }
  return false;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/applicationinsights-common.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// Licensed under the


























var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Constants.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */
var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var SampleRate = "sampleRate";
var ProcessLegacy = "ProcessLegacy";
var HttpMethod = "http.method";
var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
var DEFAULT_BREEZE_PATH = "/v2/track";
var strNotSpecified = "not_specified";
var strIkey = "iKey";
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Common/DataSanitizer.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var DataSanitizer_a;


function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
  var origLength = key[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
  var field = dataSanitizeKey(logger, key);
  // validation truncated the length.  We need to add uniqueness
  if (field[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] !== origLength) {
    var i = 0;
    var uniqueField = field;
    while (map[uniqueField] !== undefined) {
      i++;
      uniqueField = field[dist_esm_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ - 3) + dsPadNumber(i);
    }
    field = uniqueField;
  }
  return field;
}
function dataSanitizeKey(logger, name) {
  var nameTrunc;
  if (name) {
    // Remove any leading or trailing whitespace
    name = HelperFuncs_strTrim(name[_DYN_TO_STRING /* @min:%2etoString */]());
    // truncate the string to 150 chars
    if (name[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 150 /* DataSanitizerValues.MAX_NAME_LENGTH */) {
      nameTrunc = name[dist_esm_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */);
      _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 57 /* _eInternalMessageId.NameTooLong */, "name is too long.  It has been truncated to " + 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ + " characters.", {
        name: name
      }, true);
    }
  }
  return nameTrunc || name;
}
function dataSanitizeString(logger, value, maxLength) {
  if (maxLength === void 0) {
    maxLength = 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */;
  }
  var valueTrunc;
  if (value) {
    maxLength = maxLength ? maxLength : 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */; // in case default parameters dont work
    value = HelperFuncs_strTrim(value);
    if (value.toString()[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > maxLength) {
      valueTrunc = value[_DYN_TO_STRING /* @min:%2etoString */]()[dist_esm_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](0, maxLength);
      _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 61 /* _eInternalMessageId.StringValueTooLong */, "string value is too long. It has been truncated to " + maxLength + " characters.", {
        value: value
      }, true);
    }
  }
  return valueTrunc || value;
}
function dataSanitizeUrl(logger, url) {
  return dataSanitizeInput(logger, url, 2048 /* DataSanitizerValues.MAX_URL_LENGTH */, 66 /* _eInternalMessageId.UrlTooLong */);
}

function dataSanitizeMessage(logger, message) {
  var messageTrunc;
  if (message) {
    if (message[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */) {
      messageTrunc = message[dist_esm_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](0, 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */);
      _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 56 /* _eInternalMessageId.MessageTruncated */, "message is too long, it has been truncated to " + 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ + " characters.", {
        message: message
      }, true);
    }
  }
  return messageTrunc || message;
}
function dataSanitizeException(logger, exception) {
  var exceptionTrunc;
  if (exception) {
    // Make surte its a string
    var value = "" + exception;
    if (value[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */) {
      exceptionTrunc = value[dist_esm_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](0, 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */);
      _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 52 /* _eInternalMessageId.ExceptionTruncated */, "exception is too long, it has been truncated to " + 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ + " characters.", {
        exception: exception
      }, true);
    }
  }
  return exceptionTrunc || exception;
}
function dataSanitizeProperties(logger, properties) {
  if (properties) {
    var tempProps_1 = {};
    HelperFuncs_objForEachKey(properties, function (prop, value) {
      if (isObject(value) && hasJSON()) {
        // Stringify any part C properties
        try {
          value = getJSON()[_DYN_STRINGIFY /* @min:%2estringify */](value);
        } catch (e) {
          _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */, "custom property is not valid", {
            exception: e
          }, true);
        }
      }
      value = dataSanitizeString(logger, value, 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */);
      prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
      tempProps_1[prop] = value;
    });
    properties = tempProps_1;
  }
  return properties;
}
function dataSanitizeMeasurements(logger, measurements) {
  if (measurements) {
    var tempMeasurements_1 = {};
    HelperFuncs_objForEachKey(measurements, function (measure, value) {
      measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
      tempMeasurements_1[measure] = value;
    });
    measurements = tempMeasurements_1;
  }
  return measurements;
}
function dataSanitizeId(logger, id) {
  return id ? dataSanitizeInput(logger, id, 128 /* DataSanitizerValues.MAX_ID_LENGTH */, 69 /* _eInternalMessageId.IdTooLong */)[_DYN_TO_STRING /* @min:%2etoString */]() : id;
}
function dataSanitizeInput(logger, input, maxLength, _msgId) {
  var inputTrunc;
  if (input) {
    input = HelperFuncs_strTrim(input);
    if (input[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > maxLength) {
      inputTrunc = input[dist_esm_DynamicConstants_DYN_SUBSTRING /* @min:%2esubstring */](0, maxLength);
      _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", {
        data: input
      }, true);
    }
  }
  return inputTrunc || input;
}
function dsPadNumber(num) {
  var s = "00" + num;
  return s.substr(s[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 3);
}
/**
 * Provides the DataSanitizer functions within the previous namespace.
 */
var DataSanitizer = (DataSanitizer_a = {
  MAX_NAME_LENGTH: 150 /* DataSanitizerValues.MAX_NAME_LENGTH */,
  MAX_ID_LENGTH: 128 /* DataSanitizerValues.MAX_ID_LENGTH */,
  MAX_PROPERTY_LENGTH: 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */,
  MAX_STRING_LENGTH: 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */,
  MAX_URL_LENGTH: 2048 /* DataSanitizerValues.MAX_URL_LENGTH */,
  MAX_MESSAGE_LENGTH: 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */,
  MAX_EXCEPTION_LENGTH: 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */
}, DataSanitizer_a[_DYN_SANITIZE_KEY_AND_ADD2 /* @min:sanitizeKeyAndAddUniqueness */] = dataSanitizeKeyAndAddUniqueness, DataSanitizer_a.sanitizeKey = dataSanitizeKey, DataSanitizer_a.sanitizeString = dataSanitizeString, DataSanitizer_a.sanitizeUrl = dataSanitizeUrl, DataSanitizer_a.sanitizeMessage = dataSanitizeMessage, DataSanitizer_a[_DYN_SANITIZE_EXCEPTION /* @min:sanitizeException */] = dataSanitizeException, DataSanitizer_a[_DYN_SANITIZE_PROPERTIES /* @min:sanitizeProperties */] = dataSanitizeProperties, DataSanitizer_a[_DYN_SANITIZE_MEASUREMENT3 /* @min:sanitizeMeasurements */] = dataSanitizeMeasurements, DataSanitizer_a.sanitizeId = dataSanitizeId, DataSanitizer_a.sanitizeInput = dataSanitizeInput, DataSanitizer_a.padNumber = dsPadNumber, DataSanitizer_a.trim = HelperFuncs_strTrim, DataSanitizer_a);
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/TelemetryItemCreator.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/**
 * Create a telemetry item that the 1DS channel understands
 * @param item domain specific properties; part B
 * @param baseType telemetry item type. ie PageViewData
 * @param envelopeName name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
 * @param customProperties user defined custom properties; part C
 * @param systemProperties system properties that are added to the context; part A
 * @returns ITelemetryItem that is sent to channel
 */
function createTelemetryItem(item, baseType, envelopeName, logger, customProperties, systemProperties) {
  var _a;
  envelopeName = dataSanitizeString(logger, envelopeName) || strNotSpecified;
  if (isNullOrUndefined(item) || isNullOrUndefined(baseType) || isNullOrUndefined(envelopeName)) {
    throwError("Input doesn't contain all required fields");
  }
  var iKey = "";
  if (item[strIkey]) {
    iKey = item[strIkey];
    delete item[strIkey];
  }
  var telemetryItem = (_a = {}, _a[dist_esm_DynamicConstants_DYN_NAME /* @min:name */] = envelopeName, _a.time = toISOString(new Date()), _a.iKey = iKey, _a.ext = systemProperties ? systemProperties : {}, _a.tags = [], _a.data = {}, _a.baseType = baseType, _a.baseData = item // Part B
  , _a);
  // Part C
  if (!isNullOrUndefined(customProperties)) {
    HelperFuncs_objForEachKey(customProperties, function (prop, value) {
      telemetryItem.data[prop] = value;
    });
  }
  return telemetryItem;
}
var TelemetryItemCreator = /** @class */function () {
  function TelemetryItemCreator() {}
  /**
   * Create a telemetry item that the 1DS channel understands
   * @param item domain specific properties; part B
   * @param baseType telemetry item type. ie PageViewData
   * @param envelopeName name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
   * @param customProperties user defined custom properties; part C
   * @param systemProperties system properties that are added to the context; part A
   * @returns ITelemetryItem that is sent to channel
   */
  TelemetryItemCreator.create = createTelemetryItem;
  return TelemetryItemCreator;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Event.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var Event_Event = /** @class */function () {
  /**
   * Constructs a new instance of the EventTelemetry object
   */
  function Event(logger, name, properties, measurements) {
    this.aiDataContract = {
      ver: 1 /* FieldType.Required */,
      name: 1 /* FieldType.Required */,
      properties: 0 /* FieldType.Default */,
      measurements: 0 /* FieldType.Default */
    };

    var _self = this;
    _self.ver = 2;
    _self[dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
    _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
    _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
  }
  Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
  Event.dataType = "EventData";
  return Event;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Trace.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var Trace = /** @class */function () {
  /**
   * Constructs a new instance of the TraceTelemetry object
   */
  function Trace(logger, message, severityLevel, properties, measurements) {
    this.aiDataContract = {
      ver: 1 /* FieldType.Required */,
      message: 1 /* FieldType.Required */,
      severityLevel: 0 /* FieldType.Default */,
      properties: 0 /* FieldType.Default */
    };

    var _self = this;
    _self.ver = 2;
    message = message || strNotSpecified;
    _self[_DynamicConstants_DYN_MESSAGE /* @min:%2emessage */] = dataSanitizeMessage(logger, message);
    _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
    _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    if (severityLevel) {
      _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = severityLevel;
    }
  }
  Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
  Trace.dataType = "MessageData";
  return Trace;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Common/DataPoint.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var DataPoint = /** @class */function () {
  function DataPoint() {
    /**
     * The data contract for serializing this object.
     */
    this.aiDataContract = {
      name: 1 /* FieldType.Required */,
      kind: 0 /* FieldType.Default */,
      value: 1 /* FieldType.Required */,
      count: 0 /* FieldType.Default */,
      min: 0 /* FieldType.Default */,
      max: 0 /* FieldType.Default */,
      stdDev: 0 /* FieldType.Default */
    };
    /**
     * Metric type. Single measurement or the aggregated value.
     */
    this.kind = 0 /* DataPointType.Measurement */;
  }

  return DataPoint;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Metric.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var Metric = /** @class */function () {
  /**
   * Constructs a new instance of the MetricTelemetry object
   */
  function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
    this.aiDataContract = {
      ver: 1 /* FieldType.Required */,
      metrics: 1 /* FieldType.Required */,
      properties: 0 /* FieldType.Default */
    };

    var _self = this;
    _self.ver = 2;
    var dataPoint = new DataPoint();
    dataPoint[_DYN_COUNT /* @min:%2ecount */] = count > 0 ? count : undefined;
    dataPoint.max = isNaN(max) || max === null ? undefined : max;
    dataPoint.min = isNaN(min) || min === null ? undefined : min;
    dataPoint[dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
    dataPoint.value = value;
    dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
    _self.metrics = [dataPoint];
    _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
    _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
  }
  Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
  Metric.dataType = "MetricData";
  return Metric;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/PageView.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var PageView = /** @class */function () {
  /**
   * Constructs a new instance of the PageEventTelemetry object
   */
  function PageView(logger, name, url, durationMs, properties, measurements, id) {
    this.aiDataContract = {
      ver: 1 /* FieldType.Required */,
      name: 0 /* FieldType.Default */,
      url: 0 /* FieldType.Default */,
      duration: 0 /* FieldType.Default */,
      properties: 0 /* FieldType.Default */,
      measurements: 0 /* FieldType.Default */,
      id: 0 /* FieldType.Default */
    };

    var _self = this;
    _self.ver = 2;
    _self.id = dataSanitizeId(logger, id);
    _self.url = dataSanitizeUrl(logger, url);
    _self[dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
    if (!isNaN(durationMs)) {
      _self[_DYN_DURATION /* @min:%2eduration */] = msToTimeSpan(durationMs);
    }
    _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
    _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
  }
  PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
  PageView.dataType = "PageviewData";
  return PageView;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/PageViewPerformance.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var PageViewPerformance = /** @class */function () {
  /**
   * Constructs a new instance of the PageEventTelemetry object
   */
  function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
    this.aiDataContract = {
      ver: 1 /* FieldType.Required */,
      name: 0 /* FieldType.Default */,
      url: 0 /* FieldType.Default */,
      duration: 0 /* FieldType.Default */,
      perfTotal: 0 /* FieldType.Default */,
      networkConnect: 0 /* FieldType.Default */,
      sentRequest: 0 /* FieldType.Default */,
      receivedResponse: 0 /* FieldType.Default */,
      domProcessing: 0 /* FieldType.Default */,
      properties: 0 /* FieldType.Default */,
      measurements: 0 /* FieldType.Default */
    };

    var _self = this;
    _self.ver = 2;
    _self.url = dataSanitizeUrl(logger, url);
    _self[dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
    _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
    _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    if (cs4BaseData) {
      _self.domProcessing = cs4BaseData.domProcessing;
      _self[_DYN_DURATION /* @min:%2eduration */] = cs4BaseData[_DYN_DURATION /* @min:%2eduration */];
      _self.networkConnect = cs4BaseData.networkConnect;
      _self.perfTotal = cs4BaseData.perfTotal;
      _self[_DYN_RECEIVED_RESPONSE /* @min:%2ereceivedResponse */] = cs4BaseData[_DYN_RECEIVED_RESPONSE /* @min:%2ereceivedResponse */];
      _self.sentRequest = cs4BaseData.sentRequest;
    }
  }
  PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
  PageViewPerformance.dataType = "PageviewPerformanceData";
  return PageViewPerformance;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Exception.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var NoMethod = "<no_method>";
var strError = "error";
var strStack = "stack";
var strStackDetails = "stackDetails";
var strErrorSrc = "errorSrc";
var strMessage = "message";
var strDescription = "description";
function _stringify(value, convertToString) {
  var result = value;
  if (result && !HelperFuncs_isString(result)) {
    if (JSON && JSON[_DYN_STRINGIFY /* @min:%2estringify */]) {
      result = JSON[_DYN_STRINGIFY /* @min:%2estringify */](value);
      if (convertToString && (!result || result === "{}")) {
        if (HelperFuncs_isFunction(value[_DYN_TO_STRING /* @min:%2etoString */])) {
          result = value[_DYN_TO_STRING /* @min:%2etoString */]();
        } else {
          result = "" + value;
        }
      }
    } else {
      result = "" + value + " - (Missing JSON.stringify)";
    }
  }
  return result || "";
}
function _formatMessage(theEvent, errorType) {
  var evtMessage = theEvent;
  if (theEvent) {
    if (evtMessage && !HelperFuncs_isString(evtMessage)) {
      evtMessage = theEvent[strMessage] || theEvent[strDescription] || evtMessage;
    }
    // Make sure the message is a string
    if (evtMessage && !HelperFuncs_isString(evtMessage)) {
      // tslint:disable-next-line: prefer-conditional-expression
      evtMessage = _stringify(evtMessage, true);
    }
    if (theEvent["filename"]) {
      // Looks like an event object with filename
      evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
    }
  }
  // Automatically add the error type to the message if it does already appear to be present
  if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (evtMessage || "")[dist_esm_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */](errorType) === -1) {
    evtMessage = errorType + ": " + evtMessage;
  }
  return evtMessage || "";
}
function _isExceptionDetailsInternal(value) {
  try {
    if (isObject(value)) {
      return "hasFullStack" in value && "typeName" in value;
    }
  } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
  }
  return false;
}
function _isExceptionInternal(value) {
  try {
    if (isObject(value)) {
      return "ver" in value && "exceptions" in value && "properties" in value;
    }
  } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
  }
  return false;
}
function _isStackDetails(details) {
  return details && details.src && HelperFuncs_isString(details.src) && details.obj && HelperFuncs_isArray(details.obj);
}
function _convertStackObj(errorStack) {
  var src = errorStack || "";
  if (!HelperFuncs_isString(src)) {
    if (HelperFuncs_isString(src[strStack])) {
      src = src[strStack];
    } else {
      src = "" + src;
    }
  }
  var items = src[_DynamicConstants_DYN_SPLIT /* @min:%2esplit */]("\n");
  return {
    src: src,
    obj: items
  };
}
function _getOperaStack(errorMessage) {
  var stack = [];
  var lines = errorMessage[_DynamicConstants_DYN_SPLIT /* @min:%2esplit */]("\n");
  for (var lp = 0; lp < lines[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
    var entry = lines[lp];
    if (lines[lp + 1]) {
      entry += "@" + lines[lp + 1];
      lp++;
    }
    stack.push(entry);
  }
  return {
    src: errorMessage,
    obj: stack
  };
}
function _getStackFromErrorObj(errorObj) {
  var details = null;
  if (errorObj) {
    try {
      /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
      notation for undefined objects and we don't want to loose the error from being reported */
      if (errorObj[strStack]) {
        // Chrome/Firefox
        details = _convertStackObj(errorObj[strStack]);
      } else if (errorObj[strError] && errorObj[strError][strStack]) {
        // Edge error event provides the stack and error object
        details = _convertStackObj(errorObj[strError][strStack]);
      } else if (errorObj["exception"] && errorObj.exception[strStack]) {
        details = _convertStackObj(errorObj.exception[strStack]);
      } else if (_isStackDetails(errorObj)) {
        details = errorObj;
      } else if (_isStackDetails(errorObj[strStackDetails])) {
        details = errorObj[strStackDetails];
      } else if (window && window["opera"] && errorObj[strMessage]) {
        // Opera
        details = _getOperaStack(errorObj[_DynamicConstants_DYN_MESSAGE /* @min:%2emessage */]);
      } else if (errorObj["reason"] && errorObj.reason[strStack]) {
        // UnhandledPromiseRejection
        details = _convertStackObj(errorObj.reason[strStack]);
      } else if (HelperFuncs_isString(errorObj)) {
        details = _convertStackObj(errorObj);
      } else {
        var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
        if (HelperFuncs_isString(errorObj[strErrorSrc])) {
          if (evtMessage) {
            evtMessage += "\n";
          }
          evtMessage += " from " + errorObj[strErrorSrc];
        }
        if (evtMessage) {
          details = _convertStackObj(evtMessage);
        }
      }
    } catch (e) {
      // something unexpected happened so to avoid failing to report any error lets swallow the exception
      // and fallback to the callee/caller method
      details = _convertStackObj(e);
    }
  }
  return details || {
    src: "",
    obj: null
  };
}
function _formatStackTrace(stackDetails) {
  var stack = "";
  if (stackDetails) {
    if (stackDetails.obj) {
      HelperFuncs_arrForEach(stackDetails.obj, function (entry) {
        stack += entry + "\n";
      });
    } else {
      stack = stackDetails.src || "";
    }
  }
  return stack;
}
function _parseStack(stack) {
  var parsedStack;
  var frames = stack.obj;
  if (frames && frames[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
    parsedStack = [];
    var level_1 = 0;
    var totalSizeInBytes_1 = 0;
    HelperFuncs_arrForEach(frames, function (frame) {
      var theFrame = frame[_DYN_TO_STRING /* @min:%2etoString */]();
      if (_StackFrame.regex.test(theFrame)) {
        var parsedFrame = new _StackFrame(theFrame, level_1++);
        totalSizeInBytes_1 += parsedFrame[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
        parsedStack.push(parsedFrame);
      }
    });
    // DP Constraint - exception parsed stack must be < 32KB
    // remove frames from the middle to meet the threshold
    var exceptionParsedStackThreshold = 32 * 1024;
    if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
      var left = 0;
      var right = parsedStack[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 1;
      var size = 0;
      var acceptedLeft = left;
      var acceptedRight = right;
      while (left < right) {
        // check size
        var lSize = parsedStack[left][_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
        var rSize = parsedStack[right][_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
        size += lSize + rSize;
        if (size > exceptionParsedStackThreshold) {
          // remove extra frames from the middle
          var howMany = acceptedRight - acceptedLeft + 1;
          parsedStack.splice(acceptedLeft, howMany);
          break;
        }
        // update pointers
        acceptedLeft = left;
        acceptedRight = right;
        left++;
        right--;
      }
    }
  }
  return parsedStack;
}
function _getErrorType(errorType) {
  // Gets the Error Type by passing the constructor (used to get the true type of native error object).
  var typeName = "";
  if (errorType) {
    typeName = errorType.typeName || errorType[dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */] || "";
    if (!typeName) {
      try {
        var funcNameRegex = /function (.{1,200})\(/;
        var results = funcNameRegex.exec(errorType.constructor[_DYN_TO_STRING /* @min:%2etoString */]());
        typeName = results && results[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 1 ? results[1] : "";
      } catch (e) {
        // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
      }
    }
  }
  return typeName;
}
/**
 * Formats the provided errorObj for display and reporting, it may be a String, Object, integer or undefined depending on the browser.
 * @param errorObj The supplied errorObj
 */
function _formatErrorCode(errorObj) {
  if (errorObj) {
    try {
      if (!HelperFuncs_isString(errorObj)) {
        var errorType = _getErrorType(errorObj);
        var result = _stringify(errorObj, false);
        if (!result || result === "{}") {
          if (errorObj[strError]) {
            // Looks like an MS Error Event
            errorObj = errorObj[strError];
            errorType = _getErrorType(errorObj);
          }
          result = _stringify(errorObj, true);
        }
        if (result[dist_esm_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */](errorType) !== 0 && errorType !== "String") {
          return errorType + ":" + result;
        }
        return result;
      }
    } catch (e) {
      // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
    }
  }
  // Fallback to just letting the object format itself into a string
  return "" + (errorObj || "");
}
var Exception = /** @class */function () {
  /**
   * Constructs a new instance of the ExceptionTelemetry object
   */
  function Exception(logger, exception, properties, measurements, severityLevel, id) {
    this.aiDataContract = {
      ver: 1 /* FieldType.Required */,
      exceptions: 1 /* FieldType.Required */,
      severityLevel: 0 /* FieldType.Default */,
      properties: 0 /* FieldType.Default */,
      measurements: 0 /* FieldType.Default */
    };

    var _self = this;
    _self.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
    if (!_isExceptionInternal(exception)) {
      if (!properties) {
        properties = {};
      }
      _self[_DYN_EXCEPTIONS /* @min:%2eexceptions */] = [new _ExceptionDetails(logger, exception, properties)];
      _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
      _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
      if (severityLevel) {
        _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = severityLevel;
      }
      if (id) {
        _self.id = id;
      }
    } else {
      _self[_DYN_EXCEPTIONS /* @min:%2eexceptions */] = exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */] || [];
      _self[_DYN_PROPERTIES /* @min:%2eproperties */] = exception[_DYN_PROPERTIES /* @min:%2eproperties */];
      _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = exception[_DYN_MEASUREMENTS /* @min:%2emeasurements */];
      if (exception[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */]) {
        _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = exception[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */];
      }

      if (exception.id) {
        _self.id = exception.id;
      }
      if (exception[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */]) {
        _self[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */] = exception[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */];
      }
      // bool/int types, use isNullOrUndefined
      if (!isNullOrUndefined(exception[_DYN_IS_MANUAL /* @min:%2eisManual */])) {
        _self[_DYN_IS_MANUAL /* @min:%2eisManual */] = exception[_DYN_IS_MANUAL /* @min:%2eisManual */];
      }
    }
  }

  Exception.CreateAutoException = function (message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
    var _a;
    var errorType = _getErrorType(error || evt || message);
    return _a = {}, _a[_DynamicConstants_DYN_MESSAGE /* @min:message */] = _formatMessage(message, errorType), _a.url = url, _a.lineNumber = lineNumber, _a.columnNumber = columnNumber, _a.error = _formatErrorCode(error || evt || message), _a.evt = _formatErrorCode(evt || message), _a[_DYN_TYPE_NAME /* @min:typeName */] = errorType, _a.stackDetails = _getStackFromErrorObj(stack || error || evt), _a.errorSrc = errorSrc, _a;
  };
  Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
    var exceptions = exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */] && arrMap(exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */], function (ex) {
      return _ExceptionDetails[_DYN__CREATE_FROM_INTERFA1 /* @min:%2eCreateFromInterface */](logger, ex);
    });
    var exceptionData = new Exception(logger, __assignFn(__assignFn({}, exception), {
      exceptions: exceptions
    }), properties, measurements);
    return exceptionData;
  };
  Exception.prototype.toInterface = function () {
    var _a;
    var _b = this,
      exceptions = _b.exceptions,
      properties = _b.properties,
      measurements = _b.measurements,
      severityLevel = _b.severityLevel,
      problemGroup = _b.problemGroup,
      id = _b.id,
      isManual = _b.isManual;
    var exceptionDetailsInterface = exceptions instanceof Array && arrMap(exceptions, function (exception) {
      return exception.toInterface();
    }) || undefined;
    return _a = {
      ver: "4.0"
    }, _a[_DYN_EXCEPTIONS /* @min:exceptions */] = exceptionDetailsInterface, _a.severityLevel = severityLevel, _a.properties = properties, _a.measurements = measurements, _a.problemGroup = problemGroup, _a.id = id, _a.isManual = isManual, _a;
  };
  /**
   * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
   */
  Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
    var _a;
    return {
      exceptions: [(_a = {}, _a[_DYN_HAS_FULL_STACK /* @min:hasFullStack */] = true, _a.message = message, _a.stack = details, _a.typeName = typeName, _a)]
    };
  };
  Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
  Exception.dataType = "ExceptionData";
  Exception.formatError = _formatErrorCode;
  return Exception;
}();

var _ExceptionDetails = /** @class */function () {
  function _ExceptionDetails(logger, exception, properties) {
    this.aiDataContract = {
      id: 0 /* FieldType.Default */,
      outerId: 0 /* FieldType.Default */,
      typeName: 1 /* FieldType.Required */,
      message: 1 /* FieldType.Required */,
      hasFullStack: 0 /* FieldType.Default */,
      stack: 0 /* FieldType.Default */,
      parsedStack: 2 /* FieldType.Array */
    };

    var _self = this;
    if (!_isExceptionDetailsInternal(exception)) {
      var error = exception;
      var evt = error && error.evt;
      if (!isError(error)) {
        error = error[strError] || evt || error;
      }
      _self[_DYN_TYPE_NAME /* @min:%2etypeName */] = dataSanitizeString(logger, _getErrorType(error)) || strNotSpecified;
      _self[_DynamicConstants_DYN_MESSAGE /* @min:%2emessage */] = dataSanitizeMessage(logger, _formatMessage(exception || error, _self[_DYN_TYPE_NAME /* @min:%2etypeName */])) || strNotSpecified;
      var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
      _self[_DYN_PARSED_STACK /* @min:%2eparsedStack */] = _parseStack(stack);
      _self[strStack] = dataSanitizeException(logger, _formatStackTrace(stack));
      _self.hasFullStack = HelperFuncs_isArray(_self.parsedStack) && _self.parsedStack[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0;
      if (properties) {
        properties[_DYN_TYPE_NAME /* @min:%2etypeName */] = properties[_DYN_TYPE_NAME /* @min:%2etypeName */] || _self[_DYN_TYPE_NAME /* @min:%2etypeName */];
      }
    } else {
      _self[_DYN_TYPE_NAME /* @min:%2etypeName */] = exception[_DYN_TYPE_NAME /* @min:%2etypeName */];
      _self[_DynamicConstants_DYN_MESSAGE /* @min:%2emessage */] = exception[_DynamicConstants_DYN_MESSAGE /* @min:%2emessage */];
      _self[strStack] = exception[strStack];
      _self[_DYN_PARSED_STACK /* @min:%2eparsedStack */] = exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */] || [];
      _self[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */] = exception[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */];
    }
  }

  _ExceptionDetails.prototype.toInterface = function () {
    var _a;
    var _self = this;
    var parsedStack = _self[_DYN_PARSED_STACK /* @min:%2eparsedStack */] instanceof Array && arrMap(_self[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) {
      return frame.toInterface();
    });
    var exceptionDetailsInterface = (_a = {
      id: _self.id,
      outerId: _self.outerId,
      typeName: _self[_DYN_TYPE_NAME /* @min:%2etypeName */],
      message: _self[_DynamicConstants_DYN_MESSAGE /* @min:%2emessage */],
      hasFullStack: _self[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */],
      stack: _self[strStack]
    }, _a[_DYN_PARSED_STACK /* @min:parsedStack */] = parsedStack || undefined, _a);
    return exceptionDetailsInterface;
  };
  _ExceptionDetails.CreateFromInterface = function (logger, exception) {
    var parsedStack = exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */] instanceof Array && arrMap(exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) {
      return _StackFrame[_DYN__CREATE_FROM_INTERFA1 /* @min:%2eCreateFromInterface */](frame);
    }) || exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */];
    var exceptionDetails = new _ExceptionDetails(logger, __assignFn(__assignFn({}, exception), {
      parsedStack: parsedStack
    }));
    return exceptionDetails;
  };
  return _ExceptionDetails;
}();

var _StackFrame = /** @class */function () {
  function _StackFrame(sourceFrame, level) {
    this.aiDataContract = {
      level: 1 /* FieldType.Required */,
      method: 1 /* FieldType.Required */,
      assembly: 0 /* FieldType.Default */,
      fileName: 0 /* FieldType.Default */,
      line: 0 /* FieldType.Default */
    };

    var _self = this;
    _self[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] = 0;
    // Not converting this to isString() as typescript uses this logic to "understand" the different
    // types for the 2 different code paths
    if (typeof sourceFrame === "string") {
      var frame = sourceFrame;
      _self[_DYN_LEVEL /* @min:%2elevel */] = level;
      _self[_DYN_METHOD /* @min:%2emethod */] = NoMethod;
      _self[_DYN_ASSEMBLY /* @min:%2eassembly */] = HelperFuncs_strTrim(frame);
      _self[_DYN_FILE_NAME /* @min:%2efileName */] = "";
      _self[_DYN_LINE /* @min:%2eline */] = 0;
      var matches = frame.match(_StackFrame.regex);
      if (matches && matches[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] >= 5) {
        _self[_DYN_METHOD /* @min:%2emethod */] = HelperFuncs_strTrim(matches[2]) || _self[_DYN_METHOD /* @min:%2emethod */];
        _self[_DYN_FILE_NAME /* @min:%2efileName */] = HelperFuncs_strTrim(matches[4]);
        _self[_DYN_LINE /* @min:%2eline */] = parseInt(matches[5]) || 0;
      }
    } else {
      _self[_DYN_LEVEL /* @min:%2elevel */] = sourceFrame[_DYN_LEVEL /* @min:%2elevel */];
      _self[_DYN_METHOD /* @min:%2emethod */] = sourceFrame[_DYN_METHOD /* @min:%2emethod */];
      _self[_DYN_ASSEMBLY /* @min:%2eassembly */] = sourceFrame[_DYN_ASSEMBLY /* @min:%2eassembly */];
      _self[_DYN_FILE_NAME /* @min:%2efileName */] = sourceFrame[_DYN_FILE_NAME /* @min:%2efileName */];
      _self[_DYN_LINE /* @min:%2eline */] = sourceFrame[_DYN_LINE /* @min:%2eline */];
      _self[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] = 0;
    }
    _self.sizeInBytes += _self.method[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    _self.sizeInBytes += _self.fileName[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    _self.sizeInBytes += _self.assembly[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    // todo: these might need to be removed depending on how the back-end settles on their size calculation
    _self[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] += _StackFrame.baseSize;
    _self.sizeInBytes += _self.level.toString()[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    _self.sizeInBytes += _self.line.toString()[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
  }

  _StackFrame.CreateFromInterface = function (frame) {
    return new _StackFrame(frame, null /* level is available in frame interface */);
  };

  _StackFrame.prototype.toInterface = function () {
    var _self = this;
    return {
      level: _self[_DYN_LEVEL /* @min:%2elevel */],
      method: _self[_DYN_METHOD /* @min:%2emethod */],
      assembly: _self[_DYN_ASSEMBLY /* @min:%2eassembly */],
      fileName: _self[_DYN_FILE_NAME /* @min:%2efileName */],
      line: _self[_DYN_LINE /* @min:%2eline */]
    };
  };
  // regex to match stack frames from ie/chrome/ff
  // methodName=$2, fileName=$4, lineNo=$5, column=$6
  _StackFrame.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
  _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
  return _StackFrame;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/DomHelperFuncs.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


function createDomEvent(eventName) {
  var event = null;
  if (HelperFuncs_isFunction(Event)) {
    // Use Event constructor when available
    event = new Event(eventName);
  } else {
    // Event has no constructor in IE
    var doc = EnvUtils_getDocument();
    if (doc && doc.createEvent) {
      event = doc.createEvent("Event");
      event.initEvent(eventName, true, true);
    }
  }
  return event;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/RequestResponseHeaders.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var RequestHeaders = createValueMap({
  requestContextHeader: [0 /* eRequestHeaders.requestContextHeader */, "Request-Context"],
  requestContextTargetKey: [1 /* eRequestHeaders.requestContextTargetKey */, "appId"],
  requestContextAppIdFormat: [2 /* eRequestHeaders.requestContextAppIdFormat */, "appId=cid-v1:"],
  requestIdHeader: [3 /* eRequestHeaders.requestIdHeader */, "Request-Id"],
  traceParentHeader: [4 /* eRequestHeaders.traceParentHeader */, "traceparent"],
  traceStateHeader: [5 /* eRequestHeaders.traceStateHeader */, "tracestate"],
  sdkContextHeader: [6 /* eRequestHeaders.sdkContextHeader */, "Sdk-Context"],
  sdkContextHeaderAppIdRequest: [7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */, "appId"],
  requestContextHeaderLowerCase: [8 /* eRequestHeaders.requestContextHeaderLowerCase */, "request-context"]
});
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/UrlHelperFuncs.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var _document = EnvUtils_getDocument() || {};
var _htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var _htmlAnchorElement = [null, null, null, null, null];
function urlParseUrl(url) {
  var anchorIdx = _htmlAnchorIdx;
  var anchorCache = _htmlAnchorElement;
  var tempAnchor = anchorCache[anchorIdx];
  if (!_document.createElement) {
    // Always create the temp instance if createElement is not available
    tempAnchor = {
      host: urlParseHost(url, true)
    };
  } else if (!anchorCache[anchorIdx]) {
    // Create and cache the unattached anchor instance
    tempAnchor = anchorCache[anchorIdx] = _document.createElement("a");
  }
  tempAnchor.href = url;
  // Move the cache index forward
  anchorIdx++;
  if (anchorIdx >= anchorCache[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
    anchorIdx = 0;
  }
  _htmlAnchorIdx = anchorIdx;
  return tempAnchor;
}
function urlGetAbsoluteUrl(url) {
  var result;
  var a = urlParseUrl(url);
  if (a) {
    result = a.href;
  }
  return result;
}
function urlGetPathName(url) {
  var result;
  var a = urlParseUrl(url);
  if (a) {
    result = a[_DYN_PATHNAME /* @min:%2epathname */];
  }

  return result;
}
function urlGetCompleteUrl(method, absoluteUrl) {
  if (method) {
    return method.toUpperCase() + " " + absoluteUrl;
  }
  return absoluteUrl;
}
// Fallback method to grab host from url if document.createElement method is not available
function urlParseHost(url, inclPort) {
  var fullHost = urlParseFullHost(url, inclPort) || "";
  if (fullHost) {
    var match = fullHost.match(/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
    if (match != null && match[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 3 && HelperFuncs_isString(match[2]) && match[2][dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
      return match[2] + (match[3] || "");
    }
  }
  return fullHost;
}
function urlParseFullHost(url, inclPort) {
  var result = null;
  if (url) {
    var match = url.match(/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
    if (match != null && match[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 2 && HelperFuncs_isString(match[2]) && match[2][dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
      result = match[2] || "";
      if (inclPort && match[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 2) {
        var protocol = (match[1] || "")[dist_esm_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
        var port = match[3] || "";
        // IE includes the standard port so pass it off if it's the same as the protocol
        if (protocol === "http" && port === ":80") {
          port = "";
        } else if (protocol === "https" && port === ":443") {
          port = "";
        }
        result += port;
      }
    }
  }
  return result;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Util.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */










// listing only non-geo specific locations
var _internalEndpoints = [DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH, "https://breeze.aimon.applicationinsights.io" + DEFAULT_BREEZE_PATH, "https://dc-int.services.visualstudio.com" + DEFAULT_BREEZE_PATH];
function isInternalApplicationInsightsEndpoint(endpointUrl) {
  return arrIndexOf(_internalEndpoints, endpointUrl[dist_esm_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]()) !== -1;
}
var Util = {
  NotSpecified: strNotSpecified,
  createDomEvent: createDomEvent,
  disableStorage: utlDisableStorage,
  isInternalApplicationInsightsEndpoint: isInternalApplicationInsightsEndpoint,
  canUseLocalStorage: utlCanUseLocalStorage,
  getStorage: utlGetLocalStorage,
  setStorage: utlSetLocalStorage,
  removeStorage: utlRemoveStorage,
  canUseSessionStorage: utlCanUseSessionStorage,
  getSessionStorageKeys: utlGetSessionStorageKeys,
  getSessionStorage: utlGetSessionStorage,
  setSessionStorage: utlSetSessionStorage,
  removeSessionStorage: utlRemoveSessionStorage,
  disableCookies: disableCookies,
  canUseCookies: canUseCookies,
  disallowsSameSiteNone: uaDisallowsSameSiteNone,
  setCookie: setCookie,
  stringToBoolOrDefault: stringToBoolOrDefault,
  getCookie: getCookie,
  deleteCookie: deleteCookie,
  trim: HelperFuncs_strTrim,
  newId: newId,
  random32: function () {
    return random32(true);
  },
  generateW3CId: generateW3CId,
  isArray: HelperFuncs_isArray,
  isError: isError,
  isDate: isDate,
  toISOStringForIE8: toISOString,
  getIEVersion: getIEVersion,
  msToTimeSpan: msToTimeSpan,
  isCrossOriginError: isCrossOriginError,
  dump: dumpObj,
  getExceptionName: getExceptionName,
  addEventHandler: attachEvent,
  IsBeaconApiSupported: isBeaconsSupported,
  getExtension: getExtensionByName
};
var UrlHelper = {
  parseUrl: urlParseUrl,
  getAbsoluteUrl: urlGetAbsoluteUrl,
  getPathName: urlGetPathName,
  getCompleteUrl: urlGetCompleteUrl,
  parseHost: urlParseHost,
  parseFullHost: urlParseFullHost
};
var CorrelationIdHelper = {
  correlationIdPrefix: "cid-v1:",
  /**
   * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
   * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
   * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
   * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
   * manually supply domains to include correlation headers on. Else, no headers will be included at all.
   */
  canIncludeCorrelationHeader: function (config, requestUrl, currentHost) {
    if (!requestUrl || config && config.disableCorrelationHeaders) {
      return false;
    }
    if (config && config[_DYN_CORRELATION_HEADER_E0 /* @min:%2ecorrelationHeaderExcludePatterns */]) {
      for (var i = 0; i < config.correlationHeaderExcludePatterns[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
        if (config[_DYN_CORRELATION_HEADER_E0 /* @min:%2ecorrelationHeaderExcludePatterns */][i].test(requestUrl)) {
          return false;
        }
      }
    }
    var requestHost = urlParseUrl(requestUrl).host[dist_esm_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
    if (requestHost && (requestHost[dist_esm_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */](":443") !== -1 || requestHost[dist_esm_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */](":80") !== -1)) {
      // [Bug #1260] IE can include the port even for http and https URLs so if present
      // try and parse it to remove if it matches the default protocol port
      requestHost = (urlParseFullHost(requestUrl, true) || "")[dist_esm_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
    }

    if ((!config || !config.enableCorsCorrelation) && requestHost && requestHost !== currentHost) {
      return false;
    }
    var includedDomains = config && config.correlationHeaderDomains;
    if (includedDomains) {
      var matchExists_1;
      HelperFuncs_arrForEach(includedDomains, function (domain) {
        var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
        matchExists_1 = matchExists_1 || regex.test(requestHost);
      });
      if (!matchExists_1) {
        return false;
      }
    }
    var excludedDomains = config && config.correlationHeaderExcludedDomains;
    if (!excludedDomains || excludedDomains[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0) {
      return true;
    }
    for (var i = 0; i < excludedDomains[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
      var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
      if (regex.test(requestHost)) {
        return false;
      }
    }
    // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
    // Previously we always returned false for a falsy requestHost
    return requestHost && requestHost[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0;
  },
  /**
   * Combines target appId and target role name from response header.
   */
  getCorrelationContext: function (responseHeader) {
    if (responseHeader) {
      var correlationId = CorrelationIdHelper.getCorrelationContextValue(responseHeader, RequestHeaders[1]);
      if (correlationId && correlationId !== CorrelationIdHelper.correlationIdPrefix) {
        return correlationId;
      }
    }
  },
  /**
   * Gets key from correlation response header
   */
  getCorrelationContextValue: function (responseHeader, key) {
    if (responseHeader) {
      var keyValues = responseHeader[_DynamicConstants_DYN_SPLIT /* @min:%2esplit */](",");
      for (var i = 0; i < keyValues[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; ++i) {
        var keyValue = keyValues[i][_DynamicConstants_DYN_SPLIT /* @min:%2esplit */]("=");
        if (keyValue[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 2 && keyValue[0] === key) {
          return keyValue[1];
        }
      }
    }
  }
};
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
  var target,
    name = commandName,
    data = commandName;
  if (absoluteUrl && absoluteUrl[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
    var parsedUrl = urlParseUrl(absoluteUrl);
    target = parsedUrl.host;
    if (!name) {
      if (parsedUrl[_DYN_PATHNAME /* @min:%2epathname */] != null) {
        var pathName = parsedUrl.pathname[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0 ? "/" : parsedUrl[_DYN_PATHNAME /* @min:%2epathname */];
        if (pathName.charAt(0) !== "/") {
          pathName = "/" + pathName;
        }
        data = parsedUrl[_DYN_PATHNAME /* @min:%2epathname */];
        name = dataSanitizeString(logger, method ? method + " " + pathName : pathName);
      } else {
        name = dataSanitizeString(logger, absoluteUrl);
      }
    }
  } else {
    target = commandName;
    name = commandName;
  }
  return {
    target: target,
    name: name,
    data: data
  };
}
function dateTimeUtilsNow() {
  // returns the window or webworker performance object
  var perf = getPerformance();
  if (perf && perf.now && perf.timing) {
    var now = perf.now() + perf.timing.navigationStart;
    // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
    if (now > 0) {
      return now;
    }
  }
  return dateNow();
}
function dateTimeUtilsDuration(start, end) {
  var result = null;
  if (start !== 0 && end !== 0 && !isNullOrUndefined(start) && !isNullOrUndefined(end)) {
    result = end - start;
  }
  return result;
}
/**
 * A utility class that helps getting time related parameters
 */
var DateTimeUtils = {
  Now: dateTimeUtilsNow,
  GetDuration: dateTimeUtilsDuration
};
/**
 * Creates a IDistributedTraceContext from an optional telemetryTrace
 * @param telemetryTrace - The telemetryTrace instance that is being wrapped
 * @param parentCtx - An optional parent distributed trace instance, almost always undefined as this scenario is only used in the case of multiple property handlers.
 * @returns A new IDistributedTraceContext instance that is backed by the telemetryTrace or temporary object
 */
function createDistributedTraceContextFromTrace(telemetryTrace, parentCtx) {
  var trace = telemetryTrace || {};
  return {
    getName: function () {
      return trace[dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */];
    },

    setName: function (newValue) {
      parentCtx && parentCtx.setName(newValue);
      trace[dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */] = newValue;
    },
    getTraceId: function () {
      return trace.traceID;
    },
    setTraceId: function (newValue) {
      parentCtx && parentCtx.setTraceId(newValue);
      if (isValidTraceId(newValue)) {
        trace.traceID = newValue;
      }
    },
    getSpanId: function () {
      return trace.parentID;
    },
    setSpanId: function (newValue) {
      parentCtx && parentCtx.setSpanId(newValue);
      if (isValidSpanId(newValue)) {
        trace.parentID = newValue;
      }
    },
    getTraceFlags: function () {
      return trace.traceFlags;
    },
    setTraceFlags: function (newTraceFlags) {
      parentCtx && parentCtx.setTraceFlags(newTraceFlags);
      trace.traceFlags = newTraceFlags;
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/RemoteDependencyData.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var RemoteDependencyData = /** @class */function () {
  /**
   * Constructs a new instance of the RemoteDependencyData object
   */
  function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
    if (requestAPI === void 0) {
      requestAPI = "Ajax";
    }
    this.aiDataContract = {
      id: 1 /* FieldType.Required */,
      ver: 1 /* FieldType.Required */,
      name: 0 /* FieldType.Default */,
      resultCode: 0 /* FieldType.Default */,
      duration: 0 /* FieldType.Default */,
      success: 0 /* FieldType.Default */,
      data: 0 /* FieldType.Default */,
      target: 0 /* FieldType.Default */,
      type: 0 /* FieldType.Default */,
      properties: 0 /* FieldType.Default */,
      measurements: 0 /* FieldType.Default */,
      kind: 0 /* FieldType.Default */,
      value: 0 /* FieldType.Default */,
      count: 0 /* FieldType.Default */,
      min: 0 /* FieldType.Default */,
      max: 0 /* FieldType.Default */,
      stdDev: 0 /* FieldType.Default */,
      dependencyKind: 0 /* FieldType.Default */,
      dependencySource: 0 /* FieldType.Default */,
      commandName: 0 /* FieldType.Default */,
      dependencyTypeName: 0 /* FieldType.Default */
    };

    var _self = this;
    _self.ver = 2;
    _self.id = id;
    _self[_DYN_DURATION /* @min:%2eduration */] = msToTimeSpan(value);
    _self.success = success;
    _self.resultCode = resultCode + "";
    _self.type = dataSanitizeString(logger, requestAPI);
    var dependencyFields = AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName);
    _self.data = dataSanitizeUrl(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
    _self.target = dataSanitizeString(logger, dependencyFields.target);
    if (correlationContext) {
      _self.target = "".concat(_self.target, " | ").concat(correlationContext);
    }
    _self[dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */] = dataSanitizeString(logger, dependencyFields[dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */]);
    _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
    _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
  }
  RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
  RemoteDependencyData.dataType = "RemoteDependencyData";
  return RemoteDependencyData;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/InstrumentHooks.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var aiInstrumentHooks = "_aiHooks";
var cbNames = ["req", "rsp", "hkErr", "fnErr"];
/** @ignore */
function _arrLoop(arr, fn) {
  if (arr) {
    for (var lp = 0; lp < arr[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
      if (fn(arr[lp], lp)) {
        break;
      }
    }
  }
}
/** @ignore */
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
  if (type >= 0 /* CallbackType.Request */ && type <= 2 /* CallbackType.HookError */) {
    _arrLoop(hooks, function (hook, idx) {
      var cbks = hook.cbks;
      var cb = cbks[cbNames[type]];
      if (cb) {
        // Set the specific hook context implementation using a lazy creation pattern
        callDetails.ctx = function () {
          var ctx = hookCtx[idx] = hookCtx[idx] || {};
          return ctx;
        };
        try {
          cb[_DYN_APPLY /* @min:%2eapply */](callDetails.inst, cbArgs);
        } catch (err) {
          var orgEx = callDetails.err;
          try {
            // Report Hook error via the callback
            var hookErrorCb = cbks[cbNames[2 /* CallbackType.HookError */]];
            if (hookErrorCb) {
              callDetails.err = err;
              hookErrorCb[_DYN_APPLY /* @min:%2eapply */](callDetails.inst, cbArgs);
            }
          } catch (e) {
            // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
          } finally {
            // restore the original exception (if any)
            callDetails.err = orgEx;
          }
        }
      }
    });
  }
}
/** @ignore */
function _createFunctionHook(aiHook) {
  // Define a temporary method that queues-up a the real method call
  return function () {
    var _a;
    var funcThis = this;
    // Capture the original arguments passed to the method
    var orgArgs = arguments;
    var hooks = aiHook.h;
    var funcArgs = (_a = {}, _a[_DynamicConstants_DYN_NAME /* @min:name */] = aiHook.n, _a.inst = funcThis, _a.ctx = null, _a.set = _replaceArg, _a);
    var hookCtx = [];
    var cbArgs = _createArgs([funcArgs], orgArgs);
    funcArgs.evt = getGlobalInst("event");
    function _createArgs(target, theArgs) {
      _arrLoop(theArgs, function (arg) {
        target[_DynamicConstants_DYN_PUSH /* @min:%2epush */](arg);
      });
      return target;
    }
    function _replaceArg(idx, value) {
      orgArgs = _createArgs([], orgArgs);
      orgArgs[idx] = value;
      cbArgs = _createArgs([funcArgs], orgArgs);
    }
    // Call the pre-request hooks
    _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* CallbackType.Request */);
    // Call the original function was called
    var theFunc = aiHook.f;
    if (theFunc) {
      try {
        funcArgs.rslt = theFunc[_DYN_APPLY /* @min:%2eapply */](funcThis, orgArgs);
      } catch (err) {
        // Report the request callback
        funcArgs.err = err;
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* CallbackType.FunctionError */);
        // rethrow the original exception so anyone listening for it can catch the exception
        throw err;
      }
    }
    // Call the post-request hooks
    _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* CallbackType.Response */);
    return funcArgs.rslt;
  };
}
/** @ignore */
function _getOwner(target, name, checkPrototype) {
  var owner = null;
  if (target) {
    if (HelperFuncs_hasOwnProperty(target, name)) {
      owner = target;
    } else if (checkPrototype) {
      owner = _getOwner(_getObjProto(target), name, false);
    }
  }
  return owner;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProto(target, funcName, callbacks) {
  if (target) {
    return InstrumentFunc(target[Constants_strShimPrototype], funcName, callbacks, false);
  }
  return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProtos(target, funcNames, callbacks) {
  if (target) {
    return InstrumentFuncs(target[strShimPrototype], funcNames, callbacks, false);
  }
  return null;
}
function _createInstrumentHook(owner, funcName, fn, callbacks) {
  var aiHook = fn && fn[aiInstrumentHooks];
  if (!aiHook) {
    // Only hook the function once
    aiHook = {
      i: 0,
      n: funcName,
      f: fn,
      h: []
    };
    // Override (hook) the original function
    var newFunc = _createFunctionHook(aiHook);
    newFunc[aiInstrumentHooks] = aiHook; // Tag and store the function hooks
    owner[funcName] = newFunc;
  }
  var theHook = {
    // tslint:disable:object-literal-shorthand
    id: aiHook.i,
    cbks: callbacks,
    rm: function () {
      // DO NOT Use () => { shorthand for the function as the this gets replaced
      // with the outer this and not the this for theHook instance.
      var id = this.id;
      _arrLoop(aiHook.h, function (hook, idx) {
        if (hook.id === id) {
          aiHook.h[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
          return 1;
        }
      });
    }
    // tslint:enable:object-literal-shorthand
  };

  aiHook.i++;
  aiHook.h[_DynamicConstants_DYN_PUSH /* @min:%2epush */](theHook);
  return theHook;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFunc(target, funcName, callbacks, checkPrototype) {
  if (checkPrototype === void 0) {
    checkPrototype = true;
  }
  if (target && funcName && callbacks) {
    var owner = _getOwner(target, funcName, checkPrototype);
    if (owner) {
      var fn = owner[funcName];
      if (typeof fn === Constants_strShimFunction) {
        return _createInstrumentHook(owner, funcName, fn, callbacks);
      }
    }
  }
  return null;
}
/**
 * Intercept the named functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFuncs(target, funcNames, callbacks, checkPrototype) {
  if (checkPrototype === void 0) {
    checkPrototype = true;
  }
  var hooks = null;
  _arrLoop(funcNames, function (funcName) {
    var hook = InstrumentFunc(target, funcName, callbacks, checkPrototype);
    if (hook) {
      if (!hooks) {
        hooks = [];
      }
      hooks[_DYN_PUSH /* @min:%2epush */](hook);
    }
  });
  return hooks;
}
/**
 * Add an instrumentation hook to the provided named "event" for the target class / object, this doesn't check whether the
 * named "event" is in fact a function and just assigns the instrumentation hook to the target[evtName]
 * @param target - The target object
 * @param evtName - The name of the event
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentEvent(target, evtName, callbacks, checkPrototype) {
  if (target && evtName && callbacks) {
    var owner = _getOwner(target, evtName, checkPrototype) || target;
    if (owner) {
      return _createInstrumentHook(owner, evtName, owner[evtName], callbacks);
    }
  }
  return null;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-analytics-js/dist-esm/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DynamicConstants_DYN_TO_STRING = "toString"; // Count: 4
var _DYN_DISABLE_EXCEPTION_TR0 = "disableExceptionTracking"; // Count: 3
var _DYN_AUTO_TRACK_PAGE_VISI1 = "autoTrackPageVisitTime"; // Count: 4
var _DYN_OVERRIDE_PAGE_VIEW_D2 = "overridePageViewDuration"; // Count: 3
var _DYN_ENABLE_UNHANDLED_PRO3 = "enableUnhandledPromiseRejectionTracking"; // Count: 3
var _DYN_SAMPLING_PERCENTAGE = "samplingPercentage"; // Count: 4
var _DYN_IS_STORAGE_USE_DISAB4 = "isStorageUseDisabled"; // Count: 4
var _DYN_IS_BROWSER_LINK_TRAC5 = "isBrowserLinkTrackingEnabled"; // Count: 4
var _DYN_ENABLE_AUTO_ROUTE_TR6 = "enableAutoRouteTracking"; // Count: 3
var _DYN_NAME_PREFIX = "namePrefix"; // Count: 3
var _DYN_DISABLE_FLUSH_ON_BEF7 = "disableFlushOnBeforeUnload"; // Count: 3
var _DYN_DISABLE_FLUSH_ON_UNL8 = "disableFlushOnUnload"; // Count: 2
var _DYN_CORE = "core"; // Count: 7
var _DYN_DATA_TYPE = "dataType"; // Count: 8
var _DYN_ENVELOPE_TYPE = "envelopeType"; // Count: 7
var _DynamicConstants_DYN_DIAG_LOG = "diagLog"; // Count: 13
var _DYN_TRACK = "track"; // Count: 7
var _DYN_TRACK_PAGE_VIEW = "trackPageView"; // Count: 4
var _DYN_TRACK_PREVIOUS_PAGE_9 = "trackPreviousPageVisit"; // Count: 3
var _DYN_SEND_PAGE_VIEW_INTER10 = "sendPageViewInternal"; // Count: 7
var _DYN_SEND_PAGE_VIEW_PERFO11 = "sendPageViewPerformanceInternal"; // Count: 3
var _DYN_POPULATE_PAGE_VIEW_P12 = "populatePageViewPerformanceEvent"; // Count: 3
var _DYN_HREF = "href"; // Count: 6
var _DYN_SEND_EXCEPTION_INTER13 = "sendExceptionInternal"; // Count: 2
var _DYN_EXCEPTION = "exception"; // Count: 3
var _DYN_ERROR = "error"; // Count: 5
var _DYN__ONERROR = "_onerror"; // Count: 3
var _DYN_ERROR_SRC = "errorSrc"; // Count: 3
var _DYN_LINE_NUMBER = "lineNumber"; // Count: 5
var _DYN_COLUMN_NUMBER = "columnNumber"; // Count: 5
var dist_esm_DynamicConstants_DYN_MESSAGE = "message"; // Count: 4
var _DYN__CREATE_AUTO_EXCEPTI14 = "CreateAutoException"; // Count: 3
var _DYN_ADD_TELEMETRY_INITIA15 = "addTelemetryInitializer"; // Count: 4
var _DynamicConstants_DYN_DURATION = "duration"; // Count: 10
var applicationinsights_analytics_js_dist_esm_DynamicConstants_DYN_LENGTH = "length"; // Count: 5
var _DYN_IS_PERFORMANCE_TIMIN16 = "isPerformanceTimingSupported"; // Count: 2
var _DYN_GET_PERFORMANCE_TIMI17 = "getPerformanceTiming"; // Count: 2
var _DYN_NAVIGATION_START = "navigationStart"; // Count: 4
var _DYN_SHOULD_COLLECT_DURAT18 = "shouldCollectDuration"; // Count: 3
var _DYN_IS_PERFORMANCE_TIMIN19 = "isPerformanceTimingDataReady"; // Count: 2
var _DYN_GET_ENTRIES_BY_TYPE = "getEntriesByType"; // Count: 3
var _DYN_RESPONSE_START = "responseStart"; // Count: 5
var _DYN_REQUEST_START = "requestStart"; // Count: 3
var _DYN_LOAD_EVENT_END = "loadEventEnd"; // Count: 4
var _DYN_RESPONSE_END = "responseEnd"; // Count: 5
var _DYN_CONNECT_END = "connectEnd"; // Count: 4
var _DYN_PAGE_VISIT_START_TIM20 = "pageVisitStartTime"; // Count: 2
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-analytics-js/dist-esm/JavaScriptSDK/Telemetry/PageViewManager.js
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/**
 * Class encapsulates sending page views and page view performance telemetry.
 */
var PageViewManager = /** @class */function () {
  function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
    dynamicProto(PageViewManager, this, function (_self) {
      var intervalHandle = null;
      var itemQueue = [];
      var pageViewPerformanceSent = false;
      var _logger;
      if (core) {
        _logger = core.logger;
      }
      function _flushChannels(isAsync) {
        if (core) {
          core.flush(isAsync);
        }
      }
      function _addQueue(cb) {
        itemQueue.push(cb);
        if (!intervalHandle) {
          intervalHandle = setInterval(function () {
            var allItems = itemQueue.slice(0);
            var doFlush = false;
            itemQueue = [];
            HelperFuncs_arrForEach(allItems, function (item) {
              if (!item()) {
                // Not processed so rescheduled
                itemQueue.push(item);
              } else {
                doFlush = true;
              }
            });
            if (itemQueue[applicationinsights_analytics_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0) {
              clearInterval(intervalHandle);
              intervalHandle = null;
            }
            if (doFlush) {
              // We process at least one item so flush the queue
              _flushChannels(true);
            }
          }, 100);
        }
      }
      _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */] = function (pageView, customProperties) {
        var name = pageView.name;
        if (isNullOrUndefined(name) || typeof name !== "string") {
          var doc = EnvUtils_getDocument();
          name = pageView.name = doc && doc.title || "";
        }
        var uri = pageView.uri;
        if (isNullOrUndefined(uri) || typeof uri !== "string") {
          var location_1 = getLocation();
          uri = pageView.uri = location_1 && location_1[_DYN_HREF /* @min:%2ehref */] || "";
        }
        // case 1a. if performance timing is not supported by the browser, send the page view telemetry with the duration provided by the user. If the user
        // do not provide the duration, set duration to undefined
        // Also this is case 4
        if (!pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN16 /* @min:%2eisPerformanceTimingSupported */]()) {
          appInsights[_DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */](pageView, customProperties);
          _flushChannels(true);
          // no navigation timing (IE 8, iOS Safari 8.4, Opera Mini 8 - see http://caniuse.com/#feat=nav-timing)
          _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 25 /* _eInternalMessageId.NavigationTimingNotSupported */, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
          return;
        }
        var pageViewSent = false;
        var customDuration;
        // if the performance timing is supported by the browser, calculate the custom duration
        var start = pageViewPerformanceManager[_DYN_GET_PERFORMANCE_TIMI17 /* @min:%2egetPerformanceTiming */]()[_DYN_NAVIGATION_START /* @min:%2enavigationStart */];
        if (start > 0) {
          customDuration = dateTimeUtilsDuration(start, +new Date());
          if (!pageViewPerformanceManager[_DYN_SHOULD_COLLECT_DURAT18 /* @min:%2eshouldCollectDuration */](customDuration)) {
            customDuration = undefined;
          }
        }
        // if the user has provided duration, send a page view telemetry with the provided duration. Otherwise, if
        // overridePageViewDuration is set to true, send a page view telemetry with the custom duration calculated earlier
        var duration;
        if (!isNullOrUndefined(customProperties) && !isNullOrUndefined(customProperties[_DynamicConstants_DYN_DURATION /* @min:%2eduration */])) {
          duration = customProperties[_DynamicConstants_DYN_DURATION /* @min:%2eduration */];
        }

        if (overridePageViewDuration || !isNaN(duration)) {
          if (isNaN(duration)) {
            // case 3
            if (!customProperties) {
              customProperties = {};
            }
            customProperties[_DynamicConstants_DYN_DURATION /* @min:%2eduration */] = customDuration;
          }
          // case 2
          appInsights[_DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */](pageView, customProperties);
          _flushChannels(true);
          pageViewSent = true;
        }
        // now try to send the page view performance telemetry
        var maxDurationLimit = 60000;
        if (!customProperties) {
          customProperties = {};
        }
        // Queue the event for processing
        _addQueue(function () {
          var processed = false;
          try {
            if (pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN19 /* @min:%2eisPerformanceTimingDataReady */]()) {
              processed = true;
              var pageViewPerformance = {
                name: name,
                uri: uri
              };
              pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P12 /* @min:%2epopulatePageViewPerformanceEvent */](pageViewPerformance);
              if (!pageViewPerformance.isValid && !pageViewSent) {
                // If navigation timing gives invalid numbers, then go back to "override page view duration" mode.
                // That's the best value we can get that makes sense.
                customProperties[_DynamicConstants_DYN_DURATION /* @min:%2eduration */] = customDuration;
                appInsights[_DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */](pageView, customProperties);
              } else {
                if (!pageViewSent) {
                  customProperties[_DynamicConstants_DYN_DURATION /* @min:%2eduration */] = pageViewPerformance.durationMs;
                  appInsights[_DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                }
                if (!pageViewPerformanceSent) {
                  appInsights[_DYN_SEND_PAGE_VIEW_PERFO11 /* @min:%2esendPageViewPerformanceInternal */](pageViewPerformance, customProperties);
                  pageViewPerformanceSent = true;
                }
              }
            } else if (start > 0 && dateTimeUtilsDuration(start, +new Date()) > maxDurationLimit) {
              // if performance timings are not ready but we exceeded the maximum duration limit, just log a page view telemetry
              // with the maximum duration limit. Otherwise, keep waiting until performance timings are ready
              processed = true;
              if (!pageViewSent) {
                customProperties[_DynamicConstants_DYN_DURATION /* @min:%2eduration */] = maxDurationLimit;
                appInsights[_DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */](pageView, customProperties);
              }
            }
          } catch (e) {
            _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 38 /* _eInternalMessageId.TrackPVFailedCalc */, "trackPageView failed on page load calculation: " + getExceptionName(e), {
              exception: dumpObj(e)
            });
          }
          return processed;
        });
      };
      _self.teardown = function (unloadCtx, unloadState) {
        if (intervalHandle) {
          clearInterval(intervalHandle);
          intervalHandle = null;
          var allItems = itemQueue.slice(0);
          var doFlush_1 = false;
          itemQueue = [];
          HelperFuncs_arrForEach(allItems, function (item) {
            if (item()) {
              doFlush_1 = true;
            }
          });
        }
      };
    });
  }
  // Removed Stub for PageViewManager.prototype.trackPageView.
  // Removed Stub for PageViewManager.prototype.teardown.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  PageViewManager.__ieDyn = 1;
  return PageViewManager;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-analytics-js/dist-esm/JavaScriptSDK/Telemetry/PageViewPerformanceManager.js
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var MAX_DURATION_ALLOWED = 3600000; // 1h
var botAgentNames = ["googlebot", "adsbot-google", "apis-google", "mediapartners-google"];
function _isPerformanceTimingSupported() {
  var perf = getPerformance();
  return perf && !!perf.timing;
}
function _isPerformanceNavigationTimingSupported() {
  var perf = getPerformance();
  return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[applicationinsights_analytics_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0;
}
function _isPerformanceTimingDataReady() {
  var perf = getPerformance();
  var timing = perf ? perf.timing : 0;
  return timing && timing.domainLookupStart > 0 && timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */] > 0 && timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */] > 0 && timing[_DYN_REQUEST_START /* @min:%2erequestStart */] > 0 && timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */] > 0 && timing[_DYN_RESPONSE_END /* @min:%2eresponseEnd */] > 0 && timing[_DYN_CONNECT_END /* @min:%2econnectEnd */] > 0 && timing.domLoading > 0;
}
function _getPerformanceTiming() {
  if (_isPerformanceTimingSupported()) {
    return getPerformance().timing;
  }
  return null;
}
function _getPerformanceNavigationTiming() {
  if (_isPerformanceNavigationTimingSupported()) {
    return getPerformance()[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */]("navigation")[0];
  }
  return null;
}
/**
* This method tells if given durations should be excluded from collection.
*/
function _shouldCollectDuration() {
  var durations = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    durations[_i] = arguments[_i];
  }
  var _navigator = getNavigator() || {};
  // a full list of Google crawlers user agent strings - https://support.google.com/webmasters/answer/1061943?hl=en
  var userAgent = _navigator.userAgent;
  var isGoogleBot = false;
  if (userAgent) {
    for (var i = 0; i < botAgentNames[applicationinsights_analytics_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
      isGoogleBot = isGoogleBot || userAgent.toLowerCase().indexOf(botAgentNames[i]) !== -1;
    }
  }
  if (isGoogleBot) {
    // Don't report durations for GoogleBot, it is returning invalid values in performance.timing API.
    return false;
  } else {
    // for other page views, don't report if it's outside of a reasonable range
    for (var i = 0; i < durations[applicationinsights_analytics_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
      if (durations[i] < 0 || durations[i] >= MAX_DURATION_ALLOWED) {
        return false;
      }
    }
  }
  return true;
}
/**
 * Class encapsulates sending page view performance telemetry.
 */
var PageViewPerformanceManager = /** @class */function () {
  function PageViewPerformanceManager(core) {
    var _this = this;
    var _logger = safeGetLogger(core);
    dynamicProto(PageViewPerformanceManager, this, function (_self) {
      _self[_DYN_POPULATE_PAGE_VIEW_P12 /* @min:%2epopulatePageViewPerformanceEvent */] = function (pageViewPerformance) {
        pageViewPerformance.isValid = false;
        /*
         * http://www.w3.org/TR/navigation-timing/#processing-model
         *  |-navigationStart
         *  |             |-connectEnd
         *  |             ||-requestStart
         *  |             ||             |-responseStart
         *  |             ||             |              |-responseEnd
         *  |             ||             |              |
         *  |             ||             |              |         |-loadEventEnd
         *  |---network---||---request---|---response---|---dom---|
         *  |--------------------------total----------------------|
         *
         *  total = The difference between the load event of the current document is completed and the first recorded timestamp of the performance entry : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#duration
         *  network = Redirect time + App Cache + DNS lookup time + TCP connection time
         *  request = Request time : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#request_time
         *  response = Response time
         *  dom = Document load time : https://html.spec.whatwg.org/multipage/dom.html#document-load-timing-info
         *      = Document processing time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#document_processing
         *      + Loading time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#loading
         */
        var navigationTiming = _getPerformanceNavigationTiming();
        var timing = _getPerformanceTiming();
        var total = 0;
        var network = 0;
        var request = 0;
        var response = 0;
        var dom = 0;
        if (navigationTiming || timing) {
          if (navigationTiming) {
            total = navigationTiming[_DynamicConstants_DYN_DURATION /* @min:%2eduration */];
            /**
             * support both cases:
             * - startTime is always zero: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
             * - for older browsers where the startTime is not zero
             */
            network = navigationTiming.startTime === 0 ? navigationTiming[_DYN_CONNECT_END /* @min:%2econnectEnd */] : dateTimeUtilsDuration(navigationTiming.startTime, navigationTiming[_DYN_CONNECT_END /* @min:%2econnectEnd */]);
            request = dateTimeUtilsDuration(navigationTiming.requestStart, navigationTiming[_DYN_RESPONSE_START /* @min:%2eresponseStart */]);
            response = dateTimeUtilsDuration(navigationTiming[_DYN_RESPONSE_START /* @min:%2eresponseStart */], navigationTiming[_DYN_RESPONSE_END /* @min:%2eresponseEnd */]);
            dom = dateTimeUtilsDuration(navigationTiming.responseEnd, navigationTiming[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
          } else {
            total = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */], timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
            network = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */], timing[_DYN_CONNECT_END /* @min:%2econnectEnd */]);
            request = dateTimeUtilsDuration(timing.requestStart, timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */]);
            response = dateTimeUtilsDuration(timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */], timing[_DYN_RESPONSE_END /* @min:%2eresponseEnd */]);
            dom = dateTimeUtilsDuration(timing.responseEnd, timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
          }

          if (total === 0) {
            _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 10 /* _eInternalMessageId.ErrorPVCalc */, "error calculating page view performance.", {
              total: total,
              network: network,
              request: request,
              response: response,
              dom: dom
            });
          } else if (!_this[_DYN_SHOULD_COLLECT_DURAT18 /* @min:%2eshouldCollectDuration */](total, network, request, response, dom)) {
            _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 45 /* _eInternalMessageId.InvalidDurationValue */, "Invalid page load duration value. Browser perf data won't be sent.", {
              total: total,
              network: network,
              request: request,
              response: response,
              dom: dom
            });
          } else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) {
            // some browsers may report individual components incorrectly so that the sum of the parts will be bigger than total PLT
            // in this case, don't report client performance from this page
            _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 8 /* _eInternalMessageId.ClientPerformanceMathError */, "client performance math error.", {
              total: total,
              network: network,
              request: request,
              response: response,
              dom: dom
            });
          } else {
            pageViewPerformance.durationMs = total;
            // // convert to timespans
            pageViewPerformance.perfTotal = pageViewPerformance[_DynamicConstants_DYN_DURATION /* @min:%2eduration */] = msToTimeSpan(total);
            pageViewPerformance.networkConnect = msToTimeSpan(network);
            pageViewPerformance.sentRequest = msToTimeSpan(request);
            pageViewPerformance.receivedResponse = msToTimeSpan(response);
            pageViewPerformance.domProcessing = msToTimeSpan(dom);
            pageViewPerformance.isValid = true;
          }
        }
      };
      _self[_DYN_GET_PERFORMANCE_TIMI17 /* @min:%2egetPerformanceTiming */] = _getPerformanceTiming;
      _self[_DYN_IS_PERFORMANCE_TIMIN16 /* @min:%2eisPerformanceTimingSupported */] = _isPerformanceTimingSupported;
      _self[_DYN_IS_PERFORMANCE_TIMIN19 /* @min:%2eisPerformanceTimingDataReady */] = _isPerformanceTimingDataReady;
      _self[_DYN_SHOULD_COLLECT_DURAT18 /* @min:%2eshouldCollectDuration */] = _shouldCollectDuration;
    });
  }
  // Removed Stub for PageViewPerformanceManager.prototype.populatePageViewPerformanceEvent.
  // Removed Stub for PageViewPerformanceManager.prototype.getPerformanceTiming.
  // Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingSupported.
  // Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingDataReady.
  // Removed Stub for PageViewPerformanceManager.prototype.shouldCollectDuration.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  PageViewPerformanceManager.__ieDyn = 1;
  return PageViewPerformanceManager;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-analytics-js/dist-esm/JavaScriptSDK/Telemetry/PageVisitTimeManager.js
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/**
 * Used to track page visit durations
 */
var PageVisitTimeManager = /** @class */function () {
  /**
   * Creates a new instance of PageVisitTimeManager
   * @param pageVisitTimeTrackingHandler Delegate that will be called to send telemetry data to AI (when trackPreviousPageVisit is called)
   * @returns {}
   */
  function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
    var prevPageVisitDataKeyName = "prevPageVisitData";
    dynamicProto(PageVisitTimeManager, this, function (_self) {
      _self[_DYN_TRACK_PREVIOUS_PAGE_9 /* @min:%2etrackPreviousPageVisit */] = function (currentPageName, currentPageUrl) {
        try {
          // Restart timer for new page view
          var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
          // If there was a page already being timed, track the visit time for it now.
          if (prevPageVisitTimeData) {
            pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
          }
        } catch (e) {
          _warnToConsole(logger, "Auto track page visit time failed, metric will not be collected: " + dumpObj(e));
        }
      };
      /**
       * Stops timing of current page (if exists) and starts timing for duration of visit to pageName
       * @param pageName Name of page to begin timing visit duration
       * @returns {PageVisitData} Page visit data (including duration) of pageName from last call to start or restart, if exists. Null if not.
       */
      function restartPageVisitTimer(pageName, pageUrl) {
        var prevPageVisitData = null;
        try {
          prevPageVisitData = stopPageVisitTimer();
          startPageVisitTimer(pageName, pageUrl);
        } catch (e) {
          _warnToConsole(logger, "Call to restart failed: " + dumpObj(e));
          prevPageVisitData = null;
        }
        return prevPageVisitData;
      }
      /**
       * Starts timing visit duration of pageName
       * @param pageName
       * @returns {}
       */
      function startPageVisitTimer(pageName, pageUrl) {
        try {
          if (utlCanUseSessionStorage()) {
            if (utlGetSessionStorage(logger, prevPageVisitDataKeyName) != null) {
              throwError("Cannot call startPageVisit consecutively without first calling stopPageVisit");
            }
            var currPageVisitData = new PageVisitData(pageName, pageUrl);
            var currPageVisitDataStr = getJSON().stringify(currPageVisitData);
            utlSetSessionStorage(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
          }
        } catch (e) {
          // TODO: Remove this catch in next phase, since if start is called twice in a row the exception needs to be propagated out
          _warnToConsole(logger, "Call to start failed: " + dumpObj(e));
        }
      }
      /**
       * Stops timing of current page, if exists.
       * @returns {PageVisitData} Page visit data (including duration) of pageName from call to start, if exists. Null if not.
       */
      function stopPageVisitTimer() {
        var prevPageVisitData = null;
        try {
          if (utlCanUseSessionStorage()) {
            // Define end time of page's visit
            var pageVisitEndTime = dateNow();
            // Try to retrieve  page name and start time from session storage
            var pageVisitDataJsonStr = utlGetSessionStorage(logger, prevPageVisitDataKeyName);
            if (pageVisitDataJsonStr && hasJSON()) {
              // if previous page data exists, set end time of visit
              prevPageVisitData = getJSON().parse(pageVisitDataJsonStr);
              prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData[_DYN_PAGE_VISIT_START_TIM20 /* @min:%2epageVisitStartTime */];
              // Remove data from storage since we already used it
              utlRemoveSessionStorage(logger, prevPageVisitDataKeyName);
            }
          }
        } catch (e) {
          _warnToConsole(logger, "Stop page visit timer failed: " + dumpObj(e));
          prevPageVisitData = null;
        }
        return prevPageVisitData;
      }
      // For backward compatibility
      objDefineAccessors(_self, "_logger", function () {
        return logger;
      });
      objDefineAccessors(_self, "pageVisitTimeTrackingHandler", function () {
        return pageVisitTimeTrackingHandler;
      });
    });
  }
  // Removed Stub for PageVisitTimeManager.prototype.trackPreviousPageVisit.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  PageVisitTimeManager.__ieDyn = 1;
  return PageVisitTimeManager;
}();

var PageVisitData = /** @class */function () {
  function PageVisitData(pageName, pageUrl) {
    this[_DYN_PAGE_VISIT_START_TIM20 /* @min:%2epageVisitStartTime */] = dateNow();
    this.pageName = pageName;
    this.pageUrl = pageUrl;
  }
  return PageVisitData;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-analytics-js/dist-esm/JavaScriptSDK/Timing.js
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * Used to record timed events and page views.
 */
var Timing = /** @class */function () {
  function Timing(logger, name) {
    var _self = this;
    var _events = {};
    _self.start = function (name) {
      if (typeof _events[name] !== "undefined") {
        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 62 /* _eInternalMessageId.StartCalledMoreThanOnce */, "start was called more than once for this event without calling stop.", {
          name: name,
          key: name
        }, true);
      }
      _events[name] = +new Date();
    };
    _self.stop = function (name, url, properties, measurements) {
      var start = _events[name];
      if (isNaN(start)) {
        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 63 /* _eInternalMessageId.StopCalledWithoutStart */, "stop was called without a corresponding start.", {
          name: name,
          key: name
        }, true);
      } else {
        var end = +new Date();
        var duration = dateTimeUtilsDuration(start, end);
        _self.action(name, url, duration, properties, measurements);
      }
      delete _events[name];
      _events[name] = undefined;
    };
  }
  return Timing;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-analytics-js/dist-esm/JavaScriptSDK/AnalyticsPlugin.js
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* ApplicationInsights.ts
* @copyright Microsoft 2018
*/









var strEvent = "event";
function _dispatchEvent(target, evnt) {
  if (target && target.dispatchEvent && evnt) {
    target.dispatchEvent(evnt);
  }
}
function _getReason(error) {
  if (error && error.reason) {
    var reason = error.reason;
    if (!HelperFuncs_isString(reason) && HelperFuncs_isFunction(reason[_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */])) {
      return reason[_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]();
    }

    return dumpObj(reason);
  }
  // Pass the original object down which will eventually get evaluated for any message or description
  return error || "";
}
var MinMilliSeconds = 60000;
function _configMilliseconds(value, defValue) {
  value = value || defValue;
  if (value < MinMilliSeconds) {
    value = MinMilliSeconds;
  }
  return value;
}
function _getDefaultConfig(config) {
  if (!config) {
    config = {};
  }
  // set default values
  config.sessionRenewalMs = _configMilliseconds(config.sessionRenewalMs, 30 * 60 * 1000);
  config.sessionExpirationMs = _configMilliseconds(config.sessionExpirationMs, 24 * 60 * 60 * 1000);
  config[_DYN_DISABLE_EXCEPTION_TR0 /* @min:%2edisableExceptionTracking */] = stringToBoolOrDefault(config[_DYN_DISABLE_EXCEPTION_TR0 /* @min:%2edisableExceptionTracking */]);
  config[_DYN_AUTO_TRACK_PAGE_VISI1 /* @min:%2eautoTrackPageVisitTime */] = stringToBoolOrDefault(config[_DYN_AUTO_TRACK_PAGE_VISI1 /* @min:%2eautoTrackPageVisitTime */]);
  config[_DYN_OVERRIDE_PAGE_VIEW_D2 /* @min:%2eoverridePageViewDuration */] = stringToBoolOrDefault(config[_DYN_OVERRIDE_PAGE_VIEW_D2 /* @min:%2eoverridePageViewDuration */]);
  config[_DYN_ENABLE_UNHANDLED_PRO3 /* @min:%2eenableUnhandledPromiseRejectionTracking */] = stringToBoolOrDefault(config[_DYN_ENABLE_UNHANDLED_PRO3 /* @min:%2eenableUnhandledPromiseRejectionTracking */]);
  if (isNaN(config[_DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */]) || config[_DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */] <= 0 || config[_DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */] >= 100) {
    config[_DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */] = 100;
  }
  config[_DYN_IS_STORAGE_USE_DISAB4 /* @min:%2eisStorageUseDisabled */] = stringToBoolOrDefault(config[_DYN_IS_STORAGE_USE_DISAB4 /* @min:%2eisStorageUseDisabled */]);
  config[_DYN_IS_BROWSER_LINK_TRAC5 /* @min:%2eisBrowserLinkTrackingEnabled */] = stringToBoolOrDefault(config[_DYN_IS_BROWSER_LINK_TRAC5 /* @min:%2eisBrowserLinkTrackingEnabled */]);
  config[_DYN_ENABLE_AUTO_ROUTE_TR6 /* @min:%2eenableAutoRouteTracking */] = stringToBoolOrDefault(config[_DYN_ENABLE_AUTO_ROUTE_TR6 /* @min:%2eenableAutoRouteTracking */]);
  config[_DYN_NAME_PREFIX /* @min:%2enamePrefix */] = config[_DYN_NAME_PREFIX /* @min:%2enamePrefix */] || "";
  config.enableDebug = stringToBoolOrDefault(config.enableDebug);
  config[_DYN_DISABLE_FLUSH_ON_BEF7 /* @min:%2edisableFlushOnBeforeUnload */] = stringToBoolOrDefault(config[_DYN_DISABLE_FLUSH_ON_BEF7 /* @min:%2edisableFlushOnBeforeUnload */]);
  config.disableFlushOnUnload = stringToBoolOrDefault(config.disableFlushOnUnload, config[_DYN_DISABLE_FLUSH_ON_BEF7 /* @min:%2edisableFlushOnBeforeUnload */]);
  return config;
}
function _updateStorageUsage(extConfig) {
  // Not resetting the storage usage as someone may have manually called utlDisableStorage, so this will only
  // reset based if the configuration option is provided
  if (!isUndefined(extConfig[_DYN_IS_STORAGE_USE_DISAB4 /* @min:%2eisStorageUseDisabled */])) {
    if (extConfig[_DYN_IS_STORAGE_USE_DISAB4 /* @min:%2eisStorageUseDisabled */]) {
      utlDisableStorage();
    } else {
      utlEnableStorage();
    }
  }
}
var AnalyticsPlugin = /** @class */function (_super) {
  __extendsFn(AnalyticsPlugin, _super);
  function AnalyticsPlugin() {
    var _this = _super.call(this) || this;
    _this.identifier = AnalyticsPluginIdentifier; // do not change name or priority
    _this.priority = 180; // take from reserved priority range 100- 200
    _this.autoRoutePVDelay = 500; // ms; Time to wait after a route change before triggering a pageview to allow DOM changes to take place
    var _eventTracking;
    var _pageTracking;
    var _pageViewManager;
    var _pageViewPerformanceManager;
    var _pageVisitTimeManager;
    var _preInitTelemetryInitializers;
    var _isBrowserLinkTrackingEnabled;
    var _browserLinkInitializerAdded;
    var _enableAutoRouteTracking;
    var _historyListenerAdded;
    var _disableExceptionTracking;
    var _autoExceptionInstrumented;
    var _enableUnhandledPromiseRejectionTracking;
    var _autoUnhandledPromiseInstrumented;
    // Counts number of trackAjax invocations.
    // By default we only monitor X ajax call per view to avoid too much load.
    // Default value is set in config.
    // This counter keeps increasing even after the limit is reached.
    var _trackAjaxAttempts = 0;
    // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
    var _prevUri; // Assigned in the constructor
    var _currUri;
    var _evtNamespace;
    dynamicProto(AnalyticsPlugin, _this, function (_self, _base) {
      var _addHook = _base._addHook;
      _initDefaults();
      _self.getCookieMgr = function () {
        return safeGetCookieMgr(_self[_DYN_CORE /* @min:%2ecore */]);
      };

      _self.processTelemetry = function (env, itemCtx) {
        _self.processNext(env, itemCtx);
      };
      _self.trackEvent = function (event, customProperties) {
        try {
          var telemetryItem = createTelemetryItem(event, Event_Event[_DYN_DATA_TYPE /* @min:%2edataType */], Event_Event[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), customProperties);
          _self[_DYN_CORE /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
        } catch (e) {
          _throwInternal(2 /* eLoggingSeverity.WARNING */, 39 /* _eInternalMessageId.TrackTraceFailed */, "trackTrace failed, trace will not be collected: " + getExceptionName(e), {
            exception: dumpObj(e)
          });
        }
      };
      /**
       * Start timing an extended event. Call `stopTrackEvent` to log the event when it ends.
       * @param   name    A string that identifies this event uniquely within the document.
       */
      _self.startTrackEvent = function (name) {
        try {
          _eventTracking.start(name);
        } catch (e) {
          _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 29 /* _eInternalMessageId.StartTrackEventFailed */, "startTrackEvent failed, event will not be collected: " + getExceptionName(e), {
            exception: dumpObj(e)
          });
        }
      };
      /**
       * Log an extended event that you started timing with `startTrackEvent`.
       * @param   name    The string you used to identify this event in `startTrackEvent`.
       * @param   properties  map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
       * @param   measurements    map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
       */
      _self.stopTrackEvent = function (name, properties, measurements) {
        try {
          _eventTracking.stop(name, undefined, properties, measurements);
        } catch (e) {
          _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 30 /* _eInternalMessageId.StopTrackEventFailed */, "stopTrackEvent failed, event will not be collected: " + getExceptionName(e), {
            exception: dumpObj(e)
          });
        }
      };
      /**
       * @description Log a diagnostic message
       * @param {ITraceTelemetry} trace
       * @param ICustomProperties.
       * @memberof ApplicationInsights
       */
      _self.trackTrace = function (trace, customProperties) {
        try {
          var telemetryItem = createTelemetryItem(trace, Trace[_DYN_DATA_TYPE /* @min:%2edataType */], Trace[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), customProperties);
          _self[_DYN_CORE /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
        } catch (e) {
          _throwInternal(2 /* eLoggingSeverity.WARNING */, 39 /* _eInternalMessageId.TrackTraceFailed */, "trackTrace failed, trace will not be collected: " + getExceptionName(e), {
            exception: dumpObj(e)
          });
        }
      };
      /**
       * @description Log a numeric value that is not associated with a specific event. Typically
       * used to send regular reports of performance indicators. To send single measurement, just
       * use the name and average fields of {@link IMetricTelemetry}. If you take measurements
       * frequently, you can reduce the telemetry bandwidth by aggregating multiple measurements
       * and sending the resulting average at intervals
       * @param {IMetricTelemetry} metric input object argument. Only name and average are mandatory.
       * @param {{[key: string]: any}} customProperties additional data used to filter metrics in the
       * portal. Defaults to empty.
       * @memberof ApplicationInsights
       */
      _self.trackMetric = function (metric, customProperties) {
        try {
          var telemetryItem = createTelemetryItem(metric, Metric[_DYN_DATA_TYPE /* @min:%2edataType */], Metric[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), customProperties);
          _self[_DYN_CORE /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
        } catch (e) {
          _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 36 /* _eInternalMessageId.TrackMetricFailed */, "trackMetric failed, metric will not be collected: " + getExceptionName(e), {
            exception: dumpObj(e)
          });
        }
      };
      /**
       * Logs that a page or other item was viewed.
       * @param IPageViewTelemetry The string you used as the name in startTrackPage. Defaults to the document title.
       * @param customProperties Additional data used to filter events and metrics. Defaults to empty.
       * If a user wants to provide duration for pageLoad, it'll have to be in pageView.properties.duration
       */
      _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */] = function (pageView, customProperties) {
        try {
          var inPv = pageView || {};
          _pageViewManager[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */](inPv, __assignFn(__assignFn(__assignFn({}, inPv.properties), inPv.measurements), customProperties));
          if (_self.config[_DYN_AUTO_TRACK_PAGE_VISI1 /* @min:%2eautoTrackPageVisitTime */]) {
            _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_9 /* @min:%2etrackPreviousPageVisit */](inPv.name, inPv.uri);
          }
        } catch (e) {
          _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 37 /* _eInternalMessageId.TrackPVFailed */, "trackPageView failed, page view will not be collected: " + getExceptionName(e), {
            exception: dumpObj(e)
          });
        }
      };
      /**
       * Create a page view telemetry item and send it to the SDK pipeline through the core.track API
       * @param pageView Page view item to be sent
       * @param properties Custom properties (Part C) that a user can add to the telemetry item
       * @param systemProperties System level properties (Part A) that a user can add to the telemetry item
       */
      _self[_DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */] = function (pageView, properties, systemProperties) {
        var doc = EnvUtils_getDocument();
        if (doc) {
          pageView.refUri = pageView.refUri === undefined ? doc.referrer : pageView.refUri;
        }
        var telemetryItem = createTelemetryItem(pageView, PageView[_DYN_DATA_TYPE /* @min:%2edataType */], PageView[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), properties, systemProperties);
        _self[_DYN_CORE /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
        // reset ajaxes counter
        _trackAjaxAttempts = 0;
      };
      /**
       * @ignore INTERNAL ONLY
       * @param pageViewPerformance
       * @param properties
       */
      _self[_DYN_SEND_PAGE_VIEW_PERFO11 /* @min:%2esendPageViewPerformanceInternal */] = function (pageViewPerformance, properties, systemProperties) {
        var telemetryItem = createTelemetryItem(pageViewPerformance, PageViewPerformance[_DYN_DATA_TYPE /* @min:%2edataType */], PageViewPerformance[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), properties, systemProperties);
        _self[_DYN_CORE /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
      };
      /**
       * Send browser performance metrics.
       * @param pageViewPerformance
       * @param customProperties
       */
      _self.trackPageViewPerformance = function (pageViewPerformance, customProperties) {
        var inPvp = pageViewPerformance || {};
        try {
          _pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P12 /* @min:%2epopulatePageViewPerformanceEvent */](inPvp);
          _self[_DYN_SEND_PAGE_VIEW_PERFO11 /* @min:%2esendPageViewPerformanceInternal */](inPvp, customProperties);
        } catch (e) {
          _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 37 /* _eInternalMessageId.TrackPVFailed */, "trackPageViewPerformance failed, page view will not be collected: " + getExceptionName(e), {
            exception: dumpObj(e)
          });
        }
      };
      /**
       * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
       * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
       * and send the event.
       * @param name A string that idenfities this item, unique within this HTML document. Defaults to the document title.
       */
      _self.startTrackPage = function (name) {
        try {
          if (typeof name !== "string") {
            var doc = EnvUtils_getDocument();
            name = doc && doc.title || "";
          }
          _pageTracking.start(name);
        } catch (e) {
          _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 31 /* _eInternalMessageId.StartTrackFailed */, "startTrackPage failed, page view may not be collected: " + getExceptionName(e), {
            exception: dumpObj(e)
          });
        }
      };
      /**
       * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
       * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
       * @param   name  The string you used as the name in startTrackPage. Defaults to the document title.
       * @param   url   String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
       * @param   properties  map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
       * @param   measurements    map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
       */
      _self.stopTrackPage = function (name, url, properties, measurement) {
        try {
          if (typeof name !== "string") {
            var doc = EnvUtils_getDocument();
            name = doc && doc.title || "";
          }
          if (typeof url !== "string") {
            var loc = getLocation();
            url = loc && loc[_DYN_HREF /* @min:%2ehref */] || "";
          }
          _pageTracking.stop(name, url, properties, measurement);
          if (_self.config[_DYN_AUTO_TRACK_PAGE_VISI1 /* @min:%2eautoTrackPageVisitTime */]) {
            _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_9 /* @min:%2etrackPreviousPageVisit */](name, url);
          }
        } catch (e) {
          _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 32 /* _eInternalMessageId.StopTrackFailed */, "stopTrackPage failed, page view will not be collected: " + getExceptionName(e), {
            exception: dumpObj(e)
          });
        }
      };
      /**
      * @ignore INTERNAL ONLY
      * @param exception
      * @param properties
      * @param systemProperties
      */
      _self[_DYN_SEND_EXCEPTION_INTER13 /* @min:%2esendExceptionInternal */] = function (exception, customProperties, systemProperties) {
        var theError = exception[_DYN_EXCEPTION /* @min:%2eexception */] || exception[_DYN_ERROR /* @min:%2eerror */] || new Error(strNotSpecified);
        var exceptionPartB = new Exception(_self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), theError, exception.properties || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
        var telemetryItem = createTelemetryItem(exceptionPartB, Exception[_DYN_DATA_TYPE /* @min:%2edataType */], Exception[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), customProperties, systemProperties);
        _self[_DYN_CORE /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
      };
      /**
       * Log an exception you have caught.
       *
       * @param {IExceptionTelemetry} exception   Object which contains exception to be sent
       * @param {{[key: string]: any}} customProperties   Additional data used to filter pages and metrics in the portal. Defaults to empty.
       *
       * Any property of type double will be considered a measurement, and will be treated by Application Insights as a metric.
       * @memberof ApplicationInsights
       */
      _self.trackException = function (exception, customProperties) {
        if (exception && !exception[_DYN_EXCEPTION /* @min:%2eexception */] && exception[_DYN_ERROR /* @min:%2eerror */]) {
          exception[_DYN_EXCEPTION /* @min:%2eexception */] = exception[_DYN_ERROR /* @min:%2eerror */];
        }

        try {
          _self[_DYN_SEND_EXCEPTION_INTER13 /* @min:%2esendExceptionInternal */](exception, customProperties);
        } catch (e) {
          _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 35 /* _eInternalMessageId.TrackExceptionFailed */, "trackException failed, exception will not be collected: " + getExceptionName(e), {
            exception: dumpObj(e)
          });
        }
      };
      /**
       * @description Custom error handler for Application Insights Analytics
       * @param {IAutoExceptionTelemetry} exception
       * @memberof ApplicationInsights
       */
      _self[_DYN__ONERROR /* @min:%2e_onerror */] = function (exception) {
        var error = exception && exception[_DYN_ERROR /* @min:%2eerror */];
        var evt = exception && exception.evt;
        try {
          if (!evt) {
            var _window = getWindow();
            if (_window) {
              evt = _window[strEvent];
            }
          }
          var url = exception && exception.url || (EnvUtils_getDocument() || {}).URL;
          // If no error source is provided assume the default window.onerror handler
          var errorSrc = exception[_DYN_ERROR_SRC /* @min:%2eerrorSrc */] || "window.onerror@" + url + ":" + (exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0) + ":" + (exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0);
          var properties = {
            errorSrc: errorSrc,
            url: url,
            lineNumber: exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0,
            columnNumber: exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0,
            message: exception[dist_esm_DynamicConstants_DYN_MESSAGE /* @min:%2emessage */]
          };

          if (isCrossOriginError(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[_DYN_ERROR /* @min:%2eerror */])) {
            _sendCORSException(Exception[_DYN__CREATE_AUTO_EXCEPTI14 /* @min:%2eCreateAutoException */]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0, exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0, error, evt, null, errorSrc), properties);
          } else {
            if (!exception[_DYN_ERROR_SRC /* @min:%2eerrorSrc */]) {
              exception[_DYN_ERROR_SRC /* @min:%2eerrorSrc */] = errorSrc;
            }
            _self.trackException({
              exception: exception,
              severityLevel: 3 /* eSeverityLevel.Error */
            }, properties);
          }
        } catch (e) {
          var errorString = error ? error.name + ", " + error[dist_esm_DynamicConstants_DYN_MESSAGE /* @min:%2emessage */] : "null";
          _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 11 /* _eInternalMessageId.ExceptionWhileLoggingError */, "_onError threw exception while logging error, error will not be collected: " + getExceptionName(e), {
            exception: dumpObj(e),
            errorString: errorString
          });
        }
      };
      _self[_DYN_ADD_TELEMETRY_INITIA15 /* @min:%2eaddTelemetryInitializer */] = function (telemetryInitializer) {
        if (_self[_DYN_CORE /* @min:%2ecore */]) {
          // Just add to the core
          return _self[_DYN_CORE /* @min:%2ecore */][_DYN_ADD_TELEMETRY_INITIA15 /* @min:%2eaddTelemetryInitializer */](telemetryInitializer);
        }
        // Handle "pre-initialization" telemetry initializers (for backward compatibility)
        if (!_preInitTelemetryInitializers) {
          _preInitTelemetryInitializers = [];
        }
        _preInitTelemetryInitializers.push(telemetryInitializer);
      };
      _self.initialize = function (config, core, extensions, pluginChain) {
        if (_self.isInitialized()) {
          return;
        }
        if (isNullOrUndefined(core)) {
          throwError("Error initializing");
        }
        _base.initialize(config, core, extensions, pluginChain);
        try {
          _evtNamespace = mergeEvtNamespace(createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
          if (_preInitTelemetryInitializers) {
            HelperFuncs_arrForEach(_preInitTelemetryInitializers, function (initializer) {
              core[_DYN_ADD_TELEMETRY_INITIA15 /* @min:%2eaddTelemetryInitializer */](initializer);
            });
            _preInitTelemetryInitializers = null;
          }
          var extConfig = _populateDefaults(config);
          _updateStorageUsage(extConfig);
          _pageViewPerformanceManager = new PageViewPerformanceManager(_self[_DYN_CORE /* @min:%2ecore */]);
          _pageViewManager = new PageViewManager(_this, extConfig[_DYN_OVERRIDE_PAGE_VIEW_D2 /* @min:%2eoverridePageViewDuration */], _self[_DYN_CORE /* @min:%2ecore */], _pageViewPerformanceManager);
          _pageVisitTimeManager = new PageVisitTimeManager(_self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), function (pageName, pageUrl, pageVisitTime) {
            return trackPageVisitTime(pageName, pageUrl, pageVisitTime);
          });
          _updateBrowserLinkTracking(extConfig, config);
          _eventTracking = new Timing(_self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), "trackEvent");
          _eventTracking.action = function (name, url, duration, properties, measurements) {
            if (!properties) {
              properties = {};
            }
            if (!measurements) {
              measurements = {};
            }
            properties.duration = duration[_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]();
            _self.trackEvent({
              name: name,
              properties: properties,
              measurements: measurements
            });
          };
          // initialize page view timing
          _pageTracking = new Timing(_self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), "trackPageView");
          _pageTracking.action = function (name, url, duration, properties, measurements) {
            // duration must be a custom property in order for the collector to extract it
            if (isNullOrUndefined(properties)) {
              properties = {};
            }
            properties.duration = duration[_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]();
            var pageViewItem = {
              name: name,
              uri: url,
              properties: properties,
              measurements: measurements
            };
            _self[_DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */](pageViewItem, properties);
          };
          if (hasWindow()) {
            _updateExceptionTracking(extConfig);
            _updateLocationChange(extConfig);
          }
        } catch (e) {
          // resetting the initialized state because of failure
          _self.setInitialized(false);
          throw e;
        }
      };
      _self._doTeardown = function (unloadCtx, unloadState) {
        _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
        // Just register to remove all events associated with this namespace
        eventOff(window, null, null, _evtNamespace);
        _initDefaults();
      };
      function _populateDefaults(config) {
        var ctx = createProcessTelemetryContext(null, config, _self[_DYN_CORE /* @min:%2ecore */]);
        var identifier = _self.identifier;
        // load default values if specified
        var defaults = _getDefaultConfig(config);
        var extConfig = _self.config = ctx.getExtCfg(identifier);
        if (defaults !== undefined) {
          HelperFuncs_objForEachKey(defaults, function (field, value) {
            // for each unspecified field, set the default value
            extConfig[field] = ctx.getConfig(identifier, field, value);
            if (extConfig[field] === undefined) {
              extConfig = value;
            }
          });
        }
        return extConfig;
      }
      function _updateBrowserLinkTracking(extConfig, config) {
        _isBrowserLinkTrackingEnabled = extConfig[_DYN_IS_BROWSER_LINK_TRAC5 /* @min:%2eisBrowserLinkTrackingEnabled */] || config[_DYN_IS_BROWSER_LINK_TRAC5 /* @min:%2eisBrowserLinkTrackingEnabled */];
        _addDefaultTelemetryInitializers();
      }
      /**
       * Log a page visit time
       * @param    pageName    Name of page
       * @param    pageVisitDuration Duration of visit to the page in milleseconds
       */
      function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
        var properties = {
          PageName: pageName,
          PageUrl: pageUrl
        };
        _self.trackMetric({
          name: "PageVisitTime",
          average: pageVisitTime,
          max: pageVisitTime,
          min: pageVisitTime,
          sampleCount: 1
        }, properties);
      }
      function _addDefaultTelemetryInitializers() {
        if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
          var browserLinkPaths_1 = ["/browserLinkSignalR/", "/__browserLink/"];
          var dropBrowserLinkRequests = function (envelope) {
            if (_isBrowserLinkTrackingEnabled && envelope.baseType === RemoteDependencyData[_DYN_DATA_TYPE /* @min:%2edataType */]) {
              var remoteData = envelope.baseData;
              if (remoteData) {
                for (var i = 0; i < browserLinkPaths_1[applicationinsights_analytics_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
                  if (remoteData.target && remoteData.target.indexOf(browserLinkPaths_1[i]) >= 0) {
                    return false;
                  }
                }
              }
            }
            return true;
          };
          _self[_DYN_ADD_TELEMETRY_INITIA15 /* @min:%2eaddTelemetryInitializer */](dropBrowserLinkRequests);
          _browserLinkInitializerAdded = true;
        }
      }
      function _sendCORSException(exception, properties) {
        var telemetryItem = createTelemetryItem(exception, Exception[_DYN_DATA_TYPE /* @min:%2edataType */], Exception[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), properties);
        _self[_DYN_CORE /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
      }
      function _updateExceptionTracking(extConfig) {
        var _window = getWindow();
        var locn = getLocation(true);
        _disableExceptionTracking = extConfig[_DYN_DISABLE_EXCEPTION_TR0 /* @min:%2edisableExceptionTracking */];
        if (!_disableExceptionTracking && !_autoExceptionInstrumented && !extConfig.autoExceptionInstrumented) {
          // We want to enable exception auto collection and it has not been done so yet
          _addHook(InstrumentEvent(_window, "onerror", {
            ns: _evtNamespace,
            rsp: function (callDetails, message, url, lineNumber, columnNumber, error) {
              if (!_disableExceptionTracking && callDetails.rslt !== true) {
                _self[_DYN__ONERROR /* @min:%2e_onerror */](Exception[_DYN__CREATE_AUTO_EXCEPTI14 /* @min:%2eCreateAutoException */](message, url, lineNumber, columnNumber, error, callDetails.evt));
              }
            }
          }, false));
          _autoExceptionInstrumented = true;
        }
        _addUnhandledPromiseRejectionTracking(extConfig, _window, locn);
      }
      function _updateLocationChange(extConfig) {
        var win = getWindow();
        var locn = getLocation(true);
        _enableAutoRouteTracking = extConfig[_DYN_ENABLE_AUTO_ROUTE_TR6 /* @min:%2eenableAutoRouteTracking */] === true;
        /**
         * Create a custom "locationchange" event which is triggered each time the history object is changed
         */
        if (win && _enableAutoRouteTracking && hasHistory()) {
          var _history = getHistory();
          if (HelperFuncs_isFunction(_history.pushState) && HelperFuncs_isFunction(_history.replaceState) && typeof Event !== Constants_strShimUndefined) {
            _addHistoryListener(extConfig, win, _history, locn);
          }
        }
      }
      function _getDistributedTraceCtx() {
        var distributedTraceCtx = null;
        if (_self[_DYN_CORE /* @min:%2ecore */] && _self[_DYN_CORE /* @min:%2ecore */].getTraceCtx) {
          distributedTraceCtx = _self[_DYN_CORE /* @min:%2ecore */].getTraceCtx(false);
        }
        if (!distributedTraceCtx) {
          // Fallback when using an older Core and PropertiesPlugin
          var properties = _self[_DYN_CORE /* @min:%2ecore */].getPlugin(PropertiesPluginIdentifier);
          if (properties) {
            var context = properties.plugin.context;
            if (context) {
              distributedTraceCtx = createDistributedTraceContextFromTrace(context.telemetryTrace);
            }
          }
        }
        return distributedTraceCtx;
      }
      /**
       * Create a custom "locationchange" event which is triggered each time the history object is changed
       */
      function _addHistoryListener(extConfig, win, history, locn) {
        var namePrefix = extConfig[_DYN_NAME_PREFIX /* @min:%2enamePrefix */] || "";
        function _popstateHandler() {
          if (_enableAutoRouteTracking) {
            _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
          }
        }
        function _locationChangeHandler() {
          // We always track the changes (if the handler is installed) to handle the feature being disabled between location changes
          if (_currUri) {
            _prevUri = _currUri;
            _currUri = locn && locn[_DYN_HREF /* @min:%2ehref */] || "";
          } else {
            _currUri = locn && locn[_DYN_HREF /* @min:%2ehref */] || "";
          }
          if (_enableAutoRouteTracking) {
            var distributedTraceCtx = _getDistributedTraceCtx();
            if (distributedTraceCtx) {
              distributedTraceCtx.setTraceId(generateW3CId());
              var traceLocationName = "_unknown_";
              if (locn && locn.pathname) {
                traceLocationName = locn.pathname + (locn.hash || "");
              }
              // This populates the ai.operation.name which has a maximum size of 1024 so we need to sanitize it
              distributedTraceCtx.setName(dataSanitizeString(_self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), traceLocationName));
            }
            setTimeout(function (uri) {
              // todo: override start time so that it is not affected by autoRoutePVDelay
              _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */]({
                refUri: uri,
                properties: {
                  duration: 0
                }
              }); // SPA route change loading durations are undefined, so send 0
            }.bind(this, _prevUri), _self.autoRoutePVDelay);
          }
        }
        if (!_historyListenerAdded) {
          _addHook(InstrumentEvent(history, "pushState", {
            ns: _evtNamespace,
            rsp: function () {
              if (_enableAutoRouteTracking) {
                _dispatchEvent(win, createDomEvent(namePrefix + "pushState"));
                _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
              }
            }
          }, true));
          _addHook(InstrumentEvent(history, "replaceState", {
            ns: _evtNamespace,
            rsp: function () {
              if (_enableAutoRouteTracking) {
                _dispatchEvent(win, createDomEvent(namePrefix + "replaceState"));
                _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
              }
            }
          }, true));
          eventOn(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
          eventOn(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
          _historyListenerAdded = true;
        }
      }
      function _addUnhandledPromiseRejectionTracking(extConfig, _window, _location) {
        _enableUnhandledPromiseRejectionTracking = extConfig[_DYN_ENABLE_UNHANDLED_PRO3 /* @min:%2eenableUnhandledPromiseRejectionTracking */] === true;
        if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
          // We want to enable exception auto collection and it has not been done so yet
          _addHook(InstrumentEvent(_window, "onunhandledrejection", {
            ns: _evtNamespace,
            rsp: function (callDetails, error) {
              if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) {
                // handled could be typeof function
                _self[_DYN__ONERROR /* @min:%2e_onerror */](Exception[_DYN__CREATE_AUTO_EXCEPTI14 /* @min:%2eCreateAutoException */](_getReason(error), _location ? _location[_DYN_HREF /* @min:%2ehref */] : "", 0, 0, error, callDetails.evt));
              }
            }
          }, false));
          _autoUnhandledPromiseInstrumented = true;
          extConfig.autoUnhandledPromiseInstrumented = _autoUnhandledPromiseInstrumented;
        }
      }
      /**
       * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
       * @param severity {eLoggingSeverity} - The severity of the log message
       * @param message {_InternalLogMessage} - The log message.
       */
      function _throwInternal(severity, msgId, msg, properties, isUserAct) {
        _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */]().throwInternal(severity, msgId, msg, properties, isUserAct);
      }
      function _initDefaults() {
        _eventTracking = null;
        _pageTracking = null;
        _pageViewManager = null;
        _pageViewPerformanceManager = null;
        _pageVisitTimeManager = null;
        _preInitTelemetryInitializers = null;
        _isBrowserLinkTrackingEnabled = false;
        _browserLinkInitializerAdded = false;
        _enableAutoRouteTracking = false;
        _historyListenerAdded = false;
        _disableExceptionTracking = false;
        _autoExceptionInstrumented = false;
        _enableUnhandledPromiseRejectionTracking = false;
        _autoUnhandledPromiseInstrumented = false;
        // Counts number of trackAjax invocations.
        // By default we only monitor X ajax call per view to avoid too much load.
        // Default value is set in config.
        // This counter keeps increasing even after the limit is reached.
        _trackAjaxAttempts = 0;
        // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
        var location = getLocation(true);
        _prevUri = location && location[_DYN_HREF /* @min:%2ehref */] || "";
        _currUri = null;
        _evtNamespace = null;
      }
      // For backward compatibility
      objDefineAccessors(_self, "_pageViewManager", function () {
        return _pageViewManager;
      });
      objDefineAccessors(_self, "_pageViewPerformanceManager", function () {
        return _pageViewPerformanceManager;
      });
      objDefineAccessors(_self, "_pageVisitTimeManager", function () {
        return _pageVisitTimeManager;
      });
      objDefineAccessors(_self, "_evtNamespace", function () {
        return "." + _evtNamespace;
      });
    });
    return _this;
  }
  // Removed Stub for AnalyticsPlugin.prototype.getCookieMgr.
  // Removed Stub for AnalyticsPlugin.prototype.processTelemetry.
  // Removed Stub for AnalyticsPlugin.prototype.trackEvent.
  // Removed Stub for AnalyticsPlugin.prototype.startTrackEvent.
  // Removed Stub for AnalyticsPlugin.prototype.stopTrackEvent.
  // Removed Stub for AnalyticsPlugin.prototype.trackTrace.
  // Removed Stub for AnalyticsPlugin.prototype.trackMetric.
  // Removed Stub for AnalyticsPlugin.prototype.trackPageView.
  // Removed Stub for AnalyticsPlugin.prototype.sendPageViewInternal.
  // Removed Stub for AnalyticsPlugin.prototype.sendPageViewPerformanceInternal.
  // Removed Stub for AnalyticsPlugin.prototype.trackPageViewPerformance.
  // Removed Stub for AnalyticsPlugin.prototype.startTrackPage.
  // Removed Stub for AnalyticsPlugin.prototype.stopTrackPage.
  // Removed Stub for AnalyticsPlugin.prototype.sendExceptionInternal.
  // Removed Stub for AnalyticsPlugin.prototype.trackException.
  // Removed Stub for AnalyticsPlugin.prototype._onerror.
  // Removed Stub for AnalyticsPlugin.prototype.addTelemetryInitializer.
  // Removed Stub for AnalyticsPlugin.prototype.initialize.
  AnalyticsPlugin.Version = '2.8.9'; // Not currently used anywhere
  AnalyticsPlugin.getDefaultConfig = _getDefaultConfig;
  return AnalyticsPlugin;
}(BaseTelemetryPlugin);

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Interfaces/Contracts/ContextTagKeys.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



function _aiNameFunc(baseName) {
  var aiName = "ai." + baseName + ".";
  return function (name) {
    return aiName + name;
  };
}
var _aiApplication = _aiNameFunc("application");
var _aiDevice = _aiNameFunc("device");
var _aiLocation = _aiNameFunc("location");
var _aiOperation = _aiNameFunc("operation");
var _aiSession = _aiNameFunc("session");
var _aiUser = _aiNameFunc("user");
var _aiCloud = _aiNameFunc("cloud");
var _aiInternal = _aiNameFunc("internal");
var ContextTagKeys = /** @class */function (_super) {
  __extendsFn(ContextTagKeys, _super);
  function ContextTagKeys() {
    return _super.call(this) || this;
  }
  return ContextTagKeys;
}(createClassFromInterface({
  applicationVersion: _aiApplication("ver"),
  applicationBuild: _aiApplication("build"),
  applicationTypeId: _aiApplication("typeId"),
  applicationId: _aiApplication("applicationId"),
  applicationLayer: _aiApplication("layer"),
  deviceId: _aiDevice("id"),
  deviceIp: _aiDevice("ip"),
  deviceLanguage: _aiDevice("language"),
  deviceLocale: _aiDevice("locale"),
  deviceModel: _aiDevice("model"),
  deviceFriendlyName: _aiDevice("friendlyName"),
  deviceNetwork: _aiDevice("network"),
  deviceNetworkName: _aiDevice("networkName"),
  deviceOEMName: _aiDevice("oemName"),
  deviceOS: _aiDevice("os"),
  deviceOSVersion: _aiDevice("osVersion"),
  deviceRoleInstance: _aiDevice("roleInstance"),
  deviceRoleName: _aiDevice("roleName"),
  deviceScreenResolution: _aiDevice("screenResolution"),
  deviceType: _aiDevice("type"),
  deviceMachineName: _aiDevice("machineName"),
  deviceVMName: _aiDevice("vmName"),
  deviceBrowser: _aiDevice("browser"),
  deviceBrowserVersion: _aiDevice("browserVersion"),
  locationIp: _aiLocation("ip"),
  locationCountry: _aiLocation("country"),
  locationProvince: _aiLocation("province"),
  locationCity: _aiLocation("city"),
  operationId: _aiOperation("id"),
  operationName: _aiOperation("name"),
  operationParentId: _aiOperation("parentId"),
  operationRootId: _aiOperation("rootId"),
  operationSyntheticSource: _aiOperation("syntheticSource"),
  operationCorrelationVector: _aiOperation("correlationVector"),
  sessionId: _aiSession("id"),
  sessionIsFirst: _aiSession("isFirst"),
  sessionIsNew: _aiSession("isNew"),
  userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
  userAccountId: _aiUser("accountId"),
  userAgent: _aiUser("userAgent"),
  userId: _aiUser("id"),
  userStoreRegion: _aiUser("storeRegion"),
  userAuthUserId: _aiUser("authUserId"),
  userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
  userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
  cloudName: _aiCloud("name"),
  cloudRole: _aiCloud("role"),
  cloudRoleVer: _aiCloud("roleVer"),
  cloudRoleInstance: _aiCloud("roleInstance"),
  cloudEnvironment: _aiCloud("environment"),
  cloudLocation: _aiCloud("location"),
  cloudDeploymentUnit: _aiCloud("deploymentUnit"),
  internalNodeName: _aiInternal("nodeName"),
  internalSdkVersion: _aiInternal("sdkVersion"),
  internalAgentVersion: _aiInternal("agentVersion"),
  internalSnippet: _aiInternal("snippet"),
  internalSdkSrc: _aiInternal("sdkSrc")
}));

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Interfaces/PartAExtensions.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Extensions = {
  UserExt: "user",
  DeviceExt: "device",
  TraceExt: "trace",
  WebExt: "web",
  AppExt: "app",
  OSExt: "os",
  SessionExt: "ses",
  SDKExt: "sdk"
};
var CtxTagKeys = new ContextTagKeys();
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Common/Envelope.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var Envelope = /** @class */function () {
  /**
   * Constructs a new instance of telemetry data.
   */
  function Envelope(logger, data, name) {
    var _this = this;
    var _self = this;
    _self.ver = 1;
    _self.sampleRate = 100.0;
    _self.tags = {};
    _self[dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
    _self.data = data;
    _self.time = toISOString(new Date());
    _self.aiDataContract = {
      time: 1 /* FieldType.Required */,
      iKey: 1 /* FieldType.Required */,
      name: 1 /* FieldType.Required */,
      sampleRate: function () {
        return _this.sampleRate === 100 ? 4 /* FieldType.Hidden */ : 1 /* FieldType.Required */;
      },

      tags: 1 /* FieldType.Required */,
      data: 1 /* FieldType.Required */
    };
  }

  return Envelope;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Common/Data.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Data = /** @class */function () {
  /**
   * Constructs a new instance of telemetry data.
   */
  function Data(baseType, data) {
    /**
     * The data contract for serializing this object.
     */
    this.aiDataContract = {
      baseType: 1 /* FieldType.Required */,
      baseData: 1 /* FieldType.Required */
    };

    this.baseType = baseType;
    this.baseData = data;
  }
  return Data;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/InternalConstants.js
/*
 * Application Insights JavaScript SDK - Channel, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var STR_DURATION = "duration";
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Channel, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TAGS = "tags"; // Count: 17
var _DYN_DEVICE_TYPE = "deviceType"; // Count: 3
var _DYN_DATA = "data"; // Count: 13
var applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_NAME = "name"; // Count: 8
var dist_esm_DynamicConstants_DYN_TRACE_ID = "traceID"; // Count: 5
var applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH = "length"; // Count: 36
var _DynamicConstants_DYN_STRINGIFY = "stringify"; // Count: 5
var _DynamicConstants_DYN_MEASUREMENTS = "measurements"; // Count: 7
var _DynamicConstants_DYN_DATA_TYPE = "dataType"; // Count: 10
var _DynamicConstants_DYN_ENVELOPE_TYPE = "envelopeType"; // Count: 7
var dist_esm_DynamicConstants_DYN_TO_STRING = "toString"; // Count: 7
var _DYN_ON_LINE = "onLine"; // Count: 4
var _DYN_ENQUEUE = "enqueue"; // Count: 5
var _DynamicConstants_DYN_COUNT = "count"; // Count: 6
var dist_esm_DynamicConstants_DYN_PUSH = "push"; // Count: 6
var _DYN_EMIT_LINE_DELIMITED_0 = "emitLineDelimitedJson"; // Count: 3
var _DYN_CLEAR = "clear"; // Count: 6
var _DYN_BATCH_PAYLOADS = "batchPayloads"; // Count: 5
var _DYN_MARK_AS_SENT = "markAsSent"; // Count: 6
var _DYN_CLEAR_SENT = "clearSent"; // Count: 5
var _DYN__BUFFER__KEY = "BUFFER_KEY"; // Count: 5
var _DYN__SENT__BUFFER__KEY = "SENT_BUFFER_KEY"; // Count: 7
var _DYN__MAX__BUFFER__SIZE = "MAX_BUFFER_SIZE"; // Count: 5
var _DynamicConstants_DYN_NAME_PREFIX = "namePrefix"; // Count: 6
var _DYN_MAX_BATCH_SIZE_IN_BY1 = "maxBatchSizeInBytes"; // Count: 3
var _DYN_TRIGGER_SEND = "triggerSend"; // Count: 6
var dist_esm_DynamicConstants_DYN_DIAG_LOG = "diagLog"; // Count: 15
var _DYN_ONUNLOAD_DISABLE_BEA2 = "onunloadDisableBeacon"; // Count: 2
var _DYN_IS_BEACON_API_DISABL3 = "isBeaconApiDisabled"; // Count: 3
var _DYN__SENDER = "_sender"; // Count: 5
var _DYN__SENDER_CONFIG = "_senderConfig"; // Count: 4
var _DYN__BUFFER = "_buffer"; // Count: 7
var _DYN_ENABLE_SESSION_STORA4 = "enableSessionStorageBuffer"; // Count: 2
var _DynamicConstants_DYN_SAMPLING_PERCENTAGE = "samplingPercentage"; // Count: 2
var _DynamicConstants_DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 4
var _DYN_ENDPOINT_URL = "endpointUrl"; // Count: 8
var _DYN_CUSTOM_HEADERS = "customHeaders"; // Count: 4
var _DYN_DISABLE_XHR = "disableXhr"; // Count: 5
var _DYN_ONUNLOAD_DISABLE_FET5 = "onunloadDisableFetch"; // Count: 2
var _DYN_DISABLE_TELEMETRY = "disableTelemetry"; // Count: 2
var _DYN_BASE_TYPE = "baseType"; // Count: 4
var _DYN_SAMPLE_RATE = "sampleRate"; // Count: 4
var _DYN_CONVERT_UNDEFINED = "convertUndefined"; // Count: 2
var _DYN__XHR_READY_STATE_CHA6 = "_xhrReadyStateChange"; // Count: 2
var _DYN__ON_ERROR = "_onError"; // Count: 11
var _DYN__ON_PARTIAL_SUCCESS = "_onPartialSuccess"; // Count: 3
var _DYN__ON_SUCCESS = "_onSuccess"; // Count: 6
var _DYN_ITEMS_ACCEPTED = "itemsAccepted"; // Count: 5
var _DYN_ITEMS_RECEIVED = "itemsReceived"; // Count: 6
var _DYN_IS_RETRY_DISABLED = "isRetryDisabled"; // Count: 5
var _DYN_SET_REQUEST_HEADER = "setRequestHeader"; // Count: 3
var _DYN_MAX_BATCH_INTERVAL = "maxBatchInterval"; // Count: 2
var _DYN_EVENTS_SEND_REQUEST = "eventsSendRequest"; // Count: 2
var _DYN_DISABLE_INSTRUMENTAT7 = "disableInstrumentationKeyValidation"; // Count: 2
var _DYN_GET_SAMPLING_SCORE = "getSamplingScore"; // Count: 2
var _DYN_GET_HASH_CODE_SCORE = "getHashCodeScore"; // Count: 4
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/EnvelopeCreator.js
/*
 * Application Insights JavaScript SDK - Channel, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





// these two constants are used to filter out properties not needed when trying to extract custom properties and measurements from the incoming payload
var strBaseType = "baseType";
var strBaseData = "baseData";
var strProperties = "properties";
var strTrue = "true";
function _setValueIf(target, field, value) {
  return setValue(target, field, value, isTruthy);
}
/*
 * Maps Part A data from CS 4.0
 */
function _extractPartAExtensions(logger, item, env) {
  // todo: switch to keys from common in this method
  var envTags = env[_DYN_TAGS /* @min:%2etags */] = env[_DYN_TAGS /* @min:%2etags */] || {};
  var itmExt = item.ext = item.ext || {};
  var itmTags = item[_DYN_TAGS /* @min:%2etags */] = item[_DYN_TAGS /* @min:%2etags */] || [];
  var extUser = itmExt.user;
  if (extUser) {
    _setValueIf(envTags, CtxTagKeys.userAuthUserId, extUser.authId);
    _setValueIf(envTags, CtxTagKeys.userId, extUser.id || extUser.localId);
  }
  var extApp = itmExt.app;
  if (extApp) {
    _setValueIf(envTags, CtxTagKeys.sessionId, extApp.sesId);
  }
  var extDevice = itmExt.device;
  if (extDevice) {
    _setValueIf(envTags, CtxTagKeys.deviceId, extDevice.id || extDevice.localId);
    _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE /* @min:%2edeviceType */], extDevice.deviceClass);
    _setValueIf(envTags, CtxTagKeys.deviceIp, extDevice.ip);
    _setValueIf(envTags, CtxTagKeys.deviceModel, extDevice.model);
    _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE /* @min:%2edeviceType */], extDevice[_DYN_DEVICE_TYPE /* @min:%2edeviceType */]);
  }

  var web = item.ext.web;
  if (web) {
    _setValueIf(envTags, CtxTagKeys.deviceLanguage, web.browserLang);
    _setValueIf(envTags, CtxTagKeys.deviceBrowserVersion, web.browserVer);
    _setValueIf(envTags, CtxTagKeys.deviceBrowser, web.browser);
    var envData = env[_DYN_DATA /* @min:%2edata */] = env[_DYN_DATA /* @min:%2edata */] || {};
    var envBaseData = envData[strBaseData] = envData[strBaseData] || {};
    var envProps = envBaseData[strProperties] = envBaseData[strProperties] || {};
    _setValueIf(envProps, "domain", web.domain);
    _setValueIf(envProps, "isManual", web.isManual ? strTrue : null);
    _setValueIf(envProps, "screenRes", web.screenRes);
    _setValueIf(envProps, "userConsent", web.userConsent ? strTrue : null);
  }
  var extOs = itmExt.os;
  if (extOs) {
    _setValueIf(envTags, CtxTagKeys.deviceOS, extOs[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */]);
  }
  // No support for mapping Trace.traceState to 2.0 as it is currently empty
  var extTrace = itmExt.trace;
  if (extTrace) {
    _setValueIf(envTags, CtxTagKeys.operationParentId, extTrace.parentID);
    _setValueIf(envTags, CtxTagKeys.operationName, dataSanitizeString(logger, extTrace[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */]));
    _setValueIf(envTags, CtxTagKeys.operationId, extTrace[dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */]);
  }
  // Sample 4.0 schema
  //  {
  //     "time" : "2018-09-05T22:51:22.4936Z",
  //     "name" : "MetricWithNamespace",
  //     "iKey" : "ABC-5a4cbd20-e601-4ef5-a3c6-5d6577e4398e",
  //     "ext": {  "cloud": {
  //          "role": "WATSON3",
  //          "roleInstance": "CO4AEAP00000260"
  //      },
  //      "device": {}, "correlation": {} },
  //      "tags": [
  //        { "amazon.region" : "east2" },
  //        { "os.expid" : "wp:02df239" }
  //     ]
  //   }
  var tgs = {};
  // deals with tags.push({object})
  for (var i = itmTags[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 1; i >= 0; i--) {
    var tg = itmTags[i];
    HelperFuncs_objForEachKey(tg, function (key, value) {
      tgs[key] = value;
    });
    itmTags.splice(i, 1);
  }
  // deals with tags[key]=value (and handles hasOwnProperty)
  HelperFuncs_objForEachKey(itmTags, function (tg, value) {
    tgs[tg] = value;
  });
  var theTags = __assignFn(__assignFn({}, envTags), tgs);
  if (!theTags[CtxTagKeys.internalSdkVersion]) {
    // Append a version in case it is not already set
    theTags[CtxTagKeys.internalSdkVersion] = "javascript:".concat(EnvelopeCreator.Version);
  }
  env[_DYN_TAGS /* @min:%2etags */] = optimizeObject(theTags);
}
function _extractPropsAndMeasurements(data, properties, measurements) {
  if (!isNullOrUndefined(data)) {
    HelperFuncs_objForEachKey(data, function (key, value) {
      if (isNumber(value)) {
        measurements[key] = value;
      } else if (HelperFuncs_isString(value)) {
        properties[key] = value;
      } else if (hasJSON()) {
        properties[key] = getJSON()[_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](value);
      }
    });
  }
}
function _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
  if (!isNullOrUndefined(properties)) {
    HelperFuncs_objForEachKey(properties, function (key, value) {
      properties[key] = value || customUndefinedValue;
    });
  }
}
// TODO: Do we want this to take logger as arg or use this._logger as nonstatic?
function _createEnvelope(logger, envelopeType, telemetryItem, data) {
  var envelope = new Envelope(logger, data, envelopeType);
  _setValueIf(envelope, "sampleRate", telemetryItem[SampleRate]);
  if ((telemetryItem[strBaseData] || {}).startTime) {
    envelope.time = toISOString(telemetryItem[strBaseData].startTime);
  }
  envelope.iKey = telemetryItem.iKey;
  var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
  envelope[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */] = envelope[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */].replace("{0}", iKeyNoDashes);
  // extract all extensions from ctx
  _extractPartAExtensions(logger, telemetryItem, envelope);
  // loop through the envelope tags (extension of Part A) and pick out the ones that should go in outgoing envelope tags
  telemetryItem[_DYN_TAGS /* @min:%2etags */] = telemetryItem[_DYN_TAGS /* @min:%2etags */] || [];
  return optimizeObject(envelope);
}
function EnvelopeCreatorInit(logger, telemetryItem) {
  if (isNullOrUndefined(telemetryItem[strBaseData])) {
    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 46 /* _eInternalMessageId.TelemetryEnvelopeInvalid */, "telemetryItem.baseData cannot be null.");
  }
}
var EnvelopeCreator = {
  Version: '2.8.9'
};
function DependencyEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  var customMeasurements = telemetryItem[strBaseData][_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
  var customProperties = telemetryItem[strBaseData][strProperties] || {};
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
  }
  var bd = telemetryItem[strBaseData];
  if (isNullOrUndefined(bd)) {
    _warnToConsole(logger, "Invalid input for dependency data");
    return null;
  }
  var method = bd[strProperties] && bd[strProperties][HttpMethod] ? bd[strProperties][HttpMethod] : "GET";
  var remoteDepData = new RemoteDependencyData(logger, bd.id, bd.target, bd[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */], bd[STR_DURATION /* @min:%2eduration */], bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
  var data = new Data(RemoteDependencyData[_DynamicConstants_DYN_DATA_TYPE /* @min:%2edataType */], remoteDepData);
  return _createEnvelope(logger, RemoteDependencyData[_DynamicConstants_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function EventEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  var customProperties = {};
  var customMeasurements = {};
  if (telemetryItem[strBaseType] !== Event_Event[_DynamicConstants_DYN_DATA_TYPE /* @min:%2edataType */]) {
    customProperties["baseTypeSource"] = telemetryItem[strBaseType]; // save the passed in base type as a property
  }

  if (telemetryItem[strBaseType] === Event_Event[_DynamicConstants_DYN_DATA_TYPE /* @min:%2edataType */]) {
    // take collection
    customProperties = telemetryItem[strBaseData][strProperties] || {};
    customMeasurements = telemetryItem[strBaseData][_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
  } else {
    // if its not a known type, convert to custom event
    if (telemetryItem[strBaseData]) {
      _extractPropsAndMeasurements(telemetryItem[strBaseData], customProperties, customMeasurements);
    }
  }
  // Extract root level properties from part C telemetryItem.data
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
  }
  var eventName = telemetryItem[strBaseData][applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */];
  var eventData = new Event_Event(logger, eventName, customProperties, customMeasurements);
  var data = new Data(Event_Event[_DynamicConstants_DYN_DATA_TYPE /* @min:%2edataType */], eventData);
  return _createEnvelope(logger, Event_Event[_DynamicConstants_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function ExceptionEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  // Extract root level properties from part C telemetryItem.data
  var customMeasurements = telemetryItem[strBaseData][_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
  var customProperties = telemetryItem[strBaseData][strProperties] || {};
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
  }
  var bd = telemetryItem[strBaseData];
  var exData = Exception.CreateFromInterface(logger, bd, customProperties, customMeasurements);
  var data = new Data(Exception[_DynamicConstants_DYN_DATA_TYPE /* @min:%2edataType */], exData);
  return _createEnvelope(logger, Exception[_DynamicConstants_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function MetricEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  var baseData = telemetryItem[strBaseData];
  var props = baseData[strProperties] || {};
  var measurements = baseData[_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], props, measurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
  }
  var baseMetricData = new Metric(logger, baseData[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
  var data = new Data(Metric[_DynamicConstants_DYN_DATA_TYPE /* @min:%2edataType */], baseMetricData);
  return _createEnvelope(logger, Metric[_DynamicConstants_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function PageViewEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  // Since duration is not part of the domain properties in Common Schema, extract it from part C
  var duration;
  var baseData = telemetryItem[strBaseData];
  if (!isNullOrUndefined(baseData) && !isNullOrUndefined(baseData[strProperties]) && !isNullOrUndefined(baseData[strProperties][STR_DURATION])) {
    // from part B properties
    duration = baseData[strProperties][STR_DURATION];
    delete baseData[strProperties][STR_DURATION];
  } else if (!isNullOrUndefined(telemetryItem[_DYN_DATA /* @min:%2edata */]) && !isNullOrUndefined(telemetryItem[_DYN_DATA /* @min:%2edata */][STR_DURATION])) {
    // from custom properties
    duration = telemetryItem[_DYN_DATA /* @min:%2edata */][STR_DURATION];
    delete telemetryItem[_DYN_DATA /* @min:%2edata */][STR_DURATION];
  }
  var bd = telemetryItem[strBaseData];
  // special case: pageview.id is grabbed from current operation id. Analytics plugin is decoupled from properties plugin, so this is done here instead. This can be made a default telemetry intializer instead if needed to be decoupled from channel
  var currentContextId;
  if (((telemetryItem.ext || {}).trace || {})[dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */]) {
    currentContextId = telemetryItem.ext.trace[dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */];
  }

  var id = bd.id || currentContextId;
  var name = bd[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */];
  var url = bd.uri;
  var properties = bd[strProperties] || {};
  var measurements = bd[_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
  // refUri is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
  if (!isNullOrUndefined(bd.refUri)) {
    properties["refUri"] = bd.refUri;
  }
  // pageType is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
  if (!isNullOrUndefined(bd.pageType)) {
    properties["pageType"] = bd.pageType;
  }
  // isLoggedIn is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
  if (!isNullOrUndefined(bd.isLoggedIn)) {
    properties["isLoggedIn"] = bd.isLoggedIn[dist_esm_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]();
  }
  // pageTags is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
  if (!isNullOrUndefined(bd[strProperties])) {
    var pageTags = bd[strProperties];
    HelperFuncs_objForEachKey(pageTags, function (key, value) {
      properties[key] = value;
    });
  }
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], properties, measurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
  }
  var pageViewData = new PageView(logger, name, url, duration, properties, measurements, id);
  var data = new Data(PageView[_DynamicConstants_DYN_DATA_TYPE /* @min:%2edataType */], pageViewData);
  return _createEnvelope(logger, PageView[_DynamicConstants_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function PageViewPerformanceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  var bd = telemetryItem[strBaseData];
  var name = bd[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */];
  var url = bd.uri || bd.url;
  var properties = bd[strProperties] || {};
  var measurements = bd[_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], properties, measurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
  }
  var baseData = new PageViewPerformance(logger, name, url, undefined, properties, measurements, bd);
  var data = new Data(PageViewPerformance[_DynamicConstants_DYN_DATA_TYPE /* @min:%2edataType */], baseData);
  return _createEnvelope(logger, PageViewPerformance[_DynamicConstants_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function TraceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
  EnvelopeCreatorInit(logger, telemetryItem);
  var message = telemetryItem[strBaseData].message;
  var severityLevel = telemetryItem[strBaseData].severityLevel;
  var props = telemetryItem[strBaseData][strProperties] || {};
  var measurements = telemetryItem[strBaseData][_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
  _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], props, measurements);
  if (!isNullOrUndefined(customUndefinedValue)) {
    _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
  }
  var baseData = new Trace(logger, message, severityLevel, props, measurements);
  var data = new Data(Trace[_DynamicConstants_DYN_DATA_TYPE /* @min:%2edataType */], baseData);
  return _createEnvelope(logger, Trace[_DynamicConstants_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/Offline.js
/*
 * Application Insights JavaScript SDK - Channel, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


function _disableEvents(target, evtNamespace) {
  eventOff(target, null, null, evtNamespace);
}
/**
 * Create a new OfflineListener instance to monitor browser online / offline events
 * @param parentEvtNamespace - The parent event namespace to append to any specific events for this instance
 */
function createOfflineListener(parentEvtNamespace) {
  var _document = EnvUtils_getDocument();
  var _navigator = getNavigator(); // Gets the window.navigator or workerNavigator depending on the global
  var _isListening = false;
  var _onlineStatus = true;
  var _evtNamespace = mergeEvtNamespace(createUniqueNamespace("OfflineListener"), parentEvtNamespace);
  try {
    if (_enableEvents(getWindow())) {
      _isListening = true;
    }
    if (_document) {
      // Also attach to the document.body or document
      var target = _document.body || _document;
      if (target.ononline) {
        if (_enableEvents(target)) {
          _isListening = true;
        }
      }
    }
    if (_isListening) {
      // We are listening to events so lets set the current status rather than assuming we are online #1538
      if (_navigator && !isNullOrUndefined(_navigator[_DYN_ON_LINE /* @min:%2eonLine */])) {
        // navigator.onLine is undefined in react-native
        _onlineStatus = _navigator[_DYN_ON_LINE /* @min:%2eonLine */];
      }
    }
  } catch (e) {
    // this makes react-native less angry
    _isListening = false;
  }
  function _enableEvents(target) {
    var enabled = false;
    if (target) {
      enabled = eventOn(target, "online", _setOnline, _evtNamespace);
      if (enabled) {
        eventOn(target, "offline", _setOffline, _evtNamespace);
      }
    }
    return enabled;
  }
  function _setOnline() {
    _onlineStatus = true;
  }
  function _setOffline() {
    _onlineStatus = false;
  }
  function _isOnline() {
    var result = true;
    if (_isListening) {
      result = _onlineStatus;
    } else if (_navigator && !isNullOrUndefined(_navigator[_DYN_ON_LINE /* @min:%2eonLine */])) {
      // navigator.onLine is undefined in react-native
      result = _navigator[_DYN_ON_LINE /* @min:%2eonLine */];
    }

    return result;
  }
  function _unload() {
    var win = getWindow();
    if (win && _isListening) {
      _disableEvents(win, _evtNamespace);
      if (_document) {
        // Also attach to the document.body or document
        var target = _document.body || _document;
        if (!isUndefined(target.ononline)) {
          _disableEvents(target, _evtNamespace);
        }
      }
      _isListening = false;
    }
  }
  return {
    isOnline: _isOnline,
    isListening: function () {
      return _isListening;
    },
    unload: _unload
  };
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/SendBuffer.js
/*
 * Application Insights JavaScript SDK - Channel, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var BaseSendBuffer = /** @class */function () {
  function BaseSendBuffer(logger, config) {
    var _buffer = [];
    var _bufferFullMessageSent = false;
    this._get = function () {
      return _buffer;
    };
    this._set = function (buffer) {
      _buffer = buffer;
      return _buffer;
    };
    dynamicProto(BaseSendBuffer, this, function (_self) {
      _self[_DYN_ENQUEUE /* @min:%2eenqueue */] = function (payload) {
        if (_self[_DynamicConstants_DYN_COUNT /* @min:%2ecount */]() >= config.eventsLimitInMem()) {
          // sent internal log only once per page view
          if (!_bufferFullMessageSent) {
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 105 /* _eInternalMessageId.InMemoryStorageBufferFull */, "Maximum in-memory buffer size reached: " + _self[_DynamicConstants_DYN_COUNT /* @min:%2ecount */](), true);
            _bufferFullMessageSent = true;
          }
          return;
        }
        _buffer[dist_esm_DynamicConstants_DYN_PUSH /* @min:%2epush */](payload);
      };
      _self[_DynamicConstants_DYN_COUNT /* @min:%2ecount */] = function () {
        return _buffer[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
      };

      _self.size = function () {
        var size = _buffer[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
        for (var lp = 0; lp < _buffer[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
          size += _buffer[lp][applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
        }

        if (!config[_DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */]()) {
          size += 2;
        }
        return size;
      };
      _self[_DYN_CLEAR /* @min:%2eclear */] = function () {
        _buffer = [];
        _bufferFullMessageSent = false;
      };
      _self.getItems = function () {
        return _buffer.slice(0);
      };
      _self[_DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */] = function (payload) {
        if (payload && payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
          var batch = config[_DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */]() ? payload.join("\n") : "[" + payload.join(",") + "]";
          return batch;
        }
        return null;
      };
    });
  }
  // Removed Stub for BaseSendBuffer.prototype.enqueue.
  // Removed Stub for BaseSendBuffer.prototype.count.
  // Removed Stub for BaseSendBuffer.prototype.size.
  // Removed Stub for BaseSendBuffer.prototype.clear.
  // Removed Stub for BaseSendBuffer.prototype.getItems.
  // Removed Stub for BaseSendBuffer.prototype.batchPayloads.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  BaseSendBuffer.__ieDyn = 1;
  return BaseSendBuffer;
}();
/*
 * An array based send buffer.
 */
var ArraySendBuffer = /** @class */function (_super) {
  __extendsFn(ArraySendBuffer, _super);
  function ArraySendBuffer(logger, config) {
    var _this = _super.call(this, logger, config) || this;
    dynamicProto(ArraySendBuffer, _this, function (_self, _base) {
      _self[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */] = function (payload) {
        _base[_DYN_CLEAR /* @min:%2eclear */]();
      };

      _self[_DYN_CLEAR_SENT /* @min:%2eclearSent */] = function (payload) {
        // not supported
      };
    });
    return _this;
  }
  // Removed Stub for ArraySendBuffer.prototype.markAsSent.
  // Removed Stub for ArraySendBuffer.prototype.clearSent.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  ArraySendBuffer.__ieDyn = 1;
  return ArraySendBuffer;
}(BaseSendBuffer);

/*
 * Session storage buffer holds a copy of all unsent items in the browser session storage.
 */
var SessionStorageSendBuffer = /** @class */function (_super) {
  __extendsFn(SessionStorageSendBuffer, _super);
  function SessionStorageSendBuffer(logger, config) {
    var _this = _super.call(this, logger, config) || this;
    var _bufferFullMessageSent = false;
    dynamicProto(SessionStorageSendBuffer, _this, function (_self, _base) {
      var bufferItems = _getBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */]);
      var notDeliveredItems = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
      var buffer = _self._set(bufferItems.concat(notDeliveredItems));
      // If the buffer has too many items, drop items from the end.
      if (buffer[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
        buffer[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */];
      }

      _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], []);
      _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], buffer);
      _self[_DYN_ENQUEUE /* @min:%2eenqueue */] = function (payload) {
        if (_self[_DynamicConstants_DYN_COUNT /* @min:%2ecount */]() >= SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
          // sent internal log only once per page view
          if (!_bufferFullMessageSent) {
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 67 /* _eInternalMessageId.SessionStorageBufferFull */, "Maximum buffer size reached: " + _self[_DynamicConstants_DYN_COUNT /* @min:%2ecount */](), true);
            _bufferFullMessageSent = true;
          }
          return;
        }
        _base[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
        _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], _self._get());
      };
      _self[_DYN_CLEAR /* @min:%2eclear */] = function () {
        _base[_DYN_CLEAR /* @min:%2eclear */]();
        _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], _self._get());
        _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], []);
        _bufferFullMessageSent = false;
      };
      _self[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */] = function (payload) {
        _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], _self._set(_removePayloadsFromBuffer(payload, _self._get())));
        var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
        if (sentElements instanceof Array && payload instanceof Array) {
          sentElements = sentElements.concat(payload);
          if (sentElements[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
            // We send telemetry normally. If the SENT_BUFFER is too big we don't add new elements
            // until we receive a response from the backend and the buffer has free space again (see clearSent method)
            _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 67 /* _eInternalMessageId.SessionStorageBufferFull */, "Sent buffer reached its maximum size: " + sentElements[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */], true);
            sentElements[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */];
          }

          _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], sentElements);
        }
      };
      _self[_DYN_CLEAR_SENT /* @min:%2eclearSent */] = function (payload) {
        var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
        sentElements = _removePayloadsFromBuffer(payload, sentElements);
        _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], sentElements);
      };
      function _removePayloadsFromBuffer(payloads, buffer) {
        var remaining = [];
        HelperFuncs_arrForEach(buffer, function (value) {
          if (!HelperFuncs_isFunction(value) && arrIndexOf(payloads, value) === -1) {
            remaining[dist_esm_DynamicConstants_DYN_PUSH /* @min:%2epush */](value);
          }
        });
        return remaining;
      }
      function _getBuffer(key) {
        var prefixedKey = key;
        try {
          prefixedKey = config[_DynamicConstants_DYN_NAME_PREFIX /* @min:%2enamePrefix */] && config[_DynamicConstants_DYN_NAME_PREFIX /* @min:%2enamePrefix */]() ? config[_DynamicConstants_DYN_NAME_PREFIX /* @min:%2enamePrefix */]() + "_" + prefixedKey : prefixedKey;
          var bufferJson = utlGetSessionStorage(logger, prefixedKey);
          if (bufferJson) {
            var buffer_1 = getJSON().parse(bufferJson);
            if (HelperFuncs_isString(buffer_1)) {
              // When using some version prototype.js the stringify / parse cycle does not decode array's correctly
              buffer_1 = getJSON().parse(buffer_1);
            }
            if (buffer_1 && HelperFuncs_isArray(buffer_1)) {
              return buffer_1;
            }
          }
        } catch (e) {
          _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 42 /* _eInternalMessageId.FailedToRestoreStorageBuffer */, " storage key: " + prefixedKey + ", " + getExceptionName(e), {
            exception: dumpObj(e)
          });
        }
        return [];
      }
      function _setBuffer(key, buffer) {
        var prefixedKey = key;
        try {
          prefixedKey = config[_DynamicConstants_DYN_NAME_PREFIX /* @min:%2enamePrefix */] && config[_DynamicConstants_DYN_NAME_PREFIX /* @min:%2enamePrefix */]() ? config[_DynamicConstants_DYN_NAME_PREFIX /* @min:%2enamePrefix */]() + "_" + prefixedKey : prefixedKey;
          var bufferJson = JSON[_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](buffer);
          utlSetSessionStorage(logger, prefixedKey, bufferJson);
        } catch (e) {
          // if there was an error, clear the buffer
          // telemetry is stored in the _buffer array so we won't loose any items
          utlSetSessionStorage(logger, prefixedKey, JSON[_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */]([]));
          _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 41 /* _eInternalMessageId.FailedToSetStorageBuffer */, " storage key: " + prefixedKey + ", " + getExceptionName(e) + ". Buffer cleared", {
            exception: dumpObj(e)
          });
        }
      }
    });
    return _this;
  }
  // Removed Stub for SessionStorageSendBuffer.prototype.enqueue.
  // Removed Stub for SessionStorageSendBuffer.prototype.clear.
  // Removed Stub for SessionStorageSendBuffer.prototype.markAsSent.
  // Removed Stub for SessionStorageSendBuffer.prototype.clearSent.
  SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer";
  SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer";
  // Maximum number of payloads stored in the buffer. If the buffer is full, new elements will be dropped.
  SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
  return SessionStorageSendBuffer;
}(BaseSendBuffer);

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/Serializer.js
/*
 * Application Insights JavaScript SDK - Channel, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var Serializer = /** @class */function () {
  function Serializer(logger) {
    dynamicProto(Serializer, this, function (_self) {
      /**
       * Serializes the current object to a JSON string.
       */
      _self.serialize = function (input) {
        var output = _serializeObject(input, "root");
        try {
          return getJSON()[_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](output);
        } catch (e) {
          // if serialization fails return an empty string
          _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, e && HelperFuncs_isFunction(e[dist_esm_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]) ? e[dist_esm_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]() : "Error serializing object", null, true);
        }
      };
      function _serializeObject(source, name) {
        var circularReferenceCheck = "__aiCircularRefCheck";
        var output = {};
        if (!source) {
          _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, "cannot serialize object because it is null or undefined", {
            name: name
          }, true);
          return output;
        }
        if (source[circularReferenceCheck]) {
          _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 50 /* _eInternalMessageId.CircularReferenceDetected */, "Circular reference detected while serializing object", {
            name: name
          }, true);
          return output;
        }
        if (!source.aiDataContract) {
          // special case for measurements/properties/tags
          if (name === "measurements") {
            output = _serializeStringMap(source, "number", name);
          } else if (name === "properties") {
            output = _serializeStringMap(source, "string", name);
          } else if (name === "tags") {
            output = _serializeStringMap(source, "string", name);
          } else if (HelperFuncs_isArray(source)) {
            output = _serializeArray(source, name);
          } else {
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */, "Attempting to serialize an object which does not implement ISerializable", {
              name: name
            }, true);
            try {
              // verify that the object can be stringified
              getJSON()[_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](source);
              output = source;
            } catch (e) {
              // if serialization fails return an empty string
              _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, e && HelperFuncs_isFunction(e[dist_esm_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]) ? e[dist_esm_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]() : "Error serializing object", null, true);
            }
          }
          return output;
        }
        source[circularReferenceCheck] = true;
        HelperFuncs_objForEachKey(source.aiDataContract, function (field, contract) {
          var isRequired = HelperFuncs_isFunction(contract) ? contract() & 1 /* FieldType.Required */ : contract & 1 /* FieldType.Required */;
          var isHidden = HelperFuncs_isFunction(contract) ? contract() & 4 /* FieldType.Hidden */ : contract & 4 /* FieldType.Hidden */;
          var isArray = contract & 2 /* FieldType.Array */;
          var isPresent = source[field] !== undefined;
          var isObj = isObject(source[field]) && source[field] !== null;
          if (isRequired && !isPresent && !isArray) {
            _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 24 /* _eInternalMessageId.MissingRequiredFieldSpecification */, "Missing required field specification. The field is required but not present on source", {
              field: field,
              name: name
            });
            // If not in debug mode, continue and hope the error is permissible
          } else if (!isHidden) {
            // Don't serialize hidden fields
            var value = void 0;
            if (isObj) {
              if (isArray) {
                // special case; recurse on each object in the source array
                value = _serializeArray(source[field], field);
              } else {
                // recurse on the source object in this field
                value = _serializeObject(source[field], field);
              }
            } else {
              // assign the source field to the output even if undefined or required
              value = source[field];
            }
            // only emit this field if the value is defined
            if (value !== undefined) {
              output[field] = value;
            }
          }
        });
        delete source[circularReferenceCheck];
        return output;
      }
      function _serializeArray(sources, name) {
        var output;
        if (!!sources) {
          if (!HelperFuncs_isArray(sources)) {
            _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 54 /* _eInternalMessageId.ItemNotInArray */, "This field was specified as an array in the contract but the item is not an array.\r\n", {
              name: name
            }, true);
          } else {
            output = [];
            for (var i = 0; i < sources[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
              var source = sources[i];
              var item = _serializeObject(source, name + "[" + i + "]");
              output[dist_esm_DynamicConstants_DYN_PUSH /* @min:%2epush */](item);
            }
          }
        }
        return output;
      }
      function _serializeStringMap(map, expectedType, name) {
        var output;
        if (map) {
          output = {};
          HelperFuncs_objForEachKey(map, function (field, value) {
            if (expectedType === "string") {
              if (value === undefined) {
                output[field] = "undefined";
              } else if (value === null) {
                output[field] = "null";
              } else if (!value[dist_esm_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]) {
                output[field] = "invalid field: toString() is not defined.";
              } else {
                output[field] = value[dist_esm_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]();
              }
            } else if (expectedType === "number") {
              if (value === undefined) {
                output[field] = "undefined";
              } else if (value === null) {
                output[field] = "null";
              } else {
                var num = parseFloat(value);
                if (isNaN(num)) {
                  output[field] = "NaN";
                } else {
                  output[field] = num;
                }
              }
            } else {
              output[field] = "invalid field: " + name + " is of unknown type.";
              _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, output[field], null, true);
            }
          });
        }
        return output;
      }
    });
  }
  // Removed Stub for Serializer.prototype.serialize.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  Serializer.__ieDyn = 1;
  return Serializer;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/TelemetryProcessors/SamplingScoreGenerators/HashCodeScoreGenerator.js
/*
 * Application Insights JavaScript SDK - Channel, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
var MIN_INPUT_LENGTH = 8;
var HashCodeScoreGenerator = /** @class */function () {
  function HashCodeScoreGenerator() {}
  HashCodeScoreGenerator.prototype.getHashCodeScore = function (key) {
    var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
    return score * 100;
  };
  HashCodeScoreGenerator.prototype.getHashCode = function (input) {
    if (input === "") {
      return 0;
    }
    while (input[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] < MIN_INPUT_LENGTH) {
      input = input.concat(input);
    }
    // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
    var hash = 5381;
    for (var i = 0; i < input[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; ++i) {
      hash = (hash << 5) + hash + input.charCodeAt(i);
      // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
      // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
      hash = hash & hash;
    }
    return Math.abs(hash);
  };
  // We're using 32 bit math, hence max value is (2^31 - 1)
  HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
  return HashCodeScoreGenerator;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/TelemetryProcessors/SamplingScoreGenerators/SamplingScoreGenerator.js
/*
 * Application Insights JavaScript SDK - Channel, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var SamplingScoreGenerator = /** @class */function () {
  function SamplingScoreGenerator() {
    var _self = this;
    var hashCodeGenerator = new HashCodeScoreGenerator();
    var keys = new ContextTagKeys();
    _self[_DYN_GET_SAMPLING_SCORE /* @min:%2egetSamplingScore */] = function (item) {
      var score = 0;
      if (item[_DYN_TAGS /* @min:%2etags */] && item[_DYN_TAGS /* @min:%2etags */][keys.userId]) {
        // search in tags first, then ext
        score = hashCodeGenerator.getHashCodeScore(item[_DYN_TAGS /* @min:%2etags */][keys.userId]);
      } else if (item.ext && item.ext.user && item.ext.user.id) {
        score = hashCodeGenerator[_DYN_GET_HASH_CODE_SCORE /* @min:%2egetHashCodeScore */](item.ext.user.id);
      } else if (item[_DYN_TAGS /* @min:%2etags */] && item[_DYN_TAGS /* @min:%2etags */][keys.operationId]) {
        // search in tags first, then ext
        score = hashCodeGenerator.getHashCodeScore(item[_DYN_TAGS /* @min:%2etags */][keys.operationId]);
      } else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */]) {
        score = hashCodeGenerator.getHashCodeScore(item.ext.telemetryTrace[dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */]);
      } else {
        // tslint:disable-next-line:insecure-random
        score = Math.random() * 100;
      }
      return score;
    };
  }
  return SamplingScoreGenerator;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/TelemetryProcessors/Sample.js
/*
 * Application Insights JavaScript SDK - Channel, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var Sample = /** @class */function () {
  function Sample(sampleRate, logger) {
    // We're using 32 bit math, hence max value is (2^31 - 1)
    this.INT_MAX_VALUE = 2147483647;
    var _logger = logger || safeGetLogger(null);
    if (sampleRate > 100 || sampleRate < 0) {
      _logger.throwInternal(2 /* eLoggingSeverity.WARNING */, 58 /* _eInternalMessageId.SampleRateOutOfRange */, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", {
        samplingRate: sampleRate
      }, true);
      sampleRate = 100;
    }
    this[_DYN_SAMPLE_RATE /* @min:%2esampleRate */] = sampleRate;
    this.samplingScoreGenerator = new SamplingScoreGenerator();
  }
  /**
  * Determines if an envelope is sampled in (i.e. will be sent) or not (i.e. will be dropped).
  */
  Sample.prototype.isSampledIn = function (envelope) {
    var samplingPercentage = this[_DYN_SAMPLE_RATE /* @min:%2esampleRate */]; // 0 - 100
    var isSampledIn = false;
    if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) {
      return true;
    } else if (envelope.baseType === Metric[_DynamicConstants_DYN_DATA_TYPE /* @min:%2edataType */]) {
      // exclude MetricData telemetry from sampling
      return true;
    }
    isSampledIn = this.samplingScoreGenerator[_DYN_GET_SAMPLING_SCORE /* @min:%2egetSamplingScore */](envelope) < samplingPercentage;
    return isSampledIn;
  };
  return Sample;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/Sender.js
/*
 * Application Insights JavaScript SDK - Channel, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Sender_a;










var FetchSyncRequestSizeLimitBytes = 65000; // approx 64kb (the current Edge, Firefox and Chrome max limit)
function _getResponseText(xhr) {
  try {
    return xhr.responseText;
  } catch (e) {
    // Best effort, as XHR may throw while XDR wont so just ignore
  }
  return null;
}
function _getDefaultAppInsightsChannelConfig() {
  var _a;
  var defaultValue;
  var defaultCustomHeaders;
  // set default values
  return _a = {
    endpointUrl: function () {
      return DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH;
    }
  }, _a[_DYN_EMIT_LINE_DELIMITED_0 /* @min:emitLineDelimitedJson */] = function () {
    return false;
  }, _a[_DYN_MAX_BATCH_INTERVAL /* @min:maxBatchInterval */] = function () {
    return 15000;
  }, _a[_DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:maxBatchSizeInBytes */] = function () {
    return 102400;
  }, _a[_DYN_DISABLE_TELEMETRY /* @min:disableTelemetry */] = function () {
    return false;
  }, _a[_DYN_ENABLE_SESSION_STORA4 /* @min:enableSessionStorageBuffer */] = function () {
    return true;
  }, _a[_DYN_IS_RETRY_DISABLED /* @min:isRetryDisabled */] = function () {
    return false;
  }, _a[_DYN_IS_BEACON_API_DISABL3 /* @min:isBeaconApiDisabled */] = function () {
    return true;
  }, _a[_DYN_DISABLE_XHR /* @min:disableXhr */] = function () {
    return false;
  }, _a[_DYN_ONUNLOAD_DISABLE_FET5 /* @min:onunloadDisableFetch */] = function () {
    return false;
  }, _a[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:onunloadDisableBeacon */] = function () {
    return false;
  }, _a[_DynamicConstants_DYN_INSTRUMENTATION_KEY /* @min:instrumentationKey */] = function () {
    return defaultValue;
  }, _a[_DynamicConstants_DYN_NAME_PREFIX /* @min:namePrefix */] = function () {
    return defaultValue;
  }, _a[_DynamicConstants_DYN_SAMPLING_PERCENTAGE /* @min:samplingPercentage */] = function () {
    return 100;
  }, _a[_DYN_CUSTOM_HEADERS /* @min:customHeaders */] = function () {
    return defaultCustomHeaders;
  }, _a[_DYN_CONVERT_UNDEFINED /* @min:convertUndefined */] = function () {
    return defaultValue;
  }, _a.eventsLimitInMem = function () {
    return 10000;
  }, _a;
}
var EnvelopeTypeCreator = (Sender_a = {}, Sender_a[Event_Event.dataType] = EventEnvelopeCreator, Sender_a[Trace.dataType] = TraceEnvelopeCreator, Sender_a[PageView.dataType] = PageViewEnvelopeCreator, Sender_a[PageViewPerformance.dataType] = PageViewPerformanceEnvelopeCreator, Sender_a[Exception.dataType] = ExceptionEnvelopeCreator, Sender_a[Metric.dataType] = MetricEnvelopeCreator, Sender_a[RemoteDependencyData.dataType] = DependencyEnvelopeCreator, Sender_a);
var Sender = /** @class */function (_super) {
  __extendsFn(Sender, _super);
  function Sender() {
    var _this = _super.call(this) || this;
    _this.priority = 1001;
    _this.identifier = BreezeChannelIdentifier;
    /**
     * The configuration for this sender instance
     */
    _this._senderConfig = _getDefaultAppInsightsChannelConfig();
    // Don't set the defaults here, set them in the _initDefaults() as this is also called during unload
    var _consecutiveErrors; // How many times in a row a retryable error condition has occurred.
    var _retryAt; // The time to retry at in milliseconds from 1970/01/01 (this makes the timer calculation easy).
    var _lastSend; // The time of the last send operation.
    var _paused; // Flag indicating that the sending should be paused
    var _timeoutHandle; // Handle to the timer for delayed sending of batches of data.
    var _serializer;
    var _stamp_specific_redirects;
    var _headers;
    var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
    var _fallbackSender; // The sender to use if the payload size is too large
    var _syncUnloadSender; // The identified sender to use for the synchronous unload stage
    var _offlineListener;
    var _evtNamespace;
    dynamicProto(Sender, _this, function (_self, _base) {
      _initDefaults();
      _self.pause = function () {
        _clearScheduledTimer();
        _paused = true;
      };
      _self.resume = function () {
        if (_paused) {
          _paused = false;
          _retryAt = null;
          // flush if we have exceeded the max-size already
          if (_self._buffer.size() > _self._senderConfig[_DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:%2emaxBatchSizeInBytes */]()) {
            _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, null, 10 /* SendRequestReason.MaxBatchSize */);
          }

          _setupTimer();
        }
      };
      _self.flush = function (isAsync, callBack, sendReason) {
        if (isAsync === void 0) {
          isAsync = true;
        }
        if (!_paused) {
          // Clear the normal schedule timer as we are going to try and flush ASAP
          _clearScheduledTimer();
          try {
            _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](isAsync, null, sendReason || 1 /* SendRequestReason.ManualFlush */);
          } catch (e) {
            _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 22 /* _eInternalMessageId.FlushFailed */, "flush failed, telemetry will not be collected: " + getExceptionName(e), {
              exception: dumpObj(e)
            });
          }
        }
      };
      _self.onunloadFlush = function () {
        if (!_paused) {
          if ((_self._senderConfig[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:%2eonunloadDisableBeacon */]() === false || _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */]() === false) && isBeaconsSupported()) {
            try {
              _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, _doUnloadSend, 2 /* SendRequestReason.Unload */);
            } catch (e) {
              _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + getExceptionName(e), {
                exception: dumpObj(e)
              });
            }
          } else {
            _self.flush();
          }
        }
      };
      _self.addHeader = function (name, value) {
        _headers[name] = value;
      };
      _self.initialize = function (config, core, extensions, pluginChain) {
        if (_self.isInitialized()) {
          _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender is already initialized");
        }
        _base.initialize(config, core, extensions, pluginChain);
        var ctx = _self._getTelCtx();
        var identifier = _self.identifier;
        _serializer = new Serializer(core.logger);
        _consecutiveErrors = 0;
        _retryAt = null;
        _lastSend = 0;
        _self[_DYN__SENDER /* @min:%2e_sender */] = null;
        _stamp_specific_redirects = 0;
        var diagLog = _self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */]();
        _evtNamespace = mergeEvtNamespace(createUniqueNamespace("Sender"), core.evtNamespace && core.evtNamespace());
        _offlineListener = createOfflineListener(_evtNamespace);
        // TODO v3.x: Change the ISenderConfig to not be function calls
        var defaultConfig = _getDefaultAppInsightsChannelConfig();
        HelperFuncs_objForEachKey(defaultConfig, function (field, value) {
          _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][field] = function () {
            var theValue = ctx.getConfig(identifier, field, value());
            if (!theValue && field === "endpointUrl") {
              // Use the default value (handles empty string in the configuration)
              theValue = value();
            }
            return theValue;
          };
        });
        _self._buffer = _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_ENABLE_SESSION_STORA4 /* @min:%2eenableSessionStorageBuffer */]() && utlCanUseSessionStorage() ? new SessionStorageSendBuffer(diagLog, _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */]) : new ArraySendBuffer(diagLog, _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */]);
        _self._sample = new Sample(_self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DynamicConstants_DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */](), diagLog);
        if (!_validateInstrumentationKey(config)) {
          _throwInternal(diagLog, 1 /* eLoggingSeverity.CRITICAL */, 100 /* _eInternalMessageId.InvalidInstrumentationKey */, "Invalid Instrumentation key " + config[_DynamicConstants_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */]);
        }

        if (!isInternalApplicationInsightsEndpoint(_self._senderConfig.endpointUrl()) && _self._senderConfig.customHeaders() && _self._senderConfig.customHeaders()[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
          HelperFuncs_arrForEach(_self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_CUSTOM_HEADERS /* @min:%2ecustomHeaders */](), function (customHeader) {
            _this.addHeader(customHeader.header, customHeader.value);
          });
        }
        var senderConfig = _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */];
        var sendPostFunc = null;
        if (!senderConfig[_DYN_DISABLE_XHR /* @min:%2edisableXhr */]() && useXDomainRequest()) {
          sendPostFunc = _xdrSender; // IE 8 and 9
        } else if (!senderConfig[_DYN_DISABLE_XHR /* @min:%2edisableXhr */]() && isXhrSupported()) {
          sendPostFunc = _xhrSender;
        }
        if (!sendPostFunc && isFetchSupported()) {
          sendPostFunc = _fetchSender;
        }
        // always fallback to XHR
        _fallbackSender = sendPostFunc || _xhrSender;
        if (!senderConfig[_DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */]() && isBeaconsSupported()) {
          // Config is set to always used beacon sending
          sendPostFunc = _beaconSender;
        }
        _self[_DYN__SENDER /* @min:%2e_sender */] = sendPostFunc || _xhrSender;
        if (!senderConfig[_DYN_ONUNLOAD_DISABLE_FET5 /* @min:%2eonunloadDisableFetch */]() && isFetchSupported(true)) {
          // Try and use the fetch with keepalive
          _syncUnloadSender = _fetchKeepAliveSender;
        } else if (isBeaconsSupported()) {
          // Try and use sendBeacon
          _syncUnloadSender = _beaconSender;
        } else if (!senderConfig[_DYN_DISABLE_XHR /* @min:%2edisableXhr */]() && useXDomainRequest()) {
          _syncUnloadSender = _xdrSender; // IE 8 and 9
        } else if (!senderConfig[_DYN_DISABLE_XHR /* @min:%2edisableXhr */]() && isXhrSupported()) {
          _syncUnloadSender = _xhrSender;
        } else {
          _syncUnloadSender = _fallbackSender;
        }
      };
      _self.processTelemetry = function (telemetryItem, itemCtx) {
        itemCtx = _self._getTelCtx(itemCtx);
        var diagLogger = itemCtx[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */]();
        try {
          // if master off switch is set, don't send any data
          if (_self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_DISABLE_TELEMETRY /* @min:%2edisableTelemetry */]()) {
            // Do not send/save data
            return;
          }
          // validate input
          if (!telemetryItem) {
            _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 7 /* _eInternalMessageId.CannotSendEmptyTelemetry */, "Cannot send empty telemetry");
            return;
          }
          // validate event
          if (telemetryItem.baseData && !telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */]) {
            _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 70 /* _eInternalMessageId.InvalidEvent */, "Cannot send telemetry without baseData and baseType");
            return;
          }
          if (!telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */]) {
            // Default
            telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */] = "EventData";
          }
          // ensure a sender was constructed
          if (!_self[_DYN__SENDER /* @min:%2e_sender */]) {
            _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender was not initialized");
            return;
          }
          // check if this item should be sampled in, else add sampleRate tag
          if (!_isSampledIn(telemetryItem)) {
            // Item is sampled out, do not send it
            _throwInternal(diagLogger, 2 /* eLoggingSeverity.WARNING */, 33 /* _eInternalMessageId.TelemetrySampledAndNotSent */, "Telemetry item was sampled out and not sent", {
              SampleRate: _self._sample[_DYN_SAMPLE_RATE /* @min:%2esampleRate */]
            });
            return;
          } else {
            telemetryItem[SampleRate] = _self._sample[_DYN_SAMPLE_RATE /* @min:%2esampleRate */];
          }

          var convertUndefined = _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_CONVERT_UNDEFINED /* @min:%2econvertUndefined */]() || undefined;
          // construct an envelope that Application Insights endpoint can understand
          // if ikey of telemetry is provided and not empty, envelope will use this iKey instead of senderConfig iKey
          var defaultEnvelopeIkey = telemetryItem.iKey || _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DynamicConstants_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */]();
          var aiEnvelope_1 = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, convertUndefined);
          if (!aiEnvelope_1) {
            _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 47 /* _eInternalMessageId.CreateEnvelopeError */, "Unable to create an AppInsights envelope");
            return;
          }
          var doNotSendItem_1 = false;
          // this is for running in legacy mode, where customer may already have a custom initializer present
          if (telemetryItem[_DYN_TAGS /* @min:%2etags */] && telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy]) {
            HelperFuncs_arrForEach(telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy], function (callBack) {
              try {
                if (callBack && callBack(aiEnvelope_1) === false) {
                  doNotSendItem_1 = true;
                  _warnToConsole(diagLogger, "Telemetry processor check returns false");
                }
              } catch (e) {
                // log error but dont stop executing rest of the telemetry initializers
                // doNotSendItem = true;
                _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "One of telemetry initializers failed, telemetry item will not be sent: " + getExceptionName(e), {
                  exception: dumpObj(e)
                }, true);
              }
            });
            delete telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy];
          }
          if (doNotSendItem_1) {
            return; // do not send, no need to execute next plugin
          }
          // check if the incoming payload is too large, truncate if necessary
          var payload = _serializer.serialize(aiEnvelope_1);
          // flush if we would exceed the max-size limit by adding this item
          var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
          var bufferSize = buffer.size();
          if (bufferSize + payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:%2emaxBatchSizeInBytes */]()) {
            _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, null, 10 /* SendRequestReason.MaxBatchSize */);
          }
          // enqueue the payload
          buffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
          // ensure an invocation timeout is set
          _setupTimer();
        } catch (e) {
          _throwInternal(diagLogger, 2 /* eLoggingSeverity.WARNING */, 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + getExceptionName(e), {
            exception: dumpObj(e)
          });
        }
        // hand off the telemetry item to the next plugin
        _self.processNext(telemetryItem, itemCtx);
      };
      /**
       * xhr state changes
       */
      _self[_DYN__XHR_READY_STATE_CHA6 /* @min:%2e_xhrReadyStateChange */] = function (xhr, payload, countOfItemsInPayload) {
        if (xhr.readyState === 4) {
          _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, _formatErrorMessageXhr(xhr), _getResponseText(xhr) || xhr.response);
        }
      };
      /**
       * Immediately send buffered data
       * @param async {boolean} - Indicates if the events should be sent asynchronously
       * @param forcedSender {SenderFunction} - Indicates the forcedSender, undefined if not passed
       */
      _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */] = function (async, forcedSender, sendReason) {
        if (async === void 0) {
          async = true;
        }
        if (!_paused) {
          try {
            var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
            // Send data only if disableTelemetry is false
            if (!_self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_DISABLE_TELEMETRY /* @min:%2edisableTelemetry */]()) {
              if (buffer[_DynamicConstants_DYN_COUNT /* @min:%2ecount */]() > 0) {
                var payload = buffer.getItems();
                _notifySendRequest(sendReason || 0 /* SendRequestReason.Undefined */, async);
                // invoke send
                if (forcedSender) {
                  forcedSender.call(_this, payload, async);
                } else {
                  _self[_DYN__SENDER /* @min:%2e_sender */](payload, async);
                }
              }
              // update lastSend time to enable throttling
              _lastSend = +new Date();
            } else {
              buffer[_DYN_CLEAR /* @min:%2eclear */]();
            }

            _clearScheduledTimer();
          } catch (e) {
            /* Ignore this error for IE under v10 */
            var ieVer = getIEVersion();
            if (!ieVer || ieVer > 9) {
              _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 40 /* _eInternalMessageId.TransmissionFailed */, "Telemetry transmission failed, some telemetry will be lost: " + getExceptionName(e), {
                exception: dumpObj(e)
              });
            }
          }
        }
      };
      _self._doTeardown = function (unloadCtx, unloadState) {
        _self.onunloadFlush();
        _offlineListener.unload();
        _initDefaults();
      };
      /**
       * error handler
       */
      _self[_DYN__ON_ERROR /* @min:%2e_onError */] = function (payload, message, event) {
        _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 26 /* _eInternalMessageId.OnError */, "Failed to send telemetry.", {
          message: message
        });
        _self._buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
      };
      /**
       * partial success handler
       */
      _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */] = function (payload, results) {
        var failed = [];
        var retry = [];
        // Iterate through the reversed array of errors so that splicing doesn't have invalid indexes after the first item.
        var errors = results.errors.reverse();
        for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
          var error = errors_1[_i];
          var extracted = payload.splice(error.index, 1)[0];
          if (_isRetriable(error.statusCode)) {
            retry[dist_esm_DynamicConstants_DYN_PUSH /* @min:%2epush */](extracted);
          } else {
            // All other errors, including: 402 (Monthly quota exceeded) and 439 (Too many requests and refresh cache).
            failed[dist_esm_DynamicConstants_DYN_PUSH /* @min:%2epush */](extracted);
          }
        }
        if (payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
          _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */]);
        }

        if (failed[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
          _self[_DYN__ON_ERROR /* @min:%2e_onError */](failed, _formatErrorMessageXhr(null, ["partial success", results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */], "of", results.itemsReceived].join(" ")));
        }
        if (retry[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
          _resendPayload(retry);
          _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, "Partial success. " + "Delivered: " + payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] + ", Failed: " + failed[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] + ". Will retry to send " + retry[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] + " our of " + results[_DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */] + " items");
        }
      };
      /**
       * success handler
       */
      _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */] = function (payload, countOfItemsInPayload) {
        _self._buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
      };
      /**
       * xdr state changes
       */
      _self._xdrOnLoad = function (xdr, payload) {
        var responseText = _getResponseText(xdr);
        if (xdr && (responseText + "" === "200" || responseText === "")) {
          _consecutiveErrors = 0;
          _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, 0);
        } else {
          var results = _parseResponse(responseText);
          if (results && results.itemsReceived && results.itemsReceived > results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */] && !_self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_IS_RETRY_DISABLED /* @min:%2eisRetryDisabled */]()) {
            _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */](payload, results);
          } else {
            _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, _formatErrorMessageXdr(xdr));
          }
        }
      };
      function _isSampledIn(envelope) {
        return _self._sample.isSampledIn(envelope);
      }
      function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
        var response = null;
        if (!_self._appId) {
          response = _parseResponse(res);
          if (response && response.appId) {
            _self._appId = response.appId;
          }
        }
        if ((status < 200 || status >= 300) && status !== 0) {
          // Update End Point url if permanent redirect or moved permanently
          // Updates the end point url before retry
          if (status === 301 || status === 307 || status === 308) {
            if (!_checkAndUpdateEndPointUrl(responseUrl)) {
              _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
              return;
            }
          }
          if (!_self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_IS_RETRY_DISABLED /* @min:%2eisRetryDisabled */]() && _isRetriable(status)) {
            _resendPayload(payload);
            _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Response code " + status + ". Will retry to send " + payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] + " items.");
          } else {
            _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
          }
        } else if (_offlineListener && !_offlineListener.isOnline()) {
          // offline
          // Note: Don't check for status == 0, since adblock gives this code
          if (!_self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_IS_RETRY_DISABLED /* @min:%2eisRetryDisabled */]()) {
            var offlineBackOffMultiplier = 10; // arbritrary number
            _resendPayload(payload, offlineBackOffMultiplier);
            _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
          }
        } else {
          // check if the xhr's responseURL or fetch's response.url is same as endpoint url
          // TODO after 10 redirects force send telemetry with 'redirect=false' as query parameter.
          _checkAndUpdateEndPointUrl(responseUrl);
          if (status === 206) {
            if (!response) {
              response = _parseResponse(res);
            }
            if (response && !_self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_IS_RETRY_DISABLED /* @min:%2eisRetryDisabled */]()) {
              _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */](payload, response);
            } else {
              _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
            }
          } else {
            _consecutiveErrors = 0;
            _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, countOfItemsInPayload);
          }
        }
      }
      function _checkAndUpdateEndPointUrl(responseUrl) {
        // Maximum stamp specific redirects allowed(uncomment this when breeze is ready with not allowing redirects feature)
        if (_stamp_specific_redirects >= 10) {
          //  _self._senderConfig.endpointUrl = () => Sender._getDefaultAppInsightsChannelConfig().endpointUrl()+"/?redirect=false";
          //  _stamp_specific_redirects = 0;
          return false;
        }
        if (!isNullOrUndefined(responseUrl) && responseUrl !== "") {
          if (responseUrl !== _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */]()) {
            _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */] = function () {
              return responseUrl;
            };
            ++_stamp_specific_redirects;
            return true;
          }
        }
        return false;
      }
      function _doUnloadSend(payload, isAsync) {
        if (_syncUnloadSender) {
          // We are unloading so always call the sender with sync set to false
          _syncUnloadSender(payload, false);
        } else {
          // Fallback to the previous beacon Sender (which causes a CORB warning on chrome now)
          _beaconSender(payload, isAsync);
        }
      }
      function _doBeaconSend(payload) {
        var nav = getNavigator();
        var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
        var url = _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */]();
        var batch = _self._buffer[_DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */](payload);
        // Chrome only allows CORS-safelisted values for the sendBeacon data argument
        // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
        var plainTextBatch = new Blob([batch], {
          type: "text/plain;charset=UTF-8"
        });
        // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
        var queued = nav.sendBeacon(url, plainTextBatch);
        if (queued) {
          buffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](payload);
          // no response from beaconSender, clear buffer
          _self._onSuccess(payload, payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]);
        }

        return queued;
      }
      /**
       * Send Beacon API request
       * @param payload {string} - The data payload to be sent.
       * @param isAsync {boolean} - not used
       * Note: Beacon API does not support custom headers and we are not able to get
       * appId from the backend for the correct correlation.
       */
      function _beaconSender(payload, isAsync) {
        if (HelperFuncs_isArray(payload) && payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
          // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
          if (!_doBeaconSend(payload)) {
            // Failed to send entire payload so try and split data and try to send as much events as possible
            var droppedPayload = [];
            for (var lp = 0; lp < payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
              var thePayload = payload[lp];
              if (!_doBeaconSend([thePayload])) {
                // Can't send anymore, so split the batch and drop the rest
                droppedPayload[dist_esm_DynamicConstants_DYN_PUSH /* @min:%2epush */](thePayload);
              }
            }
            if (droppedPayload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
              _fallbackSender && _fallbackSender(droppedPayload, true);
              _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
            }
          }
        }
      }
      /**
       * Send XMLHttpRequest
       * @param payload {string} - The data payload to be sent.
       * @param isAsync {boolean} - Indicates if the request should be sent asynchronously
       */
      function _xhrSender(payload, isAsync) {
        var xhr = new XMLHttpRequest();
        var endPointUrl = _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */]();
        try {
          xhr[DisabledPropertyName] = true;
        } catch (e) {
          // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
          // cause the request to fail and we no telemetry would be sent
        }
        xhr.open("POST", endPointUrl, isAsync);
        xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */]("Content-type", "application/json");
        // append Sdk-Context request header only in case of breeze endpoint
        if (isInternalApplicationInsightsEndpoint(endPointUrl)) {
          xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[6], RequestHeaders[7]);
        }

        HelperFuncs_arrForEach(objKeys(_headers), function (headerName) {
          xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](headerName, _headers[headerName]);
        });
        xhr.onreadystatechange = function () {
          return _self._xhrReadyStateChange(xhr, payload, payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]);
        };
        xhr.onerror = function (event) {
          return _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, _formatErrorMessageXhr(xhr), event);
        };
        // compose an array of payloads
        var batch = _self._buffer[_DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */](payload);
        xhr.send(batch);
        _self._buffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](payload);
      }
      function _fetchKeepAliveSender(payload, isAsync) {
        if (HelperFuncs_isArray(payload)) {
          var payloadSize = payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
          for (var lp = 0; lp < payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
            payloadSize += payload[lp][applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
          }

          if (_syncFetchPayload + payloadSize <= FetchSyncRequestSizeLimitBytes) {
            _doFetchSender(payload, false);
          } else if (isBeaconsSupported()) {
            // Fallback to beacon sender as we at least get told which events can't be scheduled
            _beaconSender(payload, isAsync);
          } else {
            // Payload is going to be too big so just try and send via XHR
            _fallbackSender && _fallbackSender(payload, true);
            _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with xhrSender.");
          }
        }
      }
      /**
       * Send fetch API request
       * @param payload {string} - The data payload to be sent.
       * @param isAsync {boolean} - not used
       */
      function _fetchSender(payload, isAsync) {
        _doFetchSender(payload, true);
      }
      /**
       * Send fetch API request
       * @param payload {string} - The data payload to be sent.
       * @param isAsync {boolean} - For fetch this identifies whether we are "unloading" (false) or a normal request
       */
      function _doFetchSender(payload, isAsync) {
        var _a;
        var endPointUrl = _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */]();
        var batch = _self._buffer[_DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */](payload);
        var plainTextBatch = new Blob([batch], {
          type: "application/json"
        });
        var requestHeaders = new Headers();
        var batchLength = batch[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
        var ignoreResponse = false;
        var responseHandled = false;
        // append Sdk-Context request header only in case of breeze endpoint
        if (isInternalApplicationInsightsEndpoint(endPointUrl)) {
          requestHeaders.append(RequestHeaders[6], RequestHeaders[7]);
        }

        HelperFuncs_arrForEach(objKeys(_headers), function (headerName) {
          requestHeaders.append(headerName, _headers[headerName]);
        });
        var init = (_a = {
          method: "POST",
          headers: requestHeaders,
          body: plainTextBatch
        }, _a[DisabledPropertyName] = true // Mark so we don't attempt to track this request
        , _a);
        if (!isAsync) {
          init.keepalive = true;
          // As a sync request (during unload), it is unlikely that we will get a chance to process the response so
          // just like beacon send assume that the events have been accepted and processed
          ignoreResponse = true;
          _syncFetchPayload += batchLength;
        }
        var request = new Request(endPointUrl, init);
        try {
          // Also try and tag the request (just in case the value in init is not copied over)
          request[DisabledPropertyName] = true;
        } catch (e) {
          // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
          // cause the request to fail and we no telemetry would be sent
        }
        _self._buffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](payload);
        try {
          fetch(request).then(function (response) {
            if (!isAsync) {
              _syncFetchPayload -= batchLength;
              batchLength = 0;
            }
            if (!responseHandled) {
              responseHandled = true;
              /**
               * The Promise returned from fetch() won’t reject on HTTP error status even if the response is an HTTP 404 or 500.
               * Instead, it will resolve normally (with ok status set to false), and it will only reject on network failure
               * or if anything prevented the request from completing.
               */
              if (!response.ok) {
                _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, response.statusText);
              } else {
                response.text().then(function (text) {
                  _checkResponsStatus(response.status, payload, response.url, payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */], response.statusText, text);
                });
              }
            }
          })["catch"](function (error) {
            if (!isAsync) {
              _syncFetchPayload -= batchLength;
              batchLength = 0;
            }
            if (!responseHandled) {
              responseHandled = true;
              _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, error.message);
            }
          });
        } catch (e) {
          if (!responseHandled) {
            _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, dumpObj(e));
          }
        }
        if (ignoreResponse && !responseHandled) {
          // Assume success during unload processing as we most likely won't get the response
          responseHandled = true;
          _self._onSuccess(payload, payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]);
        }
      }
      /**
       * Parses the response from the backend.
       * @param response - XMLHttpRequest or XDomainRequest response
       */
      function _parseResponse(response) {
        try {
          if (response && response !== "") {
            var result = getJSON().parse(response);
            if (result && result.itemsReceived && result.itemsReceived >= result[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */] && result.itemsReceived - result.itemsAccepted === result.errors[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
              return result;
            }
          }
        } catch (e) {
          _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 43 /* _eInternalMessageId.InvalidBackendResponse */, "Cannot parse the response. " + getExceptionName(e), {
            response: response
          });
        }
        return null;
      }
      /**
       * Resend payload. Adds payload back to the send buffer and setup a send timer (with exponential backoff).
       * @param payload
       */
      function _resendPayload(payload, linearFactor) {
        if (linearFactor === void 0) {
          linearFactor = 1;
        }
        if (!payload || payload[applicationinsights_channel_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0) {
          return;
        }
        var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
        buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
        _consecutiveErrors++;
        for (var _i = 0, payload_1 = payload; _i < payload_1.length; _i++) {
          var item = payload_1[_i];
          buffer[_DYN_ENQUEUE /* @min:%2eenqueue */](item);
        }
        // setup timer
        _setRetryTime(linearFactor);
        _setupTimer();
      }
      /**
       * Calculates the time to wait before retrying in case of an error based on
       * http://en.wikipedia.org/wiki/Exponential_backoff
       */
      function _setRetryTime(linearFactor) {
        var SlotDelayInSeconds = 10;
        var delayInSeconds;
        if (_consecutiveErrors <= 1) {
          delayInSeconds = SlotDelayInSeconds;
        } else {
          var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
          // tslint:disable-next-line:insecure-random
          var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
          backOffDelay = linearFactor * backOffDelay;
          delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
        }
        // TODO: Log the backoff time like the C# version does.
        var retryAfterTimeSpan = dateNow() + delayInSeconds * 1000;
        // TODO: Log the retry at time like the C# version does.
        _retryAt = retryAfterTimeSpan;
      }
      /**
       * Sets up the timer which triggers actually sending the data.
       */
      function _setupTimer() {
        if (!_timeoutHandle && !_paused) {
          var retryInterval = _retryAt ? Math.max(0, _retryAt - dateNow()) : 0;
          var timerValue = Math.max(_self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_MAX_BATCH_INTERVAL /* @min:%2emaxBatchInterval */](), retryInterval);
          _timeoutHandle = setTimeout(function () {
            _timeoutHandle = null;
            _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, null, 1 /* SendRequestReason.NormalSchedule */);
          }, timerValue);
        }
      }
      function _clearScheduledTimer() {
        clearTimeout(_timeoutHandle);
        _timeoutHandle = null;
        _retryAt = null;
      }
      /**
       * Checks if the SDK should resend the payload after receiving this status code from the backend.
       * @param statusCode
       */
      function _isRetriable(statusCode) {
        return statusCode === 401 // Unauthorized
        || statusCode === 403 // Forbidden
        || statusCode === 408 // Timeout
        || statusCode === 429 // Too many requests.
        || statusCode === 500 // Internal server error.
        || statusCode === 502 // Bad Gateway.
        || statusCode === 503 // Service unavailable.
        || statusCode === 504; // Gateway timeout.
      }

      function _formatErrorMessageXhr(xhr, message) {
        if (xhr) {
          return "XMLHttpRequest,Status:" + xhr.status + ",Response:" + _getResponseText(xhr) || 0 || 0;
        }
        return message;
      }
      /**
       * Send XDomainRequest
       * @param payload {string} - The data payload to be sent.
       * @param isAsync {boolean} - Indicates if the request should be sent asynchronously
       *
       * Note: XDomainRequest does not support sync requests. This 'isAsync' parameter is added
       * to maintain consistency with the xhrSender's contract
       * Note: XDomainRequest does not support custom headers and we are not able to get
       * appId from the backend for the correct correlation.
       */
      function _xdrSender(payload, isAsync) {
        var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
        var _window = getWindow();
        var xdr = new XDomainRequest();
        xdr.onload = function () {
          return _self._xdrOnLoad(xdr, payload);
        };
        xdr.onerror = function (event) {
          return _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, _formatErrorMessageXdr(xdr), event);
        };
        // XDomainRequest requires the same protocol as the hosting page.
        // If the protocol doesn't match, we can't send the telemetry :(.
        var hostingProtocol = _window && _window.location && _window.location.protocol || "";
        if (_self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */]().lastIndexOf(hostingProtocol, 0) !== 0) {
          _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.");
          buffer[_DYN_CLEAR /* @min:%2eclear */]();
          return;
        }
        var endpointUrl = _self[_DYN__SENDER_CONFIG /* @min:%2e_senderConfig */][_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */]().replace(/^(https?:)/, "");
        xdr.open("POST", endpointUrl);
        // compose an array of payloads
        var batch = buffer[_DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */](payload);
        xdr.send(batch);
        buffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](payload);
      }
      function _formatErrorMessageXdr(xdr, message) {
        if (xdr) {
          return "XDomainRequest,Response:" + _getResponseText(xdr) || 0;
        }
        return message;
      }
      // Using function lookups for backward compatibility as the getNotifyMgr() did not exist until after v2.5.6
      function _getNotifyMgr() {
        var func = "getNotifyMgr";
        if (_self.core[func]) {
          return _self.core[func]();
        }
        // using _self.core['_notificationManager'] for backward compatibility
        return _self.core["_notificationManager"];
      }
      function _notifySendRequest(sendRequest, isAsync) {
        var manager = _getNotifyMgr();
        if (manager && manager[_DYN_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */]) {
          try {
            manager[_DYN_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */](sendRequest, isAsync);
          } catch (e) {
            _throwInternal(_self[dist_esm_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 74 /* _eInternalMessageId.NotificationException */, "send request notification failed: " + getExceptionName(e), {
              exception: dumpObj(e)
            });
          }
        }
      }
      /**
       * Validate UUID Format
       * Specs taken from https://tools.ietf.org/html/rfc4122 and breeze repo
       */
      function _validateInstrumentationKey(config) {
        var disableIKeyValidationFlag = isNullOrUndefined(config[_DYN_DISABLE_INSTRUMENTAT7 /* @min:%2edisableInstrumentationKeyValidation */]) ? false : config[_DYN_DISABLE_INSTRUMENTAT7 /* @min:%2edisableInstrumentationKeyValidation */];
        if (disableIKeyValidationFlag) {
          return true;
        }
        var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
        var regexp = new RegExp(UUID_Regex);
        return regexp.test(config[_DynamicConstants_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */]);
      }

      function _initDefaults() {
        _self[_DYN__SENDER /* @min:%2e_sender */] = null;
        _self[_DYN__BUFFER /* @min:%2e_buffer */] = null;
        _self._appId = null;
        _self._sample = null;
        _headers = {};
        _offlineListener = null;
        _consecutiveErrors = 0;
        _retryAt = null;
        _lastSend = null;
        _paused = false;
        _timeoutHandle = null;
        _serializer = null;
        _stamp_specific_redirects = 0;
        _syncFetchPayload = 0;
        _fallbackSender = null;
        _syncUnloadSender = null;
        _evtNamespace = null;
      }
    });
    return _this;
  }
  Sender.constructEnvelope = function (orig, iKey, logger, convertUndefined) {
    var envelope;
    if (iKey !== orig.iKey && !isNullOrUndefined(iKey)) {
      envelope = __assignFn(__assignFn({}, orig), {
        iKey: iKey
      });
    } else {
      envelope = orig;
    }
    var creator = EnvelopeTypeCreator[envelope.baseType] || EventEnvelopeCreator;
    return creator(logger, envelope, convertUndefined);
  };
  // Removed Stub for Sender.prototype.pause.
  // Removed Stub for Sender.prototype.resume.
  // Removed Stub for Sender.prototype.flush.
  // Removed Stub for Sender.prototype.onunloadFlush.
  // Removed Stub for Sender.prototype.initialize.
  // Removed Stub for Sender.prototype.processTelemetry.
  // Removed Stub for Sender.prototype._xhrReadyStateChange.
  // Removed Stub for Sender.prototype.triggerSend.
  // Removed Stub for Sender.prototype._onError.
  // Removed Stub for Sender.prototype._onPartialSuccess.
  // Removed Stub for Sender.prototype._onSuccess.
  // Removed Stub for Sender.prototype._xdrOnLoad.
  // Removed Stub for Sender.prototype.addHeader.
  return Sender;
}(BaseTelemetryPlugin);

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/ConnectionStringParser.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _FIELDS_SEPARATOR = ";";
var _FIELD_KEY_VALUE_SEPARATOR = "=";
function parseConnectionString(connectionString) {
  if (!connectionString) {
    return {};
  }
  var kvPairs = connectionString[_DynamicConstants_DYN_SPLIT /* @min:%2esplit */](_FIELDS_SEPARATOR);
  var result = arrReduce(kvPairs, function (fields, kv) {
    var kvParts = kv[_DynamicConstants_DYN_SPLIT /* @min:%2esplit */](_FIELD_KEY_VALUE_SEPARATOR);
    if (kvParts[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 2) {
      // only save fields with valid formats
      var key = kvParts[0][dist_esm_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
      var value = kvParts[1];
      fields[key] = value;
    }
    return fields;
  }, {});
  if (objKeys(result)[dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
    // this is a valid connection string, so parse the results
    if (result.endpointsuffix) {
      // use endpoint suffix where overrides are not provided
      var locationPrefix = result.location ? result.location + "." : "";
      result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] || "https://" + locationPrefix + "dc." + result.endpointsuffix;
    }
    // apply the default endpoints
    result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] || DEFAULT_BREEZE_ENDPOINT;
  }
  return result;
}
var ConnectionStringParser = {
  parse: parseConnectionString
};
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-common/dist-esm/Interfaces/IConfig.js
/*
 * Application Insights JavaScript SDK - Common, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var ConfigurationManager = /** @class */function () {
  function ConfigurationManager() {}
  ConfigurationManager.getConfig = function (config, field, identifier, defaultValue) {
    if (defaultValue === void 0) {
      defaultValue = false;
    }
    var configValue;
    if (identifier && config[_DYN_EXTENSION_CONFIG /* @min:%2eextensionConfig */] && config[_DYN_EXTENSION_CONFIG /* @min:%2eextensionConfig */][identifier] && !isNullOrUndefined(config[_DYN_EXTENSION_CONFIG /* @min:%2eextensionConfig */][identifier][field])) {
      configValue = config[_DYN_EXTENSION_CONFIG /* @min:%2eextensionConfig */][identifier][field];
    } else {
      configValue = config[field];
    }
    return !isNullOrUndefined(configValue) ? configValue : defaultValue;
  };
  return ConfigurationManager;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/ChannelController.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// 





var ChannelControllerPriority = 500;
var ChannelValidationMessage = "Channel has invalid priority - ";
function _addChannelQueue(channelQueue, queue, core) {
  if (queue && HelperFuncs_isArray(queue) && queue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
    queue = queue.sort(function (a, b) {
      return a[STR_PRIORITY /* @min:%2epriority */] - b[STR_PRIORITY /* @min:%2epriority */];
    });

    HelperFuncs_arrForEach(queue, function (queueItem) {
      if (queueItem[STR_PRIORITY /* @min:%2epriority */] < ChannelControllerPriority) {
        throwError(ChannelValidationMessage + queueItem[_DYN_IDENTIFIER /* @min:%2eidentifier */]);
      }
    });

    channelQueue[_DynamicConstants_DYN_PUSH /* @min:%2epush */]({
      queue: objFreeze(queue),
      chain: createTelemetryProxyChain(queue, core[_DYN_CONFIG /* @min:%2econfig */], core)
    });
  }
}
function createChannelControllerPlugin(channelQueue, core) {
  function _getTelCtx() {
    return createProcessTelemetryContext(null, core[_DYN_CONFIG /* @min:%2econfig */], core, null);
  }
  function _processChannelQueue(theChannels, itemCtx, processFn, onComplete) {
    var waiting = theChannels ? theChannels[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] + 1 : 1;
    function _runChainOnComplete() {
      waiting--;
      if (waiting === 0) {
        onComplete && onComplete();
        onComplete = null;
      }
    }
    if (waiting > 0) {
      HelperFuncs_arrForEach(theChannels, function (channels) {
        // pass on to first item in queue
        if (channels && channels.queue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
          var channelChain = channels.chain;
          var chainCtx = itemCtx[_DYN_CREATE_NEW /* @min:%2ecreateNew */](channelChain);
          chainCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](_runChainOnComplete);
          // Cause this chain to start processing
          processFn(chainCtx);
        } else {
          waiting--;
        }
      });
    }
    _runChainOnComplete();
  }
  function _doUpdate(updateCtx, updateState) {
    var theUpdateState = updateState || {
      reason: 0 /* TelemetryUpdateReason.Unknown */
    };

    _processChannelQueue(channelQueue, updateCtx, function (chainCtx) {
      chainCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](theUpdateState);
    }, function () {
      updateCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](theUpdateState);
    });
    return true;
  }
  function _doTeardown(unloadCtx, unloadState) {
    var theUnloadState = unloadState || {
      reason: 0 /* TelemetryUnloadReason.ManualTeardown */,
      isAsync: false
    };
    _processChannelQueue(channelQueue, unloadCtx, function (chainCtx) {
      chainCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](theUnloadState);
    }, function () {
      unloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](theUnloadState);
      isInitialized = false;
    });
    return true;
  }
  function _getChannel(pluginIdentifier) {
    var thePlugin = null;
    if (channelQueue && channelQueue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
      HelperFuncs_arrForEach(channelQueue, function (channels) {
        // pass on to first item in queue
        if (channels && channels.queue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
          HelperFuncs_arrForEach(channels.queue, function (ext) {
            if (ext[_DYN_IDENTIFIER /* @min:%2eidentifier */] === pluginIdentifier) {
              thePlugin = ext;
              // Cause arrForEach to stop iterating
              return -1;
            }
          });
          if (thePlugin) {
            // Cause arrForEach to stop iterating
            return -1;
          }
        }
      });
    }
    return thePlugin;
  }
  var isInitialized = false;
  var channelController = {
    identifier: "ChannelControllerPlugin",
    priority: ChannelControllerPriority,
    initialize: function (config, core, extensions, pluginChain) {
      isInitialized = true;
      HelperFuncs_arrForEach(channelQueue, function (channels) {
        if (channels && channels.queue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
          initializePlugins(createProcessTelemetryContext(channels.chain, config, core), extensions);
        }
      });
    },
    isInitialized: function () {
      return isInitialized;
    },
    processTelemetry: function (item, itemCtx) {
      _processChannelQueue(channelQueue, itemCtx || _getTelCtx(), function (chainCtx) {
        chainCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](item);
      }, function () {
        itemCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](item);
      });
    },
    update: _doUpdate,
    pause: function () {
      _processChannelQueue(channelQueue, _getTelCtx(), function (chainCtx) {
        chainCtx.iterate(function (plugin) {
          plugin.pause && plugin.pause();
        });
      }, null);
    },
    resume: function () {
      _processChannelQueue(channelQueue, _getTelCtx(), function (chainCtx) {
        chainCtx.iterate(function (plugin) {
          plugin.resume && plugin.resume();
        });
      }, null);
    },
    teardown: _doTeardown,
    getChannel: _getChannel,
    flush: function (isAsync, callBack, sendReason, cbTimeout) {
      // Setting waiting to one so that we don't call the callBack until we finish iterating
      var waiting = 1;
      var doneIterating = false;
      var cbTimer = null;
      cbTimeout = cbTimeout || 5000;
      function doCallback() {
        waiting--;
        if (doneIterating && waiting === 0) {
          if (cbTimer) {
            clearTimeout(cbTimer);
            cbTimer = null;
          }
          callBack && callBack(doneIterating);
          callBack = null;
        }
      }
      _processChannelQueue(channelQueue, _getTelCtx(), function (chainCtx) {
        chainCtx.iterate(function (plugin) {
          if (plugin[_DYN_FLUSH /* @min:%2eflush */]) {
            waiting++;
            var handled_1 = false;
            // Not all channels will call this callback for every scenario
            if (!plugin[_DYN_FLUSH /* @min:%2eflush */](isAsync, function () {
              handled_1 = true;
              doCallback();
            }, sendReason)) {
              if (!handled_1) {
                // If any channel doesn't return true and it didn't call the callback, then we should assume that the callback
                // will never be called, so use a timeout to allow the channel(s) some time to "finish" before triggering any
                // followup function (such as unloading)
                if (isAsync && cbTimer == null) {
                  cbTimer = setTimeout(function () {
                    cbTimer = null;
                    doCallback();
                  }, cbTimeout);
                } else {
                  doCallback();
                }
              }
            }
          }
        });
      }, function () {
        doneIterating = true;
        doCallback();
      });
      return true;
    },
    _setQueue: function (queue) {
      channelQueue = queue;
    }
  };
  return channelController;
}
function createChannelQueues(channels, extensions, core) {
  var channelQueue = [];
  if (channels) {
    // Add and sort the configuration channel queues
    HelperFuncs_arrForEach(channels, function (queue) {
      return _addChannelQueue(channelQueue, queue, core);
    });
  }
  if (extensions) {
    // Create a new channel queue for any extensions with a priority > the ChannelControllerPriority
    var extensionQueue_1 = [];
    HelperFuncs_arrForEach(extensions, function (plugin) {
      if (plugin[STR_PRIORITY /* @min:%2epriority */] > ChannelControllerPriority) {
        extensionQueue_1[_DynamicConstants_DYN_PUSH /* @min:%2epush */](plugin);
      }
    });
    _addChannelQueue(channelQueue, extensionQueue_1, core);
  }
  return channelQueue;
}
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/TelemetryInitializerPlugin.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// 
// 








var TelemetryInitializerPlugin = /** @class */function (_super) {
  __extendsFn(TelemetryInitializerPlugin, _super);
  function TelemetryInitializerPlugin() {
    var _this = _super.call(this) || this;
    _this.identifier = "TelemetryInitializerPlugin";
    _this.priority = 199;
    // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
    var _id;
    var _initializers;
    _initDefaults();
    dynamicProto(TelemetryInitializerPlugin, _this, function (_self, _base) {
      _self.addTelemetryInitializer = function (telemetryInitializer) {
        var theInitializer = {
          id: _id++,
          fn: telemetryInitializer
        };
        _initializers[_DynamicConstants_DYN_PUSH /* @min:%2epush */](theInitializer);
        var handler = {
          remove: function () {
            HelperFuncs_arrForEach(_initializers, function (initializer, idx) {
              if (initializer.id === theInitializer.id) {
                _initializers[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                return -1;
              }
            });
          }
        };
        return handler;
      };
      _self[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */] = function (item, itemCtx) {
        var doNotSendItem = false;
        var telemetryInitializersCount = _initializers[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
        for (var i = 0; i < telemetryInitializersCount; ++i) {
          var telemetryInitializer = _initializers[i];
          if (telemetryInitializer) {
            try {
              if (telemetryInitializer.fn[_DYN_APPLY /* @min:%2eapply */](null, [item]) === false) {
                doNotSendItem = true;
                break;
              }
            } catch (e) {
              // log error but dont stop executing rest of the telemetry initializers
              // doNotSendItem = true;
              _throwInternal(itemCtx[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "One of telemetry initializers failed, telemetry item will not be sent: " + getExceptionName(e), {
                exception: dumpObj(e)
              }, true);
            }
          }
        }
        if (!doNotSendItem) {
          _self[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](item, itemCtx);
        }
      };
      _self[_DynamicConstants_DYN_DO_TEARDOWN /* @min:%2e_doTeardown */] = function () {
        _initDefaults();
      };
    });
    function _initDefaults() {
      _id = 0;
      _initializers = [];
    }
    return _this;
  }
  // Removed Stub for TelemetryInitializerPlugin.prototype.addTelemetryInitializer.
  // Removed Stub for TelemetryInitializerPlugin.prototype.processTelemetry.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  TelemetryInitializerPlugin.__ieDyn = 1;
  return TelemetryInitializerPlugin;
}(BaseTelemetryPlugin);

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/BaseCore.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



















var strValidationError = "Plugins must provide initialize method";
var strNotificationManager = "_notificationManager";
var strSdkUnloadingError = "SDK is still unloading...";
var strSdkNotInitialized = "SDK is not initialized";
// const strPluginUnloadFailed = "Failed to unload plugin";
var defaultInitConfig = {
  // Have the Diagnostic Logger default to log critical errors to the console
  loggingLevelConsole: 1 /* eLoggingSeverity.CRITICAL */
};
/**
 * Helper to create the default performance manager
 * @param core
 * @param notificationMgr
 */
function _createPerfManager(core, notificationMgr) {
  return new PerfManager(notificationMgr);
}
function _validateExtensions(logger, channelPriority, allExtensions) {
  var _a;
  // Concat all available extensions
  var coreExtensions = [];
  // Check if any two extensions have the same priority, then warn to console
  // And extract the local extensions from the
  var extPriorities = {};
  // Extension validation
  HelperFuncs_arrForEach(allExtensions, function (ext) {
    // Check for ext.initialize
    if (isNullOrUndefined(ext) || isNullOrUndefined(ext[_DYN_INITIALIZE /* @min:%2einitialize */])) {
      throwError(strValidationError);
    }
    var extPriority = ext[STR_PRIORITY /* @min:%2epriority */];
    var identifier = ext[_DYN_IDENTIFIER /* @min:%2eidentifier */];
    if (ext && extPriority) {
      if (!isNullOrUndefined(extPriorities[extPriority])) {
        _warnToConsole(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
      } else {
        // set a value
        extPriorities[extPriority] = identifier;
      }
    }
    // Split extensions to core and channelController
    if (!extPriority || extPriority < channelPriority) {
      // Add to core extension that will be managed by BaseCore
      coreExtensions[_DynamicConstants_DYN_PUSH /* @min:%2epush */](ext);
    }
  });
  return _a = {
    all: allExtensions
  }, _a[STR_CORE /* @min:core */] = coreExtensions, _a;
}
function _isPluginPresent(thePlugin, plugins) {
  var exists = false;
  HelperFuncs_arrForEach(plugins, function (plugin) {
    if (plugin === thePlugin) {
      exists = true;
      return -1;
    }
  });
  return exists;
}
function _createDummyNotificationManager() {
  var _a;
  return objCreateFn((_a = {}, _a[_DYN_ADD_NOTIFICATION_LIS1 /* @min:addNotificationListener */] = function (listener) {}, _a[_DYN_REMOVE_NOTIFICATION_2 /* @min:removeNotificationListener */] = function (listener) {}, _a[STR_EVENTS_SENT /* @min:eventsSent */] = function (events) {}, _a[STR_EVENTS_DISCARDED /* @min:eventsDiscarded */] = function (events, reason) {}, _a[STR_EVENTS_SEND_REQUEST /* @min:eventsSendRequest */] = function (sendReason, isAsync) {}, _a));
}
var BaseCore = /** @class */function () {
  function BaseCore() {
    // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
    var _config;
    var _isInitialized;
    var _eventQueue;
    var _notificationManager;
    var _perfManager;
    var _cfgPerfManager;
    var _cookieManager;
    var _pluginChain;
    var _configExtensions;
    var _coreExtensions;
    var _channelControl;
    var _channelConfig;
    var _channelQueue;
    var _isUnloading;
    var _telemetryInitializerPlugin;
    var _internalLogsEventName;
    var _evtNamespace;
    var _unloadHandlers;
    var _debugListener;
    var _traceCtx;
    /**
     * Internal log poller
     */
    var _internalLogPoller = 0;
    dynamicProto(BaseCore, this, function (_self) {
      // Set the default values (also called during teardown)
      _initDefaults();
      _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = function () {
        return _isInitialized;
      };
      // Creating the self.initialize = ()
      _self[_DYN_INITIALIZE /* @min:%2einitialize */] = function (config, extensions, logger, notificationManager) {
        if (_isUnloading) {
          throwError(strSdkUnloadingError);
        }
        // Make sure core is only initialized once
        if (_self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
          throwError("Core should not be initialized more than once");
        }
        _config = config || {};
        _self[_DYN_CONFIG /* @min:%2econfig */] = _config;
        if (isNullOrUndefined(config[_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */])) {
          throwError("Please provide instrumentation key");
        }
        _notificationManager = notificationManager;
        // For backward compatibility only
        _self[strNotificationManager] = notificationManager;
        _initDebugListener();
        _initPerfManager();
        // add notification to the extensions in the config so other plugins can access it
        _initExtConfig();
        if (logger) {
          _self[_DYN_LOGGER /* @min:%2elogger */] = logger;
        }
        var cfgExtensions = getSetValue(_config, STR_EXTENSIONS, []);
        // Extension validation
        _configExtensions = [];
        _configExtensions[_DynamicConstants_DYN_PUSH /* @min:%2epush */].apply(_configExtensions, __spreadArrayFn(__spreadArrayFn([], extensions, false), cfgExtensions, false));
        _channelConfig = getSetValue(_config, STR_CHANNELS, []);
        _initPluginChain(null);
        if (!_channelQueue || _channelQueue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0) {
          throwError("No " + STR_CHANNELS + " available");
        }
        _isInitialized = true;
        _self.releaseQueue();
      };
      _self.getTransmissionControls = function () {
        var controls = [];
        if (_channelQueue) {
          HelperFuncs_arrForEach(_channelQueue, function (channels) {
            controls[_DynamicConstants_DYN_PUSH /* @min:%2epush */](channels.queue);
          });
        }
        return objFreeze(controls);
      };
      _self.track = function (telemetryItem) {
        // setup default iKey if not passed in
        telemetryItem.iKey = telemetryItem.iKey || _config[_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */];
        // add default timestamp if not passed in
        telemetryItem[_DYN_TIME /* @min:%2etime */] = telemetryItem[_DYN_TIME /* @min:%2etime */] || toISOString(new Date());
        // Common Schema 4.0
        telemetryItem.ver = telemetryItem.ver || "4.0";
        if (!_isUnloading && _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
          // Process the telemetry plugin chain
          _createTelCtx()[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](telemetryItem);
        } else {
          // Queue events until all extensions are initialized
          _eventQueue[_DynamicConstants_DYN_PUSH /* @min:%2epush */](telemetryItem);
        }
      };
      _self[_DYN_GET_PROCESS_TEL_CONT0 /* @min:%2egetProcessTelContext */] = _createTelCtx;
      _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */] = function () {
        if (!_notificationManager) {
          // Create Dummy notification manager
          _notificationManager = _createDummyNotificationManager();
          // For backward compatibility only
          _self[strNotificationManager] = _notificationManager;
        }
        return _notificationManager;
      };
      /**
       * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
       * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
       * called.
       * @param {INotificationListener} listener - An INotificationListener object.
       */
      _self[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */] = function (listener) {
        if (_notificationManager) {
          _notificationManager[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */](listener);
        }
      };
      /**
       * Removes all instances of the listener.
       * @param {INotificationListener} listener - INotificationListener to remove.
       */
      _self[_DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */] = function (listener) {
        if (_notificationManager) {
          _notificationManager[_DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */](listener);
        }
      };
      _self.getCookieMgr = function () {
        if (!_cookieManager) {
          _cookieManager = createCookieMgr(_config, _self[_DYN_LOGGER /* @min:%2elogger */]);
        }

        return _cookieManager;
      };
      _self.setCookieMgr = function (cookieMgr) {
        _cookieManager = cookieMgr;
      };
      _self[STR_GET_PERF_MGR /* @min:%2egetPerfMgr */] = function () {
        if (!_perfManager && !_cfgPerfManager) {
          if (getCfgValue(_config.enablePerfMgr)) {
            var createPerfMgr = getCfgValue(_config[STR_CREATE_PERF_MGR /* @min:%2ecreatePerfMgr */]);
            if (HelperFuncs_isFunction(createPerfMgr)) {
              _cfgPerfManager = createPerfMgr(_self, _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]());
            }
          }
        }

        return _perfManager || _cfgPerfManager || getGblPerfMgr();
      };
      _self.setPerfMgr = function (perfMgr) {
        _perfManager = perfMgr;
      };
      _self.eventCnt = function () {
        return _eventQueue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
      };

      _self.releaseQueue = function () {
        if (_isInitialized && _eventQueue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
          var eventQueue = _eventQueue;
          _eventQueue = [];
          HelperFuncs_arrForEach(eventQueue, function (event) {
            _createTelCtx()[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](event);
          });
        }
      };
      /**
       * Periodically check logger.queue for log messages to be flushed
       */
      _self.pollInternalLogs = function (eventName) {
        _internalLogsEventName = eventName || null;
        var interval = getCfgValue(_config.diagnosticLogInterval);
        if (!interval || !(interval > 0)) {
          interval = 10000;
        }
        if (_internalLogPoller) {
          clearInterval(_internalLogPoller);
        }
        _internalLogPoller = setInterval(function () {
          _flushInternalLogs();
        }, interval);
        return _internalLogPoller;
      };
      /**
       * Stop polling log messages from logger.queue
       */
      _self[_DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */] = function () {
        if (_internalLogPoller) {
          clearInterval(_internalLogPoller);
          _internalLogPoller = 0;
          _flushInternalLogs();
        }
      };
      // Add addTelemetryInitializer
      proxyFunctions(_self, function () {
        return _telemetryInitializerPlugin;
      }, ["addTelemetryInitializer"]);
      _self.unload = function (isAsync, unloadComplete, cbTimeout) {
        var _a;
        if (isAsync === void 0) {
          isAsync = true;
        }
        if (!_isInitialized) {
          // The SDK is not initialized
          throwError(strSdkNotInitialized);
        }
        // Check if the SDK still unloading so throw
        if (_isUnloading) {
          // The SDK is already unloading
          throwError(strSdkUnloadingError);
        }
        var unloadState = (_a = {
          reason: 50 /* TelemetryUnloadReason.SdkUnload */
        }, _a[_DYN_IS_ASYNC /* @min:isAsync */] = isAsync, _a.flushComplete = false, _a);
        var processUnloadCtx = createProcessTelemetryUnloadContext(_getPluginChain(), _self);
        processUnloadCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](function () {
          _initDefaults();
          unloadComplete && unloadComplete(unloadState);
        }, _self);
        function _doUnload(flushComplete) {
          unloadState.flushComplete = flushComplete;
          _isUnloading = true;
          // Run all of the unload handlers first (before unloading the plugins)
          _unloadHandlers.run(processUnloadCtx, unloadState);
          // Stop polling the internal logs
          _self[_DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */]();
          // Start unloading the components, from this point onwards the SDK should be considered to be in an unstable state
          processUnloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
        }
        if (!_flushChannels(isAsync, _doUnload, 6 /* SendRequestReason.SdkUnload */, cbTimeout)) {
          _doUnload(false);
        }
      };
      _self[_DYN_GET_PLUGIN /* @min:%2egetPlugin */] = _getPlugin;
      _self.addPlugin = function (plugin, replaceExisting, isAsync, addCb) {
        if (!plugin) {
          addCb && addCb(false);
          _logOrThrowError(strValidationError);
          return;
        }
        var existingPlugin = _getPlugin(plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */]);
        if (existingPlugin && !replaceExisting) {
          addCb && addCb(false);
          _logOrThrowError("Plugin [" + plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] + "] is already loaded!");
          return;
        }
        var updateState = {
          reason: 16 /* TelemetryUpdateReason.PluginAdded */
        };

        function _addPlugin(removed) {
          _configExtensions[_DynamicConstants_DYN_PUSH /* @min:%2epush */](plugin);
          updateState.added = [plugin];
          // Re-Initialize the plugin chain
          _initPluginChain(updateState);
          addCb && addCb(true);
        }
        if (existingPlugin) {
          var removedPlugins_1 = [existingPlugin.plugin];
          var unloadState = {
            reason: 2 /* TelemetryUnloadReason.PluginReplace */,
            isAsync: !!isAsync
          };
          _removePlugins(removedPlugins_1, unloadState, function (removed) {
            if (!removed) {
              // Previous plugin was successfully removed or was not installed
              addCb && addCb(false);
            } else {
              updateState.removed = removedPlugins_1;
              updateState.reason |= 32 /* TelemetryUpdateReason.PluginRemoved */;
              _addPlugin(true);
            }
          });
        } else {
          _addPlugin(false);
        }
      };
      _self.evtNamespace = function () {
        return _evtNamespace;
      };
      _self[_DYN_FLUSH /* @min:%2eflush */] = _flushChannels;
      _self.getTraceCtx = function (createNew) {
        if (!_traceCtx) {
          _traceCtx = createDistributedTraceContext();
        }
        return _traceCtx;
      };
      _self.setTraceCtx = function (traceCtx) {
        _traceCtx = traceCtx || null;
      };
      // Create the addUnloadCb
      proxyFunctionAs(_self, "addUnloadCb", function () {
        return _unloadHandlers;
      }, "add");
      function _initDefaults() {
        _isInitialized = false;
        // Use a default logger so initialization errors are not dropped on the floor with full logging
        _config = objExtend(true, {}, defaultInitConfig);
        _self[_DYN_CONFIG /* @min:%2econfig */] = _config;
        _self[_DYN_LOGGER /* @min:%2elogger */] = new DiagnosticLogger(_config);
        _self[_DYN__EXTENSIONS /* @min:%2e_extensions */] = [];
        _telemetryInitializerPlugin = new TelemetryInitializerPlugin();
        _eventQueue = [];
        _notificationManager = null;
        _perfManager = null;
        _cfgPerfManager = null;
        _cookieManager = null;
        _pluginChain = null;
        _coreExtensions = null;
        _configExtensions = [];
        _channelControl = null;
        _channelConfig = null;
        _channelQueue = null;
        _isUnloading = false;
        _internalLogsEventName = null;
        _evtNamespace = createUniqueNamespace("AIBaseCore", true);
        _unloadHandlers = createUnloadHandlerContainer();
        _traceCtx = null;
      }
      function _createTelCtx() {
        return createProcessTelemetryContext(_getPluginChain(), _config, _self);
      }
      // Initialize or Re-initialize the plugins
      function _initPluginChain(updateState) {
        // Extension validation
        var theExtensions = _validateExtensions(_self[_DYN_LOGGER /* @min:%2elogger */], ChannelControllerPriority, _configExtensions);
        _coreExtensions = theExtensions[STR_CORE /* @min:%2ecore */];
        _pluginChain = null;
        // Sort the complete set of extensions by priority
        var allExtensions = theExtensions.all;
        // Initialize the Channel Queues and the channel plugins first
        _channelQueue = objFreeze(createChannelQueues(_channelConfig, allExtensions, _self));
        if (_channelControl) {
          // During add / remove of a plugin this may get called again, so don't re-add if already present
          // But we also want the controller as the last, so remove if already present
          // And reusing the existing instance, just in case an installed plugin has a reference and
          // is using it.
          var idx = arrIndexOf(allExtensions, _channelControl);
          if (idx !== -1) {
            allExtensions[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
          }
          idx = arrIndexOf(_coreExtensions, _channelControl);
          if (idx !== -1) {
            _coreExtensions[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
          }
          _channelControl._setQueue(_channelQueue);
        } else {
          _channelControl = createChannelControllerPlugin(_channelQueue, _self);
        }
        // Add on "channelController" as the last "plugin"
        allExtensions[_DynamicConstants_DYN_PUSH /* @min:%2epush */](_channelControl);
        _coreExtensions[_DynamicConstants_DYN_PUSH /* @min:%2epush */](_channelControl);
        // Required to allow plugins to call core.getPlugin() during their own initialization
        _self[_DYN__EXTENSIONS /* @min:%2e_extensions */] = sortPlugins(allExtensions);
        // Initialize the controls
        _channelControl[_DYN_INITIALIZE /* @min:%2einitialize */](_config, _self, allExtensions);
        initializePlugins(_createTelCtx(), allExtensions);
        // Now reset the extensions to just those being managed by Basecore
        _self[_DYN__EXTENSIONS /* @min:%2e_extensions */] = objFreeze(sortPlugins(_coreExtensions || [])).slice();
        if (updateState) {
          _doUpdate(updateState);
        }
      }
      function _getPlugin(pluginIdentifier) {
        var _a;
        var theExt = null;
        var thePlugin = null;
        HelperFuncs_arrForEach(_self[_DYN__EXTENSIONS /* @min:%2e_extensions */], function (ext) {
          if (ext[_DYN_IDENTIFIER /* @min:%2eidentifier */] === pluginIdentifier && ext !== _channelControl && ext !== _telemetryInitializerPlugin) {
            thePlugin = ext;
            return -1;
          }
        });
        if (!thePlugin && _channelControl) {
          // Check the channel Controller
          thePlugin = _channelControl.getChannel(pluginIdentifier);
        }
        if (thePlugin) {
          theExt = (_a = {
            plugin: thePlugin
          }, _a[_DYN_SET_ENABLED /* @min:setEnabled */] = function (enabled) {
            _getPluginState(thePlugin)[STR_DISABLED] = !enabled;
          }, _a.isEnabled = function () {
            var pluginState = _getPluginState(thePlugin);
            return !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] && !pluginState[STR_DISABLED];
          }, _a.remove = function (isAsync, removeCb) {
            var _a;
            if (isAsync === void 0) {
              isAsync = true;
            }
            var pluginsToRemove = [thePlugin];
            var unloadState = (_a = {
              reason: 1 /* TelemetryUnloadReason.PluginUnload */
            }, _a[_DYN_IS_ASYNC /* @min:isAsync */] = isAsync, _a);
            _removePlugins(pluginsToRemove, unloadState, function (removed) {
              if (removed) {
                // Re-Initialize the plugin chain
                _initPluginChain({
                  reason: 32 /* TelemetryUpdateReason.PluginRemoved */,
                  removed: pluginsToRemove
                });
              }
              removeCb && removeCb(removed);
            });
          }, _a);
        }
        return theExt;
      }
      function _getPluginChain() {
        if (!_pluginChain) {
          // copy the collection of extensions
          var extensions = (_coreExtensions || []).slice();
          // During add / remove this may get called again, so don't readd if already present
          if (arrIndexOf(extensions, _telemetryInitializerPlugin) === -1) {
            extensions[_DynamicConstants_DYN_PUSH /* @min:%2epush */](_telemetryInitializerPlugin);
          }
          _pluginChain = createTelemetryProxyChain(sortPlugins(extensions), _config, _self);
        }
        return _pluginChain;
      }
      function _removePlugins(thePlugins, unloadState, removeComplete) {
        if (thePlugins && thePlugins[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
          var unloadChain = createTelemetryProxyChain(thePlugins, _config, _self);
          var unloadCtx = createProcessTelemetryUnloadContext(unloadChain, _self);
          unloadCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](function () {
            var removed = false;
            // Remove the listed config extensions
            var newConfigExtensions = [];
            HelperFuncs_arrForEach(_configExtensions, function (plugin, idx) {
              if (!_isPluginPresent(plugin, thePlugins)) {
                newConfigExtensions[_DynamicConstants_DYN_PUSH /* @min:%2epush */](plugin);
              } else {
                removed = true;
              }
            });
            _configExtensions = newConfigExtensions;
            // Re-Create the channel config
            var newChannelConfig = [];
            if (_channelConfig) {
              HelperFuncs_arrForEach(_channelConfig, function (queue, idx) {
                var newQueue = [];
                HelperFuncs_arrForEach(queue, function (channel) {
                  if (!_isPluginPresent(channel, thePlugins)) {
                    newQueue[_DynamicConstants_DYN_PUSH /* @min:%2epush */](channel);
                  } else {
                    removed = true;
                  }
                });
                newChannelConfig[_DynamicConstants_DYN_PUSH /* @min:%2epush */](newQueue);
              });
              _channelConfig = newChannelConfig;
            }
            removeComplete && removeComplete(removed);
          });
          unloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
        } else {
          removeComplete(false);
        }
      }
      function _flushInternalLogs() {
        var queue = _self[_DYN_LOGGER /* @min:%2elogger */] ? _self[_DYN_LOGGER /* @min:%2elogger */].queue : [];
        if (queue) {
          HelperFuncs_arrForEach(queue, function (logMessage) {
            var _a;
            var item = (_a = {}, _a[_DynamicConstants_DYN_NAME /* @min:name */] = _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[_DYN_MESSAGE_ID /* @min:%2emessageId */], _a.iKey = getCfgValue(_config[_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */]), _a.time = toISOString(new Date()), _a.baseType = _InternalLogMessage.dataType, _a.baseData = {
              message: logMessage[_DYN_MESSAGE /* @min:%2emessage */]
            }, _a);
            _self.track(item);
          });
          queue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] = 0;
        }
      }
      function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
        if (_channelControl) {
          return _channelControl[_DYN_FLUSH /* @min:%2eflush */](isAsync, callBack, sendReason || 6 /* SendRequestReason.SdkUnload */, cbTimeout);
        }
        callBack && callBack(false);
        return true;
      }
      function _initDebugListener() {
        var disableDbgExt = getCfgValue(_config.disableDbgExt);
        if (disableDbgExt === true && _debugListener) {
          // Remove any previously loaded debug listener
          _notificationManager[_DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */](_debugListener);
          _debugListener = null;
        }
        if (_notificationManager && !_debugListener && disableDbgExt !== true) {
          _debugListener = getDebugListener(_config);
          _notificationManager[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */](_debugListener);
        }
      }
      function _initPerfManager() {
        var enablePerfMgr = getCfgValue(_config.enablePerfMgr);
        if (!enablePerfMgr && _cfgPerfManager) {
          // Remove any existing config based performance manager
          _cfgPerfManager = null;
        }
        if (enablePerfMgr) {
          // Set the performance manager creation function if not defined
          getSetValue(_config, STR_CREATE_PERF_MGR, _createPerfManager);
        }
      }
      function _initExtConfig() {
        var extConfig = getSetValue(_config, STR_EXTENSION_CONFIG, {});
        extConfig.NotificationManager = _notificationManager;
      }
      function _doUpdate(updateState) {
        var updateCtx = createProcessTelemetryUpdateContext(_getPluginChain(), _self);
        if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) {
          updateCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](updateState);
        }
      }
      function _logOrThrowError(message) {
        var logger = _self[_DYN_LOGGER /* @min:%2elogger */];
        if (logger) {
          // there should always be a logger
          _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, message);
        } else {
          throwError(message);
        }
      }
    });
  }
  // Removed Stub for BaseCore.prototype.initialize.
  // Removed Stub for BaseCore.prototype.getTransmissionControls.
  // Removed Stub for BaseCore.prototype.track.
  // Removed Stub for BaseCore.prototype.getProcessTelContext.
  // Removed Stub for BaseCore.prototype.getNotifyMgr.
  // Removed Stub for BaseCore.prototype.addNotificationListener.
  // Removed Stub for BaseCore.prototype.removeNotificationListener.
  // Removed Stub for BaseCore.prototype.getCookieMgr.
  // Removed Stub for BaseCore.prototype.setCookieMgr.
  // Removed Stub for BaseCore.prototype.getPerfMgr.
  // Removed Stub for BaseCore.prototype.setPerfMgr.
  // Removed Stub for BaseCore.prototype.eventCnt.
  // Removed Stub for BaseCore.prototype.pollInternalLogs.
  // Removed Stub for BaseCore.prototype.stopPollingInternalLogs.
  // Removed Stub for BaseCore.prototype.addTelemetryInitializer.
  // Removed Stub for BaseCore.prototype.unload.
  // Removed Stub for BaseCore.prototype.getPlugin.
  // Removed Stub for BaseCore.prototype.addPlugin.
  // Removed Stub for BaseCore.prototype.evtNamespace.
  // Removed Stub for BaseCore.prototype.addUnloadCb.
  // Removed Stub for BaseCore.prototype.flush.
  // Removed Stub for BaseCore.prototype.getTraceCtx.
  // Removed Stub for BaseCore.prototype.setTraceCtx.
  // Removed Stub for BaseCore.prototype.releaseQueue.
  // Removed Stub for BaseCore.prototype._updateHook.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  BaseCore.__ieDyn = 1;
  return BaseCore;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/NotificationManager.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





function _runListeners(listeners, name, isAsync, callback) {
  HelperFuncs_arrForEach(listeners, function (listener) {
    if (listener && listener[name]) {
      if (isAsync) {
        setTimeout(function () {
          return callback(listener);
        }, 0);
      } else {
        try {
          callback(listener);
        } catch (e) {
          // Catch errors to ensure we don't block sending the requests
        }
      }
    }
  });
}
/**
 * Class to manage sending notifications to all the listeners.
 */
var NotificationManager = /** @class */function () {
  function NotificationManager(config) {
    this.listeners = [];
    var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
    dynamicProto(NotificationManager, this, function (_self) {
      _self[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */] = function (listener) {
        _self.listeners[_DynamicConstants_DYN_PUSH /* @min:%2epush */](listener);
      };
      /**
       * Removes all instances of the listener.
       * @param {INotificationListener} listener - AWTNotificationListener to remove.
       */
      _self[_DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */] = function (listener) {
        var index = arrIndexOf(_self[_DYN_LISTENERS /* @min:%2elisteners */], listener);
        while (index > -1) {
          _self.listeners[_DYN_SPLICE /* @min:%2esplice */](index, 1);
          index = arrIndexOf(_self[_DYN_LISTENERS /* @min:%2elisteners */], listener);
        }
      };
      /**
       * Notification for events sent.
       * @param {ITelemetryItem[]} events - The array of events that have been sent.
       */
      _self[STR_EVENTS_SENT /* @min:%2eeventsSent */] = function (events) {
        _runListeners(_self[_DYN_LISTENERS /* @min:%2elisteners */], STR_EVENTS_SENT, true, function (listener) {
          listener[STR_EVENTS_SENT /* @min:%2eeventsSent */](events);
        });
      };
      /**
       * Notification for events being discarded.
       * @param {ITelemetryItem[]} events - The array of events that have been discarded by the SDK.
       * @param {number} reason           - The reason for which the SDK discarded the events. The EventsDiscardedReason
       * constant should be used to check the different values.
       */
      _self[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */] = function (events, reason) {
        _runListeners(_self[_DYN_LISTENERS /* @min:%2elisteners */], STR_EVENTS_DISCARDED, true, function (listener) {
          listener[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */](events, reason);
        });
      };
      /**
       * [Optional] A function called when the events have been requested to be sent to the sever.
       * @param {number} sendReason - The reason why the event batch is being sent.
       * @param {boolean} isAsync   - A flag which identifies whether the requests are being sent in an async or sync manner.
       */
      _self[STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */] = function (sendReason, isAsync) {
        _runListeners(_self[_DYN_LISTENERS /* @min:%2elisteners */], STR_EVENTS_SEND_REQUEST, isAsync, function (listener) {
          listener[STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */](sendReason, isAsync);
        });
      };
      _self[STR_PERF_EVENT /* @min:%2eperfEvent */] = function (perfEvent) {
        if (perfEvent) {
          // Send all events or only parent events
          if (perfEvtsSendAll || !perfEvent[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */]()) {
            _runListeners(_self[_DYN_LISTENERS /* @min:%2elisteners */], STR_PERF_EVENT, false, function (listener) {
              if (perfEvent[_DYN_IS_ASYNC /* @min:%2eisAsync */]) {
                setTimeout(function () {
                  return listener[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent);
                }, 0);
              } else {
                listener[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent);
              }
            });
          }
        }
      };
    });
  }
  // Removed Stub for NotificationManager.prototype.addNotificationListener.
  // Removed Stub for NotificationManager.prototype.removeNotificationListener.
  // Removed Stub for NotificationManager.prototype.eventsSent.
  // Removed Stub for NotificationManager.prototype.eventsDiscarded.
  // Removed Stub for NotificationManager.prototype.eventsSendRequest.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  NotificationManager.__ieDyn = 1;
  return NotificationManager;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/AppInsightsCore.js
/*
 * Application Insights JavaScript SDK - Core, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var AppInsightsCore = /** @class */function (_super) {
  __extendsFn(AppInsightsCore, _super);
  function AppInsightsCore() {
    var _this = _super.call(this) || this;
    dynamicProto(AppInsightsCore, _this, function (_self, _base) {
      _self[_DYN_INITIALIZE /* @min:%2einitialize */] = function (config, extensions, logger, notificationManager) {
        _base[_DYN_INITIALIZE /* @min:%2einitialize */](config, extensions, logger || new DiagnosticLogger(config), notificationManager || new NotificationManager(config));
      };
      _self.track = function (telemetryItem) {
        doPerf(_self[STR_GET_PERF_MGR /* @min:%2egetPerfMgr */](), function () {
          return "AppInsightsCore:track";
        }, function () {
          if (telemetryItem === null) {
            _notifyInvalidEvent(telemetryItem);
            // throw error
            throwError("Invalid telemetry item");
          }
          // do basic validation before sending it through the pipeline
          _validateTelemetryItem(telemetryItem);
          _base.track(telemetryItem);
        }, function () {
          return {
            item: telemetryItem
          };
        }, !telemetryItem.sync);
      };
      function _validateTelemetryItem(telemetryItem) {
        if (isNullOrUndefined(telemetryItem[_DynamicConstants_DYN_NAME /* @min:%2ename */])) {
          _notifyInvalidEvent(telemetryItem);
          throwError("telemetry name required");
        }
      }
      function _notifyInvalidEvent(telemetryItem) {
        var manager = _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]();
        if (manager) {
          manager[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */]([telemetryItem], 2 /* eEventsDiscardedReason.InvalidEvent */);
        }
      }
    });

    return _this;
  }
  // Removed Stub for AppInsightsCore.prototype.initialize.
  // Removed Stub for AppInsightsCore.prototype.track.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  AppInsightsCore.__ieDyn = 1;
  return AppInsightsCore;
}(BaseCore);

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-dependencies-js/dist-esm/InternalConstants.js
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var InternalConstants_STR_DURATION = "duration";
var STR_PROPERTIES = "properties";
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-dependencies-js/dist-esm/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_REQUEST_URL = "requestUrl"; // Count: 12
var _DYN_INST = "inst"; // Count: 5
var applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_LENGTH = "length"; // Count: 10
var applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TRACE_ID = "traceID"; // Count: 9
var dist_esm_DynamicConstants_DYN_SPAN_ID = "spanID"; // Count: 8
var dist_esm_DynamicConstants_DYN_TRACE_FLAGS = "traceFlags"; // Count: 13
var _DYN_CONTEXT = "context"; // Count: 7
var _DYN_TRACE_ID0 = "traceId"; // Count: 5
var _DYN_SPAN_ID1 = "spanId"; // Count: 5
var _DynamicConstants_DYN_CORE = "core"; // Count: 8
var _DYN_INCLUDE_CORRELATION_2 = "includeCorrelationHeaders"; // Count: 4
var _DYN_CAN_INCLUDE_CORRELAT3 = "canIncludeCorrelationHeader"; // Count: 2
var _DYN_GET_ABSOLUTE_URL = "getAbsoluteUrl"; // Count: 3
var _DYN_HEADERS = "headers"; // Count: 6
var _DYN_REQUEST_HEADERS = "requestHeaders"; // Count: 13
var _DYN_APP_ID = "appId"; // Count: 5
var _DynamicConstants_DYN_SET_REQUEST_HEADER = "setRequestHeader"; // Count: 3
var _DYN_TRACK_DEPENDENCY_DAT4 = "trackDependencyDataInternal"; // Count: 2
var _DYN_DISTRIBUTED_TRACING_5 = "distributedTracingMode"; // Count: 3
var _DYN_START_TIME = "startTime"; // Count: 6
var applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 6
var _DYN_ENABLE_REQUEST_HEADE6 = "enableRequestHeaderTracking"; // Count: 2
var _DYN_ENABLE_AJAX_ERROR_ST7 = "enableAjaxErrorStatusText"; // Count: 2
var _DYN_ENABLE_AJAX_PERF_TRA8 = "enableAjaxPerfTracking"; // Count: 2
var _DYN_MAX_AJAX_CALLS_PER_V9 = "maxAjaxCallsPerView"; // Count: 2
var _DYN_ENABLE_RESPONSE_HEAD10 = "enableResponseHeaderTracking"; // Count: 2
var _DYN_EXCLUDE_REQUEST_FROM11 = "excludeRequestFromAutoTrackingPatterns"; // Count: 2
var _DYN_ADD_REQUEST_CONTEXT = "addRequestContext"; // Count: 2
var _DYN_DISABLE_AJAX_TRACKIN12 = "disableAjaxTracking"; // Count: 2
var _DYN_DISABLE_FETCH_TRACKI13 = "disableFetchTracking"; // Count: 2
var _DYN_STATUS = "status"; // Count: 10
var _DYN_STATUS_TEXT = "statusText"; // Count: 8
var _DYN_HEADER_MAP = "headerMap"; // Count: 8
var _DYN_OPEN_DONE = "openDone"; // Count: 3
var _DYN_SEND_DONE = "sendDone"; // Count: 3
var _DYN_REQUEST_SENT_TIME = "requestSentTime"; // Count: 9
var _DYN_ABORT_DONE = "abortDone"; // Count: 3
var _DYN_GET_TRACE_ID = "getTraceId"; // Count: 3
var _DYN_GET_TRACE_FLAGS = "getTraceFlags"; // Count: 3
var _DynamicConstants_DYN_METHOD = "method"; // Count: 10
var _DYN_ERROR_STATUS_TEXT = "errorStatusText"; // Count: 3
var _DYN_STATE_CHANGE_ATTACHE14 = "stateChangeAttached"; // Count: 2
var _DYN_RESPONSE_TEXT = "responseText"; // Count: 5
var _DYN_RESPONSE_FINISHED_TI15 = "responseFinishedTime"; // Count: 7
var _DYN__CREATE_TRACK_ITEM = "CreateTrackItem"; // Count: 3
var _DYN_RESPONSE = "response"; // Count: 4
var _DYN_GET_ALL_RESPONSE_HEA16 = "getAllResponseHeaders"; // Count: 2
var _DYN_GET_PART_APROPS = "getPartAProps"; // Count: 3
var _DYN_GET_CORRELATION_CONT17 = "getCorrelationContext"; // Count: 2
var _DYN_PERF_MARK = "perfMark"; // Count: 4
var _DYN_AJAX_PERF_LOOKUP_DEL18 = "ajaxPerfLookupDelay"; // Count: 2
var applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_NAME = "name"; // Count: 6
var _DYN_PERF_TIMING = "perfTiming"; // Count: 3
var _DYN_AJAX_DIAGNOSTICS_MES19 = "ajaxDiagnosticsMessage"; // Count: 3
var _DYN_CORRELATION_CONTEXT = "correlationContext"; // Count: 3
var _DYN_AJAX_TOTAL_DURATION = "ajaxTotalDuration"; // Count: 3
var _DYN_EVENT_TRACE_CTX = "eventTraceCtx"; // Count: 3
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-dependencies-js/dist-esm/ajaxRecord.js
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






/** @ignore */
function _calcPerfDuration(resourceEntry, start, end) {
  var result = 0;
  var from = resourceEntry[start];
  var to = resourceEntry[end];
  if (from && to) {
    result = dateTimeUtilsDuration(from, to);
  }
  return result;
}
/** @ignore */
function _setPerfDuration(props, name, resourceEntry, start, end) {
  var result = 0;
  var value = _calcPerfDuration(resourceEntry, start, end);
  if (value) {
    result = _setPerfValue(props, name, msToTimeSpan(value));
  }
  return result;
}
/** @ignore */
function _setPerfValue(props, name, value) {
  var strPerf = "ajaxPerf";
  var result = 0;
  if (props && name && value) {
    var perfData = props[strPerf] = props[strPerf] || {};
    perfData[name] = value;
    result = 1;
  }
  return result;
}
/** @ignore */
function _populatePerfData(ajaxData, dependency) {
  /*
  * https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API
  *  | -startTime
  *  | -redirectStart
  *  |            | -redirectEnd
  *  |            | | -fetchStart
  *  |            | |   | -domainLookupStart
  *  |            | |   |                |- domainLookupEnd
  *  |            | |   |                | | -connectStart
  *  |            | |   |                | |  | -secureConnectionStart
  *  |            | |   |                | |  |        | -connectEnd
  *  |            | |   |                | |  |        | | -requestStart
  *  |            | |   |                | |  |        | |           | | -responseStart
  *  |            | |   |                | |  |        | |           | |            | | -responseEnd
  *  +------------+-+---+----------------+-+--+--------+-+-----------+-+------------+-+
  *  |--redirect--| |---|--domainLookup--| |--connect--| |--request--| |--response--| |
  *  |-------------------networkConnect----------------|
  *  |                                                   |---------sentRequest--------|
  *  |------------------------------------perfTotal-----------------------------------|
  */
  var resourceEntry = ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */];
  var props = dependency[STR_PROPERTIES /* @min:%2eproperties */] || {};
  var propsSet = 0;
  var strName = "name";
  var strStart = "Start";
  var strEnd = "End";
  var strDomainLookup = "domainLookup";
  var strConnect = "connect";
  var strRedirect = "redirect";
  var strRequest = "request";
  var strResponse = "response";
  var strStartTime = "startTime";
  var strDomainLookupStart = strDomainLookup + strStart;
  var strDomainLookupEnd = strDomainLookup + strEnd;
  var strConnectStart = strConnect + strStart;
  var strConnectEnd = strConnect + strEnd;
  var strRequestStart = strRequest + strStart;
  var strRequestEnd = strRequest + strEnd;
  var strResponseStart = strResponse + strStart;
  var strResponseEnd = strResponse + strEnd;
  var strRedirectStart = strRedirect + strStart;
  var strRedirectEnd = strRedirect = strEnd;
  var strTransferSize = "transferSize";
  var strEncodedBodySize = "encodedBodySize";
  var strDecodedBodySize = "decodedBodySize";
  var strServerTiming = "serverTiming";
  if (resourceEntry) {
    // redirect
    propsSet |= _setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
    // domainLookup
    propsSet |= _setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
    // connect
    propsSet |= _setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
    // request
    propsSet |= _setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
    // response
    propsSet |= _setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
    // Network connection time
    propsSet |= _setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
    // Sent Request
    propsSet |= _setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
    // PerfTotal / Duration
    var duration = resourceEntry[InternalConstants_STR_DURATION /* @min:%2eduration */];
    if (!duration) {
      duration = _calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
    }
    propsSet |= _setPerfValue(props, InternalConstants_STR_DURATION, duration);
    propsSet |= _setPerfValue(props, "perfTotal", duration);
    var serverTiming = resourceEntry[strServerTiming];
    if (serverTiming) {
      var server_1 = {};
      HelperFuncs_arrForEach(serverTiming, function (value, idx) {
        var name = normalizeJsName(value[strName] || "" + idx);
        var newValue = server_1[name] || {};
        HelperFuncs_objForEachKey(value, function (key, val) {
          if (key !== strName && HelperFuncs_isString(val) || isNumber(val)) {
            if (newValue[key]) {
              val = newValue[key] + ";" + val;
            }
            if (val || !HelperFuncs_isString(val)) {
              // Only set the value if it has a value and it's not an empty string
              newValue[key] = val;
            }
          }
        });
        server_1[name] = newValue;
      });
      propsSet |= _setPerfValue(props, strServerTiming, server_1);
    }
    propsSet |= _setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
    propsSet |= _setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
    propsSet |= _setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
  } else {
    if (ajaxData[_DYN_PERF_MARK /* @min:%2eperfMark */]) {
      propsSet |= _setPerfValue(props, "missing", ajaxData.perfAttempts);
    }
  }
  if (propsSet) {
    dependency[STR_PROPERTIES /* @min:%2eproperties */] = props;
  }
}
var XHRMonitoringState = /** @class */function () {
  function XHRMonitoringState() {
    var self = this;
    self[_DYN_OPEN_DONE /* @min:%2eopenDone */] = false;
    self.setRequestHeaderDone = false;
    self[_DYN_SEND_DONE /* @min:%2esendDone */] = false;
    self[_DYN_ABORT_DONE /* @min:%2eabortDone */] = false;
    // <summary>True, if onreadyStateChangeCallback function attached to xhr, otherwise false</summary>
    self[_DYN_STATE_CHANGE_ATTACHE14 /* @min:%2estateChangeAttached */] = false;
  }
  return XHRMonitoringState;
}();

var ajaxRecord = /** @class */function () {
  function ajaxRecord(traceId, spanId, logger, traceCtx) {
    var _a;
    var self = this;
    var _logger = logger;
    var strResponseText = "responseText";
    // Assigning the initial/default values within the constructor to avoid typescript from creating a bunch of
    // this.XXXX = null
    self[_DYN_PERF_MARK /* @min:%2eperfMark */] = null;
    self.completed = false;
    self.requestHeadersSize = null;
    self[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = null;
    self.responseReceivingDuration = null;
    self.callbackDuration = null;
    self[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */] = null;
    self.aborted = 0;
    self.pageUrl = null;
    self[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = null;
    self.requestSize = 0;
    self[_DynamicConstants_DYN_METHOD /* @min:%2emethod */] = null;
    self[_DYN_STATUS /* @min:%2estatus */] = null;
    self[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */] = null;
    self.responseStartedTime = null;
    self[_DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */] = null;
    self.callbackFinishedTime = null;
    self.endTime = null;
    self.xhrMonitoringState = new XHRMonitoringState();
    self.clientFailure = 0;
    self[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */] = traceId;
    self[dist_esm_DynamicConstants_DYN_SPAN_ID /* @min:%2espanID */] = spanId;
    self[dist_esm_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = traceCtx === null || traceCtx === void 0 ? void 0 : traceCtx.getTraceFlags();
    if (traceCtx) {
      self[_DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */] = (_a = {}, _a[_DYN_TRACE_ID0 /* @min:traceId */] = traceCtx[_DYN_GET_TRACE_ID /* @min:%2egetTraceId */](), _a[_DYN_SPAN_ID1 /* @min:spanId */] = traceCtx.getSpanId(), _a[dist_esm_DynamicConstants_DYN_TRACE_FLAGS /* @min:traceFlags */] = traceCtx[_DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */](), _a);
    } else {
      self[_DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */] = null;
    }
    dynamicProto(ajaxRecord, self, function (self) {
      self.getAbsoluteUrl = function () {
        return self[_DYN_REQUEST_URL /* @min:%2erequestUrl */] ? urlGetAbsoluteUrl(self[_DYN_REQUEST_URL /* @min:%2erequestUrl */]) : null;
      };
      self.getPathName = function () {
        return self[_DYN_REQUEST_URL /* @min:%2erequestUrl */] ? dataSanitizeUrl(_logger, urlGetCompleteUrl(self[_DynamicConstants_DYN_METHOD /* @min:%2emethod */], self[_DYN_REQUEST_URL /* @min:%2erequestUrl */])) : null;
      };
      self[_DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */] = function (ajaxType, enableRequestHeaderTracking, getResponse) {
        var _a;
        // round to 3 decimal points
        self.ajaxTotalDuration = Math.round(dateTimeUtilsDuration(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
        if (self[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */] < 0) {
          return null;
        }
        var dependency = (_a = {
          id: "|" + self[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */] + "." + self[dist_esm_DynamicConstants_DYN_SPAN_ID /* @min:%2espanID */],
          target: self[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */]()
        }, _a[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_NAME /* @min:name */] = self.getPathName(), _a.type = ajaxType, _a[_DYN_START_TIME /* @min:startTime */] = null, _a.duration = self[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */], _a.success = +self[_DYN_STATUS /* @min:%2estatus */] >= 200 && +self[_DYN_STATUS /* @min:%2estatus */] < 400, _a.responseCode = +self[_DYN_STATUS /* @min:%2estatus */], _a.method = self[_DynamicConstants_DYN_METHOD /* @min:%2emethod */], _a[STR_PROPERTIES] = {
          HttpMethod: self[_DynamicConstants_DYN_METHOD /* @min:%2emethod */]
        }, _a);
        if (self[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */]) {
          // Set the correct dependency start time
          dependency[_DYN_START_TIME /* @min:%2estartTime */] = new Date();
          dependency[_DYN_START_TIME /* @min:%2estartTime */].setTime(self[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */]);
        }
        // Add Ajax perf details if available
        _populatePerfData(self, dependency);
        if (enableRequestHeaderTracking) {
          if (objKeys(self.requestHeaders)[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
            var props = dependency[STR_PROPERTIES /* @min:%2eproperties */] = dependency[STR_PROPERTIES /* @min:%2eproperties */] || {};
            props[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = self[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */];
          }
        }

        if (getResponse) {
          var response = getResponse();
          if (response) {
            // enrich dependency target with correlation context from the server
            var correlationContext = response[_DYN_CORRELATION_CONTEXT /* @min:%2ecorrelationContext */];
            if (correlationContext) {
              dependency.correlationContext = /* dependency.target + " | " + */correlationContext;
            }
            if (response[_DYN_HEADER_MAP /* @min:%2eheaderMap */]) {
              if (objKeys(response.headerMap)[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                var props = dependency[STR_PROPERTIES /* @min:%2eproperties */] = dependency[STR_PROPERTIES /* @min:%2eproperties */] || {};
                props.responseHeaders = response[_DYN_HEADER_MAP /* @min:%2eheaderMap */];
              }
            }

            if (self.errorStatusText && self[_DYN_STATUS /* @min:%2estatus */] >= 400) {
              var responseType = response.type;
              var props = dependency[STR_PROPERTIES /* @min:%2eproperties */] = dependency[STR_PROPERTIES /* @min:%2eproperties */] || {};
              if (responseType === "" || responseType === "text") {
                props.responseText = response.responseText ? response[_DYN_STATUS_TEXT /* @min:%2estatusText */] + " - " + response[strResponseText] : response[_DYN_STATUS_TEXT /* @min:%2estatusText */];
              }

              if (responseType === "json") {
                props.responseText = response.response ? response[_DYN_STATUS_TEXT /* @min:%2estatusText */] + " - " + JSON.stringify(response[_DYN_RESPONSE /* @min:%2eresponse */]) : response[_DYN_STATUS_TEXT /* @min:%2estatusText */];
              }
            }
          }
        }

        return dependency;
      };
      self[_DYN_GET_PART_APROPS /* @min:%2egetPartAProps */] = function () {
        var _a;
        var partA = null;
        var traceCtx = self[_DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */];
        if (traceCtx && (traceCtx[_DYN_TRACE_ID0 /* @min:%2etraceId */] || traceCtx[_DYN_SPAN_ID1 /* @min:%2espanId */])) {
          partA = {};
          var traceExt = partA[Extensions.TraceExt] = (_a = {}, _a[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:traceID */] = traceCtx[_DYN_TRACE_ID0 /* @min:%2etraceId */], _a.parentID = traceCtx[_DYN_SPAN_ID1 /* @min:%2espanId */], _a);
          if (!isNullOrUndefined(traceCtx[dist_esm_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */])) {
            traceExt[dist_esm_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = traceCtx[dist_esm_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
          }
        }

        return partA;
      };
    });
  }
  // Removed Stub for ajaxRecord.prototype.getAbsoluteUrl.
  // Removed Stub for ajaxRecord.prototype.getPathName.
  // Removed Stub for ajaxRecord.prototype.CreateTrackItem.
  // Removed Stub for ajaxRecord.prototype.getPartAProps.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  ajaxRecord.__ieDyn = 1;
  return ajaxRecord;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-dependencies-js/dist-esm/ajax.js
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








var AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var strDiagLog = "diagLog";
var strAjaxData = "ajaxData";
var strFetch = "fetch";
var ERROR_HEADER = "Failed to monitor XMLHttpRequest";
var ERROR_PREFIX = ", monitoring data for this ajax call ";
var ERROR_POSTFIX = ERROR_PREFIX + "may be incorrect.";
var ERROR_NOT_SENT = ERROR_PREFIX + "won't be sent.";
var CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
var CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
var FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
// Using a global value so that to handle same iKey with multiple app insights instances (mostly for testing)
var _markCount = 0;
/** @Ignore */
function _supportsFetch() {
  var _global = getGlobal();
  if (!_global || isNullOrUndefined(_global.Request) || isNullOrUndefined(_global.Request[Constants_strShimPrototype]) || isNullOrUndefined(_global[strFetch])) {
    return null;
  }
  return _global[strFetch];
}
/**
 * Determines whether ajax monitoring can be enabled on this document
 * @returns True if Ajax monitoring is supported on this page, otherwise false
 * @ignore
 */
function _supportsAjaxMonitoring(ajaxMonitorInstance) {
  var result = false;
  if (isXhrSupported()) {
    var proto = XMLHttpRequest[Constants_strShimPrototype];
    result = !isNullOrUndefined(proto) && !isNullOrUndefined(proto.open) &&
    // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
    !isNullOrUndefined(proto.send) && !isNullOrUndefined(proto.abort);
  }
  var ieVer = getIEVersion();
  if (ieVer && ieVer < 9) {
    result = false;
  }
  if (result) {
    // Disable if the XmlHttpRequest can't be extended or hooked
    try {
      var xhr = new XMLHttpRequest();
      xhr[strAjaxData] = {};
      // Check that we can update the prototype
      var theOpen = XMLHttpRequest[Constants_strShimPrototype].open;
      XMLHttpRequest[Constants_strShimPrototype].open = theOpen;
    } catch (e) {
      // We can't decorate the xhr object so disable monitoring
      result = false;
      _throwInternalCritical(ajaxMonitorInstance, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to enable XMLHttpRequest monitoring, extension is not supported", {
        exception: dumpObj(e)
      });
    }
  }
  return result;
}
/** @Ignore */
function _getFailedAjaxDiagnosticsMessage(xhr) {
  var result = "";
  try {
    if (xhr && xhr[strAjaxData] && xhr[strAjaxData][_DYN_REQUEST_URL /* @min:%2erequestUrl */]) {
      result += "(url: '" + xhr[strAjaxData][_DYN_REQUEST_URL /* @min:%2erequestUrl */] + "')";
    }
  } catch (e) {
    // eslint-disable-next-line no-empty
  }
  return result;
}
/** @ignore */
function _throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
  _throwInternal(ajaxMonitorInstance[strDiagLog](), 1 /* eLoggingSeverity.CRITICAL */, msgId, message, properties, isUserAct);
}
/** @ignore */
function _throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
  _throwInternal(ajaxMonitorInstance[strDiagLog](), 2 /* eLoggingSeverity.WARNING */, msgId, message, properties, isUserAct);
}
/** @Ignore */
function _createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
  // tslint:disable-next-line
  return function (args) {
    _throwInternalCritical(ajaxMonitorInstance, internalMessage, message, {
      ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(args[_DYN_INST /* @min:%2einst */]),
      exception: dumpObj(args.err)
    });
  };
}
function _indexOf(value, match) {
  if (value && match) {
    return value.indexOf(match);
  }
  return -1;
}
function _addHandler(container, id, theFunc) {
  var theHandler = {
    id: id,
    fn: theFunc
  };
  container.push(theHandler);
  return {
    remove: function () {
      HelperFuncs_arrForEach(container, function (initializer, idx) {
        if (initializer.id === theHandler.id) {
          container.splice(idx, 1);
          return -1;
        }
      });
    }
  };
}
function _processDependencyContainer(core, container, details, message) {
  var result = true;
  HelperFuncs_arrForEach(container, function (theFunc, idx) {
    try {
      if (theFunc.fn.call(null, details) === false) {
        result = false;
      }
    } catch (e) {
      _throwInternal(core && core.logger, 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Dependency " + message + " [#" + idx + "] failed: " + getExceptionName(e), {
        exception: dumpObj(e)
      }, true);
    }
  });
  return result;
}
function _processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
  var _a;
  var initializersCount = listeners[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
  if (initializersCount > 0) {
    var details = (_a = {}, _a[_DynamicConstants_DYN_CORE /* @min:core */] = core, _a.xhr = xhr, _a.input = input, _a.init = init, _a.traceId = ajaxData[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */], _a.spanId = ajaxData[dist_esm_DynamicConstants_DYN_SPAN_ID /* @min:%2espanID */], _a.traceFlags = ajaxData[dist_esm_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */], _a.context = ajaxData[_DYN_CONTEXT /* @min:%2econtext */] || {}, _a);
    _processDependencyContainer(core, listeners, details, "listener");
    ajaxData[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */] = details[_DYN_TRACE_ID0 /* @min:%2etraceId */];
    ajaxData[dist_esm_DynamicConstants_DYN_SPAN_ID /* @min:%2espanID */] = details[_DYN_SPAN_ID1 /* @min:%2espanId */];
    ajaxData[dist_esm_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = details[dist_esm_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
    ajaxData[_DYN_CONTEXT /* @min:%2econtext */] = details[_DYN_CONTEXT /* @min:%2econtext */];
  }
}

var BLOB_CORE = "*.blob.core.";
var DfltAjaxCorrelationHeaderExDomains = HelperFuncs_deepFreeze([BLOB_CORE + "windows.net", BLOB_CORE + "chinacloudapi.cn", BLOB_CORE + "cloudapi.de", BLOB_CORE + "usgovcloudapi.net"]);
var _internalExcludeEndpoints = [/https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i];
function ajax_getDefaultConfig() {
  var _a;
  var config = (_a = {}, _a[_DYN_MAX_AJAX_CALLS_PER_V9 /* @min:maxAjaxCallsPerView */] = 500, _a[_DYN_DISABLE_AJAX_TRACKIN12 /* @min:disableAjaxTracking */] = false, _a[_DYN_DISABLE_FETCH_TRACKI13 /* @min:disableFetchTracking */] = false, _a[_DYN_EXCLUDE_REQUEST_FROM11 /* @min:excludeRequestFromAutoTrackingPatterns */] = undefined, _a.disableCorrelationHeaders = false, _a.distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */, _a.correlationHeaderExcludedDomains = DfltAjaxCorrelationHeaderExDomains, _a.correlationHeaderDomains = undefined, _a.correlationHeaderExcludePatterns = undefined, _a[_DYN_APP_ID /* @min:appId */] = undefined, _a.enableCorsCorrelation = false, _a[_DYN_ENABLE_REQUEST_HEADE6 /* @min:enableRequestHeaderTracking */] = false, _a[_DYN_ENABLE_RESPONSE_HEAD10 /* @min:enableResponseHeaderTracking */] = false, _a[_DYN_ENABLE_AJAX_ERROR_ST7 /* @min:enableAjaxErrorStatusText */] = false, _a[_DYN_ENABLE_AJAX_PERF_TRA8 /* @min:enableAjaxPerfTracking */] = false, _a.maxAjaxPerfLookupAttempts = 3, _a[_DYN_AJAX_PERF_LOOKUP_DEL18 /* @min:ajaxPerfLookupDelay */] = 25, _a.ignoreHeaders = ["Authorization", "X-API-Key", "WWW-Authenticate"], _a[_DYN_ADD_REQUEST_CONTEXT /* @min:addRequestContext */] = undefined, _a.addIntEndpoints = true, _a);
  return config;
}
function _getEmptyConfig() {
  var emptyConfig = ajax_getDefaultConfig();
  HelperFuncs_objForEachKey(emptyConfig, function (value) {
    emptyConfig[value] = undefined;
  });
  return emptyConfig;
}
var AjaxMonitor = /** @class */function (_super) {
  __extendsFn(AjaxMonitor, _super);
  function AjaxMonitor() {
    var _this = _super.call(this) || this;
    _this.identifier = AjaxMonitor.identifier;
    _this.priority = 120;
    var _fetchInitialized; // fetch monitoring initialized
    var _xhrInitialized; // XHR monitoring initialized
    var _currentWindowHost;
    var _config;
    var _enableRequestHeaderTracking;
    var _enableAjaxErrorStatusText;
    var _trackAjaxAttempts;
    var _context;
    var _isUsingW3CHeaders;
    var _isUsingAIHeaders;
    var _markPrefix;
    var _enableAjaxPerfTracking;
    var _maxAjaxCallsPerView;
    var _enableResponseHeaderTracking;
    var _disabledUrls;
    var _disableAjaxTracking;
    var _disableFetchTracking;
    var _excludeRequestFromAutoTrackingPatterns;
    var _addRequestContext;
    var _evtNamespace;
    var _dependencyHandlerId;
    var _dependencyListeners;
    var _dependencyInitializers;
    dynamicProto(AjaxMonitor, _this, function (_self, _base) {
      var _addHook = _base._addHook;
      _initDefaults();
      _self.initialize = function (config, core, extensions, pluginChain) {
        if (!_self.isInitialized()) {
          _base.initialize(config, core, extensions, pluginChain);
          _evtNamespace = mergeEvtNamespace(createUniqueNamespace("ajax"), core && core.evtNamespace && core.evtNamespace());
          _populateDefaults(config);
          _instrumentXhr();
          _instrumentFetch();
          _populateContext();
        }
      };
      _self._doTeardown = function () {
        _initDefaults();
      };
      _self.trackDependencyData = function (dependency, properties) {
        _reportDependencyInternal(_dependencyInitializers, _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */], null, dependency, properties);
      };
      _self[_DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */] = function (ajaxData, input, init, xhr) {
        // Test Hook to allow the overriding of the location host
        var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
        _processDependencyListeners(_dependencyListeners, _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */], ajaxData, xhr, input, init);
        if (input) {
          // Fetch
          if (CorrelationIdHelper[_DYN_CAN_INCLUDE_CORRELAT3 /* @min:%2ecanIncludeCorrelationHeader */](_config, ajaxData[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */](), currentWindowHost)) {
            if (!init) {
              init = {};
            }
            // init headers override original request headers
            // so, if they exist use only them, otherwise use request's because they should have been applied in the first place
            // not using original request headers will result in them being lost
            var headers = new Headers(init[_DYN_HEADERS /* @min:%2eheaders */] || (input instanceof Request ? input[_DYN_HEADERS /* @min:%2eheaders */] || {} : {}));
            if (_isUsingAIHeaders) {
              var id = "|" + ajaxData[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */] + "." + ajaxData[dist_esm_DynamicConstants_DYN_SPAN_ID /* @min:%2espanID */];
              headers.set(RequestHeaders[3], id);
              if (_enableRequestHeaderTracking) {
                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[3]] = id;
              }
            }
            var appId = _config[_DYN_APP_ID /* @min:%2eappId */] || _context && _context[_DYN_APP_ID /* @min:%2eappId */]();
            if (appId) {
              headers.set(RequestHeaders[0], RequestHeaders[2] + appId);
              if (_enableRequestHeaderTracking) {
                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[0]] = RequestHeaders[2] + appId;
              }
            }
            if (_isUsingW3CHeaders) {
              var traceFlags = ajaxData[dist_esm_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
              if (isNullOrUndefined(traceFlags)) {
                traceFlags = 0x01;
              }
              var traceParent = formatTraceParent(createTraceParent(ajaxData[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */], ajaxData[dist_esm_DynamicConstants_DYN_SPAN_ID /* @min:%2espanID */], traceFlags));
              headers.set(RequestHeaders[4], traceParent);
              if (_enableRequestHeaderTracking) {
                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[4]] = traceParent;
              }
            }
            init[_DYN_HEADERS /* @min:%2eheaders */] = headers;
          }
          return init;
        } else if (xhr) {
          // XHR
          if (CorrelationIdHelper[_DYN_CAN_INCLUDE_CORRELAT3 /* @min:%2ecanIncludeCorrelationHeader */](_config, ajaxData[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */](), currentWindowHost)) {
            if (_isUsingAIHeaders) {
              var id = "|" + ajaxData[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */] + "." + ajaxData[dist_esm_DynamicConstants_DYN_SPAN_ID /* @min:%2espanID */];
              xhr[_DynamicConstants_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[3], id);
              if (_enableRequestHeaderTracking) {
                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[3]] = id;
              }
            }
            var appId = _config[_DYN_APP_ID /* @min:%2eappId */] || _context && _context[_DYN_APP_ID /* @min:%2eappId */]();
            if (appId) {
              xhr[_DynamicConstants_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[0], RequestHeaders[2] + appId);
              if (_enableRequestHeaderTracking) {
                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[0]] = RequestHeaders[2] + appId;
              }
            }
            if (_isUsingW3CHeaders) {
              var traceFlags = ajaxData[dist_esm_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
              if (isNullOrUndefined(traceFlags)) {
                traceFlags = 0x01;
              }
              var traceParent = formatTraceParent(createTraceParent(ajaxData[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */], ajaxData[dist_esm_DynamicConstants_DYN_SPAN_ID /* @min:%2espanID */], traceFlags));
              xhr[_DynamicConstants_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[4], traceParent);
              if (_enableRequestHeaderTracking) {
                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[4]] = traceParent;
              }
            }
          }
          return xhr;
        }
        return undefined;
      };
      _self[_DYN_TRACK_DEPENDENCY_DAT4 /* @min:%2etrackDependencyDataInternal */] = function (dependency, properties, systemProperties) {
        if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
          // Hack since expected format in w3c mode is |abc.def.
          // Non-w3c format is |abc.def
          // @todo Remove if better solution is available, e.g. handle in portal
          if ((_config[_DYN_DISTRIBUTED_TRACING_5 /* @min:%2edistributedTracingMode */] === 2 /* eDistributedTracingModes.W3C */ || _config[_DYN_DISTRIBUTED_TRACING_5 /* @min:%2edistributedTracingMode */] === 1 /* eDistributedTracingModes.AI_AND_W3C */) && typeof dependency.id === "string" && dependency.id[dependency.id[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 1] !== ".") {
            dependency.id += ".";
          }
          if (isNullOrUndefined(dependency[_DYN_START_TIME /* @min:%2estartTime */])) {
            dependency[_DYN_START_TIME /* @min:%2estartTime */] = new Date();
          }
          var item = createTelemetryItem(dependency, RemoteDependencyData.dataType, RemoteDependencyData.envelopeType, _self[strDiagLog](), properties, systemProperties);
          _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */].track(item);
        } else if (_trackAjaxAttempts === _maxAjaxCallsPerView) {
          _throwInternalCritical(_self, 55 /* _eInternalMessageId.MaxAjaxPerPVExceeded */, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
        }
        ++_trackAjaxAttempts;
      };
      _self.addDependencyListener = function (dependencyListener) {
        return _addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
      };
      _self.addDependencyInitializer = function (dependencyInitializer) {
        return _addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
      };
      function _initDefaults() {
        var location = getLocation();
        _fetchInitialized = false; // fetch monitoring initialized
        _xhrInitialized = false; // XHR monitoring initialized
        _currentWindowHost = location && location.host && location.host[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
        _config = AjaxMonitor.getEmptyConfig();
        _enableRequestHeaderTracking = false;
        _enableAjaxErrorStatusText = false;
        _trackAjaxAttempts = 0;
        _context = null;
        _isUsingW3CHeaders = false;
        _isUsingAIHeaders = false;
        _markPrefix = null;
        _enableAjaxPerfTracking = false;
        _maxAjaxCallsPerView = 0;
        _enableResponseHeaderTracking = false;
        _disabledUrls = {};
        _disableAjaxTracking = false;
        _disableFetchTracking = false;
        _excludeRequestFromAutoTrackingPatterns = null;
        _addRequestContext = null;
        _evtNamespace = null;
        _dependencyHandlerId = 0;
        _dependencyListeners = [];
        _dependencyInitializers = [];
      }
      function _populateDefaults(config) {
        var ctx = createProcessTelemetryContext(null, config, _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */]);
        // Reset to the empty config
        _config = _getEmptyConfig();
        var defaultConfig = ajax_getDefaultConfig();
        HelperFuncs_objForEachKey(defaultConfig, function (field, value) {
          _config[field] = ctx.getConfig(AjaxMonitor.identifier, field, value);
        });
        var distributedTracingMode = _config[_DYN_DISTRIBUTED_TRACING_5 /* @min:%2edistributedTracingMode */];
        _enableRequestHeaderTracking = _config[_DYN_ENABLE_REQUEST_HEADE6 /* @min:%2eenableRequestHeaderTracking */];
        _enableAjaxErrorStatusText = _config[_DYN_ENABLE_AJAX_ERROR_ST7 /* @min:%2eenableAjaxErrorStatusText */];
        _enableAjaxPerfTracking = _config[_DYN_ENABLE_AJAX_PERF_TRA8 /* @min:%2eenableAjaxPerfTracking */];
        _maxAjaxCallsPerView = _config[_DYN_MAX_AJAX_CALLS_PER_V9 /* @min:%2emaxAjaxCallsPerView */];
        _enableResponseHeaderTracking = _config[_DYN_ENABLE_RESPONSE_HEAD10 /* @min:%2eenableResponseHeaderTracking */];
        _excludeRequestFromAutoTrackingPatterns = [].concat(_config[_DYN_EXCLUDE_REQUEST_FROM11 /* @min:%2eexcludeRequestFromAutoTrackingPatterns */] || [], _config.addIntEndpoints !== false ? _internalExcludeEndpoints : []);
        _addRequestContext = _config[_DYN_ADD_REQUEST_CONTEXT /* @min:%2eaddRequestContext */];
        _isUsingAIHeaders = distributedTracingMode === 0 /* eDistributedTracingModes.AI */ || distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */;
        _isUsingW3CHeaders = distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ || distributedTracingMode === 2 /* eDistributedTracingModes.W3C */;
        if (_enableAjaxPerfTracking) {
          var iKey = config.instrumentationKey || "unkwn";
          if (iKey[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 5) {
            _markPrefix = AJAX_MONITOR_PREFIX + iKey.substring(iKey[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 5) + ".";
          } else {
            _markPrefix = AJAX_MONITOR_PREFIX + iKey + ".";
          }
        }
        _disableAjaxTracking = !!_config[_DYN_DISABLE_AJAX_TRACKIN12 /* @min:%2edisableAjaxTracking */];
        _disableFetchTracking = !!_config[_DYN_DISABLE_FETCH_TRACKI13 /* @min:%2edisableFetchTracking */];
      }

      function _populateContext() {
        var propExt = _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */].getPlugin(PropertiesPluginIdentifier);
        if (propExt) {
          _context = propExt.plugin[_DYN_CONTEXT /* @min:%2econtext */]; // we could move IPropertiesPlugin to common as well
        }
      }
      // discard the header if it's defined as ignoreHeaders in ICorrelationConfig
      function _canIncludeHeaders(header) {
        var rlt = true;
        if (header || _config.ignoreHeaders) {
          HelperFuncs_arrForEach(_config.ignoreHeaders, function (key) {
            if (key[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]() === header[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]()) {
              rlt = false;
              return -1;
            }
          });
        }
        return rlt;
      }
      // Fetch Stuff
      function _instrumentFetch() {
        var fetch = _supportsFetch();
        if (!fetch) {
          return;
        }
        var global = getGlobal();
        var isPolyfill = fetch.polyfill;
        if (!_disableFetchTracking && !_fetchInitialized) {
          _addHook(InstrumentFunc(global, strFetch, {
            ns: _evtNamespace,
            // Add request hook
            req: function (callDetails, input, init) {
              var fetchData;
              if (!_disableFetchTracking && _fetchInitialized && !_isDisabledRequest(null, input, init) &&
              // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
              !(isPolyfill && _xhrInitialized)) {
                var ctx = callDetails.ctx();
                fetchData = _createFetchRecord(input, init);
                var newInit = _self[_DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */](fetchData, input, init);
                if (newInit !== init) {
                  callDetails.set(1, newInit);
                }
                ctx.data = fetchData;
              }
            },
            rsp: function (callDetails, input) {
              if (!_disableFetchTracking) {
                var fetchData_1 = callDetails.ctx().data;
                if (fetchData_1) {
                  // Replace the result with the new promise from this code
                  callDetails.rslt = callDetails.rslt.then(function (response) {
                    _reportFetchMetrics(callDetails, (response || {})[_DYN_STATUS /* @min:%2estatus */], input, response, fetchData_1, function () {
                      var _a;
                      var ajaxResponse = (_a = {
                        statusText: response[_DYN_STATUS_TEXT /* @min:%2estatusText */]
                      }, _a[_DYN_HEADER_MAP /* @min:headerMap */] = null, _a[_DYN_CORRELATION_CONTEXT /* @min:correlationContext */] = _getFetchCorrelationContext(response), _a);
                      if (_enableResponseHeaderTracking) {
                        var responseHeaderMap_1 = {};
                        response.headers.forEach(function (value, name) {
                          if (_canIncludeHeaders(name)) {
                            responseHeaderMap_1[name] = value;
                          }
                        });
                        ajaxResponse[_DYN_HEADER_MAP /* @min:%2eheaderMap */] = responseHeaderMap_1;
                      }
                      return ajaxResponse;
                    });
                    return response;
                  })["catch"](function (reason) {
                    _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, {
                      error: reason.message
                    });
                    throw reason;
                  });
                }
              }
            },
            // Create an error callback to report any hook errors
            hkErr: _createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to monitor Window.fetch" + ERROR_POSTFIX)
          }));
          _fetchInitialized = true;
        } else if (isPolyfill) {
          // If fetch is a polyfill we need to capture the request to ensure that we correctly track
          // disabled request URLS (i.e. internal urls) to ensure we don't end up in a constant loop
          // of reporting ourselves, for example React Native uses a polyfill for fetch
          // Note: Polyfill implementations that don't support the "poyyfill" tag are not supported
          // the workaround is to add a polyfill property to your fetch implementation before initializing
          // App Insights
          _addHook(InstrumentFunc(global, strFetch, {
            ns: _evtNamespace,
            req: function (callDetails, input, init) {
              // Just call so that we record any disabled URL
              _isDisabledRequest(null, input, init);
            }
          }));
        }
        if (isPolyfill) {
          // retag the instrumented fetch with the same polyfill settings this is mostly for testing
          // But also supports multiple App Insights usages
          global[strFetch].polyfill = isPolyfill;
        }
      }
      function _hookProto(target, funcName, callbacks) {
        _addHook(InstrumentProto(target, funcName, callbacks));
      }
      function _instrumentXhr() {
        if (_supportsAjaxMonitoring(_self) && !_disableAjaxTracking && !_xhrInitialized) {
          // Instrument open
          _hookProto(XMLHttpRequest, "open", {
            ns: _evtNamespace,
            req: function (args, method, url, async) {
              if (!_disableAjaxTracking) {
                var xhr = args[_DYN_INST /* @min:%2einst */];
                var ajaxData = xhr[strAjaxData];
                if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, true)) {
                  if (!ajaxData || !ajaxData.xhrMonitoringState[_DYN_OPEN_DONE /* @min:%2eopenDone */]) {
                    // Only create a single ajaxData (even when multiple AI instances are running)
                    _openHandler(xhr, method, url, async);
                  }
                  // always attach to the on ready state change (required for handling multiple instances)
                  _attachToOnReadyStateChange(xhr);
                }
              }
            },
            hkErr: _createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, ERROR_HEADER + ".open" + ERROR_POSTFIX)
          });
          // Instrument send
          _hookProto(XMLHttpRequest, "send", {
            ns: _evtNamespace,
            req: function (args, context) {
              if (!_disableAjaxTracking) {
                var xhr = args[_DYN_INST /* @min:%2einst */];
                var ajaxData = xhr[strAjaxData];
                if (_isMonitoredXhrInstance(xhr) && !ajaxData.xhrMonitoringState[_DYN_SEND_DONE /* @min:%2esendDone */]) {
                  _createMarkId("xhr", ajaxData);
                  ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */] = dateTimeUtilsNow();
                  _self[_DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */](ajaxData, undefined, undefined, xhr);
                  ajaxData.xhrMonitoringState[_DYN_SEND_DONE /* @min:%2esendDone */] = true;
                }
              }
            },
            hkErr: _createErrorCallbackFunc(_self, 17 /* _eInternalMessageId.FailedMonitorAjaxSend */, ERROR_HEADER + ERROR_POSTFIX)
          });
          // Instrument abort
          _hookProto(XMLHttpRequest, "abort", {
            ns: _evtNamespace,
            req: function (args) {
              if (!_disableAjaxTracking) {
                var xhr = args[_DYN_INST /* @min:%2einst */];
                var ajaxData = xhr[strAjaxData];
                if (_isMonitoredXhrInstance(xhr) && !ajaxData.xhrMonitoringState[_DYN_ABORT_DONE /* @min:%2eabortDone */]) {
                  ajaxData.aborted = 1;
                  ajaxData.xhrMonitoringState[_DYN_ABORT_DONE /* @min:%2eabortDone */] = true;
                }
              }
            },
            hkErr: _createErrorCallbackFunc(_self, 13 /* _eInternalMessageId.FailedMonitorAjaxAbort */, ERROR_HEADER + ".abort" + ERROR_POSTFIX)
          });
          // Instrument setRequestHeader
          _hookProto(XMLHttpRequest, "setRequestHeader", {
            ns: _evtNamespace,
            req: function (args, header, value) {
              if (!_disableAjaxTracking && _enableRequestHeaderTracking) {
                var xhr = args[_DYN_INST /* @min:%2einst */];
                if (_isMonitoredXhrInstance(xhr) && _canIncludeHeaders(header)) {
                  xhr[strAjaxData][_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][header] = value;
                }
              }
            },
            hkErr: _createErrorCallbackFunc(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, ERROR_HEADER + ".setRequestHeader" + ERROR_POSTFIX)
          });
          _xhrInitialized = true;
        }
      }
      function _isDisabledRequest(xhr, request, init) {
        var isDisabled = false;
        var theUrl = ((!HelperFuncs_isString(request) ? (request || {}).url || "" : request) || "")[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
        // check excludeRequestFromAutoTrackingPatterns before stripping off any query string
        HelperFuncs_arrForEach(_excludeRequestFromAutoTrackingPatterns, function (regex) {
          var theRegex = regex;
          if (HelperFuncs_isString(regex)) {
            theRegex = new RegExp(regex);
          }
          if (!isDisabled) {
            isDisabled = theRegex.test(theUrl);
          }
        });
        // if request url matches with exclude regex pattern, return true and no need to check for headers
        if (isDisabled) {
          return isDisabled;
        }
        var idx = _indexOf(theUrl, "?");
        var idx2 = _indexOf(theUrl, "#");
        if (idx === -1 || idx2 !== -1 && idx2 < idx) {
          idx = idx2;
        }
        if (idx !== -1) {
          // Strip off any Query string
          theUrl = theUrl.substring(0, idx);
        }
        // check that this instance is not not used by ajax call performed inside client side monitoring to send data to collector
        if (!isNullOrUndefined(xhr)) {
          // Look on the XMLHttpRequest of the URL string value
          isDisabled = xhr[DisabledPropertyName] === true || theUrl[DisabledPropertyName] === true;
        } else if (!isNullOrUndefined(request)) {
          // fetch
          // Look for DisabledPropertyName in either Request or RequestInit
          isDisabled = (typeof request === "object" ? request[DisabledPropertyName] === true : false) || (init ? init[DisabledPropertyName] === true : false);
        }
        // Also add extra check just in case the XHR or fetch objects where not decorated with the DisableProperty due to sealing or freezing
        if (!isDisabled && theUrl && isInternalApplicationInsightsEndpoint(theUrl)) {
          isDisabled = true;
        }
        if (isDisabled) {
          // Add the disabled url if not present
          if (!_disabledUrls[theUrl]) {
            _disabledUrls[theUrl] = 1;
          }
        } else {
          // Check to see if the url is listed as disabled
          if (_disabledUrls[theUrl]) {
            isDisabled = true;
          }
        }
        return isDisabled;
      }
      /// <summary>Verifies that particalar instance of XMLHttpRequest needs to be monitored</summary>
      /// <param name="excludeAjaxDataValidation">Optional parameter. True if ajaxData must be excluded from verification</param>
      /// <returns type="bool">True if instance needs to be monitored, otherwise false</returns>
      function _isMonitoredXhrInstance(xhr, excludeAjaxDataValidation) {
        var ajaxValidation = true;
        var initialized = _xhrInitialized;
        if (!isNullOrUndefined(xhr)) {
          ajaxValidation = excludeAjaxDataValidation === true || !isNullOrUndefined(xhr[strAjaxData]);
        }
        // checking to see that all interested functions on xhr were instrumented
        return initialized
        // checking on ajaxData to see that it was not removed in user code
        && ajaxValidation;
      }
      function _getDistributedTraceCtx() {
        var distributedTraceCtx = null;
        if (_self[_DynamicConstants_DYN_CORE /* @min:%2ecore */] && _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */].getTraceCtx) {
          distributedTraceCtx = _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */].getTraceCtx(false);
        }
        // Fall back
        if (!distributedTraceCtx && _context && _context.telemetryTrace) {
          distributedTraceCtx = createDistributedTraceContextFromTrace(_context.telemetryTrace);
        }
        return distributedTraceCtx;
      }
      function _openHandler(xhr, method, url, async) {
        var _a;
        var distributedTraceCtx = _getDistributedTraceCtx();
        var traceID = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_ID /* @min:%2egetTraceId */]() || generateW3CId();
        var spanID = generateW3CId().substr(0, 16);
        var ajaxData = new ajaxRecord(traceID, spanID, _self[strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
        ajaxData[dist_esm_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */]();
        ajaxData[_DynamicConstants_DYN_METHOD /* @min:%2emethod */] = method;
        ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = url;
        ajaxData.xhrMonitoringState[_DYN_OPEN_DONE /* @min:%2eopenDone */] = true;
        ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = {};
        ajaxData.async = async;
        ajaxData[_DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */] = _enableAjaxErrorStatusText;
        xhr[strAjaxData] = ajaxData;
      }
      function _attachToOnReadyStateChange(xhr) {
        xhr[strAjaxData].xhrMonitoringState[_DYN_STATE_CHANGE_ATTACHE14 /* @min:%2estateChangeAttached */] = eventOn(xhr, "readystatechange", function () {
          var _a;
          try {
            if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr)) {
              _onAjaxComplete(xhr);
            }
          } catch (e) {
            var exceptionText = dumpObj(e);
            // ignore messages with c00c023f, as this a known IE9 XHR abort issue
            if (!exceptionText || _indexOf(exceptionText[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */](), "c00c023f") === -1) {
              _throwInternalCritical(_self, 16 /* _eInternalMessageId.FailedMonitorAjaxRSC */, ERROR_HEADER + " 'readystatechange' event handler" + ERROR_POSTFIX, (_a = {}, _a[_DYN_AJAX_DIAGNOSTICS_MES19 /* @min:ajaxDiagnosticsMessage */] = _getFailedAjaxDiagnosticsMessage(xhr), _a.exception = exceptionText, _a));
            }
          }
        }, _evtNamespace);
      }
      function _getResponseText(xhr) {
        try {
          var responseType = xhr.responseType;
          if (responseType === "" || responseType === "text") {
            // As per the specification responseText is only valid if the type is an empty string or "text"
            return xhr[_DYN_RESPONSE_TEXT /* @min:%2eresponseText */];
          }
        } catch (e) {
          // This shouldn't happen because of the above check -- but just in case, so just ignore
        }
        return null;
      }
      function _onAjaxComplete(xhr) {
        var ajaxData = xhr[strAjaxData];
        ajaxData[_DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */] = dateTimeUtilsNow();
        ajaxData[_DYN_STATUS /* @min:%2estatus */] = xhr[_DYN_STATUS /* @min:%2estatus */];
        function _reportXhrError(e, failedProps) {
          var errorProps = failedProps || {};
          errorProps["ajaxDiagnosticsMessage"] = _getFailedAjaxDiagnosticsMessage(xhr);
          if (e) {
            errorProps["exception"] = dumpObj(e);
          }
          _throwInternalWarning(_self, 14 /* _eInternalMessageId.FailedMonitorAjaxDur */, FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + ERROR_NOT_SENT, errorProps);
        }
        _findPerfResourceEntry("xmlhttprequest", ajaxData, function () {
          try {
            var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */]("Ajax", _enableRequestHeaderTracking, function () {
              var _a;
              var ajaxResponse = (_a = {
                statusText: xhr[_DYN_STATUS_TEXT /* @min:%2estatusText */]
              }, _a[_DYN_HEADER_MAP /* @min:headerMap */] = null, _a[_DYN_CORRELATION_CONTEXT /* @min:correlationContext */] = _getAjaxCorrelationContext(xhr), _a.type = xhr.responseType, _a[_DYN_RESPONSE_TEXT /* @min:responseText */] = _getResponseText(xhr), _a.response = xhr[_DYN_RESPONSE /* @min:%2eresponse */], _a);
              if (_enableResponseHeaderTracking) {
                var headers = xhr[_DYN_GET_ALL_RESPONSE_HEA16 /* @min:%2egetAllResponseHeaders */]();
                if (headers) {
                  // xhr.getAllResponseHeaders() method returns all the response headers, separated by CRLF, as a string or null
                  // the regex converts the header string into an array of individual headers
                  var arr = HelperFuncs_strTrim(headers).split(/[\r\n]+/);
                  var responseHeaderMap_2 = {};
                  HelperFuncs_arrForEach(arr, function (line) {
                    var parts = line.split(": ");
                    var header = parts.shift();
                    var value = parts.join(": ");
                    if (_canIncludeHeaders(header)) {
                      responseHeaderMap_2[header] = value;
                    }
                  });
                  ajaxResponse[_DYN_HEADER_MAP /* @min:%2eheaderMap */] = responseHeaderMap_2;
                }
              }
              return ajaxResponse;
            });
            var properties = void 0;
            try {
              if (!!_addRequestContext) {
                properties = _addRequestContext({
                  status: xhr[_DYN_STATUS /* @min:%2estatus */],
                  xhr: xhr
                });
              }
            } catch (e) {
              _throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */, CUSTOM_REQUEST_CONTEXT_ERROR);
            }
            if (dependency) {
              if (properties !== undefined) {
                dependency[STR_PROPERTIES /* @min:%2eproperties */] = __assignFn(__assignFn({}, dependency.properties), properties);
              }
              var sysProperties = ajaxData[_DYN_GET_PART_APROPS /* @min:%2egetPartAProps */]();
              _reportDependencyInternal(_dependencyInitializers, _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */], ajaxData, dependency, null, sysProperties);
            } else {
              _reportXhrError(null, {
                requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */],
                responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */]
              });
            }
          } finally {
            // cleanup telemetry data
            try {
              xhr[strAjaxData] = null;
            } catch (e) {
              // May throw in environments that prevent extension or freeze xhr
            }
          }
        }, function (e) {
          _reportXhrError(e, null);
        });
      }
      function _getAjaxCorrelationContext(xhr) {
        var _a;
        try {
          var responseHeadersString = xhr[_DYN_GET_ALL_RESPONSE_HEA16 /* @min:%2egetAllResponseHeaders */]();
          if (responseHeadersString !== null) {
            var index = _indexOf(responseHeadersString[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */](), RequestHeaders[8]);
            if (index !== -1) {
              var responseHeader = xhr.getResponseHeader(RequestHeaders[0]);
              return CorrelationIdHelper[_DYN_GET_CORRELATION_CONT17 /* @min:%2egetCorrelationContext */](responseHeader);
            }
          }
        } catch (e) {
          _throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, CORRELATION_HEADER_ERROR, (_a = {}, _a[_DYN_AJAX_DIAGNOSTICS_MES19 /* @min:ajaxDiagnosticsMessage */] = _getFailedAjaxDiagnosticsMessage(xhr), _a.exception = dumpObj(e), _a));
        }
      }
      function _createMarkId(type, ajaxData) {
        if (ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] && _markPrefix && _enableAjaxPerfTracking) {
          var performance_1 = getPerformance();
          if (performance_1 && HelperFuncs_isFunction(performance_1.mark)) {
            _markCount++;
            var markId = _markPrefix + type + "#" + _markCount;
            performance_1.mark(markId);
            var entries = performance_1.getEntriesByName(markId);
            if (entries && entries[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 1) {
              ajaxData[_DYN_PERF_MARK /* @min:%2eperfMark */] = entries[0];
            }
          }
        }
      }
      function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
        var perfMark = ajaxData[_DYN_PERF_MARK /* @min:%2eperfMark */];
        var performance = getPerformance();
        var maxAttempts = _config.maxAjaxPerfLookupAttempts;
        var retryDelay = _config[_DYN_AJAX_PERF_LOOKUP_DEL18 /* @min:%2eajaxPerfLookupDelay */];
        var requestUrl = ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */];
        var attempt = 0;
        (function locateResourceTiming() {
          try {
            if (performance && perfMark) {
              attempt++;
              var perfTiming = null;
              var entries = performance.getEntries();
              for (var lp = entries[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 1; lp >= 0; lp--) {
                var entry = entries[lp];
                if (entry) {
                  if (entry.entryType === "resource") {
                    if (entry.initiatorType === initiatorType && (_indexOf(entry[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */], requestUrl) !== -1 || _indexOf(requestUrl, entry[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */]) !== -1)) {
                      perfTiming = entry;
                    }
                  } else if (entry.entryType === "mark" && entry[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */] === perfMark[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */]) {
                    // We hit the start event
                    ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */] = perfTiming;
                    break;
                  }
                  if (entry[_DYN_START_TIME /* @min:%2estartTime */] < perfMark[_DYN_START_TIME /* @min:%2estartTime */] - 1000) {
                    // Fallback to try and reduce the time spent looking for the perf entry
                    break;
                  }
                }
              }
            }
            if (!perfMark ||
            // - we don't have a perfMark or
            ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */] ||
            // - we have not found the perf entry or
            attempt >= maxAttempts ||
            // - we have tried too many attempts or
            ajaxData.async === false) {
              // - this is a sync request
              if (perfMark && HelperFuncs_isFunction(performance.clearMarks)) {
                // Remove the mark so we don't fill up the performance resources too much
                performance.clearMarks(perfMark[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_NAME /* @min:%2ename */]);
              }

              ajaxData.perfAttempts = attempt;
              // just continue and report the track event
              trackCallback();
            } else {
              // We need to wait for the browser to populate the window.performance entry
              // This needs to be at least 1ms as waiting <= 1 (on firefox) is not enough time for fetch or xhr,
              // this is a scheduling issue for the browser implementation
              setTimeout(locateResourceTiming, retryDelay);
            }
          } catch (e) {
            reportError(e);
          }
        })();
      }
      function _createFetchRecord(input, init) {
        var _a;
        var distributedTraceCtx = _getDistributedTraceCtx();
        var traceID = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_ID /* @min:%2egetTraceId */]() || generateW3CId();
        var spanID = generateW3CId().substr(0, 16);
        var ajaxData = new ajaxRecord(traceID, spanID, _self[strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
        ajaxData[dist_esm_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = distributedTraceCtx && distributedTraceCtx[_DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */]();
        ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */] = dateTimeUtilsNow();
        ajaxData[_DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */] = _enableAjaxErrorStatusText;
        if (input instanceof Request) {
          ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = input ? input.url : "";
        } else {
          ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = input;
        }
        var method = "GET";
        if (init && init[_DynamicConstants_DYN_METHOD /* @min:%2emethod */]) {
          method = init[_DynamicConstants_DYN_METHOD /* @min:%2emethod */];
        } else if (input && input instanceof Request) {
          method = input[_DynamicConstants_DYN_METHOD /* @min:%2emethod */];
        }

        ajaxData[_DynamicConstants_DYN_METHOD /* @min:%2emethod */] = method;
        var requestHeaders = {};
        if (_enableRequestHeaderTracking) {
          var headers = new Headers((init ? init[_DYN_HEADERS /* @min:%2eheaders */] : 0) || (input instanceof Request ? input[_DYN_HEADERS /* @min:%2eheaders */] || {} : {}));
          headers.forEach(function (value, key) {
            if (_canIncludeHeaders(key)) {
              requestHeaders[key] = value;
            }
          });
        }
        ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = requestHeaders;
        _createMarkId("fetch", ajaxData);
        return ajaxData;
      }
      function _getFailedFetchDiagnosticsMessage(input) {
        var result = "";
        try {
          if (!isNullOrUndefined(input)) {
            if (typeof input === "string") {
              result += "(url: '".concat(input, "')");
            } else {
              result += "(url: '".concat(input.url, "')");
            }
          }
        } catch (e) {
          _throwInternalCritical(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to grab failed fetch diagnostics message", {
            exception: dumpObj(e)
          });
        }
        return result;
      }
      function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
        if (!ajaxData) {
          return;
        }
        function _reportFetchError(msgId, e, failedProps) {
          var errorProps = failedProps || {};
          errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
          if (e) {
            errorProps["exception"] = dumpObj(e);
          }
          _throwInternalWarning(_self, msgId, FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + ERROR_NOT_SENT, errorProps);
        }
        ajaxData[_DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */] = dateTimeUtilsNow();
        ajaxData[_DYN_STATUS /* @min:%2estatus */] = status;
        _findPerfResourceEntry("fetch", ajaxData, function () {
          var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */]("Fetch", _enableRequestHeaderTracking, getResponse);
          var properties;
          try {
            if (!!_addRequestContext) {
              properties = _addRequestContext({
                status: status,
                request: input,
                response: response
              });
            }
          } catch (e) {
            _throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */, CUSTOM_REQUEST_CONTEXT_ERROR);
          }
          if (dependency) {
            if (properties !== undefined) {
              dependency[STR_PROPERTIES /* @min:%2eproperties */] = __assignFn(__assignFn({}, dependency.properties), properties);
            }
            var sysProperties = ajaxData[_DYN_GET_PART_APROPS /* @min:%2egetPartAProps */]();
            _reportDependencyInternal(_dependencyInitializers, _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */], ajaxData, dependency, null, sysProperties);
          } else {
            _reportFetchError(14 /* _eInternalMessageId.FailedMonitorAjaxDur */, null, {
              requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */],
              responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */]
            });
          }
        }, function (e) {
          _reportFetchError(18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, e, null);
        });
      }
      function _getFetchCorrelationContext(response) {
        if (response && response[_DYN_HEADERS /* @min:%2eheaders */]) {
          try {
            var responseHeader = response[_DYN_HEADERS /* @min:%2eheaders */].get(RequestHeaders[0]);
            return CorrelationIdHelper[_DYN_GET_CORRELATION_CONT17 /* @min:%2egetCorrelationContext */](responseHeader);
          } catch (e) {
            _throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, CORRELATION_HEADER_ERROR, {
              fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response),
              exception: dumpObj(e)
            });
          }
        }
      }
      function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
        var _a;
        var result = true;
        var initializersCount = initializers[applicationinsights_dependencies_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
        if (initializersCount > 0) {
          var details = (_a = {
            item: dependency
          }, _a[STR_PROPERTIES /* @min:properties */] = properties, _a.sysProperties = systemProperties, _a.context = ajaxData ? ajaxData[_DYN_CONTEXT /* @min:%2econtext */] : null, _a);
          result = _processDependencyContainer(core, initializers, details, "initializer");
        }
        if (result) {
          _self[_DYN_TRACK_DEPENDENCY_DAT4 /* @min:%2etrackDependencyDataInternal */](dependency, properties, systemProperties);
        }
      }
    });
    return _this;
  }
  // Removed Stub for AjaxMonitor.prototype.initialize.
  AjaxMonitor.prototype.processTelemetry = function (item, itemCtx) {
    this.processNext(item, itemCtx);
  };
  // Removed Stub for AjaxMonitor.prototype.trackDependencyData.
  // Removed Stub for AjaxMonitor.prototype.includeCorrelationHeaders.
  // Removed Stub for AjaxMonitor.prototype.addDependencyListener.
  /**
   * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
   * It is called after the dependency call has completed and any available performance details are available. A dependency
   * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
   * request so that it doesn't count against the `maxAjaxCallsPerView`.
   * @param dependencyInitializer - The Dependency Telemetry Initializer function
   * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
   */
  AjaxMonitor.prototype.addDependencyInitializer = function (dependencyInitializer) {
    return null;
  };
  // Removed Stub for AjaxMonitor.prototype.trackDependencyDataInternal.
  AjaxMonitor.identifier = "AjaxDependencyPlugin";
  AjaxMonitor.getDefaultConfig = ajax_getDefaultConfig;
  AjaxMonitor.getEmptyConfig = _getEmptyConfig;
  return AjaxMonitor;
}(BaseTelemetryPlugin);

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/Application.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Application = /** @class */function () {
  function Application() {}
  return Application;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/Device.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Device = /** @class */function () {
  /**
   * Constructs a new instance of the Device class
   */
  function Device() {
    // don't attempt to fingerprint browsers
    this.id = "browser";
    // Device type is a dimension in our data platform
    // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
    this.deviceClass = "Browser";
  }
  return Device;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-esm/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_SESSION_MANAGER = "sessionManager"; // Count: 3
var _DynamicConstants_DYN_UPDATE = "update"; // Count: 4
var _DYN_IS_USER_COOKIE_SET = "isUserCookieSet"; // Count: 4
var _DYN_IS_NEW_USER = "isNewUser"; // Count: 4
var _DYN_GET_TRACE_CTX = "getTraceCtx"; // Count: 3
var _DYN_TELEMETRY_TRACE = "telemetryTrace"; // Count: 3
var _DYN_APPLY_SESSION_CONTEX0 = "applySessionContext"; // Count: 2
var _DYN_APPLY_APPLICATION_CO1 = "applyApplicationContext"; // Count: 2
var _DYN_APPLY_DEVICE_CONTEXT = "applyDeviceContext"; // Count: 2
var _DYN_APPLY_OPERATION_CONT2 = "applyOperationContext"; // Count: 2
var _DYN_APPLY_USER_CONTEXT = "applyUserContext"; // Count: 2
var _DYN_APPLY_OPERATING_SYST3 = "applyOperatingSystemContxt"; // Count: 2
var _DYN_APPLY_LOCATION_CONTE4 = "applyLocationContext"; // Count: 2
var _DYN_APPLY_INTERNAL_CONTE5 = "applyInternalContext"; // Count: 2
var _DYN_ACCOUNT_ID = "accountId"; // Count: 8
var _DYN_SDK_EXTENSION = "sdkExtension"; // Count: 4
var _DYN_GET_SESSION_ID = "getSessionId"; // Count: 4
var dist_esm_DynamicConstants_DYN_NAME_PREFIX = "namePrefix"; // Count: 7
var _DYN_SESSION_COOKIE_POSTF6 = "sessionCookiePostfix"; // Count: 4
var _DYN_USER_COOKIE_POSTFIX = "userCookiePostfix"; // Count: 4
var _DYN_ID_LENGTH = "idLength"; // Count: 5
var _DYN_GET_NEW_ID = "getNewId"; // Count: 6
var applicationinsights_properties_js_dist_esm_DynamicConstants_DYN_LENGTH = "length"; // Count: 4
var _DYN_AUTOMATIC_SESSION = "automaticSession"; // Count: 5
var _DYN_AUTHENTICATED_ID = "authenticatedId"; // Count: 6
var _DYN_SESSION_EXPIRATION_M7 = "sessionExpirationMs"; // Count: 5
var _DYN_SESSION_RENEWAL_MS = "sessionRenewalMs"; // Count: 4
var _DynamicConstants_DYN_CONFIG = "config"; // Count: 4
var _DYN_ACQUISITION_DATE = "acquisitionDate"; // Count: 5
var _DYN_RENEWAL_DATE = "renewalDate"; // Count: 4
var _DYN_COOKIE_DOMAIN = "cookieDomain"; // Count: 3
var _DYN_JOIN = "join"; // Count: 5
var _DYN_COOKIE_SEPARATOR = "cookieSeparator"; // Count: 5
var _DYN_AUTH_USER_COOKIE_NAM8 = "authUserCookieName"; // Count: 3
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/Internal.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Version = '2.8.9';
var Internal = /** @class */function () {
  /**
   * Constructs a new instance of the internal telemetry data class.
   */
  function Internal(config) {
    this.sdkVersion = (config[_DYN_SDK_EXTENSION /* @min:%2esdkExtension */] && config[_DYN_SDK_EXTENSION /* @min:%2esdkExtension */]() ? config[_DYN_SDK_EXTENSION /* @min:%2esdkExtension */]() + "_" : "") + "javascript:" + Version;
  }
  return Internal;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/Location.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Location = /** @class */function () {
  function Location() {}
  return Location;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/Session.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var cookieNameConst = "ai_session";
var Session = /** @class */function () {
  function Session() {}
  return Session;
}();

var _SessionManager = /** @class */function () {
  function _SessionManager(config, core) {
    var self = this;
    var _storageNamePrefix;
    var _cookieUpdatedTimestamp;
    var _logger = safeGetLogger(core);
    var _cookieManager = safeGetCookieMgr(core);
    dynamicProto(_SessionManager, self, function (_self) {
      if (!config) {
        config = {};
      }
      if (!HelperFuncs_isFunction(config[_DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */])) {
        config[_DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */] = function () {
          return _SessionManager.acquisitionSpan;
        };
      }
      if (!HelperFuncs_isFunction(config[_DYN_SESSION_RENEWAL_MS /* @min:%2esessionRenewalMs */])) {
        config[_DYN_SESSION_RENEWAL_MS /* @min:%2esessionRenewalMs */] = function () {
          return _SessionManager.renewalSpan;
        };
      }
      _self[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */] = config;
      // sessionCookiePostfix takes the preference if it is configured, otherwise takes namePrefix if configured.
      var sessionCookiePostfix = _self.config[_DYN_SESSION_COOKIE_POSTF6 /* @min:%2esessionCookiePostfix */] && _self[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */][_DYN_SESSION_COOKIE_POSTF6 /* @min:%2esessionCookiePostfix */]() ? _self.config[_DYN_SESSION_COOKIE_POSTF6 /* @min:%2esessionCookiePostfix */]() : _self.config[dist_esm_DynamicConstants_DYN_NAME_PREFIX /* @min:%2enamePrefix */] && _self[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */][dist_esm_DynamicConstants_DYN_NAME_PREFIX /* @min:%2enamePrefix */]() ? _self[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */][dist_esm_DynamicConstants_DYN_NAME_PREFIX /* @min:%2enamePrefix */]() : "";
      _storageNamePrefix = function () {
        return cookieNameConst + sessionCookiePostfix;
      };
      _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */] = new Session();
      _self[_DynamicConstants_DYN_UPDATE /* @min:%2eupdate */] = function () {
        // Always using Date getTime() as there is a bug in older IE instances that causes the performance timings to have the hi-bit set eg 0x800000000 causing
        // the number to be incorrect.
        var nowMs = dateNow();
        var isExpired = false;
        var session = _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
        if (!session.id) {
          isExpired = !_initializeAutomaticSession(session, nowMs);
        }
        var sessionExpirationMs = _self.config[_DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */]();
        if (!isExpired && sessionExpirationMs > 0) {
          var sessionRenewalMs = _self.config[_DYN_SESSION_RENEWAL_MS /* @min:%2esessionRenewalMs */]();
          var timeSinceAcqMs = nowMs - session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */];
          var timeSinceRenewalMs = nowMs - session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */];
          isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0; // expired if the acquisition or last renewal are in the future
          isExpired = isExpired || timeSinceAcqMs > sessionExpirationMs; // expired if the time since acquisition is more than session Expiration
          isExpired = isExpired || timeSinceRenewalMs > sessionRenewalMs; // expired if the time since last renewal is more than renewal period
        }
        // renew if acquisitionSpan or renewalSpan has elapsed
        if (isExpired) {
          // update automaticSession so session state has correct id
          _renew(nowMs);
        } else {
          // do not update the cookie more often than cookieUpdateInterval
          if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > _SessionManager.cookieUpdateInterval) {
            _setCookie(session, nowMs);
          }
        }
      };
      /**
       *  Record the current state of the automatic session and store it in our cookie string format
       *  into the browser's local storage. This is used to restore the session data when the cookie
       *  expires.
       */
      _self.backup = function () {
        var session = _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
        _setStorage(session.id, session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */], session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */]);
      };
      /**
       * Use config.namePrefix + ai_session cookie data or local storage data (when the cookie is unavailable) to
       * initialize the automatic session.
       * @returns true if values set otherwise false
       */
      function _initializeAutomaticSession(session, now) {
        var isValid = false;
        var cookieValue = _cookieManager.get(_storageNamePrefix());
        if (cookieValue && HelperFuncs_isFunction(cookieValue.split)) {
          isValid = _initializeAutomaticSessionWithData(session, cookieValue);
        } else {
          // There's no cookie, but we might have session data in local storage
          // This can happen if the session expired or the user actively deleted the cookie
          // We only want to recover data if the cookie is missing from expiry. We should respect the user's wishes if the cookie was deleted actively.
          // The User class handles this for us and deletes our local storage object if the persistent user cookie was removed.
          var storageValue = utlGetLocalStorage(_logger, _storageNamePrefix());
          if (storageValue) {
            isValid = _initializeAutomaticSessionWithData(session, storageValue);
          }
        }
        return isValid || !!session.id;
      }
      /**
       * Extract id, acquisitionDate, and renewalDate from an ai_session payload string and
       * use this data to initialize automaticSession.
       *
       * @param {string} sessionData - The string stored in an ai_session cookie or local storage backup
       * @returns true if values set otherwise false
       */
      function _initializeAutomaticSessionWithData(session, sessionData) {
        var isValid = false;
        var sessionReset = ", session will be reset";
        var tokens = sessionData.split("|");
        if (tokens[applicationinsights_properties_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] >= 2) {
          try {
            var acqMs = +tokens[1] || 0;
            var renewalMs = +tokens[2] || 0;
            if (isNaN(acqMs) || acqMs <= 0) {
              _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 27 /* _eInternalMessageId.SessionRenewalDateIsZero */, "AI session acquisition date is 0" + sessionReset);
            } else if (isNaN(renewalMs) || renewalMs <= 0) {
              _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 27 /* _eInternalMessageId.SessionRenewalDateIsZero */, "AI session renewal date is 0" + sessionReset);
            } else if (tokens[0]) {
              // Everything looks valid so set the values
              session.id = tokens[0];
              session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */] = acqMs;
              session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */] = renewalMs;
              isValid = true;
            }
          } catch (e) {
            _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 9 /* _eInternalMessageId.ErrorParsingAISessionCookie */, "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + getExceptionName(e), {
              exception: dumpObj(e)
            });
          }
        }
        return isValid;
      }
      function _renew(nowMs) {
        var theConfig = _self[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */] || {};
        var getNewId = (theConfig[_DYN_GET_NEW_ID /* @min:%2egetNewId */] ? theConfig[_DYN_GET_NEW_ID /* @min:%2egetNewId */]() : null) || newId;
        _self.automaticSession.id = getNewId(theConfig[_DYN_ID_LENGTH /* @min:%2eidLength */] ? theConfig[_DYN_ID_LENGTH /* @min:%2eidLength */]() : 22);
        _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */][_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */] = nowMs;
        _setCookie(_self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */], nowMs);
        // If this browser does not support local storage, fire an internal log to keep track of it at this point
        if (!utlCanUseLocalStorage()) {
          _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 0 /* _eInternalMessageId.BrowserDoesNotSupportLocalStorage */, "Browser does not support local storage. Session durations will be inaccurate.");
        }
      }
      function _setCookie(session, nowMs) {
        var acq = session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */];
        session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */] = nowMs;
        var config = _self[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */];
        var renewalPeriodMs = config[_DYN_SESSION_RENEWAL_MS /* @min:%2esessionRenewalMs */]();
        // Set cookie to expire after the session expiry time passes or the session renewal deadline, whichever is sooner
        // Expiring the cookie will cause the session to expire even if the user isn't on the page
        var acqTimeLeftMs = acq + config[_DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */]() - nowMs;
        var cookie = [session.id, acq, nowMs];
        var maxAgeSec = 0;
        if (acqTimeLeftMs < renewalPeriodMs) {
          maxAgeSec = acqTimeLeftMs / 1000;
        } else {
          maxAgeSec = renewalPeriodMs / 1000;
        }
        var cookieDomain = config[_DYN_COOKIE_DOMAIN /* @min:%2ecookieDomain */] ? config[_DYN_COOKIE_DOMAIN /* @min:%2ecookieDomain */]() : null;
        // if sessionExpirationMs is set to 0, it means the expiry is set to 0 for this session cookie
        // A cookie with 0 expiry in the session cookie will never expire for that browser session.  If the browser is closed the cookie expires.
        // Depending on the browser, another instance does not inherit this cookie, however, another tab will
        _cookieManager.set(_storageNamePrefix(), cookie.join("|"), config[_DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */]() > 0 ? maxAgeSec : null, cookieDomain);
        _cookieUpdatedTimestamp = nowMs;
      }
      function _setStorage(guid, acq, renewal) {
        // Keep data in local storage to retain the last session id, allowing us to cleanly end the session when it expires
        // Browsers that don't support local storage won't be able to end sessions cleanly from the client
        // The server will notice this and end the sessions itself, with loss of accurate session duration
        utlSetLocalStorage(_logger, _storageNamePrefix(), [guid, acq, renewal][_DYN_JOIN /* @min:%2ejoin */]("|"));
      }
    });
  }
  // Removed Stub for _SessionManager.prototype.update.
  // Removed Stub for _SessionManager.prototype.backup.
  _SessionManager.acquisitionSpan = 86400000; // 24 hours in ms
  _SessionManager.renewalSpan = 1800000; // 30 minutes in ms
  _SessionManager.cookieUpdateInterval = 60000; // 1 minute in ms
  return _SessionManager;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/TelemetryTrace.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var TelemetryTrace = /** @class */function () {
  function TelemetryTrace(id, parentId, name, logger) {
    var _self = this;
    _self.traceID = id || generateW3CId();
    _self.parentID = parentId;
    var location = getLocation();
    if (!name && location && location.pathname) {
      name = location.pathname;
    }
    _self.name = dataSanitizeString(logger, name);
  }
  return TelemetryTrace;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-esm/Context/User.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





function _validateUserInput(id) {
  // Validate:
  // 1. Id is a non-empty string.
  // 2. It does not contain special characters for cookies.
  if (typeof id !== "string" || !id || id.match(/,|;|=| |\|/)) {
    return false;
  }
  return true;
}
var User = /** @class */function () {
  function User(config, core) {
    /**
     * A flag indicating whether this represents a new user
     */
    this.isNewUser = false;
    /**
     * A flag indicating whether the user cookie has been set
     */
    this.isUserCookieSet = false;
    var _logger = safeGetLogger(core);
    var _cookieManager = safeGetCookieMgr(core);
    var _storageNamePrefix;
    dynamicProto(User, this, function (_self) {
      _self[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */] = config;
      var userCookiePostfix = _self.config[_DYN_USER_COOKIE_POSTFIX /* @min:%2euserCookiePostfix */] && _self[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */][_DYN_USER_COOKIE_POSTFIX /* @min:%2euserCookiePostfix */]() ? _self[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */][_DYN_USER_COOKIE_POSTFIX /* @min:%2euserCookiePostfix */]() : "";
      _storageNamePrefix = function () {
        return User.userCookieName + userCookiePostfix;
      };
      // get userId or create new one if none exists
      var cookie = _cookieManager.get(_storageNamePrefix());
      if (cookie) {
        _self[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = false;
        var params = cookie.split(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
        if (params[applicationinsights_properties_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
          _self.id = params[0];
          // we already have a cookie
          _self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */] = !!_self.id;
        }
      }
      function _generateNewId() {
        var theConfig = config || {};
        var getNewId = (theConfig[_DYN_GET_NEW_ID /* @min:%2egetNewId */] ? theConfig[_DYN_GET_NEW_ID /* @min:%2egetNewId */]() : null) || newId;
        var id = getNewId(theConfig[_DYN_ID_LENGTH /* @min:%2eidLength */] ? config[_DYN_ID_LENGTH /* @min:%2eidLength */]() : 22);
        return id;
      }
      function _generateNewCookie(userId) {
        var acqStr = toISOString(new Date());
        _self.accountAcquisitionDate = acqStr;
        _self[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = true;
        var newCookie = [userId, acqStr];
        return newCookie;
      }
      function _setUserCookie(cookie) {
        // without expiration, cookies expire at the end of the session
        // set it to 365 days from now
        // 365 * 24 * 60 * 60 = 31536000
        var oneYear = 31536000;
        _self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */] = _cookieManager.set(_storageNamePrefix(), cookie, oneYear);
      }
      if (!_self.id) {
        _self.id = _generateNewId();
        var newCookie = _generateNewCookie(_self.id);
        _setUserCookie(newCookie[_DYN_JOIN /* @min:%2ejoin */](User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]));
        // If we have an config.namePrefix() + ai_session in local storage this means the user actively removed our cookies.
        // We should respect their wishes and clear ourselves from local storage
        var name_1 = config[dist_esm_DynamicConstants_DYN_NAME_PREFIX /* @min:%2enamePrefix */] && config[dist_esm_DynamicConstants_DYN_NAME_PREFIX /* @min:%2enamePrefix */]() ? config[dist_esm_DynamicConstants_DYN_NAME_PREFIX /* @min:%2enamePrefix */]() + "ai_session" : "ai_session";
        utlRemoveStorage(_logger, name_1);
      }
      // We still take the account id from the ctor param for backward compatibility.
      // But if the the customer set the accountId through the newer setAuthenticatedUserContext API, we will override it.
      _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = config[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] ? config[_DYN_ACCOUNT_ID /* @min:%2eaccountId */]() : undefined;
      // Get the auth user id and account id from the cookie if exists
      // Cookie is in the pattern: <authenticatedId>|<accountId>
      var authCookie = _cookieManager.get(User[_DYN_AUTH_USER_COOKIE_NAM8 /* @min:%2eauthUserCookieName */]);
      if (authCookie) {
        authCookie = decodeURI(authCookie);
        var authCookieString = authCookie.split(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
        if (authCookieString[0]) {
          _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = authCookieString[0];
        }
        if (authCookieString[applicationinsights_properties_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 1 && authCookieString[1]) {
          _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = authCookieString[1];
        }
      }
      _self.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
        if (storeInCookie === void 0) {
          storeInCookie = false;
        }
        // Validate inputs to ensure no cookie control characters.
        var isInvalidInput = !_validateUserInput(authenticatedUserId) || accountId && !_validateUserInput(accountId);
        if (isInvalidInput) {
          _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 60 /* _eInternalMessageId.SetAuthContextFailedAccountName */, "Setting auth user context failed. " + "User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
          return;
        }
        // Create cookie string.
        _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = authenticatedUserId;
        var authCookie = _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */];
        if (accountId) {
          _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = accountId;
          authCookie = [_self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */], _self.accountId][_DYN_JOIN /* @min:%2ejoin */](User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
        }

        if (storeInCookie) {
          // Set the cookie. No expiration date because this is a session cookie (expires when browser closed).
          // Encoding the cookie to handle unexpected unicode characters.
          _cookieManager.set(User[_DYN_AUTH_USER_COOKIE_NAM8 /* @min:%2eauthUserCookieName */], encodeURI(authCookie));
        }
      };
      /**
       * Clears the authenticated user id and the account id from the user context.
       * @returns {}
       */
      _self.clearAuthenticatedUserContext = function () {
        _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = null;
        _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = null;
        _cookieManager.del(User[_DYN_AUTH_USER_COOKIE_NAM8 /* @min:%2eauthUserCookieName */]);
      };

      _self[_DynamicConstants_DYN_UPDATE /* @min:%2eupdate */] = function (userId) {
        // Optimizations to avoid setting and processing the cookie when not needed
        if (_self.id !== userId || !_self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */]) {
          var user_id = userId ? userId : _generateNewId();
          var user_cookie = _generateNewCookie(user_id);
          _setUserCookie(user_cookie[_DYN_JOIN /* @min:%2ejoin */](User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]));
        }
      };
    });
  }
  // Removed Stub for User.prototype.setAuthenticatedUserContext.
  // Removed Stub for User.prototype.clearAuthenticatedUserContext.
  // Removed Stub for User.prototype.update.
  User.cookieSeparator = "|";
  User.userCookieName = "ai_user";
  User.authUserCookieName = "ai_authUser";
  return User;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-esm/TelemetryContext.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* TelemetryContext.ts
* @copyright Microsoft 2018
*/











var strExt = "ext";
var strTags = "tags";
function _removeEmpty(target, name) {
  if (target && target[name] && objKeys(target[name])[applicationinsights_properties_js_dist_esm_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0) {
    delete target[name];
  }
}
var TelemetryContext = /** @class */function () {
  function TelemetryContext(core, defaultConfig, previousTraceCtx) {
    var _this = this;
    var logger = core.logger;
    this.appId = function () {
      return null;
    };
    this[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */] = function () {
      return null;
    };
    dynamicProto(TelemetryContext, this, function (_self) {
      _self.application = new Application();
      _self.internal = new Internal(defaultConfig);
      if (hasWindow()) {
        _self[_DYN_SESSION_MANAGER /* @min:%2esessionManager */] = new _SessionManager(defaultConfig, core);
        _self.device = new Device();
        _self.location = new Location();
        _self.user = new User(defaultConfig, core);
        var traceId = void 0;
        var parentId = void 0;
        var name_1;
        if (previousTraceCtx) {
          traceId = previousTraceCtx.getTraceId();
          parentId = previousTraceCtx.getSpanId();
          name_1 = previousTraceCtx.getName();
        }
        _self[_DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */] = new TelemetryTrace(traceId, parentId, name_1, logger);
        _self.session = new Session();
      }
      _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */] = function () {
        var session = _self.session;
        var sesId = null;
        // If customer set session info, apply their context; otherwise apply context automatically generated
        if (session && HelperFuncs_isString(session.id)) {
          sesId = session.id;
        } else {
          // Gets the automatic session if it exists or an empty object
          var autoSession = (_self[_DYN_SESSION_MANAGER /* @min:%2esessionManager */] || {})[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
          sesId = autoSession && HelperFuncs_isString(autoSession.id) ? autoSession.id : null;
        }
        return sesId;
      };
      _self[_DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */] = function (evt, itemCtx) {
        setValue(getSetValue(evt.ext, Extensions.AppExt), "sesId", _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */](), HelperFuncs_isString);
      };
      _self[_DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */] = function (evt, itemCtx) {
        setValue(evt.ext, Extensions.OSExt, _self.os);
      };
      _self[_DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */] = function (evt, itemCtx) {
        var application = _self.application;
        if (application) {
          // evt.ext.app
          var tags = getSetValue(evt, strTags);
          setValue(tags, CtxTagKeys.applicationVersion, application.ver, HelperFuncs_isString);
          setValue(tags, CtxTagKeys.applicationBuild, application.build, HelperFuncs_isString);
        }
      };
      _self[_DYN_APPLY_DEVICE_CONTEXT /* @min:%2eapplyDeviceContext */] = function (evt, itemCtx) {
        var device = _self.device;
        if (device) {
          // evt.ext.device
          var extDevice = getSetValue(getSetValue(evt, strExt), Extensions.DeviceExt);
          setValue(extDevice, "localId", device.id, HelperFuncs_isString);
          setValue(extDevice, "ip", device.ip, HelperFuncs_isString);
          setValue(extDevice, "model", device.model, HelperFuncs_isString);
          setValue(extDevice, "deviceClass", device.deviceClass, HelperFuncs_isString);
        }
      };
      _self[_DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */] = function (evt, itemCtx) {
        var internal = _self.internal;
        if (internal) {
          var tags = getSetValue(evt, strTags);
          setValue(tags, CtxTagKeys.internalAgentVersion, internal.agentVersion, HelperFuncs_isString); // not mapped in CS 4.0
          setValue(tags, CtxTagKeys.internalSdkVersion, internal.sdkVersion, HelperFuncs_isString);
          if (evt.baseType === _InternalLogMessage.dataType || evt.baseType === PageView.dataType) {
            setValue(tags, CtxTagKeys.internalSnippet, internal.snippetVer, HelperFuncs_isString);
            setValue(tags, CtxTagKeys.internalSdkSrc, internal.sdkSrc, HelperFuncs_isString);
          }
        }
      };
      _self[_DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */] = function (evt, itemCtx) {
        var location = _this.location;
        if (location) {
          setValue(getSetValue(evt, strTags, []), CtxTagKeys.locationIp, location.ip, HelperFuncs_isString);
        }
      };
      _self[_DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */] = function (evt, itemCtx) {
        var telemetryTrace = _self[_DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */];
        if (telemetryTrace) {
          var extTrace = getSetValue(getSetValue(evt, strExt), Extensions.TraceExt, {
            traceID: undefined,
            parentID: undefined
          });
          setValue(extTrace, "traceID", telemetryTrace.traceID, HelperFuncs_isString, isNullOrUndefined);
          setValue(extTrace, "name", telemetryTrace.name, HelperFuncs_isString, isNullOrUndefined);
          setValue(extTrace, "parentID", telemetryTrace.parentID, HelperFuncs_isString, isNullOrUndefined);
        }
      };
      _self.applyWebContext = function (evt, itemCtx) {
        var web = _this.web;
        if (web) {
          setValue(getSetValue(evt, strExt), Extensions.WebExt, web);
        }
      };
      _self[_DYN_APPLY_USER_CONTEXT /* @min:%2eapplyUserContext */] = function (evt, itemCtx) {
        var user = _self.user;
        if (user) {
          var tags = getSetValue(evt, strTags, []);
          // stays in tags
          setValue(tags, CtxTagKeys.userAccountId, user[_DYN_ACCOUNT_ID /* @min:%2eaccountId */], HelperFuncs_isString);
          // CS 4.0
          var extUser = getSetValue(getSetValue(evt, strExt), Extensions.UserExt);
          setValue(extUser, "id", user.id, HelperFuncs_isString);
          setValue(extUser, "authId", user[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */], HelperFuncs_isString);
        }
      };
      _self.cleanUp = function (evt, itemCtx) {
        var ext = evt.ext;
        if (ext) {
          _removeEmpty(ext, Extensions.DeviceExt);
          _removeEmpty(ext, Extensions.UserExt);
          _removeEmpty(ext, Extensions.WebExt);
          _removeEmpty(ext, Extensions.OSExt);
          _removeEmpty(ext, Extensions.AppExt);
          _removeEmpty(ext, Extensions.TraceExt);
        }
      };
    });
  }
  // Removed Stub for TelemetryContext.prototype.applySessionContext.
  // Removed Stub for TelemetryContext.prototype.applyOperatingSystemContxt.
  // Removed Stub for TelemetryContext.prototype.applyApplicationContext.
  // Removed Stub for TelemetryContext.prototype.applyDeviceContext.
  // Removed Stub for TelemetryContext.prototype.applyInternalContext.
  // Removed Stub for TelemetryContext.prototype.applyLocationContext.
  // Removed Stub for TelemetryContext.prototype.applyOperationContext.
  // Removed Stub for TelemetryContext.prototype.applyWebContext.
  // Removed Stub for TelemetryContext.prototype.applyUserContext.
  // Removed Stub for TelemetryContext.prototype.cleanUp.
  // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
  // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
  // this will be removed when ES3 support is dropped.
  TelemetryContext.__ieDyn = 1;
  return TelemetryContext;
}();

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-esm/PropertiesPlugin.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* PropertiesPlugin.ts
* @copyright Microsoft 2018
*/






var PropertiesPlugin = /** @class */function (_super) {
  __extendsFn(PropertiesPlugin, _super);
  function PropertiesPlugin() {
    var _this = _super.call(this) || this;
    _this.priority = 110;
    _this.identifier = PropertiesPluginIdentifier;
    var _extensionConfig;
    var _distributedTraceCtx;
    var _previousTraceCtx;
    dynamicProto(PropertiesPlugin, _this, function (_self, _base) {
      _initDefaults();
      _self.initialize = function (config, core, extensions, pluginChain) {
        _base.initialize(config, core, extensions, pluginChain);
        _populateDefaults(config);
      };
      /**
       * Add Part A fields to the event
       * @param event The event that needs to be processed
       */
      _self.processTelemetry = function (event, itemCtx) {
        if (isNullOrUndefined(event)) {
          // TODO(barustum): throw an internal event once we have support for internal logging
        } else {
          itemCtx = _self._getTelCtx(itemCtx);
          // If the envelope is PageView, reset the internal message count so that we can send internal telemetry for the new page.
          if (event.name === PageView.envelopeType) {
            itemCtx.diagLog().resetInternalMessageCount();
          }
          var theContext = _self.context || {};
          if (theContext.session) {
            // If customer did not provide custom session id update the session manager
            if (typeof _self.context.session.id !== "string" && theContext[_DYN_SESSION_MANAGER /* @min:%2esessionManager */]) {
              theContext[_DYN_SESSION_MANAGER /* @min:%2esessionManager */][_DynamicConstants_DYN_UPDATE /* @min:%2eupdate */]();
            }
          }

          var userCtx = theContext.user;
          if (userCtx && !userCtx[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */]) {
            userCtx[_DynamicConstants_DYN_UPDATE /* @min:%2eupdate */](theContext.user.id);
          }
          _processTelemetryInternal(event, itemCtx);
          if (userCtx && userCtx[_DYN_IS_NEW_USER /* @min:%2eisNewUser */]) {
            userCtx[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = false;
            var message = new _InternalLogMessage(72 /* _eInternalMessageId.SendBrowserInfoOnUserInit */, (getNavigator() || {}).userAgent || "");
            _logInternalMessage(itemCtx.diagLog(), 1 /* eLoggingSeverity.CRITICAL */, message);
          }
          _self.processNext(event, itemCtx);
        }
      };
      _self._doTeardown = function (unloadCtx, unloadState) {
        var core = (unloadCtx || {}).core();
        if (core && core[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */]) {
          var traceCtx = core[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */](false);
          if (traceCtx === _distributedTraceCtx) {
            core.setTraceCtx(_previousTraceCtx);
          }
        }
        _initDefaults();
      };
      function _initDefaults() {
        _extensionConfig = null;
        _distributedTraceCtx = null;
        _previousTraceCtx = null;
      }
      function _populateDefaults(config) {
        var identifier = _self.identifier;
        var core = _self.core;
        var ctx = createProcessTelemetryContext(null, config, core);
        var defaultConfig = PropertiesPlugin.getDefaultConfig();
        _extensionConfig = _extensionConfig || {};
        HelperFuncs_objForEachKey(defaultConfig, function (field, value) {
          _extensionConfig[field] = function () {
            return ctx.getConfig(identifier, field, value());
          };
        });
        _previousTraceCtx = core[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */](false);
        _self.context = new TelemetryContext(core, _extensionConfig, _previousTraceCtx);
        _distributedTraceCtx = createDistributedTraceContextFromTrace(_self.context[_DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */], _previousTraceCtx);
        core.setTraceCtx(_distributedTraceCtx);
        _self.context.appId = function () {
          var breezeChannel = core.getPlugin(BreezeChannelIdentifier);
          return breezeChannel ? breezeChannel.plugin["_appId"] : null;
        };
        // Test hook to allow accessing the internal values -- explicitly not defined as an available property on the class
        _self["_extConfig"] = _extensionConfig;
      }
      function _processTelemetryInternal(evt, itemCtx) {
        // Set Part A fields
        getSetValue(evt, "tags", []);
        getSetValue(evt, "ext", {});
        var ctx = _self.context;
        ctx[_DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */](evt, itemCtx);
        ctx[_DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */](evt, itemCtx);
        ctx[_DYN_APPLY_DEVICE_CONTEXT /* @min:%2eapplyDeviceContext */](evt, itemCtx);
        ctx[_DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */](evt, itemCtx);
        ctx[_DYN_APPLY_USER_CONTEXT /* @min:%2eapplyUserContext */](evt, itemCtx);
        ctx[_DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */](evt, itemCtx);
        ctx.applyWebContext(evt, itemCtx);
        ctx[_DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */](evt, itemCtx); // legacy tags
        ctx[_DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */](evt, itemCtx); // legacy tags
        ctx.cleanUp(evt, itemCtx);
      }
    });
    return _this;
  }
  PropertiesPlugin.getDefaultConfig = function () {
    var _a;
    var defaultValue;
    var nullValue = null;
    var defaultConfig = (_a = {
      instrumentationKey: function () {
        return defaultValue;
      }
    }, _a[_DYN_ACCOUNT_ID /* @min:accountId */] = function () {
      return nullValue;
    }, _a.sessionRenewalMs = function () {
      return 30 * 60 * 1000;
    }, _a.samplingPercentage = function () {
      return 100;
    }, _a.sessionExpirationMs = function () {
      return 24 * 60 * 60 * 1000;
    }, _a[_DYN_COOKIE_DOMAIN /* @min:cookieDomain */] = function () {
      return nullValue;
    }, _a[_DYN_SDK_EXTENSION /* @min:sdkExtension */] = function () {
      return nullValue;
    }, _a.isBrowserLinkTrackingEnabled = function () {
      return false;
    }, _a.appId = function () {
      return nullValue;
    }, _a[_DYN_GET_SESSION_ID /* @min:getSessionId */] = function () {
      return nullValue;
    }, _a[dist_esm_DynamicConstants_DYN_NAME_PREFIX /* @min:namePrefix */] = function () {
      return defaultValue;
    }, _a[_DYN_SESSION_COOKIE_POSTF6 /* @min:sessionCookiePostfix */] = function () {
      return defaultValue;
    }, _a[_DYN_USER_COOKIE_POSTFIX /* @min:userCookiePostfix */] = function () {
      return defaultValue;
    }, _a[_DYN_ID_LENGTH /* @min:idLength */] = function () {
      return 22;
    }, _a[_DYN_GET_NEW_ID /* @min:getNewId */] = function () {
      return nullValue;
    }, _a);
    return defaultConfig;
  };
  // Removed Stub for PropertiesPlugin.prototype.initialize.
  // Removed Stub for PropertiesPlugin.prototype.processTelemetry.
  return PropertiesPlugin;
}(BaseTelemetryPlugin);
/* harmony default export */ var dist_esm_PropertiesPlugin = (PropertiesPlugin);
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-web/dist-esm/InternalConstants.js
/*
 * Application Insights JavaScript SDK - Web, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var _AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var _TRACK = "track";
var dist_esm_InternalConstants_STR_EMPTY = "";
var STR_SNIPPET = "snippet";
var STR_GET_COOKIE_MGR = "getCookieMgr";
var STR_START_TRACK_PAGE = "startTrackPage";
var STR_STOP_TRACK_PAGE = "stopTrackPage";
var STR_FLUSH = "flush";
var STR_START_TRACK_EVENT = "startTrackEvent";
var STR_STOP_TRACK_EVENT = "stopTrackEvent";
var STR_ADD_TELEMETRY_INITIALIZER = "addTelemetryInitializer";
var STR_ADD_TELEMETRY_INITIALIZERS = STR_ADD_TELEMETRY_INITIALIZER + "s";
var STR_POLL_INTERNAL_LOGS = "pollInternalLogs";
var STR_GET_PLUGIN = "getPlugin";
var STR_EVT_NAMESPACE = "evtNamespace";
var STR_TRACK_EVENT = _TRACK + "Event";
var STR_TRACK_TRACE = _TRACK + "Trace";
var STR_TRACK_METRIC = _TRACK + "Metric";
var STR_TRACK_PAGE_VIEW = _TRACK + "PageView";
var STR_TRACK_EXCEPTION = _TRACK + "Exception";
var STR_TRACK_DEPENDENCY_DATA = _TRACK + "DependencyData";
var STR_SET_AUTHENTICATED_USER_CONTEXT = "set" + _AUTHENTICATED_USER_CONTEXT;
var STR_CLEAR_AUTHENTICATED_USER_CONTEXT = "clear" + _AUTHENTICATED_USER_CONTEXT;
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-web/dist-esm/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Web, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_UPDATE_SNIPPET_DEFIN0 = "updateSnippetDefinitions"; // Count: 4
var _DYN_LOAD_APP_INSIGHTS = "loadAppInsights"; // Count: 4
var _DynamicConstants_DYN_ENDPOINT_URL = "endpointUrl"; // Count: 4
var _DynamicConstants_DYN_MAX_BATCH_SIZE_IN_BY1 = "maxBatchSizeInBytes"; // Count: 3
var _DynamicConstants_DYN_MAX_BATCH_INTERVAL = "maxBatchInterval"; // Count: 3
var _DYN_DISABLE_EXCEPTION_TR2 = "disableExceptionTracking"; // Count: 2
var _DynamicConstants_DYN_DISABLE_TELEMETRY = "disableTelemetry"; // Count: 2
var _DYN_EMIT_LINE_DELIMITED_3 = "emitLineDelimitedJson"; // Count: 2
var _DYN_DIAGNOSTIC_LOG_INTER4 = "diagnosticLogInterval"; // Count: 6
var _DYN_AUTO_TRACK_PAGE_VISI5 = "autoTrackPageVisitTime"; // Count: 2
var dist_esm_DynamicConstants_DYN_SAMPLING_PERCENTAGE = "samplingPercentage"; // Count: 4
var _DYN_DISABLE_AJAX_TRACKIN6 = "disableAjaxTracking"; // Count: 2
var _DYN_MAX_AJAX_CALLS_PER_V7 = "maxAjaxCallsPerView"; // Count: 3
var _DYN_IS_BEACON_API_DISABL8 = "isBeaconApiDisabled"; // Count: 2
var _DYN_DISABLE_CORRELATION_9 = "disableCorrelationHeaders"; // Count: 2
var _DYN_CORRELATION_HEADER_E10 = "correlationHeaderExcludedDomains"; // Count: 2
var _DYN_DISABLE_FLUSH_ON_BEF11 = "disableFlushOnBeforeUnload"; // Count: 4
var _DYN_DISABLE_FLUSH_ON_UNL12 = "disableFlushOnUnload"; // Count: 3
var _DYN_ENABLE_SESSION_STORA13 = "enableSessionStorageBuffer"; // Count: 2
var _DYN_IS_COOKIE_USE_DISABL14 = "isCookieUseDisabled"; // Count: 2
var _DYN_IS_STORAGE_USE_DISAB15 = "isStorageUseDisabled"; // Count: 2
var _DYN_IS_BROWSER_LINK_TRAC16 = "isBrowserLinkTrackingEnabled"; // Count: 2
var _DYN_ENABLE_CORS_CORRELAT17 = "enableCorsCorrelation"; // Count: 2
var dist_esm_DynamicConstants_DYN_CONFIG = "config"; // Count: 6
var _DynamicConstants_DYN_CONTEXT = "context"; // Count: 8
var applicationinsights_web_dist_esm_DynamicConstants_DYN_PUSH = "push"; // Count: 5
var dist_esm_DynamicConstants_DYN_VERSION = "version"; // Count: 6
var _DYN_QUEUE = "queue"; // Count: 6
var _DYN_CONNECTION_STRING = "connectionString"; // Count: 3
var dist_esm_DynamicConstants_DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 2
var _DYN_APP_INSIGHTS = "appInsights"; // Count: 3
var _DYN_DISABLE_IKEY_DEPRECA18 = "disableIkeyDeprecationMessage"; // Count: 2
var _DYN_GET_TRANSMISSION_CON19 = "getTransmissionControls"; // Count: 2
var _DYN_ONUNLOAD_FLUSH = "onunloadFlush"; // Count: 6
var _DYN_ADD_HOUSEKEEPING_BEF20 = "addHousekeepingBeforeUnload"; // Count: 2
var applicationinsights_web_dist_esm_DynamicConstants_DYN_INDEX_OF = "indexOf"; // Count: 4
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-web/dist-esm/Initialization.js
/*
 * Application Insights JavaScript SDK - Web, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */












var _internalSdkSrc;
// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var _ignoreUpdateSnippetProperties = [STR_SNIPPET, "dependencies", "properties", "_snippetVersion", "appInsightsNew", "getSKUDefaults"];
// Re-exposing the Common classes as Telemetry, the list was taken by reviewing the generated code for the build while using
// the previous configuration :-
// import * as Common from "@microsoft/applicationinsights-common"
// export const Telemetry = Common;
var fieldType = {
  Default: 0 /* FieldType.Default */,
  Required: 1 /* FieldType.Required */,
  Array: 2 /* FieldType.Array */,
  Hidden: 4 /* FieldType.Hidden */
};
/**
 * Telemetry type classes, e.g. PageView, Exception, etc
 */
var Telemetry = {
  __proto__: null,
  PropertiesPluginIdentifier: PropertiesPluginIdentifier,
  BreezeChannelIdentifier: BreezeChannelIdentifier,
  AnalyticsPluginIdentifier: AnalyticsPluginIdentifier,
  Util: Util,
  CorrelationIdHelper: CorrelationIdHelper,
  UrlHelper: UrlHelper,
  DateTimeUtils: DateTimeUtils,
  ConnectionStringParser: ConnectionStringParser,
  FieldType: fieldType,
  RequestHeaders: RequestHeaders,
  DisabledPropertyName: DisabledPropertyName,
  ProcessLegacy: ProcessLegacy,
  SampleRate: SampleRate,
  HttpMethod: HttpMethod,
  DEFAULT_BREEZE_ENDPOINT: DEFAULT_BREEZE_ENDPOINT,
  Envelope: Envelope,
  Event: Event_Event,
  Exception: Exception,
  Metric: Metric,
  PageView: PageView,
  RemoteDependencyData: RemoteDependencyData,
  Trace: Trace,
  PageViewPerformance: PageViewPerformance,
  Data: Data,
  SeverityLevel: SeverityLevel,
  ConfigurationManager: ConfigurationManager,
  ContextTagKeys: ContextTagKeys,
  DataSanitizer: DataSanitizer,
  TelemetryItemCreator: TelemetryItemCreator,
  CtxTagKeys: CtxTagKeys,
  Extensions: Extensions,
  DistributedTracingModes: DistributedTracingModes
};
/**
 * Application Insights API
 * @class Initialization
 * @implements {IApplicationInsights}
 */
var Initialization = /** @class */function () {
  function Initialization(snippet) {
    var _this = this;
    // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
    var dependencies;
    var properties;
    var _sender;
    var _snippetVersion;
    var _evtNamespace;
    var _houseKeepingNamespace;
    var _core;
    dynamicProto(Initialization, this, function (_self) {
      _initDefaults();
      // initialize the queue and config in case they are undefined
      _snippetVersion = "" + (snippet.sv || snippet[dist_esm_DynamicConstants_DYN_VERSION /* @min:%2eversion */] || "");
      snippet[_DYN_QUEUE /* @min:%2equeue */] = snippet[_DYN_QUEUE /* @min:%2equeue */] || [];
      snippet[dist_esm_DynamicConstants_DYN_VERSION /* @min:%2eversion */] = snippet[dist_esm_DynamicConstants_DYN_VERSION /* @min:%2eversion */] || 2.0; // Default to new version
      var config = snippet[dist_esm_DynamicConstants_DYN_CONFIG /* @min:%2econfig */] || {};
      if (config[_DYN_CONNECTION_STRING /* @min:%2econnectionString */]) {
        var cs = parseConnectionString(config[_DYN_CONNECTION_STRING /* @min:%2econnectionString */]);
        var ingest = cs.ingestionendpoint;
        config[_DynamicConstants_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */] = ingest ? ingest + DEFAULT_BREEZE_PATH : config[_DynamicConstants_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */]; // only add /v2/track when from connectionstring
        config[dist_esm_DynamicConstants_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */] = cs.instrumentationkey || config[dist_esm_DynamicConstants_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */];
      }

      _self[_DYN_APP_INSIGHTS /* @min:%2eappInsights */] = new AnalyticsPlugin();
      properties = new dist_esm_PropertiesPlugin();
      dependencies = new AjaxMonitor();
      _sender = new Sender();
      _core = new AppInsightsCore();
      _self.core = _core;
      var isErrMessageDisabled = isNullOrUndefined(config[_DYN_DISABLE_IKEY_DEPRECA18 /* @min:%2edisableIkeyDeprecationMessage */]) ? true : config[_DYN_DISABLE_IKEY_DEPRECA18 /* @min:%2edisableIkeyDeprecationMessage */];
      if (!config[_DYN_CONNECTION_STRING /* @min:%2econnectionString */] && !isErrMessageDisabled) {
        _throwInternal(_core.logger, 1 /* eLoggingSeverity.CRITICAL */, 106 /* _eInternalMessageId.InstrumentationKeyDeprecation */, "Instrumentation key support will end soon, see aka.ms/IkeyMigrate");
      }
      _self[STR_SNIPPET /* @min:%2esnippet */] = snippet;
      _self[dist_esm_DynamicConstants_DYN_CONFIG /* @min:%2econfig */] = config;
      _getSKUDefaults();
      _self[STR_FLUSH /* @min:%2eflush */] = function (async) {
        if (async === void 0) {
          async = true;
        }
        doPerf(_core, function () {
          return "AISKU.flush";
        }, function () {
          HelperFuncs_arrForEach(_core[_DYN_GET_TRANSMISSION_CON19 /* @min:%2egetTransmissionControls */](), function (channels) {
            HelperFuncs_arrForEach(channels, function (channel) {
              channel[STR_FLUSH /* @min:%2eflush */](async);
            });
          });
        }, null, async);
      };
      _self[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */] = function (async) {
        if (async === void 0) {
          async = true;
        }
        HelperFuncs_arrForEach(_core[_DYN_GET_TRANSMISSION_CON19 /* @min:%2egetTransmissionControls */](), function (channels) {
          HelperFuncs_arrForEach(channels, function (channel) {
            if (channel[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */]) {
              channel[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */]();
            } else {
              channel[STR_FLUSH /* @min:%2eflush */](async);
            }
          });
        });
      };
      _self[_DYN_LOAD_APP_INSIGHTS /* @min:%2eloadAppInsights */] = function (legacyMode, logger, notificationManager) {
        if (legacyMode === void 0) {
          legacyMode = false;
        }
        function _updateSnippetProperties(snippet) {
          if (snippet) {
            var snippetVer = "";
            if (!isNullOrUndefined(_snippetVersion)) {
              snippetVer += _snippetVersion;
            }
            if (legacyMode) {
              snippetVer += ".lg";
            }
            if (_self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */] && _self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */].internal) {
              _self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */].internal.snippetVer = snippetVer || "-";
            }
            // apply updated properties to the global instance (snippet)
            HelperFuncs_objForEachKey(_self, function (field, value) {
              if (HelperFuncs_isString(field) && !HelperFuncs_isFunction(value) && field && field[0] !== "_" &&
              // Don't copy "internal" values
              arrIndexOf(_ignoreUpdateSnippetProperties, field) === -1) {
                snippet[field] = value;
              }
            });
          }
        }
        // dont allow additional channels/other extensions for legacy mode; legacy mode is only to allow users to switch with no code changes!
        if (legacyMode && _self[dist_esm_DynamicConstants_DYN_CONFIG /* @min:%2econfig */].extensions && _self[dist_esm_DynamicConstants_DYN_CONFIG /* @min:%2econfig */].extensions.length > 0) {
          throwError("Extensions not allowed in legacy mode");
        }
        doPerf(_self.core, function () {
          return "AISKU.loadAppInsights";
        }, function () {
          var extensions = [];
          extensions[applicationinsights_web_dist_esm_DynamicConstants_DYN_PUSH /* @min:%2epush */](_sender);
          extensions[applicationinsights_web_dist_esm_DynamicConstants_DYN_PUSH /* @min:%2epush */](properties);
          extensions[applicationinsights_web_dist_esm_DynamicConstants_DYN_PUSH /* @min:%2epush */](dependencies);
          extensions[applicationinsights_web_dist_esm_DynamicConstants_DYN_PUSH /* @min:%2epush */](_self[_DYN_APP_INSIGHTS /* @min:%2eappInsights */]);
          // initialize core
          _core.initialize(_self[dist_esm_DynamicConstants_DYN_CONFIG /* @min:%2econfig */], extensions, logger, notificationManager);
          _self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */] = properties[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */];
          if (_internalSdkSrc && _self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */]) {
            _self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */].internal.sdkSrc = _internalSdkSrc;
          }
          _updateSnippetProperties(_self[STR_SNIPPET /* @min:%2esnippet */]);
          // Empty queue of all api calls logged prior to sdk download
          _self.emptyQueue();
          _self[STR_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */]();
          _self[_DYN_ADD_HOUSEKEEPING_BEF20 /* @min:%2eaddHousekeepingBeforeUnload */](_this);
        });
        return _self;
      };
      _self[_DYN_UPDATE_SNIPPET_DEFIN0 /* @min:%2eupdateSnippetDefinitions */] = function (snippet) {
        // apply full appInsights to the global instance
        // Note: This must be called before loadAppInsights is called
        proxyAssign(snippet, _self, function (name) {
          // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
          return name && arrIndexOf(_ignoreUpdateSnippetProperties, name) === -1;
        });
      };
      _self.emptyQueue = function () {
        // call functions that were queued before the main script was loaded
        try {
          if (HelperFuncs_isArray(_self.snippet[_DYN_QUEUE /* @min:%2equeue */])) {
            // note: do not check length in the for-loop conditional in case something goes wrong and the stub methods are not overridden.
            var length_1 = _self.snippet[_DYN_QUEUE /* @min:%2equeue */].length;
            for (var i = 0; i < length_1; i++) {
              var call = _self.snippet[_DYN_QUEUE /* @min:%2equeue */][i];
              call();
            }
            _self.snippet[_DYN_QUEUE /* @min:%2equeue */] = undefined;
            delete _self.snippet[_DYN_QUEUE /* @min:%2equeue */];
          }
        } catch (exception) {
          var properties_1 = {};
          if (exception && HelperFuncs_isFunction(exception.toString)) {
            properties_1.exception = exception.toString();
          }
          // need from core
          // Microsoft.ApplicationInsights._InternalLogging.throwInternal(
          //     eLoggingSeverity.WARNING,
          //     _eInternalMessageId.FailedToSendQueuedTelemetry,
          //     "Failed to send queued telemetry",
          //     properties);
        }
      };

      _self[_DYN_ADD_HOUSEKEEPING_BEF20 /* @min:%2eaddHousekeepingBeforeUnload */] = function (appInsightsInstance) {
        // Add callback to push events when the user navigates away
        if (hasWindow() || hasDocument()) {
          var performHousekeeping = function () {
            // Adds the ability to flush all data before the page unloads.
            // Note: This approach tries to push a sync request with all the pending events onbeforeunload.
            // Firefox does not respect this.Other browsers DO push out the call with < 100% hit rate.
            // Telemetry here will help us analyze how effective this approach is.
            // Another approach would be to make this call sync with a acceptable timeout to reduce the
            // impact on user experience.
            // appInsightsInstance.context._sender.triggerSend();
            appInsightsInstance[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */](false);
            // Back up the current session to local storage
            // This lets us close expired sessions after the cookies themselves expire
            if (HelperFuncs_isFunction(_this.core[STR_GET_PLUGIN /* @min:%2egetPlugin */])) {
              var loadedPlugin = _this.core[STR_GET_PLUGIN /* @min:%2egetPlugin */](PropertiesPluginIdentifier);
              if (loadedPlugin) {
                var propertiesPlugin = loadedPlugin.plugin;
                if (propertiesPlugin && propertiesPlugin[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */] && propertiesPlugin[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */]._sessionManager) {
                  propertiesPlugin[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */]._sessionManager.backup();
                }
              }
            }
          };
          var added = false;
          var excludePageUnloadEvents = appInsightsInstance.appInsights[dist_esm_DynamicConstants_DYN_CONFIG /* @min:%2econfig */].disablePageUnloadEvents;
          if (!_houseKeepingNamespace) {
            _houseKeepingNamespace = mergeEvtNamespace(_evtNamespace, _core[STR_EVT_NAMESPACE /* @min:%2eevtNamespace */] && _core[STR_EVT_NAMESPACE /* @min:%2eevtNamespace */]());
          }

          if (!appInsightsInstance.appInsights.config[_DYN_DISABLE_FLUSH_ON_BEF11 /* @min:%2edisableFlushOnBeforeUnload */]) {
            // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
            // As just hooking the window does not always fire (on chrome) for page navigation's.
            if (addPageUnloadEventListener(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace)) {
              added = true;
            }
            // We also need to hook the pagehide and visibilitychange events as not all versions of Safari support load/unload events.
            if (addPageHideEventListener(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace)) {
              added = true;
            }
            // A reactNative app may not have a window and therefore the beforeunload/pagehide events -- so don't
            // log the failure in this case
            if (!added && !isReactNative()) {
              _throwInternal(appInsightsInstance[_DYN_APP_INSIGHTS /* @min:%2eappInsights */].core.logger, 1 /* eLoggingSeverity.CRITICAL */, 19 /* _eInternalMessageId.FailedToAddHandlerForOnBeforeUnload */, "Could not add handler for beforeunload and pagehide");
            }
          }
          if (!added && !appInsightsInstance.appInsights.config[_DYN_DISABLE_FLUSH_ON_UNL12 /* @min:%2edisableFlushOnUnload */]) {
            // If we didn't add the normal set then attempt to add the pagehide and visibilitychange only
            addPageHideEventListener(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace);
          }
        }
      };
      _self.getSender = function () {
        return _sender;
      };
      _self.unload = function (isAsync, unloadComplete, cbTimeout) {
        _self[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */](isAsync);
        // Remove any registered event handlers
        if (_houseKeepingNamespace) {
          removePageUnloadEventListener(null, _houseKeepingNamespace);
          removePageHideEventListener(null, _houseKeepingNamespace);
        }
        _core.unload && _core.unload(isAsync, unloadComplete, cbTimeout);
      };
      proxyFunctions(_self, _self[_DYN_APP_INSIGHTS /* @min:%2eappInsights */], [STR_GET_COOKIE_MGR, STR_TRACK_EVENT, STR_TRACK_PAGE_VIEW, "trackPageViewPerformance", STR_TRACK_EXCEPTION, "_onerror", STR_TRACK_TRACE, STR_TRACK_METRIC, STR_START_TRACK_PAGE, STR_STOP_TRACK_PAGE, STR_START_TRACK_EVENT, STR_STOP_TRACK_EVENT]);
      proxyFunctions(_self, _getCurrentDependencies, [STR_TRACK_DEPENDENCY_DATA, "addDependencyListener", "addDependencyInitializer"]);
      proxyFunctions(_self, _core, [STR_ADD_TELEMETRY_INITIALIZER, STR_POLL_INTERNAL_LOGS, "stopPollingInternalLogs", STR_GET_PLUGIN, "addPlugin", STR_EVT_NAMESPACE, "addUnloadCb", "getTraceCtx"]);
      proxyFunctions(_self, function () {
        var context = properties[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */];
        return context ? context.user : null;
      }, [STR_SET_AUTHENTICATED_USER_CONTEXT, STR_CLEAR_AUTHENTICATED_USER_CONTEXT]);
      function _getSKUDefaults() {
        _self.config[_DYN_DIAGNOSTIC_LOG_INTER4 /* @min:%2ediagnosticLogInterval */] = _self.config[_DYN_DIAGNOSTIC_LOG_INTER4 /* @min:%2ediagnosticLogInterval */] && _self[dist_esm_DynamicConstants_DYN_CONFIG /* @min:%2econfig */][_DYN_DIAGNOSTIC_LOG_INTER4 /* @min:%2ediagnosticLogInterval */] > 0 ? _self[dist_esm_DynamicConstants_DYN_CONFIG /* @min:%2econfig */][_DYN_DIAGNOSTIC_LOG_INTER4 /* @min:%2ediagnosticLogInterval */] : 10000;
      }
      // Using a function to support the dynamic adding / removal of plugins, so this will always return the current value
      function _getCurrentDependencies() {
        return dependencies;
      }
      function _initDefaults() {
        _evtNamespace = createUniqueNamespace("AISKU");
        _houseKeepingNamespace = null;
        dependencies = null;
        properties = null;
        _sender = null;
        _snippetVersion = null;
      }
    });
  }
  // Analytics Plugin
  // Removed Stub for Initialization.prototype.getCookieMgr.
  // Removed Stub for Initialization.prototype.trackEvent.
  // Removed Stub for Initialization.prototype.trackPageView.
  // Removed Stub for Initialization.prototype.trackPageViewPerformance.
  // Removed Stub for Initialization.prototype.trackException.
  // Removed Stub for Initialization.prototype._onerror.
  // Removed Stub for Initialization.prototype.trackTrace.
  // Removed Stub for Initialization.prototype.trackMetric.
  // Removed Stub for Initialization.prototype.startTrackPage.
  // Removed Stub for Initialization.prototype.stopTrackPage.
  // Removed Stub for Initialization.prototype.startTrackEvent.
  // Removed Stub for Initialization.prototype.stopTrackEvent.
  // Removed Stub for Initialization.prototype.addTelemetryInitializer.
  // Properties Plugin
  // Removed Stub for Initialization.prototype.setAuthenticatedUserContext.
  // Removed Stub for Initialization.prototype.clearAuthenticatedUserContext.
  // Dependencies Plugin
  // Removed Stub for Initialization.prototype.trackDependencyData.
  // Misc
  // Removed Stub for Initialization.prototype.flush.
  // Removed Stub for Initialization.prototype.onunloadFlush.
  // Removed Stub for Initialization.prototype.loadAppInsights.
  // Removed Stub for Initialization.prototype.updateSnippetDefinitions.
  // Removed Stub for Initialization.prototype.emptyQueue.
  // Removed Stub for Initialization.prototype.pollInternalLogs.
  // Removed Stub for Initialization.prototype.stopPollingInternalLogs.
  // Removed Stub for Initialization.prototype.addHousekeepingBeforeUnload.
  // Removed Stub for Initialization.prototype.getSender.
  // Removed Stub for Initialization.prototype.unload.
  // Removed Stub for Initialization.prototype.getPlugin.
  // Removed Stub for Initialization.prototype.addPlugin.
  // Removed Stub for Initialization.prototype.evtNamespace.
  // Removed Stub for Initialization.prototype.addUnloadCb.
  // Removed Stub for Initialization.prototype.addDependencyListener.
  /**
   * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
   * It is called after the dependency call has completed and any available performance details are available. A dependency
   * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
   * request so that it doesn't count against the `maxAjaxCallsPerView`.
   * @param dependencyInitializer - The Dependency Telemetry Initializer function
   * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
   */
  Initialization.prototype.addDependencyInitializer = function (dependencyInitializer) {
    return null;
  };
  // Removed Stub for Initialization.prototype.getTraceCtx.
  return Initialization;
}();

// tslint:disable-next-line
(function () {
  var sdkSrc = null;
  var isModule = false;
  var cdns = ["://js.monitor.azure.com/", "://az416426.vo.msecnd.net/"];
  try {
    // Try and determine whether the sdk is being loaded from the CDN
    // currentScript is only valid during initial processing
    var scrpt = (document || {}).currentScript;
    if (scrpt) {
      sdkSrc = scrpt.src;
      // } else {
      //     // We need to update to at least typescript 2.9 for this to work :-(
      //     // Leaving as a stub for now so after we upgrade this breadcrumb is available
      //     let meta = import.meta;
      //     sdkSrc = (meta || {}).url;
      //     isModule = true;
    }
  } catch (e) {
    // eslint-disable-next-line no-empty
  }
  if (sdkSrc) {
    try {
      var url = sdkSrc.toLowerCase();
      if (url) {
        var src = "";
        for (var idx = 0; idx < cdns.length; idx++) {
          if (url[applicationinsights_web_dist_esm_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */](cdns[idx]) !== -1) {
            src = "cdn" + (idx + 1);
            if (url[applicationinsights_web_dist_esm_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */]("/scripts/") === -1) {
              if (url[applicationinsights_web_dist_esm_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */]("/next/") !== -1) {
                src += "-next";
              } else if (url[applicationinsights_web_dist_esm_DynamicConstants_DYN_INDEX_OF /* @min:%2eindexOf */]("/beta/") !== -1) {
                src += "-beta";
              }
            }
            _internalSdkSrc = src + (isModule ? ".mod" : "");
            break;
          }
        }
      }
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
  }
})();
;// CONCATENATED MODULE: ./src/contexts/useAppInsights.tsx


const defaultBrowserHistory = {
    url: "/",
    location: {
        pathname: ""
    },
    listen: ()=>{}
};
let browserHistory = defaultBrowserHistory;
if (true) {
    var ref;
    browserHistory = {
        ...browserHistory,
        ...window.history
    };
    browserHistory.location.pathname = browserHistory === null || browserHistory === void 0 ? void 0 : (ref = browserHistory.state) === null || ref === void 0 ? void 0 : ref.url;
}
const reactPlugin = new dist_esm_ReactPlugin();
const appInsights = new Initialization({
    config: {
        instrumentationKey: "d47ab2c0-dfed-43f1-949e-cfee9f487dd4",
        maxBatchSizeInBytes: 10000,
        maxBatchInterval: 15000,
        disableCookiesUsage: true,
        extensions: [
            reactPlugin
        ],
        extensionConfig: {
            [reactPlugin.identifier]: {
                history: browserHistory
            }
        }
    }
});
if (true) {
    appInsights.loadAppInsights();
}


;// CONCATENATED MODULE: ./src/contexts/useAuth.tsx


const AuthContext = /*#__PURE__*/ (0,react.createContext)(undefined);
const AuthProvider = (param)=>{
    let { children  } = param;
    const [initialState, setInitialState] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const { referrer  } = document;
        if (referrer) {
            // Start listening to AEM response
            window.addEventListener("message", (event)=>{
                if (event.data.id !== "gb_aem_response") {
                    return;
                }
                const { user  } = event.data;
                if (user) {
                    setInitialState(JSON.parse(user));
                }
            }, false);
            // Post message to AEM
            const message = {
                id: "gb_form_ready"
            };
            window.parent.postMessage(message, referrer);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthContext.Provider, {
        value: initialState,
        children: children
    });
};
const useAuth = ()=>{
    return (0,react.useContext)(AuthContext);
};


// EXTERNAL MODULE: ./src/contexts/useBrand.tsx
var useBrand = __webpack_require__(25765);
// EXTERNAL MODULE: ./src/contexts/useCampaign.tsx + 1 modules
var useCampaign = __webpack_require__(19168);
// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(46392);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(34376);
;// CONCATENATED MODULE: ./src/contexts/useDealer.tsx





const DealerContext = /*#__PURE__*/ (0,react.createContext)(undefined);
const DealerProvider = (param)=>{
    let { children  } = param;
    const router = (0,next_router.useRouter)();
    const brand = (0,useBrand/* useBrand */.D)();
    const [dealerObj, setdealerObj] = (0,react.useState)(false);
    const [preferredDealer, setPreferredDealer] = (0,react.useState)("");
    const { dealer , centre , centreId , dealerID , dealerId , otso , olso  } = router.query;
    let query = dealer || centre || centreId || dealerID || dealerId || "";
    (0,react.useEffect)(()=>{
        const { referrer  } = document;
        if (referrer) {
            // Start listening to AEM response
            window.addEventListener("message", (event)=>{
                if (event.data.id !== "gb_aem_getPreferredDealer") {
                    return;
                }
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const { dealer  } = event.data;
                if (dealer) {
                    setPreferredDealer(dealer);
                }
            }, false);
            // Post message to AEM
            const message = {
                id: "gb_form_getPreferredDealer"
            };
            window.parent.postMessage(message, referrer);
        }
    }, []);
    (0,react.useEffect)(()=>{
        async function getDealer(queryDealer) {
            try {
                var ref, ref1;
                const response = await axios/* default.post */.ZP.post("".concat("https://api.toyota.co.uk/forms/api", "/dealers"), {
                    dealer: queryDealer,
                    servicing: !!otso || !!olso
                });
                if (((ref = response === null || response === void 0 ? void 0 : response.data[0]) === null || ref === void 0 ? void 0 : (ref1 = ref._source) === null || ref1 === void 0 ? void 0 : ref1.brands[0].toLowerCase()) !== brand) {
                    return false;
                }
                return response.data;
            } catch (error) {
                return false;
            }
        }
        async function checkDealer() {
            if (!query && preferredDealer) {
                query = preferredDealer;
            }
            if (query) {
                const res = await getDealer(query);
                if (res) {
                    setdealerObj(res[0]._source);
                    // eslint-disable-next-line no-console
                    console.log("[GB] Dealer/Center in querystring: ".concat(res[0]._source.brands[0], " - ").concat(res[0]._source.name, " - ").concat(res[0]._source.applications.NMSC.externalID, " - ").concat(res[0]._source.uuid));
                    window.tngaDataLayer.dealer = {
                        name: res[0]._source.name,
                        dealerId: res[0]._source.uuid,
                        city: res[0]._source.addresses[0].city,
                        zipcode: res[0]._source.addresses[0].zip
                    };
                }
            }
        }
        checkDealer();
    }, [
        query,
        brand,
        preferredDealer
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DealerContext.Provider, {
        value: dealerObj,
        children: children
    });
};
const useDealer = ()=>{
    return (0,react.useContext)(DealerContext);
};


;// CONCATENATED MODULE: ./src/contexts/useFilter.tsx



const FilterContext = /*#__PURE__*/ (0,react.createContext)(undefined);
const FilterProvider = (param)=>{
    let { children  } = param;
    const router = (0,next_router.useRouter)();
    const { Categories , categories , fuel , Fuel , Featured , featured  } = router.query;
    const PreSelectedCategories = Categories || categories || "";
    const PreSelectedFuel = fuel || Fuel || "";
    const PreSelectedFeatured = featured || Featured || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterContext.Provider, {
        value: {
            Categories: PreSelectedCategories,
            Fuel: PreSelectedFuel,
            Featured: PreSelectedFeatured
        },
        children: children
    });
};
const useFilter = ()=>{
    return (0,react.useContext)(FilterContext);
};


;// CONCATENATED MODULE: ./src/contexts/useModel.tsx



const ModelContext = /*#__PURE__*/ (0,react.createContext)(undefined);
const ModelProvider = (param)=>{
    let { children  } = param;
    const router = (0,next_router.useRouter)();
    const { ModelID , ModelId , RangeCode , RC , rc , modelId , modelID , rangecode , modelid , model , Model  } = router.query;
    const MODEL = Model || model || ModelID || ModelId || RangeCode || RC || modelid || rangecode || rc || modelId || modelID || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContext.Provider, {
        value: MODEL,
        children: children
    });
};
const useModel = ()=>{
    return (0,react.useContext)(ModelContext);
};


;// CONCATENATED MODULE: ./src/contexts/useQuery.tsx



const QueryContext = /*#__PURE__*/ (0,react.createContext)(undefined);
const QueryProvider = (param)=>{
    let { children  } = param;
    const router = (0,next_router.useRouter)();
    const initialState = router.query;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryContext.Provider, {
        value: initialState,
        children: children
    });
};
const useQuery = ()=>{
    return (0,react.useContext)(QueryContext);
};


;// CONCATENATED MODULE: ./src/contexts/index.tsx











const ContextProvider = (param)=>{
    let { children  } = param;
    const Error = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col min-h-screen items-center justify-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {
                    className: "object-center w-48 mb-10"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-xl md:text-2xl lg:text-3xl",
                    children: "Error"
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm_AppInsightsErrorBoundary, {
        onError: Error,
        appInsights: reactPlugin,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useBrand/* BrandProvider */.M, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthProvider, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterProvider, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelProvider, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DealerProvider, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useCampaign/* CampaignProvider */.e, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryProvider, {
                                    children: children
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};



/***/ }),

/***/ 25765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useBrand; },
/* harmony export */   "M": function() { return /* binding */ BrandProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82684);



const BrandContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)("toyota");
const BrandProvider = (param)=>{
    let { children  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var _locale;
    // Should never be undefined as comes from next.config.js
    const initialState = (_locale = router.locale) !== null && _locale !== void 0 ? _locale : "toyota";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BrandContext.Provider, {
        value: initialState,
        children: children
    });
};
const useBrand = ()=>{
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(BrandContext);
};



/***/ }),

/***/ 19168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ CampaignProvider; },
  "y": function() { return /* binding */ useCampaign; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
;// CONCATENATED MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function js_cookie_assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function (value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === 'undefined') {
      return;
    }
    attributes = js_cookie_assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += '; ' + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }
    return document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes;
  }
  function get(key) {
    if (typeof document === 'undefined' || arguments.length && !key) {
      return;
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e) {}
    }
    return key ? jar[key] : jar;
  }
  return Object.create({
    set: set,
    get: get,
    remove: function (key, attributes) {
      set(key, '', js_cookie_assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function (attributes) {
      return init(this.converter, js_cookie_assign({}, this.attributes, attributes));
    },
    withConverter: function (converter) {
      return init(js_cookie_assign({}, this.converter, converter), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(defaultAttributes)
    },
    converter: {
      value: Object.freeze(converter)
    }
  });
}
var api = init(defaultConverter, {
  path: '/'
});
/* eslint-enable no-var */

/* harmony default export */ var js_cookie = (api);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(34376);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./src/contexts/useCampaign.tsx




const CampaignContext = /*#__PURE__*/ (0,react.createContext)(undefined);
const CampaignProvider = (param)=>{
    let { children  } = param;
    const router = (0,next_router.useRouter)();
    // Extract relevant query parameters
    const { BrochureRCode , BrochureRC , TestdriveRCode , TestDriveRCode , testdriveRC , CampaignID , CampaignId , campaignID , CID , ac , mc , utmCampaign  } = router.query;
    // Determine the campaign value
    const campaign = CampaignID || CampaignId || campaignID || CID || ac || js_cookie.get("CampaignID") || "";
    // State to hold UTM parameters
    const [utms, setUtms] = (0,react.useState)(null);
    // Function to retrieve and parse UTM cookie
    function getUTMCookie(cookieName) {
        const cookieValue = document.cookie.split("; ").find((row)=>row.startsWith("".concat(cookieName, "=")));
        if (cookieValue) {
            const jsonString = decodeURIComponent(cookieValue.split("=")[1] || "");
            try {
                const utmsVal = JSON.parse(jsonString);
                return utmsVal;
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error("Failed to parse UTM cookie JSON:", e);
            }
        }
        return null;
    }
    // useEffect to ensure the code runs on the client side
    (0,react.useEffect)(()=>{
        const utmParams = getUTMCookie("utm_cookie") || {};
        setUtms(utmParams);
    }, []);
    // Determine other campaign-related values
    const brochure = BrochureRCode || BrochureRC || js_cookie.get("BrochureRcode") || "";
    const testDrive = TestdriveRCode || TestDriveRCode || testdriveRC || js_cookie.get("TestdriveRCode") || "";
    const media = mc || "";
    const utm = utmCampaign || "";
    // Initial state to be provided through context
    const initialState = {
        campaign,
        brochure,
        testDrive,
        media,
        utm,
        utms
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignContext.Provider, {
        value: initialState,
        children: children
    });
};
// Hook to use the campaign context
const useCampaign = ()=>{
    return (0,react.useContext)(CampaignContext);
};



/***/ }),

/***/ 31412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./src/utils/helpers/wdyr.tsx
/* eslint-disable */ /**
 * WDYR (why-did-you-render) helps locate unnecessary re-renders.
 * Applied in development environment, on the frontend only.
 *
 * It will only log unnecessary re-renders, not expected re-renders.
 *
 * @see https://github.com/welldone-software/why-did-you-render
 * @see https://github.com/vercel/next.js/tree/canary/examples/with-why-did-you-render
 */ 
if (false) {}

// EXTERNAL MODULE: ./src/styles/main.scss
var main = __webpack_require__(11020);
// EXTERNAL MODULE: ./src/utils/helpers/index.ts + 9 modules
var helpers = __webpack_require__(45911);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1887);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/contexts/index.tsx + 96 modules
var contexts = __webpack_require__(28798);
;// CONCATENATED MODULE: ./src/pages/_app.tsx







const MyApp = (param)=>{
    let { Component , pageProps  } = param;
    var ref, ref1;
    const metaTitleSuffix = (pageProps === null || pageProps === void 0 ? void 0 : pageProps.isFinance) ? pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.settings) === null || ref === void 0 ? void 0 : ref.finance_title_suffix : pageProps === null || pageProps === void 0 ? void 0 : (ref1 = pageProps.settings) === null || ref1 === void 0 ? void 0 : ref1.title_suffix;
    const metaTitle = "".concat(pageProps.title, " | ").concat(metaTitleSuffix);
    const metaDesc = pageProps.description || "";
    (0,react.useEffect)(()=>{
        (0,helpers/* initTracking */.kP)(true);
        return ()=>{
            (0,helpers/* initTracking */.kP)(false);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(contexts/* ContextProvider */.HQ, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "viewport",
                            content: "width=device-width, initial-scale=1, viewport-fit=cover"
                        }, "viewport"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "robots",
                            content: "noindex, nofollow"
                        }, "robots"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "format-detection",
                            content: "telephone=no"
                        }, "format-detection"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: metaTitle
                        }, "title"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: metaDesc
                        }, "description")
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col min-h-screen",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                        ...pageProps
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 45911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Km": function() { return /* reexport */ helpers_closeOverlay; },
  "uu": function() { return /* reexport */ helpers_getCodeweaversConfiguration; },
  "lf": function() { return /* reexport */ helpers_getDealers; },
  "gU": function() { return /* reexport */ helpers_getModelImage; },
  "kP": function() { return /* reexport */ tracking/* initTracking */.kP; },
  "be": function() { return /* reexport */ removeDuplicates; },
  "UO": function() { return /* reexport */ tracking/* tracking */.UO; }
});

// UNUSED EXPORTS: getLinks, getModels, getPageData, getSource, getUsedCarData, useMediaQuery

;// CONCATENATED MODULE: ./src/utils/helpers/closeOverlay.ts
const closeOverlay = (title, copy, setSubmitResonse, disabled)=>{
    if (window && window.location !== window.parent.location && !disabled) {
        const message = {
            id: "gb-iframe-close",
            data: {
                title,
                copy: copy || ""
            }
        };
        window.parent.postMessage(message, "*");
        // eslint-disable-next-line no-console
        console.log("[GB] Close overlay message sent:", message);
    } else {
        setSubmitResonse("".concat(title, " ").concat(copy || ""));
    }
};
/* harmony default export */ var helpers_closeOverlay = (closeOverlay);

;// CONCATENATED MODULE: ./src/utils/helpers/getCodeweaversConfiguration.ts
const getCodeweaversConfiguration = (param)=>{
    let { model , configVehicle , settings  } = param;
    var ref, ref1;
    if (configVehicle) {
        var ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
        const options = (configVehicle === null || configVehicle === void 0 ? void 0 : (ref2 = configVehicle.car) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.equipment) === null || ref3 === void 0 ? void 0 : ref3.packs) && (configVehicle === null || configVehicle === void 0 ? void 0 : (ref4 = configVehicle.car) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.equipment) === null || ref5 === void 0 ? void 0 : ref5.packs.map((pack)=>{
            return {
                ...pack,
                description: pack.name,
                price: pack.price.listWithDiscount
            };
        }));
        const accessories = configVehicle === null || configVehicle === void 0 ? void 0 : (ref6 = configVehicle.car) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.equipment) === null || ref7 === void 0 ? void 0 : ref7.options.filter((option)=>option.type === "Accessory").map((option)=>{
            return {
                ...option,
                description: option.name,
                price: option.price.listWithDiscount
            };
        });
        return {
            defaultParameters: {
                deposit: {
                    defaultValue: (model === null || model === void 0 ? void 0 : (ref8 = model.finance) === null || ref8 === void 0 ? void 0 : ref8.deposit) || (settings === null || settings === void 0 ? void 0 : (ref9 = settings.configuration) === null || ref9 === void 0 ? void 0 : ref9.deposit)
                },
                annualMileage: {
                    defaultValue: (model === null || model === void 0 ? void 0 : (ref10 = model.finance) === null || ref10 === void 0 ? void 0 : ref10.mileage) || (settings === null || settings === void 0 ? void 0 : (ref11 = settings.configuration) === null || ref11 === void 0 ? void 0 : ref11.mileage)
                },
                term: {
                    defaultValue: (model === null || model === void 0 ? void 0 : (ref12 = model.finance) === null || ref12 === void 0 ? void 0 : ref12.term) || (settings === null || settings === void 0 ? void 0 : (ref13 = settings.configuration) === null || ref13 === void 0 ? void 0 : ref13.term)
                }
            },
            vehicle: {
                identifier: configVehicle === null || configVehicle === void 0 ? void 0 : (ref14 = configVehicle.car) === null || ref14 === void 0 ? void 0 : ref14.localCode,
                identifierType: "Rams",
                description: {
                    range: configVehicle === null || configVehicle === void 0 ? void 0 : (ref15 = configVehicle.car) === null || ref15 === void 0 ? void 0 : ref15.model,
                    bodyStyle: configVehicle === null || configVehicle === void 0 ? void 0 : (ref16 = configVehicle.car) === null || ref16 === void 0 ? void 0 : ref16.body,
                    grade: configVehicle === null || configVehicle === void 0 ? void 0 : (ref17 = configVehicle.car) === null || ref17 === void 0 ? void 0 : ref17.grade,
                    engine: configVehicle === null || configVehicle === void 0 ? void 0 : (ref18 = configVehicle.car) === null || ref18 === void 0 ? void 0 : ref18.engine,
                    colour: configVehicle === null || configVehicle === void 0 ? void 0 : (ref19 = configVehicle.car) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.colour) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.exterior) === null || ref21 === void 0 ? void 0 : ref21.name
                },
                options: options || [],
                accessories: accessories || [],
                isNew: "true",
                type: "car",
                cashPrice: configVehicle === null || configVehicle === void 0 ? void 0 : (ref22 = configVehicle.price) === null || ref22 === void 0 ? void 0 : ref22.listWithDiscount,
                // customerSaving: null, // Optional
                // centreContribution: vehicle.centr_contr, // Optional
                linkBackUrl: configVehicle === null || configVehicle === void 0 ? void 0 : configVehicle.url,
                imageUrl: "".concat("https://images.toyota-europe.com", "/configuration/").concat(configVehicle === null || configVehicle === void 0 ? void 0 : (ref23 = configVehicle.personal) === null || ref23 === void 0 ? void 0 : ref23.code, "/exterior-04.png?width=768&height=516")
            }
        };
    }
    if (model) {
        var ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31;
        return {
            defaultParameters: {
                deposit: {
                    defaultValue: (model === null || model === void 0 ? void 0 : (ref24 = model.finance) === null || ref24 === void 0 ? void 0 : ref24.deposit) || (settings === null || settings === void 0 ? void 0 : (ref25 = settings.configuration) === null || ref25 === void 0 ? void 0 : ref25.deposit)
                },
                annualMileage: {
                    defaultValue: (model === null || model === void 0 ? void 0 : (ref26 = model.finance) === null || ref26 === void 0 ? void 0 : ref26.mileage) || (settings === null || settings === void 0 ? void 0 : (ref27 = settings.configuration) === null || ref27 === void 0 ? void 0 : ref27.mileage)
                },
                term: {
                    defaultValue: (model === null || model === void 0 ? void 0 : (ref28 = model.finance) === null || ref28 === void 0 ? void 0 : ref28.term) || (settings === null || settings === void 0 ? void 0 : (ref29 = settings.configuration) === null || ref29 === void 0 ? void 0 : ref29.term)
                },
                vehicle: {
                    model: (model === null || model === void 0 ? void 0 : (ref30 = model.finance) === null || ref30 === void 0 ? void 0 : ref30.name) || (model === null || model === void 0 ? void 0 : (ref31 = model.d4t4) === null || ref31 === void 0 ? void 0 : ref31.id),
                    identifier: "",
                    identifierType: "Rams",
                    type: "car"
                }
            }
        };
    }
    return {
        defaultParameters: {
            annualMileage: {
                defaultValue: (model === null || model === void 0 ? void 0 : (ref = model.finance) === null || ref === void 0 ? void 0 : ref.mileage) || (settings === null || settings === void 0 ? void 0 : (ref1 = settings.configuration) === null || ref1 === void 0 ? void 0 : ref1.mileage)
            }
        }
    };
};
/* harmony default export */ var helpers_getCodeweaversConfiguration = (getCodeweaversConfiguration);

// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var node_modules_axios = __webpack_require__(46392);
;// CONCATENATED MODULE: ./src/utils/helpers/getDealers.ts

const getDealers = async ()=>{
    try {
        const response = await node_modules_axios/* default.get */.ZP.get("".concat("https://api.toyota.co.uk/forms/api", "/dealers"));
        return response.data;
    } catch (error) {
        return false;
    }
};
/* harmony default export */ var helpers_getDealers = (getDealers);

// EXTERNAL MODULE: fs (ignored)
var fs_ignored_ = __webpack_require__(14077);
// EXTERNAL MODULE: ./node_modules/gray-matter/index.js
var gray_matter = __webpack_require__(15868);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/path-browserify/index.js
var path_browserify = __webpack_require__(17717);
;// CONCATENATED MODULE: ./src/utils/helpers/getLinks.ts
/* provided dependency */ var process = __webpack_require__(554);



const getLinks = (locale, links)=>{
    const linksFiles = path.join(process.cwd(), "./src/content/".concat(locale, "/links"));
    let files;
    try {
        files = readdirSync(linksFiles);
    } catch (error) {
        return [];
    }
    const linksArr = files.map((file)=>{
        const fullPath = path.join(linksFiles, file);
        const contents = readFileSync(fullPath, "utf8");
        const { data  } = matter(contents);
        return {
            ...data
        };
    });
    if (links) {
        const sortedLinks = links.map((link)=>linksArr.find((linkArr)=>linkArr.id === link)).filter(Boolean);
        return sortedLinks.filter((link)=>link.active);
    }
    const activeLinks = linksArr.filter((link)=>link.active);
    return activeLinks.map((link)=>{
        return link.id;
    });
};
/* harmony default export */ var helpers_getLinks = ((/* unused pure expression or super */ null && (getLinks)));

;// CONCATENATED MODULE: ./src/utils/helpers/getModelImage.ts
const getModelImage = (locale, model, grade, color, format, fallback)=>{
    if (fallback && fallback !== "") {
        return fallback;
    }
    if (format === "webp") {
        return "https://kong-proxy-aws.toyota-europe.com/".concat(locale === "lexus" ? "l" : "c", "1-images/resize/ccis/680x680/png/gb/model/").concat(model, "/").concat(grade ? "grade/".concat(encodeURIComponent(grade), "/") : "", "scale-mode/0/padding/100,100,0,0/image-quality/75/day-exterior-03").concat(color ? "_".concat(color) : "", ".webp");
    }
    return "https://kong-proxy-aws.toyota-europe.com/".concat(locale === "lexus" ? "l" : "c", "1-images/resize/ccis/680x680/zip/gb/model/").concat(model, "/").concat(grade ? "grade/".concat(encodeURIComponent(grade), "/") : "", "scale-mode/0/padding/100,100,0,0/image-quality/75/day-exterior-03").concat(color ? "_".concat(color) : "", ".png");
};
/* harmony default export */ var helpers_getModelImage = (getModelImage);

;// CONCATENATED MODULE: ./src/utils/helpers/getModels.ts
/* provided dependency */ var getModels_process = __webpack_require__(554);



const getModelsForLocale = (locale)=>{
    const MODELS_DIR = path.join(getModels_process.cwd(), "./src/content/".concat(locale, "/models"));
    const files = readdirSync(MODELS_DIR);
    const modelData = files.map((file)=>{
        const fullPath = path.join(MODELS_DIR, file);
        const contents = readFileSync(fullPath, "utf8");
        const { data  } = matter(contents);
        return data;
    });
    return modelData.sort((a, b)=>a.order > b.order ? 1 : -1);
};
const getModels = (locale, type)=>{
    let modelData = [];
    if (locale === "kinto") {
        const toyotaModels = getModelsForLocale("toyota");
        const lexusModels = getModelsForLocale("lexus");
        const filteredToyotaModels = toyotaModels.filter((model)=>{
            if (type === "bch-get-a-quote") {
                return model.active && model.visibility.show_kinto_request_a_callback;
            }
            return model.active;
        });
        const filteredLexusModels = lexusModels.filter((model)=>{
            if (type === "bch-get-a-quote") {
                return model.active && model.visibility.show_kinto_request_a_callback;
            }
            return model.active;
        });
        return {
            toyotaModels: filteredToyotaModels,
            lexusModels: filteredLexusModels
        };
    }
    modelData = getModelsForLocale(locale);
    modelData = modelData.filter((model)=>{
        if (type === "brochure") {
            return model.active && model.visibility.show_brochure;
        }
        if (type === "test-drive") {
            return model.active && model.visibility.show_testdrive;
        }
        if (type === "newsletter") {
            return model.active && model.visibility.show_newsletter;
        }
        if (type === "video-consulation") {
            return model.active && model.visibility.show_video_consulation;
        }
        if (type === "internal-cans") {
            return model.active && model.visibility.show_internal_cans;
        }
        if (type === "request-a-callback") {
            return model.active && model.visibility.show_request_a_callback;
        }
        if (type === "kmi") {
            return model.active && model.visibility.show_kmi;
        }
        if (type === "get-a-quote") {
            return model.active && model.visibility.show_get_a_quote;
        }
        if (type === "kinto-bch-get-a-quote") {
            return model.active && model.visibility.show_kinto_request_a_callback;
        }
        if (type === "power-of-choice") {
            return model.active && model.visibility.show_power_of_choice;
        }
        if (type === "toyota-thon") {
            return model.active && model.visibility.show_toyota_thon;
        }
        if (type === "dealer") {
            return model.active && model.visibility.show_contact_us_dealer;
        }
        return model.active;
    });
    // Sort the modelData array based on the name property
    if (type !== "brochure" && type !== "test-drive" && type !== "get-a-quote") {
        modelData.sort((a, b)=>a.name.localeCompare(b.name));
    }
    return modelData;
};
/* harmony default export */ var helpers_getModels = ((/* unused pure expression or super */ null && (getModels)));

;// CONCATENATED MODULE: ./src/utils/helpers/getPageData.ts
/* provided dependency */ var getPageData_process = __webpack_require__(554);




const API =  false ? 0 : "https://api.toyota.co.uk/forms/api";
const getDealer = async (queryDealer, brand, servicing)=>{
    try {
        var ref, ref1;
        const response = await axios.post("".concat(API, "/dealers"), {
            dealer: queryDealer,
            servicing
        });
        if (((ref = response === null || response === void 0 ? void 0 : response.data[0]) === null || ref === void 0 ? void 0 : (ref1 = ref._source) === null || ref1 === void 0 ? void 0 : ref1.brands[0].toLowerCase()) !== brand) {
            return false;
        }
        return response.data[0]._source;
    } catch (error) {
        return false;
    }
};
const getModel = async (queryModel, locale, formType)=>{
    const MODELS_DIR = path.join(getPageData_process.cwd(), "./src/content/".concat(locale, "/models"));
    let files;
    try {
        files = readdirSync(MODELS_DIR);
    } catch (error) {
        return [];
    }
    const modelData = files.map((file)=>{
        const fullPath = path.join(MODELS_DIR, file);
        const contents = readFileSync(fullPath, "utf8");
        const { data  } = matter(contents);
        return data;
    });
    const sortedModelData = modelData.sort((a, b)=>a.order > b.order ? 1 : -1);
    const modelVisability = sortedModelData.filter((model)=>{
        if (formType === "brochure") {
            return model.active && model.visibility.show_brochure;
        }
        if (formType === "test-drive") {
            return model.active && model.visibility.show_testdrive;
        }
        if (formType === "newsletter") {
            return model.active && model.visibility.show_newsletter;
        }
        if (formType === "video-consulation") {
            return model.active && model.visibility.show_video_consulation;
        }
        if (formType === "internal-cans") {
            return model.active && model.visibility.show_internal_cans;
        }
        if (formType === "request-a-callback") {
            return model.active && model.visibility.show_request_a_callback;
        }
        if (formType === "kmi") {
            return model.active && model.visibility.show_kmi;
        }
        if (formType === "get-a-quote") {
            return model.active && model.visibility.show_get_a_quote;
        }
        if (formType === "kinto-bch-get-a-quote") {
            return model.active && model.visibility.show_kinto_request_a_callback;
        }
        if (formType === "power-of-choice") {
            return model.active && model.visibility.show_power_of_choice;
        }
        if (formType === "toyota-thon") {
            return model.active && model.visibility.show_toyota_thon;
        }
        if (formType === "dealer") {
            return model.active && model.visibility.show_contact_us_dealer;
        }
        return model.active;
    });
    return modelVisability.filter((model)=>{
        if (queryModel.toLowerCase() === model.rangecode.toLowerCase() && model.active) {
            return model;
        }
        if (queryModel.toLowerCase() === model.image.id.toLowerCase() && model.active) {
            return model;
        }
        if (queryModel.toLowerCase() === model.d4t4.id.toLowerCase() && model.active) {
            return model;
        }
        if (queryModel.toLowerCase() === model.name.toLowerCase() && model.active) {
            return model;
        }
        return false;
    });
};
const getPageData = async (context, form, formModel, productInfo)=>{
    const { locale , query  } = context;
    const { dealer , centre , centreId , dealerID , dealerId , model , modelID , modelId , otso , olso  } = query;
    const queryDealer = dealer || centre || centreId || dealerID || dealerId || "";
    const queryModel = model || modelID || modelId || formModel || "";
    const formType = form || "";
    const queryServicing = !!(otso === "true" || olso === "true" || otso === "" || olso === "");
    const selectedDealer = await getDealer(queryDealer, locale, queryServicing);
    const selectedModel = await getModel(queryModel, locale, formType);
    const settings = await __webpack_require__(36220)("./".concat(locale, "/settings/global.md")).catch(()=>null);
    if (!settings) {
        throw new Error("No settings found for brand ".concat(locale));
    }
    const pageModel = productInfo ? {
        ...productInfo,
        ...selectedModel[0]
    } : selectedModel[0];
    return {
        brand: locale,
        query,
        formType,
        dealer: selectedDealer || false,
        model: pageModel || false,
        servicing: queryServicing,
        settings: settings === null || settings === void 0 ? void 0 : settings.attributes
    };
};
/* harmony default export */ var helpers_getPageData = ((/* unused pure expression or super */ null && (getPageData)));

;// CONCATENATED MODULE: ./src/utils/helpers/removeDuplicates.ts
const removeDuplicate = (arr, key)=>arr.reduce((acc, current)=>{
        const x = acc.find((item)=>item[key] === current[key]);
        if (!x) return acc.concat([
            current
        ]);
        return acc;
    }, []);
/* harmony default export */ var removeDuplicates = (removeDuplicate);

// EXTERNAL MODULE: ./src/utils/helpers/tracking.ts + 1 modules
var tracking = __webpack_require__(68379);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./src/utils/helpers/useMediaQuery.tsx

function useMediaQuery(query) {
    const getMatches = (q)=>{
        if (true) {
            return window.matchMedia(q).matches;
        }
        return false;
    };
    const [matches, setMatches] = useState(getMatches(query));
    const handleChange = ()=>{
        setMatches(getMatches(query));
    };
    useEffect(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) {
            matchMedia.addListener(handleChange);
        } else {
            matchMedia.addEventListener("change", handleChange);
        }
        return ()=>{
            if (matchMedia.removeListener) {
                matchMedia.removeListener(handleChange);
            } else {
                matchMedia.removeEventListener("change", handleChange);
            }
        };
    }, [
        query
    ]);
    return matches;
}
/* harmony default export */ var helpers_useMediaQuery = ((/* unused pure expression or super */ null && (useMediaQuery)));

;// CONCATENATED MODULE: ./src/utils/helpers/index.ts















/***/ }),

/***/ 68379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_H": function() { return /* binding */ customEvent; },
  "Be": function() { return /* binding */ formEvent; },
  "kP": function() { return /* binding */ initTracking; },
  "UO": function() { return /* binding */ tracking; },
  "WX": function() { return /* binding */ updateDatalayer; },
  "Sd": function() { return /* binding */ workflowEvent; }
});

;// CONCATENATED MODULE: ./src/utils/helpers/getSource.ts
const getSource = ()=>{
    var ref;
    const urlQuery = new URLSearchParams(window.location.search);
    const source = (ref = urlQuery.get("source")) === null || ref === void 0 ? void 0 : ref.toString();
    return source;
};
/* harmony default export */ var helpers_getSource = (getSource);

;// CONCATENATED MODULE: ./src/utils/helpers/tracking.ts

const getValues = (brand)=>{
    if (brand === "kinto") {
        return {
            eventName: "new-formevent",
            eventComponentGroup: "services"
        };
    }
    return {
        eventName: "formevent",
        eventComponentGroup: "forms"
    };
};
/* eslint-disable no-console */ const formEvent = (data, brand)=>{
    var ref;
    window.tngaDataLayer.form = {
        name: data.name,
        step: data.action || data.step,
        conversion: data.conversion,
        variant: data.variant,
        source: helpers_getSource() || "(national site)"
    };
    window.tngaDataLayer.event = {
        name: getValues(brand).eventName,
        componentName: data.page || data.name,
        componentGroup: getValues(brand).eventComponentGroup,
        action: data.action || "form-step",
        label: data.step
    };
    (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: getValues(brand).eventName
    });
    const savedEvent = {
        ...window.tngaDataLayer
    };
    console.log("".concat(getValues(brand).eventName, " triggered"), savedEvent);
};
const workflowEvent = (data)=>{
    var ref;
    window.tngaDataLayer.workflow = {
        name: data.name || data.page,
        step: data.step,
        conversion: data.conversion,
        variant: data.variant,
        source: helpers_getSource() || "(national site)"
    };
    window.tngaDataLayer.event = {
        name: "workflowevent",
        componentName: data.page || data.name,
        componentGroup: "tools",
        action: data.action,
        label: data.step
    };
    (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "workflowevent"
    });
    const savedEvent = {
        ...window.tngaDataLayer
    };
    console.log("workflowevent triggered", savedEvent);
};
const customEvent = (data)=>{
    // TME advised to disable input interaction
    if (!data.action.includes("interaction")) {
        var ref;
        window.tngaDataLayer.event = {
            name: data.name,
            componentName: data.componentName,
            componentGroup: data.componentGroup,
            action: data.action,
            label: data.label,
            variant: data.variant
        };
        window.tngaDataLayer.workflow = {};
        (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push({
            event: data.name
        });
        const savedEvent = {
            ...window.tngaDataLayer
        };
        console.log("".concat(data.name, " triggered"), savedEvent);
    }
};
const updateDatalayer = (object, data)=>{
    // Dealer
    if (object === "dealer") {
        if (data) {
            window.tngaDataLayer.dealer = {
                city: data.address.city,
                dealerId: data.uuid,
                name: data.name,
                zipcode: data.address.zip
            };
        } else {
            window.tngaDataLayer.dealer = {};
        }
    }
    // Dealer group
    if (object === "group") {
        if (data) {
            window.tngaDataLayer.dealer = {
                dealerId: data.uuid,
                name: data.name
            };
        } else {
            window.tngaDataLayer.dealer = {};
        }
    }
    // Non kinto forms with models
    if (object === "model") {
        if (data) {
            window.tngaDataLayer.product = [
                {
                    category: "cars",
                    productInfo: {
                        modelName: data.name,
                        tmeModelId: data.id
                    },
                    subCategory: "new-cars"
                }
            ];
        } else {
            window.tngaDataLayer.product = [
                {}
            ];
        }
    }
    if (object === "model-qfc") {
        if (data) {
            window.tngaDataLayer.product = [
                {
                    category: "cars",
                    productInfo: {
                        modelName: data.name,
                        tmeModelId: data.id,
                        productId: data.productId,
                        productName: data.productName
                    },
                    subCategory: "new-cars"
                }
            ];
        } else {
            window.tngaDataLayer.product = [
                {}
            ];
        }
    }
    // Kinto forms with models
    if (data.brand === "kinto" && object === "model") {
        if (data) {
            window.tngaDataLayer.product = [
                {
                    category: "services",
                    productInfo: {
                        productName: data.service,
                        modelName: data.name,
                        manufacturerName: data.manufacturer
                    },
                    subCategory: "kinto-mobility"
                }
            ];
        } else {
            window.tngaDataLayer.product = [
                {}
            ];
        }
    }
    // Kinto forms with service
    if (data.brand === "kinto" && object === "service") {
        if (data) {
            window.tngaDataLayer.product = [
                {
                    category: "services",
                    productInfo: {
                        productName: data.service
                    },
                    subCategory: "kinto-mobility"
                }
            ];
        } else {
            window.tngaDataLayer.product = [
                {}
            ];
        }
    }
};
const getEvent = (e)=>{
    if (e.target.dataset.gtAction) {
        var ref, ref1, ref2, ref3, ref4;
        const el = e.target;
        const tracking = {
            name: ((ref = el.closest("[data-gt-name]")) === null || ref === void 0 ? void 0 : ref.dataset.gtName) || "",
            componentName: ((ref1 = el.closest("[data-gt-componentname]")) === null || ref1 === void 0 ? void 0 : ref1.dataset.gtComponentname) || "",
            componentGroup: ((ref2 = el.closest("[data-gt-componentgroup]")) === null || ref2 === void 0 ? void 0 : ref2.dataset.gtComponentgroup) || "",
            action: ((ref3 = el.closest("[data-gt-action]")) === null || ref3 === void 0 ? void 0 : ref3.dataset.gtAction) || "",
            label: ((ref4 = el.closest("[data-gt-label]")) === null || ref4 === void 0 ? void 0 : ref4.dataset.gtLabel) || ""
        };
        customEvent(tracking);
    }
};
const initTracking = (active)=>{
    if (active) {
        window.addEventListener("click", getEvent, false);
    } else {
        window.removeEventListener("click", getEvent, false);
    }
};
const tracking = {
    componentGroup: ()=>{
        var ref;
        return  true ? (ref = document.body.dataset) === null || ref === void 0 ? void 0 : ref.gtComponentgroup : 0;
    },
    componentName: ()=>{
        var ref;
        return  true ? (ref = document.body.dataset) === null || ref === void 0 ? void 0 : ref.gtComponentname : 0;
    }
};



/***/ }),

/***/ 11020:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 36220:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./kinto/settings/global.md": [
		47182,
		7182
	],
	"./lexus/settings/global.md": [
		78238,
		8238
	],
	"./toyota/settings/global.md": [
		7057,
		7057
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 36220;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 33596:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 14077:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 46392:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ node_modules_axios; }
});

// UNUSED EXPORTS: Axios, AxiosError, Cancel, CancelToken, CanceledError, VERSION, all, isAxiosError, isCancel, spread, toFormData

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {
  toString: utils_toString
} = Object.prototype;
const {
  getPrototypeOf
} = Object;
const kindOf = (cache => thing => {
  const str = utils_toString.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));
const kindOfTest = type => {
  type = type.toLowerCase();
  return thing => kindOf(thing) === type;
};
const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {
  isArray
} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = thing => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = val => {
  if (kindOf(val) !== 'object') {
    return false;
  }
  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = val => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = thing => {
  const pattern = '[object FormData]';
  return thing && (typeof FormData === 'function' && thing instanceof FormData || utils_toString.call(thing) === pattern || isFunction(thing.toString) && thing.toString() === pattern);
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = str => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {void}
 */
function forEach(obj, fn, {
  allOwnKeys = false
} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }
  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }
  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;
    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge( /* obj1, obj2, obj3, ... */
) {
  const result = {};
  const assignValue = (val, key) => {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  };
  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {
  allOwnKeys
} = {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {
    allOwnKeys
  });
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = content => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};
  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};

/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = thing => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator = generator.call(obj);
  let result;
  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];
  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }
  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');
const toCamelCase = str => {
  return str.toLowerCase().replace(/[_-\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
    return p1.toUpperCase() + p2;
  });
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({
  hasOwnProperty
}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');
const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors, (descriptor, name) => {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = obj => {
  reduceDescriptors(obj, (descriptor, name) => {
    const value = obj[name];
    if (!isFunction(value)) return;
    descriptor.enumerable = false;
    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not read-only method \'' + name + '\'');
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define = arr => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };
  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
  return obj;
};
const noop = () => {};
const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
};
/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}
utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};
['ERR_BAD_OPTION_VALUE', 'ERR_BAD_OPTION', 'ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK', 'ERR_FR_TOO_MANY_REDIRECTS', 'ERR_DEPRECATED', 'ERR_BAD_RESPONSE', 'ERR_BAD_REQUEST', 'ERR_CANCELED', 'ERR_NOT_SUPPORT', 'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {
    value: code
  };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {
  value: true
});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);
  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });
  AxiosError.call(axiosError, error.message, code, config, request, response);
  axiosError.cause = error;
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
/* harmony default export */ var core_AxiosError = (AxiosError);
// EXTERNAL MODULE: ./node_modules/axios/node_modules/form-data/lib/browser.js
var browser = __webpack_require__(45635);
;// CONCATENATED MODULE: ./node_modules/axios/lib/env/classes/FormData.js

/* harmony default export */ var classes_FormData = (browser);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(80365)["lW"];






/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliant(thing) {
  return thing && utils.isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator];
}

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (classes_FormData || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });
  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && isSpecCompliant(formData);
  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }
  function convertValue(value) {
    if (value === null) return '';
    if (utils.isDate(value)) {
      return value.toISOString();
    }
    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }
    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;
    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (utils.isArray(value) && isFlatArray(value) || utils.isFileList(value) || utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);
        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
          // eslint-disable-next-line no-nested-ternary
          indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
        });
        return false;
      }
    }
    if (isVisitable(value)) {
      return true;
    }
    formData.append(renderKey(path, key, dots), convertValue(value));
    return false;
  }
  const stack = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build(value, path) {
    if (utils.isUndefined(value)) return;
    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }
    stack.push(value);
    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers);
      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });
    stack.pop();
  }
  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }
  build(obj);
  return formData;
}
/* harmony default export */ var helpers_toFormData = (toFormData);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];
  params && helpers_toFormData(params, this, options);
}
const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;
AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};
AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function (value) {
    return encoder.call(this, value, encode);
  } : encode;
  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};
/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  const _encode = options && options.encode || buildURL_encode;
  const serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ? params.toString() : new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }
  return url;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js



class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}
/* harmony default export */ var core_InterceptorManager = (InterceptorManager);
;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var browser_classes_FormData = (FormData);
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js



/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && ((product = navigator.product) === 'ReactNative' || product === 'NativeScript' || product === 'NS')) {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();
/* harmony default export */ var platform_browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: browser_classes_FormData,
    Blob
  },
  isStandardBrowserEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/index.js


;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js





function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform_browser.classes.URLSearchParams(), Object.assign({
    visitor: function (value, key, path, helpers) {
      if (platform_browser.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }
      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;
    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }
      return !isNumericKey;
    }
    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }
    const result = buildPath(path, value, target[name], index);
    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }
    return !isNumericKey;
  }
  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};
    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });
    return obj;
  }
  return null;
}
/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError('Request failed with status code ' + response.status, [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4], response.config, response.request, response));
  }
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js




/* harmony default export */ var cookies = (platform_browser.isStandardBrowserEnv ?
// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      const cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));
      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }
      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }
      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }
      if (secure === true) {
        cookie.push('secure');
      }
      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :
// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}());
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js




/* harmony default export */ var isURLSameOrigin = (platform_browser.isStandardBrowserEnv ?
// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  const msie = /(msie|trident)/i.test(navigator.userAgent);
  const urlParsingNode = document.createElement('a');
  let originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    let href = url;
    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    const parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :
// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}());
;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}
utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});
/* harmony default export */ var cancel_CanceledError = (CanceledError);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet(['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent']);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;
  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });
  return parsed;
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js




const $internals = Symbol('internals');
const $defaults = Symbol('defaults');
function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;
  while (match = tokensRE.exec(str)) {
    tokens[match[1]] = match[2];
  }
  return tokens;
}
function matchHeaderValue(context, value, header, filter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }
  if (!utils.isString(value)) return;
  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }
  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}
function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
    return char.toUpperCase() + str;
  });
}
function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);
  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function (arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
function AxiosHeaders(headers, defaults) {
  headers && this.set(headers);
  this[$defaults] = defaults || null;
}
Object.assign(AxiosHeaders.prototype, {
  set: function (header, valueOrRewrite, rewrite) {
    const self = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }
      const key = findKey(self, lHeader);
      if (key && _rewrite !== true && (self[key] === false || _rewrite === false)) {
        return;
      }
      self[key || _header] = normalizeValue(_value);
    }
    if (utils.isPlainObject(header)) {
      utils.forEach(header, (_value, _header) => {
        setHeader(_value, _header, valueOrRewrite);
      });
    } else {
      setHeader(valueOrRewrite, header, rewrite);
    }
    return this;
  },
  get: function (header, parser) {
    header = normalizeHeader(header);
    if (!header) return undefined;
    const key = findKey(this, header);
    if (key) {
      const value = this[key];
      if (!parser) {
        return value;
      }
      if (parser === true) {
        return parseTokens(value);
      }
      if (utils.isFunction(parser)) {
        return parser.call(this, value, key);
      }
      if (utils.isRegExp(parser)) {
        return parser.exec(value);
      }
      throw new TypeError('parser must be boolean|regexp|function');
    }
  },
  has: function (header, matcher) {
    header = normalizeHeader(header);
    if (header) {
      const key = findKey(this, header);
      return !!(key && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }
    return false;
  },
  delete: function (header, matcher) {
    const self = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = findKey(self, _header);
        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];
          deleted = true;
        }
      }
    }
    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }
    return deleted;
  },
  clear: function () {
    return Object.keys(this).forEach(this.delete.bind(this));
  },
  normalize: function (format) {
    const self = this;
    const headers = {};
    utils.forEach(this, (value, header) => {
      const key = findKey(headers, header);
      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }
      const normalized = format ? formatHeader(header) : String(header).trim();
      if (normalized !== header) {
        delete self[header];
      }
      self[normalized] = normalizeValue(value);
      headers[normalized] = true;
    });
    return this;
  },
  toJSON: function (asStrings) {
    const obj = Object.create(null);
    utils.forEach(Object.assign({}, this[$defaults] || null, this), (value, header) => {
      if (value == null || value === false) return;
      obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value;
    });
    return obj;
  }
});
Object.assign(AxiosHeaders, {
  from: function (thing) {
    if (utils.isString(thing)) {
      return new this(parseHeaders(thing));
    }
    return thing instanceof this ? thing : new this(thing);
  },
  accessor: function (header) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }
    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
    return this;
  }
});
AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent']);
utils.freezeMethods(AxiosHeaders.prototype);
utils.freezeMethods(AxiosHeaders);
/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;
  min = min !== undefined ? min : 1000;
  return function push(chunkLength) {
    const now = Date.now();
    const startedAt = timestamps[tail];
    if (!firstSampleTS) {
      firstSampleTS = now;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now;
    let i = tail;
    let bytesCount = 0;
    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }
    if (now - firstSampleTS < min) {
      return;
    }
    const passed = startedAt && now - startedAt;
    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}
/* harmony default export */ var helpers_speedometer = (speedometer);
;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);
  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined
    };
    data[isDownloadStream ? 'download' : 'upload'] = true;
    listener(data);
  };
}
function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }
    if (utils.isFormData(requestData) && platform_browser.isStandardBrowserEnv) {
      requestHeaders.setContentType(false); // Let the browser set it
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }
    const fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }
    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(timeoutErrorMessage, transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (platform_browser.isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName && cookies.read(config.xsrfCookieName);
      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }
    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }
    const protocol = parseProtocol(fullPath);
    if (protocol && platform_browser.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }

    // Send the request
    request.send(requestData || null);
  });
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/index.js



const adapters = {
  http: xhrAdapter,
  xhr: xhrAdapter
};
/* harmony default export */ var lib_adapters = ({
  getAdapter: nameOrAdapter => {
    if (utils.isString(nameOrAdapter)) {
      const adapter = adapters[nameOrAdapter];
      if (!nameOrAdapter) {
        throw Error(utils.hasOwnProp(nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Can not resolve adapter '${nameOrAdapter}'`);
      }
      return adapter;
    }
    if (!utils.isFunction(nameOrAdapter)) {
      throw new TypeError('adapter is not a function');
    }
    return nameOrAdapter;
  },
  adapters
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js
/* provided dependency */ var process = __webpack_require__(554);










const DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

/**
 * If the browser has an XMLHttpRequest object, use the XHR adapter, otherwise use the HTTP
 * adapter
 *
 * @returns {Function}
 */
function getDefaultAdapter() {
  let adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = lib_adapters.getAdapter('xhr');
  } else if (typeof process !== 'undefined' && utils.kindOf(process) === 'process') {
    // For node use HTTP adapter
    adapter = lib_adapters.getAdapter('http');
  }
  return adapter;
}

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
  transitional: defaults_transitional,
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);
    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }
    const isFormData = utils.isFormData(data);
    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }
    if (utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }
    let isFileList;
    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }
      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;
        return helpers_toFormData(isFileList ? {
          'files[]': data
        } : data, _FormData && new _FormData(), this.formSerializer);
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';
    if (data && utils.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform_browser.classes.FormData,
    Blob: platform_browser.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
/* harmony default export */ var lib_defaults = (defaults);
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;
  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });
  headers.normalize();
  return data;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js








/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(config, config.transformRequest);
  const adapter = config.adapter || lib_defaults.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(config, config.transformResponse, response);
    response.headers = core_AxiosHeaders.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(config, config.transformResponse, reason.response);
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js




/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};
  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }
  const mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };
  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(prop);
    utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
const VERSION = "1.1.3";
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js




const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});
const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), core_AxiosError.ERR_DEPRECATED);
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
    }
    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}
/* harmony default export */ var validator = ({
  assertOptions,
  validators
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js










const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }
    config = mergeConfig(this.defaults, config);
    const {
      transitional,
      paramsSerializer
    } = config;
    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }
    if (paramsSerializer !== undefined) {
      validator.assertOptions(paramsSerializer, {
        encode: Axios_validators.function,
        serialize: Axios_validators.function
      }, true);
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    const defaultHeaders = config.headers && utils.merge(config.headers.common, config.headers[config.method]);
    defaultHeaders && utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
      delete config.headers[method];
    });
    config.headers = new core_AxiosHeaders(config.headers, defaultHeaders);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;
      promise = Promise.resolve(config);
      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config;
    i = 0;
    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    i = 0;
    len = responseInterceptorChain.length;
    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }
    return promise;
  }
  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }
  Axios.prototype[method] = generateHTTPMethod();
  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
/* harmony default export */ var core_Axios = (Axios);
;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;
      let i = token._listeners.length;
      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }
      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}
/* harmony default export */ var cancel_CancelToken = (CancelToken);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && payload.isAxiosError === true;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js

















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {
    allOwnKeys: true
  });

  // Copy context to instance
  utils.extend(instance, context, null, {
    allOwnKeys: true
  });

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };
  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;
axios.formToJSON = thing => {
  return helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);
};
/* harmony default export */ var lib_axios = (axios);
;// CONCATENATED MODULE: ./node_modules/axios/index.js


// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const {
  Axios: axios_Axios,
  AxiosError: axios_AxiosError,
  CanceledError: axios_CanceledError,
  isCancel: axios_isCancel,
  CancelToken: axios_CancelToken,
  VERSION: axios_VERSION,
  all: axios_all,
  Cancel,
  isAxiosError: axios_isAxiosError,
  spread: axios_spread,
  toFormData: axios_toFormData
} = lib_axios;
/* harmony default export */ var node_modules_axios = (lib_axios);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(6840), __webpack_exec__(71378); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);